(function () {
  'use strict';

  const TEST_MODE =
    !!window.__TEST_MODE__ ||
    /([?&])tests?=true\b/i.test(String(window.location.search || ''));
  if (TEST_MODE) {
    window.__TEST_MODE__ = true;
  }

  const REMOVE_BACKGROUND_IMAGE_CREDITS = 2;
  const REMOVE_BACKGROUND_VIDEO_CREDITS = 50;
  const MAGIC_RESIZE_AI_CREDITS = 24;

  const state = {
    assets: [],
    clips: [],
    selectedClipId: null,
    selectedClipIds: [],
    timelineSelectionAnchorId: null,
    selectedAssetId: null,
    stageElements: [],
    selectedStageElementId: null,
    selectedStageElementIds: [],
    stageElementClipboard: null,
    stageElementSizeClipboard: null,
    stageElementStyleClipboard: null,
    stageElementOpacityClipboard: null,
    stageElementVisibilityClipboard: null,
    stageElementPositionClipboard: null,
    stageElementRotationClipboard: null,
    stageElementAlignClipboard: null,
    stageElementScaleClipboard: null,
    stageElementStageAlignClipboard: null,
    stageContextId: null,
    assetContextMenuId: null,
    pages: [],
    activePageId: null,
    previewScale: 1,
    searchKind: 'images',
    audioSearchUnavailable: false,
    audioTabQuery: '',
    musicGenerateJobId: '',
    musicGenerateResult: null,
    audioPreviewEl: null,
    audioPreviewUrl: '',
    stageElementsFilter: '',
    stageElementsFilterType: 'all',
    stageElementsFilterStatus: 'all',
    stageElementsFilterSelectedOnly: false,
    stageElementsShowTypeBadges: true,
    stageElementsCompact: false,
    stageElementsPresetCycleIndex: 0,
    stageSnapEnabled: true,
    stageSnapStrength: 1.5,
    stageGridEnabled: false,
    stageRotationSnapEnabled: true,
    stageAspectLocked: false,
    stageKeyframeGroupOpen: {},
    stageKeyframeFilter: 'all',
    stageKeyframeMuted: {},
    stageKeyframeSoloId: null,
    stageKeyframeTrackSnap: true,
    timelineShowWaveform: false,
    playing: false,
    playStartTime: 0,
    playhead: 0,
    fps: 30,
    resolution: { width: 1920, height: 1080 },
    timelineScale: window.matchMedia('(max-width: 768px)').matches ? 48 : 80,
    bpm: 120,
    bpmMin: 60,
    bpmMax: 180,
    bpmConfidence: null,
    bpmMethod: '',
    snapToBeat: false,
    showBeatHighlights: true,
    beatHighlightThreshold: 0.7,
    autoScrollWaveform: true,
    showAutomationTooltip: true,
    showAutomationBeatGrid: false,
    audioElement: null,
    audioContext: null,
    audioSource: null,
    audioSourceElement: null,
    audioDestination: null,
    audioFile: null,
    audioLabel: '',
    audioGainNode: null,
    audioSettings: { gain: 1, fadeIn: 0, fadeOut: 0 },
    waveform: { peaks: [], duration: 0 },
    queue: [],
    exportInProgress: false,
    uploadingAssets: false,
    autosaveTimer: null,
    lastSavedSnapshot: '',
    lastFileSavedSnapshot: '',
    selectedAutomation: null,
    selectedAutomationMulti: null,
    selectedAutomationAnchor: { gain: null, pan: null },
    automationClipboard: null,
    automationPresets: { gain: [], pan: [] },
    timelinePresetPreviewPayload: null,
    automationHistoryBadgesCollapsed: false,
    trackHeaders: {},
    audioTracks: [],
    inspectorPins: [],
    timelineMarkers: [],
    shaderStage: null,
    shaderEffects: {
      blur: { enabled: false, radius: 2 },
      recolor: { enabled: false, hueShift: 0, saturation: 1, brightness: 1 },
      glitch: { enabled: false, intensity: 0.5 },
      vhs: { enabled: false, intensity: 0.5 },
      corrupt: { enabled: false, intensity: 0.5 },
      bloom: { enabled: false, intensity: 1 },
      sharpen: { enabled: false, intensity: 0.5 },
      vignette: { enabled: false, intensity: 0.5, softness: 0.5 },
      chromatic: { enabled: false, intensity: 1 },
      filmgrain: { enabled: false, intensity: 0.1 },
      crt: { enabled: false, intensity: 0.5 },
      pixelate: { enabled: false, pixelSize: 8 },
      dream: { enabled: false, intensity: 0.5 },
      edgeglow: { enabled: false, intensity: 1, glowColor: [0.3, 0.6, 1.0] },
      duotone: {
        enabled: false,
        intensity: 1,
        colorA: [0, 0, 0.3],
        colorB: [1, 0.9, 0.6],
      },
    },
    shaderPreset: 'none',
    loopPlayback: false,
    exportSettings: {
      resolution: '1920x1080',
      bitrate: 4000000,
      format: 'mp4',
    },
    fsCurrentPath: '',
    fsParentPath: '',
    fsLastDir: localStorage.getItem('netwrck_ve_fs_last_dir') || '~',
    fsEntries: [],
    fsBrowseMode: 'media',
    fsSelectedEntry: null,
    fsSidebarPath: localStorage.getItem('netwrck_ve_fs_sidebar_dir') || '~',
    fsSidebarEntries: [],
    currentProjectPath: '',
    currentProjectId: '',
    currentProjectName: '',
    currentShareToken: '',
    currentProjectParentId: '',
    projectReadOnly: false,
    syncedSavedAiAssets: [],
    accountProjects: [],
    userInteracted: false,
  };

  const RECENT_FONTS_KEY = 'netwrck_video_editor_recent_fonts_v1';
  let toolbarFontAllOptions = [];
  let toolbarFontFilterQuery = '';
  let toolbarFontSearchTimer = null;
  let toolbarFontSearchSeq = 0;
  let toolbarFontPickerQuery = '';
  let toolbarFontPickerCategory = 'all';
  let toolbarFontPickerTimer = null;
  let toolbarFontPickerSeq = 0;
  let toolbarFontPreviewState = null;
  let suppressDefaultAssetForTests = false;

  let sidebarOpen = false;
  let inspectorOpen = false;
  let focusRestoreSeq = 0;
  let sidebarActiveTab = 'uploads';
  let stageFiltersPopoverManualClosed = false;
  let stageFiltersPopoverCloseTimer = null;
  let timelineHoverTimer = null;
  let timelineLeaveTimer = null;
  let timelineContextTargetId = null;
  let timelineTrackContextTime = null;
  let lastTimelineTrackMenuSection = null;
  let lastTimelineClipMenuSection = null;
  let timelineRememberSubmenu = true;
  let timelineRememberQuickActions = true;
  let timelineClipboard = [];
  let timelineMarkerContextIndex = null;
  let timelineMarkerListFocusIndex = null;
  let lastPasteGap = null;
  let timelineLongPressTimer = null;
  let timelineLongPressStart = null;
  let timelinePinchActive = false;
  let timelinePinchStartDistance = 0;
  let timelinePinchStartScale = 80;
  let timelineRulerStep = 1;
  let timelineRulerPxPerSec = 80;
  let lastTimelineRulerKey = '';
  let lastContextMenuOpenedAt = 0;
  let timelineSheetDragMenu = null;
  let timelineSheetDragStart = null;
  let timelineSheetSnapTimer = null;
  let lastTimelineClipQuickAction = null;
  let lastTimelineTrackQuickAction = null;
  let lastTimelineMarkerQuickAction = null;
  let lastStagePointer = null;
  let timelineVideoHover = null;
  let timelineSuppressClickUntil = 0;
  let transitionPanelDirection = 'both';
  let audioMutePrevGain = null;
  let stageInlineToolbarRaf = null;
  let stageElementsListRaf = null;
  let stageInspectorRaf = null;
  let shortcutsFocusRaf = null;
  let textContrastSampleCanvas = null;
  let inspectorContext = 'clip';
  let aiReferencePreviewToken = 0;
  let aiPromptAutocompleteMenu = null;
  let aiPromptAutocompleteInput = null;
  let aiPromptAutocompleteItems = [];
  let aiPromptAutocompleteIndex = -1;
  let aiPromptGhostLayer = null;
  let aiPromptGhostValue = '';

  const FILTER_POPOVER_CLOSE_DELAY_MS = 120;
  const TIMELINE_HOVER_DELAY_MS = 120;
  const TIMELINE_HOVER_LEAVE_DELAY_MS = 120;
  const TIMELINE_LONG_PRESS_DELAY_MS = 450;
  const TIMELINE_LONG_PRESS_MOVE_THRESHOLD = 8;
  const TIMELINE_ZOOM_MIN = 16;
  const TIMELINE_ZOOM_MAX = 420;
  const TIMELINE_ZOOM_SNAP_POINTS = [25, 50, 80, 100, 150, 200, 300, 400];
  const TIMELINE_ZOOM_SNAP_THRESHOLD = 6;
  const TIMELINE_SHEET_DRAG_THRESHOLD = 90;
  const TIMELINE_HEIGHT_MIN = 150;
  const TIMELINE_STAGE_MIN = 220;
  const FILE_DROP_ZONE_LIBRARY = 'library';
  const FILE_DROP_ZONE_STAGE = 'stage';
  const FILE_DROP_ZONE_TIMELINE = 'timeline';
  const AI_REFERENCE_ASSET_MIME = 'application/x-netwrck-video-asset-id';
  let lastLongPressMenuAt = 0;

  const STORAGE_KEY = 'netwrck_video_editor_project_v1';
  const HISTORY_KEY = 'netwrck_video_editor_history_v1';
  const FS_MEDIA_LIBRARY_KEY = 'netwrck_ve_fs_media_library_v1';
  const HISTORY_LIMIT = 12;
  const PROJECT_HISTORY_LIMIT = 80;
  const AUTOMATION_HISTORY_LIMIT = 80;
  const TIMELINE_HISTORY_LIMIT = 60;
  const TIMELINE_HISTORY_COALESCE_MS = 700;
  const TIMELINE_QUICK_ACTIONS_KEY =
    'netwrck_video_editor_timeline_quick_actions_v1';
  const TIMELINE_WAVEFORM_KEY = 'netwrck_video_editor_timeline_waveform_v1';
  const TIMELINE_HEIGHT_KEY = 'netwrck_video_editor_timeline_height_v1';
  const TIMELINE_REMEMBER_SUBMENU_KEY =
    'netwrck_video_editor_timeline_remember_submenu_v1';
  const AI_ASSET_CACHE_KEY = 'netwrck_video_editor_ai_asset_cache_v1';
  const AI_LAST_PROMPT_KEY = 'netwrck_video_editor_ai_prompt_v1';
  const AI_LAST_SIZE_KEY = 'netwrck_video_editor_ai_size_v1';
  const AI_SEARCH_QUERY_KEY = 'netwrck_video_editor_ai_search_query_v1';
  const AI_SEARCH_KIND_KEY = 'netwrck_video_editor_ai_search_kind_v1';
  const AI_SAVED_ASSET_KEY = 'netwrck_video_editor_saved_generations_v1';
  const TIMELINE_GAP_EPS = 1e-4;
  const NOTIFY_MESSAGES = {
    au: 'Asset upload failed',
    ha: 'Upload local assets before server render',
    h3c: 'H3 generation cancelled',
    h3d: 'H3 video added to timeline',
    h3f: 'H3 generation failed',
    hu: 'Reference image uploaded',
    ld: 'Video added to timeline',
    lf: 'Video generation failed',
    li: 'Sign in to continue',
    nc: 'Add at least one clip before rendering',
    np: 'Add a prompt first',
    nu: 'Add a reference image URL first',
    pf: 'Publish failed',
    rb: 'Removing background',
    rbd: 'Background removed',
    rbf: 'Background removal failed',
    cr: 'Cutout refined',
    cf: 'Refine unavailable',
    rf: 'Server render failed',
    rq: 'Render queued',
    sa: 'Select an image asset first',
    tf: 'Thumbnail upload failed',
    xd: 'Export complete',
    xf: 'Export failed',
    xs: 'Export started',
  };

  const DEFAULT_AI_ASSETS = [
    {
      name: 'Peaceful Landscape',
      src: '/static/img/tree-stary-sky.jpeg',
      type: 'image',
    },
    {
      name: 'Serene Nature',
      src: '/static/img/relighting/default-relighting-image.webp',
      type: 'image',
    },
    {
      name: 'Fantasy Scenery',
      src: '/static/img/robot-purp.png',
      type: 'image',
    },
  ];
  const AUTOMATION_HISTORY_FILTER_KEY =
    'netwrck_video_editor_automation_history_filter_v1';
  const AUTOMATION_HISTORY_BADGES_KEY =
    'netwrck_video_editor_automation_history_badges_v1';
  const PRESET_KEY = 'netwrck_video_editor_automation_presets_v1';
  const INSPECTOR_PINS_KEY = 'netwrck_video_editor_inspector_pins_v1';
  const STAGE_ELEMENTS_FILTER_TYPE_KEY =
    'netwrck_video_editor_stage_elements_filter_type_v1';
  const STAGE_ELEMENTS_SELECTED_ONLY_KEY =
    'netwrck_video_editor_stage_elements_selected_only_v1';
  const STAGE_ELEMENTS_FILTER_STATUS_KEY =
    'netwrck_video_editor_stage_elements_filter_status_v1';
  const STAGE_ELEMENTS_TYPE_BADGE_KEY =
    'netwrck_video_editor_stage_elements_type_badge_v1';
  const STAGE_ELEMENTS_COMPACT_KEY =
    'netwrck_video_editor_stage_elements_compact_v1';
  const STAGE_ELEMENTS_PRESET_HISTORY_KEY =
    'netwrck_video_editor_stage_elements_filter_presets_v1';
  const HISTORY_MIN_INTERVAL = 60000;
  const INSPECTOR_PIN_MAX = 5;
  const INSPECTOR_PIN_FIELDS = [
    { key: 'name', label: 'Name', type: 'text' },
    {
      key: 'duration',
      label: 'Duration (s)',
      type: 'number',
      min: 0.1,
      step: 0.1,
    },
    {
      key: 'trimStart',
      label: 'Trim start',
      type: 'number',
      min: 0,
      step: 0.1,
    },
    { key: 'trimEnd', label: 'Trim end', type: 'number', min: 0, step: 0.1 },
    { key: 'speed', label: 'Speed', type: 'number', min: 0.1, step: 0.1 },
    { key: 'audioGain', label: 'Gain', type: 'number', min: 0, step: 0.1 },
    {
      key: 'audioPan',
      label: 'Pan',
      type: 'number',
      min: -1,
      max: 1,
      step: 0.1,
    },
  ];
  const INSPECTOR_PIN_DEFAULTS = {
    trimStart: 0,
    trimEnd: 0,
    speed: 1,
    audioGain: 1,
    audioPan: 0,
  };
  const DEFAULT_CAPTION_STYLE = {
    fontSize: 48,
    color: '#ffffff',
    align: 'center',
    y: 82,
  };
  const DEFAULT_STAGE_ELEMENT_DURATION = 4;

  const el = {};
  let dragClipId = null;
  let dragClipIds = null;
  let timelineClipDrag = null;
  let timelinePlayheadDrag = null;
  let timelineClipPointerDrag = null;
  let timelineClipDragRaf = 0;
  let timelineResizeDrag = null;
  let previewFrameCacheCanvas = null;
  let previewFrameCacheKey = '';
  let clipVisualizerScrub = null;
  let clipVisualizerHover = null;
  let clipVisualizerAltDown = false;
  let timelineHandleDrag = null;
  let timelineStageHandleDrag = null;
  let timelineMarquee = null;
  let rulerPointerSession = null;
  let rulerSelectionDrag = null;
  let waveformDragging = false;
  let automationDragging = null;
  let inspectorPinDrag = null;
  let stageDrag = null;
  let stageElementDragId = null;
  let stagePointerId = null;
  let externalFileDragDepth = 0;
  let activeExternalFileDropZone = '';
  const timelineHistory = [];
  const timelineFuture = [];
  const projectHistory = [];
  const projectFuture = [];
  const automationHistory = [];
  const automationFuture = [];
  const globalRedoStack = [];
  const importedSharedArtSrcs = new Set();
  let historyLastAt = 0;
  let automationUndoTimer = null;
  let timelineCoalesceTimer = null;
  let timelineCoalesceInfo = null;
  let stageElementsPresetHistoryUndo = null;
  let stageElementsPresetHistoryUndoTimer = null;
  let recordStream = null;
  let recordRecorder = null;
  let recordChunks = [];
  let recordFaceStream = null;
  let recordFaceRecorder = null;
  let recordFaceChunks = [];
  let recordSourceKind = 'camera';
  let playbackLastRenderNow = 0;
  let shaderControlsBound = false;
  let shaderStageUnavailable = false;

  function getEl(id) {
    return document.getElementById(id);
  }

  function getEventKeyData(event) {
    let key = event && typeof event.key === 'string' ? event.key : '';
    if (event && event.code === 'BracketLeft') key = '[';
    if (event && event.code === 'BracketRight') key = ']';
    return { key, lower: key.toLowerCase() };
  }

  async function apiJson(url, options) {
    const opts = options ? { ...options } : {};
    opts.headers = { ...(opts.headers || {}) };
    if (opts.body && !opts.headers['Content-Type']) {
      opts.headers['Content-Type'] = 'application/json';
    }
    const resp = await fetch(url, opts);
    const text = await resp.text();
    let data = {};
    if (text) {
      try {
        data = JSON.parse(text);
      } catch (_) {
        data = { error: text };
      }
    }
    if (!resp.ok) {
      const error = new Error(
        (data && (data.error || data.message)) || 'Request failed'
      );
      error.status = resp.status;
      error.data = data;
      throw error;
    }
    return data;
  }

  function editorMediaSrc(src) {
    return src;
  }

  function mediaIsSameOrigin(src) {
    try {
      return (
        new URL(src, window.location.href).origin === window.location.origin
      );
    } catch (_) {
      return true;
    }
  }

  function mediaAllowsAnonymousCors(src) {
    try {
      const parsed = new URL(src, window.location.href);
      const host = parsed.hostname.toLowerCase();
      return (
        host !== 'netwrckstatic.netwrck.com' && host !== 'static.netwrck.com'
      );
    } catch (_) {
      return true;
    }
  }

  function setEditorMediaSource(media, src) {
    const resolved = editorMediaSrc(src);
    if (mediaIsSameOrigin(resolved) || !mediaAllowsAnonymousCors(resolved)) {
      media.removeAttribute('crossorigin');
      media.crossOrigin = null;
    } else {
      media.crossOrigin = 'anonymous';
    }
    media.src = resolved;
    return resolved;
  }

  function projectLocationUrl(mode, value) {
    const url = new URL(window.location.href);
    url.searchParams.delete('project');
    url.searchParams.delete('share');
    if (mode && value) {
      url.searchParams.set(mode, value);
    }
    return url.pathname + (url.search ? url.search : '') + (url.hash || '');
  }

  function notify(message, type) {
    if (TEST_MODE) {
      return;
    }
    const shortMessage = normalizeNotificationMessage(message);
    const liveRegion = getEl('editor-live-region');
    if (liveRegion) {
      liveRegion.textContent = '';
      requestAnimationFrame(() => {
        liveRegion.textContent = shortMessage;
      });
    }
    if (
      window.NetwrckTools &&
      typeof window.NetwrckTools.showNotification === 'function'
    ) {
      window.NetwrckTools.showNotification(shortMessage, type || 'info');
      positionEditorNotificationToast();
      return;
    }
    if (typeof window.showSnackbar === 'function') {
      window.showSnackbar(shortMessage);
      positionEditorNotificationToast();
      return;
    }
    if (type === 'error') {
      alert(shortMessage);
    }
  }

  function positionEditorNotificationToast() {
    requestAnimationFrame(() => {
      const toast = document.getElementById('toast');
      if (!toast) return;
      toast.style.left = '50%';
      toast.style.right = 'auto';
      toast.style.top = 'auto';
      toast.style.transform = 'translateX(-50%)';
      toast.style.bottom = window.matchMedia('(max-width: 700px)').matches
        ? 'calc(env(safe-area-inset-bottom) + 64px)'
        : 'max(196px, calc(24vh + 16px))';
    });
  }

  function normalizeNotificationMessage(message) {
    if (typeof message !== 'string') return String(message || '');
    const trimmed = message.trim();
    if (!trimmed) return '';
    const match = trimmed.match(/^([a-z0-9]{1,3})(\s|:|—|-|$)(.*)$/i);
    if (match && NOTIFY_MESSAGES[match[1].toLowerCase()]) {
      const base = NOTIFY_MESSAGES[match[1].toLowerCase()];
      const detail = (match[3] || '').trim();
      if (!detail) return base;
      const cleanDetail = detail.replace(/^[\s:—-]+/, '').trim();
      return cleanDetail ? `${base}: ${cleanDetail}` : base;
    }
    return trimmed;
  }

  function announceLive(message) {
    const liveRegion = getEl('editor-live-region');
    if (!liveRegion) return;
    liveRegion.textContent = '';
    requestAnimationFrame(() => {
      liveRegion.textContent = message;
    });
  }

  function setExportInProgress(next) {
    state.exportInProgress = !!next;
    const buttons = [
      { el: el.exportWebm, busy: 'Exporting…' },
      { el: el.exportMp4, busy: 'Exporting…' },
      { el: el.exportStart, busy: 'Exporting…' },
      { el: el.publishGallery, busy: 'Publishing…' },
      { el: el.serverRender, busy: 'Rendering…' },
      { el: el.serverPublish, busy: 'Publishing…' },
    ];
    buttons.forEach(({ el: button, busy }) => {
      if (!button) return;
      if (!button.dataset.originalLabel) {
        button.dataset.originalLabel = button.textContent.trim();
      }
      if (state.exportInProgress) {
        button.innerHTML = `<span class="btn-spinner"></span>${busy}`;
      } else {
        button.textContent = button.dataset.originalLabel;
      }
      button.disabled = state.exportInProgress;
      button.setAttribute(
        'aria-busy',
        state.exportInProgress ? 'true' : 'false'
      );
      button.setAttribute(
        'aria-disabled',
        state.exportInProgress ? 'true' : 'false'
      );
    });
  }

  function applyFeatureFlags() {
    const form = el.featureFlagContainer;
    let serverRenderEnabled =
      form && form.dataset ? form.dataset.serverRenderEnabled === 'true' : true;
    if (
      window.NETWRCK_FEATURES &&
      typeof window.NETWRCK_FEATURES.serverRender === 'boolean'
    ) {
      serverRenderEnabled = window.NETWRCK_FEATURES.serverRender;
    }
    const stored = localStorage.getItem('netwrck_video_editor_server_render');
    if (stored === '0') serverRenderEnabled = false;
    if (stored === '1') serverRenderEnabled = true;
    document
      .querySelectorAll('[data-feature="server-render"]')
      .forEach((node) => {
        node.style.display = serverRenderEnabled ? '' : 'none';
      });
    document.querySelectorAll('.export-action-row').forEach((node) => {
      node.classList.toggle('server-render-disabled', !serverRenderEnabled);
    });
  }

  function initSettingsDisclosures() {
    document
      .querySelectorAll('.editor-shortcuts-advanced')
      .forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary) return;
        const sync = () => {
          summary.setAttribute(
            'aria-expanded',
            details.open ? 'true' : 'false'
          );
        };
        sync();
        details.addEventListener('toggle', sync);
      });
  }

  function syncStageAspectLockState(selectedList = getSelectedStageElements()) {
    const anySelected = selectedList.length > 0;
    const allLocked =
      anySelected && selectedList.every((element) => element.aspectLocked);
    const someLocked =
      anySelected && selectedList.some((element) => element.aspectLocked);
    state.stageAspectLocked = allLocked;
    if (el.stageAspectLockToggle) {
      el.stageAspectLockToggle.checked = allLocked;
      el.stageAspectLockToggle.indeterminate = !allLocked && someLocked;
      el.stageAspectLockToggle.disabled = !anySelected;
    }
  }

  function applyTimelineWaveformVisibility() {
    if (!el.editorSettingsModal) return;
    el.editorSettingsModal.classList.toggle(
      'show-waveform',
      state.timelineShowWaveform
    );
  }

  function loadTimelineWaveformSetting() {
    state.timelineShowWaveform =
      localStorage.getItem(TIMELINE_WAVEFORM_KEY) === '1';
    if (TEST_MODE) {
      state.timelineShowWaveform = false;
    }
    applyTimelineWaveformVisibility();
    if (el.timelineWaveformToggle) {
      el.timelineWaveformToggle.checked = state.timelineShowWaveform;
    }
  }

  function loadTimelineRememberSubmenuSetting() {
    const stored = localStorage.getItem(TIMELINE_REMEMBER_SUBMENU_KEY);
    timelineRememberSubmenu = stored !== '0';
    if (el.timelineRememberSubmenuToggle) {
      el.timelineRememberSubmenuToggle.checked = timelineRememberSubmenu;
    }
  }

  function setTimelineRememberSubmenu(enabled) {
    timelineRememberSubmenu = !!enabled;
    localStorage.setItem(
      TIMELINE_REMEMBER_SUBMENU_KEY,
      timelineRememberSubmenu ? '1' : '0'
    );
  }

  function loadTimelineRememberQuickSetting() {
    const stored = localStorage.getItem(TIMELINE_QUICK_ACTIONS_KEY);
    timelineRememberQuickActions = stored !== '0';
    if (el.timelineRememberQuickToggle) {
      el.timelineRememberQuickToggle.checked = timelineRememberQuickActions;
    }
  }

  function setTimelineRememberQuickActions(enabled) {
    timelineRememberQuickActions = !!enabled;
    localStorage.setItem(
      TIMELINE_QUICK_ACTIONS_KEY,
      timelineRememberQuickActions ? '1' : '0'
    );
  }

  function setTimelineWaveformVisible(enabled) {
    state.timelineShowWaveform = !!enabled;
    localStorage.setItem(
      TIMELINE_WAVEFORM_KEY,
      state.timelineShowWaveform ? '1' : '0'
    );
    applyTimelineWaveformVisibility();
  }

  function updateStageElementsFilterChips() {
    const chips = document.querySelectorAll('[data-stage-filter]');
    if (!chips.length) return;
    chips.forEach((chip) => {
      const type = chip.dataset.stageFilter || 'all';
      const active = type === state.stageElementsFilterType;
      chip.classList.toggle('active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function setStageElementsFilterType(type) {
    state.stageElementsFilterType = type || 'all';
    localStorage.setItem(
      STAGE_ELEMENTS_FILTER_TYPE_KEY,
      state.stageElementsFilterType
    );
    updateStageElementsFilterChips();
    renderStageElementsList();
  }

  function loadStageElementsFilterType() {
    const raw = localStorage.getItem(STAGE_ELEMENTS_FILTER_TYPE_KEY);
    if (raw) state.stageElementsFilterType = raw;
    updateStageElementsFilterChips();
  }

  function updateStageElementsStatusChips() {
    const chips = document.querySelectorAll('[data-stage-status]');
    if (!chips.length) return;
    chips.forEach((chip) => {
      const value = chip.dataset.stageStatus || 'all';
      const active = value === state.stageElementsFilterStatus;
      chip.classList.toggle('active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function stageTypeMatchesSearch(key, search) {
    if (!search) return false;
    if (key === 'text')
      return search.includes('text') || search.includes('txt');
    if (key === 'shape') return search.includes('shape');
    if (key === 'asset') {
      return (
        search.includes('asset') ||
        search.includes('image') ||
        search.includes('img')
      );
    }
    return false;
  }

  function stageStatusMatchesSearch(key, search) {
    if (!search) return false;
    if (key === 'locked' || key === 'unlocked') return search.includes('lock');
    if (key === 'hidden')
      return search.includes('hid') || search.includes('hide');
    if (key === 'visible')
      return search.includes('vis') || search.includes('show');
    return false;
  }

  function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function updateStageElementsFilterCounts() {
    const elements = state.activePageId
      ? (state.stageElements || []).filter(
          (element) => !element.pageId || element.pageId === state.activePageId
        )
      : state.stageElements || [];
    const total = elements.length;
    const countText = elements.filter(
      (element) => element.type === 'text'
    ).length;
    const countShape = elements.filter(
      (element) => element.type === 'shape'
    ).length;
    const countAsset = elements.filter(
      (element) => element.type !== 'text' && element.type !== 'shape'
    ).length;
    const countLocked = elements.filter((element) => element.locked).length;
    const countHidden = elements.filter((element) => element.hidden).length;

    const typeCounts = {
      all: total,
      text: countText,
      shape: countShape,
      asset: countAsset,
    };
    const statusCounts = {
      all: total,
      locked: countLocked,
      hidden: countHidden,
      unlocked: total - countLocked,
      visible: total - countHidden,
    };

    const typeSearch = (state.stageElementsFilter || '').toLowerCase();
    document.querySelectorAll('[data-stage-filter]').forEach((chip) => {
      const key = chip.dataset.stageFilter || 'all';
      const base = chip.dataset.stageFilterLabel || chip.textContent || key;
      if (typeof typeCounts[key] === 'number') {
        const label = `${base} (${typeCounts[key]})`;
        const icon = chip.dataset.stageIcon;
        if (icon) {
          chip.innerHTML = `<span class="stage-chip-icon" aria-hidden="true">${icon}</span><span class="sr-only">${label}</span>`;
          chip.setAttribute('aria-label', label);
        } else {
          chip.textContent = label;
          chip.setAttribute('aria-label', label);
        }
        chip.title = `${base}: ${typeCounts[key]} · click to filter · Esc clears search`;
        const isActive = key === state.stageElementsFilterType;
        const isEmpty = key !== 'all' && typeCounts[key] === 0 && !isActive;
        chip.disabled = isEmpty;
        chip.classList.toggle('is-empty', isEmpty);
        chip.setAttribute('aria-disabled', isEmpty ? 'true' : 'false');
        const isMatch = stageTypeMatchesSearch(key, typeSearch);
        chip.classList.toggle('is-match', isMatch && !isActive);
      }
    });
    const statusSearch = (state.stageElementsFilter || '').toLowerCase();
    document.querySelectorAll('[data-stage-status]').forEach((chip) => {
      const key = chip.dataset.stageStatus || 'all';
      const base = chip.dataset.stageStatusLabel || chip.textContent || key;
      if (typeof statusCounts[key] === 'number') {
        const label = `${base} (${statusCounts[key]})`;
        const icon = chip.dataset.stageIcon;
        if (icon) {
          chip.innerHTML = `<span class="stage-chip-icon" aria-hidden="true">${icon}</span><span class="sr-only">${label}</span>`;
          chip.setAttribute('aria-label', label);
        } else {
          chip.textContent = label;
          chip.setAttribute('aria-label', label);
        }
        chip.title = `${base}: ${statusCounts[key]} · click to filter · Esc clears search`;
        const isActive = key === state.stageElementsFilterStatus;
        const isEmpty = key !== 'all' && statusCounts[key] === 0 && !isActive;
        chip.disabled = isEmpty;
        chip.classList.toggle('is-empty', isEmpty);
        chip.setAttribute('aria-disabled', isEmpty ? 'true' : 'false');
        const isMatch = stageStatusMatchesSearch(key, statusSearch);
        chip.classList.toggle('is-match', isMatch && !isActive);
      }
    });
    document
      .querySelectorAll('[data-stage-filter-preset]')
      .forEach((option) => {
        const key = option.dataset.stageFilterPreset || 'all';
        const base =
          option.dataset.stageFilterPresetLabel || option.textContent || key;
        const count =
          typeof typeCounts[key] === 'number'
            ? typeCounts[key]
            : statusCounts[key];
        if (typeof count === 'number') {
          option.textContent = `${base} (${count})`;
          option.title = `${base}: ${count}`;
        }
      });
  }

  function normalizeStageElementsPresetHistory(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map((item) => {
        if (typeof item === 'string') return { id: item, ts: 0 };
        if (item && typeof item === 'object' && item.id) {
          return { id: item.id, ts: Number(item.ts) || 0 };
        }
        return null;
      })
      .filter(Boolean);
  }

  function getStageElementsPresetHistory() {
    const raw = localStorage.getItem(STAGE_ELEMENTS_PRESET_HISTORY_KEY);
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return normalizeStageElementsPresetHistory(parsed);
    } catch (err) {
      return [];
    }
  }

  function setStageElementsPresetHistory(list) {
    localStorage.setItem(
      STAGE_ELEMENTS_PRESET_HISTORY_KEY,
      JSON.stringify(list)
    );
  }

  function formatStageElementsPresetAge(ts) {
    if (!ts) return '';
    const diff = Date.now() - ts;
    if (!Number.isFinite(diff) || diff < 0) return '';
    const sec = Math.floor(diff / 1000);
    if (sec < 60) return `${sec}s`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min}m`;
    const hour = Math.floor(min / 60);
    if (hour < 24) return `${hour}h`;
    const day = Math.floor(hour / 24);
    return `${day}d`;
  }

  function renderStageElementsPresetHistory() {
    if (!el.stageElementsFilterPresets) return;
    const history = getStageElementsPresetHistory();
    el.stageElementsFilterPresets.innerHTML = '';
    if (!history.length) {
      el.stageElementsFilterPresets.style.display = 'none';
      return;
    }
    const labels = {
      text: 'Text',
      shape: 'Shape',
      asset: 'Asset',
      locked: 'Locked',
      hidden: 'Hidden',
      unlocked: 'Unlocked',
      visible: 'Visible',
      selected: 'Selected',
    };
    const counts = {
      text: state.stageElements.filter((element) => element.type === 'text')
        .length,
      shape: state.stageElements.filter((element) => element.type === 'shape')
        .length,
      asset: state.stageElements.filter(
        (element) => element.type !== 'text' && element.type !== 'shape'
      ).length,
      locked: state.stageElements.filter((element) => element.locked).length,
      hidden: state.stageElements.filter((element) => element.hidden).length,
      unlocked: state.stageElements.filter((element) => !element.locked).length,
      visible: state.stageElements.filter((element) => !element.hidden).length,
      selected: Array.isArray(state.selectedStageElementIds)
        ? state.selectedStageElementIds.length
        : 0,
    };
    history.forEach((preset) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'stage-filter-preset';
      const label = labels[preset.id] || preset.id;
      button.textContent = label;
      const age = formatStageElementsPresetAge(preset.ts);
      const count =
        typeof counts[preset.id] === 'number' ? counts[preset.id] : null;
      const countLabel =
        count !== null ? ` · ${count} layer${count === 1 ? '' : 's'}` : '';
      button.title = age
        ? `Apply preset: ${label}${countLabel} · last used ${age} ago`
        : `Apply preset: ${label}${countLabel}`;
      button.addEventListener('click', () =>
        applyStageElementsFilterPreset(preset.id, false)
      );
      el.stageElementsFilterPresets.appendChild(button);
    });
    const clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'stage-filter-preset-clear';
    clear.textContent = 'Clear';
    clear.title = 'Clear recent presets (Alt+Shift+0)';
    clear.addEventListener('click', () => {
      clearStageElementsPresetHistory();
    });
    el.stageElementsFilterPresets.appendChild(clear);
    el.stageElementsFilterPresets.style.display = 'flex';
  }

  function clearStageElementsPresetHistory() {
    const history = getStageElementsPresetHistory();
    if (!history.length) return;
    stageElementsPresetHistoryUndo = history;
    if (stageElementsPresetHistoryUndoTimer) {
      clearTimeout(stageElementsPresetHistoryUndoTimer);
    }
    stageElementsPresetHistoryUndoTimer = setTimeout(() => {
      stageElementsPresetHistoryUndo = null;
      stageElementsPresetHistoryUndoTimer = null;
    }, 10000);
    setStageElementsPresetHistory([]);
    state.stageElementsPresetCycleIndex = 0;
    renderStageElementsPresetHistory();
    notify('Preset history cleared (Alt+Shift+Z to undo)', 'info');
  }

  function restoreStageElementsPresetHistory() {
    if (
      !stageElementsPresetHistoryUndo ||
      !stageElementsPresetHistoryUndo.length
    )
      return;
    setStageElementsPresetHistory(stageElementsPresetHistoryUndo);
    stageElementsPresetHistoryUndo = null;
    if (stageElementsPresetHistoryUndoTimer) {
      clearTimeout(stageElementsPresetHistoryUndoTimer);
      stageElementsPresetHistoryUndoTimer = null;
    }
    renderStageElementsPresetHistory();
    notify('Preset history restored', 'info');
  }

  function recordStageElementsPreset(preset) {
    if (!preset || preset === 'all') return;
    const history = getStageElementsPresetHistory();
    const now = Date.now();
    const next = [
      { id: preset, ts: now },
      ...history.filter((item) => item.id !== preset),
    ].slice(0, 3);
    setStageElementsPresetHistory(next);
    state.stageElementsPresetCycleIndex = 0;
    renderStageElementsPresetHistory();
  }

  function applyStageElementsFilterPreset(preset, record = true) {
    state.stageElementsFilter = '';
    state.stageElementsFilterType = 'all';
    state.stageElementsFilterStatus = 'all';
    state.stageElementsFilterSelectedOnly = false;
    if (preset === 'text' || preset === 'shape' || preset === 'asset') {
      state.stageElementsFilterType = preset;
    } else if (
      preset === 'locked' ||
      preset === 'hidden' ||
      preset === 'unlocked' ||
      preset === 'visible'
    ) {
      state.stageElementsFilterStatus = preset;
    } else if (preset === 'selected') {
      state.stageElementsFilterSelectedOnly = true;
    }
    localStorage.setItem(
      STAGE_ELEMENTS_FILTER_TYPE_KEY,
      state.stageElementsFilterType
    );
    localStorage.setItem(
      STAGE_ELEMENTS_FILTER_STATUS_KEY,
      state.stageElementsFilterStatus
    );
    localStorage.setItem(
      STAGE_ELEMENTS_SELECTED_ONLY_KEY,
      state.stageElementsFilterSelectedOnly ? '1' : '0'
    );
    if (el.stageElementsFilter) {
      el.stageElementsFilter.value = '';
    }
    if (el.stageElementsFilterPreset) {
      el.stageElementsFilterPreset.value = '';
    }
    applyStageElementsSelectedOnly();
    updateStageElementsFilterChips();
    updateStageElementsStatusChips();
    renderStageElementsList();
    if (record) recordStageElementsPreset(preset);
  }

  function cycleStageElementsPreset(direction) {
    const history = getStageElementsPresetHistory();
    if (!history.length) return;
    const count = history.length;
    const nextIndex =
      (state.stageElementsPresetCycleIndex + direction + count) % count;
    state.stageElementsPresetCycleIndex = nextIndex;
    const preset = history[nextIndex];
    if (preset && preset.id) {
      applyStageElementsFilterPreset(preset.id, true);
    }
  }

  function getStageElementsFilterPresetMatch() {
    const filterRaw = (state.stageElementsFilter || '').trim();
    if (filterRaw) return null;
    const typeFilter = state.stageElementsFilterType || 'all';
    const statusFilter = state.stageElementsFilterStatus || 'all';
    const selectedOnly = !!state.stageElementsFilterSelectedOnly;
    if (selectedOnly)
      return typeFilter === 'all' && statusFilter === 'all' ? 'selected' : null;
    if (typeFilter !== 'all' && statusFilter === 'all') return typeFilter;
    if (statusFilter !== 'all' && typeFilter === 'all') return statusFilter;
    return typeFilter === 'all' && statusFilter === 'all' ? 'all' : null;
  }

  function updateStageElementsFilterPreset() {
    if (!el.stageElementsFilterPreset) return;
    if (el.stageElementsActivePreset) {
      el.stageElementsActivePreset.style.display = 'none';
      el.stageElementsActivePreset.textContent = '';
    }
    const preset = getStageElementsFilterPresetMatch();
    const placeholder =
      el.stageElementsFilterPreset.querySelector('option[value=""]');
    if (preset && preset !== 'all') {
      el.stageElementsFilterPreset.value = preset;
      if (placeholder) placeholder.textContent = 'Preset';
      el.stageElementsFilterPreset.title = `Preset: ${preset}`;
      if (el.stageElementsActivePreset) {
        el.stageElementsActivePreset.textContent = preset.toUpperCase();
        el.stageElementsActivePreset.style.display = 'inline-flex';
      }
      renderStageElementsPresetHistory();
      return;
    }
    if (!preset) {
      el.stageElementsFilterPreset.value = '';
      if (placeholder) placeholder.textContent = 'Custom';
      el.stageElementsFilterPreset.title = 'Custom filters active';
      renderStageElementsPresetHistory();
      return;
    }
    el.stageElementsFilterPreset.value = '';
    if (placeholder) placeholder.textContent = 'Preset';
    el.stageElementsFilterPreset.title = 'Preset';
    renderStageElementsPresetHistory();
  }

  function toggleStageElementsLocked() {
    if (!state.stageElements.length) {
      notify('No stage elements to lock/unlock', 'info');
      return;
    }
    const selected = getSelectedStageElements();
    const targets = selected.length ? selected : state.stageElements;
    const nextValue = !targets.every((element) => element.locked);
    targets.forEach((element) => {
      element.locked = nextValue;
    });
    renderPages();
    renderStageElements();
    renderStageElementsList();
    updateStageElementControls();
    scheduleAutosave('stage-lock');
    notify(nextValue ? 'Locked layer(s)' : 'Unlocked layer(s)', 'success');
  }

  function toggleStageElementsHidden() {
    if (!state.stageElements.length) {
      notify('No stage elements to show/hide', 'info');
      return;
    }
    const selected = getSelectedStageElements();
    const targets = selected.length ? selected : state.stageElements;
    const nextValue = !targets.every((element) => element.hidden);
    targets.forEach((element) => {
      element.hidden = nextValue;
    });
    renderStageElements();
    renderStageElementsList();
    updateStageElementControls();
    scheduleAutosave('stage-visibility');
    notify(nextValue ? 'Hidden layer(s)' : 'Shown layer(s)', 'success');
  }

  function setStageElementsFilterStatus(value) {
    state.stageElementsFilterStatus = value || 'all';
    localStorage.setItem(
      STAGE_ELEMENTS_FILTER_STATUS_KEY,
      state.stageElementsFilterStatus
    );
    updateStageElementsStatusChips();
    renderStageElementsList();
  }

  function loadStageElementsFilterStatus() {
    const raw = localStorage.getItem(STAGE_ELEMENTS_FILTER_STATUS_KEY);
    if (raw) state.stageElementsFilterStatus = raw;
    updateStageElementsStatusChips();
  }

  function applyStageElementsSelectedOnly() {
    if (el.stageElementsSelectedToggle) {
      el.stageElementsSelectedToggle.checked =
        state.stageElementsFilterSelectedOnly;
    }
  }

  function clearStageElementsFilters() {
    state.stageElementsFilter = '';
    state.stageElementsFilterType = 'all';
    state.stageElementsFilterStatus = 'all';
    state.stageElementsFilterSelectedOnly = false;
    localStorage.setItem(STAGE_ELEMENTS_FILTER_TYPE_KEY, 'all');
    localStorage.setItem(STAGE_ELEMENTS_FILTER_STATUS_KEY, 'all');
    localStorage.setItem(STAGE_ELEMENTS_SELECTED_ONLY_KEY, '0');
    if (el.stageElementsFilter) {
      el.stageElementsFilter.value = '';
    }
    if (el.stageElementsFilterPreset) {
      el.stageElementsFilterPreset.value = '';
    }
    applyStageElementsSelectedOnly();
    updateStageElementsFilterChips();
    updateStageElementsStatusChips();
    renderStageElementsList();
  }

  function loadStageElementsSelectedOnly() {
    state.stageElementsFilterSelectedOnly =
      localStorage.getItem(STAGE_ELEMENTS_SELECTED_ONLY_KEY) === '1';
    applyStageElementsSelectedOnly();
  }

  function setStageElementsSelectedOnly(enabled) {
    state.stageElementsFilterSelectedOnly = !!enabled;
    localStorage.setItem(
      STAGE_ELEMENTS_SELECTED_ONLY_KEY,
      state.stageElementsFilterSelectedOnly ? '1' : '0'
    );
    applyStageElementsSelectedOnly();
    renderStageElementsList();
  }

  function applyStageElementsTypeBadges() {
    if (el.stageElementsTypeBadgeToggle) {
      el.stageElementsTypeBadgeToggle.checked =
        state.stageElementsShowTypeBadges;
    }
  }

  function loadStageElementsTypeBadges() {
    state.stageElementsShowTypeBadges =
      localStorage.getItem(STAGE_ELEMENTS_TYPE_BADGE_KEY) !== '0';
    applyStageElementsTypeBadges();
  }

  function setStageElementsTypeBadges(enabled) {
    state.stageElementsShowTypeBadges = !!enabled;
    localStorage.setItem(
      STAGE_ELEMENTS_TYPE_BADGE_KEY,
      state.stageElementsShowTypeBadges ? '1' : '0'
    );
    applyStageElementsTypeBadges();
    renderStageElementsList();
  }

  function applyStageElementsCompact() {
    if (el.stageElementsPanel) {
      el.stageElementsPanel.classList.toggle(
        'compact',
        state.stageElementsCompact
      );
    }
    if (el.stageElementsCompactToggle) {
      el.stageElementsCompactToggle.checked = state.stageElementsCompact;
    }
  }

  function loadStageElementsCompact() {
    state.stageElementsCompact =
      localStorage.getItem(STAGE_ELEMENTS_COMPACT_KEY) === '1';
    applyStageElementsCompact();
  }

  function setStageElementsCompact(enabled) {
    state.stageElementsCompact = !!enabled;
    localStorage.setItem(
      STAGE_ELEMENTS_COMPACT_KEY,
      state.stageElementsCompact ? '1' : '0'
    );
    applyStageElementsCompact();
  }

  function updateStageToolsDetails() {
    if (!el.stageToolsDetails) return;
    const anyEnabled = !!(
      el.stageSnapToggle?.checked ||
      el.stageGridToggle?.checked ||
      el.stageSnapGridToggle?.checked
    );
    if (anyEnabled) {
      el.stageToolsDetails.open = true;
      return;
    }
    if (el.stageToolsDetails.open) {
      el.stageToolsDetails.open = false;
    }
  }

  function hasActiveStageElementsFilters() {
    const filterRaw = (state.stageElementsFilter || '').trim();
    return (
      !!filterRaw ||
      state.stageElementsFilterType !== 'all' ||
      state.stageElementsFilterStatus !== 'all' ||
      !!state.stageElementsFilterSelectedOnly
    );
  }

  function setStageFiltersPopoverOpen(open, { focus } = {}) {
    if (!el.stageFiltersPopover) return;
    if (stageFiltersPopoverCloseTimer) {
      clearTimeout(stageFiltersPopoverCloseTimer);
      stageFiltersPopoverCloseTimer = null;
    }
    el.stageFiltersPopover.classList.toggle('open', open);
    el.stageFiltersPopover.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (el.stageFiltersToggle) {
      el.stageFiltersToggle.classList.toggle('active', open);
      el.stageFiltersToggle.style.display = open ? 'none' : 'inline-flex';
    }
    if (open && focus && el.stageElementsFilter) {
      el.stageElementsFilter.focus();
    }
  }

  function updateStageFiltersPopover(
    hasFilter = hasActiveStageElementsFilters()
  ) {
    if (!el.stageFiltersPopover) return;
    const hasFocus = el.stageFiltersPopover.contains(document.activeElement);
    if (hasFocus) {
      stageFiltersPopoverManualClosed = false;
    }
    if (!hasFilter) {
      stageFiltersPopoverManualClosed = false;
    }
    const shouldOpen =
      hasFocus || (hasFilter && !stageFiltersPopoverManualClosed);
    if (shouldOpen) {
      if (stageFiltersPopoverCloseTimer) {
        clearTimeout(stageFiltersPopoverCloseTimer);
        stageFiltersPopoverCloseTimer = null;
      }
      setStageFiltersPopoverOpen(true);
      return;
    }
    if (stageFiltersPopoverCloseTimer) return;
    stageFiltersPopoverCloseTimer = window.setTimeout(() => {
      stageFiltersPopoverCloseTimer = null;
      if (hasActiveStageElementsFilters()) return;
      if (el.stageFiltersPopover.contains(document.activeElement)) return;
      setStageFiltersPopoverOpen(false);
    }, FILTER_POPOVER_CLOSE_DELAY_MS);
  }

  function updateStageElementsFilterClearIcon() {
    if (!el.stageElementsFilterClearIcon) return;
    const hasFilter = !!(state.stageElementsFilter || '').trim();
    el.stageElementsFilterClearIcon.style.display = hasFilter
      ? 'inline-flex'
      : 'none';
  }

  function setTimelineHoverState(open) {
    if (!el.timelinePanel) return;
    el.timelinePanel.classList.toggle('is-hover', open);
  }

  function scheduleTimelineHover(open) {
    if (!el.timelinePanel) return;
    if (timelineHoverTimer) {
      clearTimeout(timelineHoverTimer);
      timelineHoverTimer = null;
    }
    if (timelineLeaveTimer) {
      clearTimeout(timelineLeaveTimer);
      timelineLeaveTimer = null;
    }
    if (open) {
      timelineHoverTimer = window.setTimeout(() => {
        timelineHoverTimer = null;
        setTimelineHoverState(true);
      }, TIMELINE_HOVER_DELAY_MS);
      return;
    }
    timelineLeaveTimer = window.setTimeout(() => {
      timelineLeaveTimer = null;
      setTimelineHoverState(false);
    }, TIMELINE_HOVER_LEAVE_DELAY_MS);
  }

  function bindElements() {
    el.videoEditorForm = getEl('video-editor-form');
    el.assetUpload = getEl('asset-upload');
    el.assetFolderUpload = getEl('asset-folder-upload');
    el.assetDrop = getEl('asset-drop');
    el.assetBrowse = getEl('asset-browse');
    el.assetFolderBrowse = getEl('asset-browse-folder');
    el.audioUpload = getEl('audio-upload');
    el.audioUploadOpen = getEl('audio-upload-open');
    el.audioClear = getEl('audio-clear');
    el.audioGain = getEl('audio-gain');
    el.audioFadeIn = getEl('audio-fade-in');
    el.audioFadeOut = getEl('audio-fade-out');
    el.assetList = getEl('asset-list');
    el.assetRecord = getEl('asset-record');
    el.assetRecordStop = getEl('asset-record-stop');
    el.assetRecordAddToStage = getEl('asset-record-add-to-stage');
    el.assetRecordSource = getEl('asset-record-source');
    el.editorSidebar = getEl('editor-sidebar');
    el.mobileSidebarToggle = getEl('mobile-sidebar-toggle');
    el.mobileInspectorToggle = getEl('mobile-inspector-toggle');
    el.mobileDrawerScrim = getEl('mobile-drawer-scrim');
    el.inspectorPanelClose = getEl('inspector-panel-close');
    el.sidebarDrawer = getEl('sidebar-drawer');
    el.sidebarDrawerTitle = getEl('sidebar-drawer-title');
    el.sidebarDrawerClose = getEl('sidebar-drawer-close');
    el.editorHistoryModal = getEl('editor-history-modal');
    el.editorHistoryClose = getEl('editor-history-close');
    el.timelineHistoryOpen = getEl('timeline-history-open');
    el.timelinePanel = getEl('timeline-panel');
    el.timelineResizeHandle = getEl('timeline-resize-handle');
    el.timelineWaveformToggle = getEl('timeline-waveform-toggle');
    el.timelineRememberSubmenuToggle = getEl(
      'timeline-remember-submenu-toggle'
    );
    el.timelineRememberQuickToggle = getEl('timeline-remember-quick-toggle');
    el.timelineList = getEl('timeline-list');
    if (el.timelinePanel) {
      el.timelinePanel.addEventListener('mouseenter', () =>
        scheduleTimelineHover(true)
      );
      el.timelinePanel.addEventListener('mouseleave', () =>
        scheduleTimelineHover(false)
      );
    }
    el.previewCanvas = getEl('preview-canvas');
    el.previewCanvasShell = getEl('preview-canvas-shell');
    el.previewStage = getEl('preview-stage');
    el.workspaceStageLabel = getEl('workspace-stage-label');
    el.workspacePageLabel = getEl('workspace-page-label');
    el.workspaceLayerLabel = getEl('workspace-layer-label');
    el.workspaceSelectionLabel = getEl('workspace-selection-label');
    el.workspaceFxLabel = getEl('workspace-fx-label');
    el.workspaceEmptyState = getEl('workspace-empty-state');
    el.workspaceEmptyOpenLibrary = getEl('workspace-empty-open-library');
    el.workspaceEmptyAddText = getEl('workspace-empty-add-text');
    el.workspaceEmptyAddShape = getEl('workspace-empty-add-shape');
    el.stageGuides = getEl('stage-guides');
    el.stageElements = getEl('stage-elements');
    el.stageContextMenu = getEl('stage-context-menu');
    el.stageBackgroundMenu = getEl('stage-background-menu');
    el.assetContextMenu = getEl('asset-context-menu');
    el.stageSelectionBox = getEl('stage-selection-box');
    el.stageSelectionMeasure = getEl('stage-selection-measure');
    el.stageSelectionGhost = getEl('stage-selection-ghost');
    el.stageDragHud = getEl('stage-drag-hud');
    el.stageInlineToolbar = getEl('stage-inline-toolbar');
    el.stageInlineFontSize = getEl('stage-inline-font-size');
    el.stageInlineColor = getEl('stage-inline-color');
    el.stageInlineCropZoom = getEl('stage-inline-crop-zoom');
    el.stageInlineCropX = getEl('stage-inline-crop-x');
    el.stageInlineCropY = getEl('stage-inline-crop-y');
    el.dropOverlay = getEl('drop-overlay');
    el.dropOverlayTitle = getEl('drop-overlay-title');
    el.dropOverlaySub = getEl('drop-overlay-sub');
    el.timelinePlayToggle = getEl('timeline-play-toggle');
    el.timelineTime = getEl('timeline-time');
    el.timelineDuration = getEl('timeline-duration');
    el.featureFlagContainer = getEl('video-editor-form');
    el.projectResolution = getEl('project-resolution');
    el.projectFps = getEl('project-fps');
    el.magicResizeOpen = getEl('magic-resize-open');
    el.magicResizeModal = getEl('magic-resize-modal');
    el.magicResizeClose = getEl('magic-resize-close');
    el.magicResizeCancel = getEl('magic-resize-cancel');
    el.magicResizeRun = getEl('magic-resize-run');
    el.magicResizeSourcePreview = getEl('magic-resize-source-preview');
    el.magicResizeSourceName = getEl('magic-resize-source-name');
    el.magicResizeSourceMeta = getEl('magic-resize-source-meta');
    el.magicResizeLocalMode = getEl('magic-resize-local-mode');
    el.magicResizeAiMode = getEl('magic-resize-ai-mode');
    el.magicResizeScope = getEl('magic-resize-scope');
    el.magicResizePromptWrap = getEl('magic-resize-prompt-wrap');
    el.magicResizePrompt = getEl('magic-resize-prompt');
    el.magicResizeStatus = getEl('magic-resize-status');
    el.timelineZoom = getEl('timeline-zoom');
    el.timelineZoomOut = getEl('timeline-zoom-out');
    el.timelineZoomIn = getEl('timeline-zoom-in');
    el.timelineHistoryToggle = getEl('timeline-history-toggle');
    el.timelineHistoryPanel = getEl('timeline-history-panel');
    el.timelineHistoryExport = getEl('timeline-history-export');
    el.timelineHistoryExportCsv = getEl('timeline-history-export-csv');
    el.pagesBar = getEl('pages-bar');
    el.pageList = getEl('page-list');
    el.pageAdd = getEl('page-add');
    el.timelineSelectionBar = getEl('timeline-selection-bar');
    el.timelineRuler = getEl('timeline-ruler');
    el.timelineRulerTrack = getEl('timeline-ruler-track');
    el.timelineRulerHover = getEl('timeline-ruler-hover');
    el.timelineRulerHoverText = getEl('timeline-ruler-hover-text');
    el.timelineRulerHoverLine = getEl('timeline-ruler-hover-line');
    el.timelineTimeGhost = getEl('timeline-time-ghost');
    el.timelineTimeGhostText = getEl('timeline-time-ghost-text');
    el.timelineTimeGhostLine = getEl('timeline-time-ghost-line');
    el.timelineTicks = getEl('timeline-ticks');
    el.timelineTrack = document.querySelector('.timeline-track');
    el.videoEditorShell = document.querySelector('.video-editor-shell');
    el.timelineContextMenu = getEl('timeline-context-menu');
    el.timelineContextTitle = getEl('timeline-context-title');
    el.timelineTrackMenu = getEl('timeline-track-menu');
    el.timelineMarkerMenu = getEl('timeline-marker-menu');
    el.timelineContextOverlay = getEl('timeline-context-overlay');
    el.timelineMarkerList = getEl('timeline-marker-list');
    el.timelineMarkerAdd = getEl('timeline-marker-add');
    el.timelineMarkerClear = getEl('timeline-marker-clear');
    el.inspectorPins = getEl('inspector-pins');
    el.inspectorPinFields = getEl('inspector-pin-fields');
    el.inspectorPinMenu = getEl('inspector-pin-menu');
    el.inspectorPanel = document.querySelector('.inspector-panel');
    el.inspectorTitle = document.querySelector('.inspector-title');
    el.inspectorContextClip = getEl('inspector-context-clip');
    el.inspectorContextStage = getEl('inspector-context-stage');
    el.inspectorEmpty = getEl('inspector-empty');
    el.videoEditorBody = document.querySelector('.video-editor-body');
    el.stageElementsPanel = getEl('stage-elements-panel');
    el.stageElementsList = getEl('stage-elements-list');
    el.stageElementsLayersSummary = getEl('stage-elements-layers-summary');
    el.stageElementsFilter = getEl('stage-elements-filter');
    el.stageElementsFilterClear = getEl('stage-elements-filter-clear');
    el.stageElementsFilterClearIcon = getEl('stage-elements-filter-clear-icon');
    el.stageElementsFilterReset = getEl('stage-elements-filter-reset');
    el.stageElementsFilterPreset = getEl('stage-elements-filter-preset');
    el.stageElementsFilterClearAll = getEl('stage-elements-filter-clear-all');
    el.stageElementsFilterCount = getEl('stage-elements-filter-count');
    el.stageElementsFilterPresets = getEl('stage-elements-filter-presets');
    el.stageElementsActivePreset = getEl('stage-elements-active-preset');
    el.stageElementsFilterSummary = getEl('stage-elements-filter-summary');
    el.stageElementsFilterChips = document.querySelectorAll(
      '[data-stage-filter]'
    );
    el.stageElementsStatusChips = document.querySelectorAll(
      '[data-stage-status]'
    );
    el.stageElementsActionChips = document.querySelectorAll(
      '[data-stage-action]'
    );
    el.stageFiltersPopover = getEl('stage-elements-filter-popover');
    el.stageFiltersToggle = getEl('stage-elements-filter-toggle');
    el.stageElementsSelectedToggle = getEl('stage-elements-selected-toggle');
    el.stageElementsTypeBadgeToggle = getEl('stage-elements-type-badge-toggle');
    el.stageElementsCompactToggle = getEl('stage-elements-compact-toggle');
    el.publishMenu = getEl('publish-menu');
    el.stageToolsDetails = document.querySelector(
      '[data-details-key="stage-section-tools"]'
    );
    el.stageSnapToggle = getEl('stage-snap-toggle');
    el.stageSnapStrength = getEl('stage-snap-strength');
    el.stageSnapStrengthInput = getEl('stage-snap-strength-input');
    el.stageToolbarSnap = getEl('stage-toolbar-snap');
    el.stageToolbarGrid = getEl('stage-toolbar-grid');
    el.stageToolbarRotate = getEl('stage-toolbar-rotate');
    el.toolbarRotate90 = getEl('toolbar-rotate-90');
    el.stageToolbarLock = getEl('stage-toolbar-lock');
    el.toolbarFontSearch = getEl('toolbar-font-search');
    el.toolbarFont = getEl('toolbar-font');
    el.toolbarFontOpen = getEl('toolbar-font-open');
    el.toolbarFontRecents = getEl('toolbar-font-recents');
    el.toolbarFontSize = getEl('toolbar-font-size');
    el.toolbarBold = getEl('toolbar-bold');
    el.toolbarItalic = getEl('toolbar-italic');
    el.toolbarUnderline = getEl('toolbar-underline');
    el.toolbarColorSwatches = document.querySelectorAll(
      '.toolbar-color-swatch'
    );
    el.toolbarColorPicker = getEl('toolbar-font-color');
    el.toolbarTransparency = getEl('toolbar-transparency');
    el.toolbarTransparencyPopover = getEl('toolbar-transparency-popover');
    el.toolbarTransparencySlider = getEl('toolbar-transparency-slider');
    el.toolbarTransparencyValue = getEl('toolbar-transparency-value');
    el.toolbarColorEyedrop = getEl('toolbar-color-eyedrop');
    el.toolbarColorPopover = getEl('toolbar-color-popover');
    el.toolbarHsvSphere = getEl('toolbar-hsv-sphere');
    el.toolbarHsvThumb = getEl('toolbar-hsv-thumb');
    el.toolbarHsvValue = getEl('toolbar-hsv-value');
    el.toolbarHsvH = getEl('toolbar-hsv-h');
    el.toolbarHsvS = getEl('toolbar-hsv-s');
    el.toolbarHsvV = getEl('toolbar-hsv-v');
    el.toolbarHsvHex = getEl('toolbar-hsv-hex');
    el.toolbarColorModes = getEl('toolbar-color-modes');
    el.toolbarColorSliders = getEl('toolbar-color-sliders');
    el.toolbarColorFavs = getEl('toolbar-color-favs');
    el.toolbarColorRecents = getEl('toolbar-color-recents');
    el.toolbarColorDoc = getEl('toolbar-color-doc');
    el.toolbarColorFavAdd = getEl('toolbar-color-fav-add');
    el.toolbarTextOptions = getEl('toolbar-text-options');
    el.toolbarEffects = getEl('toolbar-effects');
    el.toolbarAnimate = getEl('toolbar-animate');
    el.toolbarPosition = getEl('toolbar-position');
    el.stageZoomFit = getEl('stage-zoom-fit');
    el.stageZoom50 = getEl('stage-zoom-50');
    el.stageZoom100 = getEl('stage-zoom-100');
    el.stageZoom200 = getEl('stage-zoom-200');
    el.stageZoomRange = getEl('stage-zoom-range');
    el.stageZoomValue = getEl('stage-zoom-value');
    el.stageGridToggle = getEl('stage-grid-toggle');
    el.stageSnapGridToggle = getEl('stage-snap-grid-toggle');
    el.stageAddText = getEl('stage-add-text');
    el.stageAddShape = getEl('stage-add-shape');
    el.stageAddFromAsset = getEl('stage-add-from-asset');
    el.toolbarAddText = getEl('toolbar-add-text');
    el.toolbarAddRect = getEl('toolbar-add-rect');
    el.toolbarAddCircle = getEl('toolbar-add-circle');
    el.toolbarAddLine = getEl('toolbar-add-line');
    el.toolbarShortcutsHelp = getEl('toolbar-shortcuts-help');
    el.stageKeyframeFilterAll = getEl('stage-keyframe-filter-all');
    el.stageKeyframeFilterPos = getEl('stage-keyframe-filter-pos');
    el.stageKeyframeFilterOpacity = getEl('stage-keyframe-filter-opacity');
    el.aiGenerateOpen = getEl('ai-generate-open');
    el.aiGenerateModal = getEl('ai-generate-modal');
    el.aiGenerateClose = getEl('ai-generate-close');
    el.aiOpenSharedArt = getEl('ai-open-shared-art');
    el.aiSearchSubmit = getEl('ai-search-submit');
    el.aiSearchResults = getEl('ai-search-results');
    el.aiSavedResults = getEl('ai-saved-results');
    el.createPicDialog = getEl('create-pic-dialog');
    el.createPicPrompt = getEl('createaiimageprompt');
    el.createPicResults = getEl('createdImagePicsList');
    el.createPicResultsInline = getEl('createdImagePicsList-inline');
    el.editorSettingsButton = getEl('editor-settings');
    el.editorSettingsModal = getEl('editor-settings-modal');
    el.editorSettingsClose = getEl('editor-settings-close');
    el.stageElementControls = getEl('stage-element-controls');
    el.stageElementName = getEl('stage-element-name');
    el.stageElementText = getEl('stage-element-text');
    el.stageElementTextAlign = getEl('stage-element-text-align');
    el.stageElementTextEffect = getEl('stage-element-text-effect');
    el.stageElementTextAnimation = getEl('stage-element-text-animation');
    el.stageElementTextAnimDur = getEl('stage-element-text-anim-dur');
    el.stageElementTextAnimDelay = getEl('stage-element-text-anim-delay');
    el.stageElementFontSize = getEl('stage-element-font-size');
    el.stageElementColor = getEl('stage-element-color');
    el.stageElementBackground = getEl('stage-element-bg');
    el.stageElementColorEyedrop = getEl('stage-element-color-eyedrop');
    el.stageElementBgEyedrop = getEl('stage-element-bg-eyedrop');
    el.stageElementStyleReset = getEl('stage-element-style-reset');
    el.stageElementCopyStyle = getEl('stage-element-copy-style');
    el.stageElementPasteStyle = getEl('stage-element-paste-style');
    el.stageElementCopyAlign = getEl('stage-element-copy-align');
    el.stageElementPasteAlign = getEl('stage-element-paste-align');
    el.stageElementRotation = getEl('stage-element-rotation');
    el.stageElementOpacity = getEl('stage-element-opacity');
    el.stageElementOpacityValue = getEl('stage-element-opacity-value');
    el.stageSectionTextLabel = getEl('stage-section-text-label');
    el.stageElementFxBlur = getEl('stage-element-fx-blur');
    el.stageElementFxBrightness = getEl('stage-element-fx-brightness');
    el.stageElementFxContrast = getEl('stage-element-fx-contrast');
    el.stageElementFxSaturation = getEl('stage-element-fx-saturation');
    el.stageElementFxHue = getEl('stage-element-fx-hue');
    el.stageElementFxReset = getEl('stage-element-fx-reset');
    el.stageElementCopyRotation = getEl('stage-element-copy-rotation');
    el.stageElementPasteRotation = getEl('stage-element-paste-rotation');
    el.stageElementCopyOpacity = getEl('stage-element-copy-opacity');
    el.stageElementPasteOpacity = getEl('stage-element-paste-opacity');
    el.stageElementCopyVisibility = getEl('stage-element-copy-visibility');
    el.stageElementPasteVisibility = getEl('stage-element-paste-visibility');
    el.stageElementAlignLeft = getEl('stage-element-align-left');
    el.stageElementAlignCenter = getEl('stage-element-align-center');
    el.stageElementAlignRight = getEl('stage-element-align-right');
    el.stageElementAlignTop = getEl('stage-element-align-top');
    el.stageElementAlignMiddle = getEl('stage-element-align-middle');
    el.stageElementAlignBottom = getEl('stage-element-align-bottom');
    el.stageElementAlignXThird = getEl('stage-element-align-x-third');
    el.stageElementAlignXCenter = getEl('stage-element-align-x-center');
    el.stageElementAlignXTwoThird = getEl('stage-element-align-x-two-third');
    el.stageElementAlignYThird = getEl('stage-element-align-y-third');
    el.stageElementAlignYCenter = getEl('stage-element-align-y-center');
    el.stageElementAlignYTwoThird = getEl('stage-element-align-y-two-third');
    el.stageElementCopyStageAlign = getEl('stage-element-copy-stage-align');
    el.stageElementPasteStageAlign = getEl('stage-element-paste-stage-align');
    el.stageElementDistributeHorizontal = getEl(
      'stage-element-distribute-horizontal'
    );
    el.stageElementDistributeVertical = getEl(
      'stage-element-distribute-vertical'
    );
    el.stageElementSpacing2 = getEl('stage-element-spacing-2');
    el.stageElementSpacing4 = getEl('stage-element-spacing-4');
    el.stageElementSpacing8 = getEl('stage-element-spacing-8');
    el.stageElementFitStage = getEl('stage-element-fit-stage');
    el.stageElementCenterStage = getEl('stage-element-center-stage');
    el.stageElementSnap16x9 = getEl('stage-element-snap-16x9');
    el.stageElementSnap1x1 = getEl('stage-element-snap-1x1');
    el.stageElementSnap9x16 = getEl('stage-element-snap-9x16');
    el.stageElementResetRotation = getEl('stage-element-reset-rotation');
    el.stageElementResetScale = getEl('stage-element-reset-scale');
    el.stageRotationSnapToggle = getEl('stage-rotation-snap-toggle');
    el.stageAspectLockToggle = getEl('stage-element-aspect-lock');
    el.stageElementResetPosition = getEl('stage-element-reset-position');
    el.stageElementResetAll = getEl('stage-element-reset-all');
    el.stageKeyframePosition = getEl('stage-keyframe-position');
    el.stageKeyframeOpacity = getEl('stage-keyframe-opacity');
    el.stageKeyframeScale = getEl('stage-keyframe-scale');
    el.stageKeyframeAll = getEl('stage-keyframe-all');
    el.stageKeyframeClear = getEl('stage-keyframe-clear');
    el.stageKeyframeList = getEl('stage-keyframe-list');
    el.stageKeyframeTrack = getEl('stage-keyframe-track');
    el.stageKeyframeEase = getEl('stage-keyframe-ease');
    el.stageKeyframePrev = getEl('stage-keyframe-prev');
    el.stageKeyframeNext = getEl('stage-keyframe-next');
    el.stageKeyframeTrackSnap = getEl('stage-keyframe-track-snap');
    el.stageKeyframeClearSolo = getEl('stage-keyframe-clear-solo');
    el.stageElementX = getEl('stage-element-x');
    el.stageElementY = getEl('stage-element-y');
    el.stageElementCopyPos = getEl('stage-element-copy-pos');
    el.stageElementPastePos = getEl('stage-element-paste-pos');
    el.stageElementWidth = getEl('stage-element-width');
    el.stageElementHeight = getEl('stage-element-height');
    el.stageElementCopyScale = getEl('stage-element-copy-scale');
    el.stageElementPasteScale = getEl('stage-element-paste-scale');
    el.stageElementCopySize = getEl('stage-element-copy-size');
    el.stageElementPasteSize = getEl('stage-element-paste-size');
    el.stageElementToFront = getEl('stage-element-to-front');
    el.stageElementToBack = getEl('stage-element-to-back');
    el.stageElementDuplicate = getEl('stage-element-duplicate');
    el.stageElementCopy = getEl('stage-element-copy');
    el.stageElementPaste = getEl('stage-element-paste');
    el.stageElementRemove = getEl('stage-element-remove');
    el.globalHistoryToggle = getEl('global-history-toggle');
    el.globalHistoryPanel = getEl('global-history-panel');
    el.timelineGapSummary = getEl('timeline-gap-summary');
    el.timelineRemoveGaps = getEl('timeline-remove-gaps');
    el.globalHistoryExport = getEl('global-history-export');
    el.globalHistoryExportCsv = getEl('global-history-export-csv');
    el.timelineWaveform = getEl('timeline-waveform');
    el.timelinePlayhead = getEl('timeline-playhead');
    el.timelineSnapline = getEl('timeline-snapline');
    el.projectOpenCloud = getEl('project-open-cloud');
    el.projectSaveCloud = getEl('project-save-cloud');
    el.projectShareCloud = getEl('project-share-cloud');
    el.projectForkCloud = getEl('project-fork-cloud');
    el.projectSyncStatus = getEl('project-sync-status');
    el.projectReadonlyBanner = getEl('project-readonly-banner');
    el.projectLibraryModal = getEl('project-library-modal');
    el.projectLibraryClose = getEl('project-library-close');
    el.projectLibraryRefresh = getEl('project-library-refresh');
    el.projectLibrarySaveCopy = getEl('project-library-save-copy');
    el.projectLibraryFileOpen = getEl('project-library-file-open');
    el.projectLibraryList = getEl('project-library-list');
    el.projectSave = getEl('project-save');
    el.projectLoad = getEl('project-load');
    el.projectExport = getEl('project-export');
    el.projectImport = getEl('project-import');
    el.projectImportInput = getEl('project-import-input');
    el.serverRender = getEl('server-render');
    el.serverPublish = getEl('server-publish');
    el.historyList = getEl('history-list');
    el.historyRestoreLatest = getEl('history-restore-latest');
    el.historyClear = getEl('history-clear');
    el.exportWebm = getEl('export-webm');
    el.exportMp4 = getEl('export-mp4');
    el.publishGallery = getEl('publish-gallery');
    el.inspectorFields = getEl('inspector-fields');
    el.clipName = getEl('clip-name');
    el.clipDuration = getEl('clip-duration');
    el.clipCaptionText = getEl('clip-caption-text');
    el.clipCaptionFontSize = getEl('clip-caption-font-size');
    el.clipCaptionColor = getEl('clip-caption-color');
    el.clipCaptionColorValue = getEl('clip-caption-color-value');
    el.clipCaptionAlign = getEl('clip-caption-align');
    el.clipCaptionY = getEl('clip-caption-y');
    el.clipTrimStart = getEl('clip-trim-start');
    el.clipTrimEnd = getEl('clip-trim-end');
    el.clipTrimStartRange = getEl('clip-trim-start-range');
    el.clipTrimEndRange = getEl('clip-trim-end-range');
    el.clipTrimReset = getEl('clip-trim-reset');
    el.clipSpeed = getEl('clip-speed');
    el.clipSpeedRange = getEl('clip-speed-range');
    el.clipSpeedRampAdd = getEl('clip-speed-ramp-add');
    el.clipSpeedRampClear = getEl('clip-speed-ramp-clear');
    el.clipSpeedRampPreset = getEl('clip-speed-ramp-preset');
    el.clipSpeedRampList = getEl('clip-speed-ramp-list');
    el.clipAudioGain = getEl('clip-audio-gain');
    el.clipAudioGainEnd = getEl('clip-audio-gain-end');
    el.clipAudioGainKeyframeAdd = getEl('clip-audio-gain-keyframe-add');
    el.clipAudioGainEaseIn = getEl('clip-audio-gain-ease-in');
    el.clipAudioGainEaseOut = getEl('clip-audio-gain-ease-out');
    el.clipAudioGainEaseInOut = getEl('clip-audio-gain-ease-in-out');
    el.clipAudioGainClear = getEl('clip-audio-gain-clear');
    el.clipAudioGainFadeIn = getEl('clip-audio-gain-fade-in');
    el.clipAudioGainFadeOut = getEl('clip-audio-gain-fade-out');
    el.clipAudioGainFadeInOut = getEl('clip-audio-gain-fade-in-out');
    el.clipAudioGainKeyframes = getEl('clip-audio-gain-keyframes');
    el.clipAudioPan = getEl('clip-audio-pan');
    el.clipAudioPanEnd = getEl('clip-audio-pan-end');
    el.clipAudioPanKeyframeAdd = getEl('clip-audio-pan-keyframe-add');
    el.clipAudioPanEaseIn = getEl('clip-audio-pan-ease-in');
    el.clipAudioPanEaseOut = getEl('clip-audio-pan-ease-out');
    el.clipAudioPanEaseInOut = getEl('clip-audio-pan-ease-in-out');
    el.clipAudioPanClear = getEl('clip-audio-pan-clear');
    el.clipAudioPanLeftRight = getEl('clip-audio-pan-left-right');
    el.clipAudioPanRightLeft = getEl('clip-audio-pan-right-left');
    el.clipAudioPanKeyframes = getEl('clip-audio-pan-keyframes');
    el.clipAudioMute = getEl('clip-audio-mute');
    el.clipAudioSolo = getEl('clip-audio-solo');
    el.clipAudioFadeIn = getEl('clip-audio-fade-in');
    el.clipAudioFadeOut = getEl('clip-audio-fade-out');
    el.clipAutomationPreview = getEl('clip-automation-preview');
    el.clipAutomationPlayhead = getEl('clip-automation-playhead');
    el.clipAutomationGridToggle = getEl('clip-automation-grid-toggle');
    el.automationUndoToast = getEl('automation-undo-toast');
    el.automationUndoMessage = getEl('automation-undo-message');
    el.automationUndoRedo = getEl('automation-undo-redo');
    el.automationHistoryToggle = getEl('automation-history-toggle');
    el.automationHistoryFilter = getEl('automation-history-filter');
    el.automationHistoryClipFilter = getEl('automation-history-clip-filter');
    el.automationHistorySearch = getEl('automation-history-search');
    el.automationHistorySearchClear = getEl('automation-history-search-clear');
    el.automationHistoryFiltersClear = getEl(
      'automation-history-filters-clear'
    );
    el.automationHistoryBadgesToggle = getEl(
      'automation-history-badges-toggle'
    );
    el.automationHistoryShowAll = getEl('automation-history-show-all');
    el.automationHistoryUndo = getEl('automation-history-undo');
    el.automationHistoryRedo = getEl('automation-history-redo');
    el.automationHistoryClear = getEl('automation-history-clear');
    el.automationHistoryExport = getEl('automation-history-export');
    el.automationHistoryExportCsv = getEl('automation-history-export-csv');
    el.automationHistoryPanel = getEl('automation-history-panel');
    el.clipAudioGainPresetName = getEl('clip-audio-gain-preset-name');
    el.clipAudioGainPresetSave = getEl('clip-audio-gain-preset-save');
    el.clipAudioGainPresets = getEl('clip-audio-gain-presets');
    el.clipAudioGainPresetApply = getEl('clip-audio-gain-preset-apply');
    el.clipAudioGainPresetRename = getEl('clip-audio-gain-preset-rename');
    el.clipAudioGainPresetDelete = getEl('clip-audio-gain-preset-delete');
    el.clipAudioPanPresetName = getEl('clip-audio-pan-preset-name');
    el.clipAudioPanPresetSave = getEl('clip-audio-pan-preset-save');
    el.clipAudioPanPresets = getEl('clip-audio-pan-presets');
    el.clipAudioPanPresetApply = getEl('clip-audio-pan-preset-apply');
    el.clipAudioPanPresetRename = getEl('clip-audio-pan-preset-rename');
    el.clipAudioPanPresetDelete = getEl('clip-audio-pan-preset-delete');
    el.automationPresetsExport = getEl('automation-presets-export');
    el.automationPresetsImport = getEl('automation-presets-import');
    el.automationPresetsCopy = getEl('automation-presets-copy');
    el.automationPresetsPaste = getEl('automation-presets-paste');
    el.automationPresetsLink = getEl('automation-presets-link');
    el.automationPresetsQr = getEl('automation-presets-qr');
    el.automationPresetsShort = getEl('automation-presets-short');
    el.automationPresetsReplace = getEl('automation-presets-replace');
    el.automationPresetsClear = getEl('automation-presets-clear');
    el.automationPresetsImportInput = getEl('automation-presets-import-input');
    el.automationQrBackdrop = getEl('automation-qr-backdrop');
    el.automationQrImage = getEl('automation-qr-img');
    el.automationQrLink = getEl('automation-qr-link');
    el.automationQrClose = getEl('automation-qr-close');
    el.clipTransitionIn = getEl('clip-transition-in');
    el.clipTransitionOut = getEl('clip-transition-out');
    el.clipTransitionDuration = getEl('clip-transition-duration');
    el.queueList = getEl('queue-list');
    el.searchKindButtons = Array.from(
      document.querySelectorAll('.search-kind-btn[data-search-kind]')
    );
    el.searchQuery = getEl('search-query');
    el.searchSubmit = getEl('search-submit');
    el.searchOpenSharedArt = getEl('search-open-shared-art');
    el.searchResults = getEl('search-results');
    el.searchSavedResults = getEl('search-saved-results');
    el.audioCategoryChips = Array.from(
      document.querySelectorAll('.audio-chip[data-audio-category]')
    );
    el.audioGeneratePrompt = getEl('audio-generate-prompt');
    el.audioGenerateDuration = getEl('audio-generate-duration');
    el.audioGenerateFormat = getEl('audio-generate-format');
    el.audioGenerateSeed = getEl('audio-generate-seed');
    el.audioGenerateSubmit = getEl('audio-generate-submit');
    el.audioGenerateOpenEditor = getEl('audio-generate-open-editor');
    el.audioGenerateStatus = getEl('audio-generate-status');
    el.audioGeneratedResult = getEl('audio-generated-result');
    el.audioSearchQuery = getEl('audio-search-query');
    el.audioSearchSubmit = getEl('audio-search-submit');
    el.audioSearchResults = getEl('audio-search-results');
    el.captionsSource = getEl('captions-source');
    el.captionsGenerate = getEl('captions-generate');
    el.captionsClearExisting = getEl('captions-clear-existing');
    el.captionsClear = getEl('captions-clear');
    el.captionsStatus = getEl('captions-status');
    el.captionsList = getEl('captions-list');
    el.keyboardShortcutsModal = getEl('keyboard-shortcuts-modal');
    el.keyboardShortcutsClose = getEl('keyboard-shortcuts-close');
    el.aiRa1Prompt = getEl('ai-ra1-prompt');
    el.aiRa1Size = getEl('ai-ra1-size');
    el.aiRa1Generate = getEl('ai-ra1-generate');
    el.aiComfyGenerate = getEl('ai-comfy-generate');
    el.aiLtx3Prompt = getEl('ai-ltx3-prompt');
    el.aiLtx3Image = getEl('ai-ltx3-image');
    el.aiLtx3Mode = getEl('ai-ltx3-mode');
    el.aiLtx3Duration = getEl('ai-ltx3-duration');
    el.aiLtx3Resolution = getEl('ai-ltx3-resolution');
    el.aiLtx3Generate = getEl('ai-ltx3-generate');
    el.aiLtx3UseSelected = getEl('ai-ltx3-use-selected');
    el.aiReferencePanel = getEl('ai-reference-panel');
    el.aiReferencePreview = getEl('ai-reference-preview');
    el.aiReferenceName = getEl('ai-reference-name');
    el.aiReferenceSize = getEl('ai-reference-size');
    el.aiReferenceUrl = getEl('ai-reference-url');
    el.aiReferenceClear = getEl('ai-reference-clear');
    el.aiH3Prompt = getEl('ai-h3-prompt');
    el.aiH3Image = getEl('ai-h3-image');
    el.aiH3Mode = getEl('ai-h3-mode');
    el.aiH3Duration = getEl('ai-h3-duration');
    el.aiH3Aspect = getEl('ai-h3-aspect');
    el.aiH3Size = getEl('ai-h3-size');
    el.aiH3Audio = getEl('ai-h3-audio');
    el.aiH3Generate = getEl('ai-h3-generate');
    el.aiH3UseSelected = getEl('ai-h3-use-selected');
    el.aiH3EndImage = getEl('ai-h3-end-image');
    el.aiH3EndUseSelected = getEl('ai-h3-end-use-selected');
    el.aiReferenceFile = getEl('ai-reference-file');
    el.shaderFxBlur = getEl('shader-fx-blur');
    el.shaderFxBlurRadius = getEl('shader-fx-blur-radius');
    el.shaderFxRecolor = getEl('shader-fx-recolor');
    el.shaderRecolorControls = getEl('shader-recolor-controls');
    el.shaderFxHue = getEl('shader-fx-hue');
    el.shaderFxSat = getEl('shader-fx-sat');
    el.shaderFxBright = getEl('shader-fx-bright');
    el.shaderFxGlitch = getEl('shader-fx-glitch');
    el.shaderFxGlitchIntensity = getEl('shader-fx-glitch-intensity');
    el.shaderFxVhs = getEl('shader-fx-vhs');
    el.shaderFxVhsIntensity = getEl('shader-fx-vhs-intensity');
    el.shaderFxCorrupt = getEl('shader-fx-corrupt');
    el.shaderFxCorruptIntensity = getEl('shader-fx-corrupt-intensity');
    el.shaderFxBloom = getEl('shader-fx-bloom');
    el.shaderFxBloomIntensity = getEl('shader-fx-bloom-intensity');
    el.shaderFxSharpen = getEl('shader-fx-sharpen');
    el.shaderFxSharpenIntensity = getEl('shader-fx-sharpen-intensity');
    el.shaderFxVignette = getEl('shader-fx-vignette');
    el.shaderFxVignetteIntensity = getEl('shader-fx-vignette-intensity');
    el.shaderFxChromatic = getEl('shader-fx-chromatic');
    el.shaderFxChromaticIntensity = getEl('shader-fx-chromatic-intensity');
    el.shaderFxFilmgrain = getEl('shader-fx-filmgrain');
    el.shaderFxFilmgrainIntensity = getEl('shader-fx-filmgrain-intensity');
    el.shaderFxCrt = getEl('shader-fx-crt');
    el.shaderFxCrtIntensity = getEl('shader-fx-crt-intensity');
    el.shaderFxPixelate = getEl('shader-fx-pixelate');
    el.shaderFxPixelateSize = getEl('shader-fx-pixelate-size');
    el.shaderFxDream = getEl('shader-fx-dream');
    el.shaderFxDreamIntensity = getEl('shader-fx-dream-intensity');
    el.shaderFxEdgeglow = getEl('shader-fx-edgeglow');
    el.shaderFxEdgeglowIntensity = getEl('shader-fx-edgeglow-intensity');
    el.shaderFxDuotone = getEl('shader-fx-duotone');
    el.shaderFxDuotoneIntensity = getEl('shader-fx-duotone-intensity');
    el.shaderFxPresetNone = getEl('shader-fx-preset-none');
    el.shaderFxPresetDreamy = getEl('shader-fx-preset-dreamy');
    el.shaderFxPresetRetro = getEl('shader-fx-preset-retro');
    el.shaderFxPresetGlitchy = getEl('shader-fx-preset-glitchy');
    el.shaderFxPresetVintage = getEl('shader-fx-preset-vintage');
    el.shaderFxPresetCinematic = getEl('shader-fx-preset-cinematic');
    el.shaderFxPresetNoir = getEl('shader-fx-preset-noir');
    el.shaderFxPresetNeon = getEl('shader-fx-preset-neon');
    el.shaderFxPresetLofi = getEl('shader-fx-preset-lofi');
    el.shaderFxPresetCyberpunk = getEl('shader-fx-preset-cyberpunk');
    el.shaderFxPresetFilm = getEl('shader-fx-preset-film');
    el.templatesGrid = getEl('templates-grid');
    el.templatesCategoryBar = getEl('templates-category-bar');
    el.transitionsTarget = getEl('transitions-target');
    el.transitionGrid = getEl('transition-grid');
    el.transitionPanelDuration = getEl('transition-panel-duration');
    el.transitionPanelDurationValue = getEl('transition-panel-duration-value');
    el.transitionPanelReset = getEl('transition-panel-reset');
    el.transitionDirectionButtons = document.querySelectorAll(
      '[data-transition-direction]'
    );
    el.transitionEaseButtons = document.querySelectorAll(
      '[data-transition-panel-ease]'
    );
    el.exportSettingsModal = getEl('export-settings-modal');
    el.exportSettingsClose = getEl('export-settings-close');
    el.exportOpen = getEl('export-open');
    el.exportStart = getEl('export-start');
    el.exportEstimate = getEl('export-estimate');
    el.exportProgress = getEl('export-progress');
    el.exportProgressBar = getEl('export-progress-bar');
    el.shareModal = getEl('share-modal');
    el.shareModalClose = getEl('share-modal-close');
    el.shareOpen = getEl('share-open');
    el.sharePublishGallery = getEl('share-publish-gallery');
    el.sharePublishProgress = getEl('share-publish-progress');
    el.shareProgressBar = getEl('share-progress-bar');
    el.shareStepPublish = getEl('share-step-publish');
    el.shareStepLinks = getEl('share-step-links');
    el.shareStepYoutube = getEl('share-step-youtube');
    el.shareUrl = getEl('share-url');
    el.shareCaption = getEl('share-caption');
    el.shareViewPost = getEl('share-view-post');
    el.shareCopyLink = getEl('share-copy-link');
    el.shareNativeBtn = getEl('share-native-btn');
    el.youtubeConnectBtn = getEl('youtube-connect-btn');
    el.youtubeUploadBtn = getEl('youtube-upload-btn');
    el.youtubeBackBtn = getEl('youtube-back-btn');
    el.youtubeTitle = getEl('youtube-title');
    el.youtubeDescription = getEl('youtube-description');
    el.youtubePrivacy = getEl('youtube-privacy');
    el.youtubeNotConnected = getEl('youtube-not-connected');
    el.youtubeUploadForm = getEl('youtube-upload-form');
  }

  function ensurePages() {
    if (!Array.isArray(state.pages) || state.pages.length === 0) {
      const firstId = `page_${Date.now()}_${Math.random().toString(16).slice(2)}`;
      state.pages = [{ id: firstId, name: 'Page 1', timelineStart: 0 }];
      state.activePageId = firstId;
    }
    state.pages.forEach((page, index) => {
      if (!Number.isFinite(page.timelineStart)) {
        page.timelineStart = index === 0 ? 0 : totalDuration();
      }
      page.timelineStart = Math.max(0, page.timelineStart);
    });
    state.pages.sort((a, b) => {
      const startA = Number.isFinite(a.timelineStart) ? a.timelineStart : 0;
      const startB = Number.isFinite(b.timelineStart) ? b.timelineStart : 0;
      if (startA !== startB) return startA - startB;
      return String(a.id).localeCompare(String(b.id));
    });
    if (state.pages[0]) state.pages[0].timelineStart = 0;
    if (
      !state.activePageId ||
      !state.pages.some((page) => page.id === state.activePageId)
    ) {
      state.activePageId = state.pages[0].id;
    }
    state.stageElements.forEach((element) => {
      if (!element.pageId) {
        element.pageId = state.activePageId;
      }
    });
  }

  function getPageTimelineStart(page) {
    return page && Number.isFinite(page.timelineStart)
      ? Math.max(0, page.timelineStart)
      : 0;
  }

  function getPageTimelineRanges() {
    ensurePages();
    const pages = state.pages.slice().sort((a, b) => {
      const startA = getPageTimelineStart(a);
      const startB = getPageTimelineStart(b);
      if (startA !== startB) return startA - startB;
      return String(a.id).localeCompare(String(b.id));
    });
    const contentEnd = totalDuration();
    return pages.map((page, index) => {
      const start = index === 0 ? 0 : getPageTimelineStart(page);
      const next = pages[index + 1];
      const nextStart = next ? getPageTimelineStart(next) : null;
      let end =
        nextStart !== null
          ? Math.max(start, nextStart)
          : Math.max(contentEnd, start);
      const active = page.id === state.activePageId;
      if (active && end <= start) end = start + 4;
      return { page, index, start, end };
    });
  }

  function pageRangeHasContent(range) {
    if (!range || !range.page) return false;
    const start = range.start;
    const end = range.end;
    const hasClips = state.clips.some((clip) => {
      if (!clip || clip.type === 'audio') return false;
      const clipStart = Number.isFinite(clip.start) ? clip.start : 0;
      const clipEnd =
        clipStart + (Number.isFinite(clip.duration) ? clip.duration : 0);
      if (end <= start) return clipEnd > start;
      return (
        clipStart < end - TIMELINE_GAP_EPS && clipEnd > start + TIMELINE_GAP_EPS
      );
    });
    if (hasClips) return true;
    return state.stageElements.some(
      (element) => (element.pageId || state.pages[0]?.id) === range.page.id
    );
  }

  function clipsTimelineDuration() {
    if (!state.clips.length) return 0;
    let maxEnd = 0;
    state.clips.forEach((clip) => {
      const start =
        typeof clip.start === 'number' && Number.isFinite(clip.start)
          ? clip.start
          : 0;
      const duration =
        typeof clip.duration === 'number' && Number.isFinite(clip.duration)
          ? clip.duration
          : 0;
      const end = start + duration;
      if (end > maxEnd) maxEnd = end;
    });
    return maxEnd;
  }

  function getStageElementPageIndex(element) {
    if (!Array.isArray(state.pages) || !state.pages.length) return -1;
    const pageId = element?.pageId || state.activePageId || state.pages[0].id;
    const index = state.pages.findIndex((page) => page.id === pageId);
    return index >= 0 ? index : 0;
  }

  function getStageElementPageStart(element) {
    const index = getStageElementPageIndex(element);
    if (index < 0) return 0;
    return getPageTimelineStart(state.pages[index]);
  }

  function getStageElementPageEnd(element) {
    const index = getStageElementPageIndex(element);
    const start = getStageElementPageStart(element);
    if (index >= 0 && state.pages[index + 1]) {
      return Math.max(
        start + 0.1,
        getPageTimelineStart(state.pages[index + 1])
      );
    }
    return Math.max(
      start + DEFAULT_STAGE_ELEMENT_DURATION,
      clipsTimelineDuration()
    );
  }

  function getStageElementTiming(element) {
    const pageStart = getStageElementPageStart(element);
    const pageEnd = getStageElementPageEnd(element);
    const start = Math.max(
      0,
      Number.isFinite(element?.timelineStart)
        ? element.timelineStart
        : pageStart
    );
    const fallbackDuration = Math.max(
      0.1,
      pageEnd > start ? pageEnd - start : DEFAULT_STAGE_ELEMENT_DURATION
    );
    const duration = Math.max(
      0.1,
      Number.isFinite(element?.timelineDuration)
        ? element.timelineDuration
        : fallbackDuration
    );
    return {
      start,
      duration,
      end: start + duration,
    };
  }

  function ensureStageElementTiming(element, options = {}) {
    if (!element) return element;
    if (!Number.isFinite(element.timelineStart)) {
      const pageStart = getStageElementPageStart(element);
      const pageEnd = getStageElementPageEnd(element);
      const playhead = snapTimelineTime(state.playhead || pageStart);
      element.timelineStart =
        options.forNew && playhead >= pageStart && playhead <= pageEnd
          ? playhead
          : pageStart;
    }
    if (!Number.isFinite(element.timelineDuration)) {
      const pageEnd = getStageElementPageEnd(element);
      element.timelineDuration = Math.max(
        0.1,
        options.forNew
          ? DEFAULT_STAGE_ELEMENT_DURATION
          : pageEnd - element.timelineStart || DEFAULT_STAGE_ELEMENT_DURATION
      );
    }
    element.timelineStart = Math.max(0, element.timelineStart);
    element.timelineDuration = Math.max(0.1, element.timelineDuration);
    return element;
  }

  function isStageElementVisibleAtTime(element, timeSec) {
    if (!element) return false;
    const timing = getStageElementTiming(element);
    const time = Number.isFinite(timeSec) ? timeSec : 0;
    return (
      time >= timing.start - TIMELINE_GAP_EPS &&
      time <= timing.end + TIMELINE_GAP_EPS
    );
  }

  function scrollTimelineToPage(pageId) {
    if (!el.timelineList || !pageId) return;
    const range = getPageTimelineRanges().find(
      (item) => item.page.id === pageId
    );
    if (!range) return;
    const pxPerSec = getTimelinePixelsPerSecond();
    const offset = getTimelineTrackOffset();
    const target = Math.max(0, offset + range.start * pxPerSec - 24);
    el.timelineList.scrollLeft = target;
    if (el.timelineRuler) el.timelineRuler.scrollLeft = target;
  }

  function getActivePageTimelineStart() {
    const page = state.pages.find((item) => item.id === state.activePageId);
    return page ? getPageTimelineStart(page) : 0;
  }

  function renderPages() {
    if (!el.pageList) return;
    ensurePages();
    el.pageList.innerHTML = '';
    state.pages.forEach((page, index) => {
      const label = page.name || `Page ${index + 1}`;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `page-item${page.id === state.activePageId ? ' active' : ''}`;
      button.dataset.pageId = page.id;
      button.setAttribute('aria-label', label);
      button.title = label;
      button.innerHTML = `
        <span class="page-thumb" aria-hidden="true"></span>
        <span class="page-name">${index + 1}</span>
      `;
      button.addEventListener('click', () => selectPage(page.id));
      el.pageList.appendChild(button);
    });
    syncWorkspaceHud();
  }

  function selectPage(pageId) {
    if (!pageId || pageId === state.activePageId) return;
    state.activePageId = pageId;
    state.playhead = getActivePageTimelineStart();
    if (
      Array.isArray(state.selectedStageElementIds) &&
      state.selectedStageElementIds.length
    ) {
      const visibleIds = new Set(
        state.stageElements
          .filter((element) => element.pageId === pageId)
          .map((element) => element.id)
      );
      const nextSelection = state.selectedStageElementIds.filter((id) =>
        visibleIds.has(id)
      );
      state.selectedStageElementIds = nextSelection;
      state.selectedStageElementId = nextSelection[0] || null;
    }
    renderPages();
    renderStageElements();
    renderStageElementsList();
    renderInspector();
    renderTimeline();
    scrollTimelineToPage(pageId);
    scheduleAutosave();
  }

  function addPage() {
    ensurePages();
    const nextId = `page_${Date.now()}_${Math.random().toString(16).slice(2)}`;
    const starts = state.pages.map((page) => getPageTimelineStart(page));
    const contentEnd = totalDuration();
    const maxStart = starts.length ? Math.max(...starts) : 0;
    const nextStart = contentEnd > maxStart ? contentEnd : maxStart + 4;
    state.pages.push({
      id: nextId,
      name: `Page ${state.pages.length + 1}`,
      timelineStart: nextStart,
    });
    state.activePageId = nextId;
    state.playhead = nextStart;
    renderPages();
    renderStageElements();
    renderStageElementsList();
    renderInspector();
    renderTimeline();
    requestAnimationFrame(() => scrollTimelineToPage(nextId));
    scheduleAutosave();
  }

  function removeActivePageIfEmpty() {
    if (!Array.isArray(state.pages) || state.pages.length <= 1) return;
    const activeId = state.activePageId;
    const activeRange = getPageTimelineRanges().find(
      (range) => range.page.id === activeId
    );
    const hasElements = state.stageElements.some(
      (element) => (element.pageId || activeId) === activeId
    );
    if (hasElements || pageRangeHasContent(activeRange)) {
      notify('Page not empty', 'info');
      return;
    }
    const nextPages = state.pages.filter((page) => page.id !== activeId);
    if (!nextPages.length) return;
    state.pages = nextPages;
    state.activePageId = nextPages[0].id;
    renderPages();
    renderStageElements();
    renderStageElementsList();
    renderInspector();
    scheduleAutosave();
  }

  function syncStageToolbar() {
    if (el.stageToolbarSnap) {
      el.stageToolbarSnap.classList.toggle(
        'is-active',
        !!el.stageSnapToggle?.checked
      );
      el.stageToolbarSnap.setAttribute(
        'aria-pressed',
        el.stageSnapToggle?.checked ? 'true' : 'false'
      );
    }
    if (el.stageToolbarGrid) {
      el.stageToolbarGrid.classList.toggle(
        'is-active',
        !!el.stageGridToggle?.checked
      );
      el.stageToolbarGrid.setAttribute(
        'aria-pressed',
        el.stageGridToggle?.checked ? 'true' : 'false'
      );
    }
    if (el.stageToolbarRotate) {
      el.stageToolbarRotate.classList.toggle(
        'is-active',
        !!el.stageRotationSnapToggle?.checked
      );
      el.stageToolbarRotate.setAttribute(
        'aria-pressed',
        el.stageRotationSnapToggle?.checked ? 'true' : 'false'
      );
    }
    if (el.stageToolbarLock) {
      el.stageToolbarLock.classList.toggle(
        'is-active',
        !!el.stageAspectLockToggle?.checked
      );
      el.stageToolbarLock.setAttribute(
        'aria-pressed',
        el.stageAspectLockToggle?.checked ? 'true' : 'false'
      );
    }
    if (el.stageZoomRange) {
      const percent = Math.round((state.previewScale || 1) * 100);
      el.stageZoomRange.value = String(percent);
    }
    if (el.stageZoomValue) {
      const percent = Math.round((state.previewScale || 1) * 100);
      el.stageZoomValue.textContent = `${percent}%`;
    }
    syncWorkspaceHud();
  }

  function getStageElementsForActivePage() {
    const pageId = state.activePageId;
    return (state.stageElements || []).filter(
      (element) => !pageId || !element.pageId || element.pageId === pageId
    );
  }

  function getEnabledShaderEffectCount() {
    return Object.values(state.shaderEffects || {}).filter(
      (effect) => effect && effect.enabled
    ).length;
  }

  function pluralizeLabel(count, singular, plural) {
    return `${count} ${count === 1 ? singular : plural || `${singular}s`}`;
  }

  function syncWorkspaceHud() {
    ensurePages();
    const pages =
      Array.isArray(state.pages) && state.pages.length
        ? state.pages
        : [{ id: state.activePageId || 'page_1', name: 'Page 1' }];
    const pageIndex = Math.max(
      0,
      pages.findIndex((page) => page.id === state.activePageId)
    );
    const page = pages[pageIndex] || pages[0];
    const layers = getStageElementsForActivePage();
    const layerCount = layers.length;
    const clipCount = Array.isArray(state.clips) ? state.clips.length : 0;
    const stageSelectionCount = Array.isArray(state.selectedStageElementIds)
      ? state.selectedStageElementIds.length
      : 0;
    const clipSelectionCount = Array.isArray(state.selectedClipIds)
      ? state.selectedClipIds.length
      : 0;
    const effectCount = getEnabledShaderEffectCount();

    if (el.workspaceStageLabel) {
      el.workspaceStageLabel.textContent = `${state.resolution.width}x${state.resolution.height} · ${state.fps} fps`;
    }
    if (el.workspacePageLabel) {
      const pageName = page && page.name ? page.name : `Page ${pageIndex + 1}`;
      el.workspacePageLabel.textContent = `${pageName} · ${pageIndex + 1}/${pages.length}`;
    }
    if (el.workspaceLayerLabel) {
      el.workspaceLayerLabel.textContent = `${pluralizeLabel(layerCount, 'layer')} · ${pluralizeLabel(clipCount, 'clip')}`;
    }
    if (el.workspaceSelectionLabel) {
      if (stageSelectionCount > 0) {
        el.workspaceSelectionLabel.textContent = `${pluralizeLabel(stageSelectionCount, 'layer')} selected`;
      } else if (clipSelectionCount > 0) {
        el.workspaceSelectionLabel.textContent = `${pluralizeLabel(clipSelectionCount, 'clip')} selected`;
      } else {
        el.workspaceSelectionLabel.textContent = 'No selection';
      }
    }
    if (el.workspaceFxLabel) {
      el.workspaceFxLabel.textContent =
        effectCount > 0
          ? `${pluralizeLabel(effectCount, 'FX')} live`
          : 'FX off';
    }
    if (el.workspaceEmptyState) {
      const empty =
        !state.userInteracted &&
        layerCount === 0 &&
        clipCount === 0 &&
        !state.audioElement;
      el.workspaceEmptyState.classList.toggle('is-hidden', !empty);
      el.workspaceEmptyState.setAttribute(
        'aria-hidden',
        empty ? 'false' : 'true'
      );
    }
  }

  function getStageSelectionAnchorRect() {
    const selected = getSelectedStageElements();
    if (!selected.length) return null;
    if (
      selected.length > 1 &&
      el.stageSelectionBox &&
      el.stageSelectionBox.style.display !== 'none'
    ) {
      const rect = el.stageSelectionBox.getBoundingClientRect();
      if (rect && rect.width && rect.height) return rect;
    }
    const primaryId =
      state.selectedStageElementId ||
      (selected[selected.length - 1] && selected[selected.length - 1].id);
    if (el.stageElements && primaryId) {
      const node = el.stageElements.querySelector(
        `[data-stage-id="${primaryId}"]`
      );
      if (node) return node.getBoundingClientRect();
    }
    if (!el.stageElements) return null;
    let minLeft = null;
    let minTop = null;
    let maxRight = null;
    let maxBottom = null;
    selected.forEach((item) => {
      const node = el.stageElements.querySelector(
        `[data-stage-id="${item.id}"]`
      );
      if (!node) return;
      const r = node.getBoundingClientRect();
      if (!r || !r.width || !r.height) return;
      if (minLeft === null) {
        minLeft = r.left;
        minTop = r.top;
        maxRight = r.right;
        maxBottom = r.bottom;
        return;
      }
      minLeft = Math.min(minLeft, r.left);
      minTop = Math.min(minTop, r.top);
      maxRight = Math.max(maxRight, r.right);
      maxBottom = Math.max(maxBottom, r.bottom);
    });
    if (minLeft === null) return null;
    return {
      left: minLeft,
      top: minTop,
      right: maxRight,
      bottom: maxBottom,
      width: maxRight - minLeft,
      height: maxBottom - minTop,
    };
  }

  function syncStageInlineToolbar() {
    if (!el.stageInlineToolbar || !el.previewStage) return;
    const selectedList = getSelectedStageElements();
    const shouldShow =
      inspectorContext === 'stage' &&
      selectedList.length > 0 &&
      !stageDrag &&
      !(sidebarOpen && isCompactEditorViewport());
    el.stageInlineToolbar.classList.toggle('open', shouldShow);
    el.stageInlineToolbar.setAttribute(
      'aria-hidden',
      shouldShow ? 'false' : 'true'
    );
    if (!shouldShow) {
      el.stageInlineToolbar.style.transform = 'translate(-9999px, -9999px)';
      return;
    }
    const primary = getSelectedStageElement();
    const showTextTools =
      selectedList.length === 1 && primary && primary.type === 'text';
    const showMediaTools =
      selectedList.length === 1 &&
      primary &&
      (primary.type === 'image' || primary.type === 'video');
    const textGroup = el.stageInlineToolbar.querySelector(
      '.stage-inline-group-text'
    );
    const mediaGroup = el.stageInlineToolbar.querySelector(
      '.stage-inline-group-media'
    );
    const textDivider = el.stageInlineToolbar.querySelector(
      '.stage-inline-divider:not(.stage-inline-divider-media)'
    );
    const cropGroup = el.stageInlineToolbar.querySelector(
      '[data-stage-inline-crop]'
    );
    const mediaDivider = el.stageInlineToolbar.querySelector(
      '.stage-inline-divider-media'
    );
    if (textGroup) {
      textGroup.style.display = showTextTools ? 'inline-flex' : 'none';
    }
    if (textDivider) {
      textDivider.style.display = showTextTools ? 'block' : 'none';
    }
    if (mediaGroup) {
      mediaGroup.style.display = showMediaTools ? 'inline-flex' : 'none';
    }
    if (cropGroup) {
      cropGroup.classList.toggle(
        'open',
        !!(showMediaTools && primary.cropMode)
      );
    }
    if (mediaDivider) {
      mediaDivider.style.display =
        showTextTools || showMediaTools ? 'block' : 'none';
    }
    const cropBtn = el.stageInlineToolbar.querySelector(
      '[data-stage-inline-action="crop-toggle"]'
    );
    if (cropBtn) {
      cropBtn.classList.toggle(
        'active',
        !!(showMediaTools && primary.cropMode)
      );
    }
    const videoBtn = el.stageInlineToolbar.querySelector(
      '[data-stage-inline-action="image-to-video"]'
    );
    if (videoBtn) {
      videoBtn.style.display =
        primary && primary.type === 'image' ? 'inline-flex' : 'none';
    }
    if (showTextTools) {
      const weight = primary.fontWeight || 600;
      const weightValue =
        typeof weight === 'string' ? weight.toLowerCase() : weight;
      const isBold =
        weightValue === 'bold' || weightValue === '700' || weightValue >= 600;
      const boldBtn = el.stageInlineToolbar.querySelector(
        '[data-stage-inline-action="bold"]'
      );
      const italicBtn = el.stageInlineToolbar.querySelector(
        '[data-stage-inline-action="italic"]'
      );
      const leftBtn = el.stageInlineToolbar.querySelector(
        '[data-stage-inline-action="align-left"]'
      );
      const centerBtn = el.stageInlineToolbar.querySelector(
        '[data-stage-inline-action="align-center"]'
      );
      const rightBtn = el.stageInlineToolbar.querySelector(
        '[data-stage-inline-action="align-right"]'
      );
      if (boldBtn) boldBtn.classList.toggle('active', isBold);
      if (italicBtn)
        italicBtn.classList.toggle('active', primary.fontStyle === 'italic');
      const align = primary.textAlign || 'center';
      if (leftBtn) leftBtn.classList.toggle('active', align === 'left');
      if (centerBtn) centerBtn.classList.toggle('active', align === 'center');
      if (rightBtn) rightBtn.classList.toggle('active', align === 'right');
      if (el.stageInlineFontSize) {
        el.stageInlineFontSize.value = String(
          Math.round(primary.fontSize || 24)
        );
      }
      if (el.stageInlineColor) {
        el.stageInlineColor.value = cssColorToHex(primary.color, '#111827');
      }
    }
    if (showMediaTools) {
      if (el.stageInlineCropZoom) {
        el.stageInlineCropZoom.value = String(
          Math.round((primary.cropZoom || 1) * 100)
        );
      }
      if (el.stageInlineCropX) {
        el.stageInlineCropX.value = String(Math.round(primary.cropX ?? 50));
      }
      if (el.stageInlineCropY) {
        el.stageInlineCropY.value = String(Math.round(primary.cropY ?? 50));
      }
    }
    const lockBtn = el.stageInlineToolbar.querySelector(
      '[data-stage-inline-action="lock"]'
    );
    const hideBtn = el.stageInlineToolbar.querySelector(
      '[data-stage-inline-action="hide"]'
    );
    const allLocked = selectedList.every((element) => element.locked);
    const allHidden = selectedList.every((element) => element.hidden);
    if (lockBtn) {
      const lockLabel = allLocked ? 'Unlock' : 'Lock';
      lockBtn.classList.toggle('active', allLocked);
      lockBtn.setAttribute('aria-pressed', allLocked ? 'true' : 'false');
      lockBtn.setAttribute('aria-label', lockLabel);
      lockBtn.title = lockLabel;
    }
    if (hideBtn) {
      const hideLabel = allHidden ? 'Show' : 'Hide';
      hideBtn.classList.toggle('active', allHidden);
      hideBtn.setAttribute('aria-pressed', allHidden ? 'true' : 'false');
      hideBtn.setAttribute('aria-label', hideLabel);
      hideBtn.title = hideLabel;
    }
    const anchorRect = getStageSelectionAnchorRect();
    if (!anchorRect) {
      el.stageInlineToolbar.classList.remove('open');
      el.stageInlineToolbar.setAttribute('aria-hidden', 'true');
      el.stageInlineToolbar.style.transform = 'translate(-9999px, -9999px)';
      return;
    }
    const stageRect = el.previewStage.getBoundingClientRect();
    if (!stageRect || !stageRect.width || !stageRect.height) return;
    const toolbarRect = el.stageInlineToolbar.getBoundingClientRect();
    if (!toolbarRect || !toolbarRect.width || !toolbarRect.height) return;
    const margin = 10;
    let left =
      anchorRect.left +
      anchorRect.width / 2 -
      stageRect.left -
      toolbarRect.width / 2;
    let top = anchorRect.top - stageRect.top - toolbarRect.height - margin;
    const maxLeft = stageRect.width - toolbarRect.width - margin;
    left = Math.max(margin, Math.min(maxLeft, left));
    const maxTop = stageRect.height - toolbarRect.height - margin;
    top = Math.max(margin, Math.min(maxTop, top));
    el.stageInlineToolbar.style.transform = `translate(${Math.round(left)}px, ${Math.round(top)}px)`;
  }

  function scheduleStageInlineToolbarSync() {
    if (!el.stageInlineToolbar) return;
    if (stageInlineToolbarRaf) return;
    stageInlineToolbarRaf = requestAnimationFrame(() => {
      stageInlineToolbarRaf = null;
      syncStageInlineToolbar();
    });
  }

  function scheduleStageElementsListRender() {
    if (stageElementsListRaf) return;
    stageElementsListRaf = requestAnimationFrame(() => {
      stageElementsListRaf = null;
      renderStageElementsList();
    });
  }

  function applyPreviewScale(scale) {
    const clamped = Math.max(0.25, Math.min(2, scale));
    state.previewScale = clamped;
    if (el.previewCanvasShell) {
      el.previewCanvasShell.style.transform = `scale(${clamped})`;
    }
    syncStageToolbar();
    scheduleStageInlineToolbarSync();
  }

  function fitPreviewScale() {
    if (!el.previewStage || !el.previewCanvasShell) return;
    const stageRect = el.previewStage.getBoundingClientRect();
    const shellRect = el.previewCanvasShell.getBoundingClientRect();
    const baseWidth = shellRect.width / (state.previewScale || 1);
    const baseHeight = shellRect.height / (state.previewScale || 1);
    const scale = Math.min(
      stageRect.width / baseWidth,
      stageRect.height / baseHeight
    );
    applyPreviewScale(scale);
  }

  function fillPreviewScale() {
    if (!el.previewStage || !el.previewCanvasShell) return;
    const stageRect = el.previewStage.getBoundingClientRect();
    const shellRect = el.previewCanvasShell.getBoundingClientRect();
    const baseWidth = shellRect.width / (state.previewScale || 1);
    const baseHeight = shellRect.height / (state.previewScale || 1);
    const scale = Math.max(
      stageRect.width / baseWidth,
      stageRect.height / baseHeight
    );
    applyPreviewScale(scale);
  }

  function adjustPreviewScale(delta) {
    const next = (state.previewScale || 1) + delta;
    applyPreviewScale(next);
  }

  function toggleSidebarDrawer() {
    const tab =
      document.querySelector('.asset-tab.active') ||
      document.querySelector('.asset-tab');
    const section = tab ? tab.getAttribute('data-tab') : sidebarActiveTab;
    if (sidebarOpen) {
      closeSidebarDrawer();
    } else {
      openSidebarDrawer(section, tab);
    }
  }

  function focusToolbar() {
    const toolbar = document.querySelector('.stage-toolbar');
    if (!toolbar) return;
    const target = toolbar.querySelector(
      'input, select, button, [tabindex]:not([tabindex="-1"])'
    );
    if (target) target.focus();
  }

  function focusStageCanvas() {
    if (!el.previewCanvasShell) return;
    if (!el.previewCanvasShell.hasAttribute('tabindex')) {
      el.previewCanvasShell.setAttribute('tabindex', '0');
    }
    el.previewCanvasShell.focus();
  }

  function setupTabs() {
    const tabs = document.querySelectorAll('.asset-tab');
    const sidebarTabs = el.editorSidebar
      ? el.editorSidebar.querySelectorAll('.sidebar-icon')
      : [];
    sidebarTabs.forEach((tab, index) => {
      tab.setAttribute('tabindex', tab.classList.contains('active') ? '0' : '-1');
      tab.addEventListener('keydown', (event) => {
        const key = event.key;
        if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;
        const horizontal = window.matchMedia('(max-width: 760px)').matches;
        const forward = horizontal ? 'ArrowRight' : 'ArrowDown';
        const backward = horizontal ? 'ArrowLeft' : 'ArrowUp';
        let nextIndex = index;
        if (key === forward) nextIndex = (index + 1) % sidebarTabs.length;
        else if (key === backward) nextIndex = (index - 1 + sidebarTabs.length) % sidebarTabs.length;
        else if (key === 'Home') nextIndex = 0;
        else if (key === 'End') nextIndex = sidebarTabs.length - 1;
        else return;
        event.preventDefault();
        sidebarTabs.forEach((item, itemIndex) => item.setAttribute('tabindex', itemIndex === nextIndex ? '0' : '-1'));
        sidebarTabs[nextIndex].focus();
      });
    });
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const section = tab.getAttribute('data-tab');
        activateSidebarTab(section, { toggleDrawer: true });
      });
    });
  }

  function activateSidebarTab(section, options = {}) {
    if (!section) return;
    dismissEmptyState();
    const tabs = document.querySelectorAll('.asset-tab');
    const tab = document.querySelector(`.asset-tab[data-tab="${section}"]`);
    const panelsScope = el.sidebarDrawer || document;
    const panels = panelsScope.querySelectorAll('.asset-section');
    tabs.forEach((item) => {
      item.classList.toggle('active', item === tab);
      item.setAttribute('tabindex', item === tab ? '0' : '-1');
    });
    panels.forEach((panel) => {
      panel.classList.toggle(
        'active',
        panel.getAttribute('data-section') === section
      );
    });
    if (!el.sidebarDrawer) return;
    if (options.toggleDrawer && sidebarOpen && sidebarActiveTab === section) {
      closeSidebarDrawer();
    } else {
      openSidebarDrawer(section, tab);
    }
    if (section === 'transitions') syncTransitionPanel();
  }

  function sidebarLabelForTab(tab) {
    if (!tab) return 'Assets';
    return (
      tab.getAttribute('data-tab-label') ||
      tab.getAttribute('title') ||
      tab.textContent.trim() ||
      'Assets'
    );
  }

  function dismissEmptyState() {
    if (!state.userInteracted) {
      state.userInteracted = true;
      syncWorkspaceHud();
    }
  }

  function openSidebarDrawer(section, tab) {
    dismissEmptyState();
    cancelQueuedFocusRestore();
    closeInspectorPanel();
    sidebarActiveTab = section || sidebarActiveTab;
    sidebarOpen = true;
    if (el.sidebarDrawer) {
      el.sidebarDrawer.classList.add('open');
      el.sidebarDrawer.addEventListener('keydown', trapSidebarFocus);
    }
    if (el.videoEditorBody) {
      el.videoEditorBody.classList.remove('sidebar-collapsed');
      el.videoEditorBody.classList.toggle(
        'filesystem-active',
        sidebarActiveTab === 'filesystem'
      );
    }
    if (el.sidebarDrawerTitle) {
      el.sidebarDrawerTitle.textContent = sidebarLabelForTab(tab);
    }
    syncSidebarToggleState();
    scheduleStageInlineToolbarSync();
    focusMobileDrawerFirstControl(el.sidebarDrawer);
  }

  function closeSidebarDrawer(options = {}) {
    const compact = isCompactEditorViewport();
    if (options.restoreFocus && el.mobileSidebarToggle && compact) {
      focusWithoutScroll(el.mobileSidebarToggle);
    }
    sidebarOpen = false;
    if (el.sidebarDrawer) {
      el.sidebarDrawer.classList.remove('open');
      el.sidebarDrawer.removeEventListener('keydown', trapSidebarFocus);
    }
    if (el.videoEditorBody) {
      el.videoEditorBody.classList.add('sidebar-collapsed');
      el.videoEditorBody.classList.remove('filesystem-active');
    }
    syncSidebarToggleState();
    if (el.sidebarDrawer && el.sidebarDrawer.contains(document.activeElement)) {
      const fallback =
        (compact && el.mobileSidebarToggle) ||
        (el.editorSidebar &&
          (el.editorSidebar.querySelector('.sidebar-icon.active') ||
            el.editorSidebar.querySelector('.sidebar-icon')));
      focusWithoutScroll(fallback);
    }
    scheduleStageInlineToolbarSync();
    if (options.restoreFocus && el.mobileSidebarToggle && compact) {
      queueFocusWithoutScroll(el.mobileSidebarToggle);
    }
  }

  function focusWithoutScroll(node) {
    if (!node || typeof node.focus !== 'function') return;
    try {
      node.focus({ preventScroll: true });
    } catch (_) {
      node.focus();
    }
  }

  function restoreModalTriggerFocus(node) {
    if (!node) return;
    focusWithoutScroll(node);
    requestAnimationFrame(() => focusWithoutScroll(node));
  }

  function trapModalFocus(event, modal) {
    if (event.key !== 'Tab' || !modal || !modal.classList.contains('open')) {
      return;
    }
    const focusable = getPanelFocusableControls(modal);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!modal.contains(document.activeElement)) {
      event.preventDefault();
      focusWithoutScroll(event.shiftKey ? last : first);
      return;
    }
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      focusWithoutScroll(last);
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      focusWithoutScroll(first);
    }
  }

  function bindEditorModal(modal, close) {
    if (!modal || typeof close !== 'function') return;
    modal.addEventListener('click', (event) => {
      if (event.target === modal) close();
    });
    modal.addEventListener('keydown', (event) => trapModalFocus(event, modal));
  }

  function closeTopEditorModal() {
    if (el.fontPickerModal?.classList.contains('open')) {
      closeFontPickerModal({ restoreFocus: false });
      return true;
    }
    if (el.shareModal?.classList.contains('open')) {
      toggleShareModal(false);
      return true;
    }
    if (el.magicResizeModal?.classList.contains('open')) {
      toggleMagicResize(false);
      return true;
    }
    if (el.exportSettingsModal?.classList.contains('open')) {
      toggleExportSettings(false);
      return true;
    }
    if (el.aiGenerateModal?.classList.contains('open')) {
      toggleAiGenerate(false);
      return true;
    }
    if (el.editorHistoryModal?.classList.contains('open')) {
      toggleEditorHistory(false);
      return true;
    }
    if (el.editorSettingsModal?.classList.contains('open')) {
      toggleEditorSettings(false);
      return true;
    }
    if (el.keyboardShortcutsModal?.classList.contains('open')) {
      toggleKeyboardShortcuts(false);
      return true;
    }
    if (el.projectLibraryModal?.classList.contains('open')) {
      toggleProjectLibrary(false);
      return true;
    }
    const fsModal = getEl('fs-browser-modal');
    if (fsModal?.classList.contains('open')) {
      toggleFsBrowser(false);
      return true;
    }
    return false;
  }

  function queueFocusWithoutScroll(node) {
    const token = ++focusRestoreSeq;
    const startedAt = performance.now();
    const attempt = () => {
      if (token !== focusRestoreSeq) return;
      const active = document.activeElement;
      const canRestore =
        !active ||
        active === node ||
        active === document.body ||
        active === document.documentElement ||
        active === el.mobileDrawerScrim ||
        (!inspectorOpen &&
          el.inspectorPanel &&
          el.inspectorPanel.contains(active)) ||
        (!sidebarOpen && el.sidebarDrawer && el.sidebarDrawer.contains(active));
      if (!canRestore || performance.now() - startedAt > 600) return;
      if (active !== node) {
        focusWithoutScroll(node);
      }
      window.setTimeout(attempt, 80);
    };
    window.setTimeout(attempt, 0);
  }

  function cancelQueuedFocusRestore() {
    focusRestoreSeq += 1;
  }

  function syncSidebarToggleState() {
    if (el.mobileSidebarToggle) {
      el.mobileSidebarToggle.setAttribute(
        'aria-expanded',
        sidebarOpen ? 'true' : 'false'
      );
      el.mobileSidebarToggle.setAttribute(
        'title',
        sidebarOpen ? 'Close panel' : 'Open panel'
      );
      el.mobileSidebarToggle.setAttribute(
        'aria-label',
        sidebarOpen ? 'Close panel' : 'Open panel'
      );
    }
    syncMobileDrawerInteractivity();
  }

  function setDrawerInert(panel, hidden) {
    if (!panel) return;
    if (hidden) {
      panel.setAttribute('aria-hidden', 'true');
      panel.inert = true;
    } else {
      panel.removeAttribute('aria-hidden');
      panel.inert = false;
    }
  }

  function syncMobileDrawerInteractivity() {
    setDrawerInert(el.sidebarDrawer, !sidebarOpen);
    setDrawerInert(
      el.inspectorPanel,
      isCompactEditorViewport() && !inspectorOpen
    );
    syncMobileDrawerScrim();
  }

  function syncMobileDrawerScrim() {
    if (!el.mobileDrawerScrim) return;
    const active = isCompactEditorViewport() && (sidebarOpen || inspectorOpen);
    el.mobileDrawerScrim.classList.toggle('is-active', active);
    el.mobileDrawerScrim.setAttribute('aria-hidden', active ? 'false' : 'true');
  }

  function setInspectorOpen(open, options = {}) {
    inspectorOpen = !!open;
    if (inspectorOpen) {
      cancelQueuedFocusRestore();
    }
    if (
      inspectorOpen &&
      (!getSelectedClip() ||
        (el.videoEditorBody &&
          el.videoEditorBody.classList.contains('inspector-empty')))
    ) {
      inspectorContext = 'stage';
      renderInspector();
    }
    if (el.inspectorPanel) {
      el.inspectorPanel.classList.toggle('open', inspectorOpen);
      if (inspectorOpen) {
        el.inspectorPanel.addEventListener('keydown', trapInspectorFocus);
      } else {
        el.inspectorPanel.removeEventListener('keydown', trapInspectorFocus);
      }
    }
    if (el.mobileInspectorToggle) {
      el.mobileInspectorToggle.setAttribute(
        'aria-expanded',
        inspectorOpen ? 'true' : 'false'
      );
      el.mobileInspectorToggle.setAttribute(
        'title',
        inspectorOpen ? 'Close inspector' : 'Open inspector'
      );
      el.mobileInspectorToggle.setAttribute(
        'aria-label',
        inspectorOpen ? 'Close inspector' : 'Open inspector'
      );
    }
    syncMobileDrawerInteractivity();
    if (inspectorOpen) {
      closeSidebarDrawer();
      focusMobileDrawerFirstControl(el.inspectorPanel);
      announceLive('Inspector opened');
    } else if (
      options.restoreFocus &&
      el.mobileInspectorToggle &&
      isCompactEditorViewport()
    ) {
      focusWithoutScroll(el.mobileInspectorToggle);
      queueFocusWithoutScroll(el.mobileInspectorToggle);
    }
  }

  function toggleInspectorPanel() {
    setInspectorOpen(!inspectorOpen);
  }

  function closeInspectorPanel(options = {}) {
    if (
      options.restoreFocus &&
      el.mobileInspectorToggle &&
      isCompactEditorViewport()
    ) {
      focusWithoutScroll(el.mobileInspectorToggle);
    }
    setInspectorOpen(false, options);
  }

  function isCompactEditorViewport() {
    return !!(
      window.matchMedia && window.matchMedia('(max-width: 1000px)').matches
    );
  }

  function toggleEditorHistory(open) {
    if (!el.editorHistoryModal) return;
    const shouldOpen = !!open;
    el.editorHistoryModal.classList.toggle('open', shouldOpen);
    el.editorHistoryModal.setAttribute(
      'aria-hidden',
      shouldOpen ? 'false' : 'true'
    );
    if (shouldOpen) {
      renderTimelineMarkerList();
      requestAnimationFrame(() => {
        if (el.editorHistoryClose) {
          el.editorHistoryClose.focus();
        }
      });
      announceLive('History opened');
    } else if (el.timelineHistoryOpen) {
      el.timelineHistoryOpen.focus();
      announceLive('History closed');
    }
    updateEditorModalOpenState();
  }

  function bindSidebar() {
    if (el.mobileSidebarToggle) {
      el.mobileSidebarToggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeInspectorPanel();
        toggleSidebarDrawer();
      });
    }
    if (el.mobileInspectorToggle) {
      el.mobileInspectorToggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleInspectorPanel();
      });
    }
    if (el.inspectorPanelClose) {
      el.inspectorPanelClose.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeInspectorPanel({ restoreFocus: true });
      });
    }
    if (el.sidebarDrawerClose) {
      el.sidebarDrawerClose.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeSidebarDrawer({ restoreFocus: true });
      });
    }
    if (el.mobileDrawerScrim) {
      el.mobileDrawerScrim.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (inspectorOpen) closeInspectorPanel({ restoreFocus: true });
        if (sidebarOpen) closeSidebarDrawer({ restoreFocus: true });
      });
    }
    document.addEventListener('click', (event) => {
      if (!sidebarOpen && !inspectorOpen) return;
      if (event.target instanceof Node && !event.target.isConnected) return;
      if (
        event.target &&
        event.target.closest &&
        event.target.closest('.context-menu')
      )
        return;
      if (isCompactEditorViewport()) return;
      if (
        sidebarOpen &&
        el.sidebarDrawer &&
        el.sidebarDrawer.contains(event.target)
      )
        return;
      if (
        sidebarOpen &&
        el.editorSidebar &&
        el.editorSidebar.contains(event.target)
      )
        return;
      if (
        inspectorOpen &&
        el.inspectorPanel &&
        el.inspectorPanel.contains(event.target)
      )
        return;
      if (
        event.target &&
        event.target.closest &&
        (event.target.closest('#mobile-sidebar-toggle') ||
          event.target.closest('#mobile-inspector-toggle') ||
          event.target.closest('#timeline-panel'))
      )
        return;
      if (sidebarOpen) closeSidebarDrawer();
      if (inspectorOpen) closeInspectorPanel();
    });
  }

  function parseResolutionValue(value) {
    if (typeof value !== 'string') return null;
    const match = value.match(/^(\d+)x(\d+)$/);
    if (!match) return null;
    const width = parseInt(match[1], 10);
    const height = parseInt(match[2], 10);
    if (!width || !height) return null;
    return { width, height };
  }

  function formatResolutionValue(width, height) {
    return `${width}x${height}`;
  }

  function ensureProjectResolutionOption(value) {
    if (!el.projectResolution || !value) return;
    const exists = Array.from(el.projectResolution.options || []).some(
      (option) => option.value === value
    );
    if (exists) return;
    const parsed = parseResolutionValue(value);
    const option = document.createElement('option');
    option.value = value;
    option.textContent = parsed ? `${parsed.width}x${parsed.height}` : value;
    el.projectResolution.appendChild(option);
  }

  function applyCanvasResolution(width, height) {
    state.resolution.width = width;
    state.resolution.height = height;
    if (el.videoEditorShell) {
      const ratio = width / Math.max(1, height);
      el.videoEditorShell.classList.remove(
        'is-landscape-project',
        'is-square-project',
        'is-portrait-project'
      );
      const orientation =
        ratio >= 1.2 ? 'landscape' : ratio <= 0.83 ? 'portrait' : 'square';
      el.videoEditorShell.classList.add(`is-${orientation}-project`);
      el.videoEditorShell.dataset.projectOrientation = orientation;
    }
    if (el.previewCanvas) {
      el.previewCanvas.width = width;
      el.previewCanvas.height = height;
    }
    applyPreviewAspect();
  }

  function syncExportSettingsUI() {
    const resolution =
      state.exportSettings.resolution ||
      formatResolutionValue(state.resolution.width, state.resolution.height);
    document.querySelectorAll('[data-export-res]').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.exportRes === resolution);
    });
    document.querySelectorAll('[data-export-bitrate]').forEach((btn) => {
      const bitrate = parseInt(btn.dataset.exportBitrate, 10);
      btn.classList.toggle('active', bitrate === state.exportSettings.bitrate);
    });
    document.querySelectorAll('[data-export-format]').forEach((btn) => {
      btn.classList.toggle(
        'active',
        btn.dataset.exportFormat === state.exportSettings.format
      );
    });
    updateExportEstimate();
  }

  function updateProjectSettings() {
    const previousProjectResolution = formatResolutionValue(
      state.resolution.width,
      state.resolution.height
    );
    const resolution =
      (el.projectResolution && el.projectResolution.value) ||
      previousProjectResolution;
    const parsed = parseResolutionValue(resolution) || {
      width: 1920,
      height: 1080,
    };
    applyCanvasResolution(parsed.width, parsed.height);
    if (
      !state.exportSettings.resolution ||
      state.exportSettings.resolution === previousProjectResolution
    ) {
      state.exportSettings.resolution = resolution;
    }
    state.fps = Math.max(1, parseInt(el.projectFps.value, 10) || 30);
    renderFrameAt(state.playhead || 0);
    syncExportSettingsUI();
    syncWorkspaceHud();
    scheduleAutosave();
  }

  function applyPreviewAspect() {
    if (!el.previewCanvas) return;
    const aspect = `${state.resolution.width}/${state.resolution.height}`;
    el.previewCanvas.style.setProperty('--preview-aspect', aspect);
    if (el.previewCanvas.parentElement) {
      el.previewCanvas.parentElement.style.setProperty(
        '--preview-aspect',
        aspect
      );
    }
  }

  let magicResizeMode = 'local';
  let magicResizeResolution = '1080x1920';

  function getMagicResizeAsset() {
    const selectedStage = getSelectedStageElement();
    if (selectedStage && selectedStage.assetId) {
      const asset = state.assets.find(
        (item) => item.id === selectedStage.assetId
      );
      if (asset && (asset.type === 'image' || asset.type === 'video'))
        return asset;
    }
    const selectedAsset = state.assets.find(
      (item) => item.id === state.selectedAssetId
    );
    if (
      selectedAsset &&
      (selectedAsset.type === 'image' || selectedAsset.type === 'video')
    ) {
      return selectedAsset;
    }
    const selectedClip = state.clips.find(
      (clip) => clip.id === state.selectedClipId
    );
    if (selectedClip) {
      const asset = state.assets.find(
        (item) => item.id === selectedClip.assetId
      );
      if (asset && (asset.type === 'image' || asset.type === 'video'))
        return asset;
    }
    return (
      state.assets.find(
        (asset) => asset.type === 'image' || asset.type === 'video'
      ) || null
    );
  }

  function setMagicResizeStatus(message, type) {
    if (!el.magicResizeStatus) return;
    el.magicResizeStatus.textContent = message || '';
    el.magicResizeStatus.classList.toggle('error', type === 'error');
  }

  function syncMagicResizeSourceUI() {
    const asset = getMagicResizeAsset();
    if (el.magicResizeSourcePreview) {
      el.magicResizeSourcePreview.innerHTML = '';
      if (asset && asset.src) {
        const media = document.createElement(
          asset.type === 'video' ? 'video' : 'img'
        );
        setEditorMediaSource(media, asset.src);
        if (asset.type === 'video') {
          media.muted = true;
          media.playsInline = true;
          media.preload = 'metadata';
        }
        el.magicResizeSourcePreview.appendChild(media);
      } else {
        el.magicResizeSourcePreview.textContent = 'No media';
      }
    }
    if (el.magicResizeSourceName) {
      el.magicResizeSourceName.textContent = asset
        ? asset.name || 'Selected media'
        : 'Select an image or video';
    }
    if (el.magicResizeSourceMeta) {
      el.magicResizeSourceMeta.textContent = asset
        ? `${asset.type === 'video' ? 'Video' : 'Image'} · ${asset.width || '?'}×${asset.height || '?'}`
        : 'Local focus works with images and video.';
    }
    if (el.magicResizeAiMode) {
      const enabled = !!asset && asset.type === 'image';
      el.magicResizeAiMode.disabled = !enabled;
      el.magicResizeAiMode.title = enabled
        ? 'Generate a recomposed image with FAL Smart Resize'
        : 'AI generative resize currently supports images';
      if (!enabled && magicResizeMode === 'ai') {
        setMagicResizeMode('local');
      }
    }
    return asset;
  }

  function setMagicResizeMode(mode) {
    magicResizeMode = mode === 'ai' ? 'ai' : 'local';
    document.querySelectorAll('[data-magic-resize-mode]').forEach((button) => {
      button.classList.toggle(
        'active',
        button.dataset.magicResizeMode === magicResizeMode
      );
    });
    if (el.magicResizePromptWrap) {
      el.magicResizePromptWrap.style.display =
        magicResizeMode === 'ai' ? '' : 'none';
    }
    if (el.magicResizeScope) {
      el.magicResizeScope.disabled = magicResizeMode === 'ai';
      if (magicResizeMode === 'ai') el.magicResizeScope.value = 'selected';
    }
    if (el.magicResizeRun) {
      el.magicResizeRun.textContent =
        magicResizeMode === 'ai'
          ? `AI resize · ${MAGIC_RESIZE_AI_CREDITS} credits`
          : 'Resize locally';
    }
  }

  function toggleMagicResize(open) {
    if (!el.magicResizeModal) return;
    const shouldOpen =
      open === undefined
        ? !el.magicResizeModal.classList.contains('open')
        : open;
    el.magicResizeModal.classList.toggle('open', shouldOpen);
    el.magicResizeModal.setAttribute(
      'aria-hidden',
      shouldOpen ? 'false' : 'true'
    );
    updateEditorModalOpenState();
    if (shouldOpen) {
      setMagicResizeStatus('');
      syncMagicResizeSourceUI();
      setMagicResizeMode(magicResizeMode);
      requestAnimationFrame(() => {
        const active = document.querySelector('.magic-resize-preset.active');
        if (active) active.focus();
      });
    } else if (el.magicResizeOpen) {
      restoreModalTriggerFocus(el.magicResizeOpen);
    }
  }

  function waitForMagicResizeMedia(media, type) {
    if (!media) return Promise.resolve(null);
    const ready =
      type === 'video'
        ? media.readyState >= 2 && media.videoWidth > 0
        : media.complete && media.naturalWidth > 0;
    if (ready) return Promise.resolve(media);
    return new Promise((resolve) => {
      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        media.removeEventListener('loadeddata', finish);
        media.removeEventListener('load', finish);
        media.removeEventListener('error', finish);
        resolve(media);
      };
      media.addEventListener('loadeddata', finish, { once: true });
      media.addEventListener('load', finish, { once: true });
      media.addEventListener('error', finish, { once: true });
      window.setTimeout(finish, 1800);
    });
  }

  async function getMagicResizeMedia(asset) {
    if (!asset) return null;
    let media = asset.element;
    if (!media) {
      media = document.createElement(asset.type === 'video' ? 'video' : 'img');
      if (asset.type === 'video') {
        media.muted = true;
        media.playsInline = true;
        media.preload = 'auto';
      }
      setEditorMediaSource(media, asset.src);
    }
    await waitForMagicResizeMedia(media, asset.type);
    return media;
  }

  function magicResizeMediaSize(media) {
    return {
      width: media?.videoWidth || media?.naturalWidth || media?.width || 0,
      height: media?.videoHeight || media?.naturalHeight || media?.height || 0,
    };
  }

  async function detectMagicResizeFaces(media) {
    if (!window.FaceDetector || !media) return null;
    try {
      const detector = new window.FaceDetector({
        fastMode: true,
        maxDetectedFaces: 8,
      });
      const faces = await detector.detect(media);
      if (!faces.length) return null;
      const size = magicResizeMediaSize(media);
      if (!size.width || !size.height) return null;
      let area = 0;
      let weightedX = 0;
      let weightedY = 0;
      faces.forEach((face) => {
        const box = face.boundingBox;
        const nextArea = Math.max(1, box.width * box.height);
        area += nextArea;
        weightedX += (box.x + box.width / 2) * nextArea;
        weightedY += (box.y + box.height / 2) * nextArea;
      });
      return {
        x: Math.max(0, Math.min(100, (weightedX / area / size.width) * 100)),
        y: Math.max(0, Math.min(100, (weightedY / area / size.height) * 100)),
        method: 'face',
      };
    } catch (_) {
      return null;
    }
  }

  function detectMagicResizeSaliency(media) {
    const source = magicResizeMediaSize(media);
    if (!source.width || !source.height) return null;
    const maxEdge = 112;
    const scale = Math.min(1, maxEdge / Math.max(source.width, source.height));
    const width = Math.max(24, Math.round(source.width * scale));
    const height = Math.max(24, Math.round(source.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;
    try {
      ctx.drawImage(media, 0, 0, width, height);
      const pixels = ctx.getImageData(0, 0, width, height).data;
      const scores = [];
      let total = 0;
      let weightedX = 0;
      let weightedY = 0;
      for (let y = 1; y < height - 1; y += 2) {
        for (let x = 1; x < width - 1; x += 2) {
          const index = (y * width + x) * 4;
          const left = index - 4;
          const above = index - width * 4;
          const r = pixels[index];
          const g = pixels[index + 1];
          const b = pixels[index + 2];
          const luma = r * 0.299 + g * 0.587 + b * 0.114;
          const leftLuma =
            pixels[left] * 0.299 +
            pixels[left + 1] * 0.587 +
            pixels[left + 2] * 0.114;
          const aboveLuma =
            pixels[above] * 0.299 +
            pixels[above + 1] * 0.587 +
            pixels[above + 2] * 0.114;
          const saturation = Math.max(r, g, b) - Math.min(r, g, b);
          const edge = Math.abs(luma - leftLuma) + Math.abs(luma - aboveLuma);
          const centerX = 1 - Math.abs(x / width - 0.5) * 0.4;
          const centerY = 1 - Math.abs(y / height - 0.5) * 0.25;
          scores.push({
            x,
            y,
            score: (edge + saturation * 0.2 + 1) * centerX * centerY,
          });
        }
      }
      scores.sort((a, b) => b.score - a.score);
      const keep = Math.max(12, Math.ceil(scores.length * 0.22));
      scores.slice(0, keep).forEach((point) => {
        total += point.score;
        weightedX += point.x * point.score;
        weightedY += point.y * point.score;
      });
      if (!total) return null;
      return {
        x: Math.max(0, Math.min(100, (weightedX / total / width) * 100)),
        y: Math.max(0, Math.min(100, (weightedY / total / height) * 100)),
        method: 'subject',
      };
    } catch (_) {
      return null;
    }
  }

  async function detectMagicResizeFocus(asset) {
    const media = await getMagicResizeMedia(asset);
    if (!media) return { x: 50, y: 50, method: 'center' };
    const face = await detectMagicResizeFaces(media);
    if (face) return face;
    return (
      detectMagicResizeSaliency(media) || {
        x: 50,
        y: 50,
        method: 'center',
      }
    );
  }

  function getMagicResizeAssets(scope) {
    const selected = getMagicResizeAsset();
    if (scope === 'selected') return selected ? [selected] : [];
    const ids = new Set();
    state.clips.forEach((clip) => {
      if (clip.type === 'image' || clip.type === 'video') ids.add(clip.assetId);
    });
    state.stageElements.forEach((element) => {
      if (element.type === 'image' || element.type === 'video')
        ids.add(element.assetId);
    });
    const assets = state.assets.filter(
      (asset) =>
        ids.has(asset.id) && (asset.type === 'image' || asset.type === 'video')
    );
    if (!assets.length && selected) assets.push(selected);
    return assets;
  }

  function applyMagicResizeFocus(asset, focus, scope) {
    const selectedClipId = state.clips.some(
      (clip) => clip.id === state.selectedClipId && clip.assetId === asset.id
    )
      ? state.selectedClipId
      : null;
    const selectedStageId = state.stageElements.some(
      (element) =>
        element.id === state.selectedStageElementId &&
        element.assetId === asset.id
    )
      ? state.selectedStageElementId
      : null;
    state.clips.forEach((clip) => {
      if (clip.assetId !== asset.id) return;
      if (scope === 'selected' && selectedStageId) return;
      if (scope === 'selected' && selectedClipId && clip.id !== selectedClipId)
        return;
      clip.focusX = focus.x;
      clip.focusY = focus.y;
      clip.resizeMode = 'focus';
    });
    state.stageElements.forEach((element) => {
      if (element.assetId !== asset.id) return;
      if (scope === 'selected' && selectedClipId && !selectedStageId) return;
      if (
        scope === 'selected' &&
        selectedStageId &&
        element.id !== selectedStageId
      )
        return;
      element.cropX = focus.x;
      element.cropY = focus.y;
      element.cropMode = true;
    });
    asset.focusX = focus.x;
    asset.focusY = focus.y;
  }

  function applyMagicResizeResolution(value) {
    const parsed = parseResolutionValue(value);
    if (!parsed) return false;
    ensureProjectResolutionOption(value);
    if (el.projectResolution) el.projectResolution.value = value;
    updateProjectSettings();
    return true;
  }

  async function runLocalMagicResize() {
    const scope = el.magicResizeScope?.value || 'project';
    const assets = getMagicResizeAssets(scope);
    if (!assets.length) {
      setMagicResizeStatus('Add or select an image or video first.', 'error');
      return false;
    }
    for (let index = 0; index < assets.length; index += 1) {
      const asset = assets[index];
      setMagicResizeStatus(
        `Finding the subject in ${asset.name || `media ${index + 1}`}…`
      );
      const focus = await detectMagicResizeFocus(asset);
      applyMagicResizeFocus(asset, focus, scope);
    }
    applyMagicResizeResolution(magicResizeResolution);
    renderStageElements();
    renderTimeline();
    renderFrameAt(state.playhead || 0);
    scheduleAutosave('magic-resize-local');
    setMagicResizeStatus(
      `${assets.length} media item${assets.length === 1 ? '' : 's'} reframed locally.`
    );
    notify('Magic Resize applied', 'success');
    return true;
  }

  async function ensureMagicResizeAssetHosted(asset) {
    if (!asset) return '';
    const persisted = asset.persistedSrc || '';
    if (/^https?:\/\//i.test(persisted)) return persisted;
    if (/^https?:\/\//i.test(asset.src || '')) return asset.src;
    let file = asset.file;
    if (!file && /^data:/i.test(asset.src || '')) {
      const response = await fetch(asset.src);
      const blob = await response.blob();
      file = new File([blob], asset.name || `magic-resize-${Date.now()}.png`, {
        type: blob.type || 'image/png',
      });
    }
    if (!file) return '';
    const uploaded = await persistMediaFile(file);
    if (!uploaded) return '';
    applyPersistedAssetUpload(asset, uploaded);
    return resolveFsEntryUrl(uploaded);
  }

  function applyMagicResizeCreditCharge(credits) {
    let remaining = Math.max(0, Number(credits) || 0);
    if (!remaining || !window.userData) return;
    if (Number.isFinite(Number(window.userData.free_credits))) {
      const free = Math.max(0, Number(window.userData.free_credits) || 0);
      const used = Math.min(free, remaining);
      window.userData.free_credits = free - used;
      remaining -= used;
    }
    if (
      remaining > 0 &&
      Number.isFinite(Number(window.userData.paid_credits))
    ) {
      window.userData.paid_credits = Math.max(
        0,
        Number(window.userData.paid_credits || 0) - remaining
      );
    }
    if (Number.isFinite(Number(window.userData.credits))) {
      window.userData.credits = Math.max(
        0,
        Number(window.userData.credits) - Number(credits)
      );
    }
    try {
      localStorage.setItem('netwrck_user', JSON.stringify(window.userData));
    } catch (_) {}
    updateBalanceFromUser();
    updateCreditsWidgets();
  }

  async function replaceMagicResizeAssetUses(sourceAsset, nextAsset) {
    const selectedClipId = state.clips.some(
      (clip) =>
        clip.id === state.selectedClipId && clip.assetId === sourceAsset.id
    )
      ? state.selectedClipId
      : null;
    const selectedStageId = state.stageElements.some(
      (element) =>
        element.id === state.selectedStageElementId &&
        element.assetId === sourceAsset.id
    )
      ? state.selectedStageElementId
      : null;
    let replaced = 0;
    state.clips.forEach((clip) => {
      if (clip.assetId !== sourceAsset.id) return;
      if (selectedStageId) return;
      if (selectedClipId && clip.id !== selectedClipId) return;
      clip.assetId = nextAsset.id;
      clip.src = nextAsset.src;
      clip.element = nextAsset.element;
      clip.focusX = 50;
      clip.focusY = 50;
      clip.resizeMode = 'generated';
      replaced += 1;
    });
    state.stageElements.forEach((element) => {
      if (element.assetId !== sourceAsset.id) return;
      if (selectedClipId && !selectedStageId) return;
      if (selectedStageId && element.id !== selectedStageId) return;
      element.assetId = nextAsset.id;
      element.src = nextAsset.src;
      element.cropX = 50;
      element.cropY = 50;
      element.cropMode = true;
      replaced += 1;
    });
    return replaced;
  }

  async function runAiMagicResize() {
    const asset = getMagicResizeAsset();
    if (!asset || asset.type !== 'image') {
      setMagicResizeStatus(
        'Select an image for AI generative resize.',
        'error'
      );
      return false;
    }
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      return false;
    }
    if (
      window.NetwrckTools &&
      !window.NetwrckTools.checkCredits(
        MAGIC_RESIZE_AI_CREDITS,
        creditsToUSD(MAGIC_RESIZE_AI_CREDITS)
      )
    ) {
      return false;
    }
    setMagicResizeStatus('Preparing source image…');
    const imageUrl = await ensureMagicResizeAssetHosted(asset);
    if (!imageUrl) {
      setMagicResizeStatus(
        'The image could not be uploaded for AI resize.',
        'error'
      );
      return false;
    }
    const response = await fetch('/api/smart-resize', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': secret,
        Authorization: `Bearer ${secret}`,
      },
      body: JSON.stringify({
        image_url: imageUrl,
        target_sizes: [magicResizeResolution],
        prompt: el.magicResizePrompt?.value.trim() || '',
        num_images_per_size: 1,
        resolution: '1K',
        output_format: 'webp',
        safety_tolerance: '4',
      }),
    });
    if (!response.ok) {
      if (
        await showPaidAPIPromptForResponse(response, MAGIC_RESIZE_AI_CREDITS)
      ) {
        return false;
      }
      const data = await response.json().catch(() => ({}));
      setMagicResizeStatus(data.error || 'AI resize failed.', 'error');
      return false;
    }
    const data = await response.json();
    const url = data.image_url || data.images?.[0];
    if (!url) {
      setMagicResizeStatus('AI resize returned no image.', 'error');
      return false;
    }
    const nextAsset = await addExternalAsset(
      url,
      'image',
      buildVariantAssetName(asset.name || 'image', 'magic-resize'),
      { select: true }
    );
    await getMagicResizeMedia(nextAsset);
    nextAsset.originalSrc = asset.src;
    await replaceMagicResizeAssetUses(asset, nextAsset);
    persistDerivedAssetLineage(asset, nextAsset, 'magic-resize');
    rememberAiAsset(url, 'image', nextAsset.name);
    applyMagicResizeResolution(magicResizeResolution);
    applyMagicResizeCreditCharge(
      Number(data.credits_charged) || MAGIC_RESIZE_AI_CREDITS
    );
    renderStageElements();
    renderTimeline();
    renderFrameAt(state.playhead || 0);
    scheduleAutosave('magic-resize-ai');
    setMagicResizeStatus('AI resize added as a new asset and applied.');
    notify('AI Magic Resize complete', 'success');
    return true;
  }

  async function runMagicResize() {
    if (!el.magicResizeRun || el.magicResizeRun.disabled) return;
    el.magicResizeRun.disabled = true;
    document
      .querySelectorAll('.magic-resize-preset, .magic-resize-mode')
      .forEach((button) => {
        button.disabled = true;
      });
    try {
      const completed =
        magicResizeMode === 'ai'
          ? await runAiMagicResize()
          : await runLocalMagicResize();
      if (completed) {
        window.setTimeout(() => toggleMagicResize(false), 350);
      }
    } catch (error) {
      setMagicResizeStatus(
        error && error.message ? error.message : 'Magic Resize failed.',
        'error'
      );
    } finally {
      el.magicResizeRun.disabled = false;
      if (el.magicResizeLocalMode) el.magicResizeLocalMode.disabled = false;
      document.querySelectorAll('.magic-resize-preset').forEach((button) => {
        button.disabled = false;
      });
      syncMagicResizeSourceUI();
      setMagicResizeMode(magicResizeMode);
    }
  }

  function updateHeaderOffset() {
    const root = document.documentElement;
    if (
      root.classList.contains('video-editor-fullscreen') ||
      window.innerWidth <= 768
    ) {
      root.style.setProperty('--ve-header-offset', '0px');
      return;
    }
    const header = document.querySelector(
      'header, #header, .header, .site-header, .main-header, .top-nav, .navbar, .demo-header, .top-bar'
    );
    let offset = 0;
    if (header) {
      const styles = window.getComputedStyle(header);
      const rect = header.getBoundingClientRect();
      const visible =
        styles.display !== 'none' &&
        styles.visibility !== 'hidden' &&
        rect.height > 0;
      if (
        visible &&
        (styles.position === 'fixed' || styles.position === 'sticky')
      ) {
        offset = Math.max(0, Math.ceil(rect.bottom));
      }
    }
    root.style.setProperty('--ve-header-offset', `${offset}px`);
  }

  function ensureTimelineVisible() {
    if (
      document.documentElement.classList.contains('video-editor-fullscreen')
    ) {
      document.documentElement.style.setProperty('--ve-header-offset', '0px');
      return;
    }
    if (!el.timelinePanel) return;
    const rect = el.timelinePanel.getBoundingClientRect();
    const overflow = rect.bottom - window.innerHeight;
    if (overflow > 0) {
      const root = document.documentElement;
      const current =
        parseFloat(
          getComputedStyle(root).getPropertyValue('--ve-header-offset')
        ) || 0;
      root.style.setProperty(
        '--ve-header-offset',
        `${current + overflow + 8}px`
      );
      requestAnimationFrame(() => {
        if (!el.timelinePanel) return;
        const nextRect = el.timelinePanel.getBoundingClientRect();
        const nextOverflow = nextRect.bottom - window.innerHeight;
        if (nextOverflow > 0) {
          const updated =
            parseFloat(
              getComputedStyle(root).getPropertyValue('--ve-header-offset')
            ) || 0;
          root.style.setProperty(
            '--ve-header-offset',
            `${updated + nextOverflow + 8}px`
          );
        }
      });
    }
  }

  function getTimelineHeightLimits() {
    const shell =
      el.videoEditorShell || document.querySelector('.video-editor-shell');
    if (!shell) {
      return { min: TIMELINE_HEIGHT_MIN, max: 420 };
    }
    const header = shell.querySelector('.video-editor-header');
    const shellHeight =
      shell.getBoundingClientRect().height || window.innerHeight;
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    const max = Math.max(
      TIMELINE_HEIGHT_MIN,
      Math.floor(shellHeight - headerHeight - TIMELINE_STAGE_MIN)
    );
    return {
      min: TIMELINE_HEIGHT_MIN,
      max: Math.min(max, Math.floor(shellHeight * 0.72)),
    };
  }

  function clampTimelineHeight(height) {
    const limits = getTimelineHeightLimits();
    const next = Math.round(Number(height) || 0);
    return Math.max(limits.min, Math.min(limits.max, next));
  }

  function getCurrentTimelineHeight() {
    if (!el.timelinePanel) return TIMELINE_HEIGHT_MIN;
    const rect = el.timelinePanel.getBoundingClientRect();
    return rect.height || TIMELINE_HEIGHT_MIN;
  }

  function updateTimelineResizeA11y(height) {
    if (!el.timelineResizeHandle) return;
    const limits = getTimelineHeightLimits();
    el.timelineResizeHandle.setAttribute('aria-valuemin', String(limits.min));
    el.timelineResizeHandle.setAttribute('aria-valuemax', String(limits.max));
    el.timelineResizeHandle.setAttribute(
      'aria-valuenow',
      String(Math.round(height))
    );
  }

  function applyTimelineHeight(height, persist = false) {
    if (!el.videoEditorShell) return;
    const next = clampTimelineHeight(height);
    el.videoEditorShell.style.setProperty('--ve-timeline-height', `${next}px`);
    el.videoEditorShell.style.gridTemplateRows = `auto minmax(0, 1fr) ${next}px`;
    updateTimelineResizeA11y(next);
    if (persist) {
      localStorage.setItem(TIMELINE_HEIGHT_KEY, String(next));
    }
    requestAnimationFrame(() => {
      updateTimelinePlayhead();
      scheduleStageInlineToolbarSync();
      ensureTimelineVisible();
    });
  }

  function loadTimelineHeightSetting() {
    const raw = localStorage.getItem(TIMELINE_HEIGHT_KEY);
    if (raw) {
      applyTimelineHeight(parseFloat(raw), false);
      return;
    }
    updateTimelineResizeA11y(getCurrentTimelineHeight());
  }

  function handleTimelineViewportResize() {
    if (!el.videoEditorShell || !el.timelinePanel) return;
    applyTimelineHeight(getCurrentTimelineHeight(), false);
  }

  function startTimelineResize(event) {
    if (!el.timelinePanel || !el.timelineResizeHandle) return;
    if (event.button !== undefined && event.button !== 0) return;
    event.preventDefault();
    timelineResizeDrag = {
      pointerId: event.pointerId,
      startY: event.clientY,
      startHeight: getCurrentTimelineHeight(),
    };
    el.timelinePanel.classList.add('is-resizing');
    document.body.classList.add('video-editor-timeline-resizing');
    try {
      el.timelineResizeHandle.setPointerCapture(event.pointerId);
    } catch (_) {}
  }

  function handleTimelineResizeMove(event) {
    if (!timelineResizeDrag) return;
    event.preventDefault();
    const delta = timelineResizeDrag.startY - event.clientY;
    applyTimelineHeight(timelineResizeDrag.startHeight + delta, false);
  }

  function endTimelineResize(event) {
    if (!timelineResizeDrag) return;
    timelineResizeDrag = null;
    if (el.timelinePanel) el.timelinePanel.classList.remove('is-resizing');
    document.body.classList.remove('video-editor-timeline-resizing');
    applyTimelineHeight(getCurrentTimelineHeight(), true);
  }

  function handleTimelineResizeKeydown(event) {
    if (!el.timelineResizeHandle) return;
    let delta = 0;
    if (event.key === 'ArrowUp') delta = 24;
    if (event.key === 'ArrowDown') delta = -24;
    if (event.key === 'PageUp') delta = 80;
    if (event.key === 'PageDown') delta = -80;
    if (event.key === 'Home') {
      event.preventDefault();
      applyTimelineHeight(TIMELINE_HEIGHT_MIN, true);
      return;
    }
    if (!delta) return;
    event.preventDefault();
    applyTimelineHeight(getCurrentTimelineHeight() + delta, true);
  }

  function bindEvents() {
    document.addEventListener(
      'click',
      (event) => {
        if (Date.now() >= timelineSuppressClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
    if (el.timelineResizeHandle) {
      el.timelineResizeHandle.addEventListener(
        'pointerdown',
        startTimelineResize
      );
      el.timelineResizeHandle.addEventListener(
        'pointermove',
        handleTimelineResizeMove,
        {
          passive: false,
        }
      );
      el.timelineResizeHandle.addEventListener('pointerup', endTimelineResize);
      el.timelineResizeHandle.addEventListener(
        'pointercancel',
        endTimelineResize
      );
      el.timelineResizeHandle.addEventListener(
        'keydown',
        handleTimelineResizeKeydown
      );
      document.addEventListener('pointermove', handleTimelineResizeMove, {
        passive: false,
      });
      document.addEventListener('pointerup', endTimelineResize);
      document.addEventListener('pointercancel', endTimelineResize);
      window.addEventListener('pointermove', handleTimelineResizeMove, {
        passive: false,
      });
      window.addEventListener('pointerup', endTimelineResize);
      window.addEventListener('pointercancel', endTimelineResize);
    }
    if (el.stageToolbarSnap && el.stageSnapToggle) {
      el.stageToolbarSnap.addEventListener('click', () => {
        el.stageSnapToggle.checked = !el.stageSnapToggle.checked;
        el.stageSnapToggle.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });
    }
    if (el.stageToolbarGrid && el.stageGridToggle) {
      el.stageToolbarGrid.addEventListener('click', () => {
        el.stageGridToggle.checked = !el.stageGridToggle.checked;
        el.stageGridToggle.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });
    }
    if (el.stageToolbarRotate && el.stageRotationSnapToggle) {
      el.stageToolbarRotate.addEventListener('click', () => {
        el.stageRotationSnapToggle.checked =
          !el.stageRotationSnapToggle.checked;
        el.stageRotationSnapToggle.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });
    }
    if (el.toolbarRotate90) {
      el.toolbarRotate90.addEventListener('click', () => {
        const selected = getSelectedStageElements();
        if (!selected.length) return;
        selected.forEach((elem) => {
          elem.rotation = ((elem.rotation || 0) + 90) % 360;
        });
        updateStageElementControls();
        renderStageElements();
        scheduleAutosave();
      });
    }
    if (el.stageToolbarLock && el.stageAspectLockToggle) {
      el.stageToolbarLock.addEventListener('click', () => {
        el.stageAspectLockToggle.checked = !el.stageAspectLockToggle.checked;
        el.stageAspectLockToggle.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      });
    }
    if (el.stageZoomFit) {
      el.stageZoomFit.addEventListener('click', fitPreviewScale);
    }
    if (el.stageZoom50) {
      el.stageZoom50.addEventListener('click', () => applyPreviewScale(0.5));
    }
    if (el.stageZoom100) {
      el.stageZoom100.addEventListener('click', () => applyPreviewScale(1));
    }
    if (el.stageZoom200) {
      el.stageZoom200.addEventListener('click', () => applyPreviewScale(2));
    }
    if (el.stageZoomRange) {
      el.stageZoomRange.addEventListener('input', () => {
        const value = parseFloat(el.stageZoomRange.value);
        if (!Number.isNaN(value)) {
          applyPreviewScale(value / 100);
        }
      });
    }
    if (el.inspectorContextClip) {
      el.inspectorContextClip.addEventListener('click', () => {
        inspectorContext = 'clip';
        renderInspector();
        scheduleStageInlineToolbarSync();
      });
    }
    if (el.inspectorContextStage) {
      el.inspectorContextStage.addEventListener('click', () => {
        inspectorContext = 'stage';
        renderInspector();
        scheduleStageInlineToolbarSync();
      });
    }
    if (el.stageInlineToolbar) {
      el.stageInlineToolbar.addEventListener('click', (event) => {
        const button =
          event.target && event.target.closest
            ? event.target.closest('button[data-stage-inline-action]')
            : null;
        if (!button) return;
        const action = button.getAttribute('data-stage-inline-action');
        if (!action) return;
        event.preventDefault();
        event.stopPropagation();
        if (action === 'front') {
          moveStageElementStep(1);
        } else if (action === 'back') {
          moveStageElementStep(-1);
        } else if (action === 'bold') {
          const selected = getSelectedStageElement();
          if (selected && selected.type === 'text') {
            const weight = selected.fontWeight || 600;
            const weightValue =
              typeof weight === 'string' ? weight.toLowerCase() : weight;
            const isBold =
              weightValue === 'bold' ||
              weightValue === '700' ||
              weightValue >= 600;
            updateStageElementField('fontWeight', isBold ? 400 : 700);
            updateStageElementControls();
          }
        } else if (action === 'italic') {
          const selected = getSelectedStageElement();
          if (selected && selected.type === 'text') {
            updateStageElementField(
              'fontStyle',
              selected.fontStyle === 'italic' ? 'normal' : 'italic'
            );
            updateStageElementControls();
          }
        } else if (
          action === 'align-left' ||
          action === 'align-center' ||
          action === 'align-right'
        ) {
          const selected = getSelectedStageElement();
          if (selected && selected.type === 'text') {
            const value =
              action === 'align-left'
                ? 'left'
                : action === 'align-right'
                  ? 'right'
                  : 'center';
            updateStageElementField('textAlign', value);
            updateStageElementControls();
          }
        } else if (action === 'duplicate') {
          duplicateSelectedStageElement();
        } else if (action === 'delete') {
          removeSelectedStageElement();
        } else if (action === 'lock') {
          toggleStageElementsLocked();
        } else if (action === 'hide') {
          toggleStageElementsHidden();
        } else if (action === 'crop-toggle') {
          toggleStageCropMode();
        } else if (action === 'crop-reset') {
          resetStageElementCrop();
        } else if (action === 'remove-bg') {
          removeBackgroundFromStageElement(getSelectedStageElement());
        } else if (action === 'refine-bg') {
          refineCutoutForStageElement(getSelectedStageElement());
        } else if (action === 'image-to-video') {
          convertStageElementToVideo(getSelectedStageElement());
        } else if (action === 'edit-external') {
          openSelectedStageElementExternalEditor();
        } else if (action === 'relight') {
          openSelectedStageElementRelighting();
        }
        scheduleStageInlineToolbarSync();
      });
    }
    if (el.stageInlineFontSize) {
      el.stageInlineFontSize.addEventListener('input', () => {
        const selected = getSelectedStageElement();
        if (!selected || selected.type !== 'text') return;
        updateStageElementNumeric('fontSize', el.stageInlineFontSize.value);
        updateStageElementControls();
        scheduleStageInlineToolbarSync();
      });
    }
    if (el.stageInlineColor) {
      el.stageInlineColor.addEventListener('input', () => {
        const selected = getSelectedStageElement();
        if (!selected || selected.type !== 'text') return;
        updateStageElementField('color', el.stageInlineColor.value);
        updateStageElementControls();
        scheduleStageInlineToolbarSync();
      });
    }
    [el.stageInlineCropZoom, el.stageInlineCropX, el.stageInlineCropY].forEach(
      (input) => {
        if (!input) return;
        input.addEventListener(
          'input',
          updateSelectedStageElementCropFromInline
        );
      }
    );
    if (el.toolbarFontSearch) {
      el.toolbarFontSearch.addEventListener('input', () => {
        filterToolbarFonts(el.toolbarFontSearch.value);
        openFontPickerModal({ query: el.toolbarFontSearch.value });
      });
      el.toolbarFontSearch.addEventListener('focus', () => {
        openFontPickerModal({ query: el.toolbarFontSearch.value });
      });
      el.toolbarFontSearch.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          const candidate = getFirstVisibleToolbarFontOption();
          if (candidate) {
            applyToolbarFontValue(candidate.value);
            closeFontPickerModal();
            if (el.toolbarFont) el.toolbarFont.focus();
          }
          return;
        }
        if (event.key === 'Escape') {
          event.preventDefault();
          el.toolbarFontSearch.value = '';
          filterToolbarFonts('');
          return;
        }
        if (event.key >= '1' && event.key <= '5') {
          if (el.toolbarFontSearch.value) return;
          event.preventDefault();
          applyRecentFontByIndex(parseInt(event.key, 10) - 1);
        }
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          moveToolbarFontFocus(1);
          return;
        }
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          moveToolbarFontFocus(-1);
        }
      });
    }
    if (el.toolbarFontOpen) {
      el.toolbarFontOpen.addEventListener('click', () => {
        openFontPickerModal({ query: el.toolbarFontSearch?.value || '' });
      });
    }
    if (el.toolbarFont) {
      el.toolbarFont.addEventListener('change', () => {
        applyToolbarFontValue(el.toolbarFont.value);
      });
    }
    if (el.toolbarFontSize) {
      el.toolbarFontSize.addEventListener('input', () => {
        updateStageElementNumeric('fontSize', el.toolbarFontSize.value);
        updateStageElementControls();
      });
    }
    if (el.toolbarBold) {
      el.toolbarBold.addEventListener('click', () => {
        const selected = getSelectedStageElement();
        if (!selected || selected.type !== 'text') return;
        const weight = selected.fontWeight || 600;
        const weightValue =
          typeof weight === 'string' ? weight.toLowerCase() : weight;
        const isBold =
          weightValue === 'bold' || weightValue === '700' || weightValue >= 600;
        updateStageElementField('fontWeight', isBold ? 400 : 700);
        updateStageElementControls();
      });
    }
    if (el.toolbarItalic) {
      el.toolbarItalic.addEventListener('click', () => {
        const selected = getSelectedStageElement();
        if (!selected || selected.type !== 'text') return;
        updateStageElementField(
          'fontStyle',
          selected.fontStyle === 'italic' ? 'normal' : 'italic'
        );
        updateStageElementControls();
      });
    }
    if (el.toolbarUnderline) {
      el.toolbarUnderline.addEventListener('click', () => {
        const selected = getSelectedStageElement();
        if (!selected || selected.type !== 'text') return;
        updateStageElementField(
          'textDecoration',
          selected.textDecoration === 'underline' ? 'none' : 'underline'
        );
        updateStageElementControls();
      });
    }
    if (el.toolbarColorSwatches && el.toolbarColorSwatches.length) {
      el.toolbarColorSwatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          const selected = getSelectedStageElement();
          if (!selected || !isToolbarColorElement(selected)) return;
          const color = swatch.dataset.color;
          if (!color) return;
          updateStageElementField(getToolbarColorField(selected), color);
          updateStageElementControls();
        });
      });
    }
    if (el.toolbarColorPicker) {
      el.toolbarColorPicker.addEventListener('click', (event) => {
        event.preventDefault();
        if (!isToolbarColorElement(getSelectedStageElement())) {
          ensureStageSelection();
        }
        openToolbarColorPopover();
      });
      el.toolbarColorPicker.addEventListener('input', () => {
        const selected = getSelectedStageElement();
        if (!selected || !isToolbarColorElement(selected)) return;
        const color = normalizeHexColor(el.toolbarColorPicker.value, '#111827');
        syncToolbarHsvFromHex(color);
        updateStageElementField(getToolbarColorField(selected), color);
        updateStageElementControls();
      });
    }
    if (el.toolbarTransparency) {
      el.toolbarTransparency.addEventListener('click', (event) => {
        event.preventDefault();
        if (!getSelectedStageElement()) ensureStageSelection();
        if (
          el.toolbarTransparencyPopover &&
          el.toolbarTransparencyPopover.classList.contains('is-open')
        ) {
          closeToolbarTransparencyPopover();
        } else {
          openToolbarTransparencyPopover();
        }
      });
    }
    if (el.toolbarTransparencySlider) {
      el.toolbarTransparencySlider.addEventListener('input', () => {
        const selected = getSelectedStageElement();
        if (!selected) return;
        const value = clampColorValue(
          parseInt(el.toolbarTransparencySlider.value, 10) || 0,
          0,
          100
        );
        updateStageElementNumeric('opacity', value);
        if (el.stageElementOpacity)
          el.stageElementOpacity.value = String(value);
        syncToolbarTransparency(selected);
      });
    }
    if (el.toolbarColorEyedrop) {
      el.toolbarColorEyedrop.addEventListener('click', async () => {
        const selected = getSelectedStageElement();
        if (!selected || !isToolbarColorElement(selected)) return;
        closeToolbarColorPopover();
        await activateEyedropper(getToolbarColorField(selected));
        updateStageElementControls();
      });
    }
    if (el.toolbarHsvSphere) {
      let pickingToolbarColor = false;
      el.toolbarHsvSphere.addEventListener('pointerdown', (event) => {
        const selected = getSelectedStageElement();
        if (!selected || !isToolbarColorElement(selected)) return;
        pickingToolbarColor = true;
        el.toolbarHsvSphere.setPointerCapture(event.pointerId);
        setToolbarHsvFromPointer(event);
      });
      el.toolbarHsvSphere.addEventListener('pointermove', (event) => {
        if (!pickingToolbarColor) return;
        setToolbarHsvFromPointer(event);
      });
      el.toolbarHsvSphere.addEventListener('pointerup', (event) => {
        pickingToolbarColor = false;
        if (el.toolbarHsvSphere.hasPointerCapture(event.pointerId)) {
          el.toolbarHsvSphere.releasePointerCapture(event.pointerId);
        }
      });
      el.toolbarHsvSphere.addEventListener('keydown', (event) => {
        const selected = getSelectedStageElement();
        if (!selected || !isToolbarColorElement(selected)) return;
        if (
          !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(
            event.key
          )
        )
          return;
        event.preventDefault();
        if (event.key === 'ArrowLeft') toolbarHsvColor.h -= 2;
        if (event.key === 'ArrowRight') toolbarHsvColor.h += 2;
        if (event.key === 'ArrowUp') toolbarHsvColor.s += 2;
        if (event.key === 'ArrowDown') toolbarHsvColor.s -= 2;
        toolbarHsvColor.s = clampColorValue(toolbarHsvColor.s, 0, 100);
        applyToolbarHsvColor();
      });
    }
    if (el.toolbarHsvValue) {
      el.toolbarHsvValue.addEventListener('input', () => {
        toolbarHsvColor.v = clampColorValue(
          parseInt(el.toolbarHsvValue.value, 10) || 0,
          0,
          100
        );
        applyToolbarHsvColor();
      });
    }
    if (el.toolbarColorModes) {
      el.toolbarColorModes.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () =>
          setToolbarColorMode(btn.dataset.mode)
        );
      });
    }
    if (el.toolbarHsvHex) {
      const commitHex = () => {
        const raw = String(el.toolbarHsvHex.value || '').trim();
        const prefixed = raw.startsWith('#') ? raw : `#${raw}`;
        if (/^#[0-9a-f]{6}$/i.test(prefixed)) {
          applyToolbarHexColor(prefixed);
          recordRecentToolbarColor(prefixed);
        } else {
          renderToolbarHsv();
        }
      };
      el.toolbarHsvHex.addEventListener('change', commitHex);
      el.toolbarHsvHex.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          commitHex();
          el.toolbarHsvHex.blur();
        }
      });
    }
    if (el.toolbarColorFavAdd) {
      el.toolbarColorFavAdd.addEventListener('click', () => {
        toggleToolbarFavColor(getToolbarHexValue());
      });
    }
    document.addEventListener('click', (event) => {
      if (
        el.toolbarColorPopover &&
        el.toolbarColorPopover.classList.contains('is-open')
      ) {
        const customPicker = event.target.closest('.toolbar-color-custom');
        if (!customPicker) closeToolbarColorPopover();
      }
      if (
        el.toolbarTransparencyPopover &&
        el.toolbarTransparencyPopover.classList.contains('is-open')
      ) {
        const transparency = event.target.closest(
          '.toolbar-transparency-control'
        );
        if (!transparency) closeToolbarTransparencyPopover();
      }
    });
    if (el.toolbarTextOptions) {
      el.toolbarTextOptions.addEventListener('click', () => {
        if (ensureStageSelection()) {
          openStageSection('stage-section-text');
        } else {
          openInspectorGroup('inspector-transition');
        }
      });
    }
    if (el.toolbarEffects) {
      el.toolbarEffects.addEventListener('click', () => {
        if (ensureStageSelection()) {
          openStageSection('stage-section-effects');
        } else {
          openInspectorGroup('inspector-transition');
        }
      });
    }
    if (el.toolbarAnimate) {
      el.toolbarAnimate.addEventListener('click', () => {
        if (ensureStageSelection()) {
          openStageSection('stage-section-keyframes');
        } else {
          openInspectorGroup('inspector-automation');
        }
      });
    }
    if (el.toolbarPosition) {
      el.toolbarPosition.addEventListener('click', () => {
        if (ensureStageSelection()) {
          openStageSection('stage-section-position-size');
        } else {
          openInspectorGroup('inspector-timing');
        }
      });
    }
    if (el.pageAdd) {
      el.pageAdd.addEventListener('click', addPage);
    }
    if (el.assetUpload) {
      el.assetUpload.addEventListener('change', handleAssetUpload);
    }
    if (el.assetFolderUpload) {
      el.assetFolderUpload.addEventListener('change', handleFolderUpload);
    }
    if (el.assetBrowse && el.assetUpload) {
      el.assetBrowse.addEventListener('click', (event) => {
        event.stopPropagation();
        el.assetUpload.click();
      });
    }
    if (el.assetFolderBrowse && el.assetFolderUpload) {
      el.assetFolderBrowse.addEventListener('click', (event) => {
        event.stopPropagation();
        el.assetFolderUpload.click();
      });
    }
    if (el.assetDrop && el.assetUpload) {
      el.assetDrop.addEventListener('click', (event) => {
        if (event.target && event.target.closest && event.target.closest('button')) {
          return;
        }
        el.assetUpload.click();
      });
    }
    if (el.assetRecord) {
      el.assetRecord.addEventListener('click', startSelfRecord);
    }
    if (el.assetRecordStop) {
      el.assetRecordStop.addEventListener('click', stopSelfRecord);
    }
    document
      .querySelectorAll('input[name="asset-record-source-mode"]')
      .forEach((input) => {
        input.addEventListener('change', () => {
          if (input.checked && el.assetRecordSource) {
            el.assetRecordSource.value = input.value;
          }
        });
      });
    if (el.assetRecordSource) {
      el.assetRecordSource.addEventListener('change', () => {
        document
          .querySelectorAll('input[name="asset-record-source-mode"]')
          .forEach((input) => {
            input.checked = input.value === el.assetRecordSource.value;
          });
      });
    }
    if (el.audioUpload) {
      el.audioUpload.addEventListener('change', handleAudioUpload);
    }
    if (el.audioUploadOpen && el.audioUpload) {
      el.audioUploadOpen.addEventListener('click', () =>
        el.audioUpload.click()
      );
    }
    if (el.audioClear) {
      el.audioClear.addEventListener('click', clearAudioTrack);
    }
    if (el.audioGain) {
      el.audioGain.addEventListener('input', updateAudioSettings);
    }
    if (el.audioFadeIn) {
      el.audioFadeIn.addEventListener('input', updateAudioSettings);
    }
    if (el.audioFadeOut) {
      el.audioFadeOut.addEventListener('input', updateAudioSettings);
    }
    if (el.timelinePlayToggle) {
      el.timelinePlayToggle.addEventListener('click', togglePreviewPlayback);
    }
    if (el.timelineHistoryOpen) {
      el.timelineHistoryOpen.addEventListener('click', () =>
        toggleEditorHistory(true)
      );
    }
    if (el.editorHistoryClose) {
      el.editorHistoryClose.addEventListener('click', () =>
        toggleEditorHistory(false)
      );
    }
    if (el.timelineWaveformToggle) {
      el.timelineWaveformToggle.addEventListener('change', () => {
        setTimelineWaveformVisible(el.timelineWaveformToggle.checked);
      });
    }
    if (el.timelineRememberSubmenuToggle) {
      el.timelineRememberSubmenuToggle.addEventListener('change', () => {
        setTimelineRememberSubmenu(el.timelineRememberSubmenuToggle.checked);
      });
    }
    if (el.timelineRememberQuickToggle) {
      el.timelineRememberQuickToggle.addEventListener('change', () => {
        setTimelineRememberQuickActions(el.timelineRememberQuickToggle.checked);
      });
    }
    if (el.aiGenerateOpen) {
      el.aiGenerateOpen.addEventListener('click', () => toggleAiGenerate(true));
    }
    if (el.aiGenerateClose) {
      el.aiGenerateClose.addEventListener('click', () =>
        toggleAiGenerate(false)
      );
    }
    if (el.aiSearchSubmit) {
      el.aiSearchSubmit.addEventListener('click', searchAiModalArt);
    }
    if (el.aiOpenSharedArt) {
      el.aiOpenSharedArt.addEventListener('click', openSharedArtDialog);
    }
    document.addEventListener('keydown', handleGlobalPlaybackKeydown);
    document.addEventListener('keydown', dismissEmptyState, { once: true });
    document.addEventListener('click', dismissEmptyState, { once: true });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      hideStageContextMenu();
      hideStageBackgroundMenu();
      hideAssetContextMenu();
      if (closeTopEditorModal()) {
        event.preventDefault();
        return;
      }
      if (inspectorOpen) {
        closeInspectorPanel({ restoreFocus: true });
        event.preventDefault();
        return;
      }
      if (sidebarOpen) {
        closeSidebarDrawer({ restoreFocus: true });
        event.preventDefault();
      }
    });
    document.addEventListener('click', (event) => {
      if (shouldIgnoreMenuDismiss(event)) return;
      const clickedStageMenu =
        el.stageContextMenu && el.stageContextMenu.contains(event.target);
      const clickedBackgroundMenu =
        el.stageBackgroundMenu && el.stageBackgroundMenu.contains(event.target);
      const clickedAssetMenu =
        el.assetContextMenu && el.assetContextMenu.contains(event.target);
      if (clickedStageMenu || clickedBackgroundMenu || clickedAssetMenu) return;
      hideStageContextMenu();
      hideStageBackgroundMenu();
      hideAssetContextMenu();
    });
    if (el.previewCanvasShell) {
      el.previewCanvasShell.addEventListener('contextmenu', (event) => {
        if (event.target.closest('.stage-element')) return;
        if (suppressLongPressContextMenu()) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        hideStageContextMenu();
        showStageBackgroundMenu(event);
      });
      bindLongPressMenu(
        el.previewCanvasShell,
        (pos) =>
          showStageBackgroundMenu({ clientX: pos.x, clientY: pos.y }, true),
        (touchTarget) =>
          !touchTarget.closest('.stage-element') &&
          !touchTarget.closest('.stage-handle') &&
          !touchTarget.closest('button')
      );
      el.previewCanvasShell.addEventListener('pointermove', (event) =>
        updateStagePointer(event, el.previewCanvasShell)
      );
      el.previewCanvasShell.addEventListener('pointerdown', (event) =>
        updateStagePointer(event, el.previewCanvasShell)
      );
      el.previewCanvasShell.addEventListener('pointerleave', clearStagePointer);
    }
    const updateTimelineRulerVisibility = (visible) => {
      if (!el.timelineTrack) return;
      el.timelineTrack.classList.toggle('show-ruler', visible);
    };
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Alt') {
        updateTimelineRulerVisibility(true);
      }
    });
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Alt') {
        updateTimelineRulerVisibility(false);
      }
    });
    window.addEventListener('blur', () => updateTimelineRulerVisibility(false));
    if (el.timelineList && el.timelineRuler) {
      let syncing = false;
      el.timelineList.addEventListener('scroll', () => {
        if (syncing) return;
        syncing = true;
        el.timelineRuler.scrollLeft = el.timelineList.scrollLeft;
        requestAnimationFrame(() => {
          syncing = false;
        });
      });
      el.timelineRuler.addEventListener('scroll', () => {
        if (syncing) return;
        syncing = true;
        el.timelineList.scrollLeft = el.timelineRuler.scrollLeft;
        requestAnimationFrame(() => {
          syncing = false;
        });
      });
      const handleTimelineZoomWheel = (event) => {
        if (!(event.ctrlKey || event.metaKey || event.altKey)) return;
        event.preventDefault();
        const delta = event.deltaY || event.deltaX || 0;
        if (!delta) return;
        const factor = Math.exp(-delta * 0.0018);
        const next = (state.timelineScale || 80) * factor;
        setTimelineZoom(next, event.clientX);
      };
      el.timelineList.addEventListener('wheel', handleTimelineZoomWheel, {
        passive: false,
      });
      el.timelineRuler.addEventListener('wheel', handleTimelineZoomWheel, {
        passive: false,
      });
    }
    if (el.timelineRuler && el.timelineRulerTrack) {
      const hideHover = (event) => {
        if (event && typeof event.clientX === 'number' && el.timelineRuler) {
          const r = el.timelineRuler.getBoundingClientRect();
          if (
            event.clientX >= r.left &&
            event.clientX <= r.right &&
            event.clientY >= r.top &&
            event.clientY <= r.bottom
          ) {
            return;
          }
        }
        if (el.timelineRulerHover) el.timelineRulerHover.style.display = 'none';
        if (el.timelineRulerHoverLine)
          el.timelineRulerHoverLine.style.display = 'none';
        if (el.timelineTicks) {
          el.timelineTicks
            .querySelectorAll('.timeline-tick.is-hover')
            .forEach((node) => node.classList.remove('is-hover'));
          el.timelineTicks
            .querySelectorAll('.timeline-tick-label.is-hover')
            .forEach((node) => node.classList.remove('is-hover'));
        }
      };
      const showHoverAt = (clientX) => {
        if (!el.timelineRuler || !el.timelineRulerTrack) return;
        const rect = el.timelineRuler.getBoundingClientRect();
        const scrollLeft = el.timelineRuler.scrollLeft || 0;
        const localX = clientX - rect.left;
        const offset = getTimelineTrackOffset();
        const x = Math.max(0, localX + scrollLeft - offset);
        const pxPerSec = timelineRulerPxPerSec || getTimelinePixelsPerSecond();
        if (!pxPerSec) return;
        const time = x / pxPerSec;
        const step = timelineRulerStep || 1;
        const snapped = step > 0 ? Math.round(time / step) * step : time;
        const snappedX = offset + snapped * pxPerSec;
        const snappedKey = timelineTickKey(snapped);
        if (el.timelineTicks) {
          el.timelineTicks
            .querySelectorAll('.timeline-tick.is-hover')
            .forEach((node) => node.classList.remove('is-hover'));
          el.timelineTicks
            .querySelectorAll('.timeline-tick-label.is-hover')
            .forEach((node) => node.classList.remove('is-hover'));
          const tick = el.timelineTicks.querySelector(
            `.timeline-tick[data-time="${snappedKey}"]`
          );
          if (tick) tick.classList.add('is-hover');
          const label = el.timelineTicks.querySelector(
            `.timeline-tick-label[data-time="${snappedKey}"]`
          );
          if (label) label.classList.add('is-hover');
        }
        if (el.timelineRulerHoverLine) {
          el.timelineRulerHoverLine.style.display = 'block';
          el.timelineRulerHoverLine.style.left = `${snappedX}px`;
        }
        if (el.timelineRulerHover && el.timelineRulerHoverText) {
          el.timelineRulerHover.style.display = 'flex';
          el.timelineRulerHover.style.left = `${rect.left + snappedX - scrollLeft}px`;
          el.timelineRulerHover.style.top = `${rect.top - 6}px`;
          el.timelineRulerHoverText.textContent = formatTimelineTimeValue(
            snapped,
            2
          );
          updateRulerHoverThumb(snapped);
        }
      };
      el.timelineRulerTrack.addEventListener('mousemove', (event) => {
        showHoverAt(event.clientX);
      });
      el.timelineRulerTrack.addEventListener('mouseleave', hideHover);
      el.timelineRulerTrack.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        startRulerPointerSession(event);
      });
    }
    if (el.timelinePlayhead) {
      el.timelinePlayhead.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        startTimelinePlayheadDrag(event, 'timeline');
      });
    }
    window.addEventListener('pointermove', handleTimelinePlayheadDragMove);
    window.addEventListener('pointerup', endTimelinePlayheadDrag);
    window.addEventListener('pointercancel', endTimelinePlayheadDrag);
    if (el.projectResolution) {
      el.projectResolution.addEventListener('change', updateProjectSettings);
    }
    if (el.projectFps) {
      el.projectFps.addEventListener('change', updateProjectSettings);
    }
    if (el.magicResizeOpen) {
      el.magicResizeOpen.addEventListener('click', () =>
        toggleMagicResize(true)
      );
    }
    if (el.magicResizeClose) {
      el.magicResizeClose.addEventListener('click', () =>
        toggleMagicResize(false)
      );
    }
    if (el.magicResizeCancel) {
      el.magicResizeCancel.addEventListener('click', () =>
        toggleMagicResize(false)
      );
    }
    if (el.magicResizeRun) {
      el.magicResizeRun.addEventListener('click', runMagicResize);
    }
    document.querySelectorAll('[data-magic-resize-res]').forEach((button) => {
      button.addEventListener('click', () => {
        magicResizeResolution = button.dataset.magicResizeRes || '1080x1920';
        document.querySelectorAll('[data-magic-resize-res]').forEach((item) => {
          item.classList.toggle('active', item === button);
        });
      });
    });
    document.querySelectorAll('[data-magic-resize-mode]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        setMagicResizeMode(button.dataset.magicResizeMode);
      });
    });
    if (el.editorSettingsButton) {
      el.editorSettingsButton.addEventListener('click', () =>
        toggleEditorSettings(true)
      );
    }
    if (el.editorSettingsClose) {
      el.editorSettingsClose.addEventListener('click', () =>
        toggleEditorSettings(false)
      );
    }
    bindEditorModal(el.editorSettingsModal, () => toggleEditorSettings(false));
    bindEditorModal(el.magicResizeModal, () => toggleMagicResize(false));
    bindEditorModal(el.editorHistoryModal, () => toggleEditorHistory(false));
    bindEditorModal(el.exportSettingsModal, () => toggleExportSettings(false));
    bindEditorModal(el.aiGenerateModal, () => toggleAiGenerate(false));
    bindEditorModal(el.keyboardShortcutsModal, () =>
      toggleKeyboardShortcuts(false)
    );
    bindEditorModal(el.projectLibraryModal, () => toggleProjectLibrary(false));
    bindEditorModal(getEl('fs-browser-modal'), () => toggleFsBrowser(false));
    if (el.projectSave) {
      el.projectSave.addEventListener('click', saveProject);
    }
    if (el.projectLoad) {
      el.projectLoad.addEventListener('click', loadProject);
    }
    if (el.projectExport) {
      el.projectExport.addEventListener('click', exportProjectFile);
    }
    if (el.projectImport) {
      el.projectImport.addEventListener('click', () => {
        if (el.projectImportInput) el.projectImportInput.click();
      });
    }
    if (el.projectImportInput) {
      el.projectImportInput.addEventListener('change', handleImportFile);
    }
    if (el.projectOpenCloud) {
      el.projectOpenCloud.addEventListener('click', openProjectLibrary);
    }
    if (el.projectSaveCloud) {
      el.projectSaveCloud.addEventListener('click', saveProject);
    }
    if (el.projectShareCloud) {
      el.projectShareCloud.addEventListener('click', shareCurrentProject);
    }
    if (el.projectForkCloud) {
      el.projectForkCloud.addEventListener('click', saveProjectCopy);
    }
    if (el.projectLibraryClose) {
      el.projectLibraryClose.addEventListener('click', () =>
        toggleProjectLibrary(false)
      );
    }
    if (el.projectLibraryModal) {
      el.projectLibraryModal.addEventListener('click', (event) => {
        if (event.target === el.projectLibraryModal) {
          toggleProjectLibrary(false);
        }
      });
    }
    if (el.projectLibraryRefresh) {
      el.projectLibraryRefresh.addEventListener('click', () => {
        refreshAccountProjects().catch((error) => {
          if (handleSyncAuthError(error)) return;
          notify('Refresh failed', 'error');
        });
      });
    }
    if (el.projectLibrarySaveCopy) {
      el.projectLibrarySaveCopy.addEventListener('click', saveProjectCopy);
    }
    if (el.projectLibraryFileOpen) {
      el.projectLibraryFileOpen.addEventListener('click', () => {
        toggleProjectLibrary(false);
        openNativeFilePicker('project-open');
      });
    }
    initFsBrowser();
    if (el.stageAddText) {
      el.stageAddText.addEventListener('click', () => addStageTextAndEdit());
    }
    if (el.workspaceEmptyAddText) {
      el.workspaceEmptyAddText.addEventListener('click', () =>
        addStageTextAndEdit()
      );
    }
    if (el.stageAddShape) {
      el.stageAddShape.addEventListener('click', addStageShape);
    }
    if (el.workspaceEmptyAddShape) {
      el.workspaceEmptyAddShape.addEventListener('click', addStageShape);
    }
    if (el.stageAddFromAsset) {
      el.stageAddFromAsset.addEventListener('click', addStageElementFromAsset);
    }
    if (el.toolbarAddText) {
      el.toolbarAddText.addEventListener('click', () => addStageTextAndEdit());
    }
    if (el.toolbarAddRect) {
      el.toolbarAddRect.addEventListener('click', function () {
        addStageShapeAt(undefined, 'rect');
      });
    }
    if (el.toolbarAddCircle) {
      el.toolbarAddCircle.addEventListener('click', function () {
        addStageShapeAt(undefined, 'circle');
      });
    }
    if (el.toolbarAddLine) {
      el.toolbarAddLine.addEventListener('click', function () {
        addStageShapeAt(undefined, 'line');
      });
    }
    if (el.toolbarShortcutsHelp) {
      el.toolbarShortcutsHelp.addEventListener('click', function () {
        toggleKeyboardShortcuts(true);
      });
    }
    if (el.workspaceEmptyOpenLibrary) {
      el.workspaceEmptyOpenLibrary.addEventListener('click', () => {
        const tab = document.querySelector('.asset-tab[data-tab="uploads"]');
        if (tab) {
          document
            .querySelectorAll('.asset-tab')
            .forEach((node) => node.classList.remove('active'));
          tab.classList.add('active');
        }
        openSidebarDrawer('uploads', tab);
      });
    }
    if (el.stageContextMenu) {
      el.stageContextMenu.addEventListener('click', (event) => {
        const btn = event.target.closest('button');
        const action = btn ? btn.dataset.stageAction : null;
        if (!action) return;
        event.preventDefault();
        const target = state.stageElements.find(
          (item) => item.id === state.stageContextId
        );
        if (target) {
          selectStageElement(target.id);
        }
        if (action === 'edit') {
          if (target && target.type === 'text' && el.stageElements) {
            const node = el.stageElements.querySelector(
              `[data-stage-id="${target.id}"]`
            );
            if (node) beginStageTextEdit(node, target);
          }
        } else if (action === 'duplicate') {
          duplicateSelectedStageElement();
        } else if (action === 'front') {
          moveStageElementStep(1);
        } else if (action === 'back') {
          moveStageElementStep(-1);
        } else if (action === 'remove-bg') {
          removeBackgroundFromStageElement(target);
        } else if (action === 'refine-bg') {
          refineCutoutForStageElement(target);
        } else if (action === 'relight') {
          openRelightForStageElement(target);
        } else if (action === 'style-transfer') {
          openStyleTransferForStageElement(target);
        } else if (action === 'convert-animated') {
          convertStageElementToVideo(target);
        } else if (action === 'delete') {
          removeSelectedStageElement();
        }
        hideStageContextMenu();
      });
    }
    if (el.stageBackgroundMenu) {
      el.stageBackgroundMenu.addEventListener('click', (event) => {
        const btn = event.target.closest('button');
        const action = btn ? btn.dataset.stageBgAction : null;
        if (!action) return;
        event.preventDefault();
        if (action === 'add-text') {
          addStageTextAndEdit();
        } else if (action === 'add-shape') {
          addStageShape();
        } else if (action === 'add-asset') {
          addStageElementFromAsset();
        } else if (action === 'paste') {
          pasteStageElementFromClipboard();
        }
        hideStageBackgroundMenu();
      });
    }
    if (el.assetContextMenu) {
      el.assetContextMenu.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-asset-action]');
        const action = btn ? btn.getAttribute('data-asset-action') : null;
        if (!action) return;
        event.preventDefault();
        const assetId = state.assetContextMenuId;
        const asset = state.assets.find((item) => item.id === assetId);
        if (!asset) {
          hideAssetContextMenu();
          return;
        }
        const capabilities = getAssetCapabilities(asset);
        if (action === 'add-clip') {
          if (!capabilities.addClip) {
            hideAssetContextMenu();
            return;
          }
          addClipFromAsset(assetId);
        } else if (action === 'add-stage') {
          if (!capabilities.addStage) {
            hideAssetContextMenu();
            return;
          }
          state.selectedAssetId = assetId;
          addStageElementFromAsset();
        } else if (action === 'use-audio') {
          if (capabilities.useAudio) {
            if (asset.file) {
              loadAudioFile(asset.file);
            } else if (asset.src) {
              if (asset.src.startsWith('blob:')) {
                fetch(asset.src)
                  .then((res) => res.blob())
                  .then((blob) => {
                    const file = new File([blob], asset.name || 'Audio', {
                      type: blob.type || 'audio/mpeg',
                    });
                    loadAudioFile(file);
                  })
                  .catch(() => {});
              } else {
                loadAudioUrl(asset.src, asset.name);
              }
            }
          }
        } else if (action === 'extract-frame') {
          if (!capabilities.extractFrame) {
            hideAssetContextMenu();
            return;
          }
          extractFrameFromVideoAsset(asset);
        } else if (action === 'image-to-video') {
          if (!capabilities.imageToVideo) {
            hideAssetContextMenu();
            return;
          }
          generateVideoFromImageAsset(asset);
        } else if (action === 'remove-bg') {
          if (!capabilities.removeBg) {
            hideAssetContextMenu();
            return;
          }
          removeBackgroundFromAsset(asset);
        } else if (action === 'refine-bg') {
          refineCutoutForAsset(asset);
        } else if (action === 'relight') {
          if (!capabilities.relight) {
            hideAssetContextMenu();
            return;
          }
          openRelightForAsset(asset);
        } else if (action === 'style-transfer') {
          if (!capabilities.styleTransfer) {
            hideAssetContextMenu();
            return;
          }
          openStyleTransferForAsset(asset);
        } else if (action === 'convert-gif') {
          if (!capabilities.convertGif) {
            hideAssetContextMenu();
            return;
          }
          convertVideoToGifAsset(asset);
        } else if (action === 'save-asset') {
          if (canPersistAiAsset(asset)) {
            toggleSavedAiAsset({
              src: asset.src,
              type: asset.type,
              name: asset.name,
            });
          }
        } else if (action === 'download-asset') {
          downloadAssetFile(asset);
        } else if (action === 'copy-asset') {
          copyAssetToClipboard(asset);
        } else if (action === 'copy-address') {
          copyAssetAddress(asset);
        } else if (action === 'cut-asset') {
          copyAssetToClipboard(asset).finally(() => {
            removeAssetById(asset.id);
          });
        } else if (action === 'duplicate-asset') {
          duplicateAsset(asset);
        } else if (action === 'rename-asset') {
          renameAsset(asset);
        } else if (action === 'delete-asset') {
          removeAssetById(asset.id);
        }
        hideAssetContextMenu();
      });
    }
    document.addEventListener(
      'contextmenu',
      (event) => {
        const item = event.target?.closest?.('#asset-list .asset-item');
        if (!item) return;
        const assetId = item.getAttribute('data-asset-id');
        const asset = state.assets.find((entry) => entry.id === assetId);
        if (!asset || asset.status === 'generating') return;
        event.preventDefault();
        event.stopPropagation();
        showAssetContextMenu(event.clientX, event.clientY, asset);
      },
      true
    );
    if (el.stageElementsCompactToggle) {
      el.stageElementsCompactToggle.addEventListener('change', () => {
        setStageElementsCompact(el.stageElementsCompactToggle.checked);
      });
    }
    if (el.stageElementsFilter) {
      el.stageElementsFilter.addEventListener('input', () => {
        state.stageElementsFilter = el.stageElementsFilter.value || '';
        updateStageElementsFilterClearIcon();
        renderStageElementsList();
      });
    }
    if (el.stageElementsFilterClearIcon) {
      el.stageElementsFilterClearIcon.addEventListener('click', () => {
        state.stageElementsFilter = '';
        if (el.stageElementsFilter) {
          el.stageElementsFilter.value = '';
        }
        updateStageElementsFilterClearIcon();
        renderStageElementsList();
      });
    }
    if (el.stageElementsFilterClear) {
      el.stageElementsFilterClear.addEventListener('click', () => {
        state.stageElementsFilter = '';
        if (el.stageElementsFilter) {
          el.stageElementsFilter.value = '';
        }
        updateStageElementsFilterClearIcon();
        renderStageElementsList();
      });
    }
    if (el.stageFiltersToggle) {
      el.stageFiltersToggle.addEventListener('click', (event) => {
        event.stopPropagation();
        const isOpen = el.stageFiltersPopover?.classList.contains('open');
        if (isOpen) {
          stageFiltersPopoverManualClosed = true;
          setStageFiltersPopoverOpen(false);
          return;
        }
        stageFiltersPopoverManualClosed = false;
        setStageFiltersPopoverOpen(true, { focus: true });
      });
    }
    if (el.stageElementsFilter) {
      el.stageElementsFilter.addEventListener('focus', () => {
        stageFiltersPopoverManualClosed = false;
        setStageFiltersPopoverOpen(true);
      });
    }
    if (el.stageElementsFilterReset) {
      el.stageElementsFilterReset.addEventListener('click', () => {
        clearStageElementsFilters();
      });
    }
    if (el.stageElementsFilterClearAll) {
      el.stageElementsFilterClearAll.addEventListener('click', () => {
        clearStageElementsFilters();
      });
    }
    if (el.stageElementsFilterPreset) {
      el.stageElementsFilterPreset.addEventListener('change', () => {
        const preset = el.stageElementsFilterPreset.value;
        if (!preset) return;
        applyStageElementsFilterPreset(preset, true);
      });
    }
    if (el.stageElementsFilterChips && el.stageElementsFilterChips.length) {
      el.stageElementsFilterChips.forEach((chip) => {
        chip.addEventListener('click', () => {
          setStageElementsFilterType(chip.dataset.stageFilter || 'all');
        });
      });
    }
    if (el.stageElementsStatusChips && el.stageElementsStatusChips.length) {
      el.stageElementsStatusChips.forEach((chip) => {
        chip.addEventListener('click', () => {
          setStageElementsFilterStatus(chip.dataset.stageStatus || 'all');
        });
      });
    }
    if (el.stageElementsActionChips && el.stageElementsActionChips.length) {
      el.stageElementsActionChips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const action = chip.dataset.stageAction;
          if (!action) return;
          if (action === 'toggle-locked') {
            toggleStageElementsLocked();
          }
          if (action === 'toggle-hidden') {
            toggleStageElementsHidden();
          }
        });
      });
    }
    if (el.stageElementsSelectedToggle) {
      el.stageElementsSelectedToggle.addEventListener('change', () => {
        setStageElementsSelectedOnly(el.stageElementsSelectedToggle.checked);
      });
    }
    if (el.stageElementsTypeBadgeToggle) {
      el.stageElementsTypeBadgeToggle.addEventListener('change', () => {
        setStageElementsTypeBadges(el.stageElementsTypeBadgeToggle.checked);
      });
    }
    document.addEventListener('click', (event) => {
      if (!el.stageFiltersPopover || !el.stageFiltersToggle) return;
      if (
        el.stageFiltersPopover.contains(event.target) ||
        el.stageFiltersToggle.contains(event.target)
      )
        return;
      stageFiltersPopoverManualClosed = true;
      setStageFiltersPopoverOpen(false);
    });
    document.addEventListener('click', (event) => {
      if (shouldIgnoreMenuDismiss(event)) return;
      if (!el.timelineContextMenu) return;
      if (!el.timelineContextMenu.classList.contains('open')) return;
      if (el.timelineContextMenu.contains(event.target)) return;
      closeTimelineContextMenu();
    });
    document.addEventListener('click', (event) => {
      if (shouldIgnoreMenuDismiss(event)) return;
      if (!el.timelineMarkerMenu) return;
      if (!el.timelineMarkerMenu.classList.contains('open')) return;
      if (el.timelineMarkerMenu.contains(event.target)) return;
      closeTimelineMarkerMenu();
    });
    document.addEventListener('click', (event) => {
      if (shouldIgnoreMenuDismiss(event)) return;
      if (!el.timelineTrackMenu) return;
      if (!el.timelineTrackMenu.classList.contains('open')) return;
      if (el.timelineTrackMenu.contains(event.target)) return;
      closeTimelineTrackMenu();
    });
    document.addEventListener('contextmenu', (event) => {
      if (shouldIgnoreMenuDismiss(event)) return;
      if (!el.timelineContextMenu) return;
      if (!el.timelineContextMenu.classList.contains('open')) return;
      if (el.timelineContextMenu.contains(event.target)) return;
      closeTimelineContextMenu();
    });
    document.addEventListener('contextmenu', (event) => {
      if (shouldIgnoreMenuDismiss(event)) return;
      if (!el.timelineMarkerMenu) return;
      if (!el.timelineMarkerMenu.classList.contains('open')) return;
      if (el.timelineMarkerMenu.contains(event.target)) return;
      closeTimelineMarkerMenu();
    });
    document.addEventListener('contextmenu', (event) => {
      if (shouldIgnoreMenuDismiss(event)) return;
      if (!el.timelineTrackMenu) return;
      if (!el.timelineTrackMenu.classList.contains('open')) return;
      if (el.timelineTrackMenu.contains(event.target)) return;
      closeTimelineTrackMenu();
    });
    document.addEventListener(
      'wheel',
      (event) => {
        const target = event.target;
        if (
          el.timelineContextMenu?.classList.contains('open') &&
          !el.timelineContextMenu.contains(target)
        ) {
          closeTimelineContextMenu();
        }
        if (
          el.timelineMarkerMenu?.classList.contains('open') &&
          !el.timelineMarkerMenu.contains(target)
        ) {
          closeTimelineMarkerMenu();
        }
        if (
          el.timelineTrackMenu?.classList.contains('open') &&
          !el.timelineTrackMenu.contains(target)
        ) {
          closeTimelineTrackMenu();
        }
      },
      { passive: true }
    );
    document.addEventListener('keydown', (event) => {
      if (!el.stageFiltersPopover || !el.stageFiltersToggle) return;
      if (
        event.defaultPrevented ||
        isEditorModalOpen() ||
        event.metaKey ||
        event.ctrlKey ||
        event.altKey
      )
        return;
      const tag = (event.target && event.target.tagName) || '';
      if (
        tag === 'INPUT' ||
        tag === 'TEXTAREA' ||
        event.target?.isContentEditable
      )
        return;
      if (event.key && event.key.toLowerCase() === 'f') {
        event.preventDefault();
        if (event.shiftKey) {
          clearStageElementsFilters();
          return;
        }
        const isOpen = el.stageFiltersPopover.classList.contains('open');
        if (isOpen) {
          stageFiltersPopoverManualClosed = true;
          setStageFiltersPopoverOpen(false);
        } else {
          stageFiltersPopoverManualClosed = false;
          setStageFiltersPopoverOpen(true, { focus: true });
        }
        return;
      }
      if (event.key === '/' || event.key === '?') {
        event.preventDefault();
        stageFiltersPopoverManualClosed = false;
        setStageFiltersPopoverOpen(true, { focus: true });
        return;
      }
      if (event.key && event.key.toLowerCase() === 'l') {
        event.preventDefault();
        if (el.stageElementsList) {
          const listSection = el.stageElementsList.closest('details');
          if (listSection) {
            listSection.open = !listSection.open;
          }
        }
      }
      if (event.key === 'Escape') {
        closeTimelineContextMenu();
        closeTimelineMarkerMenu();
        closeTimelineTrackMenu();
      }
    });
    if (el.stageKeyframeFilterAll) {
      el.stageKeyframeFilterAll.addEventListener('click', () => {
        state.stageKeyframeFilter = 'all';
        renderStageKeyframeList();
      });
    }
    if (el.stageKeyframeFilterPos) {
      el.stageKeyframeFilterPos.addEventListener('click', () => {
        state.stageKeyframeFilter = 'pos';
        renderStageKeyframeList();
      });
    }
    if (el.stageKeyframeFilterOpacity) {
      el.stageKeyframeFilterOpacity.addEventListener('click', () => {
        state.stageKeyframeFilter = 'opacity';
        renderStageKeyframeList();
      });
    }
    if (el.stageSnapToggle) {
      el.stageSnapToggle.addEventListener('change', () => {
        state.stageSnapEnabled = el.stageSnapToggle.checked;
        if (!state.stageSnapEnabled) {
          setStageGuides(null, null);
        }
        if (el.stageSnapGridToggle) {
          el.stageSnapGridToggle.checked =
            state.stageGridEnabled && state.stageSnapEnabled;
        }
        updateStageToolsDetails();
        syncStageToolbar();
      });
    }
    if (el.stageSnapStrength) {
      el.stageSnapStrength.addEventListener('input', () => {
        const value = parseFloat(el.stageSnapStrength.value);
        if (!Number.isNaN(value)) {
          state.stageSnapStrength = Math.max(0.25, Math.min(5, value));
          if (el.stageSnapStrengthInput) {
            el.stageSnapStrengthInput.value = state.stageSnapStrength;
          }
        }
      });
    }
    if (el.stageSnapStrengthInput) {
      el.stageSnapStrengthInput.addEventListener('input', () => {
        const value = parseFloat(el.stageSnapStrengthInput.value);
        if (!Number.isNaN(value)) {
          state.stageSnapStrength = Math.max(0.25, Math.min(5, value));
          if (el.stageSnapStrength) {
            el.stageSnapStrength.value = state.stageSnapStrength;
          }
        }
      });
    }
    if (el.stageGridToggle) {
      el.stageGridToggle.addEventListener('change', () => {
        state.stageGridEnabled = el.stageGridToggle.checked;
        if (el.previewCanvasShell) {
          el.previewCanvasShell.classList.toggle(
            'show-grid',
            state.stageGridEnabled
          );
        }
        if (el.stageSnapToggle && state.stageGridEnabled) {
          el.stageSnapToggle.checked = true;
          state.stageSnapEnabled = true;
        }
        if (el.stageSnapGridToggle) {
          el.stageSnapGridToggle.checked =
            state.stageGridEnabled && state.stageSnapEnabled;
        }
        updateStageToolsDetails();
        syncStageToolbar();
      });
    }
    if (el.stageSnapGridToggle) {
      el.stageSnapGridToggle.addEventListener('change', () => {
        if (!el.stageSnapGridToggle.checked) return;
        state.stageGridEnabled = true;
        state.stageSnapEnabled = true;
        if (el.previewCanvasShell) {
          el.previewCanvasShell.classList.add('show-grid');
        }
        if (el.stageGridToggle) {
          el.stageGridToggle.checked = true;
        }
        if (el.stageSnapToggle) {
          el.stageSnapToggle.checked = true;
        }
        updateStageToolsDetails();
      });
    }
    if (el.stageSnapStrength) {
      el.stageSnapStrength.value = state.stageSnapStrength;
    }
    if (el.stageElementName) {
      el.stageElementName.addEventListener('input', () =>
        updateStageElementField('name', el.stageElementName.value)
      );
    }
    if (el.stageElementText) {
      el.stageElementText.addEventListener('input', () =>
        updateStageElementField('text', el.stageElementText.value)
      );
    }
    if (el.stageElementTextAlign) {
      el.stageElementTextAlign.addEventListener('change', () =>
        updateStageElementField('textAlign', el.stageElementTextAlign.value)
      );
    }
    if (el.stageElementTextEffect) {
      el.stageElementTextEffect.addEventListener('change', () =>
        updateStageElementField('textEffect', el.stageElementTextEffect.value)
      );
    }
    if (el.stageElementTextAnimation) {
      el.stageElementTextAnimation.addEventListener('change', () => {
        updateStageElementField(
          'textAnimation',
          el.stageElementTextAnimation.value
        );
        renderStageElements();
      });
    }
    if (el.stageElementTextAnimDur) {
      el.stageElementTextAnimDur.addEventListener('input', () =>
        updateStageElementNumeric(
          'textAnimationDuration',
          el.stageElementTextAnimDur.value
        )
      );
    }
    if (el.stageElementTextAnimDelay) {
      el.stageElementTextAnimDelay.addEventListener('input', () =>
        updateStageElementNumeric(
          'textAnimationDelay',
          el.stageElementTextAnimDelay.value
        )
      );
    }
    if (el.stageElementFontSize) {
      el.stageElementFontSize.addEventListener('input', () =>
        updateStageElementNumeric('fontSize', el.stageElementFontSize.value)
      );
    }
    if (el.stageElementColor) {
      el.stageElementColor.addEventListener('input', () =>
        updateStageElementField('color', el.stageElementColor.value)
      );
    }
    if (el.stageElementColorEyedrop) {
      el.stageElementColorEyedrop.addEventListener('click', () =>
        activateEyedropper('color')
      );
    }
    if (el.stageElementBackground) {
      el.stageElementBackground.addEventListener('input', () =>
        updateStageElementField('background', el.stageElementBackground.value)
      );
    }
    if (el.stageElementBgEyedrop) {
      el.stageElementBgEyedrop.addEventListener('click', () =>
        activateEyedropper('background')
      );
    }
    if (el.stageElementStyleReset) {
      el.stageElementStyleReset.addEventListener(
        'click',
        resetStageElementStyle
      );
    }
    if (el.stageElementCopyStyle) {
      el.stageElementCopyStyle.addEventListener('click', copyStageElementStyle);
    }
    if (el.stageElementPasteStyle) {
      el.stageElementPasteStyle.addEventListener(
        'click',
        pasteStageElementStyle
      );
    }
    if (el.stageElementCopyAlign) {
      el.stageElementCopyAlign.addEventListener('click', copyStageElementAlign);
    }
    if (el.stageElementPasteAlign) {
      el.stageElementPasteAlign.addEventListener(
        'click',
        pasteStageElementAlign
      );
    }
    if (el.stageElementRotation) {
      el.stageElementRotation.addEventListener('input', () =>
        updateStageElementNumeric('rotation', el.stageElementRotation.value)
      );
    }
    if (el.stageElementCopyRotation) {
      el.stageElementCopyRotation.addEventListener(
        'click',
        copyStageElementRotation
      );
    }
    if (el.stageElementPasteRotation) {
      el.stageElementPasteRotation.addEventListener(
        'click',
        pasteStageElementRotation
      );
    }
    if (el.stageElementOpacity) {
      el.stageElementOpacity.addEventListener('input', () =>
        updateStageElementNumeric('opacity', el.stageElementOpacity.value)
      );
    }
    ['Blur', 'Brightness', 'Contrast', 'Saturation', 'Hue'].forEach(
      function (name) {
        var key =
          name === 'Hue'
            ? 'hueRotate'
            : name.charAt(0).toLowerCase() + name.slice(1);
        var input = el['stageElementFx' + name];
        if (input)
          input.addEventListener('input', function () {
            updateStageElementEffect(key, parseFloat(input.value));
          });
      }
    );
    if (el.stageElementFxReset) {
      el.stageElementFxReset.addEventListener('click', function () {
        resetStageElementEffects();
      });
    }
    if (el.stageElementCopyOpacity) {
      el.stageElementCopyOpacity.addEventListener(
        'click',
        copyStageElementOpacity
      );
    }
    if (el.stageElementPasteOpacity) {
      el.stageElementPasteOpacity.addEventListener(
        'click',
        pasteStageElementOpacity
      );
    }
    if (el.stageElementCopyVisibility) {
      el.stageElementCopyVisibility.addEventListener(
        'click',
        copyStageElementVisibility
      );
    }
    if (el.stageElementPasteVisibility) {
      el.stageElementPasteVisibility.addEventListener(
        'click',
        pasteStageElementVisibility
      );
    }
    if (el.stageElementAlignLeft) {
      el.stageElementAlignLeft.addEventListener('click', () =>
        alignStageElement('left')
      );
    }
    if (el.stageElementAlignCenter) {
      el.stageElementAlignCenter.addEventListener('click', () =>
        alignStageElement('center')
      );
    }
    if (el.stageElementAlignRight) {
      el.stageElementAlignRight.addEventListener('click', () =>
        alignStageElement('right')
      );
    }
    if (el.stageElementAlignTop) {
      el.stageElementAlignTop.addEventListener('click', () =>
        alignStageElement('top')
      );
    }
    if (el.stageElementAlignMiddle) {
      el.stageElementAlignMiddle.addEventListener('click', () =>
        alignStageElement('middle')
      );
    }
    if (el.stageElementAlignBottom) {
      el.stageElementAlignBottom.addEventListener('click', () =>
        alignStageElement('bottom')
      );
    }
    if (el.stageElementAlignXThird) {
      el.stageElementAlignXThird.addEventListener('click', () =>
        alignStageElementAxis('x', 33.333)
      );
    }
    if (el.stageElementAlignXCenter) {
      el.stageElementAlignXCenter.addEventListener('click', () =>
        alignStageElementAxis('x', 50)
      );
    }
    if (el.stageElementAlignXTwoThird) {
      el.stageElementAlignXTwoThird.addEventListener('click', () =>
        alignStageElementAxis('x', 66.666)
      );
    }
    if (el.stageElementAlignYThird) {
      el.stageElementAlignYThird.addEventListener('click', () =>
        alignStageElementAxis('y', 33.333)
      );
    }
    if (el.stageElementAlignYCenter) {
      el.stageElementAlignYCenter.addEventListener('click', () =>
        alignStageElementAxis('y', 50)
      );
    }
    if (el.stageElementAlignYTwoThird) {
      el.stageElementAlignYTwoThird.addEventListener('click', () =>
        alignStageElementAxis('y', 66.666)
      );
    }
    if (el.stageElementCopyStageAlign) {
      el.stageElementCopyStageAlign.addEventListener(
        'click',
        copyStageElementStageAlign
      );
    }
    if (el.stageElementPasteStageAlign) {
      el.stageElementPasteStageAlign.addEventListener(
        'click',
        pasteStageElementStageAlign
      );
    }
    if (el.stageElementDistributeHorizontal) {
      el.stageElementDistributeHorizontal.addEventListener('click', () =>
        distributeStageElements('horizontal')
      );
    }
    if (el.stageElementDistributeVertical) {
      el.stageElementDistributeVertical.addEventListener('click', () =>
        distributeStageElements('vertical')
      );
    }
    if (el.stageElementSpacing2) {
      el.stageElementSpacing2.addEventListener('click', () =>
        distributeStageElements('horizontal', 2)
      );
    }
    if (el.stageElementSpacing4) {
      el.stageElementSpacing4.addEventListener('click', () =>
        distributeStageElements('horizontal', 4)
      );
    }
    if (el.stageElementSpacing8) {
      el.stageElementSpacing8.addEventListener('click', () =>
        distributeStageElements('horizontal', 8)
      );
    }
    if (el.stageElementFitStage) {
      el.stageElementFitStage.addEventListener(
        'click',
        fitStageElementsToStage
      );
    }
    if (el.stageElementCenterStage) {
      el.stageElementCenterStage.addEventListener('click', centerStageElements);
    }
    if (el.stageElementSnap16x9) {
      el.stageElementSnap16x9.addEventListener('click', () =>
        snapStageElementsAspect(16 / 9)
      );
    }
    if (el.stageElementSnap1x1) {
      el.stageElementSnap1x1.addEventListener('click', () =>
        snapStageElementsAspect(1)
      );
    }
    if (el.stageElementSnap9x16) {
      el.stageElementSnap9x16.addEventListener('click', () =>
        snapStageElementsAspect(9 / 16)
      );
    }
    if (el.stageElementResetRotation) {
      el.stageElementResetRotation.addEventListener(
        'click',
        resetStageElementsRotation
      );
    }
    if (el.stageElementResetScale) {
      el.stageElementResetScale.addEventListener(
        'click',
        resetStageElementsScale
      );
    }
    if (el.stageRotationSnapToggle) {
      el.stageRotationSnapToggle.addEventListener('change', () => {
        state.stageRotationSnapEnabled = el.stageRotationSnapToggle.checked;
        syncStageToolbar();
      });
    }
    if (el.stageAspectLockToggle) {
      el.stageAspectLockToggle.addEventListener('change', () => {
        const selectedList = getSelectedStageElements();
        if (!selectedList.length) return;
        const nextValue = el.stageAspectLockToggle.checked;
        selectedList.forEach((element) => {
          element.aspectLocked = nextValue;
        });
        syncStageAspectLockState(selectedList);
        renderStageSelectionBox();
        syncStageToolbar();
      });
    }
    if (el.stageElementResetPosition) {
      el.stageElementResetPosition.addEventListener(
        'click',
        resetStageElementsPosition
      );
    }
    if (el.stageElementResetAll) {
      el.stageElementResetAll.addEventListener('click', resetStageElementsAll);
    }
    if (el.stageKeyframePosition) {
      el.stageKeyframePosition.addEventListener('click', () =>
        addStageKeyframe('position')
      );
    }
    if (el.stageKeyframeOpacity) {
      el.stageKeyframeOpacity.addEventListener('click', () =>
        addStageKeyframe('opacity')
      );
    }
    if (el.stageKeyframeScale) {
      el.stageKeyframeScale.addEventListener('click', () =>
        addStageKeyframe('scale')
      );
    }
    if (el.stageKeyframeAll) {
      el.stageKeyframeAll.addEventListener('click', () =>
        addStageKeyframe('all')
      );
    }
    if (el.stageKeyframeClear) {
      el.stageKeyframeClear.addEventListener('click', clearStageKeyframes);
    }
    if (el.stageKeyframePrev) {
      el.stageKeyframePrev.addEventListener('click', () =>
        jumpStageKeyframe('prev')
      );
    }
    if (el.stageKeyframeNext) {
      el.stageKeyframeNext.addEventListener('click', () =>
        jumpStageKeyframe('next')
      );
    }
    if (el.stageKeyframeTrackSnap) {
      el.stageKeyframeTrackSnap.addEventListener('change', () => {
        state.stageKeyframeTrackSnap = el.stageKeyframeTrackSnap.checked;
      });
    }
    if (el.stageKeyframeClearSolo) {
      el.stageKeyframeClearSolo.addEventListener('click', () => {
        state.stageKeyframeSoloId = null;
        renderStageKeyframeList();
        renderStageElements();
      });
    }
    if (el.stageElementX) {
      el.stageElementX.addEventListener('input', () =>
        updateStageElementNumeric('x', el.stageElementX.value)
      );
    }
    if (el.stageElementY) {
      el.stageElementY.addEventListener('input', () =>
        updateStageElementNumeric('y', el.stageElementY.value)
      );
    }
    if (el.stageElementCopyPos) {
      el.stageElementCopyPos.addEventListener(
        'click',
        copyStageElementPosition
      );
    }
    if (el.stageElementPastePos) {
      el.stageElementPastePos.addEventListener(
        'click',
        pasteStageElementPosition
      );
    }
    if (el.stageElementWidth) {
      el.stageElementWidth.addEventListener('input', () =>
        updateStageElementNumeric('w', el.stageElementWidth.value)
      );
    }
    if (el.stageElementHeight) {
      el.stageElementHeight.addEventListener('input', () =>
        updateStageElementNumeric('h', el.stageElementHeight.value)
      );
    }
    if (el.stageElementCopyScale) {
      el.stageElementCopyScale.addEventListener('click', copyStageElementScale);
    }
    if (el.stageElementPasteScale) {
      el.stageElementPasteScale.addEventListener(
        'click',
        pasteStageElementScale
      );
    }
    if (el.stageElementCopySize) {
      el.stageElementCopySize.addEventListener('click', copyStageElementSize);
    }
    if (el.stageElementPasteSize) {
      el.stageElementPasteSize.addEventListener('click', pasteStageElementSize);
    }
    if (el.stageElementToFront) {
      el.stageElementToFront.addEventListener('click', () =>
        moveStageElementStep(1)
      );
    }
    if (el.stageElementToBack) {
      el.stageElementToBack.addEventListener('click', () =>
        moveStageElementStep(-1)
      );
    }
    if (el.stageElementDuplicate) {
      el.stageElementDuplicate.addEventListener(
        'click',
        duplicateSelectedStageElement
      );
    }
    if (el.stageElementCopy) {
      el.stageElementCopy.addEventListener('click', copySelectedStageElement);
    }
    if (el.stageElementPaste) {
      el.stageElementPaste.addEventListener(
        'click',
        pasteStageElementFromClipboard
      );
    }
    if (el.stageElementRemove) {
      el.stageElementRemove.addEventListener(
        'click',
        removeSelectedStageElement
      );
    }
    if (el.stageElements) {
      el.stageElements.addEventListener('click', (event) => {
        if (
          event.target &&
          event.target.closest &&
          event.target.closest('.stage-element')
        )
          return;
        selectStageElement(null);
      });
    }
    document.addEventListener('keydown', (event) => {
      const { key, lower } = getEventKeyData(event);
      if (!key) return;
      if (isEditorModalOpen()) return;
      if (
        !event.altKey &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey &&
        key === '/' &&
        el.stageElementsFilter
      ) {
        const target = event.target;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable)
        ) {
          return;
        }
        event.preventDefault();
        el.stageElementsFilter.focus();
        el.stageElementsFilter.select();
        return;
      }
      if (
        !event.altKey &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey &&
        key === 'Escape' &&
        el.stageElementsFilter &&
        el.stageElementsFilter.value
      ) {
        const target = event.target;
        const isFilterInput = target === el.stageElementsFilter;
        if (
          !isFilterInput &&
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable)
        ) {
          return;
        }
        event.preventDefault();
        state.stageElementsFilter = '';
        el.stageElementsFilter.value = '';
        renderStageElementsList();
        return;
      }
      if (event.altKey && event.shiftKey && key === 'Backspace') {
        const target = event.target;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable)
        ) {
          return;
        }
        event.preventDefault();
        clearStageElementsFilters();
        return;
      }
      if (
        event.altKey &&
        event.shiftKey &&
        (key === 'PageUp' || key === 'PageDown')
      ) {
        const target = event.target;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable)
        ) {
          return;
        }
        event.preventDefault();
        const direction = key === 'PageUp' ? -1 : 1;
        cycleStageElementsPreset(direction);
        return;
      }
      if (event.altKey && event.shiftKey && ['1', '2', '3'].includes(key)) {
        const target = event.target;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable)
        ) {
          return;
        }
        const history = getStageElementsPresetHistory();
        const index = Number(key) - 1;
        const preset = history[index];
        if (preset) {
          event.preventDefault();
          applyStageElementsFilterPreset(preset, true);
        }
        return;
      }
      if (event.altKey && event.shiftKey && key === '0') {
        const target = event.target;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable)
        ) {
          return;
        }
        event.preventDefault();
        clearStageElementsPresetHistory();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'z') {
        const target = event.target;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable)
        ) {
          return;
        }
        event.preventDefault();
        restoreStageElementsPresetHistory();
        return;
      }
      if (!event.ctrlKey && !event.metaKey && !event.altKey && key === 'Tab') {
        const target = event.target;
        if (
          target &&
          (target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.isContentEditable)
        ) {
          return;
        }
        event.preventDefault();
        selectNextStageElement(event.shiftKey ? -1 : 1);
        return;
      }
      if (!state.selectedStageElementId) return;
      const target = event.target;
      if (
        target &&
        (target.tagName === 'INPUT' ||
          target.tagName === 'TEXTAREA' ||
          target.isContentEditable)
      )
        return;
      const modKey = event.ctrlKey || event.metaKey;
      if (modKey && event.altKey && (key === '[' || key === ']')) {
        event.preventDefault();
        moveStageElement(key === ']' ? 1 : -1);
        return;
      }
      if (
        modKey &&
        !event.altKey &&
        !event.shiftKey &&
        (key === '[' || key === ']')
      ) {
        event.preventDefault();
        moveStageElementStep(key === ']' ? 1 : -1);
        return;
      }
      if (modKey && !event.altKey && !event.shiftKey && lower === 'b') {
        event.preventDefault();
        if (state.selectedStageElementId) {
          const selected = getSelectedStageElement();
          if (selected && selected.type === 'text') {
            const weight = selected.fontWeight || 600;
            const weightValue =
              typeof weight === 'string' ? weight.toLowerCase() : weight;
            const isBold =
              weightValue === 'bold' ||
              weightValue === '700' ||
              weightValue >= 600;
            updateStageElementField('fontWeight', isBold ? 400 : 700);
            updateStageElementControls();
          }
        }
        return;
      }
      if (modKey && !event.altKey && !event.shiftKey && lower === 'i') {
        event.preventDefault();
        const selected = getSelectedStageElement();
        if (selected && selected.type === 'text') {
          updateStageElementField(
            'fontStyle',
            selected.fontStyle === 'italic' ? 'normal' : 'italic'
          );
          updateStageElementControls();
        }
        return;
      }
      if (modKey && !event.altKey && !event.shiftKey && lower === 'u') {
        event.preventDefault();
        const selected = getSelectedStageElement();
        if (selected && selected.type === 'text') {
          updateStageElementField(
            'textDecoration',
            selected.textDecoration === 'underline' ? 'none' : 'underline'
          );
          updateStageElementControls();
        }
        return;
      }
      if (modKey && event.shiftKey && !event.altKey && lower === 'f') {
        event.preventDefault();
        if (el.toolbarFontSearch) {
          el.toolbarFontSearch.focus();
          el.toolbarFontSearch.select();
        } else if (el.toolbarFont) {
          el.toolbarFont.focus();
        }
        return;
      }
      if (modKey && event.shiftKey && !event.altKey && lower === 'k') {
        event.preventDefault();
        const selected = getSelectedStageElement();
        if (selected && selected.type === 'text') {
          updateStageElementField('text', (selected.text || '').toUpperCase());
        }
        return;
      }
      if (modKey && event.shiftKey && !event.altKey && lower === 'l') {
        event.preventDefault();
        const selected = getSelectedStageElement();
        if (selected && selected.type === 'text') {
          updateStageElementField('textAlign', 'left');
          updateStageElementControls();
        }
        return;
      }
      if (modKey && event.shiftKey && !event.altKey && lower === 'c') {
        event.preventDefault();
        const selected = getSelectedStageElement();
        if (selected && selected.type === 'text') {
          updateStageElementField('textAlign', 'center');
          updateStageElementControls();
        }
        return;
      }
      if (modKey && event.shiftKey && !event.altKey && lower === 'r') {
        event.preventDefault();
        const selected = getSelectedStageElement();
        if (selected && selected.type === 'text') {
          updateStageElementField('textAlign', 'right');
          updateStageElementControls();
        }
        return;
      }
      if (
        modKey &&
        event.shiftKey &&
        !event.altKey &&
        (key === '.' || key === '>')
      ) {
        event.preventDefault();
        const selected = getSelectedStageElement();
        if (selected && selected.type === 'text') {
          const next = Math.min(200, (selected.fontSize || 32) + 1);
          updateStageElementNumeric('fontSize', next);
          updateStageElementControls();
        }
        return;
      }
      if (
        modKey &&
        event.shiftKey &&
        !event.altKey &&
        (key === ',' || key === '<')
      ) {
        event.preventDefault();
        const selected = getSelectedStageElement();
        if (selected && selected.type === 'text') {
          const next = Math.max(8, (selected.fontSize || 32) - 1);
          updateStageElementNumeric('fontSize', next);
          updateStageElementControls();
        }
        return;
      }
      if (modKey && event.altKey && lower === 'c') {
        event.preventDefault();
        copyStageElementStyle();
        return;
      }
      if (modKey && event.altKey && lower === 'v') {
        event.preventDefault();
        pasteStageElementStyle();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'l') {
        event.preventDefault();
        const selectedList = getSelectedStageElements();
        if (selectedList.length) {
          const nextValue = !selectedList.every((element) => element.locked);
          selectedList.forEach((element) => {
            element.locked = nextValue;
          });
          renderStageElements();
          renderStageElementsList();
          updateStageElementControls();
          scheduleAutosave();
        }
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'r') {
        event.preventDefault();
        resetStageElementsRotation();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 's') {
        event.preventDefault();
        resetStageElementsScale();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'p') {
        event.preventDefault();
        resetStageElementsPosition();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'a') {
        event.preventDefault();
        copyStageElementStageAlign();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'v') {
        event.preventDefault();
        pasteStageElementStageAlign();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'c') {
        event.preventDefault();
        copyStageElementRotation();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'x') {
        event.preventDefault();
        pasteStageElementRotation();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'o') {
        event.preventDefault();
        copyStageElementOpacity();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'u') {
        event.preventDefault();
        pasteStageElementOpacity();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'w') {
        event.preventDefault();
        copyStageElementScale();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'e') {
        event.preventDefault();
        pasteStageElementScale();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 't') {
        event.preventDefault();
        tidyStageElements();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'y') {
        event.preventDefault();
        pasteStageElementPosition();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'h') {
        event.preventDefault();
        copyStageElementVisibility();
        return;
      }
      if (event.altKey && event.shiftKey && lower === 'j') {
        event.preventDefault();
        pasteStageElementVisibility();
        return;
      }
      if (event.altKey && event.shiftKey && key === 'ArrowUp') {
        event.preventDefault();
        moveStageElement(1);
        return;
      }
      if (event.altKey && event.shiftKey && key === 'ArrowDown') {
        event.preventDefault();
        moveStageElement(-1);
        return;
      }
      if (
        !event.altKey &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey &&
        lower === 'h'
      ) {
        event.preventDefault();
        if (state.selectedStageElementId) {
          toggleStageElementVisibility(state.selectedStageElementId);
        }
        return;
      }
      if (event.altKey && lower === 'l') {
        event.preventDefault();
        const selectedList = getSelectedStageElements();
        if (selectedList.length) {
          const nextValue = !selectedList.every(
            (element) => element.aspectLocked
          );
          selectedList.forEach((element) => {
            element.aspectLocked = nextValue;
          });
          syncStageAspectLockState(selectedList);
          renderStageSelectionBox();
        }
        return;
      }
      if (
        (event.ctrlKey || event.metaKey) &&
        !event.altKey &&
        !event.shiftKey &&
        hasDomTextSelection() &&
        (lower === 'c' || lower === 'x')
      ) {
        return;
      }
      if ((event.ctrlKey || event.metaKey) && lower === 'd') {
        event.preventDefault();
        duplicateSelectedStageElement();
        return;
      }
      if ((event.ctrlKey || event.metaKey) && lower === 'c') {
        event.preventDefault();
        copySelectedStageElement();
        return;
      }
      if ((event.ctrlKey || event.metaKey) && lower === 'v') {
        event.preventDefault();
        pasteStageElementFromClipboard();
        return;
      }
      if (event.altKey && !event.shiftKey && !event.ctrlKey && !event.metaKey) {
        if (key === '[') {
          event.preventDefault();
          jumpStageKeyframe('prev');
          return;
        }
        if (key === ']') {
          event.preventDefault();
          jumpStageKeyframe('next');
          return;
        }
      }
      if (
        event.altKey &&
        !event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey &&
        lower === 's'
      ) {
        event.preventDefault();
        if (state.selectedStageElementId) {
          state.stageKeyframeSoloId =
            state.stageKeyframeSoloId === state.selectedStageElementId
              ? null
              : state.selectedStageElementId;
          renderStageKeyframeList();
          renderStageElements();
        }
        return;
      }
      const step = event.shiftKey ? 5 : 1;
      if (key === 'ArrowUp') {
        event.preventDefault();
        nudgeStageElement(0, -step);
      } else if (key === 'ArrowDown') {
        event.preventDefault();
        nudgeStageElement(0, step);
      } else if (key === 'ArrowLeft') {
        event.preventDefault();
        nudgeStageElement(-step, 0);
      } else if (key === 'ArrowRight') {
        event.preventDefault();
        nudgeStageElement(step, 0);
      } else if (key === 'Delete' || key === 'Backspace') {
        event.preventDefault();
        removeSelectedStageElement();
      }
    });
    if (el.serverRender) {
      el.serverRender.addEventListener('click', () => queueServerRender(false));
    }
    if (el.serverPublish) {
      el.serverPublish.addEventListener('click', () => queueServerRender(true));
    }
    if (el.historyRestoreLatest) {
      el.historyRestoreLatest.addEventListener('click', restoreLatestHistory);
    }
    if (el.historyClear) {
      el.historyClear.addEventListener('click', clearHistory);
    }
    if (el.historyList) {
      el.historyList.addEventListener('click', handleHistoryAction);
    }
    if (el.timelineZoom) {
      el.timelineZoom.addEventListener('input', () => {
        setTimelineZoom(parseInt(el.timelineZoom.value, 10) || 80);
      });
    }
    if (el.timelineZoomOut) {
      el.timelineZoomOut.addEventListener('click', () => {
        setTimelineZoom((state.timelineScale || 80) / 1.2);
      });
    }
    if (el.timelineZoomIn) {
      el.timelineZoomIn.addEventListener('click', () => {
        setTimelineZoom((state.timelineScale || 80) * 1.2);
      });
    }
    if (el.timelineHistoryToggle) {
      el.timelineHistoryToggle.addEventListener('click', () => {
        if (!el.timelineHistoryPanel) return;
        const isVisible = el.timelineHistoryPanel.style.display === 'block';
        el.timelineHistoryPanel.style.display = isVisible ? 'none' : 'block';
        if (!isVisible) renderTimelineHistoryPanel();
      });
    }
    if (el.globalHistoryToggle) {
      el.globalHistoryToggle.addEventListener('click', () => {
        if (!el.globalHistoryPanel) return;
        const isVisible = el.globalHistoryPanel.style.display === 'block';
        el.globalHistoryPanel.style.display = isVisible ? 'none' : 'block';
        if (!isVisible) renderGlobalHistoryPanel();
      });
    }
    if (el.timelineRemoveGaps) {
      el.timelineRemoveGaps.addEventListener('click', removeTimelineGaps);
    }
    if (el.globalHistoryExport) {
      el.globalHistoryExport.addEventListener('click', () =>
        exportGlobalHistory(false)
      );
    }
    if (el.globalHistoryExportCsv) {
      el.globalHistoryExportCsv.addEventListener('click', () =>
        exportGlobalHistory(true)
      );
    }
    if (el.timelineHistoryExport) {
      el.timelineHistoryExport.addEventListener('click', () =>
        exportTimelineHistory(false)
      );
    }
    if (el.timelineHistoryExportCsv) {
      el.timelineHistoryExportCsv.addEventListener('click', () =>
        exportTimelineHistory(true)
      );
    }
    window.addEventListener('keydown', (event) => {
      if (!event.defaultPrevented) {
        if (event.key === 'Alt') {
          clipVisualizerAltDown = true;
          if (clipVisualizerHover) {
            const clip = state.clips.find(
              (item) => item.id === clipVisualizerHover.clipId
            );
            updateClipVisualizerTooltipTitle(
              clip,
              clipVisualizerHover.tooltip,
              true
            );
          }
        }
      }
      if (isEditorModalOpen()) return;
      const active = document.activeElement;
      const pinFocus = !!(
        el.inspectorPinFields &&
        active &&
        el.inspectorPinFields.contains(active)
      );
      if (
        event.altKey &&
        event.shiftKey &&
        (event.key === 'r' || event.key === 'R')
      ) {
        if (!pinFocus) return;
        const row = active.closest('.inspector-pins-row');
        if (!row) return;
        const key = row.dataset.pinKey;
        if (
          !key ||
          !Object.prototype.hasOwnProperty.call(INSPECTOR_PIN_DEFAULTS, key)
        )
          return;
        event.preventDefault();
        updateClipField(key, INSPECTOR_PIN_DEFAULTS[key]);
        requestAnimationFrame(() => {
          if (!el.inspectorPinFields) return;
          const nextRow = el.inspectorPinFields.querySelector(
            `.inspector-pins-row[data-pin-key="${key}"]`
          );
          const input = nextRow ? nextRow.querySelector('input') : null;
          if (input) {
            input.focus();
            if (typeof input.select === 'function') {
              input.select();
            }
          }
        });
        return;
      }
      if (
        event.altKey &&
        event.shiftKey &&
        (event.key === 'p' || event.key === 'P')
      ) {
        if (!el.inspectorPinFields) return;
        const inputs = Array.from(
          el.inspectorPinFields.querySelectorAll('input')
        );
        if (!inputs.length) return;
        event.preventDefault();
        const current = pinFocus ? inputs.indexOf(active) : -1;
        const next = current >= 0 ? (current + 1) % inputs.length : 0;
        const input = inputs[next];
        if (input) {
          input.focus();
          if (typeof input.select === 'function') {
            input.select();
          }
        }
        return;
      }
      if (!(event.altKey && (event.key === 'p' || event.key === 'P'))) return;
      if (isEditableTarget(active) && !pinFocus) return;
      if (!el.inspectorPinFields) return;
      const firstInput = el.inspectorPinFields.querySelector('input');
      if (!firstInput) return;
      event.preventDefault();
      firstInput.focus();
      if (typeof firstInput.select === 'function') {
        firstInput.select();
      }
    });
    window.addEventListener('keyup', (event) => {
      if (event.key === 'Alt') {
        clipVisualizerAltDown = false;
        if (clipVisualizerHover) {
          const clip = state.clips.find(
            (item) => item.id === clipVisualizerHover.clipId
          );
          updateClipVisualizerTooltipTitle(
            clip,
            clipVisualizerHover.tooltip,
            false
          );
        }
      }
    });
    if (el.timelineWaveform) {
      el.timelineWaveform.addEventListener('mousedown', startWaveformScrub);
      el.timelineWaveform.addEventListener('click', scrubFromWaveformEvent);
      window.addEventListener('mousemove', moveWaveformScrub);
      window.addEventListener('mouseup', endWaveformScrub);
    }
    if (el.exportWebm) {
      el.exportWebm.addEventListener('click', () =>
        exportProject('webm', false)
      );
    }
    if (el.exportMp4) {
      el.exportMp4.addEventListener('click', () => exportProject('mp4', false));
    }
    if (el.publishGallery) {
      el.publishGallery.addEventListener('click', () =>
        exportProject('mp4', true)
      );
    }
    if (el.exportOpen) {
      el.exportOpen.addEventListener('click', () => toggleExportSettings(true));
    }
    if (el.exportSettingsClose) {
      el.exportSettingsClose.addEventListener('click', () =>
        toggleExportSettings(false)
      );
    }
    if (el.shareOpen) {
      el.shareOpen.addEventListener('click', () => toggleShareModal(true));
    }
    if (el.shareModalClose) {
      el.shareModalClose.addEventListener('click', () =>
        toggleShareModal(false)
      );
    }
    bindEditorModal(el.shareModal, () => toggleShareModal(false));
    if (el.sharePublishGallery) {
      el.sharePublishGallery.addEventListener('click', sharePublishToGallery);
    }
    if (el.shareCopyLink) {
      el.shareCopyLink.addEventListener('click', () => {
        if (shareGalleryUrl && navigator.clipboard) {
          navigator.clipboard
            .writeText(shareGalleryUrl)
            .then(() => notify('Link copied', 'success'))
            .catch(() => {});
        }
      });
    }
    document.querySelectorAll('[data-share-platform]').forEach((btn) => {
      btn.addEventListener('click', () =>
        openShareLink(btn.dataset.sharePlatform)
      );
    });
    if (el.youtubeConnectBtn) {
      el.youtubeConnectBtn.addEventListener('click', () => {
        window.open(
          '/api/youtube/auth',
          'youtube-auth',
          'width=600,height=700'
        );
      });
    }
    window.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'youtube-connected')
        checkYouTubeConnection();
    });
    if (el.youtubeUploadBtn) {
      el.youtubeUploadBtn.addEventListener('click', uploadToYouTube);
    }
    if (el.youtubeBackBtn) {
      el.youtubeBackBtn.addEventListener('click', () => {
        if (el.shareStepYoutube) el.shareStepYoutube.style.display = 'none';
        if (el.shareStepLinks) el.shareStepLinks.style.display = '';
      });
    }
    if (el.exportStart) {
      el.exportStart.addEventListener('click', () => {
        const fmt = state.exportSettings.format || 'mp4';
        if (el.exportProgress) el.exportProgress.style.display = 'block';
        if (el.exportProgressBar) el.exportProgressBar.style.width = '0%';
        exportProject(fmt, false);
      });
    }
    document.querySelectorAll('[data-export-res]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.exportSettings.resolution = btn.dataset.exportRes;
        syncExportSettingsUI();
      });
    });
    document.querySelectorAll('[data-export-bitrate]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.exportSettings.bitrate = parseInt(btn.dataset.exportBitrate, 10);
        syncExportSettingsUI();
      });
    });
    document.querySelectorAll('[data-export-format]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.exportSettings.format = btn.dataset.exportFormat;
        syncExportSettingsUI();
      });
    });
    document.querySelectorAll('[data-export-platform]').forEach((btn) => {
      btn.addEventListener('click', () => {
        state.exportSettings.resolution = btn.dataset.exportRes;
        state.exportSettings.bitrate = parseInt(btn.dataset.exportBitrate, 10);
        state.exportSettings.format = btn.dataset.exportFormat;
        syncExportSettingsUI();
      });
    });
    if (el.timelineList) {
      el.timelineList.addEventListener('click', handleTimelineAction);
      el.timelineList.addEventListener(
        'contextmenu',
        handleTimelineContextMenu
      );
      el.timelineList.addEventListener(
        'touchstart',
        handleTimelineLongPressStart,
        { passive: true }
      );
      el.timelineList.addEventListener(
        'touchmove',
        handleTimelineLongPressMove,
        { passive: true }
      );
      el.timelineList.addEventListener('touchend', handleTimelineLongPressEnd);
      el.timelineList.addEventListener(
        'touchcancel',
        handleTimelineLongPressEnd
      );
      el.timelineList.addEventListener('touchstart', startTimelinePinch, {
        passive: false,
      });
      el.timelineList.addEventListener('touchmove', moveTimelinePinch, {
        passive: false,
      });
      el.timelineList.addEventListener('touchend', endTimelinePinch);
      el.timelineList.addEventListener('touchcancel', endTimelinePinch);
      el.timelineList.addEventListener(
        'mousedown',
        handleClipVisualizerScrubStart
      );
      el.timelineList.addEventListener('mousemove', handleTimelineTimeHover);
      el.timelineList.addEventListener('mousemove', handleClipVisualizerHover);
      el.timelineList.addEventListener('mousemove', handleTimelineVideoHover);
      el.timelineList.addEventListener('mouseleave', () => {
        handleClipVisualizerHoverLeave();
        hideTimelineVideoHover();
        hideTimelineTimeGhost();
      });
      el.timelineList.addEventListener('pointerdown', handleTimelineHandleDown);
      el.timelineList.addEventListener('mousedown', handleTimelineHandleDown);
      el.timelineList.addEventListener('touchstart', handleTimelineHandleDown, {
        passive: false,
      });
      el.timelineList.addEventListener(
        'pointerdown',
        handleTimelineClipPointerDown
      );
      el.timelineList.addEventListener('pointerdown', handleTimelineMarqueeStart);
      el.timelineList.addEventListener('dragstart', handleTimelineDragStart);
      el.timelineList.addEventListener('dragover', handleTimelineDragOver);
      el.timelineList.addEventListener('drop', handleTimelineDrop);
      el.timelineList.addEventListener('dragleave', handleTimelineDragLeave);
      el.timelineList.addEventListener('dragend', handleTimelineDragEnd);
      el.timelineList.addEventListener('scroll', () => {
        closeTimelineContextMenu();
        closeTimelineTrackMenu();
        hideTimelineVideoHover();
        hideTimelineTimeGhost();
      });
      el.timelineList.addEventListener(
        'wheel',
        () => {
          if (timelinePinchActive) {
            timelinePinchActive = false;
            timelinePinchStartDistance = 0;
          }
        },
        { passive: true }
      );
    }
    if (el.timelineContextMenu) {
      el.timelineContextMenu.addEventListener(
        'touchstart',
        handleTimelineSheetDragStart,
        { passive: true }
      );
      el.timelineContextMenu.addEventListener(
        'touchmove',
        handleTimelineSheetDragMove,
        { passive: true }
      );
      el.timelineContextMenu.addEventListener(
        'touchend',
        handleTimelineSheetDragEnd
      );
      el.timelineContextMenu.addEventListener(
        'touchcancel',
        handleTimelineSheetDragEnd
      );
    }
    if (el.timelineTrackMenu) {
      el.timelineTrackMenu.addEventListener(
        'touchstart',
        handleTimelineSheetDragStart,
        { passive: true }
      );
      el.timelineTrackMenu.addEventListener(
        'touchmove',
        handleTimelineSheetDragMove,
        { passive: true }
      );
      el.timelineTrackMenu.addEventListener(
        'touchend',
        handleTimelineSheetDragEnd
      );
      el.timelineTrackMenu.addEventListener(
        'touchcancel',
        handleTimelineSheetDragEnd
      );
    }
    if (el.timelineMarkerMenu) {
      el.timelineMarkerMenu.addEventListener(
        'touchstart',
        handleTimelineSheetDragStart,
        { passive: true }
      );
      el.timelineMarkerMenu.addEventListener(
        'touchmove',
        handleTimelineSheetDragMove,
        { passive: true }
      );
      el.timelineMarkerMenu.addEventListener(
        'touchend',
        handleTimelineSheetDragEnd
      );
      el.timelineMarkerMenu.addEventListener(
        'touchcancel',
        handleTimelineSheetDragEnd
      );
    }
    if (el.timelineContextOverlay) {
      el.timelineContextOverlay.addEventListener('click', () => {
        closeTimelineContextMenu();
        closeTimelineTrackMenu();
        closeTimelineMarkerMenu();
      });
    }
    if (el.timelineContextMenu) {
      el.timelineContextMenu.addEventListener('click', (event) => {
        const transitionButton = event.target.closest('[data-transition]');
        if (transitionButton) {
          applyTransitionToSelection(
            transitionButton.dataset.transition || 'none'
          );
          closeTimelineContextMenu();
          return;
        }
        const comboButton = event.target.closest('[data-transition-combo]');
        if (comboButton) {
          applyTransitionComboToSelection(
            comboButton.dataset.transitionDuration || '0.6',
            comboButton.dataset.transitionEase || 'linear'
          );
          closeTimelineContextMenu();
          return;
        }
        const presetButton = event.target.closest('[data-transition-preset]');
        if (presetButton) {
          const duration = presetButton.dataset.transitionPreset || '0';
          applyTransitionToSelection('crossfade');
          applyTransitionDurationToSelection(duration);
          closeTimelineContextMenu();
          return;
        }
        const durationButton = event.target.closest(
          '[data-transition-duration]'
        );
        if (durationButton) {
          applyTransitionDurationToSelection(
            durationButton.dataset.transitionDuration || '0'
          );
          closeTimelineContextMenu();
          return;
        }
        const easeButton = event.target.closest('[data-transition-ease]');
        if (easeButton) {
          applyTransitionEaseToSelection(
            easeButton.dataset.transitionEase || 'linear'
          );
          closeTimelineContextMenu();
          return;
        }
        const resetButton = event.target.closest('[data-transition-none-ease]');
        if (resetButton) {
          applyTransitionResetToSelection(
            resetButton.dataset.transitionNoneEase || 'linear'
          );
          closeTimelineContextMenu();
          return;
        }
        const actionButton = event.target.closest('[data-context-action]');
        if (actionButton) {
          const action = actionButton.dataset.contextAction;
          if (action === 'copy') {
            copyTimelineSelectionToClipboard();
            lastTimelineClipMenuSection = 'paste';
          } else if (action === 'duplicate') {
            duplicateTimelineSelection();
            lastTimelineClipQuickAction = 'duplicate';
          } else if (action === 'split') {
            splitTimelineSelectionAtPlayhead();
            lastTimelineClipQuickAction = 'split';
          } else if (action === 'transitions') {
            openTransitionsPanelForSelection();
            return;
          } else if (action === 'remove') {
            removeTimelineSelection();
          } else if (action === 'remove-gaps') {
            removeTimelineGaps();
          }
          closeTimelineContextMenu();
        }
        const pasteGapButton = event.target.closest('[data-context-paste-gap]');
        if (pasteGapButton) {
          const gap = parseFloat(pasteGapButton.dataset.contextPasteGap);
          pasteTimelineClipboardSpaced(state.playhead || 0, gap);
          lastTimelineClipMenuSection = 'paste';
          lastTimelineClipQuickAction = 'paste';
          closeTimelineContextMenu();
        }
      });
    }
    if (el.timelineTrackMenu) {
      el.timelineTrackMenu.addEventListener('click', (event) => {
        const button = event.target.closest('[data-track-action]');
        if (!button) return;
        const action = button.dataset.trackAction;
        if (action === 'paste') {
          lastTimelineTrackMenuSection = 'paste';
          pasteTimelineClipboard(timelineTrackContextTime || 0);
          lastTimelineTrackQuickAction = 'paste';
        } else if (action === 'paste-spaced') {
          lastTimelineTrackMenuSection = 'paste';
          const gap = button.dataset.gapDuration
            ? parseFloat(button.dataset.gapDuration)
            : 0;
          pasteTimelineClipboardSpaced(timelineTrackContextTime || 0, gap);
          lastTimelineTrackQuickAction = 'paste';
        } else if (action === 'paste-playhead') {
          lastTimelineTrackMenuSection = 'paste';
          pasteTimelineClipboard(state.playhead || 0);
          lastTimelineTrackQuickAction = 'paste';
        } else if (action === 'paste-spaced-playhead') {
          lastTimelineTrackMenuSection = 'paste';
          const gap = button.dataset.gapDuration
            ? parseFloat(button.dataset.gapDuration)
            : 0;
          pasteTimelineClipboardSpaced(state.playhead || 0, gap);
          lastTimelineTrackQuickAction = 'paste';
        } else if (action === 'add-marker') {
          if (timelineRememberSubmenu) {
            lastTimelineTrackMenuSection = 'markers';
          }
          lastTimelineTrackQuickAction = 'marker';
          addTimelineMarkerAtTime(timelineTrackContextTime || 0);
          renderTimelineMarkerList();
        } else if (action === 'add-marker-snap') {
          if (timelineRememberSubmenu) {
            lastTimelineTrackMenuSection = 'markers';
          }
          lastTimelineTrackQuickAction = 'marker';
          const snapped = snapTimelineMarkerTime(timelineTrackContextTime || 0);
          addTimelineMarkerAtTime(snapped);
          renderTimelineMarkerList();
        } else if (action === 'insert-gap') {
          if (timelineRememberSubmenu) {
            lastTimelineTrackMenuSection = 'gaps';
          }
          lastTimelineTrackQuickAction = 'gap';
          let gap = null;
          if (button.dataset.gapDuration) {
            gap = parseFloat(button.dataset.gapDuration);
          } else {
            const input = window.prompt('Insert gap duration (seconds)', '1.0');
            if (input === null) return;
            gap = parseFloat(input);
          }
          if (!Number.isFinite(gap) || gap <= 0) {
            notify('Invalid gap duration', 'error');
            closeTimelineTrackMenu();
            return;
          }
          insertTimelineGapAtTime(timelineTrackContextTime || 0, gap);
        } else if (action === 'insert-gap-playhead') {
          if (timelineRememberSubmenu) {
            lastTimelineTrackMenuSection = 'gaps';
          }
          const gap = button.dataset.gapDuration
            ? parseFloat(button.dataset.gapDuration)
            : 1.0;
          if (!Number.isFinite(gap) || gap <= 0) {
            notify('Invalid gap duration', 'error');
            closeTimelineTrackMenu();
            return;
          }
          insertTimelineGapAtTime(state.playhead || 0, gap);
        } else if (action === 'remove-gaps') {
          if (timelineRememberSubmenu) {
            lastTimelineTrackMenuSection = 'gaps';
          }
          removeTimelineGaps();
        }
        closeTimelineTrackMenu();
      });
    }
    if (el.timelineMarkerMenu) {
      el.timelineMarkerMenu.addEventListener('click', (event) => {
        const button = event.target.closest('[data-marker-action]');
        if (!button) return;
        const markers = normalizeTimelineMarkers(state.timelineMarkers);
        const target = markers[timelineMarkerContextIndex];
        if (!target) {
          closeTimelineMarkerMenu();
          return;
        }
        const action = button.dataset.markerAction;
        if (action === 'jump') {
          lastTimelineMarkerQuickAction = 'jump';
          state.playhead = Math.max(0, target.time);
          renderFrameAt(state.playhead);
          updateTimeLabel();
        } else if (action === 'delete') {
          lastTimelineMarkerQuickAction = 'delete';
          markers.splice(timelineMarkerContextIndex, 1);
          state.timelineMarkers = markers;
          renderTimeline();
          scheduleAutosave();
        }
        closeTimelineMarkerMenu();
      });
    }
    if (el.timelineMarkerAdd) {
      el.timelineMarkerAdd.addEventListener('click', () => {
        addTimelineMarkerAtTime(state.playhead || 0);
        renderTimelineMarkerList();
      });
    }
    if (el.timelineMarkerClear) {
      el.timelineMarkerClear.addEventListener('click', () => {
        state.timelineMarkers = [];
        renderTimeline();
        scheduleAutosave();
      });
    }
    const selectionDuplicate = getEl('timeline-selection-duplicate');
    if (selectionDuplicate)
      selectionDuplicate.addEventListener('click', () =>
        duplicateTimelineSelection()
      );
    const selectionSplit = getEl('timeline-selection-split');
    if (selectionSplit)
      selectionSplit.addEventListener('click', () =>
        splitTimelineSelectionAtPlayhead()
      );
    const selectionDelete = getEl('timeline-selection-delete');
    if (selectionDelete)
      selectionDelete.addEventListener('click', () =>
        removeTimelineSelection()
      );
    if (el.timelineMarkerList) {
      el.timelineMarkerList.addEventListener('keydown', (event) => {
        if (event.target instanceof HTMLInputElement) return;
        const markers = normalizeTimelineMarkers(state.timelineMarkers);
        if (!markers.length) return;
        let index = timelineMarkerListFocusIndex;
        if (index == null || index < 0 || index >= markers.length) {
          index = 0;
        }
        let nextIndex = index;
        if (event.key === 'ArrowDown') {
          nextIndex = Math.min(markers.length - 1, index + 1);
        } else if (event.key === 'ArrowUp') {
          nextIndex = Math.max(0, index - 1);
        } else if (event.key === 'Enter' || event.key === ' ') {
          state.playhead = Math.max(0, markers[index].time);
          renderFrameAt(state.playhead);
          updateTimeLabel();
          event.preventDefault();
          return;
        } else if (event.key === 'Delete' || event.key === 'Backspace') {
          const nextMarkers = normalizeTimelineMarkers(state.timelineMarkers);
          nextMarkers.splice(index, 1);
          state.timelineMarkers = nextMarkers;
          timelineMarkerListFocusIndex = nextMarkers.length
            ? Math.min(index, nextMarkers.length - 1)
            : null;
          renderTimeline();
          scheduleAutosave();
          event.preventDefault();
          return;
        } else {
          return;
        }
        timelineMarkerListFocusIndex = nextIndex;
        state.playhead = Math.max(0, markers[nextIndex].time);
        renderFrameAt(state.playhead);
        updateTimeLabel();
        renderTimelineMarkerList();
        event.preventDefault();
      });
    }
    if (el.assetList) {
      el.assetList.addEventListener('click', handleAssetAction);
      el.assetList.addEventListener('keydown', (e) => {
        const focusedId = document.activeElement
          ?.closest?.('.asset-item')
          ?.getAttribute('data-asset-id');
        if (focusedId && (e.key === 'Delete' || e.key === 'Backspace')) {
          e.preventDefault();
          removeAssetById(focusedId);
          return;
        }
        if (
          focusedId &&
          (e.ctrlKey || e.metaKey) &&
          (e.key === 'c' || e.key === 'x')
        ) {
          const asset = state.assets.find((item) => item.id === focusedId);
          if (asset && asset.src) {
            e.preventDefault();
            copyAssetToClipboard(asset).finally(() => {
              if (e.key === 'x') removeAssetById(focusedId);
            });
            return;
          }
        }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')
          return;
        const items = el.assetList.querySelectorAll('.asset-item');
        if (!items.length) return;
        const idx = Array.prototype.indexOf.call(items, document.activeElement);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          items[idx < items.length - 1 ? idx + 1 : 0].focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          items[idx > 0 ? idx - 1 : items.length - 1].focus();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          document.activeElement.click();
        }
      });
    }
    if (el.clipName) {
      el.clipName.addEventListener('input', () =>
        updateClipField('name', el.clipName.value)
      );
    }
    if (el.clipDuration) {
      el.clipDuration.addEventListener('input', () =>
        updateClipField('duration', el.clipDuration.value)
      );
    }
    if (el.clipCaptionText) {
      el.clipCaptionText.addEventListener('input', () =>
        updateClipField('text', el.clipCaptionText.value)
      );
    }
    if (el.clipCaptionFontSize) {
      el.clipCaptionFontSize.addEventListener('input', () =>
        updateClipField('captionFontSize', el.clipCaptionFontSize.value)
      );
    }
    if (el.clipCaptionColor) {
      el.clipCaptionColor.addEventListener('input', () =>
        updateClipField('captionColor', el.clipCaptionColor.value)
      );
    }
    document.querySelectorAll('[data-caption-color]').forEach((button) => {
      button.addEventListener('click', () =>
        updateClipField('captionColor', button.dataset.captionColor)
      );
    });
    if (el.clipCaptionAlign) {
      el.clipCaptionAlign.addEventListener('change', () =>
        updateClipField('captionAlign', el.clipCaptionAlign.value)
      );
    }
    if (el.clipCaptionY) {
      el.clipCaptionY.addEventListener('input', () =>
        updateClipField('captionY', el.clipCaptionY.value)
      );
    }
    if (el.clipTrimStart) {
      el.clipTrimStart.addEventListener('input', () =>
        updateClipField('trimStart', el.clipTrimStart.value)
      );
    }
    if (el.clipTrimEnd) {
      el.clipTrimEnd.addEventListener('input', () =>
        updateClipField('trimEnd', el.clipTrimEnd.value)
      );
    }
    if (el.clipTrimStartRange) {
      el.clipTrimStartRange.addEventListener('input', () =>
        updateClipField('trimStart', el.clipTrimStartRange.value)
      );
    }
    if (el.clipTrimEndRange) {
      el.clipTrimEndRange.addEventListener('input', () =>
        updateClipField('trimEnd', el.clipTrimEndRange.value)
      );
    }
    if (el.clipTrimReset) {
      el.clipTrimReset.addEventListener('click', () => {
        updateClipField('trimStart', 0);
        updateClipField('trimEnd', 0);
      });
    }
    if (el.clipSpeed) {
      el.clipSpeed.addEventListener('input', () =>
        updateClipField('speed', el.clipSpeed.value)
      );
    }
    if (el.clipSpeedRange) {
      el.clipSpeedRange.addEventListener('input', () =>
        updateClipField('speed', el.clipSpeedRange.value)
      );
    }
    if (el.clipSpeedRampAdd) {
      el.clipSpeedRampAdd.addEventListener('click', () => addSpeedKeyframe());
    }
    if (el.clipSpeedRampClear) {
      el.clipSpeedRampClear.addEventListener('click', () =>
        clearSpeedKeyframes()
      );
    }
    if (el.clipSpeedRampPreset) {
      el.clipSpeedRampPreset.addEventListener('change', () =>
        applySpeedRampPreset(el.clipSpeedRampPreset.value)
      );
    }
    if (el.clipAudioGain) {
      el.clipAudioGain.addEventListener('input', () =>
        updateClipField('audioGain', el.clipAudioGain.value)
      );
    }
    if (el.clipAudioGainEnd) {
      el.clipAudioGainEnd.addEventListener('input', () =>
        updateClipField('audioGainEnd', el.clipAudioGainEnd.value)
      );
    }
    if (el.clipAudioGainKeyframeAdd) {
      el.clipAudioGainKeyframeAdd.addEventListener('click', () =>
        addAudioGainKeyframe()
      );
    }
    if (el.clipAudioGainEaseIn) {
      el.clipAudioGainEaseIn.addEventListener('click', () =>
        applyAudioKeyframePreset('gain', 'ease-in')
      );
    }
    if (el.clipAudioGainEaseOut) {
      el.clipAudioGainEaseOut.addEventListener('click', () =>
        applyAudioKeyframePreset('gain', 'ease-out')
      );
    }
    if (el.clipAudioGainEaseInOut) {
      el.clipAudioGainEaseInOut.addEventListener('click', () =>
        applyAudioKeyframePreset('gain', 'ease-in-out')
      );
    }
    if (el.clipAudioGainClear) {
      el.clipAudioGainClear.addEventListener('click', () =>
        clearAudioKeyframes('gain')
      );
    }
    if (el.clipAudioGainFadeIn) {
      el.clipAudioGainFadeIn.addEventListener('click', () =>
        applyAudioGainPreset('fade-in')
      );
    }
    if (el.clipAudioGainFadeOut) {
      el.clipAudioGainFadeOut.addEventListener('click', () =>
        applyAudioGainPreset('fade-out')
      );
    }
    if (el.clipAudioGainFadeInOut) {
      el.clipAudioGainFadeInOut.addEventListener('click', () =>
        applyAudioGainPreset('fade-in-out')
      );
    }
    if (el.clipAudioPan) {
      el.clipAudioPan.addEventListener('input', () =>
        updateClipField('audioPan', el.clipAudioPan.value)
      );
    }
    if (el.clipAudioPanEnd) {
      el.clipAudioPanEnd.addEventListener('input', () =>
        updateClipField('audioPanEnd', el.clipAudioPanEnd.value)
      );
    }
    if (el.clipAudioPanKeyframeAdd) {
      el.clipAudioPanKeyframeAdd.addEventListener('click', () =>
        addAudioPanKeyframe()
      );
    }
    if (el.clipAudioPanEaseIn) {
      el.clipAudioPanEaseIn.addEventListener('click', () =>
        applyAudioKeyframePreset('pan', 'ease-in')
      );
    }
    if (el.clipAudioPanEaseOut) {
      el.clipAudioPanEaseOut.addEventListener('click', () =>
        applyAudioKeyframePreset('pan', 'ease-out')
      );
    }
    if (el.clipAudioPanEaseInOut) {
      el.clipAudioPanEaseInOut.addEventListener('click', () =>
        applyAudioKeyframePreset('pan', 'ease-in-out')
      );
    }
    if (el.clipAudioPanClear) {
      el.clipAudioPanClear.addEventListener('click', () =>
        clearAudioKeyframes('pan')
      );
    }
    if (el.clipAudioPanLeftRight) {
      el.clipAudioPanLeftRight.addEventListener('click', () =>
        applyAudioPanPreset('left-right')
      );
    }
    if (el.clipAudioPanRightLeft) {
      el.clipAudioPanRightLeft.addEventListener('click', () =>
        applyAudioPanPreset('right-left')
      );
    }
    if (el.clipAudioGainPresetSave) {
      el.clipAudioGainPresetSave.addEventListener('click', () =>
        saveAutomationPreset('gain')
      );
    }
    if (el.clipAudioGainPresetApply) {
      el.clipAudioGainPresetApply.addEventListener('click', () =>
        applyAutomationPreset('gain')
      );
    }
    if (el.clipAudioGainPresetRename) {
      el.clipAudioGainPresetRename.addEventListener('click', () =>
        renameAutomationPreset('gain')
      );
    }
    if (el.clipAudioGainPresetDelete) {
      el.clipAudioGainPresetDelete.addEventListener('click', () =>
        deleteAutomationPreset('gain')
      );
    }
    if (el.clipAudioPanPresetSave) {
      el.clipAudioPanPresetSave.addEventListener('click', () =>
        saveAutomationPreset('pan')
      );
    }
    if (el.clipAudioPanPresetApply) {
      el.clipAudioPanPresetApply.addEventListener('click', () =>
        applyAutomationPreset('pan')
      );
    }
    if (el.clipAudioPanPresetRename) {
      el.clipAudioPanPresetRename.addEventListener('click', () =>
        renameAutomationPreset('pan')
      );
    }
    if (el.clipAudioPanPresetDelete) {
      el.clipAudioPanPresetDelete.addEventListener('click', () =>
        deleteAutomationPreset('pan')
      );
    }
    if (el.automationPresetsExport) {
      el.automationPresetsExport.addEventListener(
        'click',
        exportAutomationPresets
      );
    }
    if (el.automationPresetsImport) {
      el.automationPresetsImport.addEventListener('click', () => {
        if (el.automationPresetsImportInput) {
          el.automationPresetsImportInput.click();
        }
      });
    }
    if (el.automationPresetsCopy) {
      el.automationPresetsCopy.addEventListener(
        'click',
        copyAutomationPresetsToClipboard
      );
    }
    if (el.automationPresetsPaste) {
      el.automationPresetsPaste.addEventListener(
        'click',
        pasteAutomationPresetsFromClipboard
      );
    }
    if (el.automationPresetsLink) {
      el.automationPresetsLink.addEventListener(
        'click',
        copyAutomationPresetsLink
      );
    }
    if (el.automationPresetsQr) {
      el.automationPresetsQr.addEventListener('click', () =>
        openAutomationPresetsQr()
      );
    }
    if (el.automationPresetsImportInput) {
      el.automationPresetsImportInput.addEventListener(
        'change',
        handleAutomationPresetImport
      );
    }
    if (el.automationPresetsClear) {
      el.automationPresetsClear.addEventListener(
        'click',
        clearAutomationPresets
      );
    }
    if (el.automationQrBackdrop) {
      el.automationQrBackdrop.addEventListener('click', (event) => {
        if (event.target === el.automationQrBackdrop)
          closeAutomationPresetsQr();
      });
    }
    if (el.automationQrClose) {
      el.automationQrClose.addEventListener('click', () =>
        closeAutomationPresetsQr()
      );
    }
    if (el.clipAutomationPreview) {
      el.clipAutomationPreview.addEventListener(
        'mousedown',
        startAutomationDrag
      );
      window.addEventListener('mousemove', moveAutomationDrag);
      window.addEventListener('mouseup', endAutomationDrag);
    }
    if (el.clipAutomationGridToggle) {
      el.clipAutomationGridToggle.addEventListener('change', () => {
        state.showAutomationBeatGrid = !!el.clipAutomationGridToggle.checked;
        drawClipAutomationPreview(getSelectedClip());
        scheduleAutosave();
      });
    }
    if (el.automationUndoRedo) {
      el.automationUndoRedo.addEventListener('click', () => {
        redoAutomation();
      });
    }
    if (el.automationHistoryToggle) {
      el.automationHistoryToggle.addEventListener('click', () => {
        if (!el.automationHistoryPanel) return;
        const isVisible = el.automationHistoryPanel.style.display === 'block';
        el.automationHistoryPanel.style.display = isVisible ? 'none' : 'block';
        if (!isVisible) renderAutomationHistoryPanel();
      });
    }
    if (el.automationHistoryFilter) {
      el.automationHistoryFilter.addEventListener('change', () =>
        renderAutomationHistoryPanel()
      );
    }
    if (el.automationHistoryClipFilter) {
      el.automationHistoryClipFilter.addEventListener('change', () =>
        renderAutomationHistoryPanel()
      );
    }
    if (el.automationHistorySearch) {
      el.automationHistorySearch.addEventListener('input', () =>
        renderAutomationHistoryPanel()
      );
      el.automationHistorySearch.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          if (event.shiftKey && el.automationHistoryFiltersClear) {
            event.preventDefault();
            el.automationHistoryFiltersClear.click();
            return;
          }
          event.preventDefault();
          el.automationHistorySearch.value = '';
          saveAutomationHistoryFilter();
          renderAutomationHistoryPanel();
        } else if (event.key === 'Backspace' && event.altKey) {
          event.preventDefault();
          el.automationHistorySearch.value = '';
          saveAutomationHistoryFilter();
          renderAutomationHistoryPanel();
        }
      });
    }
    if (el.automationHistorySearchClear) {
      el.automationHistorySearchClear.addEventListener('click', () => {
        if (el.automationHistorySearch) el.automationHistorySearch.value = '';
        saveAutomationHistoryFilter();
        renderAutomationHistoryPanel();
      });
    }
    if (el.automationHistoryFiltersClear) {
      el.automationHistoryFiltersClear.addEventListener('click', () => {
        if (el.automationHistoryFilter)
          el.automationHistoryFilter.value = 'all';
        if (el.automationHistoryClipFilter)
          el.automationHistoryClipFilter.value = 'all';
        if (el.automationHistorySearch) el.automationHistorySearch.value = '';
        if (el.automationHistoryShowAll)
          el.automationHistoryShowAll.checked = false;
        saveAutomationHistoryFilter();
        renderAutomationHistoryPanel();
      });
    }
    if (el.automationHistoryBadgesToggle) {
      el.automationHistoryBadgesToggle.addEventListener('click', () =>
        toggleAutomationHistoryBadges()
      );
    }
    if (el.automationHistoryShowAll) {
      el.automationHistoryShowAll.addEventListener('change', () => {
        saveAutomationHistoryFilter();
        renderAutomationHistoryPanel();
      });
    }
    if (el.automationHistoryUndo) {
      el.automationHistoryUndo.addEventListener('click', () =>
        undoAutomation()
      );
    }
    if (el.automationHistoryRedo) {
      el.automationHistoryRedo.addEventListener('click', () =>
        redoAutomation()
      );
    }
    if (el.automationHistoryClear) {
      el.automationHistoryClear.addEventListener('click', () =>
        clearAutomationHistory()
      );
    }
    if (el.automationHistoryExport) {
      el.automationHistoryExport.addEventListener('click', () =>
        exportAutomationHistory()
      );
    }
    if (el.automationHistoryExportCsv) {
      el.automationHistoryExportCsv.addEventListener('click', () =>
        exportAutomationHistory(true)
      );
    }
    window.addEventListener('keydown', handleAutomationKeydown);
    window.addEventListener('keydown', handleTimelineKeydown);
    if (el.clipAudioMute) {
      el.clipAudioMute.addEventListener('change', () =>
        updateClipField('audioMute', el.clipAudioMute.checked)
      );
    }
    if (el.clipAudioSolo) {
      el.clipAudioSolo.addEventListener('change', () =>
        updateClipField('audioSolo', el.clipAudioSolo.checked)
      );
    }
    if (el.clipAudioFadeIn) {
      el.clipAudioFadeIn.addEventListener('input', () =>
        updateClipField('audioFadeIn', el.clipAudioFadeIn.value)
      );
    }
    if (el.clipAudioFadeOut) {
      el.clipAudioFadeOut.addEventListener('input', () =>
        updateClipField('audioFadeOut', el.clipAudioFadeOut.value)
      );
    }
    if (el.clipTransitionIn) {
      el.clipTransitionIn.addEventListener('change', () =>
        updateClipField('transitionIn', el.clipTransitionIn.value)
      );
    }
    if (el.clipTransitionOut) {
      el.clipTransitionOut.addEventListener('change', () =>
        updateClipField('transitionOut', el.clipTransitionOut.value)
      );
    }
    if (el.clipTransitionDuration) {
      el.clipTransitionDuration.addEventListener('input', () =>
        updateClipField('transitionDuration', el.clipTransitionDuration.value)
      );
    }
    if (el.transitionDirectionButtons) {
      el.transitionDirectionButtons.forEach((button) => {
        button.addEventListener('click', () =>
          setTransitionPanelDirection(button.dataset.transitionDirection)
        );
      });
    }
    if (el.transitionGrid) {
      el.transitionGrid.addEventListener('click', (event) => {
        const button = event.target.closest('[data-transition-choice]');
        if (!button || button.disabled) return;
        applyTransitionToSelection(button.dataset.transitionChoice || 'none', {
          direction: transitionPanelDirection,
        });
        renderFrameAt(state.playhead);
      });
    }
    if (el.transitionPanelDuration) {
      el.transitionPanelDuration.addEventListener('input', () =>
        handleTransitionPanelDuration(el.transitionPanelDuration.value)
      );
    }
    if (el.transitionPanelDurationValue) {
      el.transitionPanelDurationValue.addEventListener('input', () =>
        handleTransitionPanelDuration(el.transitionPanelDurationValue.value)
      );
    }
    if (el.transitionEaseButtons) {
      el.transitionEaseButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          applyTransitionEaseToSelection(
            button.dataset.transitionPanelEase || 'linear'
          );
          renderFrameAt(state.playhead);
        });
      });
    }
    if (el.transitionPanelReset) {
      el.transitionPanelReset.addEventListener('click', () => {
        applyTransitionResetToSelection('linear');
        renderFrameAt(state.playhead);
      });
    }
    if (el.searchKindButtons && el.searchKindButtons.length) {
      el.searchKindButtons.forEach((btn) => {
        btn.addEventListener('click', () =>
          setSearchKind(btn.dataset.searchKind || 'images')
        );
      });
    }
    if (el.searchSubmit) {
      el.searchSubmit.addEventListener('click', searchAssets);
    }
    if (el.searchOpenSharedArt) {
      el.searchOpenSharedArt.addEventListener('click', openSharedArtDialog);
    }
    if (el.searchQuery) {
      el.searchQuery.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          searchAssets();
        }
      });
    }
    if (el.audioCategoryChips && el.audioCategoryChips.length) {
      el.audioCategoryChips.forEach((chip) => {
        chip.addEventListener('click', () => {
          el.audioCategoryChips.forEach((c) => c.classList.remove('active'));
          chip.classList.add('active');
          const cat = chip.dataset.audioCategory || '';
          if (el.audioSearchQuery) el.audioSearchQuery.value = cat;
          searchAudioTab();
        });
      });
    }
    if (el.audioSearchSubmit) {
      el.audioSearchSubmit.addEventListener('click', searchAudioTab);
    }
    if (el.audioSearchQuery) {
      el.audioSearchQuery.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          searchAudioTab();
        }
      });
    }
    if (el.audioSearchResults) {
      el.audioSearchResults.addEventListener(
        'keydown',
        handleAudioResultsKeydown
      );
    }
    if (el.audioGenerateSubmit) {
      el.audioGenerateSubmit.addEventListener('click', submitGeneratedMusicJob);
    }
    if (el.audioGeneratePrompt) {
      el.audioGeneratePrompt.addEventListener('keydown', (event) => {
        if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
          event.preventDefault();
          submitGeneratedMusicJob();
        }
      });
    }
    if (el.audioGenerateOpenEditor) {
      el.audioGenerateOpenEditor.addEventListener('click', () => {
        window.open('/tools/music-generator', '_blank');
      });
    }
    if (el.captionsGenerate) {
      el.captionsGenerate.addEventListener('click', generateCaptionClips);
    }
    if (el.captionsClear) {
      el.captionsClear.addEventListener('click', () => {
        if (!getCaptionClips().length) {
          setCaptionStatus('No caption clips to clear');
          return;
        }
        clearCaptionClips();
        setCaptionStatus('Caption clips cleared', 'success');
      });
    }
    if (el.keyboardShortcutsClose) {
      el.keyboardShortcutsClose.addEventListener('click', () =>
        toggleKeyboardShortcuts(false)
      );
    }
    var shortcutsSearchEl = getEl('shortcuts-search');
    if (shortcutsSearchEl) {
      shortcutsSearchEl.addEventListener('input', function () {
        renderShortcutsList(shortcutsSearchEl.value);
      });
    }
    if (el.aiRa1Prompt) {
      el.aiRa1Prompt.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          searchAiModalArt();
        }
      });
    }
    if (el.aiRa1Generate) {
      el.aiRa1Generate.addEventListener('click', generateRa1Asset);
    }
    if (el.aiComfyGenerate) {
      el.aiComfyGenerate.addEventListener('click', generateComfyAsset);
    }
    if (el.aiLtx3Generate) {
      el.aiLtx3Generate.addEventListener('click', generateLtx3Asset);
    }
    if (el.aiLtx3UseSelected) {
      el.aiLtx3UseSelected.addEventListener('click', applySelectedImageToLtx3);
    }
    if (el.aiLtx3Mode) {
      el.aiLtx3Mode.addEventListener('change', () => {
        if (el.aiLtx3Image) {
          el.aiLtx3Image.style.display =
            el.aiLtx3Mode.value === 'image-to-video' ? 'block' : 'none';
        }
      });
    }
    if (el.aiH3Generate) {
      el.aiH3Generate.addEventListener('click', generateH3Asset);
    }
    if (el.aiH3UseSelected) {
      el.aiH3UseSelected.addEventListener('click', () =>
        applySelectedImageToInput(el.aiH3Image)
      );
    }
    if (el.aiH3EndUseSelected) {
      el.aiH3EndUseSelected.addEventListener('click', () =>
        applySelectedImageToInput(el.aiH3EndImage)
      );
    }
    if (el.aiH3Mode) {
      el.aiH3Mode.addEventListener('change', () => {
        const show = el.aiH3Mode.value === 'image-to-video' ? 'block' : 'none';
        if (el.aiH3Image) el.aiH3Image.style.display = show;
        if (el.aiH3EndImage) el.aiH3EndImage.style.display = show;
      });
    }
    [el.aiLtx3Image, el.aiH3Image].forEach((input) => {
      if (!input) return;
      input.addEventListener('input', () =>
        syncAiReferencePreviewFromInput(input)
      );
    });
    [el.aiH3Image, el.aiH3EndImage].forEach((input) => {
      if (!input) return;
      bindAiImageInputDrop(input);
    });
    if (el.aiReferenceClear) {
      el.aiReferenceClear.addEventListener('click', (event) => {
        event.stopPropagation();
        clearAiReferenceImage();
      });
    }
    if (el.aiReferencePanel) {
      el.aiReferencePanel.addEventListener('click', () => {
        if (el.aiReferenceFile) el.aiReferenceFile.click();
      });
    }
    if (el.aiReferenceFile) {
      el.aiReferenceFile.addEventListener('change', () => {
        const file = el.aiReferenceFile.files && el.aiReferenceFile.files[0];
        el.aiReferenceFile.value = '';
        if (!file) return;
        uploadReferenceImageToR2(file).catch((err) => {
          const detail = err && err.message ? `: ${err.message}` : '';
          notify(`au${detail}`, 'error');
        });
      });
    }
    if (el.aiReferencePanel) {
      ['dragenter', 'dragover'].forEach((type) => {
        el.aiReferencePanel.addEventListener(type, (event) => {
          if (!hasAiReferenceDropPayload(event.dataTransfer)) return;
          event.preventDefault();
          event.stopPropagation();
          event.dataTransfer.dropEffect = 'copy';
          el.aiReferencePanel.classList.add('drag-over');
        });
      });
      el.aiReferencePanel.addEventListener('dragleave', (event) => {
        if (el.aiReferencePanel.contains(event.relatedTarget)) return;
        el.aiReferencePanel.classList.remove('drag-over');
      });
      el.aiReferencePanel.addEventListener('drop', (event) => {
        if (!hasAiReferenceDropPayload(event.dataTransfer)) return;
        event.preventDefault();
        event.stopPropagation();
        el.aiReferencePanel.classList.remove('drag-over');
        applyDroppedImageToAiReference(event.dataTransfer).catch(() => {
          notify('Failed to use reference image', 'error');
        });
      });
    }
    bindAiPromptAutocomplete(el.aiRa1Prompt);
    bindAiPromptAutocomplete(el.aiLtx3Prompt);
  }

  function getAiPromptAutocompleteToken(value) {
    const text = String(value || '');
    const match = text.match(/(?:^|[\s,])([^,\s]*)$/);
    const token = match ? match[1] : text;
    return {
      token,
      lower: token.toLowerCase(),
      prefix: text.slice(0, text.length - token.length),
    };
  }

  function getAiPromptWordList() {
    if (window.WordFrequencyLoader) {
      if (!window.WordFrequencyLoader.isLoaded()) {
        window.WordFrequencyLoader.load();
        return [];
      }
      return window.WordFrequencyLoader.getSorted();
    }
    if (Array.isArray(window.top_used_words_sorted))
      return window.top_used_words_sorted;
    if (window.top_used_words && typeof window.top_used_words === 'object') {
      return Object.keys(window.top_used_words).sort(
        (a, b) =>
          (window.top_used_words[b] || 0) - (window.top_used_words[a] || 0)
      );
    }
    return [];
  }

  function getAiPromptFrequency(word) {
    if (window.WordFrequencyLoader && window.WordFrequencyLoader.isLoaded()) {
      return window.WordFrequencyLoader.getFrequency(word) || 0;
    }
    return window.top_used_words && window.top_used_words[word]
      ? window.top_used_words[word]
      : 0;
  }

  function buildAiPromptSuggestions(value) {
    const token = getAiPromptAutocompleteToken(value);
    if (!token.lower) return [];
    const used = new Set(
      String(value || '')
        .toLowerCase()
        .split(/[\s,]+/)
        .filter(Boolean)
    );
    const suggestions = [];
    const words = getAiPromptWordList();
    for (let i = 0; i < words.length; i += 1) {
      const word = words[i];
      if (!word || word.length > 30) continue;
      const lower = word.toLowerCase();
      if (used.has(lower)) continue;
      if (!lower.startsWith(token.lower) || lower.length <= token.lower.length)
        continue;
      suggestions.push({
        word,
        value: token.prefix + word,
        suffix: word.slice(token.token.length),
        frequency: getAiPromptFrequency(word),
      });
      if (suggestions.length >= 8) break;
    }
    return suggestions;
  }

  function ensureAiPromptAutocompleteMenu() {
    if (aiPromptAutocompleteMenu) return aiPromptAutocompleteMenu;
    aiPromptAutocompleteMenu = document.createElement('div');
    aiPromptAutocompleteMenu.className = 'ai-prompt-autocomplete-menu';
    document.addEventListener('pointerdown', (event) => {
      if (
        aiPromptAutocompleteMenu &&
        !aiPromptAutocompleteMenu.contains(event.target) &&
        event.target !== aiPromptAutocompleteInput
      ) {
        hideAiPromptAutocomplete();
      }
    });
    return aiPromptAutocompleteMenu;
  }

  function positionAiPromptAutocompleteMenu() {
    if (!aiPromptAutocompleteMenu || !aiPromptAutocompleteInput) return;
    const host =
      aiPromptAutocompleteInput.closest('.twitter-typeahead') ||
      aiPromptAutocompleteInput;
    if (aiPromptAutocompleteMenu.previousElementSibling !== host) {
      host.insertAdjacentElement('afterend', aiPromptAutocompleteMenu);
    }
  }

  function hideAiPromptAutocomplete() {
    if (aiPromptAutocompleteMenu) {
      aiPromptAutocompleteMenu.classList.remove('open');
      aiPromptAutocompleteMenu.innerHTML = '';
    }
    aiPromptAutocompleteItems = [];
    aiPromptAutocompleteIndex = -1;
    aiPromptGhostValue = '';
    if (aiPromptGhostLayer) aiPromptGhostLayer.classList.remove('on');
  }

  function setAiPromptAutocompleteIndex(index) {
    aiPromptAutocompleteIndex = index;
    if (!aiPromptAutocompleteMenu) return;
    aiPromptAutocompleteMenu
      .querySelectorAll('.ai-prompt-autocomplete-item')
      .forEach((item, itemIndex) => {
        item.classList.toggle('active', itemIndex === index);
      });
    updateAiPromptGhost();
  }

  function applyAiPromptAutocompleteItem(item) {
    if (!aiPromptAutocompleteInput || !item) return;
    aiPromptAutocompleteInput.value = item.value;
    aiPromptAutocompleteInput.dispatchEvent(
      new Event('input', { bubbles: true })
    );
    hideAiPromptAutocomplete();
    aiPromptAutocompleteInput.focus();
  }

  function ensureAiPromptGhost(input) {
    if (!aiPromptGhostLayer) {
      aiPromptGhostLayer = document.createElement('div');
      aiPromptGhostLayer.className = 'ai-prompt-typeahead-ghost';
      aiPromptGhostLayer.setAttribute('aria-hidden', 'true');
      const typed = document.createElement('span');
      typed.className = 'ai-prompt-ghost-typed';
      const suffix = document.createElement('span');
      suffix.className = 'ai-prompt-ghost-suffix';
      aiPromptGhostLayer.appendChild(typed);
      aiPromptGhostLayer.appendChild(suffix);
    }
    let wrap = input.parentElement;
    if (!wrap || !wrap.classList.contains('ai-prompt-typeahead-wrap')) {
      wrap = document.createElement('div');
      wrap.className = 'ai-prompt-typeahead-wrap';
      input.parentNode.insertBefore(wrap, input);
      wrap.appendChild(input);
    }
    if (aiPromptGhostLayer.parentElement !== wrap) {
      wrap.insertBefore(aiPromptGhostLayer, input);
      const cs = getComputedStyle(input);
      [
        'fontFamily',
        'fontSize',
        'fontWeight',
        'fontStyle',
        'fontVariantLigatures',
        'lineHeight',
        'letterSpacing',
        'textTransform',
        'textAlign',
        'textIndent',
        'paddingTop',
        'paddingRight',
        'paddingBottom',
        'paddingLeft',
        'borderTopWidth',
        'borderRightWidth',
        'borderBottomWidth',
        'borderLeftWidth',
        'boxSizing',
      ].forEach((prop) => {
        aiPromptGhostLayer.style[prop] = cs[prop];
      });
    }
    return aiPromptGhostLayer;
  }

  function activeAiPromptAutocompleteItem() {
    return (
      aiPromptAutocompleteItems[
        aiPromptAutocompleteIndex >= 0 ? aiPromptAutocompleteIndex : 0
      ] || null
    );
  }

  function updateAiPromptGhost() {
    if (!aiPromptGhostLayer || !aiPromptAutocompleteInput) return;
    const input = aiPromptAutocompleteInput;
    const item = activeAiPromptAutocompleteItem();
    aiPromptGhostValue = item ? item.value : '';
    aiPromptGhostLayer.classList.toggle('on', Boolean(item));
    if (!item) return;
    aiPromptGhostLayer.firstChild.textContent = input.value;
    aiPromptGhostLayer.lastChild.textContent = item.suffix;
  }

  function acceptAiPromptGhost() {
    const item = activeAiPromptAutocompleteItem();
    if (!aiPromptGhostValue || !item) return false;
    applyAiPromptAutocompleteItem(item);
    return true;
  }

  function showAiPromptAutocomplete(input) {
    const menu = ensureAiPromptAutocompleteMenu();
    aiPromptAutocompleteInput = input;
    aiPromptAutocompleteItems = buildAiPromptSuggestions(input.value);
    aiPromptAutocompleteIndex = -1;
    if (!aiPromptAutocompleteItems.length) {
      hideAiPromptAutocomplete();
      return;
    }
    menu.innerHTML = '';
    const token = getAiPromptAutocompleteToken(input.value);
    aiPromptAutocompleteItems.forEach((item, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ai-prompt-autocomplete-item';
      const label = document.createElement('span');
      label.appendChild(document.createTextNode(token.prefix + token.token));
      const suffix = document.createElement('strong');
      suffix.textContent = item.suffix;
      label.appendChild(suffix);
      button.appendChild(label);
      button.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        applyAiPromptAutocompleteItem(item);
      });
      button.addEventListener('mouseenter', () =>
        setAiPromptAutocompleteIndex(index)
      );
      menu.appendChild(button);
    });
    menu.classList.add('open');
    positionAiPromptAutocompleteMenu();
    ensureAiPromptGhost(input);
    updateAiPromptGhost();
  }

  function bindAiPromptAutocomplete(input) {
    if (!input || input.dataset.aiPromptAutocompleteBound === '1') return;
    input.dataset.aiPromptAutocompleteBound = '1';
    input.addEventListener('input', () => showAiPromptAutocomplete(input));
    input.addEventListener('focus', () => showAiPromptAutocomplete(input));
    input.addEventListener('blur', () => {
      aiPromptGhostValue = '';
      if (aiPromptGhostLayer) aiPromptGhostLayer.classList.remove('on');
    });
    input.addEventListener('keydown', (event) => {
      if (!aiPromptAutocompleteItems.length) return;
      if (event.key === 'Tab' && !event.shiftKey && !event.isComposing) {
        if (acceptAiPromptGhost()) event.preventDefault();
        return;
      }
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setAiPromptAutocompleteIndex(
          (aiPromptAutocompleteIndex + 1) % aiPromptAutocompleteItems.length
        );
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setAiPromptAutocompleteIndex(
          (aiPromptAutocompleteIndex - 1 + aiPromptAutocompleteItems.length) %
            aiPromptAutocompleteItems.length
        );
      } else if (event.key === 'Enter' && aiPromptAutocompleteIndex >= 0) {
        event.preventDefault();
        applyAiPromptAutocompleteItem(
          aiPromptAutocompleteItems[aiPromptAutocompleteIndex]
        );
      } else if (event.key === 'Escape') {
        hideAiPromptAutocomplete();
      }
    });
  }

  function handleAssetUpload(event) {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;
    files.forEach((file, index) => {
      addAssetFromFile(file, {
        persistToMedia: true,
        addToTimeline: true,
        timelineTime: Math.max(0, (state.playhead || 0) + index * 0.1),
      }).catch(() => {
        notify(`Failed to add ${file.name || 'file'}`, 'error');
      });
    });
    event.target.value = '';
  }

  function handleFolderUpload(event) {
    const files = Array.from(event.target.files || []);
    if (!files.length) return;
    Promise.all(
      files.map((file) =>
        addAssetFromFile(file, { persistToMedia: true }).catch(() => {
          notify(`Failed to add ${file.name || 'file'}`, 'error');
        })
      )
    ).then(() => {
      notify(
        files.length > 1
          ? `Imported ${files.length} files to your library`
          : `Imported ${files[0].name || '1 file'} to your library`
      );
    });
    event.target.value = '';
  }

  async function startSelfRecord() {
    if (recordRecorder) return;
    const media = navigator.mediaDevices;
    if (!media) {
      notify(
        window.isSecureContext
          ? 'Recording not supported in this browser'
          : 'Recording requires HTTPS',
        'error'
      );
      return;
    }
    const source = el.assetRecordSource ? el.assetRecordSource.value : 'camera';
    recordSourceKind = source;
    try {
      if (source === 'screen') {
        if (!media.getDisplayMedia) {
          notify('Screen recording not supported in this browser', 'error');
          return;
        }
        const displayStream = await media.getDisplayMedia({
          video: true,
          audio: true,
        });
        let micStream = null;
        if (media.getUserMedia) {
          try {
            micStream = await media.getUserMedia({ audio: true });
          } catch {}
          try {
            recordFaceStream = await media.getUserMedia({
              video: {
                width: { ideal: 640 },
                height: { ideal: 640 },
              },
              audio: false,
            });
          } catch {}
        }
        const tracks = [
          ...displayStream.getVideoTracks(),
          ...displayStream.getAudioTracks(),
          ...(micStream ? micStream.getAudioTracks() : []),
        ];
        recordStream = new MediaStream(
          tracks.length ? tracks : displayStream.getTracks()
        );
        const videoTrack = displayStream.getVideoTracks()[0];
        if (videoTrack) {
          videoTrack.addEventListener('ended', () => stopSelfRecord());
        }
      } else {
        if (!media.getUserMedia) {
          notify('Camera recording not supported in this browser', 'error');
          return;
        }
        recordStream = await media.getUserMedia({ video: true, audio: true });
      }
      recordChunks = [];
      recordFaceChunks = [];
      recordRecorder = createVideoMediaRecorder(recordStream);
      recordRecorder.addEventListener('dataavailable', (event) => {
        if (event.data && event.data.size > 0) {
          recordChunks.push(event.data);
        }
      });
      if (recordFaceStream && recordFaceStream.getVideoTracks().length) {
        recordFaceRecorder = createVideoMediaRecorder(recordFaceStream);
        recordFaceRecorder.addEventListener('dataavailable', (event) => {
          if (event.data && event.data.size > 0) {
            recordFaceChunks.push(event.data);
          }
        });
      }
      recordRecorder.addEventListener('stop', async () => {
        const blob = new Blob(recordChunks, { type: 'video/webm' });
        const file = new File(
          [blob],
          `${source === 'screen' ? 'screen-recording' : 'record-yourself'}-${Date.now()}.webm`,
          {
            type: 'video/webm',
          }
        );
        const addToTimeline = el.assetRecordAddToStage
          ? el.assetRecordAddToStage.checked
          : true;
        const screenAsset = await addVideoAsset(file, {
          select: true,
          addToTimeline,
        });
        if (
          addToTimeline &&
          screenAsset &&
          source === 'screen' &&
          recordFaceChunks.length
        ) {
          await addFaceBubbleRecording(recordFaceChunks);
        }
        notify(
          addToTimeline
            ? source === 'screen'
              ? 'Screen recording added with removable face bubble'
              : 'Recording added to timeline'
            : 'Recording added to assets',
          'success'
        );
        recordChunks = [];
        recordFaceChunks = [];
      });
      recordRecorder.start(200);
      if (recordFaceRecorder) recordFaceRecorder.start(200);
      if (el.assetRecord) el.assetRecord.disabled = true;
      if (el.assetRecordStop) el.assetRecordStop.disabled = false;
      if (el.assetRecordSource) el.assetRecordSource.disabled = true;
      document
        .querySelectorAll('input[name="asset-record-source-mode"]')
        .forEach((input) => {
          input.disabled = true;
        });
    } catch (err) {
      notify('Unable to start recording', 'error');
      cleanupSelfRecordStreams();
      if (el.assetRecord) el.assetRecord.disabled = false;
      if (el.assetRecordStop) el.assetRecordStop.disabled = true;
      if (el.assetRecordSource) el.assetRecordSource.disabled = false;
      document
        .querySelectorAll('input[name="asset-record-source-mode"]')
        .forEach((input) => {
          input.disabled = false;
        });
    }
  }

  function createVideoMediaRecorder(stream) {
    if (
      window.MediaRecorder &&
      MediaRecorder.isTypeSupported &&
      MediaRecorder.isTypeSupported('video/webm;codecs=vp9,opus')
    ) {
      return new MediaRecorder(stream, {
        mimeType: 'video/webm;codecs=vp9,opus',
      });
    }
    if (
      window.MediaRecorder &&
      MediaRecorder.isTypeSupported &&
      MediaRecorder.isTypeSupported('video/webm')
    ) {
      return new MediaRecorder(stream, { mimeType: 'video/webm' });
    }
    return new MediaRecorder(stream);
  }

  async function addFaceBubbleRecording(chunks) {
    const blob = new Blob(chunks, { type: 'video/webm' });
    if (!blob.size) return null;
    const file = new File([blob], `face-bubble-${Date.now()}.webm`, {
      type: 'video/webm',
    });
    const asset = await addVideoAsset(file, { select: false });
    if (!asset) return null;
    const aspect =
      state.resolution.width / Math.max(1, state.resolution.height);
    const w = 16;
    const h = Math.min(40, w * aspect);
    return addStageElement({
      type: 'video',
      name: 'Face bubble',
      src: asset.src,
      assetId: asset.id,
      x: 4,
      y: Math.max(4, 100 - h - 5),
      w,
      h,
      circleClip: true,
    });
  }

  function cleanupSelfRecordStreams() {
    if (recordStream) {
      recordStream.getTracks().forEach((track) => track.stop());
    }
    if (recordFaceStream) {
      recordFaceStream.getTracks().forEach((track) => track.stop());
    }
    recordStream = null;
    recordRecorder = null;
    recordFaceStream = null;
    recordFaceRecorder = null;
  }

  function stopSelfRecord() {
    if (!recordRecorder) return;
    const mainRecorder = recordRecorder;
    const faceRecorder = recordFaceRecorder;
    try {
      mainRecorder.requestData();
      if (faceRecorder) faceRecorder.requestData();
    } catch {}
    function cleanup() {
      cleanupSelfRecordStreams();
      if (el.assetRecord) el.assetRecord.disabled = false;
      if (el.assetRecordStop) el.assetRecordStop.disabled = true;
      if (el.assetRecordSource) el.assetRecordSource.disabled = false;
      document
        .querySelectorAll('input[name="asset-record-source-mode"]')
        .forEach((input) => {
          input.disabled = false;
        });
    }
    function stopMainRecorder() {
      try {
        if (mainRecorder && mainRecorder.state !== 'inactive') {
          mainRecorder.stop();
        }
      } catch {}
    }
    if (mainRecorder) {
      mainRecorder.addEventListener('stop', cleanup, { once: true });
    }
    if (faceRecorder && faceRecorder.state !== 'inactive') {
      faceRecorder.addEventListener('stop', stopMainRecorder, { once: true });
      try {
        faceRecorder.stop();
      } catch {
        stopMainRecorder();
      }
    } else {
      stopMainRecorder();
    }
  }

  async function persistMediaFile(file) {
    const type = String((file && file.type) || '').toLowerCase();
    if (
      !type.startsWith('image/') &&
      !type.startsWith('video/') &&
      !type.startsWith('audio/')
    ) {
      return null;
    }
    const uploaded = await uploadMediaToBucket(file);
    if (uploaded && uploaded.url) {
      upsertStoredFsSidebarEntry(uploaded);
      refreshFsSidebarEntries();
    }
    return uploaded;
  }

  function applyPersistedAssetUpload(asset, uploaded) {
    if (!asset || !uploaded) return;
    const mediaUrl = resolveFsEntryUrl(uploaded);
    if (!mediaUrl) return;
    asset.persistedSrc = mediaUrl;
    asset.fsPath = uploaded.path || uploaded.objectPath || uploaded.url || '';
    asset.uploading = false;
    if (asset.type !== 'audio') {
      asset.src = mediaUrl;
      state.clips.forEach((clip) => {
        if (clip.assetId !== asset.id) return;
        clip.src = mediaUrl;
        clip.persistedSrc = mediaUrl;
      });
    }
    renderAssetList();
    renderTimeline();
    scheduleAutosave();
  }

  function queueBackgroundMediaPersist(asset, file) {
    if (!asset || !(file instanceof File) || asset.uploading) return;
    asset.uploading = true;
    asset.uploadError = '';
    renderAssetList();
    persistMediaFile(file)
      .then((uploaded) => {
        if (!uploaded) {
          asset.uploading = false;
          renderAssetList();
          return;
        }
        applyPersistedAssetUpload(asset, uploaded);
      })
      .catch(() => {
        asset.uploading = false;
        asset.uploadError = 'upload-failed';
        renderAssetList();
      });
  }

  function buildCaptionAudioOutputName(name) {
    const base =
      String(name || 'video')
        .replace(/\.[a-z0-9]+$/i, '')
        .replace(/[^a-z0-9_-]+/gi, '-')
        .replace(/^-+|-+$/g, '') || 'video';
    return `${base}-captions.webm`;
  }

  function queueVideoCaptionAudioExtraction(asset, file) {
    if (!asset || asset.type !== 'video' || asset.captionAudioPromise)
      return asset?.captionAudioPromise || null;
    asset.captionAudioStatus = 'pending';
    asset.captionAudioPromise = (async () => {
      try {
        const sourceBlob = file || (await fetchAssetBlob(asset));
        const { ffmpeg, module } = await getFfmpegInstance();
        const inputName = `caption_input_${Date.now()}_${Math.random().toString(16).slice(2)}.mp4`;
        const outputName = `caption_output_${Date.now()}_${Math.random().toString(16).slice(2)}.webm`;
        const data = await module.fetchFile(sourceBlob);
        ffmpeg.FS('writeFile', inputName, data);
        await ffmpeg.run(
          '-i',
          inputName,
          '-vn',
          '-ac',
          '1',
          '-c:a',
          'libopus',
          '-b:a',
          '48k',
          outputName
        );
        const output = ffmpeg.FS('readFile', outputName);
        ffmpeg.FS('unlink', inputName);
        ffmpeg.FS('unlink', outputName);
        const audioBlob = new Blob([output.buffer], { type: 'audio/webm' });
        asset.captionAudioFile = new File(
          [audioBlob],
          buildCaptionAudioOutputName(asset.name),
          { type: 'audio/webm' }
        );
        asset.captionAudioUrl = URL.createObjectURL(audioBlob);
        asset.captionAudioStatus = 'ready';
        renderCaptionPanel();
        return asset.captionAudioFile;
      } catch (_) {
        asset.captionAudioStatus = 'error';
        return null;
      } finally {
        asset.captionAudioPromise = null;
      }
    })();
    return asset.captionAudioPromise;
  }

  async function importScreenRecording() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('import') !== 'screen-recording') return;
    try {
      const db = await new Promise((resolve, reject) => {
        const req = indexedDB.open('sr_transfer', 1);
        req.onupgradeneeded = () => req.result.createObjectStore('blobs');
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
      });
      const tx = db.transaction('blobs', 'readonly');
      const blob = await new Promise((resolve, reject) => {
        const req = tx.objectStore('blobs').get('screen-recording');
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
      });
      db.close();
      if (blob) {
        const file = new File(
          [blob],
          'screen-recording-' + Date.now() + '.webm',
          { type: blob.type || 'video/webm' }
        );
        await addVideoAsset(file, { select: true, addToStage: true });
        notify('Screen recording imported', 'success');
        const delDb = await new Promise((resolve, reject) => {
          const req = indexedDB.open('sr_transfer', 1);
          req.onsuccess = () => resolve(req.result);
          req.onerror = () => reject(req.error);
        });
        const delTx = delDb.transaction('blobs', 'readwrite');
        delTx.objectStore('blobs').delete('screen-recording');
        delDb.close();
      }
      const url = new URL(window.location);
      url.searchParams.delete('import');
      window.history.replaceState({}, '', url);
    } catch (e) {
      notify('Could not import screen recording', 'error');
    }
  }

  async function importFeedUpload() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('import') !== 'feed-upload') return;
    try {
      const db = await new Promise((resolve, reject) => {
        const request = indexedDB.open('feed_editor_transfer', 1);
        request.onupgradeneeded = () =>
          request.result.createObjectStore('files');
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      });
      const file = await new Promise((resolve, reject) => {
        const request = db
          .transaction('files', 'readonly')
          .objectStore('files')
          .get('media');
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
      });
      if (file) {
        await addAssetFromFile(file, {
          select: true,
          addToTimeline: true,
          addToStage: true,
        });
        const tx = db.transaction('files', 'readwrite');
        tx.objectStore('files').delete('media');
        await new Promise((resolve) => {
          tx.oncomplete = resolve;
          tx.onerror = resolve;
        });
        notify('Feed upload imported. Press ? for shortcuts.', 'success');
      }
      db.close();
      const url = new URL(window.location);
      url.searchParams.delete('import');
      window.history.replaceState({}, '', url);
    } catch (_) {
      notify('Could not import feed upload', 'error');
    }
  }

  async function addAssetFromFile(file, options = {}) {
    const type = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();
    var videoExts = ['.mp4', '.webm', '.mov', '.m4v', '.avi', '.mkv', '.ogv'];
    var audioExts = ['.mp3', '.wav', '.ogg', '.aac', '.m4a', '.flac', '.wma'];
    var imageExts = [
      '.png',
      '.jpg',
      '.jpeg',
      '.webp',
      '.gif',
      '.bmp',
      '.svg',
      '.ico',
      '.tiff',
    ];
    var isVideo =
      type.startsWith('video/') ||
      videoExts.some(function (e) {
        return name.endsWith(e);
      });
    var isAudio =
      type.startsWith('audio/') ||
      audioExts.some(function (e) {
        return name.endsWith(e);
      });
    var isImage =
      type.startsWith('image/') ||
      imageExts.some(function (e) {
        return name.endsWith(e);
      });
    const shouldPersist =
      options.persistToMedia !== false && (isImage || isVideo || isAudio);
    if (isImage) {
      const asset = await addImageAsset(file, options);
      if (asset && shouldPersist) queueBackgroundMediaPersist(asset, file);
      return asset;
    }
    if (isVideo) {
      const asset = await addVideoAsset(file, options);
      if (asset && shouldPersist) queueBackgroundMediaPersist(asset, file);
      return asset;
    }
    if (isAudio) {
      const asset = await addAudioAsset(file, options);
      if (asset) {
        if (!options.addToTimeline) loadAudioFile(file);
        if (shouldPersist) queueBackgroundMediaPersist(asset, file);
      }
      return asset;
    }
    if (isTextFile(file)) {
      return addTextFileAsStageElement(file);
    }
    return addFileAsset(file, options);
  }

  async function addAudioAsset(file, options = {}) {
    const id =
      'asset_' + Date.now() + '_' + Math.random().toString(16).slice(2);
    const url = URL.createObjectURL(file);
    const audio = new Audio();
    audio.src = url;
    audio.preload = 'metadata';
    let duration = 0;
    try {
      await new Promise((resolve) => {
        audio.addEventListener(
          'loadedmetadata',
          () => {
            duration = isFinite(audio.duration) ? audio.duration : 0;
            resolve();
          },
          { once: true }
        );
        audio.addEventListener('error', resolve, { once: true });
      });
    } catch {
      duration = 0;
    }
    const asset = {
      id,
      type: 'audio',
      name: file.name || 'Audio',
      src: url,
      file,
      duration: duration || 4,
      width: 0,
      height: 0,
      element: null,
    };
    finalizeAssetAdd(asset, options);
    return asset;
  }

  async function addFileAsset(file, options = {}) {
    const id =
      'asset_' + Date.now() + '_' + Math.random().toString(16).slice(2);
    const preview = await createFilePreview(file, options);
    const img = new Image();
    img.src = preview.src;
    const asset = {
      id,
      type: 'image',
      name: file.name || 'File',
      src: preview.src,
      file,
      duration: 4,
      width: preview.width || 640,
      height: preview.height || 360,
      element: img,
    };
    finalizeAssetAdd(asset, options);
    return asset;
  }

  async function createFilePreview(file, options = {}) {
    const name = file.name || 'File';
    const type = (file.type || '').toLowerCase();
    const ext = (name.split('.').pop() || '').toUpperCase();
    if (type === 'application/pdf' || name.toLowerCase().endsWith('.pdf')) {
      const pdfPreview = await renderPdfPreview(file);
      if (pdfPreview) return pdfPreview;
      return createFilePlaceholder(name, ext || 'PDF', options.accent);
    }
    return createFilePlaceholder(name, ext || 'FILE', options.accent);
  }

  async function renderPdfPreview(file) {
    if (!window.pdfjsLib || typeof window.pdfjsLib.getDocument !== 'function') {
      return null;
    }
    try {
      const data = await file.arrayBuffer();
      const doc = await window.pdfjsLib.getDocument({ data }).promise;
      const page = await doc.getPage(1);
      const viewport = page.getViewport({ scale: 1 });
      const scale = Math.min(1.5, 960 / Math.max(1, viewport.width));
      const scaledViewport = page.getViewport({ scale });
      const canvas = document.createElement('canvas');
      canvas.width = scaledViewport.width;
      canvas.height = scaledViewport.height;
      const ctx = canvas.getContext('2d');
      await page.render({ canvasContext: ctx, viewport: scaledViewport })
        .promise;
      return {
        src: canvas.toDataURL('image/png'),
        width: canvas.width,
        height: canvas.height,
      };
    } catch {
      return null;
    }
  }

  function createFilePlaceholder(name, label, accent = '#0f172a') {
    const canvas = document.createElement('canvas');
    canvas.width = 960;
    canvas.height = 540;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#0b1020';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = accent;
    ctx.fillRect(0, 0, canvas.width, 6);
    ctx.fillStyle = '#f8fafc';
    ctx.font = '600 34px ui-sans-serif, system-ui, -apple-system, "Segoe UI"';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(label, canvas.width / 2, canvas.height / 2 - 10);
    ctx.font = '400 18px ui-sans-serif, system-ui, -apple-system, "Segoe UI"';
    ctx.fillStyle = '#cbd5f5';
    const trimmed = name.length > 32 ? name.slice(0, 29) + '…' : name;
    ctx.fillText(trimmed, canvas.width / 2, canvas.height / 2 + 24);
    return {
      src: canvas.toDataURL('image/png'),
      width: canvas.width,
      height: canvas.height,
    };
  }

  function isTextFile(file) {
    var type = String((file && file.type) || '').toLowerCase();
    if (
      type.startsWith('text/') ||
      type === 'application/json' ||
      type === 'application/xml' ||
      type === 'application/javascript'
    )
      return true;
    var name = String((file && file.name) || '').toLowerCase();
    var textExts = [
      '.json',
      '.txt',
      '.md',
      '.csv',
      '.xml',
      '.html',
      '.css',
      '.js',
      '.ts',
      '.yaml',
      '.yml',
      '.toml',
      '.ini',
      '.cfg',
      '.log',
      '.sh',
      '.py',
      '.rb',
      '.go',
      '.rs',
      '.java',
      '.c',
      '.cpp',
      '.h',
      '.hpp',
      '.jsx',
      '.tsx',
      '.vue',
      '.svelte',
      '.sql',
      '.env',
      '.conf',
    ];
    for (var i = 0; i < textExts.length; i++) {
      if (name.endsWith(textExts[i])) return true;
    }
    return false;
  }

  async function addTextFileAsStageElement(file) {
    var text = await file.text();
    var truncated = text.length > 5000 ? text.slice(0, 5000) + '\n...' : text;
    return addStageElement({
      type: 'text',
      name: file.name || 'Text',
      text: truncated,
      fontSize: 14,
      fontFamily: 'monospace',
      fontWeight: 400,
      fontStyle: 'normal',
      textDecoration: 'none',
      color: '#e2e8f0',
      background: '#0f172a',
      x: 5,
      y: 5,
      w: 90,
      h: 80,
    });
  }

  async function handleAudioUpload(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    try {
      const uploaded = await persistMediaFile(file);
      if (uploaded) {
        loadAudioUrl(
          resolveFsEntryUrl(uploaded),
          uploaded.name || file.name || 'Audio'
        );
      } else {
        loadAudioFile(file);
      }
    } catch (_) {
      loadAudioFile(file);
    }
    event.target.value = '';
  }

  function loadAudioFile(file) {
    const url = URL.createObjectURL(file);
    const audio = new Audio();
    audio.src = url;
    audio.preload = 'auto';
    state.audioElement = audio;
    state.audioFile = file;
    state.audioLabel = (file && file.name) || 'Audio';
    prepareAudioGraph();
    updateAudioSettings();
    drawWaveformFromAudioFile(file);
    renderTimeline();
    updateTimeLabel();
    notify('Audio track loaded', 'success');
    scheduleAutosave();
  }

  function loadAudioUrl(url, label) {
    if (!url) return;
    let derived = '';
    try {
      const parsed = new URL(url, window.location.href);
      const last = parsed.pathname.split('/').filter(Boolean).pop();
      if (last) derived = decodeURIComponent(last);
    } catch (_) {}
    const audio = new Audio();
    audio.preload = 'auto';
    setEditorMediaSource(audio, url);
    state.audioElement = audio;
    state.audioFile = null;
    state.audioLabel = label || derived || 'Audio';
    prepareAudioGraph();
    updateAudioSettings();
    drawWaveformFromUrl(url);
    renderTimeline();
    updateTimeLabel();
    notify('Audio track loaded', 'success');
    scheduleAutosave();
  }

  function clearAudioTrack() {
    if (state.audioElement) {
      try {
        state.audioElement.pause();
      } catch (_) {}
    }
    state.audioElement = null;
    state.audioFile = null;
    state.audioLabel = '';
    clearWaveform();
    renderTimeline();
    updateTimeLabel();
    scheduleAutosave();
    notify('Audio cleared', 'info');
  }

  function loadAudioTrackFile(track, file) {
    var url = URL.createObjectURL(file);
    var audio = new Audio();
    audio.src = url;
    audio.preload = 'auto';
    track.element = audio;
    track.src = url;
    track.label = file.name || track.label;
    renderTimeline();
    scheduleAutosave();
    notify('Audio loaded: ' + track.label, 'success');
  }

  function removeAudioTrack(trackId) {
    var idx = state.audioTracks.findIndex(function (t) {
      return t.id === trackId;
    });
    if (idx === -1) return;
    var track = state.audioTracks[idx];
    if (track.element)
      try {
        track.element.pause();
      } catch (_) {}
    state.audioTracks.splice(idx, 1);
    renderTimeline();
    scheduleAutosave();
    notify('Audio track removed', 'info');
  }

  function playAllAudioTracks() {
    state.audioTracks.forEach(function (track) {
      if (track.element && !track.muted) {
        track.element.currentTime = state.playhead || 0;
        try {
          track.element.play();
        } catch (_) {}
      }
    });
  }

  function pauseAllAudioTracks() {
    state.audioTracks.forEach(function (track) {
      if (track.element)
        try {
          track.element.pause();
        } catch (_) {}
    });
  }

  function bindDropTargets() {
    const root =
      el.videoEditorForm || el.featureFlagContainer || el.videoEditorBody;
    if (!root) return;
    const reset = () => {
      externalFileDragDepth = 0;
      clearActiveExternalFileDropZone();
    };
    root.addEventListener('dragenter', (event) => {
      if (!hasExternalFilePayload(event.dataTransfer)) return;
      externalFileDragDepth += 1;
      event.preventDefault();
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'copy';
      }
      updateActiveExternalFileDropZone(resolveExternalFileDropZone(event));
    });
    root.addEventListener('dragover', (event) => {
      if (!hasExternalFilePayload(event.dataTransfer)) return;
      event.preventDefault();
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'copy';
      }
      updateActiveExternalFileDropZone(resolveExternalFileDropZone(event));
    });
    root.addEventListener('dragleave', (event) => {
      if (!hasExternalFilePayload(event.dataTransfer)) return;
      const nextTarget = event.relatedTarget;
      if (nextTarget && root.contains(nextTarget)) return;
      externalFileDragDepth = Math.max(0, externalFileDragDepth - 1);
      if (!externalFileDragDepth) {
        clearActiveExternalFileDropZone();
      }
    });
    root.addEventListener('drop', (event) => {
      if (!hasExternalFilePayload(event.dataTransfer)) {
        reset();
        return;
      }
      event.preventDefault();
      const dropPromise = handleExternalFileDrop(event);
      reset();
      dropPromise.catch(() => {
        notify('Upload failed', 'error');
      });
    });
    root.addEventListener('dragend', reset);
  }

  function hasExternalFilePayload(dataTransfer) {
    if (!dataTransfer) return false;
    if (dataTransfer.files && dataTransfer.files.length) return true;
    if (
      dataTransfer.items &&
      Array.from(dataTransfer.items).some(
        (item) => item && item.kind === 'file'
      )
    )
      return true;
    if (
      dataTransfer.types &&
      Array.from(dataTransfer.types).some(
        (type) => String(type).toLowerCase() === 'files'
      )
    )
      return true;
    return false;
  }

  function collectDroppedFiles(dataTransfer) {
    if (!dataTransfer) return [];
    const files = dataTransfer.files
      ? Array.from(dataTransfer.files).filter(Boolean)
      : [];
    if (files.length) return files;
    if (!dataTransfer.items) return [];
    return Array.from(dataTransfer.items)
      .filter(
        (item) =>
          item && item.kind === 'file' && typeof item.getAsFile === 'function'
      )
      .map((item) => item.getAsFile())
      .filter(Boolean);
  }

  function traverseFileEntry(entry) {
    if (!entry) return Promise.resolve([]);
    if (entry.isFile) {
      return new Promise((resolve) => {
        entry.file((file) => resolve(file ? [file] : []), () => resolve([]));
      });
    }
    if (entry.isDirectory) {
      if (!entry.createReader) return Promise.resolve([]);
      const reader = entry.createReader();
      return new Promise((resolve) => {
        const all = [];
        const readBatch = () => {
          reader.readEntries((entries) => {
            if (!entries.length) {
              resolve(all);
              return;
            }
            Promise.all(entries.map(traverseFileEntry)).then((groups) => {
              groups.forEach((group) => {
                if (group && group.length) all.push(...group);
              });
              readBatch();
            });
          }, () => resolve(all));
        };
        readBatch();
      });
    }
    return Promise.resolve([]);
  }

  async function collectDroppedFilesDeep(dataTransfer) {
    if (!dataTransfer) return [];
    const items = dataTransfer.items
      ? Array.from(dataTransfer.items)
      : [];
    const fileItems = items.filter(
      (item) => item && item.kind === 'file'
    );
    const hasEntryTraversal = fileItems.some(
      (item) => typeof item.webkitGetAsEntry === 'function'
    );
    if (hasEntryTraversal) {
      const groups = await Promise.all(
        fileItems.map((item) => traverseFileEntry(item.webkitGetAsEntry()))
      );
      const files = [];
      groups.forEach((group) => {
        if (group && group.length) files.push(...group);
      });
      if (files.length) return files;
    }
    return collectDroppedFiles(dataTransfer);
  }

  function pointInsideNode(node, x, y) {
    if (!node || !Number.isFinite(x) || !Number.isFinite(y)) return false;
    const rect = node.getBoundingClientRect();
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      x >= rect.left &&
      x <= rect.right &&
      y >= rect.top &&
      y <= rect.bottom
    );
  }

  function resolveExternalFileDropZone(event) {
    const target =
      event && event.target && event.target.nodeType === 1
        ? event.target
        : null;
    if (target && typeof target.closest === 'function') {
      if (target.closest('#timeline-list')) return FILE_DROP_ZONE_TIMELINE;
      if (target.closest('#preview-canvas-shell')) return FILE_DROP_ZONE_STAGE;
      if (target.closest('#asset-drop, #sidebar-drawer, #editor-sidebar'))
        return FILE_DROP_ZONE_LIBRARY;
    }
    const x = Number(event && event.clientX);
    const y = Number(event && event.clientY);
    if (pointInsideNode(el.timelineList, x, y)) return FILE_DROP_ZONE_TIMELINE;
    if (pointInsideNode(el.previewCanvasShell, x, y))
      return FILE_DROP_ZONE_STAGE;
    if (pointInsideNode(el.assetDrop, x, y)) return FILE_DROP_ZONE_LIBRARY;
    return FILE_DROP_ZONE_LIBRARY;
  }

  function buildExternalFileDropOptions(zone, event) {
    if (zone === FILE_DROP_ZONE_STAGE) {
      return {
        addToStage: true,
        stagePoint: el.previewCanvasShell
          ? getStageDropPoint(event, el.previewCanvasShell)
          : null,
      };
    }
    if (zone === FILE_DROP_ZONE_TIMELINE) {
      const point = getTimelineDropPoint(event);
      return {
        addToTimeline: true,
        timelineIndex: point.index,
        timelineTime: point.time,
        timelineTrack: point.track,
      };
    }
    return {
      addToLibrary: true,
    };
  }

  function updateActiveExternalFileDropZone(zone) {
    const nextZone = zone || FILE_DROP_ZONE_LIBRARY;
    if (activeExternalFileDropZone === nextZone) return;
    activeExternalFileDropZone = nextZone;
    if (el.assetDrop) {
      const active = nextZone === FILE_DROP_ZONE_LIBRARY;
      el.assetDrop.classList.toggle('drop-hover', active);
      el.assetDrop.classList.toggle('dragover', active);
    }
    if (el.previewCanvasShell) {
      el.previewCanvasShell.classList.toggle(
        'drop-hover',
        nextZone === FILE_DROP_ZONE_STAGE
      );
    }
    if (el.timelineList) {
      el.timelineList.classList.toggle(
        'drop-hover',
        nextZone === FILE_DROP_ZONE_TIMELINE
      );
    }
    if (nextZone === FILE_DROP_ZONE_STAGE) {
      showDropOverlay({ title: 'Drop to stage', sub: 'Place at cursor' });
      return;
    }
    if (nextZone === FILE_DROP_ZONE_TIMELINE) {
      showDropOverlay({ title: 'Drop to timeline', sub: 'Insert at position' });
      return;
    }
    showDropOverlay({
      title: 'Drop to save',
      sub: 'Store in Files and add to assets',
    });
  }

  function clearActiveExternalFileDropZone() {
    activeExternalFileDropZone = '';
    if (el.assetDrop) {
      el.assetDrop.classList.remove('drop-hover', 'dragover');
    }
    if (el.previewCanvasShell) {
      el.previewCanvasShell.classList.remove('drop-hover');
    }
    if (el.timelineList) {
      el.timelineList.classList.remove('drop-hover');
    }
    hideDropOverlay();
  }

  async function handleExternalFileDrop(event) {
    const zone = resolveExternalFileDropZone(event || {});
    const options = buildExternalFileDropOptions(zone, event || {});
    const files = await collectDroppedFilesDeep(
      event ? event.dataTransfer : null
    );
    if (!files.length) {
      return { zone, options, count: 0 };
    }
    await handleDroppedFiles(files, options);
    return { zone, options, count: files.length };
  }

  function updateEditorModalOpenState() {
    const open =
      (el.editorSettingsModal &&
        el.editorSettingsModal.classList.contains('open')) ||
      (el.aiGenerateModal && el.aiGenerateModal.classList.contains('open')) ||
      (el.editorHistoryModal &&
        el.editorHistoryModal.classList.contains('open')) ||
      (el.keyboardShortcutsModal &&
        el.keyboardShortcutsModal.classList.contains('open')) ||
      (el.magicResizeModal && el.magicResizeModal.classList.contains('open')) ||
      (el.exportSettingsModal &&
        el.exportSettingsModal.classList.contains('open')) ||
      (el.shareModal && el.shareModal.classList.contains('open')) ||
      (el.projectLibraryModal &&
        el.projectLibraryModal.classList.contains('open')) ||
      (getEl('fs-browser-modal') &&
        getEl('fs-browser-modal').classList.contains('open'));
    document.body.classList.toggle('editor-modal-open', !!open);
    [
      el.editorSettingsModal,
      el.aiGenerateModal,
      el.editorHistoryModal,
      el.keyboardShortcutsModal,
      el.magicResizeModal,
      el.exportSettingsModal,
      el.shareModal,
      el.projectLibraryModal,
      getEl('fs-browser-modal'),
    ].forEach((modal) => {
      if (modal) modal.inert = !modal.classList.contains('open');
    });
  }

  function toggleEditorSettings(open) {
    if (!el.editorSettingsModal) return;
    const shouldOpen =
      open === undefined
        ? !el.editorSettingsModal.classList.contains('open')
        : open;
    el.editorSettingsModal.classList.toggle('open', shouldOpen);
    el.editorSettingsModal.setAttribute(
      'aria-hidden',
      shouldOpen ? 'false' : 'true'
    );
    updateEditorModalOpenState();
    if (shouldOpen) {
      requestAnimationFrame(() => {
        if (el.editorSettingsClose) {
          el.editorSettingsClose.focus();
        }
      });
      announceLive('Settings opened');
    } else if (el.editorSettingsButton) {
      el.editorSettingsButton.focus();
      announceLive('Settings closed');
    }
  }

  function toggleAiGenerate(open) {
    if (!el.aiGenerateModal) return;
    const shouldOpen =
      open === undefined
        ? !el.aiGenerateModal.classList.contains('open')
        : open;
    el.aiGenerateModal.classList.toggle('open', shouldOpen);
    el.aiGenerateModal.setAttribute(
      'aria-hidden',
      shouldOpen ? 'false' : 'true'
    );
    updateEditorModalOpenState();
    if (shouldOpen) {
      if (typeof window.initializeNetwrckTypeahead === 'function') {
        window.initializeNetwrckTypeahead();
      }
      renderSavedAiPanels();
      syncAiReferencePreviewFromSelectedOrInputs();
      closeSidebarDrawer();
      requestAnimationFrame(() => {
        if (el.aiGenerateClose) {
          el.aiGenerateClose.focus();
        }
      });
      announceLive('Generator opened');
    } else if (el.aiGenerateOpen) {
      el.aiGenerateOpen.focus();
      announceLive('Generator closed');
    }
  }

  function updateCreditsWidgets() {
    const total =
      parseFloat(window.userData?.free_credits || 0) +
      parseFloat(window.userData?.paid_credits || 0);
    document.querySelectorAll('.api-credits-balance-usd').forEach((node) => {
      node.textContent = total.toFixed(2);
    });
    document.querySelectorAll('.api-credits-balance').forEach((node) => {
      node.textContent = String(total);
    });
  }

  function importSharedArtImage(img) {
    if (!img) return;
    const src = img.currentSrc || img.src || img.getAttribute('src') || '';
    if (!src || importedSharedArtSrcs.has(src)) return;
    if (state.assets.some((asset) => asset.src === src)) {
      importedSharedArtSrcs.add(src);
      return;
    }
    importedSharedArtSrcs.add(src);
    const name = (img.getAttribute('alt') || '').trim() || 'AI Art';
    addExternalAsset(src, 'image', name, { select: true }).then((asset) => {
      if (!asset) return;
      rememberAiAsset(src, 'image', name);
    });
  }

  function importSharedArtNodes(node) {
    if (!node) return;
    if (node.nodeType === 1 && node.tagName === 'IMG') {
      importSharedArtImage(node);
      return;
    }
    if (node.nodeType !== 1 || !node.querySelectorAll) return;
    node.querySelectorAll('img').forEach(importSharedArtImage);
  }

  function setupSharedArtDialogBridge() {
    if (typeof MutationObserver === 'undefined') return;
    const targets = [el.createPicResults, el.createPicResultsInline].filter(
      Boolean
    );
    if (!targets.length) return;
    targets.forEach((target) => {
      target.querySelectorAll('img').forEach(importSharedArtImage);
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach(importSharedArtNodes);
          if (mutation.type === 'attributes') {
            importSharedArtNodes(mutation.target);
          }
        });
      });
      observer.observe(target, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src'],
      });
    });
  }

  function openSharedArtDialog() {
    if (!el.createPicDialog) {
      window.location.href = '/ai-art-generator';
      return;
    }
    const prompt = (
      el.aiRa1Prompt && el.aiRa1Prompt.value ? el.aiRa1Prompt.value : ''
    ).trim();
    if (prompt && el.createPicPrompt) {
      el.createPicPrompt.value = prompt;
    }
    toggleAiGenerate(false);
    if (typeof el.createPicDialog.showModal === 'function') {
      try {
        el.createPicDialog.showModal();
      } catch (_) {
        el.createPicDialog.setAttribute('open', 'open');
      }
    } else {
      el.createPicDialog.setAttribute('open', 'open');
    }
    requestAnimationFrame(() => {
      if (!el.createPicPrompt) return;
      el.createPicPrompt.focus();
      if (typeof el.createPicPrompt.select === 'function') {
        el.createPicPrompt.select();
      }
    });
  }

  function showDropOverlay(config) {
    if (!el.dropOverlay) return;
    if (config && el.dropOverlayTitle) {
      el.dropOverlayTitle.textContent = config.title || 'Drop files';
    }
    if (config && el.dropOverlaySub) {
      el.dropOverlaySub.textContent = config.sub || 'Stage or timeline';
    }
    el.dropOverlay.classList.add('active');
  }

  function hideDropOverlay() {
    if (!el.dropOverlay) return;
    el.dropOverlay.classList.remove('active');
  }

  async function handleDroppedFiles(files, options) {
    dismissEmptyState();
    if (!Array.isArray(files) || !files.length) return;
    let insertIndex =
      typeof options?.timelineIndex === 'number' ? options.timelineIndex : null;
    for (let i = 0; i < files.length; i += 1) {
      const file = files[i];
      const stagePoint = options?.stagePoint
        ? { x: options.stagePoint.x + i * 2, y: options.stagePoint.y + i * 2 }
        : null;
      const timelineTime =
        typeof options?.timelineTime === 'number'
          ? Math.max(0, options.timelineTime + i * 0.1)
          : null;
      const timelineTrack = Number.isFinite(options?.timelineTrack)
        ? options.timelineTrack
        : null;
      const asset = await addAssetFromFile(file, {
        persistToMedia: true,
        addToStage: options?.addToStage,
        stagePoint,
        addToTimeline: options?.addToTimeline,
        timelineIndex: insertIndex,
        timelineTime,
        timelineTrack,
      });
      if (asset && asset.type !== 'audio' && typeof insertIndex === 'number') {
        insertIndex += 1;
      }
    }
  }

  function getStageDropPoint(event, node) {
    const rect = node.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    return {
      x: Math.max(0, Math.min(100, x)),
      y: Math.max(0, Math.min(100, y)),
    };
  }

  function updateStagePointer(event, node) {
    if (!node) return;
    const point = getStageDropPoint(event, node);
    lastStagePointer = { x: point.x, y: point.y, onStage: true };
  }

  function clearStagePointer() {
    if (lastStagePointer) lastStagePointer.onStage = false;
  }

  function getStagePointer() {
    if (!lastStagePointer || !lastStagePointer.onStage) return null;
    return { x: lastStagePointer.x, y: lastStagePointer.y };
  }

  function getTimelineDropPoint(event) {
    if (!el.timelineList) {
      return { time: 0, track: 0, index: state.clips.length };
    }
    const listRect = el.timelineList.getBoundingClientRect();
    let trackEl = event.target.closest('.timeline-lane-track');
    if (!trackEl) {
      const tracks = Array.from(
        el.timelineList.querySelectorAll('.timeline-lane-track.video-track')
      );
      trackEl =
        tracks.find((row) => {
          const rect = row.getBoundingClientRect();
          return event.clientY >= rect.top && event.clientY <= rect.bottom;
        }) || null;
    }
    const baseTrackEl =
      trackEl || el.timelineList.querySelector('.timeline-lane-track');
    const localX = baseTrackEl
      ? event.clientX - baseTrackEl.getBoundingClientRect().left
      : event.clientX - listRect.left + el.timelineList.scrollLeft;
    const pxPerSec = getTimelinePixelsPerSecond();
    const time = Math.max(0, localX / pxPerSec);
    const trackAttr = trackEl && trackEl.dataset ? trackEl.dataset.track : null;
    const track =
      trackAttr !== null && trackAttr !== undefined && trackAttr !== ''
        ? Math.max(0, parseInt(trackAttr, 10) || 0)
        : 0;
    return { time: snapTimelineTime(time), track, index: state.clips.length };
  }

  function getTimelinePointerTime(event) {
    if (!el.timelineList) return 0;
    const listRect = el.timelineList.getBoundingClientRect();
    const localX = event.clientX - listRect.left + el.timelineList.scrollLeft;
    return Math.max(0, localX / getTimelinePixelsPerSecond());
  }

  function getTimelineTrackAtEvent(event) {
    if (!el.timelineList) return 0;
    let trackEl = event.target.closest('.timeline-lane-track');
    if (!trackEl) {
      const tracks = Array.from(
        el.timelineList.querySelectorAll('.timeline-lane-track.video-track')
      );
      trackEl =
        tracks.find((row) => {
          const rect = row.getBoundingClientRect();
          return event.clientY >= rect.top && event.clientY <= rect.bottom;
        }) || null;
    }
    const trackAttr = trackEl && trackEl.dataset ? trackEl.dataset.track : null;
    return trackAttr !== null && trackAttr !== undefined && trackAttr !== ''
      ? Math.max(0, parseInt(trackAttr, 10) || 0)
      : 0;
  }

  function getTimelineAdjustedDropPoint(event, ids) {
    const pointerTime = getTimelinePointerTime(event);
    const track = getTimelineTrackAtEvent(event);
    if (!timelineClipDrag || !Array.isArray(ids) || !ids.length) {
      return { time: snapTimelineTime(pointerTime), track };
    }
    const anchorOffset =
      timelineClipDrag.anchorStart -
      timelineClipDrag.minStart +
      timelineClipDrag.grabOffset;
    return {
      time: snapTimelineTime(Math.max(0, pointerTime - anchorOffset)),
      track,
    };
  }

  function prepareAudioGraph(options = {}) {
    if (!state.audioElement) return;
    if (!state.audioContext) {
      state.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
    }
    if (state.audioSource && state.audioSourceElement === state.audioElement) {
      try {
        state.audioSource.disconnect();
      } catch (err) {}
    } else {
      state.audioSource = state.audioContext.createMediaElementSource(
        state.audioElement
      );
      state.audioSourceElement = state.audioElement;
    }
    if (state.audioGainNode) {
      try {
        state.audioGainNode.disconnect();
      } catch (err) {}
    }
    state.audioDestination = state.audioContext.createMediaStreamDestination();
    state.audioGainNode = state.audioContext.createGain();
    state.audioGainNode.gain.value = state.audioSettings.gain;
    state.audioSource.connect(state.audioGainNode);
    state.audioGainNode.connect(state.audioDestination);
    if (options.monitor !== false) {
      state.audioGainNode.connect(state.audioContext.destination);
    }
  }

  function updateAudioSettings() {
    const gain = el.audioGain
      ? Math.max(0, parseFloat(el.audioGain.value) || 1)
      : 1;
    const fadeIn = el.audioFadeIn
      ? Math.max(0, parseFloat(el.audioFadeIn.value) || 0)
      : 0;
    const fadeOut = el.audioFadeOut
      ? Math.max(0, parseFloat(el.audioFadeOut.value) || 0)
      : 0;
    state.audioSettings = { gain, fadeIn, fadeOut };
    if (state.audioGainNode) {
      state.audioGainNode.gain.value = gain;
    }
    scheduleAutosave();
  }

  function setAudioGain(value) {
    const gain = Math.max(0, Number(value) || 0);
    state.audioSettings = { ...state.audioSettings, gain };
    if (el.audioGain) el.audioGain.value = String(gain);
    if (state.audioGainNode) state.audioGainNode.gain.value = gain;
    scheduleAutosave();
  }

  function toggleAudioMute() {
    if (!state.audioElement) return;
    const current = state.audioSettings.gain || 0;
    if (current > 0.001) {
      audioMutePrevGain = current;
      setAudioGain(0);
      return;
    }
    setAudioGain(audioMutePrevGain || 1);
  }

  function finalizeAssetAdd(asset, options = {}) {
    if (!asset) return;
    state.assets.unshift(asset);
    if (options.select || options.addToStage || options.addToTimeline) {
      state.selectedAssetId = asset.id;
    }
    renderAssetList();
    maybeLoadSampleAsset();
    if (!options.skipTimeline && options.addToTimeline) {
      addClipFromAssetAtIndex(asset.id, {
        index: options.timelineIndex,
        start: options.timelineTime,
        track: options.timelineTrack,
      });
    }
    if (options.addToStage) {
      addStageElementFromAssetAt(asset, options.stagePoint, options);
    }
    scheduleAutosave();
  }

  function addImageAsset(file, options = {}) {
    return new Promise((resolve) => {
      const id =
        'asset_' + Date.now() + '_' + Math.random().toString(16).slice(2);
      const url = URL.createObjectURL(file);
      const img = new Image();
      let settled = false;
      const finish = (loaded) => {
        if (settled) return;
        settled = true;
        const asset = {
          id,
          type: 'image',
          name: file.name || 'Image',
          src: url,
          file,
          duration: 4,
          width: loaded && img.naturalWidth ? img.naturalWidth : 640,
          height: loaded && img.naturalHeight ? img.naturalHeight : 360,
          element: img,
        };
        finalizeAssetAdd(asset, options);
        resolve(asset);
      };
      img.onload = () => finish(true);
      img.onerror = () => finish(false);
      img.src = url;
      setTimeout(() => finish(false), window.__TEST_MODE__ ? 250 : 2000);
    });
  }

  function addVideoAsset(file, options = {}) {
    return new Promise((resolve) => {
      const id =
        'asset_' + Date.now() + '_' + Math.random().toString(16).slice(2);
      const url = URL.createObjectURL(file);
      const video = document.createElement('video');
      video.preload = 'auto';
      video.muted = true;
      video.onloadedmetadata = () => {
        const duration = isFinite(video.duration) ? video.duration : 4;
        const asset = {
          id,
          type: 'video',
          name: file.name || 'Video',
          src: url,
          file,
          duration: duration,
          width: video.videoWidth,
          height: video.videoHeight,
          element: video,
        };
        finalizeAssetAdd(asset, options);
        queueAssetAudioPeaks(asset, file);
        primeVideoPreviewFrame(video);
        setTimeout(() => renderPrimedVideoFrame(video), 500);
        refreshPreviewFrame();
        resolve(asset);
      };
      video.onloadeddata = () => {
        primeVideoPreviewFrame(video);
        renderPrimedVideoFrame(video);
      };
      video.onseeked = refreshPreviewFrame;
      video.onerror = () => resolve(null);
      video.src = url;
    });
  }

  function refreshPreviewFrame() {
    requestAnimationFrame(() => {
      if (!el.previewCanvas) return;
      renderFrameAt(state.playhead || 0);
    });
  }

  function renderPrimedVideoFrame(video) {
    requestAnimationFrame(() => {
      if (!el.previewCanvas || !video || video.readyState < 2) return;
      const ctx = el.previewCanvas.getContext('2d');
      ctx.clearRect(0, 0, state.resolution.width, state.resolution.height);
      drawMediaCover(ctx, video);
      if (!state.exportInProgress) renderStageElements();
      drawCaptionOverlays(ctx, state.playhead || 0);
      if (!state.exportInProgress) updateShaderStageSource();
    });
  }

  function primeVideoPreviewFrame(video) {
    if (!video || video.__previewPrimed || typeof video.play !== 'function')
      return;
    video.__previewPrimed = true;
    video.muted = true;
    video.playsInline = true;
    const restoreTime = Math.max(0, video.currentTime || 0);
    const wasConnected = video.isConnected;
    if (!wasConnected && document.body) {
      video.style.position = 'fixed';
      video.style.left = '0';
      video.style.top = '0';
      video.style.width = '160px';
      video.style.height = '90px';
      video.style.opacity = '0.01';
      video.style.pointerEvents = 'none';
      document.body.appendChild(video);
    }
    const played = video.play();
    if (!played || typeof played.then !== 'function') {
      if (!wasConnected && video.parentNode)
        video.parentNode.removeChild(video);
      refreshPreviewFrame();
      return;
    }
    played
      .then(
        () =>
          new Promise((resolve) => {
            setTimeout(resolve, 120);
          })
      )
      .then(() => {
        video.pause();
        if (restoreTime > 0.5) {
          video.currentTime = restoreTime;
        }
        if (!wasConnected && video.parentNode)
          video.parentNode.removeChild(video);
        renderPrimedVideoFrame(video);
      })
      .catch(() => {
        if (!wasConnected && video.parentNode)
          video.parentNode.removeChild(video);
        refreshPreviewFrame();
      });
  }

  function addExternalAsset(src, type, name, options = {}) {
    return new Promise((resolve) => {
      const id =
        'asset_' + Date.now() + '_' + Math.random().toString(16).slice(2);
      const addOptions =
        type === 'audio' && !options.addToTimeline
          ? { ...options, skipTimeline: true }
          : options;
      const baseAsset = {
        id,
        type,
        name:
          name ||
          (type === 'video' ? 'Video' : type === 'audio' ? 'Audio' : 'Image'),
        src,
        fsPath: options.fsPath || '',
        file: null,
        duration: 4,
        width: type === 'audio' ? 0 : 640,
        height: type === 'audio' ? 0 : 360,
        element: null,
      };
      finalizeAssetAdd(baseAsset, addOptions);
      resolve(baseAsset);
      if (type === 'image') {
        const img = new Image();
        img.onload = () => {
          baseAsset.width = img.naturalWidth;
          baseAsset.height = img.naturalHeight;
          baseAsset.element = img;
          renderAssetList();
          scheduleAutosave();
        };
        img.onerror = () => {
          if (img.crossOrigin) {
            img.crossOrigin = null;
            img.src = src;
            return;
          }
          baseAsset.element = null;
          renderAssetList();
        };
        setEditorMediaSource(img, src);
        return;
      }
      if (type === 'video') {
        const video = document.createElement('video');
        video.preload = 'auto';
        video.muted = true;
        video.onloadedmetadata = () => {
          const duration = isFinite(video.duration)
            ? video.duration
            : baseAsset.duration;
          baseAsset.duration = duration;
          baseAsset.width = video.videoWidth;
          baseAsset.height = video.videoHeight;
          baseAsset.element = video;
          state.clips.forEach((clip) => {
            if (clip.assetId !== baseAsset.id) return;
            clip.duration = duration;
            clip.sourceDuration = duration;
            clip.element = video;
          });
          recalcTimeline();
          renderTimeline();
          renderAssetList();
          queueAssetAudioPeaks(baseAsset, null);
          primeVideoPreviewFrame(video);
          setTimeout(() => renderPrimedVideoFrame(video), 500);
          refreshPreviewFrame();
          scheduleAutosave();
        };
        video.onloadeddata = () => {
          primeVideoPreviewFrame(video);
          renderPrimedVideoFrame(video);
        };
        video.oncanplay = () => {
          primeVideoPreviewFrame(video);
          renderPrimedVideoFrame(video);
        };
        video.onseeked = refreshPreviewFrame;
        video.onerror = () => {
          if (video.crossOrigin) {
            video.crossOrigin = null;
            video.src = src;
            return;
          }
          removeAssetById(id);
        };
        setEditorMediaSource(video, src);
        return;
      }
      if (type === 'audio') {
        const audio = new Audio();
        setEditorMediaSource(audio, src);
        audio.preload = 'metadata';
        audio.onloadedmetadata = () => {
          const duration = isFinite(audio.duration)
            ? audio.duration
            : baseAsset.duration;
          baseAsset.duration = duration;
          baseAsset.element = audio;
          state.clips.forEach((clip) => {
            if (clip.assetId !== baseAsset.id) return;
            clip.duration = duration;
            clip.sourceDuration = duration;
            clip.element = audio;
          });
          recalcTimeline();
          renderTimeline();
          renderAssetList();
          scheduleAutosave();
        };
        audio.onerror = () => {
          if (audio.crossOrigin) {
            audio.crossOrigin = null;
            audio.src = src;
            return;
          }
          removeAssetById(id);
        };
        return;
      }
    });
  }

  async function maybeLoadSampleAsset() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('sample')) return;
    const sampleSrc = '/static/video-editor/rickroll.webm';
    if (state.assets && state.assets.some((asset) => asset.src === sampleSrc))
      return;
    await addExternalAsset(sampleSrc, 'video', 'gameplay_01.mp4', {
      select: true,
      addToTimeline: true,
      addToStage: true,
    });
  }

  async function maybeLoadDefaultAsset() {
    if (window.__TEST_MODE__) return;
    if (suppressDefaultAssetForTests) return;
    const src = '/static/video-editor/rickroll.webm';
    if (
      state.assets &&
      state.assets.some((asset) => asset.type === 'video' || asset.src === src)
    )
      return;
    const params = new URLSearchParams(window.location.search);
    if (
      params.has('sample') ||
      params.get('import') === 'feed-upload' ||
      params.get('videoUrl') ||
      params.get('videourl') ||
      params.get('imageUrl') ||
      params.get('imageurl') ||
      params.get('audioUrl') ||
      params.get('audiourl') ||
      params.get('src')
    )
      return;
    if (window.__TEST_MODE__ && suppressDefaultAssetForTests) return;
    await addExternalAsset(
      src,
      'video',
      'Rick Astley - Never Gonna Give You Up',
      {
        select: true,
        addToTimeline: true,
      }
    );
    if (!state.audioElement) {
      const audio = new Audio();
      audio.preload = 'auto';
      setEditorMediaSource(audio, src);
      state.audioElement = audio;
      state.audioLabel = 'Rick Astley - Never Gonna Give You Up';
      prepareAudioGraph();
      updateAudioSettings();
      drawWaveformFromUrl(src);
      renderTimeline();
    }
  }

  function guessStartupAssetType(url) {
    const clean = String(url || '').split('?')[0].split('#')[0].toLowerCase();
    if (/\.(png|jpe?g|webp|gif|bmp|svg|ico|avif)$/.test(clean)) return 'image';
    if (/\.(mp3|wav|ogg|oga|aac|m4a|flac|wma|opus)$/.test(clean)) return 'audio';
    if (/\.(mp4|webm|mov|m4v|avi|mkv|ogv)$/.test(clean)) return 'video';
    return '';
  }

  async function maybeLoadUrlAsset() {
    const params = new URLSearchParams(window.location.search);
    const rawVideoUrl = params.get('videoUrl') || params.get('videourl');
    const rawImageUrl = params.get('imageUrl') || params.get('imageurl');
    const rawAudioUrl = params.get('audioUrl') || params.get('audiourl');
    const rawSrc = params.get('src');
    const rawUrl = rawVideoUrl || rawImageUrl || rawAudioUrl || rawSrc;
    if (!rawUrl) return;
    let assetType = rawImageUrl ? 'image' : rawAudioUrl ? 'audio' : 'video';
    if (!rawVideoUrl && !rawImageUrl && !rawAudioUrl && rawSrc) {
      const guess = guessStartupAssetType(rawSrc);
      if (guess) assetType = guess;
    }
    const trimmed = rawUrl.trim();
    if (!trimmed) return;

    let resolvedSrc = trimmed;
    try {
      resolvedSrc = new URL(trimmed, window.location.href).toString();
    } catch {}

    if (state.assets && state.assets.some((asset) => asset.src === resolvedSrc))
      return;

    let name =
      assetType === 'image'
        ? 'Image'
        : assetType === 'audio'
          ? 'Audio'
          : 'Video';
    const explicitName =
      params.get('audioName') || params.get('audioname') || '';
    if (assetType === 'audio' && explicitName.trim()) {
      name = explicitName.trim();
    }
    try {
      const parsed = new URL(resolvedSrc, window.location.href);
      const last = parsed.pathname.split('/').filter(Boolean).pop();
      if (last && !(assetType === 'audio' && explicitName.trim()))
        name = decodeURIComponent(last);
    } catch {}

    const asset = await addExternalAsset(
      resolvedSrc,
      assetType,
      name,
      assetType === 'audio'
        ? {
            select: true,
          }
        : assetType === 'video' || assetType === 'image'
          ? {
              select: true,
              addToTimeline: true,
              addToStage: true,
              fullBleed: true,
            }
          : {
              select: true,
            }
    );
    if (asset) {
      if (assetType === 'audio') {
        rememberAiAsset(resolvedSrc, 'audio', name);
        loadAudioUrl(resolvedSrc, name);
        return;
      }
      if (assetType !== 'video') {
        rememberAiAsset(resolvedSrc, 'image', name);
        return;
      }
      const hasClip = state.clips.some((clip) => clip.assetId === asset.id);
      if (!hasClip) {
        addClipFromAssetAtIndex(asset.id);
      }
      const hasStage = state.stageElements.some(
        (element) => element.src === asset.src
      );
      if (!hasStage) {
        addStageElementFromAssetAt(asset, null, { fullBleed: true });
      }
    }
  }

  function addMockAsset(type, name) {
    const id =
      'asset_' + Date.now() + '_' + Math.random().toString(16).slice(2);
    const isVideo = type === 'video';
    let element = null;
    let src = '';
    if (isVideo) {
      element = document.createElement('video');
      element.muted = true;
    } else {
      element = new Image();
      src =
        'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360"><rect width="640" height="360" fill="%231e293b"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%23f8fafc" font-size="24">Mock</text></svg>';
      element.src = src;
    }
    const asset = {
      id,
      type: isVideo ? 'video' : 'image',
      name: name || (isVideo ? 'Mock Video' : 'Mock Image'),
      src,
      file: null,
      duration: 4,
      width: 640,
      height: 360,
      element,
      mock: true,
    };
    if (isVideo) {
      asset.audioPeaks = [0.18, 0.42, 0.65, 0.34, 0.78, 0.5, 0.24, 0.58];
    }
    state.assets.unshift(asset);
    renderAssetList();
    scheduleAutosave();
    return asset;
  }

  function getAssetCapabilities(asset) {
    const type = asset && asset.type ? asset.type : '';
    return {
      addClip: type === 'image' || type === 'video' || type === 'audio',
      addStage: type === 'image' || type === 'video',
      useAudio: type === 'audio',
      imageToVideo: type === 'image',
      removeBg: type === 'image' || type === 'video',
      relight: type === 'image',
      styleTransfer: type === 'image',
      extractFrame: type === 'video',
      convertGif: type === 'video',
      saveAsset: !!asset && canPersistAiAsset(asset),
    };
  }

  function renderAssetList() {
    if (!el.assetList) return;
    el.assetList.innerHTML = '';
    const savedLookup = new Set(readSavedAiAssets().map((item) => item.src));
    state.assets.forEach((asset) => {
      const item = document.createElement('div');
      item.className = 'asset-item';
      if (asset.status === 'generating') {
        item.classList.add('generating');
      }
      if (
        (asset.type === 'image' || asset.type === 'video') &&
        asset.status !== 'generating'
      ) {
        item.classList.add('media');
        item.title = asset.name || '';
      }
      item.tabIndex = 0;
      if (asset.type === 'image' && asset.src) {
        item.draggable = true;
        item.addEventListener('dragstart', (event) => {
          event.dataTransfer.effectAllowed = 'copy';
          event.dataTransfer.setData(AI_REFERENCE_ASSET_MIME, asset.id);
          event.dataTransfer.setData('text/plain', asset.id);
        });
      }
      if (asset.type === 'audio') {
        item.classList.add('audio');
      }
      item.setAttribute('data-asset-id', asset.id);
      if (state.selectedAssetId === asset.id) {
        item.classList.add('selected');
        item.style.borderColor = '#2563eb';
      }
      const previewWrap = document.createElement('div');
      previewWrap.className = 'asset-preview';
      if (asset.status === 'generating') {
        previewWrap.classList.add('generating');
        previewWrap.textContent = 'Generating…';
      } else if (asset.type === 'image' || asset.type === 'video') {
        if (asset.type === 'video') previewWrap.classList.add('video');
        const preview = document.createElement(
          asset.type === 'image' ? 'img' : 'video'
        );
        preview.src = asset.src;
        if (asset.type === 'video') {
          preview.muted = true;
          preview.playsInline = true;
          preview.preload = 'metadata';
        }
        preview.addEventListener('error', () => {
          if (!asset.mock) removeAssetById(asset.id);
        });
        previewWrap.appendChild(preview);
        if (asset.type === 'video') {
          enableAssetPreviewScrub(previewWrap, preview, asset);
        }
      } else if (asset.type === 'audio') {
        previewWrap.classList.add('audio');
        const canvas = document.createElement('canvas');
        canvas.className = 'asset-audio-wave';
        canvas.width = 144;
        canvas.height = 48;
        renderAudioAssetWave(canvas, asset);
        previewWrap.appendChild(canvas);
        const label = document.createElement('div');
        label.className = 'asset-audio-label';
        label.textContent = asset.name || 'Audio';
        previewWrap.appendChild(label);
        const audioEl = document.createElement('audio');
        audioEl.src = asset.src;
        audioEl.preload = 'metadata';
        previewWrap.appendChild(audioEl);
        enableAssetAudioScrub(previewWrap, audioEl, asset);
      }
      const info = document.createElement('div');
      info.className = 'asset-name';
      info.textContent = asset.name;
      const capabilities = getAssetCapabilities(asset);
      const actions = document.createElement('div');
      actions.className = 'asset-actions';
      if (asset.status === 'generating') {
        const progressWrap = document.createElement('div');
        progressWrap.className = 'asset-progress';
        const progressBar = document.createElement('div');
        progressBar.className = 'asset-progress-bar';
        const progressValue =
          typeof asset.progress === 'number' ? asset.progress : 0;
        const percent = Math.max(0, Math.min(100, progressValue));
        progressBar.style.width = `${percent}%`;
        const progressLabel = document.createElement('span');
        progressLabel.className = 'asset-progress-bar-text';
        progressLabel.textContent =
          percent > 0 ? `${Math.round(percent)}%` : '…';
        progressBar.appendChild(progressLabel);
        progressWrap.appendChild(progressBar);
        actions.appendChild(progressWrap);
      } else if (capabilities.useAudio) {
        if (capabilities.saveAsset) {
          const saveBtn = document.createElement('button');
          saveBtn.className = 'asset-action-btn secondary';
          saveBtn.type = 'button';
          saveBtn.textContent = savedLookup.has(asset.src) ? 'Saved' : 'Save';
          saveBtn.title = savedLookup.has(asset.src)
            ? 'Remove saved generation'
            : 'Save generation locally';
          saveBtn.setAttribute('data-action', 'save-asset');
          saveBtn.setAttribute('data-asset-id', asset.id);
          actions.appendChild(saveBtn);
        }
        const useBtn = document.createElement('button');
        useBtn.className = 'asset-action-btn';
        useBtn.type = 'button';
        useBtn.textContent = 'Add';
        useBtn.title = 'Add to timeline';
        useBtn.setAttribute('data-action', 'add-clip');
        useBtn.setAttribute('data-asset-id', asset.id);
        actions.appendChild(useBtn);
      } else if (item.classList.contains('media')) {
        if (capabilities.addClip) {
          const addBtn = document.createElement('button');
          addBtn.className = 'asset-action-btn secondary';
          addBtn.type = 'button';
          addBtn.textContent = 'Add';
          addBtn.title = 'Add to timeline';
          addBtn.setAttribute('data-action', 'add-clip');
          addBtn.setAttribute('data-asset-id', asset.id);
          actions.appendChild(addBtn);
        }
        const menuBtn = document.createElement('button');
        menuBtn.className = 'asset-action-btn asset-menu-btn';
        menuBtn.type = 'button';
        menuBtn.textContent = '\u22ef';
        menuBtn.title = 'More options';
        menuBtn.setAttribute('aria-label', 'More options');
        menuBtn.setAttribute('data-action', 'asset-menu');
        menuBtn.setAttribute('data-asset-id', asset.id);
        actions.appendChild(menuBtn);
      } else {
        if (capabilities.saveAsset) {
          const saveBtn = document.createElement('button');
          saveBtn.className = 'asset-action-btn secondary';
          saveBtn.type = 'button';
          saveBtn.textContent = savedLookup.has(asset.src) ? 'Saved' : 'Save';
          saveBtn.title = savedLookup.has(asset.src)
            ? 'Remove saved generation'
            : 'Save generation locally';
          saveBtn.setAttribute('data-action', 'save-asset');
          saveBtn.setAttribute('data-asset-id', asset.id);
          actions.appendChild(saveBtn);
        }
        if (capabilities.addClip) {
          const addBtn = document.createElement('button');
          addBtn.className = 'asset-action-btn';
          addBtn.type = 'button';
          addBtn.textContent = 'Add';
          addBtn.title = 'Add to timeline';
          addBtn.setAttribute('data-action', 'add-clip');
          addBtn.setAttribute('data-asset-id', asset.id);
          actions.appendChild(addBtn);
        }
        if (capabilities.addStage) {
          const stageBtn = document.createElement('button');
          stageBtn.className = 'asset-action-btn secondary';
          stageBtn.type = 'button';
          stageBtn.textContent = 'Stage';
          stageBtn.title = 'Add to stage';
          stageBtn.setAttribute('data-action', 'add-stage');
          stageBtn.setAttribute('data-asset-id', asset.id);
          actions.appendChild(stageBtn);
        }
      }
      item.appendChild(previewWrap);
      item.appendChild(info);
      item.appendChild(actions);
      item.addEventListener('mousedown', (event) => {
        if (event.button !== 2) return;
        if (asset.status === 'generating') return;
        event.preventDefault();
        event.stopPropagation();
        showAssetContextMenu(event.clientX, event.clientY, asset);
      });
      item.addEventListener('auxclick', (event) => {
        if (event.button !== 2) return;
        if (asset.status === 'generating') return;
        event.preventDefault();
        event.stopPropagation();
        showAssetContextMenu(event.clientX, event.clientY, asset);
      });
      bindLongPressMenu(
        item,
        (pos) => {
          if (asset.status === 'generating') return;
          showAssetContextMenu(pos.x, pos.y, asset, true);
        },
        (touchTarget) => !touchTarget.closest('button')
      );
      item.addEventListener('pointerdown', (event) => {
        if (event.button !== 2) return;
        if (asset.status === 'generating') return;
        event.preventDefault();
        event.stopPropagation();
        showAssetContextMenu(event.clientX, event.clientY, asset);
      });
      item.addEventListener('contextmenu', (event) => {
        if (asset.status === 'generating') return;
        event.preventDefault();
        event.stopPropagation();
        if (suppressLongPressContextMenu()) return;
        showAssetContextMenu(event.clientX, event.clientY, asset);
      });
      el.assetList.appendChild(item);
    });
  }

  function removeAssetById(assetId) {
    const idx = state.assets.findIndex((asset) => asset.id === assetId);
    if (idx === -1) return;
    const [removed] = state.assets.splice(idx, 1);
    if (state.selectedAssetId === assetId) {
      state.selectedAssetId = null;
    }
    state.clips = state.clips.filter((clip) => clip.assetId !== assetId);
    if (removed && removed.src) {
      state.stageElements = state.stageElements.filter(
        (element) => element.src !== removed.src
      );
    }
    renderAssetList();
    recalcTimeline();
    renderTimeline();
    renderStageElements();
    scheduleAutosave();
  }

  function assetDownloadName(asset) {
    const base =
      (asset.name || 'asset')
        .replace(/[\\/:*?"<>|]+/g, ' ')
        .trim()
        .slice(0, 80) || 'asset';
    if (extFromName(base)) return base;
    const fromSrc =
      typeof asset.src === 'string' && !asset.src.startsWith('blob:')
        ? extFromName(asset.src.split('?')[0])
        : '';
    const ext =
      fromSrc ||
      (asset.type === 'image'
        ? '.png'
        : asset.type === 'video'
          ? '.mp4'
          : asset.type === 'audio'
            ? '.mp3'
            : '');
    return base + ext;
  }

  async function downloadAssetFile(asset) {
    if (!asset || !asset.src) return;
    try {
      const res = await fetch(asset.src);
      if (!res.ok) throw new Error('fetch failed');
      const blob = await res.blob();
      downloadBlob(blob, assetDownloadName(asset));
    } catch (err) {
      window.open(asset.src, '_blank', 'noopener');
    }
  }

  function assetAbsoluteUrl(src) {
    try {
      return new URL(src, window.location.href).href;
    } catch (err) {
      return src;
    }
  }

  async function copyAssetAddress(asset) {
    if (!asset || !asset.src) return;
    try {
      await navigator.clipboard.writeText(assetAbsoluteUrl(asset.src));
      notify('Copied address', 'success');
    } catch (err) {
      notify('Copy failed', 'error');
    }
  }

  async function copyAssetToClipboard(asset) {
    if (!asset || !asset.src) return;
    try {
      if (
        asset.type === 'image' &&
        navigator.clipboard &&
        navigator.clipboard.write &&
        window.ClipboardItem
      ) {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          img.src = asset.src;
        });
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;
        canvas.getContext('2d').drawImage(img, 0, 0);
        const blob = await new Promise((resolve) =>
          canvas.toBlob(resolve, 'image/png')
        );
        if (blob) {
          await navigator.clipboard.write([
            new ClipboardItem({ 'image/png': blob }),
          ]);
          notify('Copied image', 'success');
          return;
        }
      }
      await navigator.clipboard.writeText(assetAbsoluteUrl(asset.src));
      notify('Copied address', 'success');
    } catch (err) {
      try {
        await navigator.clipboard.writeText(assetAbsoluteUrl(asset.src));
        notify('Copied address', 'success');
      } catch (err2) {
        notify('Copy failed', 'error');
      }
    }
  }

  function duplicateAsset(asset) {
    if (!asset || !asset.src) return;
    addExternalAsset(asset.src, asset.type, `${asset.name || 'Asset'} copy`, {
      select: true,
    });
  }

  function renameAsset(asset) {
    if (!asset) return;
    const next = window.prompt('Rename asset', asset.name || '');
    if (next === null) return;
    const trimmed = next.trim();
    if (!trimmed) return;
    asset.name = trimmed;
    renderAssetList();
    scheduleAutosave();
  }

  function createGeneratingAsset({ name, type, jobId }) {
    const id = `asset_gen_${Date.now()}_${Math.random().toString(16).slice(2)}`;
    const asset = {
      id,
      type: type || 'video',
      name: name || 'Generating',
      src: '',
      file: null,
      duration: 0,
      width: 0,
      height: 0,
      status: 'generating',
      progress: 0,
      jobId: jobId || null,
    };
    state.assets.unshift(asset);
    renderAssetList();
    return asset;
  }

  function updateGeneratingAssetProgress(job, progress) {
    if (!job?.assetId) return;
    const asset = state.assets.find((item) => item.id === job.assetId);
    if (!asset) return;
    const percent = progress <= 1 ? progress * 100 : progress;
    asset.progress = Math.max(0, Math.min(100, percent));
    renderAssetList();
  }

  function renderAudioAssetWave(canvas, asset) {
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const w = canvas.width;
    const h = canvas.height;
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = '#0b1020';
    ctx.fillRect(0, 0, w, h);
    const seed =
      (asset?.name || asset?.id || '')
        .split('')
        .reduce((acc, ch) => acc + ch.charCodeAt(0), 0) || 1;
    let value = seed % 97;
    const barCount = Math.max(16, Math.floor(w / 6));
    const barWidth = w / barCount;
    ctx.fillStyle = '#38bdf8';
    for (let i = 0; i < barCount; i += 1) {
      value = (value * 41 + 17) % 101;
      const amp = (value / 100) * h * 0.75 + h * 0.1;
      const x = i * barWidth;
      const y = (h - amp) / 2;
      ctx.fillRect(x + 1, y, Math.max(2, barWidth - 2), amp);
    }
  }

  function enableAssetAudioScrub(container, audio, asset) {
    if (!container || !audio || !asset) return;
    let rafId = null;
    let hover = false;
    let lastX = 0;
    let duration = null;

    const resolveDuration = () => {
      if (Number.isFinite(duration) && duration > 0) return duration;
      if (Number.isFinite(audio.duration) && audio.duration > 0)
        return audio.duration;
      if (Number.isFinite(asset.duration) && asset.duration > 0)
        return asset.duration;
      return 4;
    };

    audio.addEventListener('loadedmetadata', () => {
      if (Number.isFinite(audio.duration) && audio.duration > 0) {
        duration = audio.duration;
      }
    });

    const queueScrub = (clientX) => {
      lastX = clientX;
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        if (!hover) return;
        const rect = container.getBoundingClientRect();
        if (!rect.width) return;
        const ratio = Math.max(
          0,
          Math.min(1, (lastX - rect.left) / rect.width)
        );
        const length = resolveDuration();
        const maxTime = Math.max(0, length - 0.05);
        const nextTime = ratio * maxTime;
        try {
          audio.currentTime = nextTime;
        } catch (err) {
          // ignore
        }
        if (audio.paused) {
          audio.volume = 0.6;
          audio.play().catch(() => {});
        }
      });
    };

    container.addEventListener('mouseenter', () => {
      hover = true;
      if (audio.readyState === 0) {
        try {
          audio.load();
        } catch (err) {
          // ignore
        }
      }
    });

    container.addEventListener('mousemove', (event) => {
      hover = true;
      queueScrub(event.clientX);
    });

    container.addEventListener('mouseleave', () => {
      hover = false;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      audio.pause();
      try {
        audio.currentTime = 0;
      } catch (err) {
        // ignore
      }
    });
  }

  function enableAssetPreviewScrub(container, preview, asset) {
    if (!container || !preview || !asset || asset.type !== 'video') return;
    let rafId = null;
    let hover = false;
    let lastX = 0;
    let duration = null;

    const resolveDuration = () => {
      if (Number.isFinite(duration) && duration > 0) return duration;
      if (Number.isFinite(preview.duration) && preview.duration > 0)
        return preview.duration;
      if (Number.isFinite(asset.duration) && asset.duration > 0)
        return asset.duration;
      return 4;
    };

    preview.addEventListener('loadedmetadata', () => {
      if (Number.isFinite(preview.duration) && preview.duration > 0) {
        duration = preview.duration;
      }
    });

    const queueScrub = (clientX) => {
      lastX = clientX;
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        if (!hover) return;
        const rect = container.getBoundingClientRect();
        if (!rect.width) return;
        const ratio = Math.max(
          0,
          Math.min(1, (lastX - rect.left) / rect.width)
        );
        const length = resolveDuration();
        const maxTime = Math.max(0, length - 0.05);
        const nextTime = ratio * maxTime;
        try {
          preview.currentTime = nextTime;
        } catch (err) {
          // Ignore seek errors for unready media.
        }
      });
    };

    container.addEventListener('mouseenter', () => {
      hover = true;
      if (preview.readyState === 0) {
        try {
          preview.load();
        } catch (err) {
          // Ignore load errors.
        }
      }
      preview.pause();
    });

    container.addEventListener('mousemove', (event) => {
      hover = true;
      queueScrub(event.clientX);
    });

    container.addEventListener('mouseleave', () => {
      hover = false;
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      preview.pause();
      try {
        preview.currentTime = 0;
      } catch (err) {
        // Ignore seek errors for unready media.
      }
    });
  }

  function normalizeStageKeyframes(keyframes, defaultEase = 'linear') {
    if (!Array.isArray(keyframes)) return [];
    return keyframes
      .map((kf) => {
        if (!kf || typeof kf !== 'object') return null;
        return {
          time: typeof kf.time === 'number' ? kf.time : 0,
          x: typeof kf.x === 'number' ? kf.x : null,
          y: typeof kf.y === 'number' ? kf.y : null,
          w: typeof kf.w === 'number' ? kf.w : null,
          h: typeof kf.h === 'number' ? kf.h : null,
          opacity: typeof kf.opacity === 'number' ? kf.opacity : null,
          ease: normalizeEase(kf.ease || defaultEase),
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.time - b.time);
  }

  function getTextAnimationStyle(element, timeSec) {
    var anim = element.textAnimation;
    if (!anim || anim === 'none') return null;
    var dur = element.textAnimationDuration || 1;
    var delay = element.textAnimationDelay || 0;
    var elapsed = timeSec - delay;
    if (elapsed < 0) return { opacity: '0', transform: '' };
    var p = Math.min(1, elapsed / Math.max(0.01, dur));
    var ep =
      p < 1 ? (p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2) : 1;
    switch (anim) {
      case 'fade-in':
        return { opacity: String(ep), transform: '' };
      case 'fade-out':
        return { opacity: String(1 - ep), transform: '' };
      case 'slide-in-left':
        return {
          opacity: String(ep),
          transform: 'translateX(' + -100 * (1 - ep) + '%)',
        };
      case 'slide-in-right':
        return {
          opacity: String(ep),
          transform: 'translateX(' + 100 * (1 - ep) + '%)',
        };
      case 'slide-up':
        return {
          opacity: String(ep),
          transform: 'translateY(' + 100 * (1 - ep) + '%)',
        };
      case 'scale-in':
        return {
          opacity: String(ep),
          transform: 'scale(' + (0.3 + 0.7 * ep) + ')',
        };
      case 'typewriter':
        return {
          clip: Math.floor((element.text || '').length * ep),
          opacity: '1',
          transform: '',
        };
      default:
        return null;
    }
  }

  function normalizeElementEffects(fx) {
    var d = {
      blur: 0,
      brightness: 100,
      contrast: 100,
      saturation: 100,
      hueRotate: 0,
    };
    if (!fx || typeof fx !== 'object') return d;
    return {
      blur: typeof fx.blur === 'number' ? fx.blur : d.blur,
      brightness:
        typeof fx.brightness === 'number' ? fx.brightness : d.brightness,
      contrast: typeof fx.contrast === 'number' ? fx.contrast : d.contrast,
      saturation:
        typeof fx.saturation === 'number' ? fx.saturation : d.saturation,
      hueRotate: typeof fx.hueRotate === 'number' ? fx.hueRotate : d.hueRotate,
    };
  }

  function buildCssFilter(fx) {
    if (!fx) return '';
    var parts = [];
    if (fx.blur > 0) parts.push('blur(' + fx.blur + 'px)');
    if (fx.brightness !== 100)
      parts.push('brightness(' + fx.brightness / 100 + ')');
    if (fx.contrast !== 100) parts.push('contrast(' + fx.contrast / 100 + ')');
    if (fx.saturation !== 100)
      parts.push('saturate(' + fx.saturation / 100 + ')');
    if (fx.hueRotate !== 0) parts.push('hue-rotate(' + fx.hueRotate + 'deg)');
    return parts.join(' ');
  }

  function normalizeStageElement(element) {
    if (!element) return null;
    const next = {
      id:
        element.id ||
        `stage_${Date.now()}_${Math.random().toString(16).slice(2)}`,
      type: element.type || 'text',
      name:
        element.name ||
        (element.type === 'text'
          ? 'Text'
          : element.type === 'shape'
            ? 'Shape'
            : 'Asset'),
      text: typeof element.text === 'string' ? element.text : 'New text',
      src: element.src || '',
      assetId: element.assetId || null,
      shapeKind:
        element.type === 'shape'
          ? typeof element.shapeKind === 'string'
            ? element.shapeKind
            : typeof element.shape_kind === 'string'
              ? element.shape_kind
              : 'rect'
          : null,
      fontSize: typeof element.fontSize === 'number' ? element.fontSize : 24,
      fontFamily:
        typeof element.fontFamily === 'string'
          ? element.fontFamily
          : 'Montserrat',
      fontWeight:
        typeof element.fontWeight === 'string' ||
        typeof element.fontWeight === 'number'
          ? element.fontWeight
          : 600,
      fontStyle:
        typeof element.fontStyle === 'string' ? element.fontStyle : 'normal',
      textDecoration:
        typeof element.textDecoration === 'string'
          ? element.textDecoration
          : 'none',
      color:
        typeof element.color === 'string' && element.color
          ? element.color
          : '#0f172a',
      background:
        typeof element.background === 'string' ? element.background : '',
      textAlign:
        typeof element.textAlign === 'string' ? element.textAlign : 'center',
      textEffect:
        typeof element.textEffect === 'string' ? element.textEffect : 'none',
      hidden: Boolean(element.hidden),
      locked: Boolean(element.locked),
      aspectLocked: Boolean(element.aspectLocked),
      circleClip: Boolean(element.circleClip || element.circle_clip),
      cropMode: Boolean(element.cropMode || element.crop_mode),
      cropZoom:
        typeof element.cropZoom === 'number'
          ? element.cropZoom
          : typeof element.crop_zoom === 'number'
            ? element.crop_zoom
            : 1,
      cropX:
        typeof element.cropX === 'number'
          ? element.cropX
          : typeof element.crop_x === 'number'
            ? element.crop_x
            : 50,
      cropY:
        typeof element.cropY === 'number'
          ? element.cropY
          : typeof element.crop_y === 'number'
            ? element.crop_y
            : 50,
      rotation: typeof element.rotation === 'number' ? element.rotation : 0,
      opacity: typeof element.opacity === 'number' ? element.opacity : 100,
      x: typeof element.x === 'number' ? element.x : 35,
      y: typeof element.y === 'number' ? element.y : 35,
      w: typeof element.w === 'number' ? element.w : 30,
      h: typeof element.h === 'number' ? element.h : 20,
      timelineStart:
        typeof element.timelineStart === 'number'
          ? element.timelineStart
          : typeof element.timeline_start === 'number'
            ? element.timeline_start
            : undefined,
      timelineDuration:
        typeof element.timelineDuration === 'number'
          ? element.timelineDuration
          : typeof element.timeline_duration === 'number'
            ? element.timeline_duration
            : undefined,
      textAnimation:
        typeof element.textAnimation === 'string'
          ? element.textAnimation
          : 'none',
      textAnimationDuration:
        typeof element.textAnimationDuration === 'number'
          ? element.textAnimationDuration
          : 1.0,
      textAnimationDelay:
        typeof element.textAnimationDelay === 'number'
          ? element.textAnimationDelay
          : 0,
      effects: normalizeElementEffects(element.effects),
      keyframes: normalizeStageKeyframes(element.keyframes),
      pageId: element.pageId || null,
    };
    next.x = Math.max(0, Math.min(100 - 5, next.x));
    next.y = Math.max(0, Math.min(100 - 5, next.y));
    next.w = Math.max(5, Math.min(100, next.w));
    next.h = Math.max(5, Math.min(100, next.h));
    next.fontSize = Math.max(8, Math.min(120, next.fontSize));
    next.rotation = Math.max(0, Math.min(360, next.rotation));
    next.opacity = Math.max(0, Math.min(100, next.opacity));
    if (Number.isFinite(next.timelineStart)) {
      next.timelineStart = Math.max(0, next.timelineStart);
    }
    if (Number.isFinite(next.timelineDuration)) {
      next.timelineDuration = Math.max(0.1, next.timelineDuration);
    }
    next.cropZoom = Math.max(1, Math.min(3, next.cropZoom));
    next.cropX = Math.max(0, Math.min(100, next.cropX));
    next.cropY = Math.max(0, Math.min(100, next.cropY));
    if (!next.pageId && state.activePageId) {
      next.pageId = state.activePageId;
    }
    return next;
  }

  function addStageElement(element) {
    const next = normalizeStageElement(element);
    if (!next) return null;
    ensureStageElementTiming(next, { forNew: true });
    state.stageElements.push(next);
    selectStageElement(next.id);
    renderStageElementsList();
    renderTimeline();
    scheduleAutosave('stage-add');
    return next;
  }

  function placeStageElementAtPoint(element, point) {
    if (!point || typeof point.x !== 'number' || typeof point.y !== 'number')
      return element;
    if (typeof Event !== 'undefined' && point instanceof Event) return element;
    if (point.target || point.currentTarget) return element;
    if (!Number.isFinite(point.x) || !Number.isFinite(point.y)) return element;
    if (point.x < 0 || point.x > 100 || point.y < 0 || point.y > 100)
      return element;
    const w = typeof element.w === 'number' ? element.w : 30;
    const h = typeof element.h === 'number' ? element.h : 20;
    element.x = Math.max(0, Math.min(100 - w, point.x - w / 2));
    element.y = Math.max(0, Math.min(100 - h, point.y - h / 2));
    return element;
  }

  function sampleCanvasModeColor(xPct, yPct, wPct, hPct) {
    if (!el.previewCanvas) return null;
    const cw = el.previewCanvas.width || state.resolution.width;
    const ch = el.previewCanvas.height || state.resolution.height;
    const sx = Math.round((cw * xPct) / 100);
    const sy = Math.round((ch * yPct) / 100);
    const sw = Math.max(1, Math.round((cw * wPct) / 100));
    const sh = Math.max(1, Math.round((ch * hPct) / 100));
    try {
      if (!textContrastSampleCanvas) {
        textContrastSampleCanvas = document.createElement('canvas');
        textContrastSampleCanvas.width = 10;
        textContrastSampleCanvas.height = 10;
      }
      const sampleCtx = textContrastSampleCanvas.getContext('2d', {
        willReadFrequently: true,
      });
      if (!sampleCtx) return null;
      sampleCtx.clearRect(0, 0, 10, 10);
      sampleCtx.drawImage(el.previewCanvas, sx, sy, sw, sh, 0, 0, 10, 10);
      const data = sampleCtx.getImageData(0, 0, 10, 10).data;
      const buckets = {};
      const step = 4;
      for (let i = 0; i < data.length; i += step) {
        const key =
          ((data[i] >> 4) << 8) |
          ((data[i + 1] >> 4) << 4) |
          (data[i + 2] >> 4);
        buckets[key] = (buckets[key] || 0) + 1;
      }
      let best = 0,
        bestKey = 0;
      for (const k in buckets) {
        if (buckets[k] > best) {
          best = buckets[k];
          bestKey = +k;
        }
      }
      return {
        r: ((bestKey >> 8) & 0xf) * 17,
        g: ((bestKey >> 4) & 0xf) * 17,
        b: (bestKey & 0xf) * 17,
      };
    } catch (_) {
      return null;
    }
  }

  function contrastTextColor(bg) {
    if (!bg) return '#f8fafc';
    const lum = (0.299 * bg.r + 0.587 * bg.g + 0.114 * bg.b) / 255;
    if (lum > 0.6) return '#0f172a';
    if (lum < 0.15) return '#f8fafc';
    return lum > 0.35 ? '#0f172a' : '#f8fafc';
  }

  function addStageText(point) {
    const elem = placeStageElementAtPoint(
      {
        type: 'text',
        name: 'Text',
        text: 'Edit me',
        fontSize: 32,
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fontStyle: 'normal',
        textDecoration: 'none',
        color: '#0f172a',
        background: '',
        x: 35,
        y: 35,
        w: 30,
        h: 12,
      },
      point
    );
    const bg = sampleCanvasModeColor(elem.x, elem.y, elem.w, elem.h);
    elem.color = contrastTextColor(bg);
    return addStageElement(elem);
  }

  function addStageTextAndEdit(point) {
    const created = addStageText(point);
    if (created && el.stageElements) {
      requestAnimationFrame(() => {
        const node = el.stageElements.querySelector(
          `[data-stage-id="${created.id}"]`
        );
        if (node) beginStageTextEdit(node, created);
      });
    }
    return created;
  }

  function addStageShape() {
    return addStageElement({
      type: 'shape',
      name: 'Shape',
      text: '',
      x: 30,
      y: 30,
      w: 35,
      h: 25,
      shapeKind: 'rect',
    });
  }

  function addStageShapeAt(point, kind = 'rect') {
    const shapeKind = kind || 'rect';
    const payload = {
      type: 'shape',
      name:
        shapeKind === 'circle'
          ? 'Circle'
          : shapeKind === 'line'
            ? 'Line'
            : 'Shape',
      text: '',
      x: 30,
      y: 30,
      w: 35,
      h: 25,
      shapeKind,
    };
    if (shapeKind === 'line') {
      payload.w = 40;
      payload.h = 3;
    } else if (shapeKind === 'circle') {
      payload.w = 20;
      payload.h = 20;
    }
    return addStageElement(placeStageElementAtPoint(payload, point));
  }

  function addStageElementFromAsset() {
    const asset = state.assets.find(
      (item) => item.id === state.selectedAssetId
    );
    if (!asset) {
      notify('Select an asset to add to stage', 'info');
      return;
    }
    addStageElementFromAssetAt(asset);
  }

  function addStageElementFromAssetAt(asset, point, options) {
    if (!asset) return;
    const placement = getStageAssetPlacement(asset, point, options);
    addStageElement({
      type: asset.type,
      name: asset.name || 'Asset',
      src: asset.src,
      assetId: asset.id,
      x: placement.x,
      y: placement.y,
      w: placement.w,
      h: placement.h,
    });
  }

  function getStageAssetPlacement(asset, point, options) {
    if (options && options.fullBleed) return { x: 0, y: 0, w: 100, h: 100 };
    const max = 65;
    const min = 12;
    const aspect = asset.width && asset.height ? asset.width / asset.height : 1;
    let w = Math.min(50, max);
    let h = Math.min(50, max);
    if (aspect > 1) {
      h = Math.max(min, Math.min(max, w / aspect));
    } else if (aspect > 0) {
      w = Math.max(min, Math.min(max, h * aspect));
    }
    const x = point ? point.x - w / 2 : 25;
    const y = point ? point.y - h / 2 : 25;
    return {
      w,
      h,
      x: Math.max(0, Math.min(100 - w, x)),
      y: Math.max(0, Math.min(100 - h, y)),
    };
  }

  function createStageElementNode(element) {
    const node = document.createElement('div');
    node.setAttribute('data-stage-id', element.id);
    node.tabIndex = 0;
    if (element.type === 'video') {
      const video = document.createElement('video');
      video.src = element.src;
      video.muted = false;
      video.loop = true;
      video.autoplay = false;
      video.playsInline = true;
      node.appendChild(video);
    } else if (element.type !== 'text' && element.type !== 'shape') {
      const img = document.createElement('img');
      img.src = element.src;
      node.appendChild(img);
    }
    if (!element.locked) {
      ['tl', 'tr', 'bl', 'br', 'mt', 'mr', 'mb', 'ml', 'rotate'].forEach(
        (pos) => {
          const handle = document.createElement('div');
          handle.className = `stage-handle handle-${pos}`;
          handle.setAttribute('data-handle', pos);
          if (pos === 'rotate') {
            handle.setAttribute('aria-label', 'Rotate');
            handle.setAttribute('title', 'Rotate');
          }
          node.appendChild(handle);
        }
      );
    } else {
      const lockBadge = document.createElement('span');
      lockBadge.className = 'stage-lock-icon';
      lockBadge.textContent = 'LOCK';
      node.appendChild(lockBadge);
    }
    bindLongPressMenu(
      node,
      (pos) =>
        showStageContextMenu({ clientX: pos.x, clientY: pos.y }, element, true),
      (touchTarget) =>
        !node.isContentEditable && !touchTarget.closest('.stage-handle')
    );
    node.addEventListener('pointerdown', (event) =>
      handleStagePointerDown(event, element.id)
    );
    node.addEventListener('contextmenu', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (suppressLongPressContextMenu()) return;
      showStageContextMenu(event, element);
    });
    node.addEventListener('dblclick', (event) => {
      if (element.type !== 'text') return;
      event.preventDefault();
      event.stopPropagation();
      beginStageTextEdit(node, element);
    });
    node.addEventListener('click', (event) => {
      event.stopPropagation();
      if (node.isContentEditable) return;
      const multi = event.shiftKey || event.metaKey || event.ctrlKey;
      if (
        !multi &&
        element.type === 'text' &&
        Array.isArray(state.selectedStageElementIds) &&
        state.selectedStageElementIds.length === 1 &&
        state.selectedStageElementIds.includes(element.id)
      ) {
        beginStageTextEdit(node, element);
        return;
      }
      selectStageElement(element.id, { toggle: multi });
    });
    node.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        if (element.type === 'text') {
          beginStageTextEdit(node, element);
          return;
        }
        selectStageElement(element.id);
      }
      if (event.key === ' ') {
        event.preventDefault();
        selectStageElement(element.id);
      }
    });
    return node;
  }

  function updateStageElementNode(node, element) {
    const layerIndex = Math.max(1, state.stageElements.indexOf(element) + 1);
    node.className = `stage-element ${element.type || 'text'}`;
    node.dataset.layerIndex = String(layerIndex);
    node.title = `${element.name || element.type || 'Layer'} · Layer ${layerIndex}`;
    node.style.left = `${element.x}%`;
    node.style.top = `${element.y}%`;
    node.style.width = `${element.w}%`;
    node.style.height = `${element.h}%`;
    if (element.rotation) {
      node.style.transform = `rotate(${element.rotation}deg)`;
    } else {
      node.style.removeProperty('transform');
    }
    if (typeof element.opacity === 'number') {
      node.style.opacity = `${Math.max(0, Math.min(100, element.opacity)) / 100}`;
    } else {
      node.style.removeProperty('opacity');
    }
    if (element.circleClip) {
      node.style.borderRadius = '999px';
      node.style.overflow = 'hidden';
      node.style.boxShadow = '0 10px 28px rgba(15,23,42,0.28)';
    } else if (element.type !== 'shape') {
      node.style.removeProperty('border-radius');
      node.style.removeProperty('overflow');
      node.style.removeProperty('box-shadow');
    }
    var cssFilter = buildCssFilter(element.effects);
    if (cssFilter) node.style.filter = cssFilter;
    else node.style.removeProperty('filter');
    const mediaChild = node.querySelector('img, video');
    if (mediaChild && (element.type === 'image' || element.type === 'video')) {
      const zoom = Math.max(1, Math.min(3, Number(element.cropZoom) || 1));
      const cropX = Math.max(0, Math.min(100, Number(element.cropX ?? 50)));
      const cropY = Math.max(0, Math.min(100, Number(element.cropY ?? 50)));
      mediaChild.style.objectPosition = `${cropX}% ${cropY}%`;
      mediaChild.style.transform = zoom > 1 ? `scale(${zoom})` : '';
      mediaChild.style.transformOrigin = `${cropX}% ${cropY}%`;
      node.style.overflow = element.circleClip || zoom > 1 ? 'hidden' : '';
    }
    if (
      Array.isArray(state.selectedStageElementIds) &&
      state.selectedStageElementIds.includes(element.id)
    ) {
      node.classList.add('selected');
    } else {
      node.classList.remove('selected');
    }
    if (element.locked) {
      node.classList.add('locked');
    } else {
      node.classList.remove('locked');
    }
    if (element.type === 'text') {
      var fullText = element.text || element.name || 'Text';
      var animStyle = getTextAnimationStyle(element, state.playhead || 0);
      var displayText =
        animStyle && typeof animStyle.clip === 'number'
          ? fullText.slice(0, animStyle.clip)
          : fullText;
      let textNode = Array.from(node.childNodes).find(
        (n) => n.nodeType === Node.TEXT_NODE
      );
      if (!textNode) {
        textNode = document.createTextNode(displayText);
        node.insertBefore(textNode, node.firstChild);
      } else if (textNode.data !== displayText) {
        textNode.data = displayText;
      }
      node.style.fontSize = `${element.fontSize || 24}px`;
      if (element.fontFamily) {
        if (_fontUrlMap[element.fontFamily])
          preloadFont(element.fontFamily, _fontUrlMap[element.fontFamily]);
        setFontFamilyStyle(node, element.fontFamily);
      }
      if (element.fontWeight)
        node.style.fontWeight = String(element.fontWeight);
      if (element.fontStyle) node.style.fontStyle = element.fontStyle;
      if (element.textDecoration)
        node.style.textDecoration = element.textDecoration;
      if (element.color) node.style.color = element.color;
      if (element.background) node.style.backgroundColor = element.background;
      if (element.textAlign) node.style.textAlign = element.textAlign;
      node.style.textShadow = '';
      node.style.webkitTextStroke = '';
      const effect = element.textEffect || 'none';
      if (effect === 'shadow') {
        node.style.textShadow = '0 6px 16px rgba(15, 23, 42, 0.35)';
      } else if (effect === 'outline') {
        node.style.webkitTextStroke = '1px rgba(15, 23, 42, 0.55)';
        node.style.textShadow = '0 0 1px rgba(15, 23, 42, 0.35)';
      } else if (effect === 'glow') {
        node.style.textShadow = '0 0 12px rgba(249, 115, 22, 0.75)';
      } else if (effect === 'lift') {
        node.style.textShadow =
          '0 2px 0 rgba(255,255,255,0.85), 0 10px 22px rgba(15,23,42,0.22)';
      } else if (effect === 'neon') {
        node.style.textShadow =
          '0 0 6px rgba(34,211,238,0.82), 0 0 18px rgba(168,85,247,0.74), 0 0 34px rgba(241,90,127,0.42)';
      } else if (effect === 'sticker') {
        node.style.webkitTextStroke = '4px rgba(255,255,255,0.92)';
        node.style.textShadow = '0 8px 18px rgba(15,23,42,0.20)';
      } else if (effect === 'echo') {
        node.style.textShadow =
          '6px 6px 0 rgba(241,90,127,0.42), 12px 12px 0 rgba(34,211,238,0.28)';
      }
      if (animStyle) {
        if (animStyle.opacity) node.style.opacity = animStyle.opacity;
        if (animStyle.transform) {
          node.style.transform =
            (element.rotation ? `rotate(${element.rotation}deg) ` : '') +
            animStyle.transform;
        }
      }
      if (!element.locked && !node.querySelector('.stage-handle')) {
        ['tl', 'tr', 'bl', 'br', 'mt', 'mr', 'mb', 'ml', 'rotate'].forEach(
          (pos) => {
            const handle = document.createElement('div');
            handle.className = `stage-handle handle-${pos}`;
            handle.setAttribute('data-handle', pos);
            if (pos === 'rotate') {
              handle.setAttribute('aria-label', 'Rotate');
              handle.setAttribute('title', 'Rotate');
            }
            node.appendChild(handle);
          }
        );
      }
    } else if (element.type === 'shape') {
      const shapeKind = element.shapeKind || 'rect';
      node.style.background = element.background || '';
      node.style.border = '';
      if (shapeKind === 'circle') {
        node.style.borderRadius = '999px';
      } else if (shapeKind === 'line') {
        node.style.borderRadius = '999px';
        node.style.background = element.background || 'rgba(37,99,235,0.6)';
        node.style.border = 'none';
      }
    } else if (element.type === 'video') {
      const video = node.querySelector('video');
      if (video) {
        if (video.src !== element.src) video.src = element.src;
        if (state.playing) {
          const targetTime = state.playhead || 0;
          if (Math.abs(video.currentTime - targetTime) > 0.2)
            video.currentTime = targetTime;
          if (video.paused)
            try {
              video.play();
            } catch (_) {}
        } else {
          if (!video.paused) video.pause();
        }
      }
    }
  }

  function renderStageElements(options = {}) {
    if (!el.stageElements) return;
    const refreshList = options.refreshList !== false;
    const editingNode = el.stageElements.querySelector(
      '.stage-element.editing[contenteditable="true"]'
    );
    if (editingNode) return;
    applyStageKeyframesAtTime(state.playhead || 0);
    const existing = new Map();
    el.stageElements
      .querySelectorAll('[data-stage-id]')
      .forEach((n) => existing.set(n.getAttribute('data-stage-id'), n));
    const currentIds = new Set();
    state.stageElements.forEach((element) => {
      if (
        state.activePageId &&
        element.pageId &&
        element.pageId !== state.activePageId
      )
        return;
      if (element.hidden) return;
      if (!isStageElementVisibleAtTime(element, state.playhead || 0)) return;
      currentIds.add(element.id);
      let node = existing.get(element.id);
      if (!node) {
        node = createStageElementNode(element);
      }
      updateStageElementNode(node, element);
      el.stageElements.appendChild(node);
    });
    existing.forEach((node, id) => {
      if (!currentIds.has(id)) node.remove();
    });
    renderStageSelectionBox();
    if (!state.playing) {
      if (refreshList) scheduleStageElementsListRender();
      syncWorkspaceHud();
      scheduleStageInlineToolbarSync();
    }
  }

  function showStageContextMenu(event, element, useSheet = false) {
    if (!el.stageContextMenu || !element) return;
    hideStageBackgroundMenu();
    state.stageContextId = element.id;
    selectStageElement(element.id);
    const editBtn = el.stageContextMenu.querySelector(
      '[data-stage-action="edit"]'
    );
    if (editBtn) {
      editBtn.style.display = element.type === 'text' ? '' : 'none';
    }
    const removeBgBtn = el.stageContextMenu.querySelector(
      '[data-stage-action="remove-bg"]'
    );
    if (removeBgBtn) {
      removeBgBtn.style.display =
        element.type === 'image' || element.type === 'video' ? '' : 'none';
    }
    const refineBgBtn = el.stageContextMenu.querySelector(
      '[data-stage-action="refine-bg"]'
    );
    if (refineBgBtn) {
      refineBgBtn.style.display = element.type === 'image' ? '' : 'none';
    }
    const convertAnimBtn = el.stageContextMenu.querySelector(
      '[data-stage-action="convert-animated"]'
    );
    if (convertAnimBtn) {
      convertAnimBtn.style.display = element.type === 'image' ? '' : 'none';
    }
    lastContextMenuOpenedAt = Date.now();
    if (useSheet) {
      el.stageContextMenu.classList.remove('is-sheet');
      el.stageContextMenu.style.visibility = '';
      el.stageContextMenu.classList.add('open');
      el.stageContextMenu.setAttribute('aria-hidden', 'false');
      positionTimelineMenu(
        el.stageContextMenu,
        event.clientX,
        event.clientY,
        true
      );
      return;
    }
    el.stageContextMenu.style.visibility = 'hidden';
    el.stageContextMenu.classList.add('open');
    el.stageContextMenu.setAttribute('aria-hidden', 'false');
    const rect = el.stageContextMenu.getBoundingClientRect();
    const { innerWidth, innerHeight } = window;
    let left = event.clientX;
    let top = event.clientY;
    if (left + rect.width > innerWidth - 12) {
      left = innerWidth - rect.width - 12;
    }
    if (top + rect.height > innerHeight - 12) {
      top = innerHeight - rect.height - 12;
    }
    el.stageContextMenu.style.left = `${Math.max(8, left)}px`;
    el.stageContextMenu.style.top = `${Math.max(8, top)}px`;
    el.stageContextMenu.style.visibility = '';
  }

  function showStageBackgroundMenu(event, useSheet = false) {
    if (!el.stageBackgroundMenu) return;
    hideStageContextMenu();
    state.stageContextId = null;
    lastContextMenuOpenedAt = Date.now();
    el.stageBackgroundMenu.classList.add('open');
    el.stageBackgroundMenu.setAttribute('aria-hidden', 'false');
    if (useSheet) {
      positionTimelineMenu(
        el.stageBackgroundMenu,
        event.clientX,
        event.clientY,
        true
      );
      return;
    }
    const rect = el.stageBackgroundMenu.getBoundingClientRect();
    const { innerWidth, innerHeight } = window;
    let left = event.clientX;
    let top = event.clientY;
    if (left + rect.width > innerWidth - 12) {
      left = innerWidth - rect.width - 12;
    }
    if (top + rect.height > innerHeight - 12) {
      top = innerHeight - rect.height - 12;
    }
    el.stageBackgroundMenu.style.left = `${Math.max(8, left)}px`;
    el.stageBackgroundMenu.style.top = `${Math.max(8, top)}px`;
  }

  function hideStageContextMenu() {
    if (!el.stageContextMenu) return;
    el.stageContextMenu.classList.remove('open');
    el.stageContextMenu.classList.remove('is-sheet');
    el.stageContextMenu.style.transform = '';
    el.stageContextMenu.setAttribute('aria-hidden', 'true');
    state.stageContextId = null;
    updateTimelineContextOverlay();
  }

  function hideStageBackgroundMenu() {
    if (!el.stageBackgroundMenu) return;
    el.stageBackgroundMenu.classList.remove('open');
    el.stageBackgroundMenu.classList.remove('is-sheet');
    el.stageBackgroundMenu.style.transform = '';
    el.stageBackgroundMenu.setAttribute('aria-hidden', 'true');
    updateTimelineContextOverlay();
  }

  function shouldIgnoreMenuDismiss(event) {
    if (!event) return false;
    if (event.button === 2) return true;
    if (Date.now() - lastContextMenuOpenedAt < 800) return true;
    return false;
  }

  function applyStageKeyframesAtTime(timeSec) {
    state.stageElements.forEach((element) => {
      if (!Array.isArray(element.keyframes) || !element.keyframes.length)
        return;
      if (state.stageKeyframeSoloId && state.stageKeyframeSoloId !== element.id)
        return;
      if (state.stageKeyframeMuted && state.stageKeyframeMuted[element.id])
        return;
      const keyframes = normalizeStageKeyframes(element.keyframes);
      element.keyframes = keyframes;
      if (keyframes.length === 1) {
        const single = keyframes[0];
        if (typeof single.x === 'number') element.x = single.x;
        if (typeof single.y === 'number') element.y = single.y;
        if (typeof single.w === 'number') element.w = single.w;
        if (typeof single.h === 'number') element.h = single.h;
        if (typeof single.opacity === 'number')
          element.opacity = single.opacity;
        return;
      }
      let prev = null;
      let next = null;
      keyframes.forEach((kf) => {
        if (kf.time <= timeSec) prev = kf;
        if (!next && kf.time >= timeSec) next = kf;
      });
      prev = prev || keyframes[0];
      next = next || keyframes[keyframes.length - 1];
      if (!prev || !next) return;
      if (prev === next) {
        if (typeof prev.x === 'number') element.x = prev.x;
        if (typeof prev.y === 'number') element.y = prev.y;
        if (typeof prev.w === 'number') element.w = prev.w;
        if (typeof prev.h === 'number') element.h = prev.h;
        if (typeof prev.opacity === 'number') element.opacity = prev.opacity;
        return;
      }
      const span = Math.max(0.001, next.time - prev.time);
      const t = Math.max(0, Math.min(1, (timeSec - prev.time) / span));
      const eased = applyEase(
        t,
        normalizeEase(next.ease || prev.ease || 'linear')
      );
      if (typeof prev.x === 'number' && typeof next.x === 'number') {
        element.x = prev.x + (next.x - prev.x) * eased;
      }
      if (typeof prev.y === 'number' && typeof next.y === 'number') {
        element.y = prev.y + (next.y - prev.y) * eased;
      }
      if (typeof prev.w === 'number' && typeof next.w === 'number') {
        element.w = prev.w + (next.w - prev.w) * eased;
      }
      if (typeof prev.h === 'number' && typeof next.h === 'number') {
        element.h = prev.h + (next.h - prev.h) * eased;
      }
      if (
        typeof prev.opacity === 'number' &&
        typeof next.opacity === 'number'
      ) {
        element.opacity = prev.opacity + (next.opacity - prev.opacity) * eased;
      }
    });
  }

  function renderStageSelectionBox() {
    if (!el.stageSelectionBox) return;
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) {
      el.stageSelectionBox.style.display = 'none';
      el.stageSelectionBox.setAttribute('aria-hidden', 'true');
      el.stageSelectionBox.classList.remove('aspect-locked');
      updateStageSelectionMeasure(null);
      if (el.stageSelectionGhost) {
        el.stageSelectionGhost.style.display = 'none';
        el.stageSelectionGhost.setAttribute('aria-hidden', 'true');
      }
      return;
    }
    const bounds = computeStageBounds(selectedList);
    if (!bounds) {
      el.stageSelectionBox.style.display = 'none';
      el.stageSelectionBox.setAttribute('aria-hidden', 'true');
      el.stageSelectionBox.classList.remove('aspect-locked');
      updateStageSelectionMeasure(null);
      if (el.stageSelectionGhost) {
        el.stageSelectionGhost.style.display = 'none';
        el.stageSelectionGhost.setAttribute('aria-hidden', 'true');
      }
      return;
    }
    el.stageSelectionBox.style.display = 'block';
    el.stageSelectionBox.setAttribute('aria-hidden', 'false');
    el.stageSelectionBox.classList.toggle(
      'aspect-locked',
      state.stageAspectLocked
    );
    el.stageSelectionBox.style.left = `${bounds.minX}%`;
    el.stageSelectionBox.style.top = `${bounds.minY}%`;
    el.stageSelectionBox.style.width = `${bounds.maxX - bounds.minX}%`;
    el.stageSelectionBox.style.height = `${bounds.maxY - bounds.minY}%`;
    const selectionRotation =
      selectedList.length === 1 ? Number(selectedList[0].rotation) || 0 : 0;
    if (selectionRotation) {
      el.stageSelectionBox.style.transform = `rotate(${selectionRotation}deg)`;
      el.stageSelectionBox.style.transformOrigin = 'center';
      if (el.stageSelectionMeasure) {
        el.stageSelectionMeasure.style.transform = `translateX(-50%) rotate(${-selectionRotation}deg)`;
      }
    } else {
      el.stageSelectionBox.style.removeProperty('transform');
      el.stageSelectionBox.style.removeProperty('transform-origin');
      if (el.stageSelectionMeasure) {
        el.stageSelectionMeasure.style.removeProperty('transform');
      }
    }
    updateStageSelectionMeasure(bounds, selectedList);
    const canTransform = selectedList.every((element) => !element.locked);
    const showRotateHandle = canTransform && selectedList.length > 0;
    const showOpacityHandle = canTransform && selectedList.length > 1;
    el.stageSelectionBox
      .querySelectorAll('[data-handle]')
      .forEach((handleNode) => {
        const handle = handleNode.getAttribute('data-handle');
        if (handle === 'rotate') {
          handleNode.style.display = showRotateHandle ? 'block' : 'none';
          return;
        }
        if (handle === 'opacity') {
          handleNode.style.display = showOpacityHandle ? 'block' : 'none';
          return;
        }
        handleNode.style.display = canTransform ? 'block' : 'none';
      });
    scheduleStageInlineToolbarSync();
  }

  function updateStageSelectionMeasure(bounds, selectedList) {
    if (!el.stageSelectionMeasure) return;
    if (!bounds || !Array.isArray(selectedList) || !selectedList.length) {
      el.stageSelectionMeasure.textContent = '';
      el.stageSelectionMeasure.style.display = 'none';
      return;
    }
    const widthPct = Math.max(0, bounds.maxX - bounds.minX);
    const heightPct = Math.max(0, bounds.maxY - bounds.minY);
    const widthPx = Math.round((widthPct / 100) * state.resolution.width);
    const heightPx = Math.round((heightPct / 100) * state.resolution.height);
    const xPx = Math.round((bounds.minX / 100) * state.resolution.width);
    const yPx = Math.round((bounds.minY / 100) * state.resolution.height);
    const count = selectedList.length > 1 ? ` | ${selectedList.length}` : '';
    el.stageSelectionMeasure.textContent = `${widthPx} x ${heightPx}px | X ${xPx} Y ${yPx}${count}`;
    el.stageSelectionMeasure.style.display = '';
  }

  function setStageSelectionGhost(bounds) {
    if (!el.stageSelectionGhost) return;
    if (!bounds) {
      el.stageSelectionGhost.style.display = 'none';
      el.stageSelectionGhost.setAttribute('aria-hidden', 'true');
      return;
    }
    el.stageSelectionGhost.style.display = 'block';
    el.stageSelectionGhost.setAttribute('aria-hidden', 'false');
    el.stageSelectionGhost.style.left = `${bounds.minX}%`;
    el.stageSelectionGhost.style.top = `${bounds.minY}%`;
    el.stageSelectionGhost.style.width = `${bounds.maxX - bounds.minX}%`;
    el.stageSelectionGhost.style.height = `${bounds.maxY - bounds.minY}%`;
  }

  function renderStageElementsList() {
    if (!el.stageElementsList) return;
    const filterRaw = (state.stageElementsFilter || '').trim();
    const filter = filterRaw.toLowerCase();
    const allElements = state.stageElements;
    const pageElements = state.activePageId
      ? allElements.filter(
          (element) => !element.pageId || element.pageId === state.activePageId
        )
      : allElements;
    const typeFilter = state.stageElementsFilterType || 'all';
    const statusFilter = state.stageElementsFilterStatus || 'all';
    const selectedOnly = !!state.stageElementsFilterSelectedOnly;
    const selectedSet = new Set(state.selectedStageElementIds || []);
    const matchesType = (element) => {
      if (typeFilter === 'all') return true;
      if (typeFilter === 'text') return element.type === 'text';
      if (typeFilter === 'shape') return element.type === 'shape';
      if (typeFilter === 'asset')
        return element.type !== 'text' && element.type !== 'shape';
      return true;
    };
    const filteredElements = pageElements.filter((element) => {
      if (!matchesType(element)) return false;
      if (statusFilter === 'locked' && !element.locked) return false;
      if (statusFilter === 'hidden' && !element.hidden) return false;
      if (statusFilter === 'unlocked' && element.locked) return false;
      if (statusFilter === 'visible' && element.hidden) return false;
      if (selectedOnly && !selectedSet.has(element.id)) return false;
      if (!filter) return true;
      const label = `${element.name || ''} ${element.type || ''}`.toLowerCase();
      return label.includes(filter);
    });
    if (el.stageElementsFilter) {
      el.stageElementsFilter.value = filterRaw;
    }
    updateStageElementsFilterClearIcon();
    updateStageElementsFilterCounts();
    updateStageElementsFilterPreset();
    const hasFilter =
      filter || typeFilter !== 'all' || selectedOnly || statusFilter !== 'all';
    const listSection = el.stageElementsList.closest('details');
    if (listSection) {
      listSection.open = selectedSet.size > 0 || !!hasFilter;
    }
    if (el.stageElementsLayersSummary) {
      if (listSection && listSection.open && hasFilter) {
        el.stageElementsLayersSummary.setAttribute(
          'data-badge',
          String(filteredElements.length)
        );
      } else if (pageElements.length > 0 && listSection && !listSection.open) {
        const count =
          selectedSet.size > 0 ? selectedSet.size : pageElements.length;
        el.stageElementsLayersSummary.setAttribute('data-badge', String(count));
      } else {
        el.stageElementsLayersSummary.removeAttribute('data-badge');
      }
    }
    if (el.stageElementsPanel) {
      const isEmpty = pageElements.length === 0;
      el.stageElementsPanel.classList.toggle('is-empty', isEmpty);
      el.stageElementsPanel.classList.toggle('no-layers', isEmpty);
      if (el.stageFiltersToggle) {
        const popoverOpen = el.stageFiltersPopover?.classList.contains('open');
        el.stageFiltersToggle.style.display = isEmpty
          ? 'none'
          : popoverOpen
            ? 'none'
            : 'inline-flex';
      }
      if (isEmpty && el.stageFiltersPopover) {
        setStageFiltersPopoverOpen(false);
      }
    }
    if (el.stageElementsFilterClearAll) {
      el.stageElementsFilterClearAll.disabled = !hasFilter;
      el.stageElementsFilterClearAll.style.display = hasFilter
        ? 'inline-flex'
        : 'none';
    }
    if (el.stageElementsFilterCount) {
      const countLabel = `${filteredElements.length}`;
      el.stageElementsFilterCount.textContent = countLabel;
      el.stageElementsFilterCount.style.display = hasFilter
        ? 'inline-flex'
        : 'none';
      el.stageElementsFilterCount.title = hasFilter
        ? `${filteredElements.length} matching`
        : '';
    }
    if (el.stageFiltersToggle) {
      const popoverOpen = el.stageFiltersPopover?.classList.contains('open');
      el.stageFiltersToggle.classList.toggle(
        'has-active',
        !!hasFilter && !popoverOpen
      );
      if (hasFilter && !popoverOpen) {
        el.stageFiltersToggle.setAttribute(
          'data-filter-count',
          String(filteredElements.length)
        );
      } else {
        el.stageFiltersToggle.removeAttribute('data-filter-count');
      }
    }
    updateStageFiltersPopover(!!hasFilter);
    const typeCounts = {
      all: allElements.length,
      text: allElements.filter((element) => element.type === 'text').length,
      shape: allElements.filter((element) => element.type === 'shape').length,
      asset: allElements.filter(
        (element) => element.type !== 'text' && element.type !== 'shape'
      ).length,
    };
    const statusCounts = {
      all: allElements.length,
      locked: allElements.filter((element) => element.locked).length,
      hidden: allElements.filter((element) => element.hidden).length,
      unlocked: allElements.filter((element) => !element.locked).length,
      visible: allElements.filter((element) => !element.hidden).length,
    };
    if (el.stageElementsFilterSummary) {
      el.stageElementsFilterSummary.innerHTML = '';
      if (hasFilter) {
        const addPill = (label, onClick, title, opts = {}) => {
          const pill = document.createElement('span');
          if (Array.isArray(opts.labelNodes) && opts.labelNodes.length) {
            opts.labelNodes.forEach((node) => pill.appendChild(node));
          } else {
            pill.textContent = label;
          }
          if (onClick) {
            pill.classList.add('is-clickable');
            pill.addEventListener('click', onClick);
          }
          if (title) {
            const showClearHint = onClick && opts.clearHint !== false;
            pill.title = showClearHint ? `${title} · click to clear` : title;
          }
          if (opts.match) {
            pill.classList.add('is-match');
          }
          if (opts.custom) {
            pill.classList.add('is-custom');
          }
          el.stageElementsFilterSummary.appendChild(pill);
        };
        if (typeFilter !== 'all') {
          const typeCount = typeCounts[typeFilter] ?? 0;
          addPill(
            `${typeFilter} · ${typeCount}`,
            () => setStageElementsFilterType('all'),
            `Type: ${typeFilter} (${typeCounts[typeFilter] ?? 0}) · Esc clears search`,
            { match: stageTypeMatchesSearch(typeFilter, filter) }
          );
        }
        if (statusFilter !== 'all') {
          const statusCount = statusCounts[statusFilter] ?? 0;
          addPill(
            `${statusFilter} · ${statusCount}`,
            () => setStageElementsFilterStatus('all'),
            `Status: ${statusFilter} (${statusCounts[statusFilter] ?? 0}) · Esc clears search`,
            { match: stageStatusMatchesSearch(statusFilter, filter) }
          );
        }
        if (selectedOnly) {
          addPill(
            `selected · ${selectedSet.size}`,
            () => setStageElementsSelectedOnly(false),
            `Selected only (${selectedSet.size}) · Esc clears search`
          );
        }
        if (filter) {
          const searchPill = document.createElement('span');
          const searchLabel = document.createElement('span');
          searchLabel.textContent = 'search ';
          const searchMatch = document.createElement('span');
          searchMatch.className = 'stage-filter-term';
          searchMatch.textContent = filterRaw;
          const searchCount = document.createElement('span');
          searchCount.textContent = ` (${filteredElements.length})`;
          searchPill.appendChild(searchLabel);
          searchPill.appendChild(searchMatch);
          searchPill.appendChild(searchCount);
          searchPill.classList.add('is-clickable', 'is-match');
          searchPill.title = `Search: "${filterRaw}" (${filteredElements.length}) · click to clear · Esc to clear`;
          searchPill.addEventListener('click', () => {
            state.stageElementsFilter = '';
            if (el.stageElementsFilter) {
              el.stageElementsFilter.value = '';
            }
            renderStageElementsList();
          });
          el.stageElementsFilterSummary.appendChild(searchPill);
        }
        const presetMatch = getStageElementsFilterPresetMatch();
        if (!presetMatch) {
          const customParts = [];
          if (typeFilter !== 'all') customParts.push(`type: ${typeFilter}`);
          if (statusFilter !== 'all')
            customParts.push(`status: ${statusFilter}`);
          if (selectedOnly) customParts.push('selected');
          if (filter) customParts.push(`search "${filterRaw}"`);
          const closestPreset = (() => {
            if (typeFilter !== 'all') return typeFilter;
            if (statusFilter !== 'all') return statusFilter;
            if (selectedOnly) return 'selected';
            if (filter) return 'all';
            return null;
          })();
          let customLabel = closestPreset
            ? `custom → ${closestPreset}`
            : 'custom ×';
          if (filter) {
            customLabel = customLabel.replace(
              'custom',
              `custom "${filterRaw}"`
            );
          }
          let customLabelNodes = null;
          if (filter) {
            const parts = customLabel.split(
              new RegExp(`(${escapeRegExp(filterRaw)})`, 'i')
            );
            if (parts.length > 1) {
              customLabelNodes = parts.map((part, idx) => {
                if (part.toLowerCase() === filterRaw.toLowerCase()) {
                  const match = document.createElement('span');
                  match.className = 'stage-filter-term';
                  match.textContent = part;
                  return match;
                }
                return document.createTextNode(part);
              });
            }
          }
          const action = () => {
            if (closestPreset) {
              applyStageElementsFilterPreset(closestPreset, true);
            } else {
              clearStageElementsFilters();
            }
          };
          const customTitleBase = customParts.length
            ? `Custom filter (${customParts.join(', ')})`
            : 'Custom filter';
          const customTitle = closestPreset
            ? `${customTitleBase} · apply closest preset: ${closestPreset}`
            : `${customTitleBase}`;
          addPill(customLabel, action, customTitle, {
            custom: true,
            clearHint: false,
            labelNodes: customLabelNodes,
          });
        }
        const toggleTargets = selectedSet.size
          ? allElements.filter((element) => selectedSet.has(element.id))
          : allElements;
        const hasToggleTargets = toggleTargets.length > 0;
        const lockedCount = toggleTargets.filter(
          (element) => element.locked
        ).length;
        const hiddenCount = toggleTargets.filter(
          (element) => element.hidden
        ).length;
        const allLocked = toggleTargets.length
          ? lockedCount === toggleTargets.length
          : false;
        const allHidden = toggleTargets.length
          ? hiddenCount === toggleTargets.length
          : false;
        const lockToggle = document.createElement('button');
        lockToggle.type = 'button';
        lockToggle.className = 'stage-filter-quick';
        lockToggle.textContent = allLocked
          ? `Unlock (${lockedCount})`
          : `Lock (${lockedCount})`;
        lockToggle.title = hasToggleTargets
          ? `${allLocked ? 'Unlock' : 'Lock'} selected layers (or all if none selected) · Alt+Shift+L · Locked: ${lockedCount} · click to toggle`
          : 'No layers to lock';
        lockToggle.setAttribute('aria-keyshortcuts', 'Alt+Shift+L');
        lockToggle.disabled = !hasToggleTargets;
        lockToggle.addEventListener('click', toggleStageElementsLocked);
        el.stageElementsFilterSummary.appendChild(lockToggle);
        const hideToggle = document.createElement('button');
        hideToggle.type = 'button';
        hideToggle.className = 'stage-filter-quick';
        hideToggle.textContent = allHidden
          ? `Show (${hiddenCount})`
          : `Hide (${hiddenCount})`;
        hideToggle.title = hasToggleTargets
          ? `${allHidden ? 'Show' : 'Hide'} selected layers (or all if none selected) · H · Hidden: ${hiddenCount} · click to toggle`
          : 'No layers to show/hide';
        hideToggle.setAttribute('aria-keyshortcuts', 'H');
        hideToggle.disabled = !hasToggleTargets;
        hideToggle.addEventListener('click', toggleStageElementsHidden);
        el.stageElementsFilterSummary.appendChild(hideToggle);
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'stage-filter-clear';
        clear.textContent = 'Clear all';
        clear.title = 'Clear all filters (Alt+Shift+Backspace)';
        clear.setAttribute('aria-keyshortcuts', 'Alt+Shift+Backspace');
        clear.addEventListener('click', () => {
          clearStageElementsFilters();
        });
        el.stageElementsFilterSummary.appendChild(clear);
        el.stageElementsFilterSummary.style.display = 'inline-flex';
      } else {
        el.stageElementsFilterSummary.style.display = 'none';
      }
    }
    el.stageElementsList.innerHTML = '';
    const allowReorder =
      !filter &&
      typeFilter === 'all' &&
      !selectedOnly &&
      statusFilter === 'all';
    filteredElements.forEach((element) => {
      const row = document.createElement('div');
      row.className = 'stage-elements-item';
      if (
        Array.isArray(state.selectedStageElementIds) &&
        state.selectedStageElementIds.includes(element.id)
      ) {
        row.classList.add('active');
      }
      const layerIndex = Math.max(1, pageElements.indexOf(element) + 1);
      row.setAttribute('data-stage-id', element.id);
      row.setAttribute('data-layer-index', String(layerIndex));
      row.title = `Layer ${layerIndex}`;
      row.addEventListener('dragover', (event) => {
        event.preventDefault();
        if (row.classList.contains('dragging')) return;
        row.classList.add('drag-over');
      });
      row.addEventListener('dragleave', () => {
        row.classList.remove('drag-over');
      });
      row.addEventListener('drop', (event) => {
        event.preventDefault();
        const fromId =
          stageElementDragId ||
          (event.dataTransfer ? event.dataTransfer.getData('text/plain') : '');
        if (!fromId || fromId === element.id) return;
        reorderStageElements(fromId, element.id);
        clearStageDragClasses();
      });
      const handle = document.createElement('span');
      handle.className = 'stage-elements-handle';
      handle.textContent = '::';
      handle.draggable = allowReorder;
      handle.addEventListener('dragstart', (event) => {
        if (!allowReorder) {
          event.preventDefault();
          return;
        }
        stageElementDragId = element.id;
        if (
          !Array.isArray(state.selectedStageElementIds) ||
          !state.selectedStageElementIds.includes(element.id)
        ) {
          selectStageElement(element.id);
        }
        if (event.dataTransfer) {
          event.dataTransfer.effectAllowed = 'move';
          event.dataTransfer.setData('text/plain', element.id);
        }
        row.classList.add('dragging');
      });
      handle.addEventListener('dragend', () => {
        stageElementDragId = null;
        clearStageDragClasses();
      });
      row.appendChild(handle);
      const label = document.createElement('span');
      label.className = 'stage-elements-label';
      const labelText = element.name || element.type || 'Element';
      label.title = labelText;
      renderStageElementLabel(label, labelText, filterRaw);
      label.addEventListener('dblclick', (event) => {
        event.stopPropagation();
        beginStageElementNameEdit(label, element, row);
      });
      row.appendChild(label);
      const layerBadge = document.createElement('span');
      layerBadge.className = 'stage-elements-layer-index';
      layerBadge.textContent = `L${layerIndex}`;
      layerBadge.title = `Layer ${layerIndex}`;
      row.appendChild(layerBadge);
      if (state.stageElementsShowTypeBadges) {
        const typeBadge = document.createElement('span');
        const typeLabel = element.type || 'asset';
        typeBadge.className = 'stage-elements-type-badge';
        typeBadge.textContent = typeLabel.toUpperCase();
        if (
          filterRaw &&
          typeLabel.toLowerCase().includes(filterRaw.toLowerCase())
        ) {
          typeBadge.classList.add('is-match');
        }
        row.appendChild(typeBadge);
      }
      if (element.aspectLocked) {
        const aspectBadge = document.createElement('span');
        aspectBadge.className = 'stage-elements-aspect-badge';
        aspectBadge.textContent = 'Aspect';
        aspectBadge.title = 'Aspect lock is enabled';
        row.appendChild(aspectBadge);
      }
      if (element.locked) {
        const lockBadge = document.createElement('span');
        lockBadge.className = 'stage-elements-lock-badge';
        lockBadge.textContent = 'Locked';
        lockBadge.title = 'This layer is locked';
        row.appendChild(lockBadge);
      }
      const actions = document.createElement('div');
      actions.className = 'stage-elements-item-actions';
      const visibilityBtn = document.createElement('button');
      visibilityBtn.type = 'button';
      visibilityBtn.textContent = element.hidden ? 'Show' : 'Hide';
      visibilityBtn.title = 'H · Toggle visibility';
      visibilityBtn.setAttribute('aria-keyshortcuts', 'H');
      visibilityBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        toggleStageElementVisibility(element.id);
      });
      const lockBtn = document.createElement('button');
      lockBtn.type = 'button';
      lockBtn.textContent = element.locked ? 'Unlock' : 'Lock';
      lockBtn.title = 'Alt+Shift+L · Toggle lock';
      lockBtn.setAttribute('aria-keyshortcuts', 'Alt+Shift+L');
      lockBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        toggleStageElementLock(element.id);
      });
      actions.appendChild(visibilityBtn);
      actions.appendChild(lockBtn);
      row.appendChild(actions);
      row.addEventListener('click', (event) => {
        const multi = event.shiftKey || event.metaKey || event.ctrlKey;
        selectStageElement(element.id, { toggle: multi });
      });
      row.tabIndex = 0;
      row.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        if (
          event.target &&
          event.target.closest &&
          event.target.closest('button')
        )
          return;
        event.preventDefault();
        beginStageElementNameEdit(label, element, row);
      });
      row.addEventListener('contextmenu', (event) => {
        event.preventDefault();
        event.stopPropagation();
        showStageContextMenu(event, element);
      });
      el.stageElementsList.appendChild(row);
    });
  }

  function renderStageElementLabel(label, text, query) {
    const trimmed = (query || '').trim();
    if (!trimmed) {
      label.textContent = text;
      return;
    }
    const lower = text.toLowerCase();
    const needle = trimmed.toLowerCase();
    let index = lower.indexOf(needle);
    if (index < 0) {
      label.textContent = text;
      return;
    }
    label.textContent = '';
    let cursor = 0;
    while (index >= 0) {
      if (index > cursor) {
        label.appendChild(document.createTextNode(text.slice(cursor, index)));
      }
      const mark = document.createElement('span');
      mark.className = 'stage-elements-match';
      mark.textContent = text.slice(index, index + needle.length);
      label.appendChild(mark);
      cursor = index + needle.length;
      index = lower.indexOf(needle, cursor);
    }
    if (cursor < text.length) {
      label.appendChild(document.createTextNode(text.slice(cursor)));
    }
  }

  function clearStageDragClasses() {
    if (!el.stageElementsList) return;
    el.stageElementsList
      .querySelectorAll('.dragging, .drag-over')
      .forEach((node) => {
        node.classList.remove('dragging', 'drag-over');
      });
  }

  function reorderStageElements(dragId, targetId) {
    if (!dragId || !targetId || dragId === targetId) return;
    const selectedIds = Array.isArray(state.selectedStageElementIds)
      ? state.selectedStageElementIds
      : [];
    const selectedSet = new Set(selectedIds);
    const groupIds = selectedSet.has(dragId)
      ? state.stageElements
          .filter((element) => selectedSet.has(element.id))
          .map((element) => element.id)
      : [dragId];
    if (groupIds.includes(targetId)) return;
    const moving = state.stageElements.filter((element) =>
      groupIds.includes(element.id)
    );
    const remaining = state.stageElements.filter(
      (element) => !groupIds.includes(element.id)
    );
    const targetIndex = remaining.findIndex(
      (element) => element.id === targetId
    );
    if (targetIndex < 0) {
      remaining.push(...moving);
    } else {
      remaining.splice(targetIndex, 0, ...moving);
    }
    state.stageElements = remaining;
    renderStageElements();
    renderTimeline();
    scheduleAutosave('stage-reorder');
  }

  function beginStageElementNameEdit(labelNode, element, row) {
    if (!labelNode || !element || !row) return;
    const previous = element.name || element.type || 'Element';
    const input = document.createElement('input');
    input.type = 'text';
    input.value = previous;
    input.addEventListener('click', (event) => event.stopPropagation());
    const finish = (commit) => {
      input.removeEventListener('blur', handleBlur);
      input.removeEventListener('keydown', handleKeydown);
      if (commit) {
        const nextName = (input.value || '').trim();
        element.name = nextName || previous;
      }
      renderStageElementsList();
      updateStageElementControls();
      scheduleAutosave('stage-name');
    };
    const handleBlur = () => finish(true);
    const handleKeydown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        finish(true);
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        finish(false);
      }
    };
    input.addEventListener('blur', handleBlur);
    input.addEventListener('keydown', handleKeydown);
    row.replaceChild(input, labelNode);
    input.focus();
    input.select();
  }

  function setStageSelection(ids, primaryId) {
    state.selectedStageElementIds = ids;
    state.selectedStageElementId = primaryId || ids[0] || null;
    syncStageAspectLockState();
    updateStageElementControls();
    updateTimelineStageSelectionDom();
    renderStageElements();
    renderInspector();
  }

  function selectStageElement(id, options = {}) {
    if (!id) {
      setStageSelection([], null);
      return;
    }
    if (options.source !== 'clip') {
      inspectorContext = 'stage';
    }
    const ids = Array.isArray(state.selectedStageElementIds)
      ? [...state.selectedStageElementIds]
      : [];
    const toggle = options.toggle === true;
    const additive = options.additive === true;
    if (toggle) {
      if (ids.includes(id)) {
        const nextIds = ids.filter((entry) => entry !== id);
        setStageSelection(nextIds, nextIds[nextIds.length - 1] || null);
        return;
      }
      ids.push(id);
      setStageSelection(ids, id);
      return;
    }
    if (additive) {
      if (!ids.includes(id)) ids.push(id);
      setStageSelection(ids, id);
      return;
    }
    setStageSelection([id], id);
  }

  function selectAllStageElements() {
    const pageId = state.activePageId;
    const ids = state.stageElements
      .filter((element) => !element.pageId || element.pageId === pageId)
      .map((element) => element.id);
    if (!ids.length) return;
    setStageSelection(ids, ids[0]);
  }

  function selectNextStageElement(direction = 1) {
    const pageId = state.activePageId;
    const elements = state.stageElements.filter(
      (element) => !element.pageId || element.pageId === pageId
    );
    if (!elements.length) return;
    const currentId = state.selectedStageElementId;
    let index = elements.findIndex((element) => element.id === currentId);
    if (index === -1) {
      index = direction > 0 ? 0 : elements.length - 1;
    } else {
      index = (index + direction + elements.length) % elements.length;
    }
    selectStageElement(elements[index].id);
  }

  function getSelectedStageElement() {
    return (
      state.stageElements.find(
        (element) => element.id === state.selectedStageElementId
      ) || null
    );
  }

  function getSelectedStageElements() {
    if (
      !Array.isArray(state.selectedStageElementIds) ||
      !state.selectedStageElementIds.length
    ) {
      return [];
    }
    return state.selectedStageElementIds
      .map((id) => state.stageElements.find((element) => element.id === id))
      .filter(Boolean);
  }

  function filterToolbarFonts(query = '') {
    if (!el.toolbarFont) return;
    toolbarFontFilterQuery = query.trim();
    const normalized = toolbarFontFilterQuery.toLowerCase();
    if (!normalized) {
      renderToolbarFonts(toolbarFontAllOptions);
      return;
    }
    const selected = el.toolbarFont.value;
    const matches = toolbarFontAllOptions
      .map(function (option, index) {
        return {
          option: option,
          score: getToolbarFontMatchScore(option, normalized),
          index: index,
        };
      })
      .filter(function (entry) {
        return (
          entry.score > 0 ||
          (selected &&
            entry.option.value.toLowerCase() === selected.toLowerCase())
        );
      })
      .sort(function (a, b) {
        if (a.score !== b.score) return b.score - a.score;
        return a.index - b.index;
      })
      .slice(0, 120)
      .map(function (entry) {
        return entry.option;
      });
    renderToolbarFonts(matches);
    scheduleToolbarFontRemoteSearch(toolbarFontFilterQuery);
  }

  function getToolbarFontMatchScore(option, normalizedQuery) {
    const family = (option.value || option.label || '').toLowerCase();
    const label = (option.label || '').toLowerCase();
    const category = (option.category || '').toLowerCase();
    const style = (option.style || '').toLowerCase();
    const weight = (option.weight || '').toLowerCase();
    const tags = Array.isArray(option.tags)
      ? option.tags.join(' ').toLowerCase()
      : '';
    const variants = Array.isArray(option.variants)
      ? option.variants.join(' ').toLowerCase()
      : '';
    const searchText = (option.searchText || '').toLowerCase();
    let score = 0;
    if (family === normalizedQuery || label === normalizedQuery) score += 140;
    else if (
      family.startsWith(normalizedQuery) ||
      label.startsWith(normalizedQuery)
    )
      score += 110;
    else if (
      family.includes(normalizedQuery) ||
      label.includes(normalizedQuery)
    )
      score += 85;
    [category, style, weight, tags, variants, searchText].forEach(
      function (hay) {
        if (hay && hay.includes(normalizedQuery)) score += 25;
      }
    );
    return score;
  }

  function formatToolbarFontOptionLabel(option) {
    const label = option.label || option.value || '';
    const meta = [];
    if (option.category) meta.push(option.category);
    if (option.style) meta.push(option.style);
    if (option.weight) meta.push(option.weight);
    return meta.length ? label + ' - ' + meta.slice(0, 2).join(', ') : label;
  }

  function moveToolbarFontSelection(direction) {
    if (!el.toolbarFont) return;
    const options = Array.from(el.toolbarFont.options || []).filter(
      (option) => !option.hidden
    );
    if (!options.length) return;
    let index = options.findIndex((option) => option.selected);
    if (index === -1) index = 0;
    const nextIndex = (index + direction + options.length) % options.length;
    const nextOption = options[nextIndex];
    if (!nextOption) return;
    el.toolbarFont.value = nextOption.value;
    el.toolbarFont.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function moveToolbarFontFocus(direction) {
    if (!el.toolbarFont) return;
    const options = Array.from(el.toolbarFont.options || []).filter(
      (option) => !option.hidden
    );
    if (!options.length) return;
    let index = options.findIndex((option) => option.selected);
    if (index === -1) index = 0;
    const nextIndex = (index + direction + options.length) % options.length;
    const nextOption = options[nextIndex];
    if (!nextOption) return;
    el.toolbarFont.value = nextOption.value;
  }

  function getFirstVisibleToolbarFontOption() {
    if (!el.toolbarFont) return null;
    return (
      Array.from(el.toolbarFont.options || []).find(
        (option) => !option.hidden && !option.disabled && option.value
      ) || null
    );
  }

  function findToolbarFontOption(value) {
    const key = String(value || '').toLowerCase();
    if (!key) return null;
    return (
      toolbarFontAllOptions.find(
        (option) =>
          String(option.value || '').toLowerCase() === key ||
          String(option.label || '').toLowerCase() === key
      ) || null
    );
  }

  function cssFontFamilyValue(fontValue) {
    const family = String(fontValue || '').replace(/["\\]/g, '\\$&');
    return `"${family}", "Space Grotesk", "Manrope", system-ui, sans-serif`;
  }

  function setFontFamilyStyle(target, fontValue) {
    if (!target || !fontValue) return;
    target.style.fontFamily = cssFontFamilyValue(fontValue);
  }

  function getFontPreviewText(fontValue) {
    const selected = getSelectedStageElement();
    const text =
      selected && selected.type === 'text' && typeof selected.text === 'string'
        ? selected.text.trim()
        : '';
    return text || fontValue || 'Text';
  }

  function ensureToolbarFontOption(fontValue) {
    if (!fontValue) return;
    if (!findToolbarFontOption(fontValue)) {
      toolbarFontAllOptions.push({
        value: fontValue,
        label: fontValue,
        category: '',
      });
    }
    if (!el.toolbarFont) return;
    const exists = Array.from(el.toolbarFont.options || []).some(
      (option) => option.value === fontValue
    );
    if (exists) return;
    const option = document.createElement('option');
    option.value = fontValue;
    option.textContent = fontValue;
    setFontFamilyStyle(option, fontValue);
    el.toolbarFont.appendChild(option);
  }

  function saveRecentFont(fontValue) {
    if (!fontValue) return;
    const recent = loadRecentFonts();
    const next = [
      fontValue,
      ...recent.filter(
        (font) => font.toLowerCase() !== fontValue.toLowerCase()
      ),
    ];
    saveRecentFonts(next);
  }

  function applyToolbarFontValue(fontValue, options = {}) {
    let selected = getSelectedStageElement();
    if (!selected || selected.type !== 'text') {
      const textElements = state.stageElements.filter(
        (element) =>
          element &&
          element.type === 'text' &&
          (!state.activePageId ||
            !element.pageId ||
            element.pageId === state.activePageId)
      );
      if (textElements.length === 1) {
        selectStageElement(textElements[0].id);
        selected = textElements[0];
      }
    }
    if (!selected || selected.type !== 'text' || !fontValue) return false;
    const match = findToolbarFontOption(fontValue);
    const value = match ? match.value : fontValue;
    ensureToolbarFontOption(value);
    if (_fontUrlMap[value]) preloadFont(value, _fontUrlMap[value]);
    if (el.toolbarFont) el.toolbarFont.value = value;
    const preview =
      toolbarFontPreviewState &&
      toolbarFontPreviewState.id === selected.id &&
      toolbarFontPreviewState.value === value
        ? toolbarFontPreviewState
        : null;
    if (preview) {
      toolbarFontPreviewState = null;
      selected.fontFamily = value;
      renderStageElements();
      if (preview.original !== value) scheduleAutosave('stage-fontFamily');
    } else {
      clearToolbarFontPreview();
      selected = getSelectedStageElement();
      if (!selected || selected.type !== 'text') return false;
      updateStageElementField('fontFamily', value);
    }
    saveRecentFont(value);
    updateStageElementControls();
    if (el.toolbarFontSearch && !options.keepQuery) {
      el.toolbarFontSearch.value = '';
      toolbarFontFilterQuery = '';
    }
    renderToolbarFonts();
    if (el.toolbarFontSearch && options.keepQuery) {
      filterToolbarFonts(el.toolbarFontSearch.value);
    }
    renderFontPickerResults();
    return true;
  }

  function previewToolbarFontValue(fontValue) {
    const selected = getSelectedStageElement();
    if (!selected || selected.type !== 'text' || !fontValue) return false;
    const match = findToolbarFontOption(fontValue);
    const value = match ? match.value : fontValue;
    ensureToolbarFontOption(value);
    if (_fontUrlMap[value]) preloadFont(value, _fontUrlMap[value]);
    if (toolbarFontPreviewState && toolbarFontPreviewState.id !== selected.id) {
      clearToolbarFontPreview();
    }
    if (!toolbarFontPreviewState) {
      toolbarFontPreviewState = {
        id: selected.id,
        original: selected.fontFamily || 'Montserrat',
        toolbarValue: el.toolbarFont ? el.toolbarFont.value : '',
        value,
      };
    } else {
      toolbarFontPreviewState.value = value;
    }
    if (selected.fontFamily !== value) {
      selected.fontFamily = value;
      renderStageElements({ refreshList: false });
    }
    if (el.toolbarFont) el.toolbarFont.value = value;
    return true;
  }

  function clearToolbarFontPreview() {
    const preview = toolbarFontPreviewState;
    if (!preview) return;
    toolbarFontPreviewState = null;
    const element = state.stageElements.find((item) => item.id === preview.id);
    if (element && element.fontFamily === preview.value) {
      element.fontFamily = preview.original;
      renderStageElements({ refreshList: false });
    }
    if (el.toolbarFont && preview.toolbarValue) {
      el.toolbarFont.value = preview.toolbarValue;
    }
  }

  function loadRecentFonts() {
    try {
      const raw = localStorage.getItem(RECENT_FONTS_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(
        (font) => typeof font === 'string' && font.trim().length
      );
    } catch (err) {
      return [];
    }
  }

  function saveRecentFonts(fonts) {
    try {
      const trimmed = fonts.filter(
        (font) => typeof font === 'string' && font.trim().length
      );
      localStorage.setItem(
        RECENT_FONTS_KEY,
        JSON.stringify(trimmed.slice(0, 5))
      );
    } catch (err) {
      // ignore storage failures
    }
  }

  function renderToolbarFonts(fontOptions) {
    if (!el.toolbarFont) return;
    if (!toolbarFontAllOptions.length) {
      toolbarFontAllOptions = Array.from(el.toolbarFont.options || []).map(
        function (option) {
          return {
            value: option.value || option.textContent || '',
            label: option.textContent || option.value || '',
            category: '',
          };
        }
      );
    }
    var sourceOptions = Array.isArray(fontOptions)
      ? fontOptions
      : toolbarFontFilterQuery
        ? toolbarFontAllOptions
            .filter(function (option) {
              return (
                getToolbarFontMatchScore(
                  option,
                  toolbarFontFilterQuery.toLowerCase()
                ) > 0
              );
            })
            .slice(0, 120)
        : toolbarFontAllOptions;
    var selected = el.toolbarFont.value;
    var recentFonts = loadRecentFonts();
    var recentSet = new Set(
      recentFonts.map(function (f) {
        return f.toLowerCase();
      })
    );
    el.toolbarFont.innerHTML = '';
    if (!toolbarFontFilterQuery && recentFonts.length) {
      var recentGroup = document.createElement('optgroup');
      recentGroup.label = 'Recent';
      recentFonts.forEach(function (font) {
        var match = toolbarFontAllOptions.find(function (o) {
          return (
            o.value.toLowerCase() === font.toLowerCase() ||
            o.label.toLowerCase() === font.toLowerCase()
          );
        });
        if (!match) return;
        var opt = document.createElement('option');
        opt.value = match.value;
        opt.textContent = formatToolbarFontOptionLabel(match);
        setFontFamilyStyle(opt, match.value);
        recentGroup.appendChild(opt);
      });
      if (recentGroup.children.length) el.toolbarFont.appendChild(recentGroup);
    }
    var categories = [
      'display',
      'handwriting',
      'serif',
      'sans-serif',
      'sans serif',
      'monospace',
    ];
    var catLabels = {
      display: 'Display',
      handwriting: 'Handwriting',
      serif: 'Serif',
      'sans-serif': 'Sans Serif',
      'sans serif': 'Sans Serif',
      monospace: 'Monospace',
    };
    var hasCategories = toolbarFontAllOptions.some(function (o) {
      return o.category;
    });
    if (toolbarFontFilterQuery) {
      var searchGroup = document.createElement('optgroup');
      searchGroup.label = 'Search results';
      sourceOptions.forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o.value;
        opt.textContent = formatToolbarFontOptionLabel(o);
        setFontFamilyStyle(opt, o.value);
        searchGroup.appendChild(opt);
      });
      if (!searchGroup.children.length) {
        var emptyOpt = document.createElement('option');
        emptyOpt.value = selected || '';
        emptyOpt.textContent = 'No matching fonts';
        emptyOpt.disabled = true;
        searchGroup.appendChild(emptyOpt);
      }
      if (searchGroup.children.length) el.toolbarFont.appendChild(searchGroup);
    } else if (hasCategories) {
      categories.forEach(function (cat) {
        var items = sourceOptions.filter(function (o) {
          return (
            (o.category || '').toLowerCase() === cat &&
            !recentSet.has(o.value.toLowerCase())
          );
        });
        if (!items.length) return;
        var group = document.createElement('optgroup');
        group.label = catLabels[cat] || cat;
        items.forEach(function (o) {
          var opt = document.createElement('option');
          opt.value = o.value;
          opt.textContent = formatToolbarFontOptionLabel(o);
          setFontFamilyStyle(opt, o.value);
          group.appendChild(opt);
        });
        el.toolbarFont.appendChild(group);
      });
      var uncategorized = sourceOptions.filter(function (o) {
        return !o.category && !recentSet.has(o.value.toLowerCase());
      });
      if (uncategorized.length) {
        var otherGroup = document.createElement('optgroup');
        otherGroup.label = 'Other';
        uncategorized.forEach(function (o) {
          var opt = document.createElement('option');
          opt.value = o.value;
          opt.textContent = formatToolbarFontOptionLabel(o);
          setFontFamilyStyle(opt, o.value);
          otherGroup.appendChild(opt);
        });
        el.toolbarFont.appendChild(otherGroup);
      }
    } else {
      var allGroup = document.createElement('optgroup');
      allGroup.label = 'All fonts';
      sourceOptions.forEach(function (o) {
        if (
          recentSet.has(o.value.toLowerCase()) ||
          recentSet.has(o.label.toLowerCase())
        )
          return;
        var opt = document.createElement('option');
        opt.value = o.value;
        opt.textContent = formatToolbarFontOptionLabel(o);
        setFontFamilyStyle(opt, o.value);
        allGroup.appendChild(opt);
      });
      el.toolbarFont.appendChild(allGroup);
    }
    if (selected) el.toolbarFont.value = selected;
    if (!el.toolbarFont.value && el.toolbarFont.options.length)
      el.toolbarFont.selectedIndex = 0;
    renderToolbarFontChips();
    renderFontPickerResults();
  }

  const _fontUrlMap = {};
  const _fontLoadPromises = {};

  function ensureFontPickerModal() {
    if (el.fontPickerModal) return;
    const modal = document.createElement('div');
    modal.id = 'font-picker-modal';
    modal.className = 'font-picker-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="font-picker-panel" role="dialog" aria-modal="true" aria-label="Font picker">' +
      '<div class="font-picker-head">' +
      '<input id="font-picker-search" class="font-picker-search" type="text" placeholder="Search fonts" aria-label="Search fonts">' +
      '<button id="font-picker-close" class="font-picker-close" type="button" aria-label="Close font picker">&times;</button>' +
      '</div>' +
      '<div id="font-picker-filters" class="font-picker-filters" aria-label="Font filters"></div>' +
      '<div id="font-picker-results" class="font-picker-results" role="listbox" aria-label="Font results"></div>' +
      '</div>';
    document.body.appendChild(modal);
    el.fontPickerModal = modal;
    el.fontPickerSearch = getEl('font-picker-search');
    el.fontPickerClose = getEl('font-picker-close');
    el.fontPickerFilters = getEl('font-picker-filters');
    el.fontPickerResults = getEl('font-picker-results');
    if (el.fontPickerClose) {
      el.fontPickerClose.addEventListener('click', closeFontPickerModal);
    }
    if (el.fontPickerResults) {
      el.fontPickerResults.addEventListener(
        'pointerleave',
        clearToolbarFontPreview
      );
    }
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeFontPickerModal();
    });
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeFontPickerModal();
      }
    });
    if (el.fontPickerSearch) {
      el.fontPickerSearch.addEventListener('input', () => {
        toolbarFontPickerQuery = el.fontPickerSearch.value.trim();
        if (el.toolbarFontSearch) {
          el.toolbarFontSearch.value = el.fontPickerSearch.value;
          filterToolbarFonts(el.toolbarFontSearch.value);
        } else {
          renderFontPickerResults();
          scheduleFontPickerRemoteSearch(toolbarFontPickerQuery);
        }
      });
      el.fontPickerSearch.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeFontPickerModal();
          return;
        }
        if (event.key === 'Enter') {
          event.preventDefault();
          const first = el.fontPickerResults?.querySelector(
            '.font-picker-result:not(:disabled)'
          );
          if (first) first.click();
        }
      });
    }
    renderFontPickerFilters();
  }

  function openFontPickerModal(options = {}) {
    ensureFontPickerModal();
    if (!el.fontPickerModal) return;
    const wasOpen = el.fontPickerModal.classList.contains('open');
    toolbarFontPickerQuery =
      typeof options.query === 'string'
        ? options.query.trim()
        : toolbarFontPickerQuery;
    if (el.fontPickerSearch) el.fontPickerSearch.value = toolbarFontPickerQuery;
    el.fontPickerModal.classList.add('open');
    el.fontPickerModal.setAttribute('aria-hidden', 'false');
    renderFontPickerFilters();
    renderFontPickerResults();
    scheduleFontPickerRemoteSearch(toolbarFontPickerQuery);
    if (!wasOpen && el.fontPickerSearch) {
      requestAnimationFrame(() => {
        el.fontPickerSearch.focus();
        el.fontPickerSearch.select();
      });
    }
  }

  function closeFontPickerModal(options = {}) {
    if (!el.fontPickerModal) return;
    clearToolbarFontPreview();
    el.fontPickerModal.classList.remove('open');
    el.fontPickerModal.setAttribute('aria-hidden', 'true');
    if (options.restoreFocus && el.toolbarFontOpen) el.toolbarFontOpen.focus();
  }

  function renderFontPickerFilters() {
    if (!el.fontPickerFilters) return;
    const filters = [
      ['all', 'All'],
      ['recent', 'Recent'],
      ['display', 'Display'],
      ['handwriting', 'Handwriting'],
      ['serif', 'Serif'],
      ['sans-serif', 'Sans'],
      ['monospace', 'Mono'],
    ];
    el.fontPickerFilters.innerHTML = '';
    filters.forEach(([key, label]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'font-picker-filter';
      button.textContent = label;
      button.classList.toggle('active', toolbarFontPickerCategory === key);
      button.addEventListener('click', () => {
        toolbarFontPickerCategory = key;
        renderFontPickerFilters();
        renderFontPickerResults();
      });
      el.fontPickerFilters.appendChild(button);
    });
  }

  function getFontPickerOptions() {
    const query = toolbarFontPickerQuery.toLowerCase();
    const selectedValue = (el.toolbarFont && el.toolbarFont.value) || '';
    let options = toolbarFontAllOptions.slice();
    if (toolbarFontPickerCategory === 'recent') {
      const recent = new Set(
        loadRecentFonts().map((font) => font.toLowerCase())
      );
      options = options.filter((option) =>
        recent.has(String(option.value || option.label || '').toLowerCase())
      );
    } else if (toolbarFontPickerCategory !== 'all') {
      const category = toolbarFontPickerCategory;
      options = options.filter((option) => {
        const raw = String(option.category || '').toLowerCase();
        if (category === 'sans-serif')
          return raw === 'sans-serif' || raw === 'sans serif';
        return raw === category;
      });
    }
    if (!query) {
      const recent = loadRecentFonts();
      const recentRank = new Map(
        recent.map((font, index) => [font.toLowerCase(), index])
      );
      return options
        .map((option, index) => {
          const value = String(option.value || option.label || '');
          return {
            option,
            score: recentRank.has(value.toLowerCase())
              ? 1000 - recentRank.get(value.toLowerCase())
              : selectedValue &&
                  value.toLowerCase() === selectedValue.toLowerCase()
                ? 900
                : 0,
            index,
          };
        })
        .sort((a, b) => {
          if (a.score !== b.score) return b.score - a.score;
          return a.index - b.index;
        })
        .slice(0, 90)
        .map((entry) => entry.option);
    }
    return options
      .map((option, index) => ({
        option,
        score: getToolbarFontMatchScore(option, query),
        index,
      }))
      .filter((entry) => entry.score > 0)
      .sort((a, b) => {
        if (a.score !== b.score) return b.score - a.score;
        return a.index - b.index;
      })
      .slice(0, 90)
      .map((entry) => entry.option);
  }

  function renderFontPickerResults() {
    if (!el.fontPickerModal || !el.fontPickerResults) return;
    if (!el.fontPickerModal.classList.contains('open')) return;
    const options = getFontPickerOptions();
    const selectedValue = (el.toolbarFont && el.toolbarFont.value) || '';
    el.fontPickerResults.innerHTML = '';
    if (!options.length) {
      const empty = document.createElement('div');
      empty.className = 'font-picker-empty';
      empty.textContent = toolbarFontPickerQuery
        ? 'No local fonts found'
        : 'No fonts found';
      el.fontPickerResults.appendChild(empty);
      return;
    }
    options.forEach((option, index) => {
      const value = option.value || option.label || '';
      if (!value) return;
      if (index < 36 && _fontUrlMap[value])
        preloadFont(value, _fontUrlMap[value]).then(() => {
          if (button.isConnected) button.dataset.fontLoaded = '1';
        });
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'font-picker-result';
      button.setAttribute('role', 'option');
      button.setAttribute(
        'aria-selected',
        selectedValue && value.toLowerCase() === selectedValue.toLowerCase()
          ? 'true'
          : 'false'
      );
      button.classList.toggle(
        'active',
        selectedValue && value.toLowerCase() === selectedValue.toLowerCase()
      );
      const preview = document.createElement('span');
      preview.className = 'font-picker-preview';
      preview.textContent = getFontPreviewText(value);
      preview.title = value;
      setFontFamilyStyle(preview, value);
      const meta = document.createElement('span');
      meta.className = 'font-picker-meta';
      meta.textContent = [value, option.category, option.style, option.weight]
        .filter(Boolean)
        .slice(0, 2)
        .join(' - ');
      button.appendChild(preview);
      button.appendChild(meta);
      button.addEventListener('pointerenter', () => {
        previewToolbarFontValue(value);
      });
      button.addEventListener('focus', () => {
        previewToolbarFontValue(value);
      });
      button.addEventListener('click', () => {
        if (applyToolbarFontValue(value)) closeFontPickerModal();
      });
      el.fontPickerResults.appendChild(button);
    });
  }

  function normalizeFontAssetUrl(url) {
    if (typeof url !== 'string') return '';
    const trimmed = url.trim();
    const bucket = 'https://netwrckstatic.netwrck.com/static/fonts/';
    const prefix = '/vfast/data/fontcrawl/';
    if (trimmed.startsWith(prefix)) {
      return fontcrawlPathToBucketUrl(trimmed.slice(prefix.length), bucket);
    }
    const routePrefix = '/fonts/fontcrawl/';
    if (trimmed.startsWith(routePrefix)) {
      return fontcrawlPathToBucketUrl(
        trimmed.slice(routePrefix.length),
        bucket
      );
    }
    if (trimmed.startsWith('http://netwrckstatic.netwrck.com/static/fonts/')) {
      return 'https://' + trimmed.slice('http://'.length);
    }
    return trimmed;
  }

  function fontcrawlPathToBucketUrl(rel, bucket) {
    const parts = String(rel || '')
      .split('/')
      .filter(Boolean);
    if (parts.length >= 3) {
      const provider = encodeURIComponent(parts[0]);
      const providerId = encodeURIComponent(parts[1]);
      const filename = parts[parts.length - 1] || '';
      const extMatch = filename.match(/\.[a-z0-9]+$/i);
      return (
        bucket +
        provider +
        '/' +
        providerId +
        (extMatch ? extMatch[0] : '.woff2')
      );
    }
    return bucket + parts.map(encodeURIComponent).join('/');
  }

  function preloadFont(family, url) {
    url = normalizeFontAssetUrl(url);
    if (!family || !url) return Promise.resolve(false);
    try {
      if (document.fonts.check('16px "' + family + '"'))
        return Promise.resolve(true);
    } catch (e) {}
    const key = family + '|' + url;
    if (_fontLoadPromises[key]) return _fontLoadPromises[key];
    try {
      const face = new FontFace(family, 'url(' + url + ')');
      _fontLoadPromises[key] = face
        .load()
        .then(function (f) {
          document.fonts.add(f);
          return document.fonts
            .load('24px "' + String(family).replace(/["\\]/g, '\\$&') + '"')
            .then(function () {
              return true;
            });
        })
        .catch(function () {
          return false;
        });
      return _fontLoadPromises[key];
    } catch (e) {}
    return Promise.resolve(false);
  }

  async function fetchFontOptions(query, limit) {
    try {
      const params = new URLSearchParams();
      params.set('limit', String(limit || 3000));
      if (query && query.trim()) params.set('query', query.trim());
      const resp = await fetch('/api/search-fonts?' + params.toString());
      if (!resp.ok) return [];
      const fonts = await resp.json();
      if (!Array.isArray(fonts)) return [];
      return fonts.map(function (f) {
        if (f.url) _fontUrlMap[f.family] = normalizeFontAssetUrl(f.url);
        return {
          value: f.family,
          label: f.family,
          category: f.category || '',
          style: f.style || '',
          weight: f.weight || '',
          variants: Array.isArray(f.variants) ? f.variants : [],
          tags: Array.isArray(f.tags) ? f.tags : [],
          searchText: f.search_text || '',
        };
      });
    } catch (e) {
      return [];
    }
  }

  function mergeToolbarFontOptions(options) {
    if (!Array.isArray(options) || !options.length) return;
    var byValue = new Map();
    toolbarFontAllOptions.forEach(function (option, index) {
      byValue.set(option.value.toLowerCase(), index);
    });
    options.forEach(function (option) {
      if (!option || !option.value) return;
      var key = option.value.toLowerCase();
      if (byValue.has(key)) {
        toolbarFontAllOptions[byValue.get(key)] = Object.assign(
          {},
          toolbarFontAllOptions[byValue.get(key)],
          option
        );
      } else {
        byValue.set(key, toolbarFontAllOptions.length);
        toolbarFontAllOptions.push(option);
      }
    });
  }

  function scheduleToolbarFontRemoteSearch(query) {
    if (!query || query.trim().length < 2) return;
    if (toolbarFontSearchTimer) clearTimeout(toolbarFontSearchTimer);
    const searchQuery = query.trim();
    toolbarFontSearchTimer = setTimeout(async function () {
      const seq = ++toolbarFontSearchSeq;
      const results = await fetchFontOptions(searchQuery, 120);
      if (seq !== toolbarFontSearchSeq) return;
      if (!results.length) return;
      mergeToolbarFontOptions(results);
      if (
        el.toolbarFontSearch &&
        el.toolbarFontSearch.value.trim() === searchQuery
      ) {
        toolbarFontFilterQuery = searchQuery;
        renderToolbarFonts(results);
        renderFontPickerResults();
      }
    }, 180);
  }

  function scheduleFontPickerRemoteSearch(query) {
    if (!query || query.trim().length < 2) return;
    if (toolbarFontPickerTimer) clearTimeout(toolbarFontPickerTimer);
    const searchQuery = query.trim();
    toolbarFontPickerTimer = setTimeout(async function () {
      const seq = ++toolbarFontPickerSeq;
      const results = await fetchFontOptions(searchQuery, 240);
      if (seq !== toolbarFontPickerSeq) return;
      if (results.length) {
        mergeToolbarFontOptions(results);
      }
      if (
        el.fontPickerSearch &&
        el.fontPickerSearch.value.trim() === searchQuery
      ) {
        toolbarFontPickerQuery = searchQuery;
        renderFontPickerResults();
      }
    }, 180);
  }

  async function initToolbarFonts() {
    if (!el.toolbarFont) return;
    var apiFonts = await fetchFontOptions('', 3000);
    if (apiFonts.length) {
      toolbarFontAllOptions = apiFonts;
    } else if (!toolbarFontAllOptions.length) {
      toolbarFontAllOptions = Array.from(el.toolbarFont.options || []).map(
        function (option) {
          return {
            value: option.value || option.textContent || '',
            label: option.textContent || option.value || '',
            category: '',
          };
        }
      );
    }
    renderToolbarFonts();
  }

  function renderToolbarFontChips() {
    if (!el.toolbarFontRecents) return;
    const recentFonts = loadRecentFonts();
    el.toolbarFontRecents.innerHTML = '';
    if (!recentFonts.length) {
      el.toolbarFontRecents.style.display = 'none';
      return;
    }
    el.toolbarFontRecents.style.display = 'flex';
    const selectedFont = el.toolbarFont ? el.toolbarFont.value : '';
    recentFonts.forEach((font) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'toolbar-font-chip';
      button.textContent = font;
      button.dataset.font = font;
      button.title = font;
      setFontFamilyStyle(button, font);
      if (_fontUrlMap[font]) preloadFont(font, _fontUrlMap[font]);
      button.setAttribute('aria-label', `Recent font ${font}`);
      button.classList.toggle(
        'active',
        selectedFont && font.toLowerCase() === selectedFont.toLowerCase()
      );
      button.addEventListener('click', () => {
        if (!el.toolbarFont) return;
        el.toolbarFont.value = font;
        el.toolbarFont.dispatchEvent(new Event('change', { bubbles: true }));
      });
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          button.click();
          return;
        }
        if (
          event.key !== 'ArrowRight' &&
          event.key !== 'ArrowLeft' &&
          event.key !== 'ArrowUp' &&
          event.key !== 'ArrowDown'
        ) {
          return;
        }
        event.preventDefault();
        const chips = Array.from(
          el.toolbarFontRecents.querySelectorAll('.toolbar-font-chip')
        );
        if (!chips.length) return;
        const index = chips.indexOf(button);
        if (index === -1) return;
        const delta =
          event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
        const nextIndex = (index + delta + chips.length) % chips.length;
        chips[nextIndex].focus();
      });
      el.toolbarFontRecents.appendChild(button);
    });
  }

  function applyRecentFontByIndex(index) {
    if (!el.toolbarFont) return;
    const recentFonts = loadRecentFonts();
    const font = recentFonts[index];
    if (!font) return;
    el.toolbarFont.value = font;
    el.toolbarFont.dispatchEvent(new Event('change', { bubbles: true }));
  }

  var toolbarHsvColor = { h: 217, s: 39, v: 15 };

  function clampColorValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function hexToRgbColor(hex) {
    const color = normalizeHexColor(hex, '#111827').slice(1);
    return {
      r: parseInt(color.slice(0, 2), 16),
      g: parseInt(color.slice(2, 4), 16),
      b: parseInt(color.slice(4, 6), 16),
    };
  }

  function rgbToHexColor(r, g, b) {
    return (
      '#' +
      [r, g, b]
        .map((part) =>
          clampColorValue(Math.round(part), 0, 255)
            .toString(16)
            .padStart(2, '0')
        )
        .join('')
    );
  }

  function rgbToHsvColor(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const diff = max - min;
    let h = 0;
    if (diff) {
      if (max === r) h = ((g - b) / diff) % 6;
      else if (max === g) h = (b - r) / diff + 2;
      else h = (r - g) / diff + 4;
      h *= 60;
      if (h < 0) h += 360;
    }
    const s = max === 0 ? 0 : diff / max;
    return {
      h: Math.round(h),
      s: Math.round(s * 100),
      v: Math.round(max * 100),
    };
  }

  function hsvToRgbColor(h, s, v) {
    h = ((h % 360) + 360) % 360;
    s = clampColorValue(s, 0, 100) / 100;
    v = clampColorValue(v, 0, 100) / 100;
    const c = v * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = v - c;
    let r = 0;
    let g = 0;
    let b = 0;
    if (h < 60) {
      r = c;
      g = x;
    } else if (h < 120) {
      r = x;
      g = c;
    } else if (h < 180) {
      g = c;
      b = x;
    } else if (h < 240) {
      g = x;
      b = c;
    } else if (h < 300) {
      r = x;
      b = c;
    } else {
      r = c;
      b = x;
    }
    return {
      r: (r + m) * 255,
      g: (g + m) * 255,
      b: (b + m) * 255,
    };
  }

  function rgbToHslColor(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    const diff = max - min;
    let h = 0;
    let s = 0;
    if (diff) {
      s = diff / (1 - Math.abs(2 * l - 1));
      if (max === r) h = ((g - b) / diff) % 6;
      else if (max === g) h = (b - r) / diff + 2;
      else h = (r - g) / diff + 4;
      h *= 60;
      if (h < 0) h += 360;
    }
    return {
      h: Math.round(h),
      s: Math.round(s * 100),
      l: Math.round(l * 100),
    };
  }

  function hslToRgbColor(h, s, l) {
    h = ((h % 360) + 360) % 360;
    s = clampColorValue(s, 0, 100) / 100;
    l = clampColorValue(l, 0, 100) / 100;
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;
    let r = 0;
    let g = 0;
    let b = 0;
    if (h < 60) {
      r = c;
      g = x;
    } else if (h < 120) {
      r = x;
      g = c;
    } else if (h < 180) {
      g = c;
      b = x;
    } else if (h < 240) {
      g = x;
      b = c;
    } else if (h < 300) {
      r = x;
      b = c;
    } else {
      r = c;
      b = x;
    }
    return {
      r: (r + m) * 255,
      g: (g + m) * 255,
      b: (b + m) * 255,
    };
  }

  var toolbarColorMode = 'hsv';
  const TOOLBAR_RECENT_COLORS_KEY = 'netwrck_ve_recent_colors_v1';
  const TOOLBAR_FAV_COLORS_KEY = 'netwrck_ve_fav_colors_v1';

  function getToolbarHexValue() {
    const rgb = hsvToRgbColor(
      toolbarHsvColor.h,
      toolbarHsvColor.s,
      toolbarHsvColor.v
    );
    return rgbToHexColor(rgb.r, rgb.g, rgb.b);
  }

  function readStoredColors(key) {
    try {
      const list = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(list)
        ? list.filter((c) => /^#[0-9a-f]{6}$/i.test(String(c)))
        : [];
    } catch (e) {
      return [];
    }
  }

  function writeStoredColors(key, list) {
    try {
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }

  function recordRecentToolbarColor(hex) {
    if (!/^#[0-9a-f]{6}$/i.test(String(hex))) return;
    const next = [hex.toLowerCase()].concat(
      readStoredColors(TOOLBAR_RECENT_COLORS_KEY).filter(
        (c) => c.toLowerCase() !== hex.toLowerCase()
      )
    );
    writeStoredColors(TOOLBAR_RECENT_COLORS_KEY, next.slice(0, 8));
    renderToolbarColorRows();
  }

  function toggleToolbarFavColor(hex) {
    if (!/^#[0-9a-f]{6}$/i.test(String(hex))) return;
    const favs = readStoredColors(TOOLBAR_FAV_COLORS_KEY);
    const without = favs.filter((c) => c.toLowerCase() !== hex.toLowerCase());
    writeStoredColors(
      TOOLBAR_FAV_COLORS_KEY,
      without.length === favs.length
        ? [hex.toLowerCase()].concat(favs)
        : without
    );
    renderToolbarColorRows();
  }

  function applyToolbarHexColor(hex) {
    const color = normalizeHexColor(hex, getToolbarHexValue());
    syncToolbarHsvFromHex(color);
    const selected = getSelectedStageElement();
    if (selected && isToolbarColorElement(selected)) {
      updateStageElementField(getToolbarColorField(selected), color);
      updateStageElementControls();
    }
  }

  function renderToolbarColorRows() {
    const renderRow = (node, colors, kind) => {
      if (!node) return;
      node.innerHTML = '';
      node.dataset.empty =
        kind === 'fav'
          ? 'Press + to save colours'
          : kind === 'doc'
            ? 'Nothing on canvas yet'
            : 'No recent colours';
      colors.forEach((color) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'toolbar-color-dot';
        dot.style.background = color;
        dot.dataset.color = color;
        dot.title = kind === 'fav' ? `${color} (right-click removes)` : color;
        dot.setAttribute('aria-label', `Use colour ${color}`);
        dot.addEventListener('click', () => {
          applyToolbarHexColor(color);
          if (kind === 'recent') recordRecentToolbarColor(color);
        });
        if (kind === 'fav') {
          dot.addEventListener('contextmenu', (event) => {
            event.preventDefault();
            toggleToolbarFavColor(color);
          });
        }
        node.appendChild(dot);
      });
    };
    renderRow(el.toolbarColorDoc, getProjectColors(), 'doc');
    renderRow(
      el.toolbarColorFavs,
      readStoredColors(TOOLBAR_FAV_COLORS_KEY),
      'fav'
    );
    renderRow(
      el.toolbarColorRecents,
      readStoredColors(TOOLBAR_RECENT_COLORS_KEY),
      'recent'
    );
  }

  function getProjectColors() {
    const colors = new Set();
    const add = (value) => {
      if (typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value.trim())) {
        colors.add(value.trim().toLowerCase());
      }
    };
    (state.stageElements || []).forEach((item) => {
      if (!item) return;
      add(item.color);
      add(item.background);
      add(item.backgroundColor);
      add(item.stroke);
    });
    (state.clips || []).forEach((clip) => {
      if (!clip) return;
      add(clip.captionColor);
      add(clip.captionBackground);
    });
    return Array.from(colors).slice(0, 12);
  }

  function getToolbarColorSliderSpec() {
    const rgb = hsvToRgbColor(
      toolbarHsvColor.h,
      toolbarHsvColor.s,
      toolbarHsvColor.v
    );
    if (toolbarColorMode === 'rgb') {
      return [
        { key: 'r', label: 'R', min: 0, max: 255, value: Math.round(rgb.r) },
        { key: 'g', label: 'G', min: 0, max: 255, value: Math.round(rgb.g) },
        { key: 'b', label: 'B', min: 0, max: 255, value: Math.round(rgb.b) },
      ];
    }
    if (toolbarColorMode === 'hsl') {
      const hsl = rgbToHslColor(rgb.r, rgb.g, rgb.b);
      return [
        { key: 'h', label: 'H', min: 0, max: 360, value: hsl.h },
        { key: 's', label: 'S', min: 0, max: 100, value: hsl.s },
        { key: 'l', label: 'L', min: 0, max: 100, value: hsl.l },
      ];
    }
    return [];
  }

  function handleToolbarColorSliderInput() {
    if (!el.toolbarColorSliders) return;
    const read = (key, fallback) => {
      const input = el.toolbarColorSliders.querySelector(
        `input[data-key="${key}"]`
      );
      return input ? parseInt(input.value, 10) || 0 : fallback;
    };
    let rgb;
    if (toolbarColorMode === 'rgb') {
      rgb = { r: read('r', 0), g: read('g', 0), b: read('b', 0) };
    } else if (toolbarColorMode === 'hsl') {
      rgb = hslToRgbColor(read('h', 0), read('s', 0), read('l', 0));
    } else {
      return;
    }
    toolbarHsvColor = rgbToHsvColor(rgb.r, rgb.g, rgb.b);
    applyToolbarHsvColor();
  }

  function renderToolbarColorSliders(rebuild) {
    if (!el.toolbarColorSliders) return;
    const spec = getToolbarColorSliderSpec();
    if (!spec.length) {
      el.toolbarColorSliders.innerHTML = '';
      return;
    }
    if (
      rebuild ||
      el.toolbarColorSliders.children.length !== spec.length ||
      el.toolbarColorSliders.dataset.mode !== toolbarColorMode
    ) {
      el.toolbarColorSliders.innerHTML = '';
      el.toolbarColorSliders.dataset.mode = toolbarColorMode;
      spec.forEach((item) => {
        const row = document.createElement('div');
        row.className = 'toolbar-color-slider-row';
        const label = document.createElement('span');
        label.textContent = item.label;
        const input = document.createElement('input');
        input.type = 'range';
        input.min = String(item.min);
        input.max = String(item.max);
        input.value = String(item.value);
        input.dataset.key = item.key;
        input.setAttribute('aria-label', `${item.label} channel`);
        input.addEventListener('input', handleToolbarColorSliderInput);
        row.appendChild(label);
        row.appendChild(input);
        el.toolbarColorSliders.appendChild(row);
      });
      return;
    }
    spec.forEach((item) => {
      const input = el.toolbarColorSliders.querySelector(
        `input[data-key="${item.key}"]`
      );
      if (input && document.activeElement !== input) {
        input.value = String(item.value);
      }
    });
  }

  function setToolbarColorMode(mode) {
    if (!['hsv', 'rgb', 'hsl'].includes(mode)) mode = 'hsv';
    toolbarColorMode = mode;
    if (el.toolbarColorPopover) el.toolbarColorPopover.dataset.mode = mode;
    if (el.toolbarColorModes) {
      el.toolbarColorModes.querySelectorAll('button').forEach((btn) => {
        btn.classList.toggle('active', btn.dataset.mode === mode);
      });
    }
    renderToolbarColorSliders(true);
    renderToolbarHsv();
  }

  function syncToolbarHsvFromHex(hex) {
    const rgb = hexToRgbColor(hex);
    toolbarHsvColor = rgbToHsvColor(rgb.r, rgb.g, rgb.b);
    renderToolbarHsv();
  }

  function renderToolbarHsv() {
    const rgb = hsvToRgbColor(
      toolbarHsvColor.h,
      toolbarHsvColor.s,
      toolbarHsvColor.v
    );
    const hex = rgbToHexColor(rgb.r, rgb.g, rgb.b);
    const angle = ((toolbarHsvColor.h - 90) * Math.PI) / 180;
    const radius = clampColorValue(toolbarHsvColor.s, 0, 100) / 100;
    const center = 75;
    const thumbRadius = 70 * radius;
    if (el.toolbarHsvThumb) {
      el.toolbarHsvThumb.style.left =
        center + Math.cos(angle) * thumbRadius + 'px';
      el.toolbarHsvThumb.style.top =
        center + Math.sin(angle) * thumbRadius + 'px';
    }
    if (el.toolbarHsvSphere) {
      el.toolbarHsvSphere.style.setProperty(
        '--toolbar-picker-value',
        String(clampColorValue(toolbarHsvColor.v, 0, 100) / 100)
      );
    }
    if (el.toolbarHsvValue) el.toolbarHsvValue.value = toolbarHsvColor.v;
    let readouts = [
      ['H', toolbarHsvColor.h],
      ['S', toolbarHsvColor.s],
      ['V', toolbarHsvColor.v],
    ];
    if (toolbarColorMode === 'rgb') {
      readouts = [
        ['R', Math.round(rgb.r)],
        ['G', Math.round(rgb.g)],
        ['B', Math.round(rgb.b)],
      ];
    } else if (toolbarColorMode === 'hsl') {
      const hsl = rgbToHslColor(rgb.r, rgb.g, rgb.b);
      readouts = [
        ['H', hsl.h],
        ['S', hsl.s],
        ['L', hsl.l],
      ];
    }
    if (el.toolbarHsvH)
      el.toolbarHsvH.textContent = readouts[0][0] + ' ' + readouts[0][1];
    if (el.toolbarHsvS)
      el.toolbarHsvS.textContent = readouts[1][0] + ' ' + readouts[1][1];
    if (el.toolbarHsvV)
      el.toolbarHsvV.textContent = readouts[2][0] + ' ' + readouts[2][1];
    if (el.toolbarHsvHex && document.activeElement !== el.toolbarHsvHex)
      el.toolbarHsvHex.value = hex.toUpperCase();
    renderToolbarColorSliders(false);
    if (el.toolbarColorPicker) {
      el.toolbarColorPicker.value = hex;
      el.toolbarColorPicker.style.background =
        'radial-gradient(circle, #fff 0%, rgba(255,255,255,0) 70%), conic-gradient(#ff0000, #ffff00, #00ff00, #00ffff, #0000ff, #ff00ff, #ff0000)';
    }
  }

  function applyToolbarHsvColor() {
    const rgb = hsvToRgbColor(
      toolbarHsvColor.h,
      toolbarHsvColor.s,
      toolbarHsvColor.v
    );
    const hex = rgbToHexColor(rgb.r, rgb.g, rgb.b);
    const selected = getSelectedStageElement();
    renderToolbarHsv();
    if (!selected || !isToolbarColorElement(selected)) return;
    updateStageElementField(getToolbarColorField(selected), hex);
    updateStageElementControls();
  }

  function setToolbarHsvFromPointer(event) {
    if (!el.toolbarHsvSphere) return;
    const rect = el.toolbarHsvSphere.getBoundingClientRect();
    const x = event.clientX - rect.left - rect.width / 2;
    const y = event.clientY - rect.top - rect.height / 2;
    const radius = Math.min(Math.sqrt(x * x + y * y), rect.width / 2);
    const saturation = clampColorValue(
      Math.round((radius / (rect.width / 2)) * 100),
      0,
      100
    );
    const hue = Math.round(((Math.atan2(y, x) * 180) / Math.PI + 450) % 360);
    toolbarHsvColor.h = hue;
    toolbarHsvColor.s = saturation;
    applyToolbarHsvColor();
  }

  function openToolbarColorPopover() {
    if (!el.toolbarColorPopover) return;
    closeToolbarTransparencyPopover();
    positionToolbarColorPopover();
    el.toolbarColorPopover.classList.add('is-open');
    if (el.toolbarColorPicker)
      el.toolbarColorPicker.setAttribute('aria-expanded', 'true');
    syncToolbarHsvFromHex(
      el.toolbarColorPicker ? el.toolbarColorPicker.value : '#111827'
    );
    renderToolbarColorRows();
    renderToolbarColorSliders(true);
  }

  function positionToolbarColorPopover() {
    if (!el.toolbarColorPopover || !el.toolbarColorPicker) return;
    const pickerRect = el.toolbarColorPicker.getBoundingClientRect();
    const popoverWidth = 212;
    const popoverHeight = el.toolbarColorPopover.offsetHeight || 380;
    const margin = 8;
    const maxLeft = Math.max(margin, window.innerWidth - popoverWidth - margin);
    const left = Math.max(
      margin,
      Math.min(
        maxLeft,
        pickerRect.left + pickerRect.width / 2 - popoverWidth / 2
      )
    );
    let top = pickerRect.bottom + margin;
    if (top + popoverHeight > window.innerHeight - margin) {
      top = Math.max(margin, pickerRect.top - popoverHeight - margin);
    }
    el.toolbarColorPopover.style.left = `${Math.round(left)}px`;
    el.toolbarColorPopover.style.top = `${Math.round(top)}px`;
  }

  function closeToolbarColorPopover() {
    if (!el.toolbarColorPopover) return;
    const wasOpen = el.toolbarColorPopover.classList.contains('is-open');
    el.toolbarColorPopover.classList.remove('is-open');
    if (el.toolbarColorPicker)
      el.toolbarColorPicker.setAttribute('aria-expanded', 'false');
    if (wasOpen) recordRecentToolbarColor(getToolbarHexValue());
  }

  function getSelectedOpacityValue(selected) {
    return Math.round(
      typeof selected?.opacity === 'number' ? selected.opacity : 100
    );
  }

  function syncToolbarTransparency(selected) {
    const value = selected ? getSelectedOpacityValue(selected) : 100;
    const disabled = !selected;
    const hex = normalizeHexColor(getToolbarElementColor(selected), '#111827');
    if (el.toolbarTransparency) {
      el.toolbarTransparency.disabled = false;
      el.toolbarTransparency.style.setProperty('--toolbar-alpha-color', hex);
      el.toolbarTransparency.style.setProperty(
        '--toolbar-alpha-preview',
        String(value / 100)
      );
      el.toolbarTransparency.setAttribute('aria-valuenow', String(value));
      el.toolbarTransparency.title = `Transparency ${100 - value}%`;
    }
    if (el.toolbarTransparencyPopover) {
      el.toolbarTransparencyPopover.style.setProperty(
        '--toolbar-alpha-color',
        hex
      );
    }
    if (
      el.toolbarTransparencySlider &&
      document.activeElement !== el.toolbarTransparencySlider
    ) {
      el.toolbarTransparencySlider.value = String(value);
    }
    if (el.toolbarTransparencySlider) {
      el.toolbarTransparencySlider.disabled = disabled;
    }
    if (el.toolbarTransparencyValue) {
      el.toolbarTransparencyValue.textContent = value + '%';
    }
  }

  function positionToolbarTransparencyPopover() {
    if (!el.toolbarTransparencyPopover || !el.toolbarTransparency) return;
    const buttonRect = el.toolbarTransparency.getBoundingClientRect();
    const popoverWidth = 190;
    const margin = 8;
    const maxLeft = Math.max(margin, window.innerWidth - popoverWidth - margin);
    const left = Math.max(
      margin,
      Math.min(
        maxLeft,
        buttonRect.left + buttonRect.width / 2 - popoverWidth / 2
      )
    );
    let top = buttonRect.bottom + margin;
    const popoverHeight = el.toolbarTransparencyPopover.offsetHeight || 74;
    if (top + popoverHeight > window.innerHeight - margin) {
      top = Math.max(margin, buttonRect.top - popoverHeight - margin);
    }
    el.toolbarTransparencyPopover.style.left = `${Math.round(left)}px`;
    el.toolbarTransparencyPopover.style.top = `${Math.round(top)}px`;
  }

  function openToolbarTransparencyPopover() {
    if (!el.toolbarTransparencyPopover) return;
    closeToolbarColorPopover();
    syncToolbarTransparency(getSelectedStageElement());
    positionToolbarTransparencyPopover();
    el.toolbarTransparencyPopover.classList.add('is-open');
    if (el.toolbarTransparency)
      el.toolbarTransparency.setAttribute('aria-expanded', 'true');
  }

  function closeToolbarTransparencyPopover() {
    if (!el.toolbarTransparencyPopover) return;
    el.toolbarTransparencyPopover.classList.remove('is-open');
    if (el.toolbarTransparency)
      el.toolbarTransparency.setAttribute('aria-expanded', 'false');
  }

  function isToolbarColorElement(selected) {
    return (
      !!selected && (selected.type === 'text' || selected.type === 'shape')
    );
  }

  function getToolbarColorField(selected) {
    return selected && selected.type === 'shape' ? 'background' : 'color';
  }

  function getToolbarElementColor(selected) {
    if (!selected) return '#111827';
    if (selected.type === 'shape') return selected.background || '#2563eb';
    return selected.color || '#111827';
  }

  function syncToolbarTextControls(selected) {
    const isText = selected && selected.type === 'text';
    const hasColor = isToolbarColorElement(selected);
    syncToolbarTransparency(selected);
    const controls = [
      el.toolbarFontSize,
      el.toolbarBold,
      el.toolbarItalic,
      el.toolbarUnderline,
    ];
    controls.forEach((ctrl) => {
      if (!ctrl) return;
      ctrl.disabled = !isText;
    });
    if (el.toolbarFontSearch) el.toolbarFontSearch.disabled = false;
    if (el.toolbarFont) el.toolbarFont.disabled = false;
    if (el.toolbarFontOpen) el.toolbarFontOpen.disabled = false;
    if (el.toolbarColorPicker) el.toolbarColorPicker.disabled = false;
    if (el.toolbarColorEyedrop) el.toolbarColorEyedrop.disabled = !hasColor;
    if (el.toolbarHsvValue) el.toolbarHsvValue.disabled = false;
    if (el.toolbarFontRecents) {
      el.toolbarFontRecents.querySelectorAll('button').forEach((button) => {
        button.disabled = false;
      });
    }
    if (el.toolbarColorSwatches && el.toolbarColorSwatches.length) {
      el.toolbarColorSwatches.forEach((swatch) => {
        swatch.disabled = !hasColor;
      });
    }
    if (!hasColor) {
      if (el.toolbarBold) el.toolbarBold.classList.remove('active');
      if (el.toolbarItalic) el.toolbarItalic.classList.remove('active');
      if (el.toolbarUnderline) el.toolbarUnderline.classList.remove('active');
      if (el.toolbarColorSwatches && el.toolbarColorSwatches.length) {
        el.toolbarColorSwatches.forEach((swatch) =>
          swatch.classList.remove('active')
        );
      }
      return;
    }
    const currentColor = normalizeHexColor(
      getToolbarElementColor(selected),
      selected.type === 'shape' ? '#2563eb' : '#111827'
    ).toLowerCase();
    if (el.toolbarColorPicker) {
      el.toolbarColorPicker.value = currentColor;
    }
    syncToolbarHsvFromHex(currentColor);
    if (el.toolbarColorSwatches && el.toolbarColorSwatches.length) {
      el.toolbarColorSwatches.forEach((swatch) => {
        const swatchColor = (swatch.dataset.color || '').toLowerCase();
        swatch.classList.toggle(
          'active',
          swatchColor && swatchColor === currentColor
        );
      });
    }
    if (!isText) {
      if (el.toolbarBold) el.toolbarBold.classList.remove('active');
      if (el.toolbarItalic) el.toolbarItalic.classList.remove('active');
      if (el.toolbarUnderline) el.toolbarUnderline.classList.remove('active');
      return;
    }
    if (el.toolbarFont) {
      const fontValue = selected.fontFamily || 'Montserrat';
      el.toolbarFont.value = fontValue;
    }
    if (el.toolbarFontSize) {
      el.toolbarFontSize.value = Math.round(selected.fontSize || 24);
    }
    const weight = selected.fontWeight || 600;
    const weightValue =
      typeof weight === 'string' ? weight.toLowerCase() : weight;
    const isBold =
      weightValue === 'bold' || weightValue === '700' || weightValue >= 600;
    if (el.toolbarBold) el.toolbarBold.classList.toggle('active', isBold);
    if (el.toolbarItalic)
      el.toolbarItalic.classList.toggle(
        'active',
        selected.fontStyle === 'italic'
      );
    if (el.toolbarUnderline)
      el.toolbarUnderline.classList.toggle(
        'active',
        selected.textDecoration === 'underline'
      );
    if (el.toolbarFontSearch) {
      filterToolbarFonts(el.toolbarFontSearch.value || '');
    }
    if (el.toolbarFontRecents) {
      renderToolbarFontChips();
    }
  }

  function ensureStageSelection() {
    if (state.selectedStageElementId) return true;
    if (!Array.isArray(state.stageElements) || !state.stageElements.length)
      return false;
    selectStageElement(state.stageElements[0].id);
    return !!state.selectedStageElementId;
  }

  function openInspectorGroup(key) {
    if (!el.inspectorPanel) return;
    if (isCompactEditorViewport()) setInspectorOpen(true);
    const details = el.inspectorPanel.querySelector(
      `[data-details-key="${key}"]`
    );
    if (!details) return;
    details.open = true;
    details.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function openStageSection(key) {
    if (!el.stageElementControls) return;
    if (!ensureStageSelection()) return;
    if (isCompactEditorViewport()) setInspectorOpen(true);
    el.stageElementControls.style.display = 'grid';
    const details = el.stageElementControls.querySelector(
      `[data-details-key="${key}"]`
    );
    if (!details) return;
    details.open = true;
    details.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function updateStageElementControls() {
    if (!el.stageElementControls) return;
    const selected = getSelectedStageElement();
    const selectedList = getSelectedStageElements();
    if (!selected) {
      el.stageElementControls.style.display = 'none';
      syncToolbarTextControls(null);
      if (el.stageKeyframeList) el.stageKeyframeList.innerHTML = '';
      if (el.stageAspectLockToggle) {
        el.stageAspectLockToggle.checked = false;
        el.stageAspectLockToggle.indeterminate = false;
        el.stageAspectLockToggle.disabled = true;
      }
      if (el.stageElementCopySize) el.stageElementCopySize.disabled = true;
      if (el.stageElementPasteSize) el.stageElementPasteSize.disabled = true;
      if (el.stageElementCopyStyle) el.stageElementCopyStyle.disabled = true;
      if (el.stageElementPasteStyle) el.stageElementPasteStyle.disabled = true;
      if (el.stageElementCopyOpacity)
        el.stageElementCopyOpacity.disabled = true;
      if (el.stageElementPasteOpacity)
        el.stageElementPasteOpacity.disabled = true;
      if (el.stageElementCopyVisibility)
        el.stageElementCopyVisibility.disabled = true;
      if (el.stageElementPasteVisibility)
        el.stageElementPasteVisibility.disabled = true;
      if (el.stageElementCopyPos) el.stageElementCopyPos.disabled = true;
      if (el.stageElementPastePos) el.stageElementPastePos.disabled = true;
      if (el.stageElementCopyRotation)
        el.stageElementCopyRotation.disabled = true;
      if (el.stageElementPasteRotation)
        el.stageElementPasteRotation.disabled = true;
      if (el.stageElementCopyAlign) el.stageElementCopyAlign.disabled = true;
      if (el.stageElementPasteAlign) el.stageElementPasteAlign.disabled = true;
      if (el.stageElementCopyScale) el.stageElementCopyScale.disabled = true;
      if (el.stageElementPasteScale) el.stageElementPasteScale.disabled = true;
      if (el.stageElementCopyStageAlign)
        el.stageElementCopyStageAlign.disabled = true;
      if (el.stageElementPasteStageAlign)
        el.stageElementPasteStageAlign.disabled = true;
      return;
    }
    syncStageAspectLockState(selectedList);
    el.stageElementControls.style.display = 'grid';
    el.stageElementControls.dataset.elementType = selected.type || 'text';
    if (el.stageSectionTextLabel) {
      el.stageSectionTextLabel.textContent =
        selected.type === 'text'
          ? 'Text'
          : selected.type === 'shape'
            ? 'Shape'
            : 'Media';
    }
    if (el.stageElementOpacityValue) {
      el.stageElementOpacityValue.textContent = `${Math.round(
        selected.opacity ?? 100
      )}%`;
    }
    const animParamsRow = el.stageElementControls.querySelector(
      '[data-text-anim-params]'
    );
    if (animParamsRow) {
      animParamsRow.hidden =
        selected.type !== 'text' ||
        !selected.textAnimation ||
        selected.textAnimation === 'none';
    }
    if (el.stageElementName) el.stageElementName.value = selected.name || '';
    if (el.stageElementText) {
      el.stageElementText.value = selected.text || '';
      el.stageElementText.disabled = selected.type !== 'text';
    }
    if (el.stageElementTextAlign) {
      el.stageElementTextAlign.value = selected.textAlign || 'center';
      el.stageElementTextAlign.disabled = selected.type !== 'text';
    }
    if (el.stageElementTextAnimation) {
      el.stageElementTextAnimation.value = selected.textAnimation || 'none';
      el.stageElementTextAnimation.disabled = selected.type !== 'text';
    }
    if (el.stageElementTextAnimDur) {
      el.stageElementTextAnimDur.value = selected.textAnimationDuration || 1;
    }
    if (el.stageElementTextAnimDelay) {
      el.stageElementTextAnimDelay.value = selected.textAnimationDelay || 0;
    }
    if (el.stageElementTextEffect) {
      el.stageElementTextEffect.value = selected.textEffect || 'none';
      el.stageElementTextEffect.disabled = selected.type !== 'text';
    }
    if (el.stageElementFontSize) {
      el.stageElementFontSize.value = Math.round(selected.fontSize || 24);
      el.stageElementFontSize.disabled = selected.type !== 'text';
    }
    if (el.stageElementColor) {
      el.stageElementColor.value = cssColorToHex(selected.color, '#f8fafc');
      el.stageElementColor.disabled = selected.type !== 'text';
    }
    if (el.stageElementBackground) {
      el.stageElementBackground.value = cssColorToHex(
        selected.background,
        '#0f172a'
      );
      el.stageElementBackground.disabled =
        selected.type !== 'text' && selected.type !== 'shape';
    }
    if (el.stageElementStyleReset) {
      el.stageElementStyleReset.disabled = selected.type !== 'text';
    }
    if (el.stageElementCopyStyle) {
      el.stageElementCopyStyle.disabled = selected.type !== 'text';
    }
    if (el.stageElementPasteStyle) {
      el.stageElementPasteStyle.disabled =
        selected.type !== 'text' || !state.stageElementStyleClipboard;
    }
    if (el.stageElementCopyAlign) {
      el.stageElementCopyAlign.disabled = selected.type !== 'text';
    }
    if (el.stageElementPasteAlign) {
      el.stageElementPasteAlign.disabled =
        selected.type !== 'text' || !state.stageElementAlignClipboard;
    }
    if (el.stageElementCopyScale) {
      el.stageElementCopyScale.disabled = false;
    }
    if (el.stageElementPasteScale) {
      el.stageElementPasteScale.disabled = !state.stageElementScaleClipboard;
    }
    if (el.stageElementCopyStageAlign) {
      el.stageElementCopyStageAlign.disabled = false;
    }
    if (el.stageElementPasteStageAlign) {
      el.stageElementPasteStageAlign.disabled =
        !state.stageElementStageAlignClipboard;
    }
    if (el.stageElementRotation) {
      el.stageElementRotation.value = Math.round(selected.rotation || 0);
    }
    if (el.stageElementCopyRotation) {
      el.stageElementCopyRotation.disabled = false;
    }
    if (el.stageElementPasteRotation) {
      el.stageElementPasteRotation.disabled =
        state.stageElementRotationClipboard === null ||
        typeof state.stageElementRotationClipboard === 'undefined';
    }
    if (el.stageElementOpacity) {
      el.stageElementOpacity.value = Math.round(
        typeof selected.opacity === 'number' ? selected.opacity : 100
      );
    }
    syncStageElementEffectsControls(selected);
    if (el.stageElementCopyOpacity) {
      el.stageElementCopyOpacity.disabled = false;
    }
    if (el.stageElementPasteOpacity) {
      el.stageElementPasteOpacity.disabled =
        !state.stageElementOpacityClipboard;
    }
    if (el.stageElementCopyVisibility) {
      el.stageElementCopyVisibility.disabled = false;
    }
    if (el.stageElementPasteVisibility) {
      el.stageElementPasteVisibility.disabled =
        state.stageElementVisibilityClipboard === null ||
        typeof state.stageElementVisibilityClipboard === 'undefined';
    }
    if (el.stageElementCopyPos) {
      el.stageElementCopyPos.disabled = false;
    }
    if (el.stageElementPastePos) {
      el.stageElementPastePos.disabled = !state.stageElementPositionClipboard;
    }
    if (el.stageElementX) el.stageElementX.value = Math.round(selected.x);
    if (el.stageElementY) el.stageElementY.value = Math.round(selected.y);
    if (el.stageElementWidth)
      el.stageElementWidth.value = Math.round(selected.w);
    if (el.stageElementHeight)
      el.stageElementHeight.value = Math.round(selected.h);
    if (el.stageKeyframeTrackSnap) {
      el.stageKeyframeTrackSnap.checked = state.stageKeyframeTrackSnap;
    }
    if (el.stageElementCopySize) el.stageElementCopySize.disabled = false;
    if (el.stageElementPasteSize) {
      el.stageElementPasteSize.disabled = !state.stageElementSizeClipboard;
    }
    if (el.stageElementCopyStyle) {
      el.stageElementCopyStyle.disabled = selected.type !== 'text';
    }
    if (el.stageElementPasteStyle) {
      el.stageElementPasteStyle.disabled =
        selected.type !== 'text' || !state.stageElementStyleClipboard;
    }
    syncToolbarTextControls(selected);
    renderStageKeyframeList();
    renderStageKeyframeTrack();
  }

  function syncStageInspectorLiveValues() {
    const selected = getSelectedStageElement();
    if (!selected) return;
    const active = document.activeElement;
    const setValue = (node, value) => {
      if (!node || node === active) return;
      node.value = value;
    };
    setValue(
      el.stageElementRotation,
      String(Math.round(((selected.rotation || 0) + 360) % 360))
    );
    setValue(
      el.stageElementOpacity,
      String(Math.round(selected.opacity ?? 100))
    );
    if (el.stageElementOpacityValue) {
      el.stageElementOpacityValue.textContent = `${Math.round(
        selected.opacity ?? 100
      )}%`;
    }
    setValue(el.stageElementX, String(Math.round(selected.x)));
    setValue(el.stageElementY, String(Math.round(selected.y)));
    setValue(el.stageElementWidth, String(Math.round(selected.w)));
    setValue(el.stageElementHeight, String(Math.round(selected.h)));
  }

  function scheduleStageInspectorLiveSync() {
    if (stageInspectorRaf) return;
    stageInspectorRaf = requestAnimationFrame(() => {
      stageInspectorRaf = null;
      syncStageInspectorLiveValues();
    });
  }

  function showStageDragHud(text, sub, clientX, clientY) {
    if (!el.stageDragHud || !el.previewStage) return;
    const rect = el.previewStage.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    el.stageDragHud.textContent = text;
    if (sub) {
      let subNode = el.stageDragHud.querySelector('.stage-drag-hud-sub');
      if (!subNode) {
        subNode = document.createElement('span');
        subNode.className = 'stage-drag-hud-sub';
        el.stageDragHud.appendChild(subNode);
      }
      subNode.textContent = sub;
    } else {
      const subNode = el.stageDragHud.querySelector('.stage-drag-hud-sub');
      if (subNode) subNode.remove();
    }
    el.stageDragHud.style.left = `${Math.max(0, Math.min(rect.width, clientX - rect.left))}px`;
    el.stageDragHud.style.top = `${Math.max(0, Math.min(rect.height, clientY - rect.top))}px`;
    el.stageDragHud.classList.add('on');
  }

  function hideStageDragHud() {
    if (!el.stageDragHud) return;
    el.stageDragHud.classList.remove('on');
  }

  function updateStageElementField(field, value) {
    const selected = getSelectedStageElement();
    if (!selected) return;
    if (selected[field] === value) return;
    selected[field] = value;
    renderStageElements();
    scheduleAutosave(`stage-${field}`);
  }

  async function activateEyedropper(target) {
    var selected = getSelectedStageElement();
    if (!selected) return;
    if (window.EyeDropper) {
      try {
        var dropper = new EyeDropper();
        var result = await dropper.open();
        if (result && result.sRGBHex) {
          selected[target] = result.sRGBHex;
          if (target === 'color' && el.stageElementColor)
            el.stageElementColor.value = result.sRGBHex;
          if (target === 'background' && el.stageElementBackground)
            el.stageElementBackground.value = result.sRGBHex;
          renderStageElements();
          scheduleAutosave(`stage-${target}`);
          updateStageElementControls();
        }
      } catch (_) {}
      return;
    }
    if (!el.previewCanvas || !el.previewCanvasShell) return;
    el.previewCanvasShell.classList.add('is-color-picking');
    return new Promise((resolve) => {
      var cleanup = function () {
        document.removeEventListener('pointerdown', pick, true);
        document.removeEventListener('keydown', cancel, true);
        el.previewCanvasShell.classList.remove('is-color-picking');
      };
      var apply = function (hex) {
        if (!hex) return;
        selected[target] = hex;
        if (target === 'color' && el.stageElementColor)
          el.stageElementColor.value = hex;
        if (target === 'background' && el.stageElementBackground)
          el.stageElementBackground.value = hex;
        renderStageElements();
        scheduleAutosave(`stage-${target}`);
        updateStageElementControls();
      };
      var pick = function (event) {
        if (!el.previewCanvasShell.contains(event.target)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var node = event.target.closest('.stage-element');
        var element =
          node &&
          state.stageElements.find((item) => item.id === node.dataset.stageId);
        var hex = element
          ? normalizeHexColor(getToolbarElementColor(element), '')
          : samplePreviewCanvasColor(event.clientX, event.clientY);
        cleanup();
        apply(hex);
        resolve(hex);
      };
      var cancel = function (event) {
        if (event.key !== 'Escape') return;
        cleanup();
        resolve(null);
      };
      document.addEventListener('pointerdown', pick, true);
      document.addEventListener('keydown', cancel, true);
    });
  }

  function samplePreviewCanvasColor(clientX, clientY) {
    var rect = el.previewCanvas.getBoundingClientRect();
    if (!rect.width || !rect.height) return '';
    var x = Math.max(
      0,
      Math.min(
        el.previewCanvas.width - 1,
        Math.floor(
          (clientX - rect.left) * (el.previewCanvas.width / rect.width)
        )
      )
    );
    var y = Math.max(
      0,
      Math.min(
        el.previewCanvas.height - 1,
        Math.floor(
          (clientY - rect.top) * (el.previewCanvas.height / rect.height)
        )
      )
    );
    try {
      var pixel = el.previewCanvas
        .getContext('2d')
        .getImageData(x, y, 1, 1).data;
      return rgbToHexColor(pixel[0], pixel[1], pixel[2]);
    } catch (_) {
      return '';
    }
  }

  function updateStageElementEffect(key, value) {
    var selected = getSelectedStageElement();
    if (!selected) return;
    if (!selected.effects) selected.effects = normalizeElementEffects(null);
    if (selected.effects[key] === value) return;
    selected.effects[key] = value;
    renderStageElements();
    scheduleAutosave('stage-effects');
  }

  function resetStageElementEffects() {
    var selected = getSelectedStageElement();
    if (!selected) return;
    selected.effects = normalizeElementEffects(null);
    syncStageElementEffectsControls(selected);
    renderStageElements();
    scheduleAutosave('stage-effects');
  }

  function syncStageElementEffectsControls(elem) {
    var fx =
      elem && elem.effects ? elem.effects : normalizeElementEffects(null);
    if (el.stageElementFxBlur) el.stageElementFxBlur.value = fx.blur;
    if (el.stageElementFxBrightness)
      el.stageElementFxBrightness.value = fx.brightness;
    if (el.stageElementFxContrast)
      el.stageElementFxContrast.value = fx.contrast;
    if (el.stageElementFxSaturation)
      el.stageElementFxSaturation.value = fx.saturation;
    if (el.stageElementFxHue) el.stageElementFxHue.value = fx.hueRotate;
  }

  function updateStageElementNumeric(field, value) {
    const selected = getSelectedStageElement();
    if (!selected) return;
    const before = JSON.stringify({
      x: selected.x,
      y: selected.y,
      w: selected.w,
      h: selected.h,
      value: selected[field],
    });
    const parsed = Math.max(0, parseFloat(value));
    if (Number.isNaN(parsed)) return;
    if (field === 'fontSize') {
      selected[field] = Math.max(8, Math.min(120, parsed));
    } else if (field === 'rotation') {
      selected[field] = Math.max(0, Math.min(360, parsed));
    } else if (field === 'opacity') {
      selected[field] = Math.max(0, Math.min(100, parsed));
    } else if (field === 'textAnimationDuration') {
      selected[field] = Math.max(0.1, Math.min(10, parsed));
    } else if (field === 'textAnimationDelay') {
      selected[field] = Math.max(0, Math.min(30, parsed));
    } else {
      const clamped = Math.max(0, Math.min(100, parsed));
      if (
        (field === 'w' || field === 'h') &&
        selected.aspectLocked &&
        selected.w &&
        selected.h
      ) {
        const ratio = selected.w / selected.h;
        if (field === 'w') {
          selected.w = Math.max(5, Math.min(100, clamped));
          selected.h = Math.max(5, Math.min(100, selected.w / ratio));
        } else {
          selected.h = Math.max(5, Math.min(100, clamped));
          selected.w = Math.max(5, Math.min(100, selected.h * ratio));
        }
      } else {
        selected[field] = clamped;
        if (field === 'w' || field === 'h') {
          selected[field] = Math.max(5, Math.min(100, selected[field]));
        }
      }
    }
    const after = JSON.stringify({
      x: selected.x,
      y: selected.y,
      w: selected.w,
      h: selected.h,
      value: selected[field],
    });
    if (before === after) return;
    renderStageElements();
    if (field === 'opacity') {
      if (el.stageElementOpacityValue) {
        el.stageElementOpacityValue.textContent = `${Math.round(
          selected.opacity ?? 100
        )}%`;
      }
      syncToolbarTransparency(selected);
    }
    const reason =
      field === 'x' || field === 'y'
        ? 'stage-move'
        : field === 'w' || field === 'h'
          ? 'stage-resize'
          : field === 'rotation'
            ? 'stage-rotate'
            : 'stage-edit';
    scheduleAutosave(reason);
  }

  function isCropStageElement(element) {
    return !!element && (element.type === 'image' || element.type === 'video');
  }

  function toggleStageCropMode() {
    const selected = getSelectedStageElement();
    if (!isCropStageElement(selected)) return;
    selected.cropMode = !selected.cropMode;
    if (!selected.cropMode) {
      renderStageElements();
      scheduleAutosave('stage-crop');
      scheduleStageInlineToolbarSync();
      return;
    }
    if (!Number.isFinite(selected.cropZoom)) selected.cropZoom = 1;
    if (!Number.isFinite(selected.cropX)) selected.cropX = 50;
    if (!Number.isFinite(selected.cropY)) selected.cropY = 50;
    renderStageElements();
    scheduleAutosave('stage-crop');
    scheduleStageInlineToolbarSync();
  }

  function resetStageElementCrop() {
    const selected = getSelectedStageElement();
    if (!isCropStageElement(selected)) return;
    selected.cropZoom = 1;
    selected.cropX = 50;
    selected.cropY = 50;
    renderStageElements();
    scheduleAutosave('stage-crop');
    scheduleStageInlineToolbarSync();
  }

  function updateSelectedStageElementCropFromInline() {
    const selected = getSelectedStageElement();
    if (!isCropStageElement(selected)) return;
    selected.cropMode = true;
    selected.cropZoom = Math.max(
      1,
      Math.min(
        3,
        (parseFloat(el.stageInlineCropZoom?.value || '100') || 100) / 100
      )
    );
    selected.cropX = Math.max(
      0,
      Math.min(100, parseFloat(el.stageInlineCropX?.value || '50') || 50)
    );
    selected.cropY = Math.max(
      0,
      Math.min(100, parseFloat(el.stageInlineCropY?.value || '50') || 50)
    );
    renderStageElements();
    scheduleAutosave('stage-crop');
  }

  function getStageElementPublicSrc(element) {
    if (!element) return '';
    const asset = state.assets.find((item) => item.id === element.assetId);
    return (asset && (asset.persistedSrc || asset.src)) || element.src || '';
  }

  function openSelectedStageElementExternalEditor() {
    const selected = getSelectedStageElement();
    if (!isCropStageElement(selected)) return;
    const src = getStageElementPublicSrc(selected);
    if (!src || src.startsWith('blob:')) {
      notify(
        'Upload or save this image before opening it in the external editor',
        'info'
      );
      return;
    }
    window.open(
      `https://editor.ebank.nz/index.html?imageUrl=${encodeURIComponent(src)}`,
      '_blank',
      'noopener'
    );
  }

  function openSelectedStageElementRelighting() {
    const selected = getSelectedStageElement();
    if (!selected || selected.type !== 'image') return;
    openRelightForStageElement(selected);
  }

  function openRelightForStageElement(element) {
    if (!element) return;
    if (element.type !== 'image') {
      notify('Relighting supports image elements', 'info');
      return;
    }
    const src = getStageElementPublicSrc(element);
    if (!src || src.startsWith('blob:')) {
      notify('Upload or save this image before opening relighting', 'info');
      return;
    }
    window.open(
      `/tools/relighting-photo-editor?image_url=${encodeURIComponent(src)}`,
      '_blank',
      'noopener'
    );
  }

  function openRelightForAsset(asset) {
    const src = (asset && (asset.persistedSrc || asset.src)) || '';
    if (!src || src.startsWith('blob:')) {
      notify('Upload or save this image before opening relighting', 'info');
      return;
    }
    window.open(
      `/tools/relighting-photo-editor?image_url=${encodeURIComponent(src)}`,
      '_blank',
      'noopener'
    );
  }

  function stashStyleTransferSource(src) {
    try {
      sessionStorage.setItem('netwrck_style_transfer_source', src);
    } catch (_) {}
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(src).catch(() => {});
    }
  }

  function openStyleTransferForStageElement(element) {
    if (!element) return;
    if (element.type !== 'image') {
      notify('Style transfer supports image elements', 'info');
      return;
    }
    const src = getStageElementPublicSrc(element);
    if (!src || src.startsWith('blob:')) {
      notify('Upload or save this asset before opening style transfer', 'info');
      return;
    }
    stashStyleTransferSource(src);
    window.open(
      `/tools/draw-ai-style-transfer?image_url=${encodeURIComponent(src)}`,
      '_blank',
      'noopener'
    );
  }

  function openStyleTransferForAsset(asset) {
    if (asset && asset.type !== 'image') {
      notify('Style transfer supports image assets', 'info');
      return;
    }
    const src = (asset && (asset.persistedSrc || asset.src)) || '';
    if (!src || src.startsWith('blob:')) {
      notify('Upload or save this asset before opening style transfer', 'info');
      return;
    }
    stashStyleTransferSource(src);
    window.open(
      `/tools/draw-ai-style-transfer?image_url=${encodeURIComponent(src)}`,
      '_blank',
      'noopener'
    );
  }

  function clipMatchesStageElement(clip, element) {
    if (!clip || !element) return false;
    const typeMatch =
      clip.type === element.type ||
      (clip.type === 'image' && element.type === 'image') ||
      (clip.type === 'video' && element.type === 'video');
    if (!typeMatch) return false;
    if (element.assetId && clip.assetId && element.assetId === clip.assetId)
      return true;
    if (element.src && clip.src && element.src === clip.src) return true;
    return false;
  }

  function collectClipIdsForStageElements(elements) {
    if (!Array.isArray(elements) || !elements.length) return [];
    const used = new Set();
    const ids = [];
    elements.forEach((element) => {
      const clip = state.clips.find(
        (item) => !used.has(item.id) && clipMatchesStageElement(item, element)
      );
      if (!clip) return;
      ids.push(clip.id);
      used.add(clip.id);
    });
    return ids;
  }

  function moveTimelineClipsByIds(direction, ids) {
    if (!Array.isArray(ids) || !ids.length) return false;
    const selection = new Set(ids);
    let moved = false;
    if (direction > 0) {
      for (let i = state.clips.length - 2; i >= 0; i -= 1) {
        if (
          selection.has(state.clips[i].id) &&
          !selection.has(state.clips[i + 1].id)
        ) {
          const temp = state.clips[i + 1];
          state.clips[i + 1] = state.clips[i];
          state.clips[i] = temp;
          moved = true;
        }
      }
    } else {
      for (let i = 1; i < state.clips.length; i += 1) {
        if (
          selection.has(state.clips[i].id) &&
          !selection.has(state.clips[i - 1].id)
        ) {
          const temp = state.clips[i - 1];
          state.clips[i - 1] = state.clips[i];
          state.clips[i] = temp;
          moved = true;
        }
      }
    }
    if (!moved) return false;
    pushTimelineHistory('reorder');
    reorderTimelineSelection();
    recalcTimeline();
    renderTimeline();
    scheduleAutosave();
    return true;
  }

  function moveTimelineClipsToEdge(edge, ids) {
    if (!Array.isArray(ids) || !ids.length) return false;
    const selection = new Set(ids);
    const selectedClips = state.clips.filter((clip) => selection.has(clip.id));
    if (!selectedClips.length) return false;
    const remaining = state.clips.filter((clip) => !selection.has(clip.id));
    if (edge === 'start') {
      state.clips = [...selectedClips, ...remaining];
    } else {
      state.clips = [...remaining, ...selectedClips];
    }
    pushTimelineHistory('reorder');
    reorderTimelineSelection();
    recalcTimeline();
    renderTimeline();
    scheduleAutosave();
    return true;
  }

  function moveStageElement(direction) {
    const selectedIds = Array.isArray(state.selectedStageElementIds)
      ? state.selectedStageElementIds
      : [];
    if (!selectedIds.length) return;
    const selectedSet = new Set(selectedIds);
    const selectedList = state.stageElements.filter((element) =>
      selectedSet.has(element.id)
    );
    const remaining = state.stageElements.filter(
      (element) => !selectedSet.has(element.id)
    );
    state.stageElements =
      direction > 0
        ? [...remaining, ...selectedList]
        : [...selectedList, ...remaining];
    renderStageElements();
    renderStageElementsList();
    renderTimeline();
    scheduleAutosave('stage-reorder');
    const clipIds = collectClipIdsForStageElements(selectedList);
    moveTimelineClipsToEdge(direction > 0 ? 'end' : 'start', clipIds);
  }

  function moveStageElementStep(direction) {
    const selectedIds = Array.isArray(state.selectedStageElementIds)
      ? state.selectedStageElementIds
      : [];
    if (!selectedIds.length) return;
    const selection = new Set(selectedIds);
    const selectedList = state.stageElements.filter((element) =>
      selection.has(element.id)
    );
    let moved = false;
    if (direction > 0) {
      for (let i = state.stageElements.length - 2; i >= 0; i -= 1) {
        if (
          selection.has(state.stageElements[i].id) &&
          !selection.has(state.stageElements[i + 1].id)
        ) {
          const temp = state.stageElements[i + 1];
          state.stageElements[i + 1] = state.stageElements[i];
          state.stageElements[i] = temp;
          moved = true;
        }
      }
    } else {
      for (let i = 1; i < state.stageElements.length; i += 1) {
        if (
          selection.has(state.stageElements[i].id) &&
          !selection.has(state.stageElements[i - 1].id)
        ) {
          const temp = state.stageElements[i - 1];
          state.stageElements[i - 1] = state.stageElements[i];
          state.stageElements[i] = temp;
          moved = true;
        }
      }
    }
    if (!moved) return;
    renderStageElements();
    renderStageElementsList();
    renderTimeline();
    scheduleAutosave('stage-reorder');
    const clipIds = collectClipIdsForStageElements(selectedList);
    moveTimelineClipsByIds(direction, clipIds);
  }

  function nudgeStageElement(dx, dy) {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (!selectedList.length) return;
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    const maxDx = 100 - bounds.maxX;
    const maxDy = 100 - bounds.maxY;
    const minDx = -bounds.minX;
    const minDy = -bounds.minY;
    const appliedDx = Math.max(minDx, Math.min(maxDx, dx));
    const appliedDy = Math.max(minDy, Math.min(maxDy, dy));
    selectedList.forEach((element) => {
      element.x += appliedDx;
      element.y += appliedDy;
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-move');
  }

  function computeStageBounds(elements) {
    if (!elements.length) return null;
    const minX = Math.min(...elements.map((el) => el.x));
    const minY = Math.min(...elements.map((el) => el.y));
    const maxX = Math.max(...elements.map((el) => el.x + el.w));
    const maxY = Math.max(...elements.map((el) => el.y + el.h));
    return { minX, minY, maxX, maxY };
  }

  function getUnlockedSelectionForTransform() {
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) {
      notify('Select one or more stage elements', 'info');
      return null;
    }
    const locked = selectedList.filter((element) => element.locked);
    if (locked.length) {
      notify('Unlock elements to transform the group', 'info');
      return null;
    }
    return selectedList;
  }

  function applyGroupBounds(selectedList, nextBounds, options = {}) {
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    const width = Math.max(5, nextBounds.maxX - nextBounds.minX);
    const height = Math.max(5, nextBounds.maxY - nextBounds.minY);
    const scaleX = width / (bounds.maxX - bounds.minX || 1);
    const scaleY = height / (bounds.maxY - bounds.minY || 1);
    selectedList.forEach((element) => {
      element.x = nextBounds.minX + (element.x - bounds.minX) * scaleX;
      element.y = nextBounds.minY + (element.y - bounds.minY) * scaleY;
      element.w = Math.max(5, element.w * scaleX);
      element.h = Math.max(5, element.h * scaleY);
      if (options.rotationDelta) {
        const nextRotation = (element.rotation || 0) + options.rotationDelta;
        element.rotation = (nextRotation + 360) % 360;
      }
    });
  }

  function alignStageElement(position) {
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) return;
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    let dx = 0;
    let dy = 0;
    if (position === 'left') {
      dx = -bounds.minX;
    } else if (position === 'center') {
      dx = 50 - (bounds.minX + bounds.maxX) / 2;
    } else if (position === 'right') {
      dx = 100 - bounds.maxX;
    } else if (position === 'top') {
      dy = -bounds.minY;
    } else if (position === 'middle') {
      dy = 50 - (bounds.minY + bounds.maxY) / 2;
    } else if (position === 'bottom') {
      dy = 100 - bounds.maxY;
    }
    selectedList.forEach((element) => {
      element.x = Math.max(0, Math.min(100 - element.w, element.x + dx));
      element.y = Math.max(0, Math.min(100 - element.h, element.y + dy));
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-align');
  }

  function alignStageElementAxis(axis, targetCenter) {
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) return;
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    if (axis === 'x') {
      const currentCenter = (bounds.minX + bounds.maxX) / 2;
      const dx = targetCenter - currentCenter;
      selectedList.forEach((element) => {
        element.x = Math.max(0, Math.min(100 - element.w, element.x + dx));
      });
    } else {
      const currentCenter = (bounds.minY + bounds.maxY) / 2;
      const dy = targetCenter - currentCenter;
      selectedList.forEach((element) => {
        element.y = Math.max(0, Math.min(100 - element.h, element.y + dy));
      });
    }
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-align');
  }

  function fitStageElementsToStage() {
    const selectedList = getUnlockedSelectionForTransform();
    if (!selectedList) return;
    applyGroupBounds(selectedList, { minX: 0, minY: 0, maxX: 100, maxY: 100 });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-transform');
  }

  function centerStageElements() {
    const selectedList = getUnlockedSelectionForTransform();
    if (!selectedList) return;
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    const width = bounds.maxX - bounds.minX;
    const height = bounds.maxY - bounds.minY;
    const minX = 50 - width / 2;
    const minY = 50 - height / 2;
    applyGroupBounds(selectedList, {
      minX: Math.max(0, Math.min(100 - width, minX)),
      minY: Math.max(0, Math.min(100 - height, minY)),
      maxX: Math.max(0, Math.min(100, minX + width)),
      maxY: Math.max(0, Math.min(100, minY + height)),
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-transform');
  }

  function snapStageElementsAspect(ratio) {
    const selectedList = getUnlockedSelectionForTransform();
    if (!selectedList) return;
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    const centerX = (bounds.minX + bounds.maxX) / 2;
    const centerY = (bounds.minY + bounds.maxY) / 2;
    const fullWidth = 100;
    const fullHeight = 100;
    let targetW = fullWidth;
    let targetH = fullWidth / ratio;
    if (targetH > fullHeight) {
      targetH = fullHeight;
      targetW = fullHeight * ratio;
    }
    const minX = Math.max(0, Math.min(100 - targetW, centerX - targetW / 2));
    const minY = Math.max(0, Math.min(100 - targetH, centerY - targetH / 2));
    applyGroupBounds(selectedList, {
      minX,
      minY,
      maxX: minX + targetW,
      maxY: minY + targetH,
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-transform');
  }

  function resetStageElementsRotation() {
    const selectedList = getUnlockedSelectionForTransform();
    if (!selectedList) return;
    selectedList.forEach((element) => {
      element.rotation = 0;
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-rotate');
  }

  function resetStageElementsScale() {
    const selectedList = getUnlockedSelectionForTransform();
    if (!selectedList) return;
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    const centerX = (bounds.minX + bounds.maxX) / 2;
    const centerY = (bounds.minY + bounds.maxY) / 2;
    const count = selectedList.length;
    const size = Math.max(8, Math.min(40, 22 + count * 2));
    selectedList.forEach((element, index) => {
      const offset = count > 1 ? (index - (count - 1) / 2) * (size + 2) : 0;
      element.w = size;
      element.h = size;
      element.x = Math.max(
        0,
        Math.min(100 - size, centerX - size / 2 + offset)
      );
      element.y = Math.max(0, Math.min(100 - size, centerY - size / 2));
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-resize');
  }

  function resetStageElementsPosition() {
    const selectedList = getUnlockedSelectionForTransform();
    if (!selectedList) return;
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    const width = bounds.maxX - bounds.minX;
    const height = bounds.maxY - bounds.minY;
    const minX = 50 - width / 2;
    const minY = 50 - height / 2;
    selectedList.forEach((element) => {
      element.x = Math.max(
        0,
        Math.min(100 - element.w, element.x + (minX - bounds.minX))
      );
      element.y = Math.max(
        0,
        Math.min(100 - element.h, element.y + (minY - bounds.minY))
      );
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-move');
  }

  function resetStageElementsAll() {
    const selectedList = getUnlockedSelectionForTransform();
    if (!selectedList) return;
    selectedList.forEach((element) => {
      element.rotation = 0;
    });
    const bounds = computeStageBounds(selectedList);
    if (bounds) {
      const width = bounds.maxX - bounds.minX;
      const height = bounds.maxY - bounds.minY;
      const minX = 50 - width / 2;
      const minY = 50 - height / 2;
      selectedList.forEach((element) => {
        element.x = Math.max(
          0,
          Math.min(100 - element.w, element.x + (minX - bounds.minX))
        );
        element.y = Math.max(
          0,
          Math.min(100 - element.h, element.y + (minY - bounds.minY))
        );
      });
    }
    resetStageElementsScale();
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-transform');
  }

  function addStageKeyframe(mode) {
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) {
      notify('Select a stage element to keyframe', 'info');
      return;
    }
    const time = Math.max(0, state.playhead || 0);
    const ease = el.stageKeyframeEase
      ? el.stageKeyframeEase.value || 'linear'
      : 'linear';
    selectedList.forEach((element) => {
      if (!Array.isArray(element.keyframes)) element.keyframes = [];
      const existing = element.keyframes.find(
        (kf) => Math.abs(kf.time - time) < 0.001
      );
      var isPos = mode === 'position' || mode === 'all';
      var isScale = mode === 'scale' || mode === 'all';
      var isOpacity = mode === 'opacity' || mode === 'all';
      if (!mode || mode === 'position') {
        isPos = true;
      }
      if (!mode || mode === 'opacity') {
        isOpacity = true;
      }
      const payload = {
        time,
        x: isPos ? element.x : null,
        y: isPos ? element.y : null,
        w: isScale ? element.w : null,
        h: isScale ? element.h : null,
        opacity: isOpacity ? element.opacity : null,
        ease,
      };
      if (existing) {
        if (payload.x !== null) existing.x = payload.x;
        if (payload.y !== null) existing.y = payload.y;
        if (payload.w !== null) existing.w = payload.w;
        if (payload.h !== null) existing.h = payload.h;
        if (payload.opacity !== null) existing.opacity = payload.opacity;
        existing.ease = ease;
      } else {
        element.keyframes.push(payload);
      }
      element.keyframes = normalizeStageKeyframes(element.keyframes);
    });
    renderStageKeyframeList();
    renderStageKeyframeTrack();
    scheduleAutosave('stage-keyframe');
    notify('Keyframe saved', 'success');
  }

  function clearStageKeyframes() {
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) return;
    selectedList.forEach((element) => {
      element.keyframes = [];
    });
    renderStageKeyframeList();
    renderStageKeyframeTrack();
    scheduleAutosave('stage-keyframe');
    notify('Keyframes cleared', 'info');
  }

  function renderStageKeyframeList() {
    if (!el.stageKeyframeList) return;
    el.stageKeyframeList.innerHTML = '';
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) {
      return;
    }
    const groups = [];
    const orderMap = new Map();
    state.stageElements.forEach((element, index) => {
      orderMap.set(element.id, index);
    });
    selectedList.forEach((element) => {
      const keyframes = Array.isArray(element.keyframes)
        ? element.keyframes
        : [];
      if (!keyframes.length) return;
      const filtered = keyframes.filter((kf) => {
        if (state.stageKeyframeFilter === 'pos') {
          return typeof kf.x === 'number' || typeof kf.y === 'number';
        }
        if (state.stageKeyframeFilter === 'opacity') {
          return typeof kf.opacity === 'number';
        }
        return true;
      });
      const items = filtered.map((kf) => ({
        elementId: element.id,
        time: kf.time,
        x: kf.x,
        y: kf.y,
        opacity: kf.opacity,
        ease: kf.ease,
      }));
      groups.push({
        elementId: element.id,
        name: element.name || 'Layer',
        order: orderMap.has(element.id)
          ? orderMap.get(element.id)
          : Number.MAX_SAFE_INTEGER,
        keyframes: items.sort((a, b) => a.time - b.time),
      });
    });
    const showHeaders = selectedList.length > 1;
    groups.sort((a, b) => a.order - b.order);
    groups.forEach((group) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'stage-keyframe-group';
      const isOpen = showHeaders
        ? state.stageKeyframeGroupOpen[group.elementId] !== false
        : true;
      if (!isOpen) {
        wrapper.classList.add('collapsed');
      }
      const soloActive = Boolean(state.stageKeyframeSoloId);
      const isSolo = state.stageKeyframeSoloId === group.elementId;
      const rowSolo = document.createElement('span');
      rowSolo.className = 'stage-keyframe-row-solo';
      rowSolo.textContent = isSolo ? 'Soloed' : '';
      rowSolo.title = 'Keyframes soloed for this element';
      if (showHeaders) {
        const header = document.createElement('div');
        header.className = 'stage-keyframe-group-title';
        const title = document.createElement('span');
        title.textContent = group.name || 'Layer';
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'stage-keyframe-group-toggle';
        toggle.textContent = isOpen ? 'Hide' : 'Show';
        toggle.addEventListener('click', (event) => {
          event.stopPropagation();
          state.stageKeyframeGroupOpen[group.elementId] = !isOpen;
          renderStageKeyframeList();
        });
        const isMuted =
          (soloActive && !isSolo) ||
          Boolean(
            state.stageKeyframeMuted &&
              state.stageKeyframeMuted[group.elementId]
          );
        const muteBtn = document.createElement('button');
        muteBtn.type = 'button';
        muteBtn.className = 'stage-keyframe-group-mute';
        muteBtn.textContent = isMuted ? 'Muted' : 'Live';
        muteBtn.title = isMuted ? 'Keyframes muted' : 'Mute keyframes';
        if (soloActive && !isSolo) {
          muteBtn.disabled = true;
        }
        const soloIndicator = document.createElement('span');
        soloIndicator.className = 'stage-keyframe-solo-indicator';
        soloIndicator.textContent = 'Solo';
        soloIndicator.title = 'Keyframes soloed for this element';
        soloIndicator.style.display = isSolo ? '' : 'none';
        muteBtn.addEventListener('click', (event) => {
          event.stopPropagation();
          state.stageKeyframeMuted[group.elementId] =
            !state.stageKeyframeMuted[group.elementId];
          renderStageKeyframeList();
          renderStageElements();
          scheduleAutosave('stage-keyframe');
        });
        const soloBtn = document.createElement('button');
        soloBtn.type = 'button';
        soloBtn.className = 'stage-keyframe-group-solo';
        soloBtn.textContent = isSolo ? 'Soloed' : 'Solo';
        soloBtn.title = isSolo ? 'Clear solo' : 'Solo keyframes';
        soloBtn.addEventListener('click', (event) => {
          event.stopPropagation();
          state.stageKeyframeSoloId = isSolo ? null : group.elementId;
          renderStageKeyframeList();
          renderStageElements();
        });
        header.appendChild(title);
        header.appendChild(soloIndicator);
        header.appendChild(muteBtn);
        header.appendChild(soloBtn);
        header.appendChild(toggle);
        header.addEventListener('click', () => {
          state.stageKeyframeGroupOpen[group.elementId] = !isOpen;
          renderStageKeyframeList();
        });
        wrapper.appendChild(header);
      }
      group.keyframes.forEach((kf) => {
        const row = document.createElement('div');
        row.className = 'stage-keyframe-item';
        row.addEventListener('click', () => {
          state.playhead = kf.time;
          renderFrameAt(kf.time);
          updateTimeLabel();
        });
        const label = document.createElement('span');
        const parts = [];
        if (typeof kf.x === 'number' || typeof kf.y === 'number')
          parts.push('pos');
        if (typeof kf.opacity === 'number') parts.push('opacity');
        const easeLabel =
          kf.ease && kf.ease !== 'linear' ? kf.ease.replace(/-/g, ' ') : '';
        label.textContent = `${kf.time.toFixed(2)}s • ${parts.join('+') || 'key'}`;
        let easeBadge = null;
        if (easeLabel) {
          easeBadge = document.createElement('span');
          easeBadge.className = 'stage-keyframe-ease';
          easeBadge.textContent = easeLabel;
        }
        const jumpBtn = document.createElement('button');
        jumpBtn.type = 'button';
        jumpBtn.className = 'stage-keyframe-jump';
        jumpBtn.textContent = 'Jump';
        jumpBtn.title = 'Jump to keyframe (Alt+[ / Alt+])';
        jumpBtn.addEventListener('click', (event) => {
          event.stopPropagation();
          state.playhead = kf.time;
          renderFrameAt(kf.time);
          updateTimeLabel();
        });
        const delBtn = document.createElement('button');
        delBtn.type = 'button';
        delBtn.textContent = 'Remove';
        delBtn.title = 'Remove keyframe (Del)';
        delBtn.addEventListener('click', (event) => {
          event.stopPropagation();
          removeStageKeyframe(kf.elementId, kf.time);
        });
        row.appendChild(label);
        if (isSolo) {
          row.appendChild(rowSolo);
        }
        if (easeBadge) {
          easeBadge.title = `Easing: ${easeLabel} (affects interpolation)`;
          row.appendChild(easeBadge);
        }
        row.appendChild(jumpBtn);
        row.appendChild(delBtn);
        wrapper.appendChild(row);
      });
      el.stageKeyframeList.appendChild(wrapper);
    });
  }

  function renderStageKeyframeTrack() {
    if (!el.stageKeyframeTrack) return;
    el.stageKeyframeTrack.innerHTML = '';
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) return;
    const duration = totalDuration();
    if (!duration) return;
    if (!el.stageKeyframeTrack.dataset.tooltipBound) {
      el.stageKeyframeTrack.addEventListener('click', (event) => {
        const rect = el.stageKeyframeTrack.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const ratio = Math.min(1, Math.max(0, x / rect.width));
        const time = ratio * duration;
        if (state.stageKeyframeTrackSnap) {
          const times = (el.stageKeyframeTrack.dataset.keyframeTimes || '')
            .split(',')
            .map((value) => parseFloat(value))
            .filter((value) => !Number.isNaN(value));
          if (!times.length) return;
          let nearest = times[0];
          let best = Math.abs(nearest - time);
          times.forEach((candidate) => {
            const diff = Math.abs(candidate - time);
            if (diff < best) {
              best = diff;
              nearest = candidate;
            }
          });
          state.playhead = nearest;
        } else {
          state.playhead = time;
        }
        renderFrameAt(state.playhead);
        updateTimeLabel();
      });
      el.stageKeyframeTrack.dataset.tooltipBound = 'true';
    }
    const markerMap = new Map();
    selectedList.forEach((element) => {
      const keyframes = normalizeStageKeyframes(element.keyframes);
      keyframes.forEach((kf) => {
        const key = kf.time;
        const existing = markerMap.get(key) || {
          time: kf.time,
          ease: 'linear',
        };
        const ease = normalizeEase(kf.ease || 'linear');
        if (ease !== 'linear') {
          if (existing.ease === 'linear') {
            existing.ease = ease;
          } else if (existing.ease !== ease) {
            existing.ease = 'mixed';
          }
        }
        markerMap.set(key, existing);
      });
    });
    const markers = Array.from(markerMap.values()).sort(
      (a, b) => a.time - b.time
    );
    el.stageKeyframeTrack.dataset.keyframeTimes = markers
      .map((marker) => marker.time)
      .join(',');
    el.stageKeyframeTrack._keyframeMeta = markers;
    markers.forEach((markerInfo) => {
      const time = markerInfo.time;
      const marker = document.createElement('div');
      marker.className = 'stage-keyframe-marker';
      if (markerInfo.ease && markerInfo.ease !== 'linear') {
        marker.classList.add('stage-keyframe-marker-ease');
        marker.classList.add(`stage-keyframe-marker-${markerInfo.ease}`);
      }
      marker.style.left = `${Math.max(0, Math.min(100, (time / duration) * 100))}%`;
      const easeLabel =
        markerInfo.ease && markerInfo.ease !== 'linear'
          ? markerInfo.ease.replace(/-/g, ' ')
          : '';
      marker.title = `${time.toFixed(2)}s${easeLabel ? ` • ${easeLabel}` : ''}`;
      marker.addEventListener('click', (event) => {
        event.stopPropagation();
        state.playhead = time;
        renderFrameAt(time);
        updateTimeLabel();
      });
      el.stageKeyframeTrack.appendChild(marker);
    });
  }

  function collectStageKeyframeTimes() {
    const selectedList = getSelectedStageElements();
    const markers = [];
    selectedList.forEach((element) => {
      const keyframes = normalizeStageKeyframes(element.keyframes);
      keyframes.forEach((kf) => {
        markers.push(kf.time);
      });
    });
    return Array.from(new Set(markers)).sort((a, b) => a - b);
  }

  function jumpStageKeyframe(direction) {
    const times = collectStageKeyframeTimes();
    if (!times.length) {
      notify('No keyframes to jump', 'info');
      return;
    }
    const current = state.playhead || 0;
    let target = null;
    if (direction === 'next') {
      target = times.find((time) => time > current + 0.0005);
      if (target === undefined) {
        notify('Already at last keyframe', 'info');
        return;
      }
    } else {
      for (let i = times.length - 1; i >= 0; i -= 1) {
        if (times[i] < current - 0.0005) {
          target = times[i];
          break;
        }
      }
      if (target === null) {
        notify('Already at first keyframe', 'info');
        return;
      }
    }
    state.playhead = target;
    renderFrameAt(target);
    updateTimeLabel();
  }

  function removeStageKeyframe(elementId, time) {
    const element = state.stageElements.find((entry) => entry.id === elementId);
    if (!element || !Array.isArray(element.keyframes)) return;
    element.keyframes = element.keyframes.filter(
      (kf) => Math.abs(kf.time - time) > 0.0001
    );
    renderStageKeyframeList();
    renderStageKeyframeTrack();
    scheduleAutosave('stage-keyframe');
  }

  function distributeStageElements(axis, spacingOverride = null) {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (selectedList.length < 3) {
      notify('Select at least 3 unlocked elements to distribute', 'info');
      return;
    }
    const axisKey = axis === 'vertical' ? 'y' : 'x';
    const sizeKey = axis === 'vertical' ? 'h' : 'w';
    const sorted = [...selectedList].sort((a, b) => a[axisKey] - b[axisKey]);
    const minPos = Math.min(...sorted.map((el) => el[axisKey]));
    const maxExtent = Math.max(
      ...sorted.map((el) => el[axisKey] + el[sizeKey])
    );
    const totalSize = sorted.reduce((sum, el) => sum + el[sizeKey], 0);
    const available = maxExtent - minPos - totalSize;
    if (available < 0) {
      notify('Not enough space to distribute elements', 'info');
      return;
    }
    let gap = available / (sorted.length - 1);
    if (typeof spacingOverride === 'number') {
      gap = spacingOverride;
      const needed = totalSize + gap * (sorted.length - 1);
      if (needed > maxExtent - minPos) {
        notify('Not enough space for the requested spacing', 'info');
        return;
      }
    }
    let cursor = minPos;
    sorted.forEach((el) => {
      el[axisKey] = Math.max(0, Math.min(100 - el[sizeKey], cursor));
      cursor += el[sizeKey] + gap;
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-distribute');
  }

  function tidyStageElements() {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (selectedList.length < 3) {
      notify('Select at least 3 unlocked elements to tidy', 'info');
      return;
    }
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    const width = bounds.maxX - bounds.minX;
    const height = bounds.maxY - bounds.minY;
    distributeStageElements(width >= height ? 'horizontal' : 'vertical');
  }

  function duplicateSelectedStageElement() {
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) return;
    const newIds = [];
    selectedList.forEach((element, index) => {
      const offset = 2 + index * 2;
      const next = {
        ...element,
        id: `stage_${Date.now()}_${Math.random().toString(16).slice(2)}`,
        x: Math.min(100 - element.w, element.x + offset),
        y: Math.min(100 - element.h, element.y + offset),
      };
      state.stageElements.push(next);
      newIds.push(next.id);
    });
    setStageSelection(newIds, newIds[newIds.length - 1] || null);
    renderStageElements();
    renderStageElementsList();
    scheduleAutosave('stage-duplicate');
  }

  function copySelectedStageElement() {
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) return;
    state.stageElementClipboard = selectedList.map((element) => ({
      ...element,
    }));
    const label =
      selectedList.length === 1
        ? 'Stage element copied'
        : `${selectedList.length} stage elements copied`;
    notify(label, 'info');
  }

  function copyStageElementSize() {
    const selected = getSelectedStageElement();
    if (!selected) {
      notify('Select a stage element to copy size', 'info');
      return;
    }
    state.stageElementSizeClipboard = { w: selected.w, h: selected.h };
    updateStageElementControls();
    notify('Stage size copied', 'info');
  }

  function copyStageElementStyle() {
    const selected = getSelectedStageElement();
    if (!selected || selected.type !== 'text') {
      notify('Select a text element to copy style', 'info');
      return;
    }
    state.stageElementStyleClipboard = {
      fontSize: selected.fontSize,
      fontFamily: selected.fontFamily,
      fontWeight: selected.fontWeight,
      fontStyle: selected.fontStyle,
      textDecoration: selected.textDecoration,
      color: selected.color,
      background: selected.background,
      textAlign: selected.textAlign,
      textEffect: selected.textEffect || 'none',
    };
    updateStageElementControls();
    notify('Text style copied', 'info');
  }

  function copyStageElementAlign() {
    const selected = getSelectedStageElement();
    if (!selected || selected.type !== 'text') {
      notify('Select a text element to copy alignment', 'info');
      return;
    }
    state.stageElementAlignClipboard = selected.textAlign || 'center';
    updateStageElementControls();
    notify('Text alignment copied', 'info');
  }

  function pasteStageElementAlign() {
    const selectedList = getSelectedStageElements().filter(
      (element) => element.type === 'text' && !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked text elements to paste alignment', 'info');
      return;
    }
    if (!state.stageElementAlignClipboard) {
      notify('No text alignment copied yet', 'info');
      return;
    }
    selectedList.forEach((element) => {
      element.textAlign = state.stageElementAlignClipboard;
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-textAlign');
    notify('Text alignment pasted', 'success');
  }

  function copyStageElementStageAlign() {
    const selected = getSelectedStageElement();
    if (!selected) {
      notify('Select a stage element to copy alignment', 'info');
      return;
    }
    state.stageElementStageAlignClipboard = {
      x: selected.x,
      y: selected.y,
      w: selected.w,
      h: selected.h,
    };
    updateStageElementControls();
    notify('Stage align copied', 'info');
  }

  function pasteStageElementStageAlign() {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked stage elements to paste alignment', 'info');
      return;
    }
    if (!state.stageElementStageAlignClipboard) {
      notify('No stage alignment copied yet', 'info');
      return;
    }
    const { x, y, w, h } = state.stageElementStageAlignClipboard;
    selectedList.forEach((element) => {
      const width = element.w;
      const height = element.h;
      const anchorX = x + w / 2;
      const anchorY = y + h / 2;
      element.x = Math.max(0, Math.min(100 - width, anchorX - width / 2));
      element.y = Math.max(0, Math.min(100 - height, anchorY - height / 2));
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-align');
    notify('Stage align pasted', 'success');
  }

  function copyStageElementScale() {
    const selected = getSelectedStageElement();
    if (!selected) {
      notify('Select a stage element to copy scale', 'info');
      return;
    }
    state.stageElementScaleClipboard = {
      w: selected.w,
      h: selected.h,
      aspectLocked: !!selected.aspectLocked,
    };
    updateStageElementControls();
    notify('Scale copied', 'info');
  }

  function pasteStageElementScale() {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked stage elements to paste scale', 'info');
      return;
    }
    if (!state.stageElementScaleClipboard) {
      notify('No scale copied yet', 'info');
      return;
    }
    const { w, h, aspectLocked } = state.stageElementScaleClipboard;
    selectedList.forEach((element) => {
      const centerX = element.x + element.w / 2;
      const centerY = element.y + element.h / 2;
      element.w = Math.max(5, Math.min(100, w));
      if (aspectLocked) {
        const ratio = w / h;
        element.h = Math.max(5, Math.min(100, element.w / ratio));
        element.aspectLocked = true;
      } else {
        element.h = Math.max(5, Math.min(100, h));
      }
      element.x = Math.max(
        0,
        Math.min(100 - element.w, centerX - element.w / 2)
      );
      element.y = Math.max(
        0,
        Math.min(100 - element.h, centerY - element.h / 2)
      );
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-resize');
    notify('Scale pasted', 'success');
  }

  function copyStageElementOpacity() {
    const selected = getSelectedStageElement();
    if (!selected) {
      notify('Select a stage element to copy opacity', 'info');
      return;
    }
    state.stageElementOpacityClipboard =
      typeof selected.opacity === 'number' ? selected.opacity : 100;
    updateStageElementControls();
    notify('Opacity copied', 'info');
  }

  function copyStageElementVisibility() {
    const selected = getSelectedStageElement();
    if (!selected) {
      notify('Select a stage element to copy visibility', 'info');
      return;
    }
    state.stageElementVisibilityClipboard = !!selected.hidden;
    updateStageElementControls();
    notify('Visibility copied', 'info');
  }

  function copyStageElementPosition() {
    const selected = getSelectedStageElement();
    if (!selected) {
      notify('Select a stage element to copy position', 'info');
      return;
    }
    state.stageElementPositionClipboard = { x: selected.x, y: selected.y };
    updateStageElementControls();
    notify('Position copied', 'info');
  }

  function copyStageElementRotation() {
    const selected = getSelectedStageElement();
    if (!selected) {
      notify('Select a stage element to copy rotation', 'info');
      return;
    }
    state.stageElementRotationClipboard =
      typeof selected.rotation === 'number' ? selected.rotation : 0;
    updateStageElementControls();
    notify('Rotation copied', 'info');
  }

  function pasteStageElementRotation() {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked stage elements to paste rotation', 'info');
      return;
    }
    if (
      state.stageElementRotationClipboard === null ||
      typeof state.stageElementRotationClipboard === 'undefined'
    ) {
      notify('No rotation copied yet', 'info');
      return;
    }
    const value = Math.max(
      0,
      Math.min(360, state.stageElementRotationClipboard)
    );
    selectedList.forEach((element) => {
      element.rotation = value;
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-rotate');
    notify('Rotation pasted', 'success');
  }

  function pasteStageElementPosition() {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked stage elements to paste position', 'info');
      return;
    }
    if (!state.stageElementPositionClipboard) {
      notify('No position copied yet', 'info');
      return;
    }
    const { x, y } = state.stageElementPositionClipboard;
    selectedList.forEach((element) => {
      element.x = Math.max(0, Math.min(100 - element.w, x));
      element.y = Math.max(0, Math.min(100 - element.h, y));
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-move');
    notify('Position pasted', 'success');
  }

  function pasteStageElementOpacity() {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked stage elements to paste opacity', 'info');
      return;
    }
    if (
      state.stageElementOpacityClipboard === null ||
      typeof state.stageElementOpacityClipboard === 'undefined'
    ) {
      notify('No opacity copied yet', 'info');
      return;
    }
    const value = Math.max(
      0,
      Math.min(100, state.stageElementOpacityClipboard)
    );
    selectedList.forEach((element) => {
      element.opacity = value;
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-opacity');
    notify('Opacity pasted', 'success');
  }

  function pasteStageElementVisibility() {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked stage elements to paste visibility', 'info');
      return;
    }
    if (
      state.stageElementVisibilityClipboard === null ||
      typeof state.stageElementVisibilityClipboard === 'undefined'
    ) {
      notify('No visibility copied yet', 'info');
      return;
    }
    selectedList.forEach((element) => {
      element.hidden = !!state.stageElementVisibilityClipboard;
    });
    renderStageElements();
    renderStageElementsList();
    updateStageElementControls();
    scheduleAutosave('stage-visibility');
    notify('Visibility pasted', 'success');
  }

  function pasteStageElementStyle() {
    const selectedList = getSelectedStageElements().filter(
      (element) => element.type === 'text' && !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked text elements to paste style', 'info');
      return;
    }
    if (!state.stageElementStyleClipboard) {
      notify('No text style copied yet', 'info');
      return;
    }
    selectedList.forEach((element) => {
      element.fontSize = state.stageElementStyleClipboard.fontSize;
      element.fontFamily =
        state.stageElementStyleClipboard.fontFamily || 'Montserrat';
      element.fontWeight = state.stageElementStyleClipboard.fontWeight || 600;
      element.fontStyle =
        state.stageElementStyleClipboard.fontStyle || 'normal';
      element.textDecoration =
        state.stageElementStyleClipboard.textDecoration || 'none';
      element.color = state.stageElementStyleClipboard.color;
      element.background = state.stageElementStyleClipboard.background;
      element.textAlign = state.stageElementStyleClipboard.textAlign;
      element.textEffect =
        state.stageElementStyleClipboard.textEffect || 'none';
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-style');
    notify('Text style pasted', 'success');
  }

  function resetStageElementStyle() {
    const selectedList = getSelectedStageElements().filter(
      (element) => element.type === 'text' && !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked text elements to reset style', 'info');
      return;
    }
    selectedList.forEach((element) => {
      element.fontSize = 24;
      element.fontFamily = 'Montserrat';
      element.fontWeight = 600;
      element.fontStyle = 'normal';
      element.textDecoration = 'none';
      element.color = '#0f172a';
      element.background = '';
      element.textAlign = 'center';
      element.textEffect = 'none';
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-style');
    notify('Text style reset', 'success');
  }

  function pasteStageElementSize() {
    const selectedList = getSelectedStageElements().filter(
      (element) => !element.locked
    );
    if (!selectedList.length) {
      notify('Select unlocked stage elements to paste size', 'info');
      return;
    }
    if (!state.stageElementSizeClipboard) {
      notify('No size copied yet', 'info');
      return;
    }
    const { w, h } = state.stageElementSizeClipboard;
    selectedList.forEach((element) => {
      const centerX = element.x + element.w / 2;
      const centerY = element.y + element.h / 2;
      element.w = Math.max(5, Math.min(100, w));
      element.h = Math.max(5, Math.min(100, h));
      element.x = Math.max(
        0,
        Math.min(100 - element.w, centerX - element.w / 2)
      );
      element.y = Math.max(
        0,
        Math.min(100 - element.h, centerY - element.h / 2)
      );
    });
    renderStageElements();
    updateStageElementControls();
    scheduleAutosave('stage-resize');
    notify('Stage size pasted', 'success');
  }

  function pasteStageElementFromClipboard() {
    const clipboard = Array.isArray(state.stageElementClipboard)
      ? state.stageElementClipboard
      : state.stageElementClipboard
        ? [state.stageElementClipboard]
        : [];
    if (!clipboard.length) {
      notify('Nothing to paste', 'info');
      return;
    }
    const newIds = [];
    clipboard.forEach((base, index) => {
      const offset = 2 + index * 2;
      const next = {
        ...base,
        id: `stage_${Date.now()}_${Math.random().toString(16).slice(2)}`,
        x: Math.min(100 - base.w, base.x + offset),
        y: Math.min(100 - base.h, base.y + offset),
      };
      state.stageElements.push(next);
      newIds.push(next.id);
    });
    setStageSelection(newIds, newIds[newIds.length - 1] || null);
    renderStageElements();
    renderStageElementsList();
    scheduleAutosave('stage-paste');
  }

  function removeSelectedStageElement() {
    const selectedIds = Array.isArray(state.selectedStageElementIds)
      ? state.selectedStageElementIds
      : [];
    if (!selectedIds.length) return;
    state.stageElements = state.stageElements.filter(
      (element) => !selectedIds.includes(element.id)
    );
    state.selectedStageElementId = null;
    state.selectedStageElementIds = [];
    renderStageElements();
    renderTimeline();
    updateStageElementControls();
    renderInspector();
    scheduleAutosave('stage-remove');
  }

  function toggleStageElementVisibility(id) {
    const element = state.stageElements.find((entry) => entry.id === id);
    if (!element) return;
    element.hidden = !element.hidden;
    renderStageElements();
    renderStageElementsList();
    renderTimeline();
    scheduleAutosave('stage-visibility');
  }

  function toggleStageElementLock(id) {
    const element = state.stageElements.find((entry) => entry.id === id);
    if (!element) return;
    element.locked = !element.locked;
    renderStageElements();
    renderStageElementsList();
    renderTimeline();
    scheduleAutosave('stage-lock');
  }

  function getStageRect() {
    if (el.stageElements) {
      return el.stageElements.getBoundingClientRect();
    }
    if (el.previewCanvas) {
      return el.previewCanvas.getBoundingClientRect();
    }
    return null;
  }

  function isSingleTextStageSelection(
    selectedList = getSelectedStageElements()
  ) {
    return (
      selectedList.length === 1 &&
      !!selectedList[0] &&
      selectedList[0].type === 'text'
    );
  }

  function clampStageRange(min, max) {
    const size = max - min;
    if (!Number.isFinite(size) || size <= 0) return { min: 0, max: 5 };
    if (size >= 100) return { min: 0, max: 100 };
    let nextMin = min;
    let nextMax = max;
    if (nextMin < 0) {
      nextMax -= nextMin;
      nextMin = 0;
    }
    if (nextMax > 100) {
      nextMin -= nextMax - 100;
      nextMax = 100;
    }
    nextMin = Math.max(0, nextMin);
    nextMax = Math.min(100, nextMax);
    return { min: nextMin, max: nextMax };
  }

  function resolveAspectLockedResizeBounds(bounds, handle, scale) {
    if (!bounds || !handle || !Number.isFinite(scale)) return bounds;
    const width = bounds.maxX - bounds.minX;
    const height = bounds.maxY - bounds.minY;
    if (!(width > 0) || !(height > 0)) return bounds;
    const hasHorizontal = handle.includes('l') || handle.includes('r');
    const hasVertical = handle.includes('t') || handle.includes('b');
    if (!hasHorizontal && !hasVertical) return bounds;
    const centerX = (bounds.minX + bounds.maxX) / 2;
    const centerY = (bounds.minY + bounds.maxY) / 2;
    const minScale = Math.max(5 / width, 5 / height);
    let maxScale = Infinity;
    if (hasHorizontal && hasVertical) {
      const anchorX = handle.includes('l') ? bounds.maxX : bounds.minX;
      const anchorY = handle.includes('t') ? bounds.maxY : bounds.minY;
      const maxWidth = handle.includes('l') ? anchorX : 100 - anchorX;
      const maxHeight = handle.includes('t') ? anchorY : 100 - anchorY;
      maxScale = Math.min(maxWidth / width, maxHeight / height);
    } else if (hasHorizontal) {
      const anchorX = handle.includes('l') ? bounds.maxX : bounds.minX;
      const maxWidth = handle.includes('l') ? anchorX : 100 - anchorX;
      const maxHeight = 2 * Math.min(centerY, 100 - centerY);
      maxScale = Math.min(maxWidth / width, maxHeight / height);
    } else if (hasVertical) {
      const anchorY = handle.includes('t') ? bounds.maxY : bounds.minY;
      const maxHeight = handle.includes('t') ? anchorY : 100 - anchorY;
      const maxWidth = 2 * Math.min(centerX, 100 - centerX);
      maxScale = Math.min(maxWidth / width, maxHeight / height);
    }
    const limit = Number.isFinite(maxScale) ? maxScale : scale;
    const nextScale = Math.max(minScale, Math.min(limit, scale));
    const nextWidth = width * nextScale;
    const nextHeight = height * nextScale;
    let minX = bounds.minX;
    let minY = bounds.minY;
    let maxX = bounds.maxX;
    let maxY = bounds.maxY;
    if (hasHorizontal && hasVertical) {
      if (handle.includes('l')) {
        minX = bounds.maxX - nextWidth;
        maxX = bounds.maxX;
      } else {
        minX = bounds.minX;
        maxX = bounds.minX + nextWidth;
      }
      if (handle.includes('t')) {
        minY = bounds.maxY - nextHeight;
        maxY = bounds.maxY;
      } else {
        minY = bounds.minY;
        maxY = bounds.minY + nextHeight;
      }
    } else if (hasHorizontal) {
      if (handle.includes('l')) {
        minX = bounds.maxX - nextWidth;
        maxX = bounds.maxX;
      } else {
        minX = bounds.minX;
        maxX = bounds.minX + nextWidth;
      }
      const rangeY = clampStageRange(
        centerY - nextHeight / 2,
        centerY + nextHeight / 2
      );
      minY = rangeY.min;
      maxY = rangeY.max;
    } else {
      const rangeX = clampStageRange(
        centerX - nextWidth / 2,
        centerX + nextWidth / 2
      );
      minX = rangeX.min;
      maxX = rangeX.max;
      if (handle.includes('t')) {
        minY = bounds.maxY - nextHeight;
        maxY = bounds.maxY;
      } else {
        minY = bounds.minY;
        maxY = bounds.minY + nextHeight;
      }
    }
    return {
      minX: Math.max(0, minX),
      minY: Math.max(0, minY),
      maxX: Math.min(100, maxX),
      maxY: Math.min(100, maxY),
    };
  }

  function handleStageGroupPointerDown(event) {
    const target = event.target;
    const handleTarget =
      target && target.closest ? target.closest('[data-handle]') : null;
    if (!handleTarget || !el.stageSelectionBox.contains(handleTarget)) return;
    const handle = handleTarget.getAttribute('data-handle');
    if (!handle) return;
    const selectedList = getSelectedStageElements();
    if (!selectedList.length) return;
    if (selectedList.some((element) => element.locked)) {
      notify('Unlock elements to transform the group', 'info');
      return;
    }
    const rect = getStageRect();
    if (!rect) return;
    const bounds = computeStageBounds(selectedList);
    if (!bounds) return;
    stagePointerId = event.pointerId;
    const centerX =
      rect.left +
      ((bounds.minX + (bounds.maxX - bounds.minX) / 2) / 100) * rect.width;
    const centerY =
      rect.top +
      ((bounds.minY + (bounds.maxY - bounds.minY) / 2) / 100) * rect.height;
    const startAngle = Math.atan2(
      event.clientY - centerY,
      event.clientX - centerX
    );
    stageDrag = {
      mode:
        handle === 'rotate'
          ? 'rotate'
          : handle === 'opacity'
            ? 'opacity'
            : 'resize',
      handle,
      pointerX: event.clientX,
      pointerY: event.clientY,
      rect,
      elements: selectedList.map((entry) => ({
        id: entry.id,
        startX: entry.x,
        startY: entry.y,
        startW: entry.w,
        startH: entry.h,
        startRotation: entry.rotation || 0,
        startOpacity: typeof entry.opacity === 'number' ? entry.opacity : 100,
      })),
      bounds,
      rotation: {
        centerX,
        centerY,
        startAngle,
      },
      startFingerprint: currentProjectFingerprint(),
      aspectLocked:
        (selectedList.length === 1 && selectedList[0].type === 'text') ||
        selectedList.every((entry) => entry.aspectLocked),
    };
    scheduleStageInlineToolbarSync();
    event.preventDefault();
    event.stopPropagation();
    window.addEventListener('pointermove', handleStagePointerMove);
    window.addEventListener('pointerup', handleStagePointerUp);
    window.addEventListener('pointercancel', handleStagePointerCancel);
  }

  function handleStagePointerDown(event, id) {
    const target = event.target;
    const element = state.stageElements.find((entry) => entry.id === id);
    if (!element) return;
    if (target && target.isContentEditable) return;
    if (target && target.closest && target.closest('.stage-element.editing'))
      return;
    const handleTarget =
      target && target.closest
        ? target.closest('.stage-handle[data-handle]')
        : null;
    const handle =
      handleTarget && handleTarget.getAttribute
        ? handleTarget.getAttribute('data-handle')
        : null;
    if (!handle && (event.shiftKey || event.ctrlKey || event.metaKey)) {
      selectStageElement(id, { toggle: true });
      return;
    }
    if (
      !Array.isArray(state.selectedStageElementIds) ||
      !state.selectedStageElementIds.includes(id)
    ) {
      selectStageElement(id);
    }
    if (element.locked) return;
    const rect = getStageRect();
    if (!rect) return;
    const selectedList = getSelectedStageElements();
    const movableList = selectedList.filter((entry) => !entry.locked);
    if (!movableList.length) return;
    stagePointerId = event.pointerId;
    const pointerX = event.clientX;
    const pointerY = event.clientY;
    const isHandle = Boolean(handle);
    const bounds = computeStageBounds(movableList);
    let rotation = null;
    if (handle === 'rotate' && bounds) {
      const centerX =
        rect.left +
        ((bounds.minX + (bounds.maxX - bounds.minX) / 2) / 100) * rect.width;
      const centerY =
        rect.top +
        ((bounds.minY + (bounds.maxY - bounds.minY) / 2) / 100) * rect.height;
      rotation = {
        centerX,
        centerY,
        startAngle: Math.atan2(pointerY - centerY, pointerX - centerX),
      };
    }
    stageDrag = {
      mode: handle === 'rotate' ? 'rotate' : isHandle ? 'resize' : 'move',
      handle,
      pointerX,
      pointerY,
      rect,
      elements: movableList.map((entry) => ({
        id: entry.id,
        startX: entry.x,
        startY: entry.y,
        startW: entry.w,
        startH: entry.h,
        startRotation: entry.rotation || 0,
      })),
      rotation,
      startFingerprint: currentProjectFingerprint(),
      aspectLocked:
        (movableList.length === 1 && movableList[0].type === 'text') ||
        (movableList.length > 0 &&
          movableList.every((entry) => entry.aspectLocked)),
      bounds,
    };
    scheduleStageInlineToolbarSync();
    event.preventDefault();
    event.stopPropagation();
    window.addEventListener('pointermove', handleStagePointerMove);
    window.addEventListener('pointerup', handleStagePointerUp);
    window.addEventListener('pointercancel', handleStagePointerCancel);
  }

  function resizeSingleRotatedStageElement(event, drag, rect) {
    const entries = Array.isArray(drag.elements) ? drag.elements : [];
    if (entries.length !== 1 || drag.mode !== 'resize') return false;
    const entry = entries[0];
    const element = state.stageElements.find((item) => item.id === entry.id);
    if (!element) return false;
    const rotation = ((Number(entry.startRotation) || 0) + 360) % 360;
    if (!rotation) return false;
    const handle = drag.handle || '';
    const sideX = handle.includes('l') ? -1 : handle.includes('r') ? 1 : 0;
    const sideY = handle.includes('t') ? -1 : handle.includes('b') ? 1 : 0;
    if (!sideX && !sideY) return false;
    const startW = Math.max(5, Number(entry.startW) || 5);
    const startH = Math.max(5, Number(entry.startH) || 5);
    const angle = (rotation * Math.PI) / 180;
    const axisX = { x: Math.cos(angle), y: Math.sin(angle) };
    const axisY = { x: -Math.sin(angle), y: Math.cos(angle) };
    const deltaX = event.clientX - drag.pointerX;
    const deltaY = event.clientY - drag.pointerY;
    const localDx = ((deltaX * axisX.x + deltaY * axisX.y) / rect.width) * 100;
    const localDy = ((deltaX * axisY.x + deltaY * axisY.y) / rect.height) * 100;
    let nextW = sideX ? startW + sideX * localDx : startW;
    let nextH = sideY ? startH + sideY * localDy : startH;
    if (drag.aspectLocked) {
      const scaleX = sideX ? nextW / startW : 1;
      const scaleY = sideY ? nextH / startH : 1;
      let scale =
        sideX && sideY
          ? Math.abs(scaleX - 1) > Math.abs(scaleY - 1)
            ? scaleX
            : scaleY
          : sideX
            ? scaleX
            : scaleY;
      scale = Math.max(Math.max(5 / startW, 5 / startH), scale);
      nextW = startW * scale;
      nextH = startH * scale;
    } else {
      nextW = Math.max(5, nextW);
      nextH = Math.max(5, nextH);
    }
    nextW = Math.min(100, nextW);
    nextH = Math.min(100, nextH);
    let centerX =
      rect.left + ((entry.startX + entry.startW / 2) / 100) * rect.width;
    let centerY =
      rect.top + ((entry.startY + entry.startH / 2) / 100) * rect.height;
    if (sideX) {
      const shift = (sideX * (nextW - startW) * rect.width) / 200;
      centerX += axisX.x * shift;
      centerY += axisX.y * shift;
    }
    if (sideY) {
      const shift = (sideY * (nextH - startH) * rect.height) / 200;
      centerX += axisY.x * shift;
      centerY += axisY.y * shift;
    }
    let nextX = ((centerX - rect.left) / rect.width) * 100 - nextW / 2;
    let nextY = ((centerY - rect.top) / rect.height) * 100 - nextH / 2;
    nextX = Math.max(0, Math.min(100 - nextW, nextX));
    nextY = Math.max(0, Math.min(100 - nextH, nextY));
    element.x = nextX;
    element.y = nextY;
    element.w = nextW;
    element.h = nextH;
    return true;
  }

  function handleStagePointerMove(event) {
    if (
      !stageDrag ||
      (stagePointerId !== null && event.pointerId !== stagePointerId)
    )
      return;
    const { rect } = stageDrag;
    if (!rect) return;
    const dx = ((event.clientX - stageDrag.pointerX) / rect.width) * 100;
    const dy = ((event.clientY - stageDrag.pointerY) / rect.height) * 100;
    const elements = Array.isArray(stageDrag.elements)
      ? stageDrag.elements
      : [];
    if (!elements.length) return;
    const bounds = stageDrag.bounds;
    let guideX = null;
    let guideY = null;
    if (stageDrag.mode === 'move') {
      if (!bounds) return;
      if (stageDrag.bounds) {
        setStageSelectionGhost({
          minX: stageDrag.bounds.minX,
          minY: stageDrag.bounds.minY,
          maxX: stageDrag.bounds.maxX,
          maxY: stageDrag.bounds.maxY,
        });
      }
      const maxDx = 100 - bounds.maxX;
      const maxDy = 100 - bounds.maxY;
      const minDx = -bounds.minX;
      const minDy = -bounds.minY;
      let appliedDx = Math.max(minDx, Math.min(maxDx, dx));
      let appliedDy = Math.max(minDy, Math.min(maxDy, dy));
      if (state.stageSnapEnabled) {
        const nextX = bounds.minX + appliedDx;
        const nextY = bounds.minY + appliedDy;
        const threshold = state.stageSnapStrength || 1.5;
        var bw = bounds.maxX - bounds.minX;
        var bh = bounds.maxY - bounds.minY;
        var xTargets = buildStageMoveSnapTargets('x', bw);
        var yTargets = buildStageMoveSnapTargets('y', bh);
        var dragIds = new Set(
          elements.map(function (e) {
            return e.id;
          })
        );
        state.stageElements.forEach(function (other) {
          if (dragIds.has(other.id) || other.hidden) return;
          if (
            state.activePageId &&
            other.pageId &&
            other.pageId !== state.activePageId
          )
            return;
          appendElementMoveSnapTargets(xTargets, 'x', bw, other);
          appendElementMoveSnapTargets(yTargets, 'y', bh, other);
        });
        const snapX = snapToTargetsWithLabel(nextX, xTargets, threshold);
        const snapY = snapToTargetsWithLabel(nextY, yTargets, threshold);
        appliedDx = snapX.value - bounds.minX;
        appliedDy = snapY.value - bounds.minY;
        guideX = snapX.label;
        guideY = snapY.label;
        if (guideX === 'element') stageDrag.snapXPos = snapX.guidePos;
        if (guideY === 'element') stageDrag.snapYPos = snapY.guidePos;
      }
      elements.forEach((entry) => {
        const element = state.stageElements.find(
          (item) => item.id === entry.id
        );
        if (!element) return;
        element.x = entry.startX + appliedDx;
        element.y = entry.startY + appliedDy;
      });
    } else if (stageDrag.mode === 'rotate') {
      const rotation = stageDrag.rotation;
      if (!rotation) return;
      const currentAngle = Math.atan2(
        event.clientY - rotation.centerY,
        event.clientX - rotation.centerX
      );
      const deltaRad = currentAngle - rotation.startAngle;
      let deltaDeg = deltaRad * (180 / Math.PI);
      const snapRotation =
        state.stageRotationSnapEnabled || event.ctrlKey || event.metaKey;
      if (snapRotation) {
        deltaDeg = Math.round(deltaDeg / 15) * 15;
      }
      if (stageDrag.bounds) {
        setStageSelectionGhost({
          minX: stageDrag.bounds.minX,
          minY: stageDrag.bounds.minY,
          maxX: stageDrag.bounds.maxX,
          maxY: stageDrag.bounds.maxY,
        });
      }
      elements.forEach((entry) => {
        const element = state.stageElements.find(
          (item) => item.id === entry.id
        );
        if (!element) return;
        const nextRotation = entry.startRotation + deltaDeg;
        element.rotation = (nextRotation + 360) % 360;
      });
      const hudElement = elements.length
        ? state.stageElements.find((item) => item.id === elements[0].id)
        : null;
      const hudRotation = Math.round(((hudElement?.rotation ?? 0) + 360) % 360);
      showStageDragHud(
        `${hudRotation}\u00B0`,
        snapRotation ? 'rotate \u00B7 15\u00B0 snap' : 'rotate',
        event.clientX,
        event.clientY
      );
      scheduleStageInspectorLiveSync();
    } else if (stageDrag.mode === 'opacity') {
      const delta = -dy * 2;
      if (stageDrag.bounds) {
        setStageSelectionGhost({
          minX: stageDrag.bounds.minX,
          minY: stageDrag.bounds.minY,
          maxX: stageDrag.bounds.maxX,
          maxY: stageDrag.bounds.maxY,
        });
      }
      elements.forEach((entry) => {
        const element = state.stageElements.find(
          (item) => item.id === entry.id
        );
        if (!element) return;
        const nextOpacity = Math.max(
          0,
          Math.min(100, entry.startOpacity + delta)
        );
        element.opacity = nextOpacity;
      });
      const hudOpacity = elements.length
        ? state.stageElements.find((item) => item.id === elements[0].id)
        : null;
      showStageDragHud(
        `${Math.round(hudOpacity?.opacity ?? 100)}%`,
        'opacity',
        event.clientX,
        event.clientY
      );
      scheduleStageInspectorLiveSync();
      syncToolbarTransparency(getSelectedStageElement());
    } else {
      if (!bounds) return;
      if (stageDrag.bounds) {
        setStageSelectionGhost({
          minX: stageDrag.bounds.minX,
          minY: stageDrag.bounds.minY,
          maxX: stageDrag.bounds.maxX,
          maxY: stageDrag.bounds.maxY,
        });
      }
      if (resizeSingleRotatedStageElement(event, stageDrag, rect)) {
        setStageGuides(null, null);
        renderStageElements({ refreshList: false });
        return;
      }
      const handle = stageDrag.handle || 'br';
      let newMinX = bounds.minX;
      let newMaxX = bounds.maxX;
      let newMinY = bounds.minY;
      let newMaxY = bounds.maxY;
      if (handle.includes('l')) {
        newMinX = Math.max(0, Math.min(bounds.maxX - 5, bounds.minX + dx));
      }
      if (handle.includes('r')) {
        newMaxX = Math.max(bounds.minX + 5, Math.min(100, bounds.maxX + dx));
      }
      if (handle.includes('t')) {
        newMinY = Math.max(0, Math.min(bounds.maxY - 5, bounds.minY + dy));
      }
      if (handle.includes('b')) {
        newMaxY = Math.max(bounds.minY + 5, Math.min(100, bounds.maxY + dy));
      }
      if (state.stageSnapEnabled) {
        const threshold = state.stageSnapStrength || 1.5;
        const guides = resolveGuidesFromBox(
          newMinX,
          newMinY,
          newMaxX - newMinX,
          newMaxY - newMinY,
          threshold
        );
        guideX = guides.guideX;
        guideY = guides.guideY;
      }
      let scaleX = (newMaxX - newMinX) / (bounds.maxX - bounds.minX);
      let scaleY = (newMaxY - newMinY) / (bounds.maxY - bounds.minY);
      if (stageDrag.aspectLocked) {
        const hasHorizontal = handle.includes('l') || handle.includes('r');
        const hasVertical = handle.includes('t') || handle.includes('b');
        const scale =
          hasHorizontal && hasVertical
            ? Math.abs(scaleX - 1) > Math.abs(scaleY - 1)
              ? scaleX
              : scaleY
            : hasHorizontal
              ? scaleX
              : scaleY;
        const nextBounds = resolveAspectLockedResizeBounds(
          bounds,
          handle,
          scale
        );
        newMinX = nextBounds.minX;
        newMinY = nextBounds.minY;
        newMaxX = nextBounds.maxX;
        newMaxY = nextBounds.maxY;
        scaleX = (newMaxX - newMinX) / (bounds.maxX - bounds.minX);
        scaleY = (newMaxY - newMinY) / (bounds.maxY - bounds.minY);
      }
      if (state.stageSnapEnabled) {
        const threshold = state.stageSnapStrength || 1.5;
        const guides = resolveGuidesFromBox(
          newMinX,
          newMinY,
          newMaxX - newMinX,
          newMaxY - newMinY,
          threshold
        );
        guideX = guides.guideX;
        guideY = guides.guideY;
      }
      elements.forEach((entry) => {
        const element = state.stageElements.find(
          (item) => item.id === entry.id
        );
        if (!element) return;
        element.x = newMinX + (entry.startX - bounds.minX) * scaleX;
        element.y = newMinY + (entry.startY - bounds.minY) * scaleY;
        element.w = Math.max(5, entry.startW * scaleX);
        element.h = Math.max(5, entry.startH * scaleY);
      });
    }
    setStageGuides(guideX, guideY, stageDrag.snapXPos, stageDrag.snapYPos);
    stageDrag.snapXPos = undefined;
    stageDrag.snapYPos = undefined;
    renderStageElements({ refreshList: false });
    scheduleStageInspectorLiveSync();
  }

  function snapToTargetsWithLabel(value, targets, threshold) {
    let snapped = value;
    let label = null;
    let guidePos = null;
    let bestDistance = threshold + 1;
    targets.forEach((target) => {
      const distance = Math.abs(value - target.value);
      if (distance <= threshold && distance < bestDistance) {
        snapped = target.value;
        label = target.label;
        guidePos =
          typeof target.guidePos === 'number' ? target.guidePos : target.value;
        bestDistance = distance;
      }
    });
    return { value: snapped, label, guidePos };
  }

  function buildStageMoveSnapTargets(axis, size) {
    if (axis === 'x') {
      return [
        { value: 0, label: 'left', guidePos: 0 },
        { value: 100 - size, label: 'right', guidePos: 100 },
        { value: 50 - size / 2, label: 'center', guidePos: 50 },
      ];
    }
    return [
      { value: 0, label: 'top', guidePos: 0 },
      { value: 100 - size, label: 'bottom', guidePos: 100 },
      { value: 50 - size / 2, label: 'center', guidePos: 50 },
    ];
  }

  function appendElementMoveSnapTargets(targets, axis, size, other) {
    if (!targets || !other) return;
    const start = axis === 'x' ? other.x : other.y;
    const length = axis === 'x' ? other.w : other.h;
    const center = start + length / 2;
    const end = start + length;
    [start, center, end].forEach((guidePos) => {
      targets.push({ value: guidePos, label: 'element', guidePos });
      targets.push({
        value: guidePos - size / 2,
        label: 'element',
        guidePos,
      });
      targets.push({ value: guidePos - size, label: 'element', guidePos });
    });
  }

  function setStageGuides(xGuide, yGuide, snapX, snapY) {
    if (!el.stageGuides) return;
    const guideX = xGuide ? `x-${xGuide}` : null;
    const guideY = yGuide ? `y-${yGuide}` : null;
    el.stageGuides.querySelectorAll('[data-guide]').forEach((node) => {
      const guide = node.getAttribute('data-guide');
      const isActive = guide === guideX || guide === guideY;
      node.classList.toggle('active', isActive);
    });
    var dynX = el.stageGuides.querySelector('.stage-guide-dynamic-x');
    var dynY = el.stageGuides.querySelector('.stage-guide-dynamic-y');
    if (dynX) {
      if (xGuide === 'element' && typeof snapX === 'number') {
        dynX.style.display = '';
        dynX.style.left = snapX + '%';
        dynX.classList.add('active');
      } else {
        dynX.style.display = 'none';
        dynX.classList.remove('active');
      }
    }
    if (dynY) {
      if (yGuide === 'element' && typeof snapY === 'number') {
        dynY.style.display = '';
        dynY.style.top = snapY + '%';
        dynY.classList.add('active');
      } else {
        dynY.style.display = 'none';
        dynY.classList.remove('active');
      }
    }
  }

  function resolveGuidesFromBox(x, y, w, h, threshold) {
    let guideX = null;
    let guideY = null;
    if (Math.abs(x) <= threshold) guideX = 'left';
    if (Math.abs(x + w - 100) <= threshold) guideX = 'right';
    if (Math.abs(x + w / 2 - 50) <= threshold) guideX = 'center';
    if (Math.abs(y) <= threshold) guideY = 'top';
    if (Math.abs(y + h - 100) <= threshold) guideY = 'bottom';
    if (Math.abs(y + h / 2 - 50) <= threshold) guideY = 'center';
    return { guideX, guideY };
  }

  function beginStageTextEdit(node, element) {
    if (!node || node.isContentEditable) return;
    const previous = element.text || '';
    node.contentEditable = 'true';
    node.classList.add('editing');
    node.style.userSelect = 'text';
    node.style.webkitUserSelect = 'text';
    node.focus();
    const sel = window.getSelection();
    if (sel) {
      const range = document.createRange();
      range.selectNodeContents(node);
      sel.removeAllRanges();
      sel.addRange(range);
    }
    let finished = false;
    const finish = (commit) => {
      if (finished) return;
      finished = true;
      node.removeEventListener('blur', handleBlur);
      node.removeEventListener('keydown', handleKeydown);
      node.removeEventListener('input', handleInput);
      node.contentEditable = 'false';
      node.classList.remove('editing');
      node.style.removeProperty('user-select');
      node.style.removeProperty('-webkit-user-select');
      if (commit) {
        const nextText = (node.textContent || '').trim();
        element.text = nextText || 'Text';
      } else {
        element.text = previous || 'Text';
      }
      renderStageElements();
      updateStageElementControls();
      scheduleAutosave('stage-text');
    };
    const handleBlur = () => finish(true);
    const handleInput = () => {
      if (el.stageElementText) {
        el.stageElementText.value = (node.textContent || '').trim();
      }
    };
    const handleKeydown = (event) => {
      event.stopPropagation();
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        finish(true);
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        finish(false);
      }
    };
    node.addEventListener('blur', handleBlur);
    node.addEventListener('keydown', handleKeydown);
    node.addEventListener('input', handleInput);
  }

  function handleStagePointerUp(event) {
    if (
      !stageDrag ||
      (stagePointerId !== null && event.pointerId !== stagePointerId)
    )
      return;
    const reason = `stage-${stageDrag.mode || 'transform'}`;
    const changed = stageDrag.startFingerprint !== currentProjectFingerprint();
    stageDrag = null;
    stagePointerId = null;
    window.removeEventListener('pointermove', handleStagePointerMove);
    window.removeEventListener('pointerup', handleStagePointerUp);
    window.removeEventListener('pointercancel', handleStagePointerCancel);
    setStageGuides(null, null);
    setStageSelectionGhost(null);
    hideStageDragHud();
    updateStageElementControls();
    renderStageElementsList();
    scheduleStageInlineToolbarSync();
    if (changed) scheduleAutosave(reason);
  }

  function handleStagePointerCancel(event) {
    if (
      !stageDrag ||
      (stagePointerId !== null && event.pointerId !== stagePointerId)
    )
      return;
    handleStagePointerUp(event);
  }

  function serializeProject() {
    const assets = state.assets.map((asset) => ({
      type: asset.type,
      name: asset.name,
      src: asset.src,
      originalSrc: asset.originalSrc || '',
      duration: asset.duration,
      width: asset.width,
      height: asset.height,
      is_local: typeof asset.src === 'string' && asset.src.startsWith('blob:'),
    }));
    const clips = state.clips.map((clip) => ({
      type: clip.type,
      name: clip.name,
      src: clip.src,
      text: clip.text,
      start: clip.start,
      track: clip.track,
      duration: clip.duration,
      sourceDuration: clip.sourceDuration,
      trimStart: clip.trimStart,
      trimEnd: clip.trimEnd,
      speed: clip.speed,
      audioGain: clip.audioGain,
      audioGainEnd: clip.audioGainEnd,
      audioPan: clip.audioPan,
      audioPanEnd: clip.audioPanEnd,
      audioMute: clip.audioMute,
      audioSolo: clip.audioSolo,
      audioFadeIn: clip.audioFadeIn,
      audioFadeOut: clip.audioFadeOut,
      transition: clip.transition,
      transitionIn: clip.transitionIn,
      transitionOut: clip.transitionOut,
      transitionDuration: clip.transitionDuration,
      transitionEase: clip.transitionEase,
      audioGainKeyframes: normalizeKeyframes(clip.audioGainKeyframes, 'linear'),
      audioPanKeyframes: normalizeKeyframes(clip.audioPanKeyframes, 'linear'),
      speedKeyframes: normalizeKeyframes(clip.speedKeyframes, 'ease-in-out'),
      captionFontSize: clip.captionFontSize,
      captionColor: clip.captionColor,
      captionAlign: clip.captionAlign,
      captionY: clip.captionY,
      focusX: clip.focusX,
      focusY: clip.focusY,
      resizeMode: clip.resizeMode,
    }));
    const audioSrc =
      state.audioElement && state.audioElement.src
        ? state.audioElement.src
        : '';
    const audio =
      audioSrc && !audioSrc.startsWith('blob:')
        ? {
            src: audioSrc,
            name: state.audioLabel || '',
            gain: state.audioSettings.gain,
            fadeIn: state.audioSettings.fadeIn,
            fadeOut: state.audioSettings.fadeOut,
          }
        : null;
    const stageElements = state.stageElements.map((element) => ({
      id: element.id,
      type: element.type,
      name: element.name,
      text: element.text,
      src: element.src,
      assetId: element.assetId || null,
      shapeKind: element.shapeKind || null,
      fontSize: element.fontSize,
      fontFamily: element.fontFamily,
      fontWeight: element.fontWeight,
      fontStyle: element.fontStyle,
      textDecoration: element.textDecoration,
      color: element.color,
      background: element.background,
      textAlign: element.textAlign,
      textEffect: element.textEffect,
      hidden: element.hidden,
      locked: element.locked,
      aspectLocked: element.aspectLocked,
      circleClip: element.circleClip,
      cropMode: element.cropMode,
      cropZoom: element.cropZoom,
      cropX: element.cropX,
      cropY: element.cropY,
      rotation: element.rotation,
      opacity: element.opacity,
      x: element.x,
      y: element.y,
      w: element.w,
      h: element.h,
      timelineStart: element.timelineStart,
      timelineDuration: element.timelineDuration,
      textAnimation: element.textAnimation || 'none',
      textAnimationDuration: element.textAnimationDuration || 1,
      textAnimationDelay: element.textAnimationDelay || 0,
      effects: element.effects || null,
      keyframes: Array.isArray(element.keyframes) ? element.keyframes : [],
      pageId: element.pageId || null,
    }));
    const normalizedMarkers = normalizeTimelineMarkers(state.timelineMarkers);
    const markersPayload = normalizedMarkers.map((marker) => ({
      time: marker.time,
      label: marker.label || '',
    }));
    const markersHaveLabels = markersPayload.some((marker) => marker.label);
    return {
      version: 1,
      saved_at: Date.now(),
      fps: state.fps,
      resolution: {
        width: state.resolution.width,
        height: state.resolution.height,
      },
      bpm: state.bpm,
      bpm_min: state.bpmMin,
      bpm_max: state.bpmMax,
      snap_to_beat: state.snapToBeat,
      beat_highlights: state.showBeatHighlights,
      beat_highlight_threshold: state.beatHighlightThreshold,
      autoscroll_waveform: state.autoScrollWaveform,
      automation_tooltip: state.showAutomationTooltip,
      automation_grid: state.showAutomationBeatGrid,
      assets,
      clips,
      timeline_markers: markersHaveLabels
        ? markersPayload
        : markersPayload.map((marker) => marker.time),
      audio,
      stage_elements: stageElements,
      pages: Array.isArray(state.pages)
        ? state.pages.map((page) => ({
            id: page.id,
            name: page.name,
            timeline_start: getPageTimelineStart(page),
          }))
        : [],
      active_page_id: state.activePageId || null,
      stage_keyframe_muted: state.stageKeyframeMuted,
      track_headers: state.trackHeaders,
      audio_tracks: state.audioTracks.map(function (t) {
        return {
          id: t.id,
          label: t.label,
          src: t.src && !t.src.startsWith('blob:') ? t.src : '',
          settings: t.settings,
          muted: t.muted,
        };
      }),
      projectPath: state.currentProjectPath || '',
    };
  }

  function normalizeKeyframes(keyframes, defaultEase) {
    if (!Array.isArray(keyframes)) return [];
    return keyframes
      .map((kf) => {
        if (!kf || typeof kf !== 'object') return null;
        return {
          time: finiteNumber(kf.time, 0),
          value: finiteNumber(kf.value, 0),
          ease: normalizeEase(kf.ease || defaultEase),
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.time - b.time);
  }

  function normalizeEase(value) {
    const ease = typeof value === 'string' ? value.toLowerCase() : 'linear';
    if (ease === 'ease-in' || ease === 'ease-out' || ease === 'ease-in-out') {
      return ease;
    }
    return 'linear';
  }

  function finiteNumber(value, fallback) {
    const next = Number(value);
    return Number.isFinite(next) ? next : fallback;
  }

  function normalizeClipSpeed(value, fallback) {
    let next = finiteNumber(value, fallback ?? 1);
    if (!Number.isFinite(next)) next = 1;
    next = Math.max(-4, Math.min(4, next));
    if (next >= 0 && next < 0.1) next = 0.1;
    if (next < 0 && next > -0.1) next = -0.1;
    return next;
  }

  function normalizeSpeedRampValue(value, fallback) {
    let next = Math.abs(normalizeClipSpeed(value, fallback ?? 1));
    if (!Number.isFinite(next)) next = 1;
    return Math.max(0.1, Math.min(4, next));
  }

  function normalizeSpeedKeyframesForClip(clip) {
    if (!clip || !Array.isArray(clip.speedKeyframes)) return [];
    const duration = Math.max(0, finiteNumber(clip.duration, 0));
    clip.speedKeyframes = clip.speedKeyframes
      .map((kf) => {
        if (!kf || typeof kf !== 'object') return null;
        return {
          time: Math.max(0, Math.min(duration, finiteNumber(kf.time, 0))),
          value: normalizeSpeedRampValue(kf.value, clip.speed || 1),
          ease: normalizeEase(kf.ease || 'ease-in-out'),
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.time - b.time);
    return clip.speedKeyframes;
  }

  function normalizeHexColor(value, fallback) {
    const text = String(value || '').trim();
    if (/^#[0-9a-f]{6}$/i.test(text)) return text.toLowerCase();
    if (/^[0-9a-f]{6}$/i.test(text)) return `#${text.toLowerCase()}`;
    return fallback || DEFAULT_CAPTION_STYLE.color;
  }

  function cssColorToHex(value, fallback) {
    const text = String(value || '').trim();
    if (/^#[0-9a-f]{6}$/i.test(text)) return text.toLowerCase();
    if (/^[0-9a-f]{6}$/i.test(text)) return `#${text.toLowerCase()}`;
    const parts = text.match(/^rgba?\(([^)]+)\)$/i);
    if (parts) {
      const channels = parts[1].split(/[\s,/]+/).filter(Boolean);
      if (channels.length >= 3 && channels.slice(0, 3).every(isFinite)) {
        const to255 = (raw) =>
          clampColorValue(Math.round(parseFloat(raw)), 0, 255);
        return rgbToHexColor(
          to255(channels[0]),
          to255(channels[1]),
          to255(channels[2])
        );
      }
    }
    return fallback;
  }

  function updateCaptionColorControls(value) {
    const color = normalizeHexColor(value, DEFAULT_CAPTION_STYLE.color);
    if (el.clipCaptionColor) el.clipCaptionColor.value = color;
    if (el.clipCaptionColorValue)
      el.clipCaptionColorValue.textContent = color.toUpperCase();
    document.querySelectorAll('[data-caption-color]').forEach((button) => {
      button.classList.toggle(
        'active',
        normalizeHexColor(button.dataset.captionColor, '') === color
      );
    });
  }

  function cloneKeyframes(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map((kf) => ({
        time: finiteNumber(kf.time, 0),
        value: finiteNumber(kf.value, 0),
        ease: normalizeEase(kf.ease || 'linear'),
      }))
      .sort((a, b) => a.time - b.time);
  }

  function keyframesEqual(a, b) {
    const left = cloneKeyframes(a);
    const right = cloneKeyframes(b);
    if (left.length !== right.length) return false;
    return left.every((kf, index) => {
      const other = right[index];
      return (
        Math.abs(kf.time - other.time) < 0.001 &&
        Math.abs(kf.value - other.value) < 0.001 &&
        kf.ease === other.ease
      );
    });
  }

  function pushAutomationHistory(clip, axis, prev, next, reason) {
    if (!clip || !axis || !prev || !next) return;
    if (keyframesEqual(prev, next)) return;
    const now = nextHistoryAt();
    if (automationHistory.length) {
      const last = automationHistory[automationHistory.length - 1];
      if (
        last &&
        last.clipId === clip.id &&
        last.axis === axis &&
        last.reason === reason &&
        now - (last.at || 0) < 700
      ) {
        last.next = cloneKeyframes(next);
        last.at = now;
        automationFuture.length = 0;
        return;
      }
    }
    globalRedoStack.length = 0;
    automationHistory.push({
      clipId: clip.id,
      axis,
      prev: cloneKeyframes(prev),
      next: cloneKeyframes(next),
      reason: reason || '',
      at: now,
    });
    if (automationHistory.length > AUTOMATION_HISTORY_LIMIT) {
      automationHistory.splice(
        0,
        automationHistory.length - AUTOMATION_HISTORY_LIMIT
      );
    }
    automationFuture.length = 0;
    renderAutomationHistoryPanel();
    updateGlobalUndoIndicators();
  }

  function applyAutomationSnapshot(entry, forward) {
    if (!entry) return false;
    const clip = state.clips.find((item) => item.id === entry.clipId);
    if (!clip) return false;
    const keyframes = forward ? entry.next : entry.prev;
    if (entry.axis === 'gain') {
      clip.audioGainKeyframes = cloneKeyframes(keyframes);
      renderAudioGainKeyframes(clip);
      refreshAutomationSelection('gain', clip.audioGainKeyframes);
    } else {
      clip.audioPanKeyframes = cloneKeyframes(keyframes);
      renderAudioPanKeyframes(clip);
      refreshAutomationSelection('pan', clip.audioPanKeyframes);
    }
    drawClipAutomationPreview(clip);
    scheduleAutosave();
    return true;
  }

  function formatAutomationAge(ms) {
    const seconds = Math.max(0, Math.floor(ms / 1000));
    if (seconds < 5) return 'just now';
    if (seconds < 60) return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m`;
    const hours = Math.floor(minutes / 60);
    return `${hours}h`;
  }

  function jumpAutomationHistory(index) {
    if (
      typeof index !== 'number' ||
      index < 0 ||
      index >= automationHistory.length
    )
      return;
    const target = automationHistory[index];
    const future = automationHistory.slice(index + 1);
    automationHistory.length = index + 1;
    automationFuture.length = 0;
    future.forEach((entry) => automationFuture.push(entry));
    if (applyAutomationSnapshot(target, true)) {
      showAutomationUndoToast(
        'Restored automation state',
        automationFuture.length > 0
      );
      renderAutomationHistoryPanel();
    }
  }

  function getAutomationHistoryFiltered() {
    const axisFilter = el.automationHistoryFilter
      ? el.automationHistoryFilter.value
      : 'all';
    let filtered =
      axisFilter === 'all'
        ? automationHistory
        : automationHistory.filter((entry) => entry.axis === axisFilter);
    const clipFilter = el.automationHistoryClipFilter
      ? el.automationHistoryClipFilter.value
      : 'all';
    const search = el.automationHistorySearch
      ? el.automationHistorySearch.value.trim().toLowerCase()
      : '';
    const showAll = el.automationHistoryShowAll
      ? el.automationHistoryShowAll.checked
      : false;
    if (clipFilter === 'current') {
      if (!state.selectedClipId) {
        return {
          axisFilter,
          clipFilter,
          search,
          showAll,
          entries: [],
          emptyMessage: 'Select a clip to view history.',
        };
      }
      filtered = filtered.filter(
        (entry) => entry.clipId === state.selectedClipId
      );
    }
    if (search) {
      filtered = filtered.filter((entry) => {
        const clip = state.clips.find((item) => item.id === entry.clipId);
        const clipName = clip ? clip.name : '';
        const haystack =
          `${entry.axis || ''} ${entry.reason || ''} ${clipName}`.toLowerCase();
        return haystack.includes(search);
      });
    }
    return {
      axisFilter,
      clipFilter,
      search,
      showAll,
      entries: filtered,
      emptyMessage: null,
    };
  }

  function renderAutomationHistoryPanel() {
    if (!el.automationHistoryPanel) return;
    el.automationHistoryPanel.innerHTML = '';
    const { entries, emptyMessage, showAll, axisFilter, clipFilter, search } =
      getAutomationHistoryFiltered();
    const showSummary = el.automationHistoryPanel.style.display === 'block';
    const items =
      showAll || entries.length <= 12 ? entries : entries.slice(-12);
    const moreCount = Math.max(0, entries.length - items.length);
    const indices = items.map((entry) => automationHistory.indexOf(entry));
    if (!items.length) {
      el.automationHistoryPanel.textContent =
        emptyMessage || 'No automation history.';
      return;
    }
    if (showSummary) {
      const summary = document.createElement('div');
      summary.className = 'automation-history-summary';
      const parts = [];
      if (axisFilter && axisFilter !== 'all') parts.push(axisFilter);
      if (clipFilter === 'current') {
        const clipName =
          state.clips.find((item) => item.id === state.selectedClipId)?.name ||
          'current clip';
        parts.push(clipName);
      }
      if (search) {
        const trimmed = search.length > 24 ? `${search.slice(0, 24)}…` : search;
        parts.push(`"${trimmed}"`);
      }
      if (showAll) parts.push('all');
      const count = document.createElement('span');
      count.textContent = `${entries.length} result${entries.length === 1 ? '' : 's'}`;
      summary.appendChild(count);
      if (!state.automationHistoryBadgesCollapsed) {
        parts.forEach((part) => {
          const badge = document.createElement('span');
          badge.className = 'automation-history-badge';
          badge.textContent = part;
          summary.appendChild(badge);
        });
      }
      summary.title = parts.length ? parts.join(' | ') : '';
      el.automationHistoryPanel.appendChild(summary);
    }
    const now = Date.now();
    items.forEach((entry, localIndex) => {
      const row = document.createElement('div');
      row.className = 'automation-history-item';
      const label = `${entry.axis.toUpperCase()} ${entry.reason || 'change'}`;
      const clip = state.clips.find((item) => item.id === entry.clipId);
      const clipName = clip ? clip.name : 'Clip';
      const age = entry.at ? formatAutomationAge(now - entry.at) : '';
      const prevCount = Array.isArray(entry.prev) ? entry.prev.length : 0;
      const nextCount = Array.isArray(entry.next)
        ? entry.next.length
        : prevCount;
      const countLabel =
        prevCount === nextCount ? `${nextCount}` : `${prevCount}→${nextCount}`;
      row.textContent = `${clipName}: ${label}${age ? ` · ${age}` : ''} · ${countLabel}`;
      const actualIndex = indices[localIndex];
      row.addEventListener('click', () => jumpAutomationHistory(actualIndex));
      el.automationHistoryPanel.appendChild(row);
    });
    if (moreCount > 0 && !showAll) {
      const more = document.createElement('div');
      more.className = 'automation-history-summary';
      more.textContent = `+${moreCount} more…`;
      el.automationHistoryPanel.appendChild(more);
    }
    saveAutomationHistoryFilter();
  }

  function showAutomationUndoToast(message, showRedo) {
    if (!el.automationUndoToast || !el.automationUndoMessage) return;
    el.automationUndoMessage.textContent = message;
    if (el.automationUndoRedo) {
      el.automationUndoRedo.style.display = showRedo ? 'inline-flex' : 'none';
    }
    el.automationUndoToast.style.display = 'flex';
    if (automationUndoTimer) window.clearTimeout(automationUndoTimer);
    automationUndoTimer = window.setTimeout(() => {
      if (el.automationUndoToast) el.automationUndoToast.style.display = 'none';
      automationUndoTimer = null;
    }, 2500);
  }

  function undoAutomation(options) {
    const entry = automationHistory.pop();
    if (!entry) return;
    if (applyAutomationSnapshot(entry, false)) {
      automationFuture.push(entry);
      showAutomationUndoToast(
        'Undid automation change',
        automationFuture.length > 0
      );
      renderAutomationHistoryPanel();
      if (!options || options.recordGlobal !== false) {
        pushGlobalRedo(
          'automation',
          formatGlobalEntryLabel('automation', entry)
        );
      }
      updateGlobalUndoIndicators();
      return true;
    }
    return false;
  }

  function redoAutomation(options) {
    const entry = automationFuture.pop();
    if (!entry) return;
    if (applyAutomationSnapshot(entry, true)) {
      automationHistory.push(entry);
      showAutomationUndoToast(
        'Redid automation change',
        automationFuture.length > 0
      );
      renderAutomationHistoryPanel();
      if (!options || options.recordGlobal !== false) {
        consumeGlobalRedo('automation');
      }
      updateGlobalUndoIndicators();
      return true;
    }
    return false;
  }

  function clearAutomationHistory() {
    if (!automationHistory.length && !automationFuture.length) {
      notify('No automation history', 'info');
      return;
    }
    if (!window.confirm('Clear automation history?')) return;
    automationHistory.length = 0;
    automationFuture.length = 0;
    renderAutomationHistoryPanel();
    showAutomationUndoToast('Cleared automation history', false);
    updateGlobalUndoIndicators();
  }

  function pushGlobalRedo(type) {
    if (!type) return;
    const label = arguments.length > 1 ? arguments[1] : '';
    globalRedoStack.push({ type, at: Date.now(), label });
    if (globalRedoStack.length > 120) {
      globalRedoStack.splice(0, globalRedoStack.length - 120);
    }
  }

  function nextHistoryAt() {
    const now = Date.now();
    historyLastAt = Math.max(now, historyLastAt + 1);
    return historyLastAt;
  }

  function consumeGlobalRedo(type) {
    if (!globalRedoStack.length) return;
    const last = globalRedoStack[globalRedoStack.length - 1];
    if (last.type === type) {
      globalRedoStack.pop();
    } else {
      globalRedoStack.length = 0;
    }
  }

  function exportAutomationHistory(asCsv) {
    const { entries, emptyMessage, axisFilter, clipFilter, search } =
      getAutomationHistoryFiltered();
    if (!entries.length) {
      notify(emptyMessage || 'No automation history', 'info');
      return;
    }
    const badgesCollapsed = state.automationHistoryBadgesCollapsed;
    if (asCsv) {
      const rows = [
        [
          'timestamp',
          'age',
          'axis',
          'reason',
          'clip_name',
          'prev_count',
          'next_count',
          'selected_clip',
          'filter_axis',
          'filter_clip',
          'filter_search',
          'filter_show_all',
          'badges_collapsed',
        ],
      ];
      const now = Date.now();
      const selectedClipName = state.selectedClipId
        ? state.clips.find((item) => item.id === state.selectedClipId)?.name ||
          ''
        : '';
      entries.forEach((entry) => {
        const age = entry.at ? formatAutomationAge(now - entry.at) : '';
        const clip = state.clips.find((item) => item.id === entry.clipId);
        const prevCount = Array.isArray(entry.prev) ? entry.prev.length : '';
        const nextCount = Array.isArray(entry.next)
          ? entry.next.length
          : prevCount;
        rows.push([
          entry.at ? new Date(entry.at).toISOString() : '',
          age,
          entry.axis || '',
          entry.reason || 'change',
          clip ? clip.name : '',
          prevCount,
          nextCount,
          selectedClipName,
          axisFilter || '',
          clipFilter || '',
          search || '',
          el.automationHistoryShowAll && el.automationHistoryShowAll.checked
            ? 'yes'
            : '',
          badgesCollapsed ? 'yes' : '',
        ]);
      });
      const csv = rows
        .map((row) =>
          row
            .map((cell) => {
              const value = String(cell ?? '');
              return `"${value.replace(/"/g, '""')}"`;
            })
            .join(',')
        )
        .join('\n');
      const blob = new Blob([csv], { type: 'text/csv' });
      downloadBlob(blob, `automation-history-${Date.now()}.csv`);
      notify('Automation history exported', 'info');
      return;
    }
    const payload = {
      exported_at: new Date().toISOString(),
      axis_filter: axisFilter,
      clip_filter: clipFilter,
      search,
      show_all: !!(
        el.automationHistoryShowAll && el.automationHistoryShowAll.checked
      ),
      badges_collapsed: badgesCollapsed,
      clip_id: clipFilter === 'current' ? state.selectedClipId : null,
      history: entries,
    };
    const blob = new Blob([JSON.stringify(payload, null, 2)], {
      type: 'application/json',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `automation-history-${Date.now()}.json`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 0);
    notify('Automation history exported', 'info');
  }

  function saveAutomationHistoryFilter() {
    if (
      !el.automationHistoryFilter ||
      !el.automationHistoryClipFilter ||
      !el.automationHistorySearch ||
      !el.automationHistoryShowAll
    )
      return;
    const payload = {
      axis: el.automationHistoryFilter.value || 'all',
      clip: el.automationHistoryClipFilter.value || 'all',
      search: el.automationHistorySearch.value || '',
      showAll: !!el.automationHistoryShowAll.checked,
    };
    localStorage.setItem(
      AUTOMATION_HISTORY_FILTER_KEY,
      JSON.stringify(payload)
    );
  }

  function loadAutomationHistoryFilter() {
    if (
      !el.automationHistoryFilter ||
      !el.automationHistoryClipFilter ||
      !el.automationHistorySearch ||
      !el.automationHistoryShowAll
    )
      return;
    const raw = localStorage.getItem(AUTOMATION_HISTORY_FILTER_KEY);
    if (!raw) return;
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        if (typeof parsed.axis === 'string')
          el.automationHistoryFilter.value = parsed.axis;
        if (typeof parsed.clip === 'string')
          el.automationHistoryClipFilter.value = parsed.clip;
        if (typeof parsed.search === 'string')
          el.automationHistorySearch.value = parsed.search;
        if (typeof parsed.showAll === 'boolean')
          el.automationHistoryShowAll.checked = parsed.showAll;
      }
    } catch {
      // ignore
    }
  }

  function saveAutomationHistoryBadgesCollapsed(collapsed) {
    localStorage.setItem(AUTOMATION_HISTORY_BADGES_KEY, collapsed ? '1' : '0');
  }

  function loadAutomationHistoryBadgesCollapsed() {
    const raw = localStorage.getItem(AUTOMATION_HISTORY_BADGES_KEY);
    return raw === '1';
  }

  function toggleAutomationHistoryBadges() {
    const collapsed = !state.automationHistoryBadgesCollapsed;
    state.automationHistoryBadgesCollapsed = collapsed;
    saveAutomationHistoryBadgesCollapsed(collapsed);
    renderAutomationHistoryPanel();
  }

  function loadDetailsState() {
    const nodes = document.querySelectorAll('details[data-details-key]');
    nodes.forEach((node) => {
      const key = node.dataset.detailsKey;
      if (!key) return;
      const raw = localStorage.getItem(`netwrck_video_editor_details_${key}`);
      if (raw === '0') {
        node.open = false;
      } else if (raw === '1') {
        node.open = true;
      }
    });
  }

  function bindDetailsPersistence() {
    const nodes = document.querySelectorAll('details[data-details-key]');
    nodes.forEach((node) => {
      const key = node.dataset.detailsKey;
      if (!key) return;
      node.addEventListener('toggle', () => {
        localStorage.setItem(
          `netwrck_video_editor_details_${key}`,
          node.open ? '1' : '0'
        );
      });
    });
  }

  function bindMenuExclusivity() {
    const menus = Array.from(document.querySelectorAll('details.editor-menu'));
    if (!menus.length) return;
    const syncMenuAria = (menu) => {
      const summaryButton = menu.querySelector(
        'summary .menu-button[aria-expanded]'
      );
      if (summaryButton) {
        summaryButton.setAttribute(
          'aria-expanded',
          menu.open ? 'true' : 'false'
        );
      }
      const panel = menu.querySelector('.menu-panel[aria-hidden]');
      if (panel) {
        panel.setAttribute('aria-hidden', menu.open ? 'false' : 'true');
        if (menu.open) {
          panel.removeAttribute('inert');
        } else {
          panel.setAttribute('inert', '');
        }
      }
    };
    menus.forEach((menu) => {
      menu.addEventListener('toggle', () => {
        syncMenuAria(menu);
        if (!menu.open) return;
        menus.forEach((other) => {
          if (other !== menu && other.open) {
            other.open = false;
          }
        });
      });
    });

    menus.forEach((menu) => {
      if (!menu.hasAttribute('data-menu-autoclose')) return;
      const panel = menu.querySelector('.menu-panel');
      if (!panel) return;
      menu.addEventListener('click', (event) => {
        if (!menu.open) return;
        if (!panel.contains(event.target)) return;
        const button = event.target.closest('button');
        if (!button) return;
        if (button.closest('summary')) return;
        if (button.classList.contains('menu-tab')) return;
        if (button.hasAttribute('data-menu-keep-open')) return;
        menu.open = false;
      });
    });

    if (el.publishMenu) {
      el.publishMenu.addEventListener('toggle', () => {
        const note = document.querySelector('.server-render-note');
        if (!note) return;
        note.style.display = el.publishMenu.open ? 'block' : 'none';
      });
    }

    const closeAllMenus = () => {
      let hasOpen = false;
      menus.forEach((menu) => {
        if (menu.open) hasOpen = true;
      });
      if (!hasOpen) return;
      menus.forEach((menu) => {
        if (menu.open) {
          menu.open = false;
        }
      });
    };

    document.addEventListener('click', (event) => {
      const target = event.target;
      const clickedMenu = menus.some((menu) => menu.contains(target));
      if (clickedMenu) return;
      closeAllMenus();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (isEditorModalOpen()) return;
      closeAllMenus();
    });
  }

  function bindTimelineContextSubmenus() {
    document
      .querySelectorAll(
        '.timeline-context-menu .timeline-context-submenu summary'
      )
      .forEach((summary) => {
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          const detail = summary.closest('details');
          if (detail) detail.open = true;
        });
      });
  }

  function bindStageSelectionBox() {
    if (!el.stageSelectionBox) return;
    el.stageSelectionBox.addEventListener(
      'pointerdown',
      handleStageGroupPointerDown
    );
  }

  function timelineSignature(clips) {
    return clips
      .map((clip) => {
        const fields = [
          clip.id,
          clip.name,
          clip.start,
          clip.track,
          clip.duration,
          clip.trimStart,
          clip.trimEnd,
          clip.speed,
          clip.audioGain,
          clip.audioGainEnd,
          clip.audioPan,
          clip.audioPanEnd,
          clip.audioMute,
          clip.audioSolo,
          clip.audioFadeIn,
          clip.audioFadeOut,
          clip.transition,
          clip.transitionDuration,
          clip.focusX,
          clip.focusY,
          clip.resizeMode,
        ];
        return fields.join(':');
      })
      .join('|');
  }

  function cloneTimelineClips() {
    return state.clips.map((clip) => ({
      ...clip,
      element: clip.element || null,
    }));
  }

  function renderTimelineHistoryPanel() {
    if (!el.timelineHistoryPanel) return;
    el.timelineHistoryPanel.innerHTML = '';
    const { entries, emptyMessage } = getTimelineHistoryFiltered();
    if (!entries.length) {
      el.timelineHistoryPanel.textContent =
        emptyMessage || 'No timeline history.';
      return;
    }
    const items = entries.slice(0, 12);
    const moreCount = entries.length - items.length;
    items.forEach((entry) => {
      const row = document.createElement('div');
      row.className = 'timeline-history-item';
      const clipCount = Array.isArray(entry.clips) ? entry.clips.length : 0;
      const reason = entry.reason || 'change';
      const historyIndex = timelineHistory.indexOf(entry);
      row.textContent = `${reason} · ${clipCount} clips`;
      row.addEventListener('click', () => jumpTimelineHistory(historyIndex));
      el.timelineHistoryPanel.appendChild(row);
    });
    if (moreCount > 0) {
      const more = document.createElement('div');
      more.className = 'timeline-history-summary';
      more.textContent = `+${moreCount} more`;
      el.timelineHistoryPanel.appendChild(more);
    }
  }

  function getTimelineHistoryFiltered() {
    if (!timelineHistory.length) {
      return { entries: [], emptyMessage: 'No timeline history.' };
    }
    const entries = timelineHistory.slice().reverse();
    if (!entries.length) {
      return { entries: [], emptyMessage: 'No timeline history.' };
    }
    return { entries, emptyMessage: null };
  }

  function exportTimelineHistory(asCsv) {
    const { entries, emptyMessage } = getTimelineHistoryFiltered();
    if (!entries.length) {
      notify(emptyMessage || 'No timeline history', 'info');
      return;
    }
    if (asCsv) {
      const rows = [
        [
          'timestamp',
          'age',
          'reason',
          'clip_count',
          'added_count',
          'removed_count',
          'updated_count',
          'diff_summary',
          'selected_clip_id',
          'playhead',
          'signature',
        ],
      ];
      const now = Date.now();
      entries.forEach((entry) => {
        const age = entry.at ? formatAutomationAge(now - entry.at) : '';
        const historyIndex = timelineHistory.indexOf(entry);
        const prevEntry =
          historyIndex > 0 ? timelineHistory[historyIndex - 1] : null;
        const diff = computeTimelineDiff(prevEntry, entry);
        const diffSummary = formatTimelineDiffSummary(diff);
        rows.push([
          entry.at ? new Date(entry.at).toISOString() : '',
          age,
          entry.reason || 'change',
          Array.isArray(entry.clips) ? entry.clips.length : 0,
          diff.added.length,
          diff.removed.length,
          diff.updated.length,
          diffSummary,
          entry.selectedClipId || '',
          typeof entry.playhead === 'number' ? entry.playhead.toFixed(3) : '',
          entry.signature || '',
        ]);
      });
      const csv = rows
        .map((row) =>
          row
            .map((cell) => {
              const value = String(cell ?? '');
              return `"${value.replace(/"/g, '""')}"`;
            })
            .join(',')
        )
        .join('\n');
      const blob = new Blob([csv], { type: 'text/csv' });
      downloadBlob(blob, `timeline-history-${Date.now()}.csv`);
      notify('Timeline history exported', 'info');
      return;
    }
    const payload = {
      exported_at: new Date().toISOString(),
      history: entries.map((entry) => {
        const historyIndex = timelineHistory.indexOf(entry);
        const prevEntry =
          historyIndex > 0 ? timelineHistory[historyIndex - 1] : null;
        const diff = computeTimelineDiff(prevEntry, entry);
        return {
          ...entry,
          diff,
        };
      }),
    };
    const blob = new Blob([JSON.stringify(payload, null, 2)], {
      type: 'application/json',
    });
    downloadBlob(blob, `timeline-history-${Date.now()}.json`);
    notify('Timeline history exported', 'info');
  }

  function pushTimelineHistory(reason) {
    const signature = timelineSignature(state.clips);
    const last = timelineHistory[timelineHistory.length - 1];
    if (last && last.signature === signature) return;
    globalRedoStack.length = 0;
    const now = nextHistoryAt();
    if (
      timelineCoalesceInfo &&
      reason &&
      timelineCoalesceInfo.reason === reason &&
      now - timelineCoalesceInfo.at <= TIMELINE_HISTORY_COALESCE_MS
    ) {
      const lastIndex = timelineHistory.length - 1;
      if (lastIndex >= 0) {
        timelineHistory[lastIndex] = {
          clips: cloneTimelineClips(),
          selectedClipId: state.selectedClipId,
          playhead: state.playhead,
          signature,
          reason: reason || 'change',
          at: now,
        };
      }
    } else {
      timelineHistory.push({
        clips: cloneTimelineClips(),
        selectedClipId: state.selectedClipId,
        playhead: state.playhead,
        signature,
        reason: reason || 'change',
        at: now,
      });
    }
    timelineCoalesceInfo = { reason: reason || 'change', at: now };
    if (timelineCoalesceTimer) window.clearTimeout(timelineCoalesceTimer);
    timelineCoalesceTimer = window.setTimeout(() => {
      timelineCoalesceInfo = null;
      timelineCoalesceTimer = null;
    }, TIMELINE_HISTORY_COALESCE_MS);
    if (timelineHistory.length > TIMELINE_HISTORY_LIMIT) {
      timelineHistory.splice(
        0,
        timelineHistory.length - TIMELINE_HISTORY_LIMIT
      );
    }
    timelineFuture.length = 0;
    renderTimelineHistoryPanel();
    updateGlobalUndoIndicators();
  }

  function jumpTimelineHistory(index) {
    if (
      typeof index !== 'number' ||
      index < 0 ||
      index >= timelineHistory.length
    )
      return;
    const target = timelineHistory[index];
    const future = timelineHistory.slice(index + 1);
    const currentSnapshot = {
      clips: cloneTimelineClips(),
      selectedClipId: state.selectedClipId,
      playhead: state.playhead,
      signature: timelineSignature(state.clips),
      reason: 'redo',
      at: nextHistoryAt(),
    };
    timelineHistory.length = index + 1;
    timelineFuture.length = 0;
    timelineFuture.push(currentSnapshot);
    for (let i = future.length - 1; i >= 0; i -= 1) {
      timelineFuture.push(future[i]);
    }
    if (applyTimelineSnapshot(target)) {
      renderTimelineHistoryPanel();
    }
  }

  function applyTimelineSnapshot(entry) {
    if (!entry) return false;
    state.clips = entry.clips.map((clip) => {
      const restored = { ...clip };
      const asset = state.assets.find(
        (item) => item.id === clip.assetId || item.src === clip.src
      );
      if (asset) {
        restored.element = asset.element;
      }
      return restored;
    });
    const nextSelected =
      entry.selectedClipId &&
      state.clips.some((clip) => clip.id === entry.selectedClipId)
        ? entry.selectedClipId
        : null;
    setTimelineSelection(nextSelected ? [nextSelected] : [], nextSelected);
    state.timelineSelectionAnchorId = state.selectedClipId || null;
    recalcTimeline();
    const duration = totalDuration();
    const nextPlayhead =
      typeof entry.playhead === 'number' ? entry.playhead : state.playhead;
    state.playhead = Math.max(0, Math.min(duration, nextPlayhead || 0));
    renderTimeline();
    renderInspector();
    renderFrameAt(state.playhead);
    updateTimeLabel();
    scheduleAutosave();
    return true;
  }

  function getLatestUndoTarget() {
    const auto = automationHistory[automationHistory.length - 1];
    const timeline = timelineHistory[timelineHistory.length - 1];
    const project =
      projectHistory.length >= 2
        ? projectHistory[projectHistory.length - 1]
        : null;
    const stageProject =
      project && /^stage-/.test(project.reason || '') ? project : null;
    if (!auto && !timeline && !stageProject) return null;
    const targets = [
      { type: 'automation', at: auto && auto.at ? auto.at : 0 },
      { type: 'timeline', at: timeline && timeline.at ? timeline.at : 0 },
      {
        type: 'project',
        at: stageProject && stageProject.at ? stageProject.at : 0,
      },
    ].filter((entry) => entry.at > 0);
    if (!targets.length) return null;
    targets.sort((a, b) => b.at - a.at);
    return targets[0].type;
  }

  function formatGlobalEntryLabel(type, entry) {
    if (!entry) return '';
    if (type === 'automation') {
      const clip = state.clips.find((item) => item.id === entry.clipId);
      const clipName = clip ? clip.name : 'Clip';
      const axis = entry.axis ? ` ${entry.axis}` : '';
      return `${clipName}: automation${axis}`;
    }
    if (type === 'timeline') {
      const count = Array.isArray(entry.clips)
        ? entry.clips.length
        : entry.clipCount || 0;
      const reason = entry.reason || 'change';
      return `timeline ${reason}${count ? ` (${count})` : ''}`;
    }
    return '';
  }

  function updateGlobalUndoIndicators() {
    renderGlobalHistoryPanel();
  }

  function getGlobalHistoryEntries() {
    const entries = [];
    automationHistory.forEach((entry, idx) => {
      entries.push({
        type: 'automation',
        at: entry.at || 0,
        reason: entry.reason || 'change',
        clipId: entry.clipId,
        axis: entry.axis,
        index: idx,
      });
    });
    timelineHistory.forEach((entry, idx) => {
      entries.push({
        type: 'timeline',
        at: entry.at || 0,
        reason: entry.reason || 'change',
        clipCount: Array.isArray(entry.clips) ? entry.clips.length : 0,
        clipNames: Array.isArray(entry.clips)
          ? entry.clips.map((item) => item.name).join(' ')
          : '',
        index: idx,
      });
    });
    return entries.sort((a, b) => (a.at || 0) - (b.at || 0));
  }

  function getGlobalHistoryFilter() {
    return {
      type: 'all',
      range: 'all',
      order: 'desc',
      search: '',
      showAll: false,
    };
  }

  function parseGlobalRange(range) {
    if (!range || range === 'all') return 0;
    if (range === '5m') return 5 * 60 * 1000;
    if (range === '1h') return 60 * 60 * 1000;
    if (range === '24h') return 24 * 60 * 60 * 1000;
    return 0;
  }

  function clipHistoryKey(clip) {
    return clip.id || clip.assetId || clip.src || clip.name || '';
  }

  function clipHistorySignature(clip) {
    const fields = [
      clip.id,
      clip.name,
      clip.duration,
      clip.trimStart,
      clip.trimEnd,
      clip.speed,
      clip.audioGain,
      clip.audioGainEnd,
      clip.audioPan,
      clip.audioPanEnd,
      clip.audioMute,
      clip.audioSolo,
      clip.audioFadeIn,
      clip.audioFadeOut,
      clip.transition,
      clip.transitionDuration,
    ];
    return fields.join(':');
  }

  const CLIP_DIFF_FIELDS = [
    { key: 'duration', label: 'duration' },
    { key: 'trimStart', label: 'trimStart' },
    { key: 'trimEnd', label: 'trimEnd' },
    { key: 'speed', label: 'speed' },
    { key: 'audioGain', label: 'audioGain' },
    { key: 'audioGainEnd', label: 'audioGainEnd' },
    { key: 'audioPan', label: 'audioPan' },
    { key: 'audioPanEnd', label: 'audioPanEnd' },
    { key: 'audioMute', label: 'audioMute' },
    { key: 'audioSolo', label: 'audioSolo' },
    { key: 'audioFadeIn', label: 'audioFadeIn' },
    { key: 'audioFadeOut', label: 'audioFadeOut' },
    { key: 'transition', label: 'transition' },
    { key: 'transitionDuration', label: 'transitionDuration' },
  ];

  function clipFieldValue(clip, key) {
    if (!clip) return '';
    const value = clip[key];
    if (value === null || typeof value === 'undefined') return '';
    if (typeof value === 'number' && Number.isNaN(value)) return '';
    return value;
  }

  function computeTimelineDiff(prevEntry, nextEntry) {
    const prevClips =
      prevEntry && Array.isArray(prevEntry.clips) ? prevEntry.clips : [];
    const nextClips =
      nextEntry && Array.isArray(nextEntry.clips) ? nextEntry.clips : [];
    const prevMap = new Map();
    prevClips.forEach((clip) => {
      const key = clipHistoryKey(clip);
      prevMap.set(key, {
        name: clip.name || 'Clip',
        signature: clipHistorySignature(clip),
        clip,
      });
    });
    const nextMap = new Map();
    nextClips.forEach((clip) => {
      const key = clipHistoryKey(clip);
      nextMap.set(key, {
        name: clip.name || 'Clip',
        signature: clipHistorySignature(clip),
        clip,
      });
    });
    const added = [];
    const removed = [];
    const updated = [];
    const updatedDetails = [];
    nextMap.forEach((value, key) => {
      if (!prevMap.has(key)) {
        added.push(value.name);
      } else if (prevMap.get(key).signature !== value.signature) {
        updated.push(value.name);
        const prevClip = prevMap.get(key).clip;
        const nextClip = value.clip;
        const fields = CLIP_DIFF_FIELDS.filter((field) => {
          return (
            clipFieldValue(prevClip, field.key) !==
            clipFieldValue(nextClip, field.key)
          );
        }).map((field) => field.label);
        updatedDetails.push({ name: value.name, fields });
      }
    });
    prevMap.forEach((value, key) => {
      if (!nextMap.has(key)) {
        removed.push(value.name);
      }
    });
    return { added, removed, updated, updatedDetails };
  }

  function formatTimelineDiffSummary(diff) {
    if (!diff) return '';
    const parts = [];
    if (diff.added.length) parts.push(`+${diff.added.length}`);
    if (diff.removed.length) parts.push(`-${diff.removed.length}`);
    if (diff.updated.length) parts.push(`~${diff.updated.length}`);
    return parts.join(' ');
  }

  function getGlobalHistoryEntriesFiltered() {
    const entries = getGlobalHistoryEntries();
    const { type, range, order, search, showAll } = getGlobalHistoryFilter();
    const rangeMs = parseGlobalRange(range);
    let filtered = entries;
    if (type && type !== 'all') {
      filtered = filtered.filter((entry) => entry.type === type);
    }
    if (rangeMs) {
      const now = Date.now();
      filtered = filtered.filter(
        (entry) => entry.at && now - entry.at <= rangeMs
      );
    }
    if (search) {
      filtered = filtered.filter((entry) => {
        const clip =
          entry.type === 'automation'
            ? state.clips.find((item) => item.id === entry.clipId)
            : null;
        const clipName = clip ? clip.name : '';
        const timelineNames =
          entry.type === 'timeline' ? entry.clipNames || '' : '';
        const haystack =
          `${entry.type} ${entry.reason || ''} ${entry.axis || ''} ${clipName} ${timelineNames}`.toLowerCase();
        return haystack.includes(search);
      });
    }
    if (order === 'desc') {
      filtered = filtered.slice().reverse();
    }
    return { entries: filtered };
  }

  function renderGlobalHistoryPanel() {
    if (!el.globalHistoryPanel) return;
    if (el.globalHistoryPanel.style.display !== 'block') return;
    const { entries } = getGlobalHistoryEntriesFiltered();
    el.globalHistoryPanel.innerHTML = '';
    if (!entries.length) {
      el.globalHistoryPanel.textContent = 'No global history.';
      return;
    }
    const items = entries.slice(0, 12);
    items.forEach((entry) => {
      const row = document.createElement('div');
      row.className = 'global-history-item';
      const label = document.createElement('span');
      if (entry.type === 'automation') {
        const clip = state.clips.find((item) => item.id === entry.clipId);
        const clipName = clip ? clip.name : 'Clip';
        const autoEntry = automationHistory[entry.index];
        const prevCount = Array.isArray(autoEntry?.prev)
          ? autoEntry.prev.length
          : null;
        const nextCount = Array.isArray(autoEntry?.next)
          ? autoEntry.next.length
          : prevCount;
        const countLabel =
          prevCount === null
            ? ''
            : prevCount === nextCount
              ? `${nextCount}`
              : `${prevCount}→${nextCount}`;
        label.textContent = `${clipName}: automation ${entry.axis}${countLabel ? ` · ${countLabel}` : ''}`;
        row.addEventListener('click', () => jumpAutomationHistory(entry.index));
      } else {
        label.textContent = `timeline ${entry.reason} (${entry.clipCount})`;
        row.addEventListener('click', () => jumpTimelineHistory(entry.index));
      }
      row.appendChild(label);
      el.globalHistoryPanel.appendChild(row);
    });
  }

  function exportGlobalHistory(asCsv) {
    const { entries } = getGlobalHistoryEntriesFiltered();
    const filter = getGlobalHistoryFilter();
    if (!entries.length) {
      notify('No global history', 'info');
      return;
    }
    if (asCsv) {
      const includeDiff = true;
      const headers = [
        'timestamp',
        'age',
        'type',
        'reason',
        'clip_name',
        'axis',
        'prev_count',
        'next_count',
        'clip_count',
      ]
        .concat(
          includeDiff
            ? ['added_count', 'removed_count', 'updated_count', 'diff_summary']
            : []
        )
        .concat(['index']);
      const rows = [];
      rows.push(headers);
      const now = Date.now();
      entries.forEach((entry) => {
        const age = entry.at ? formatAutomationAge(now - entry.at) : '';
        const clip =
          entry.type === 'automation'
            ? state.clips.find((item) => item.id === entry.clipId)
            : null;
        let prevCount = '';
        let nextCount = '';
        if (entry.type === 'automation') {
          const autoEntry = automationHistory[entry.index];
          if (Array.isArray(autoEntry?.prev)) prevCount = autoEntry.prev.length;
          if (Array.isArray(autoEntry?.next)) nextCount = autoEntry.next.length;
        }
        let diff = { added: [], removed: [], updated: [] };
        let diffSummary = '';
        if (entry.type === 'timeline') {
          const currentEntry = timelineHistory[entry.index];
          const prevEntry =
            entry.index > 0 ? timelineHistory[entry.index - 1] : null;
          diff = computeTimelineDiff(prevEntry, currentEntry);
          diffSummary = formatTimelineDiffSummary(diff);
        }
        rows.push([
          entry.at ? new Date(entry.at).toISOString() : '',
          age,
          entry.type,
          entry.reason || 'change',
          clip ? clip.name : '',
          entry.axis || '',
          prevCount,
          nextCount,
          entry.clipCount || '',
          ...(includeDiff
            ? [
                diff.added.length,
                diff.removed.length,
                diff.updated.length,
                diffSummary,
              ]
            : []),
          entry.index,
        ]);
      });
      const csv = rows
        .map((row) =>
          row
            .map((cell) => {
              const value = String(cell ?? '');
              return `"${value.replace(/"/g, '""')}"`;
            })
            .join(',')
        )
        .join('\n');
      const blob = new Blob([csv], { type: 'text/csv' });
      downloadBlob(blob, `global-history-${Date.now()}.csv`);
      notify('Global history exported', 'info');
      return;
    }
    const payload = {
      exported_at: new Date().toISOString(),
      filter,
      history: entries.map((entry) => ({
        ...entry,
        prev_count:
          entry.type === 'automation' &&
          Array.isArray(automationHistory[entry.index]?.prev)
            ? automationHistory[entry.index].prev.length
            : null,
        next_count:
          entry.type === 'automation' &&
          Array.isArray(automationHistory[entry.index]?.next)
            ? automationHistory[entry.index].next.length
            : null,
        diff:
          entry.type === 'timeline'
            ? computeTimelineDiff(
                entry.index > 0 ? timelineHistory[entry.index - 1] : null,
                timelineHistory[entry.index]
              )
            : null,
      })),
    };
    const blob = new Blob([JSON.stringify(payload, null, 2)], {
      type: 'application/json',
    });
    downloadBlob(blob, `global-history-${Date.now()}.json`);
    notify('Global history exported', 'info');
  }

  function undoGlobal() {
    const target = getLatestUndoTarget();
    if (!target) {
      undoProject();
      return;
    }
    if (target === 'automation') {
      undoAutomation({ recordGlobal: true });
    } else if (target === 'timeline') {
      undoTimeline({ recordGlobal: true });
    } else {
      undoProject({ recordGlobal: true });
    }
  }

  function redoGlobal() {
    if (!globalRedoStack.length) {
      redoProject();
      return;
    }
    const target = globalRedoStack[globalRedoStack.length - 1].type;
    globalRedoStack.pop();
    if (target === 'automation') {
      redoAutomation({ recordGlobal: false });
      return;
    }
    if (target === 'timeline') {
      redoTimeline({ recordGlobal: false });
      return;
    }
    if (target === 'project') {
      redoProject({ recordGlobal: false });
    }
  }

  function undoProject(options) {
    if (projectHistory.length < 2) return false;
    const current = projectHistory.pop();
    projectFuture.push(current);
    const previous = projectHistory[projectHistory.length - 1];
    if (!previous || !previous.project) return false;
    applyProjectData(previous.project, {
      preserveProjectMeta: true,
      skipProjectHistoryReset: true,
      silent: true,
      preserveSaveSnapshots: true,
    });
    updateProjectDirtyState();
    if (options && options.recordGlobal) {
      pushGlobalRedo('project', current.reason || 'project');
    }
    updateGlobalUndoIndicators();
    return true;
  }

  function redoProject(options) {
    const next = projectFuture.pop();
    if (!next || !next.project) return false;
    projectHistory.push(next);
    applyProjectData(next.project, {
      preserveProjectMeta: true,
      skipProjectHistoryReset: true,
      silent: true,
      preserveSaveSnapshots: true,
    });
    updateProjectDirtyState();
    if (!options || options.recordGlobal !== false) {
      consumeGlobalRedo('project');
    }
    updateGlobalUndoIndicators();
    return true;
  }

  function undoTimeline(options) {
    const entry = timelineHistory.pop();
    if (!entry) return;
    timelineFuture.push({
      clips: cloneTimelineClips(),
      selectedClipId: state.selectedClipId,
      playhead: state.playhead,
      signature: timelineSignature(state.clips),
      reason: 'redo',
      at: nextHistoryAt(),
    });
    applyTimelineSnapshot(entry);
    renderTimelineHistoryPanel();
    if (!options || options.recordGlobal !== false) {
      pushGlobalRedo('timeline', formatGlobalEntryLabel('timeline', entry));
    }
    updateGlobalUndoIndicators();
    return true;
  }

  function redoTimeline(options) {
    const entry = timelineFuture.pop();
    if (!entry) return;
    timelineHistory.push({
      clips: cloneTimelineClips(),
      selectedClipId: state.selectedClipId,
      playhead: state.playhead,
      signature: timelineSignature(state.clips),
      reason: 'undo',
      at: nextHistoryAt(),
    });
    applyTimelineSnapshot(entry);
    renderTimelineHistoryPanel();
    if (!options || options.recordGlobal !== false) {
      consumeGlobalRedo('timeline');
    }
    updateGlobalUndoIndicators();
    return true;
  }

  function projectFingerprint(project) {
    if (!project) return '';
    const data = {
      fps: project.fps,
      resolution: project.resolution,
      bpm: project.bpm,
      bpm_min: project.bpm_min,
      bpm_max: project.bpm_max,
      snap_to_beat: project.snap_to_beat,
      beat_highlights: project.beat_highlights,
      beat_highlight_threshold: project.beat_highlight_threshold,
      autoscroll_waveform: project.autoscroll_waveform,
      automation_tooltip: project.automation_tooltip,
      automation_grid: project.automation_grid,
      assets: project.assets,
      clips: project.clips,
      audio: project.audio,
      stage_elements: project.stage_elements,
    };
    return JSON.stringify(data);
  }

  function currentProjectFingerprint() {
    return projectFingerprint(serializeProject());
  }

  function hasUnsavedProjectChanges() {
    return currentProjectFingerprint() !== state.lastSavedSnapshot;
  }

  function hasUnsavedFileChanges() {
    const current = currentProjectFingerprint();
    if (state.currentProjectPath || state.currentProjectId) {
      return current !== state.lastFileSavedSnapshot;
    }
    return current !== state.lastSavedSnapshot;
  }

  function updateProjectDirtyState() {
    const saveButton = getEl('project-save-fs');
    const fileSaveButton = getEl('fs-save-project');
    const dirty = hasUnsavedFileChanges();
    if (saveButton) {
      saveButton.textContent = dirty ? 'Save*' : 'Save';
      saveButton.title = dirty ? 'Save project (Ctrl+S)' : 'Save project';
    }
    if (fileSaveButton) {
      fileSaveButton.textContent = dirty ? 'Save*' : 'Save';
      fileSaveButton.title = dirty ? 'Save project (Ctrl+S)' : 'Save project';
    }
    if (document.documentElement && document.documentElement.classList) {
      document.documentElement.classList.toggle('video-editor-dirty', dirty);
    }
  }

  function markProjectFileSaved(project) {
    state.lastFileSavedSnapshot = projectFingerprint(
      project || serializeProject()
    );
    updateProjectDirtyState();
  }

  function applyProjectIdentity(meta) {
    const next = meta || {};
    if (Object.prototype.hasOwnProperty.call(next, 'projectId'))
      state.currentProjectId = next.projectId || '';
    if (Object.prototype.hasOwnProperty.call(next, 'projectName'))
      state.currentProjectName = next.projectName || '';
    if (Object.prototype.hasOwnProperty.call(next, 'shareToken'))
      state.currentShareToken = next.shareToken || '';
    if (Object.prototype.hasOwnProperty.call(next, 'parentProjectId'))
      state.currentProjectParentId = next.parentProjectId || '';
    if (Object.prototype.hasOwnProperty.call(next, 'readOnly'))
      state.projectReadOnly = !!next.readOnly;
    syncProjectChrome();
  }

  function syncProjectChrome() {
    const status = el.projectSyncStatus;
    if (status) {
      status.classList.remove('readonly', 'synced');
      let text = 'Local only';
      let title = 'Project only saved in this browser';
      if (state.projectReadOnly && state.currentShareToken) {
        text = `Read only: ${state.currentProjectName || 'Shared Project'}`;
        title = 'Shared project preview';
        status.classList.add('readonly');
      } else if (state.currentProjectId) {
        text = `Synced: ${state.currentProjectName || 'Project'}`;
        title = 'Project saved to your account';
        status.classList.add('synced');
      }
      status.textContent = text;
      status.title = title;
    }
    if (el.projectForkCloud) {
      el.projectForkCloud.style.display = state.projectReadOnly ? '' : 'none';
    }
    if (el.projectReadonlyBanner) {
      el.projectReadonlyBanner.classList.toggle(
        'open',
        !!state.projectReadOnly
      );
    }
    const shell = document.querySelector('.video-editor-shell');
    if (shell) {
      shell.classList.toggle('read-only', !!state.projectReadOnly);
    }
  }

  function resetProjectHistory(project) {
    projectHistory.length = 0;
    projectFuture.length = 0;
    const snapshot = JSON.parse(JSON.stringify(project || serializeProject()));
    const fingerprint = projectFingerprint(snapshot);
    projectHistory.push({
      project: snapshot,
      fingerprint,
      at: nextHistoryAt(),
      reason: 'reset',
    });
  }

  function captureProjectHistory(reason) {
    const snapshot = serializeProject();
    const fingerprint = projectFingerprint(snapshot);
    const last = projectHistory[projectHistory.length - 1];
    if (last && last.fingerprint === fingerprint) return false;
    projectHistory.push({
      project: JSON.parse(JSON.stringify(snapshot)),
      fingerprint,
      at: nextHistoryAt(),
      reason: reason || 'edit',
    });
    if (projectHistory.length > PROJECT_HISTORY_LIMIT) {
      projectHistory.shift();
    }
    projectFuture.length = 0;
    return true;
  }

  function handleEditorBeforeUnload(event) {
    if (!state.userInteracted) return;
    if (!hasUnsavedFileChanges()) return;
    event.preventDefault();
    event.returnValue = '';
    return '';
  }

  function handleReadOnlyKeydown(event) {
    if (!state.projectReadOnly) return;
    const { key, lower } = getEventKeyData(event);
    if (!key) return;
    const modKey = event.ctrlKey || event.metaKey;
    if (modKey && !event.altKey && !event.shiftKey && lower === 's') {
      event.preventDefault();
      event.stopPropagation();
      saveProjectCopy();
      return;
    }
    if (isEditorModalOpen()) return;
    if (
      key === 'Tab' ||
      key === 'Escape' ||
      key === 'Shift' ||
      key === 'Control' ||
      key === 'Meta' ||
      key === 'Alt'
    ) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    notify('Shared project is read only', 'info');
  }

  function getHistory() {
    const raw = localStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function normalizePresetList(list) {
    if (!Array.isArray(list)) return [];
    return list
      .map((preset) => {
        if (!preset || typeof preset !== 'object') return null;
        const name =
          typeof preset.name === 'string' && preset.name.trim()
            ? preset.name.trim()
            : 'Preset';
        const keyframes = normalizeKeyframes(
          preset.keyframes || preset.frames || [],
          'linear'
        );
        if (!keyframes.length) return null;
        const id =
          typeof preset.id === 'string' && preset.id
            ? preset.id
            : `preset_${Date.now()}_${Math.random().toString(16).slice(2)}`;
        const duration =
          typeof preset.duration === 'number' && preset.duration > 0
            ? preset.duration
            : null;
        return { id, name, keyframes, duration };
      })
      .filter(Boolean);
  }

  function loadAutomationPresets() {
    const raw = localStorage.getItem(PRESET_KEY);
    if (!raw) {
      state.automationPresets = { gain: [], pan: [] };
      renderAutomationPresetSelects();
      return;
    }
    try {
      const parsed = JSON.parse(raw);
      state.automationPresets = {
        gain: normalizePresetList(parsed.gain || []),
        pan: normalizePresetList(parsed.pan || []),
      };
    } catch {
      state.automationPresets = { gain: [], pan: [] };
    }
    renderAutomationPresetSelects();
  }

  function saveAutomationPresets() {
    localStorage.setItem(
      PRESET_KEY,
      JSON.stringify(state.automationPresets || { gain: [], pan: [] })
    );
  }

  function loadInspectorPins() {
    const raw = localStorage.getItem(INSPECTOR_PINS_KEY);
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      const validKeys = new Set(INSPECTOR_PIN_FIELDS.map((field) => field.key));
      return parsed
        .filter((key) => typeof key === 'string' && validKeys.has(key))
        .slice(0, INSPECTOR_PIN_MAX);
    } catch {
      return [];
    }
  }

  function saveInspectorPins() {
    localStorage.setItem(
      INSPECTOR_PINS_KEY,
      JSON.stringify(state.inspectorPins || [])
    );
  }

  function toggleInspectorPin(key, enabled) {
    const next = new Set(state.inspectorPins || []);
    if (enabled) {
      if (next.size >= INSPECTOR_PIN_MAX && !next.has(key)) {
        notify(`Pin limit is ${INSPECTOR_PIN_MAX}`, 'warning');
        renderInspectorPinMenu();
        return;
      }
      next.add(key);
    } else {
      next.delete(key);
    }
    state.inspectorPins = Array.from(next);
    saveInspectorPins();
    renderInspectorPinMenu();
    renderInspector();
  }

  function renderInspectorPinMenu() {
    if (!el.inspectorPinMenu) return;
    el.inspectorPinMenu.innerHTML = '';
    const active = new Set(state.inspectorPins || []);
    INSPECTOR_PIN_FIELDS.forEach((field) => {
      const label = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.checked = active.has(field.key);
      if (!input.checked && active.size >= INSPECTOR_PIN_MAX) {
        input.disabled = true;
      }
      input.addEventListener('change', () =>
        toggleInspectorPin(field.key, input.checked)
      );
      label.appendChild(input);
      label.append(` ${field.label}`);
      el.inspectorPinMenu.appendChild(label);
    });
    if (active.size) {
      const resetBtn = document.createElement('button');
      resetBtn.type = 'button';
      resetBtn.textContent = 'Reset pinned defaults';
      resetBtn.addEventListener('click', () => {
        const clip = getSelectedClip();
        if (!clip) return;
        active.forEach((key) => {
          if (
            Object.prototype.hasOwnProperty.call(INSPECTOR_PIN_DEFAULTS, key)
          ) {
            updateClipField(key, INSPECTOR_PIN_DEFAULTS[key]);
          }
        });
        renderInspector();
      });
      el.inspectorPinMenu.appendChild(resetBtn);
      const clearBtn = document.createElement('button');
      clearBtn.type = 'button';
      clearBtn.textContent = 'Clear all pins';
      clearBtn.addEventListener('click', () => {
        state.inspectorPins = [];
        saveInspectorPins();
        renderInspectorPinMenu();
        renderInspector();
      });
      el.inspectorPinMenu.appendChild(clearBtn);
    }
    const note = document.createElement('div');
    note.className = 'inspector-pin-note';
    note.textContent = `${active.size}/${INSPECTOR_PIN_MAX} pinned`;
    el.inspectorPinMenu.appendChild(note);
  }

  function formatPinnedValue(clip, key) {
    if (!clip) return '';
    if (key === 'name') return clip.name || '';
    if (key === 'duration') return clip.duration.toFixed(2);
    if (key === 'trimStart') return clip.trimStart.toFixed(2);
    if (key === 'trimEnd') return clip.trimEnd.toFixed(2);
    if (key === 'speed') return clip.speed.toFixed(2);
    if (key === 'audioGain') return (clip.audioGain ?? 1).toFixed(2);
    if (key === 'audioPan') return (clip.audioPan ?? 0).toFixed(2);
    return '';
  }

  function renderInspectorPins(clip) {
    if (!el.inspectorPins || !el.inspectorPinFields) return;
    if (!clip || !state.inspectorPins || !state.inspectorPins.length) {
      el.inspectorPins.style.display = 'none';
      return;
    }
    el.inspectorPins.style.display = 'block';
    el.inspectorPinFields.innerHTML = '';
    state.inspectorPins.forEach((key) => {
      const field = INSPECTOR_PIN_FIELDS.find((item) => item.key === key);
      if (!field) return;
      const row = document.createElement('div');
      row.className = 'inspector-pins-row';
      row.setAttribute('draggable', 'true');
      row.dataset.pinKey = key;
      row.addEventListener('dragstart', () => {
        inspectorPinDrag = key;
        row.classList.add('dragging');
      });
      row.addEventListener('dragend', () => {
        inspectorPinDrag = null;
        row.classList.remove('dragging');
        el.inspectorPinFields
          .querySelectorAll('.inspector-pins-row')
          .forEach((elRow) => elRow.classList.remove('drag-over'));
      });
      row.addEventListener('dragover', (event) => {
        if (!inspectorPinDrag || inspectorPinDrag === key) return;
        event.preventDefault();
        row.classList.add('drag-over');
      });
      row.addEventListener('dragleave', () => {
        row.classList.remove('drag-over');
      });
      row.addEventListener('drop', (event) => {
        if (!inspectorPinDrag || inspectorPinDrag === key) return;
        event.preventDefault();
        row.classList.remove('drag-over');
        const current = state.inspectorPins.slice();
        const from = current.indexOf(inspectorPinDrag);
        const to = current.indexOf(key);
        if (from === -1 || to === -1) return;
        current.splice(from, 1);
        current.splice(to, 0, inspectorPinDrag);
        state.inspectorPins = current;
        saveInspectorPins();
        renderInspectorPins(clip);
      });
      const handle = document.createElement('span');
      handle.className = 'inspector-pin-handle';
      handle.textContent = '⋮⋮';
      const label = document.createElement('label');
      label.textContent = field.label;
      const input = document.createElement('input');
      input.type = field.type || 'text';
      if (typeof field.min !== 'undefined') input.min = String(field.min);
      if (typeof field.max !== 'undefined') input.max = String(field.max);
      if (typeof field.step !== 'undefined') input.step = String(field.step);
      input.value = formatPinnedValue(clip, key);
      input.addEventListener('change', () => {
        updateClipField(key, input.value);
      });
      const reset = document.createElement('button');
      reset.type = 'button';
      reset.className = 'inspector-pin-reset';
      reset.textContent = '↺';
      if (!Object.prototype.hasOwnProperty.call(INSPECTOR_PIN_DEFAULTS, key)) {
        reset.disabled = true;
      } else {
        reset.addEventListener('click', () => {
          updateClipField(key, INSPECTOR_PIN_DEFAULTS[key]);
          input.value = formatPinnedValue(clip, key);
        });
      }
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'inspector-pin-remove';
      remove.textContent = '×';
      remove.addEventListener('click', () => toggleInspectorPin(key, false));
      row.appendChild(handle);
      row.appendChild(label);
      row.appendChild(input);
      row.appendChild(reset);
      row.appendChild(remove);
      el.inspectorPinFields.appendChild(row);
    });
  }

  function renderAutomationPresetSelect(axis) {
    const select =
      axis === 'gain' ? el.clipAudioGainPresets : el.clipAudioPanPresets;
    const presets = state.automationPresets
      ? state.automationPresets[axis] || []
      : [];
    if (!select) return;
    const current = select.value;
    select.innerHTML = '';
    if (!presets.length) {
      const opt = document.createElement('option');
      opt.value = '';
      opt.textContent = 'No presets';
      opt.disabled = true;
      opt.selected = true;
      select.appendChild(opt);
      if (axis === 'gain') {
        if (el.clipAudioGainPresetApply)
          el.clipAudioGainPresetApply.disabled = true;
        if (el.clipAudioGainPresetRename)
          el.clipAudioGainPresetRename.disabled = true;
        if (el.clipAudioGainPresetDelete)
          el.clipAudioGainPresetDelete.disabled = true;
      } else {
        if (el.clipAudioPanPresetApply)
          el.clipAudioPanPresetApply.disabled = true;
        if (el.clipAudioPanPresetRename)
          el.clipAudioPanPresetRename.disabled = true;
        if (el.clipAudioPanPresetDelete)
          el.clipAudioPanPresetDelete.disabled = true;
      }
      return;
    }
    const sorted = presets
      .slice()
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    sorted.forEach((preset) => {
      const opt = document.createElement('option');
      opt.value = preset.id;
      const details = [];
      if (typeof preset.duration === 'number' && preset.duration > 0) {
        details.push(`${preset.duration.toFixed(2)}s`);
      }
      details.push(`${preset.keyframes.length} pts`);
      opt.textContent = details.length
        ? `${preset.name} • ${details.join(' • ')}`
        : preset.name;
      select.appendChild(opt);
    });
    if (current && sorted.some((preset) => preset.id === current)) {
      select.value = current;
    } else {
      select.selectedIndex = 0;
    }
    if (axis === 'gain') {
      if (el.clipAudioGainPresetApply)
        el.clipAudioGainPresetApply.disabled = false;
      if (el.clipAudioGainPresetRename)
        el.clipAudioGainPresetRename.disabled = false;
      if (el.clipAudioGainPresetDelete)
        el.clipAudioGainPresetDelete.disabled = false;
    } else {
      if (el.clipAudioPanPresetApply)
        el.clipAudioPanPresetApply.disabled = false;
      if (el.clipAudioPanPresetRename)
        el.clipAudioPanPresetRename.disabled = false;
      if (el.clipAudioPanPresetDelete)
        el.clipAudioPanPresetDelete.disabled = false;
    }
  }

  function renderAutomationPresetSelects() {
    renderAutomationPresetSelect('gain');
    renderAutomationPresetSelect('pan');
  }

  function saveAutomationPreset(axis) {
    const clip = getSelectedClip();
    if (!clip) return;
    const keyframes =
      axis === 'gain' ? clip.audioGainKeyframes : clip.audioPanKeyframes;
    if (!Array.isArray(keyframes) || !keyframes.length) {
      notify('No keyframes to save', 'error');
      return;
    }
    const nameInput =
      axis === 'gain' ? el.clipAudioGainPresetName : el.clipAudioPanPresetName;
    let name = nameInput && nameInput.value ? nameInput.value.trim() : '';
    if (!name) {
      const count = (state.automationPresets?.[axis]?.length || 0) + 1;
      name = axis === 'gain' ? `Gain Preset ${count}` : `Pan Preset ${count}`;
    }
    const normalized = normalizeKeyframes(keyframes, 'linear');
    const duration = clip.duration || 0;
    const presets = state.automationPresets
      ? state.automationPresets[axis]
      : null;
    if (!presets) {
      state.automationPresets = state.automationPresets || {
        gain: [],
        pan: [],
      };
      state.automationPresets[axis] = [];
    }
    const existing = state.automationPresets[axis].find(
      (preset) => preset.name === name
    );
    let presetId = existing ? existing.id : '';
    if (existing) {
      existing.keyframes = normalized;
      existing.duration = duration;
    } else {
      presetId = `preset_${Date.now()}_${Math.random().toString(16).slice(2)}`;
      state.automationPresets[axis].push({
        id: presetId,
        name,
        keyframes: normalized,
        duration,
      });
    }
    saveAutomationPresets();
    renderAutomationPresetSelect(axis);
    const select =
      axis === 'gain' ? el.clipAudioGainPresets : el.clipAudioPanPresets;
    if (select && presetId) {
      select.value = presetId;
    }
    if (nameInput) nameInput.value = '';
    notify(`${name} saved`, 'success');
  }

  function applyAutomationPreset(axis) {
    const clip = getSelectedClip();
    if (!clip) return;
    const select =
      axis === 'gain' ? el.clipAudioGainPresets : el.clipAudioPanPresets;
    if (!select || !select.value) return;
    const presets = state.automationPresets
      ? state.automationPresets[axis] || []
      : [];
    const currentDuration = clip.duration || 0;
    const preset = presets.find((item) => item.id === select.value);
    if (!preset) return;
    const duration = Math.max(0.01, clip.duration || 1);
    const sourceDuration =
      preset.duration && preset.duration > 0 ? preset.duration : duration;
    const scale = sourceDuration > 0 ? duration / sourceDuration : 1;
    if (preset.duration && Math.abs(preset.duration - currentDuration) > 0.01) {
      notify(
        `Preset scaled ${preset.duration.toFixed(2)}s → ${duration.toFixed(2)}s`,
        'info'
      );
    }
    const keyframes = preset.keyframes.map((kf) => ({
      time: Math.max(0, Math.min(duration, kf.time * scale)),
      value: kf.value,
      ease: kf.ease,
    }));
    if (axis === 'gain') {
      clip.audioGainKeyframes = keyframes;
      setSelectedAutomation('gain', clip.audioGainKeyframes[0], 0);
      renderAudioGainKeyframes(clip);
    } else {
      clip.audioPanKeyframes = keyframes;
      setSelectedAutomation('pan', clip.audioPanKeyframes[0], 0);
      renderAudioPanKeyframes(clip);
    }
    drawClipAutomationPreview(clip);
    scheduleAutosave();
    notify(`${preset.name} applied`, 'success');
  }

  function deleteAutomationPreset(axis) {
    const select =
      axis === 'gain' ? el.clipAudioGainPresets : el.clipAudioPanPresets;
    if (!select || !select.value) return;
    const presets = state.automationPresets
      ? state.automationPresets[axis] || []
      : [];
    const index = presets.findIndex((item) => item.id === select.value);
    if (index < 0) return;
    const name = presets[index].name;
    if (!window.confirm(`Delete preset "${name}"?`)) return;
    presets.splice(index, 1);
    saveAutomationPresets();
    renderAutomationPresetSelect(axis);
    notify(`${name} deleted`, 'info');
  }

  function renameAutomationPreset(axis) {
    const select =
      axis === 'gain' ? el.clipAudioGainPresets : el.clipAudioPanPresets;
    if (!select || !select.value) return;
    const presets = state.automationPresets
      ? state.automationPresets[axis] || []
      : [];
    const preset = presets.find((item) => item.id === select.value);
    if (!preset) return;
    const next = window.prompt('Rename preset', preset.name || '');
    if (!next || !next.trim()) return;
    const name = next.trim();
    if (presets.some((item) => item.id !== preset.id && item.name === name)) {
      notify('Preset name already exists', 'error');
      return;
    }
    preset.name = name;
    saveAutomationPresets();
    renderAutomationPresetSelect(axis);
    select.value = preset.id;
    notify(`${name} renamed`, 'success');
  }

  function exportAutomationPresets() {
    const payload = state.automationPresets || { gain: [], pan: [] };
    const blob = new Blob([JSON.stringify(payload, null, 2)], {
      type: 'application/json',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'automation-presets.json';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }

  function encodePresets(payload) {
    const json = JSON.stringify(payload || { gain: [], pan: [] });
    if (window.TextEncoder && window.TextDecoder) {
      const bytes = new TextEncoder().encode(json);
      let binary = '';
      bytes.forEach((b) => {
        binary += String.fromCharCode(b);
      });
      return btoa(binary);
    }
    return btoa(unescape(encodeURIComponent(json)));
  }

  async function encodePresetsCompressed(payload) {
    if (!window.CompressionStream || !window.TextEncoder) return null;
    const json = JSON.stringify(payload || { gain: [], pan: [] });
    const stream = new CompressionStream('gzip');
    const writer = stream.writable.getWriter();
    writer.write(new TextEncoder().encode(json));
    writer.close();
    const compressed = await new Response(stream.readable).arrayBuffer();
    const bytes = new Uint8Array(compressed);
    let binary = '';
    bytes.forEach((b) => {
      binary += String.fromCharCode(b);
    });
    return btoa(binary);
  }

  function decodePresets(encoded) {
    if (window.TextDecoder && window.TextEncoder) {
      const binary = atob(encoded);
      const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
      const json = new TextDecoder().decode(bytes);
      return JSON.parse(json);
    }
    const json = decodeURIComponent(escape(atob(encoded)));
    return JSON.parse(json);
  }

  async function decodePresetsCompressed(encoded) {
    if (!window.DecompressionStream || !window.TextDecoder) {
      throw new Error('Compressed presets not supported');
    }
    const binary = atob(encoded);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    const stream = new DecompressionStream('gzip');
    const writer = stream.writable.getWriter();
    writer.write(bytes);
    writer.close();
    const decompressed = await new Response(stream.readable).arrayBuffer();
    const json = new TextDecoder().decode(new Uint8Array(decompressed));
    return JSON.parse(json);
  }

  function importAutomationPresetsFromPayload(parsed, replace) {
    const incoming = {
      gain: normalizePresetList(parsed.gain || []),
      pan: normalizePresetList(parsed.pan || []),
    };
    if (!incoming.gain.length && !incoming.pan.length) {
      notify('No presets found', 'error');
      return false;
    }
    ['gain', 'pan'].forEach((axis) => {
      state.automationPresets = state.automationPresets || {
        gain: [],
        pan: [],
      };
      const existing = replace ? [] : state.automationPresets[axis] || [];
      incoming[axis].forEach((preset) => {
        let name = preset.name;
        let suffix = 1;
        const names = new Set(existing.map((item) => item.name));
        while (names.has(name)) {
          suffix += 1;
          name = `${preset.name} (${suffix})`;
        }
        existing.push({
          id: `preset_${Date.now()}_${Math.random().toString(16).slice(2)}`,
          name,
          keyframes: preset.keyframes,
          duration: preset.duration,
        });
      });
      state.automationPresets[axis] = existing;
    });
    saveAutomationPresets();
    renderAutomationPresetSelects();
    notify(replace ? 'Presets replaced' : 'Presets imported', 'success');
    return true;
  }

  async function copyAutomationPresetsToClipboard() {
    if (!navigator.clipboard || !navigator.clipboard.writeText) {
      notify('Clipboard not available', 'error');
      return;
    }
    try {
      const payload = state.automationPresets || { gain: [], pan: [] };
      await navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
      notify('Presets copied', 'success');
    } catch {
      notify('Failed to copy presets', 'error');
    }
  }

  async function pasteAutomationPresetsFromClipboard() {
    if (!navigator.clipboard || !navigator.clipboard.readText) {
      notify('Clipboard not available', 'error');
      return;
    }
    try {
      const text = await navigator.clipboard.readText();
      if (!text) {
        notify('Clipboard is empty', 'error');
        return;
      }
      const parsed = JSON.parse(text);
      const replace =
        el.automationPresetsReplace && el.automationPresetsReplace.checked;
      importAutomationPresetsFromPayload(parsed, replace);
    } catch {
      notify('Failed to paste presets', 'error');
    }
  }

  function buildAutomationPresetsLink(options) {
    const allowLong = options && options.allowLong;
    const payload = state.automationPresets || { gain: [], pan: [] };
    const encoded = encodePresets(payload);
    if (!allowLong && encoded.length > 1800) {
      return {
        url: null,
        error: 'Preset link too long; use Export or Copy instead',
      };
    }
    const base = `${window.location.origin}${window.location.pathname}${window.location.search}`;
    const replace =
      el.automationPresetsReplace && el.automationPresetsReplace.checked
        ? '&replace=1'
        : '';
    const url = `${base}#automation_presets=${encodeURIComponent(encoded)}${replace}`;
    return { url, error: null };
  }

  async function buildAutomationPresetsCompressedLink(options) {
    const allowLong = options && options.allowLong;
    const payload = state.automationPresets || { gain: [], pan: [] };
    const encoded = await encodePresetsCompressed(payload);
    if (!encoded) {
      return {
        url: null,
        error: 'Compressed presets not supported; use Export or Copy instead',
      };
    }
    if (!allowLong && encoded.length > 1800) {
      return {
        url: null,
        error: 'Compressed preset link too long; use Export or Copy instead',
      };
    }
    const base = `${window.location.origin}${window.location.pathname}${window.location.search}`;
    const replace =
      el.automationPresetsReplace && el.automationPresetsReplace.checked
        ? '&replace=1'
        : '';
    const url = `${base}#automation_presets_gz=${encodeURIComponent(encoded)}${replace}`;
    return { url, error: null };
  }

  async function copyAutomationPresetsLink() {
    if (!navigator.clipboard || !navigator.clipboard.writeText) {
      notify('Clipboard not available', 'error');
      return;
    }
    try {
      const { url, error } = await resolveAutomationPresetsLink();
      if (!url) {
        notify(error || 'Failed to build preset link', 'error');
        return;
      }
      if (error) {
        notify(error, 'info');
      }
      await navigator.clipboard.writeText(url);
      notify('Preset link copied', 'success');
    } catch {
      notify('Failed to copy preset link', 'error');
    }
  }

  async function resolveAutomationPresetsLink() {
    const wantShort = !!(
      el.automationPresetsShort && el.automationPresetsShort.checked
    );
    const { url, error } = buildAutomationPresetsLink({ allowLong: wantShort });
    if (!url) {
      if (!wantShort) {
        const compressed = await buildAutomationPresetsCompressedLink({
          allowLong: false,
        });
        if (compressed.url) {
          return { url: compressed.url, error: 'Using compressed link' };
        }
      }
      return { url: null, error };
    }
    if (!wantShort) return { url, error: null };
    try {
      const resp = await fetch(
        `https://is.gd/create.php?format=simple&url=${encodeURIComponent(url)}`
      );
      if (resp.ok) {
        const text = (await resp.text()).trim();
        if (text.startsWith('http')) {
          return { url: text, error: null };
        }
      }
    } catch {
      // ignore
    }
    const compressed = await buildAutomationPresetsCompressedLink({
      allowLong: true,
    });
    if (compressed.url) {
      return {
        url: compressed.url,
        error: 'Short link failed; using compressed link',
      };
    }
    return { url, error: 'Short link failed; using long link' };
  }

  function openAutomationPresetsQr() {
    resolveAutomationPresetsLink().then((result) => {
      if (!result.url) {
        notify(result.error || 'Failed to build preset link', 'error');
        return;
      }
      if (result.error) {
        notify(result.error, 'info');
      }
      if (el.automationQrImage) {
        el.automationQrImage.src = `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(result.url)}`;
      }
      if (el.automationQrLink) {
        el.automationQrLink.textContent = result.url;
      }
      if (el.automationQrBackdrop) {
        el.automationQrBackdrop.style.display = 'flex';
      }
    });
  }

  function closeAutomationPresetsQr() {
    if (el.automationQrBackdrop) {
      el.automationQrBackdrop.style.display = 'none';
    }
  }

  function maybeImportPresetsFromHash() {
    const hash = window.location.hash || '';
    if (
      !hash.includes('automation_presets=') &&
      !hash.includes('automation_presets_gz=')
    )
      return;
    const params = new URLSearchParams(hash.slice(1));
    const encoded = params.get('automation_presets');
    const compressed = params.get('automation_presets_gz');
    const replace = params.get('replace') === '1';
    const clearHash = () => {
      const base = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(null, '', base);
    };
    if (compressed) {
      decodePresetsCompressed(compressed)
        .then((parsed) => {
          importAutomationPresetsFromPayload(parsed, replace);
        })
        .catch(() => {
          notify('Failed to import compressed presets from link', 'error');
        })
        .finally(clearHash);
      return;
    }
    if (!encoded) return;
    try {
      const parsed = decodePresets(encoded);
      importAutomationPresetsFromPayload(parsed, replace);
    } catch {
      notify('Failed to import presets from link', 'error');
    } finally {
      clearHash();
    }
  }

  function clearAutomationPresets() {
    if (!window.confirm('Clear all automation presets?')) return;
    state.automationPresets = { gain: [], pan: [] };
    saveAutomationPresets();
    renderAutomationPresetSelects();
    notify('Presets cleared', 'info');
  }

  function handleAutomationPresetImport(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const parsed = JSON.parse(reader.result);
        const replace =
          el.automationPresetsReplace && el.automationPresetsReplace.checked;
        importAutomationPresetsFromPayload(parsed, replace);
      } catch {
        notify('Failed to import presets', 'error');
      } finally {
        event.target.value = '';
      }
    };
    reader.readAsText(file);
  }

  function saveHistory(entries) {
    localStorage.setItem(
      HISTORY_KEY,
      JSON.stringify(entries.slice(0, HISTORY_LIMIT))
    );
  }

  function updateHistory(project, fingerprint) {
    const now = Date.now();
    const history = getHistory();
    const entry = { id: now, saved_at: now, snapshot: fingerprint, project };
    if (history.length > 0) {
      const last = history[0];
      if (last.snapshot === fingerprint) {
        return;
      }
      if (now - last.saved_at < HISTORY_MIN_INTERVAL) {
        history[0] = entry;
      } else {
        history.unshift(entry);
      }
    } else {
      history.unshift(entry);
    }
    saveHistory(history);
  }

  function renderHistory() {
    if (!el.historyList) return;
    const history = getHistory();
    el.historyList.innerHTML = '';
    if (history.length === 0) {
      const empty = document.createElement('div');
      empty.className = 'queue-item';
      empty.textContent = 'No history saved yet';
      el.historyList.appendChild(empty);
      return;
    }
    history.forEach((entry) => {
      const row = document.createElement('div');
      row.className = 'queue-item';
      const when = new Date(entry.saved_at).toLocaleString();
      const clips = entry.project?.clips?.length || 0;
      const assets = entry.project?.assets?.length || 0;
      row.innerHTML = `<div>${when}</div><div>${clips} clips · ${assets} assets</div><div class="action-row"><button data-action="restore-history" data-history-id="${entry.id}">Restore</button></div>`;
      el.historyList.appendChild(row);
    });
  }

  function handleHistoryAction(event) {
    const target = event.target;
    if (!target) return;
    const action = target.getAttribute('data-action');
    if (action !== 'restore-history') return;
    const id = target.getAttribute('data-history-id');
    if (!id) return;
    const history = getHistory();
    const entry = history.find((item) => String(item.id) === String(id));
    if (!entry || !entry.project) {
      notify('History entry missing', 'error');
      return;
    }
    applyProjectData(entry.project);
  }

  function restoreLatestHistory() {
    const history = getHistory();
    if (history.length === 0) {
      notify('No history to restore', 'error');
      return;
    }
    applyProjectData(history[0].project);
  }

  function clearHistory() {
    localStorage.removeItem(HISTORY_KEY);
    renderHistory();
    notify('History cleared', 'success');
  }

  async function loadAssetFromData(asset) {
    if (!asset || !asset.src || asset.is_local) return null;
    if (asset.type === 'image') {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          resolve({
            id:
              'asset_' + Date.now() + '_' + Math.random().toString(16).slice(2),
            type: 'image',
            name: asset.name || 'Image',
            src: asset.src,
            originalSrc: asset.originalSrc || '',
            file: null,
            duration: asset.duration || 4,
            width: img.naturalWidth,
            height: img.naturalHeight,
            element: img,
          });
        };
        img.onerror = () => {
          if (img.crossOrigin) {
            img.crossOrigin = null;
            img.src = asset.src;
            return;
          }
          resolve(null);
        };
        setEditorMediaSource(img, asset.src);
      });
    }
    if (asset.type === 'video') {
      return new Promise((resolve) => {
        const video = document.createElement('video');
        video.preload = 'auto';
        video.muted = true;
        video.onloadedmetadata = () => {
          const duration = isFinite(video.duration)
            ? video.duration
            : asset.duration || 4;
          resolve({
            id:
              'asset_' + Date.now() + '_' + Math.random().toString(16).slice(2),
            type: 'video',
            name: asset.name || 'Video',
            src: asset.src,
            file: null,
            duration: duration,
            width: video.videoWidth,
            height: video.videoHeight,
            element: video,
          });
          primeVideoPreviewFrame(video);
          setTimeout(() => renderPrimedVideoFrame(video), 500);
        };
        video.onloadeddata = () => {
          primeVideoPreviewFrame(video);
          renderPrimedVideoFrame(video);
        };
        video.oncanplay = () => {
          primeVideoPreviewFrame(video);
          renderPrimedVideoFrame(video);
        };
        video.onseeked = refreshPreviewFrame;
        video.onerror = () => {
          if (video.crossOrigin) {
            video.crossOrigin = null;
            video.src = asset.src;
            return;
          }
          resolve(null);
        };
        setEditorMediaSource(video, asset.src);
      });
    }
    if (asset.type === 'audio') {
      return new Promise((resolve) => {
        const audio = new Audio();
        setEditorMediaSource(audio, asset.src);
        audio.preload = 'metadata';
        audio.onloadedmetadata = () => {
          const duration = isFinite(audio.duration)
            ? audio.duration
            : asset.duration || 4;
          resolve({
            id:
              'asset_' + Date.now() + '_' + Math.random().toString(16).slice(2),
            type: 'audio',
            name: asset.name || 'Audio',
            src: asset.src,
            file: null,
            duration: duration,
            width: 0,
            height: 0,
            element: null,
          });
        };
        audio.onerror = () => resolve(null);
      });
    }
    return null;
  }

  async function applyProjectData(project, options) {
    const opts = options || {};
    const previousLastSavedSnapshot = state.lastSavedSnapshot;
    const previousLastFileSavedSnapshot = state.lastFileSavedSnapshot;
    if (!project || typeof project !== 'object') {
      notify('Invalid project file', 'error');
      return;
    }
    state.assets = [];
    state.clips = [];
    state.pages = [];
    state.activePageId = null;
    setTimelineSelection([], null);
    state.selectedAssetId = null;
    timelineHistory.length = 0;
    timelineFuture.length = 0;
    timelineCoalesceInfo = null;
    globalRedoStack.length = 0;
    if (timelineCoalesceTimer) {
      window.clearTimeout(timelineCoalesceTimer);
      timelineCoalesceTimer = null;
    }
    renderTimelineHistoryPanel();
    updateGlobalUndoIndicators();
    if (!opts.preserveProjectMeta) {
      applyProjectIdentity({
        projectId: opts.projectId || '',
        projectName: opts.projectName || '',
        shareToken: opts.shareToken || '',
        parentProjectId: opts.parentProjectId || '',
        readOnly: opts.readOnly || false,
      });
      if (!opts.keepCurrentProjectPath) {
        state.currentProjectPath = opts.projectPath || '';
        updateFsProjectLabel();
      }
    } else if (Object.prototype.hasOwnProperty.call(opts, 'readOnly')) {
      applyProjectIdentity({ readOnly: opts.readOnly });
    }

    if (
      project.resolution &&
      project.resolution.width &&
      project.resolution.height
    ) {
      const value = `${project.resolution.width}x${project.resolution.height}`;
      if (el.projectResolution) {
        ensureProjectResolutionOption(value);
        el.projectResolution.value = value;
      }
    }
    if (project.fps && el.projectFps) {
      el.projectFps.value = String(project.fps);
    }
    if (typeof project.bpm === 'number' && !isNaN(project.bpm)) {
      state.bpm = Math.max(20, Math.min(260, project.bpm));
    }
    state.bpmConfidence = null;
    state.bpmMethod = '';
    if (typeof project.bpm_min === 'number' && !isNaN(project.bpm_min)) {
      state.bpmMin = Math.max(30, Math.min(240, project.bpm_min));
    }
    if (typeof project.bpm_max === 'number' && !isNaN(project.bpm_max)) {
      state.bpmMax = Math.max(60, Math.min(300, project.bpm_max));
    }
    if (typeof project.snap_to_beat === 'boolean') {
      state.snapToBeat = project.snap_to_beat;
    }
    if (typeof project.beat_highlights === 'boolean') {
      state.showBeatHighlights = project.beat_highlights;
    }
    if (
      typeof project.beat_highlight_threshold === 'number' &&
      !isNaN(project.beat_highlight_threshold)
    ) {
      const next = Math.max(
        0.4,
        Math.min(0.9, project.beat_highlight_threshold)
      );
      state.beatHighlightThreshold = next;
    }
    if (typeof project.autoscroll_waveform === 'boolean') {
      state.autoScrollWaveform = project.autoscroll_waveform;
    }
    if (typeof project.automation_tooltip === 'boolean') {
      state.showAutomationTooltip = project.automation_tooltip;
      if (!state.showAutomationTooltip) hideAutomationTooltip();
    }
    if (typeof project.automation_grid === 'boolean') {
      state.showAutomationBeatGrid = project.automation_grid;
      if (el.clipAutomationGridToggle)
        el.clipAutomationGridToggle.checked = state.showAutomationBeatGrid;
    }
    if (Array.isArray(project.timeline_markers)) {
      state.timelineMarkers = normalizeTimelineMarkers(
        project.timeline_markers
      );
    } else {
      state.timelineMarkers = [];
    }
    updateProjectSettings();
    if (!opts.preserveProjectMeta && project.projectPath) {
      state.currentProjectPath = project.projectPath;
      updateFsProjectLabel();
    }

    const stageElements = Array.isArray(project.stage_elements)
      ? project.stage_elements
      : [];
    state.stageKeyframeMuted = project.stage_keyframe_muted
      ? { ...project.stage_keyframe_muted }
      : {};
    state.trackHeaders =
      project.track_headers && typeof project.track_headers === 'object'
        ? { ...project.track_headers }
        : {};
    pauseAllAudioTracks();
    state.audioTracks = [];
    if (Array.isArray(project.audio_tracks)) {
      project.audio_tracks.forEach(function (t) {
        if (!t || !t.id) return;
        var track = {
          id: t.id,
          label: t.label || 'Audio',
          src: t.src || '',
          element: null,
          settings: t.settings || { gain: 1, fadeIn: 0, fadeOut: 0 },
          muted: !!t.muted,
        };
        if (track.src) {
          var audio = new Audio();
          audio.preload = 'auto';
          setEditorMediaSource(audio, track.src);
          track.element = audio;
        }
        state.audioTracks.push(track);
      });
    }
    state.stageElements = stageElements
      .map(normalizeStageElement)
      .filter(Boolean);
    const pagesData = Array.isArray(project.pages) ? project.pages : [];
    state.pages = pagesData
      .map((page) =>
        page && page.id
          ? {
              id: page.id,
              name: page.name || 'Page',
              timelineStart: Number.isFinite(page.timeline_start)
                ? Math.max(0, page.timeline_start)
                : Number.isFinite(page.timelineStart)
                  ? Math.max(0, page.timelineStart)
                  : undefined,
            }
          : null
      )
      .filter(Boolean);
    state.activePageId =
      project.active_page_id || (state.pages[0] ? state.pages[0].id : null);
    ensurePages();
    state.stageElements.forEach((element) => ensureStageElementTiming(element));
    renderPages();
    state.selectedStageElementId = null;
    state.selectedStageElementIds = [];
    renderStageElements();

    const assetsData = Array.isArray(project.assets) ? project.assets : [];
    const missingAssets = assetsData.filter(
      (asset) => asset && asset.is_local
    ).length;
    const loadedAssets = [];
    for (const asset of assetsData) {
      const loaded = await loadAssetFromData(asset);
      if (loaded) {
        loadedAssets.push(loaded);
      }
    }
    state.assets = loadedAssets;
    state.assets.forEach((asset) => {
      if (asset.type === 'video')
        queueAssetAudioPeaks(asset, asset.file || null);
    });

    const assetBySrc = new Map();
    state.assets.forEach((asset) => {
      if (asset.src) assetBySrc.set(asset.src, asset);
    });

    const clipsData = Array.isArray(project.clips) ? project.clips : [];
    let skippedClips = 0;
    clipsData.forEach((clipData) => {
      if (clipData && clipData.type === 'caption') {
        const clip = buildCaptionClip({
          text: clipData.text || clipData.captionText || clipData.name || '',
          start: typeof clipData.start === 'number' ? clipData.start : 0,
          track: Number.isFinite(clipData.track)
            ? Math.max(0, Math.floor(clipData.track))
            : getCaptionTrack(),
          duration: clipData.duration || 2,
          captionFontSize:
            typeof clipData.captionFontSize === 'number'
              ? clipData.captionFontSize
              : clipData.caption_font_size,
          captionColor: clipData.captionColor || clipData.caption_color,
          captionAlign: clipData.captionAlign || clipData.caption_align,
          captionY:
            typeof clipData.captionY === 'number'
              ? clipData.captionY
              : clipData.caption_y,
        });
        state.clips.push(clip);
        ensureCaptionTrackLabel(clip.track);
        return;
      }
      const asset = assetBySrc.get(clipData.src);
      if (!asset) {
        skippedClips += 1;
        return;
      }
      const clipId =
        'clip_' + Date.now() + '_' + Math.random().toString(16).slice(2);
      const audioGain =
        typeof clipData.audioGain === 'number' ? clipData.audioGain : 1;
      const audioGainEnd =
        typeof clipData.audioGainEnd === 'number'
          ? clipData.audioGainEnd
          : typeof clipData.audio_gain_end === 'number'
            ? clipData.audio_gain_end
            : audioGain;
      const audioPan = Math.max(
        -1,
        Math.min(
          1,
          typeof clipData.audioPan === 'number'
            ? clipData.audioPan
            : typeof clipData.audio_pan === 'number'
              ? clipData.audio_pan
              : 0
        )
      );
      const audioPanEnd = Math.max(
        -1,
        Math.min(
          1,
          typeof clipData.audioPanEnd === 'number'
            ? clipData.audioPanEnd
            : typeof clipData.audio_pan_end === 'number'
              ? clipData.audio_pan_end
              : audioPan
        )
      );
      const gainKeyframes = Array.isArray(clipData.audioGainKeyframes)
        ? clipData.audioGainKeyframes
        : Array.isArray(clipData.audio_gain_keyframes)
          ? clipData.audio_gain_keyframes
          : [];
      const normalizedGainKeyframes = gainKeyframes
        .map((kf) => {
          if (!kf || typeof kf !== 'object') return null;
          const time =
            typeof kf.time === 'number'
              ? kf.time
              : typeof kf.t === 'number'
                ? kf.t
                : null;
          const value =
            typeof kf.value === 'number'
              ? kf.value
              : typeof kf.v === 'number'
                ? kf.v
                : null;
          const ease = normalizeEase(
            typeof kf.ease === 'string'
              ? kf.ease
              : typeof kf.e === 'string'
                ? kf.e
                : 'linear'
          );
          if (time === null || value === null) return null;
          return { time: Math.max(0, time), value: Math.max(0, value), ease };
        })
        .filter(Boolean)
        .sort((a, b) => a.time - b.time);
      const panKeyframes = Array.isArray(clipData.audioPanKeyframes)
        ? clipData.audioPanKeyframes
        : Array.isArray(clipData.audio_pan_keyframes)
          ? clipData.audio_pan_keyframes
          : [];
      const normalizedPanKeyframes = panKeyframes
        .map((kf) => {
          if (!kf || typeof kf !== 'object') return null;
          const time =
            typeof kf.time === 'number'
              ? kf.time
              : typeof kf.t === 'number'
                ? kf.t
                : null;
          const value =
            typeof kf.value === 'number'
              ? kf.value
              : typeof kf.v === 'number'
                ? kf.v
                : null;
          const ease = normalizeEase(
            typeof kf.ease === 'string'
              ? kf.ease
              : typeof kf.e === 'string'
                ? kf.e
                : 'linear'
          );
          if (time === null || value === null) return null;
          return {
            time: Math.max(0, time),
            value: Math.max(-1, Math.min(1, value)),
            ease,
          };
        })
        .filter(Boolean)
        .sort((a, b) => a.time - b.time);
      const transitionValue = clipData.transition || 'none';
      const transitionIn =
        clipData.transitionIn || clipData.transition_in || transitionValue;
      const transitionOut =
        clipData.transitionOut || clipData.transition_out || transitionValue;
      const transitionEase =
        clipData.transitionEase || clipData.transition_ease || 'linear';
      state.clips.push({
        id: clipId,
        assetId: asset.id,
        type: clipData.type || asset.type,
        name: clipData.name || asset.name,
        src: asset.src,
        start: typeof clipData.start === 'number' ? clipData.start : null,
        track: Number.isFinite(clipData.track)
          ? Math.max(0, Math.floor(clipData.track))
          : 0,
        duration: clipData.duration || asset.duration || 4,
        sourceDuration: clipData.sourceDuration || asset.duration || 4,
        audioPeaks: asset.audioPeaks || null,
        audioPeaksDuration: asset.audioPeaksDuration || null,
        trimStart: clipData.trimStart || 0,
        trimEnd: clipData.trimEnd || 0,
        speed: clipData.speed || 1,
        audioGain,
        audioGainEnd,
        audioPan,
        audioPanEnd,
        audioMute:
          typeof clipData.audioMute === 'boolean'
            ? clipData.audioMute
            : typeof clipData.audio_mute === 'boolean'
              ? clipData.audio_mute
              : false,
        audioSolo:
          typeof clipData.audioSolo === 'boolean'
            ? clipData.audioSolo
            : typeof clipData.audio_solo === 'boolean'
              ? clipData.audio_solo
              : false,
        audioFadeIn:
          typeof clipData.audioFadeIn === 'number' ? clipData.audioFadeIn : 0,
        audioFadeOut:
          typeof clipData.audioFadeOut === 'number' ? clipData.audioFadeOut : 0,
        audioGainKeyframes: normalizedGainKeyframes,
        audioPanKeyframes: normalizedPanKeyframes,
        speedKeyframes: normalizeKeyframes(
          Array.isArray(clipData.speedKeyframes)
            ? clipData.speedKeyframes
            : Array.isArray(clipData.speed_keyframes)
              ? clipData.speed_keyframes
              : [],
          'ease-in-out'
        ),
        transition: transitionValue,
        transitionIn,
        transitionOut,
        transitionDuration:
          clipData.transitionDuration || clipData.transition_duration || 0.6,
        transitionEase,
        focusX:
          typeof clipData.focusX === 'number'
            ? Math.max(0, Math.min(100, clipData.focusX))
            : typeof clipData.focus_x === 'number'
              ? Math.max(0, Math.min(100, clipData.focus_x))
              : 50,
        focusY:
          typeof clipData.focusY === 'number'
            ? Math.max(0, Math.min(100, clipData.focusY))
            : typeof clipData.focus_y === 'number'
              ? Math.max(0, Math.min(100, clipData.focus_y))
              : 50,
        resizeMode: clipData.resizeMode || clipData.resize_mode || '',
        element: asset.element,
      });
    });

    if (project.audio && project.audio.src) {
      const audio = new Audio();
      audio.preload = 'auto';
      setEditorMediaSource(audio, project.audio.src);
      state.audioElement = audio;
      state.audioFile = null;
      state.audioLabel =
        typeof project.audio.name === 'string' ? project.audio.name.trim() : '';
      if (!state.audioLabel) {
        try {
          const parsed = new URL(project.audio.src, window.location.href);
          const last = parsed.pathname.split('/').filter(Boolean).pop();
          if (last) state.audioLabel = decodeURIComponent(last);
        } catch (_) {}
      }
      if (typeof project.audio.gain === 'number') {
        state.audioSettings.gain = Math.max(0, project.audio.gain);
      }
      if (typeof project.audio.fadeIn === 'number') {
        state.audioSettings.fadeIn = Math.max(0, project.audio.fadeIn);
      }
      if (typeof project.audio.fadeOut === 'number') {
        state.audioSettings.fadeOut = Math.max(0, project.audio.fadeOut);
      }
      if (el.audioGain) el.audioGain.value = String(state.audioSettings.gain);
      if (el.audioFadeIn)
        el.audioFadeIn.value = String(state.audioSettings.fadeIn);
      if (el.audioFadeOut)
        el.audioFadeOut.value = String(state.audioSettings.fadeOut);
      prepareAudioGraph();
      drawWaveformFromUrl(project.audio.src);
    } else {
      state.audioElement = null;
      state.audioFile = null;
      state.audioLabel = '';
      state.audioSettings = { gain: 1, fadeIn: 0, fadeOut: 0 };
      if (el.audioGain) el.audioGain.value = '1';
      if (el.audioFadeIn) el.audioFadeIn.value = '0';
      if (el.audioFadeOut) el.audioFadeOut.value = '0';
      clearWaveform();
    }

    recalcTimeline();
    renderAssetList();
    renderTimeline();
    renderInspector();
    renderFrameAt(0);
    updateTimeLabel();
    const appliedFingerprint = projectFingerprint(serializeProject());
    if (opts.preserveSaveSnapshots) {
      state.lastSavedSnapshot = previousLastSavedSnapshot;
      state.lastFileSavedSnapshot = previousLastFileSavedSnapshot;
    } else {
      state.lastSavedSnapshot = appliedFingerprint;
      if (!state.currentProjectPath && !state.currentProjectId) {
        state.lastFileSavedSnapshot = '';
      }
    }
    if (!opts.skipProjectHistoryReset) {
      resetProjectHistory(serializeProject());
    }
    renderHistory();
    updateProjectDirtyState();

    if (opts.silent) {
      return;
    }
    if (missingAssets > 0 || skippedClips > 0) {
      notify('Some local assets were skipped during load', 'error');
    } else {
      notify('Project loaded', 'success');
    }
  }

  function loadProject() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      notify('No saved project', 'error');
      return null;
    }
    try {
      const project = JSON.parse(raw);
      return applyProjectData(project);
    } catch (err) {
      notify('Invalid saved project', 'error');
      return null;
    }
  }

  function setProjectLocation(mode, value) {
    window.history.replaceState(null, '', projectLocationUrl(mode, value));
  }

  function defaultAccountProjectName() {
    return state.currentProjectName || 'Untitled Project';
  }

  function promptProjectName(defaultName) {
    const value = window.prompt(
      'Project name',
      defaultName || defaultAccountProjectName()
    );
    if (value === null) return null;
    const trimmed = String(value || '').trim();
    return trimmed || defaultAccountProjectName();
  }

  function handleSyncAuthError(error) {
    if (error && error.status === 401) {
      if (
        window.NetwrckTools &&
        typeof window.NetwrckTools.requireLogin === 'function'
      ) {
        window.NetwrckTools.requireLogin();
      }
      return true;
    }
    return false;
  }

  async function copyTextValue(value) {
    if (!value) return false;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch (_) {}
    }
    return false;
  }

  function renderProjectLibrary() {
    if (!el.projectLibraryList) return;
    const items = Array.isArray(state.accountProjects)
      ? state.accountProjects
      : [];
    el.projectLibraryList.innerHTML = '';
    if (!items.length) {
      el.projectLibraryList.innerHTML =
        '<div class="project-library-empty">No synced projects yet.</div>';
      return;
    }
    items.forEach((item) => {
      const row = document.createElement('div');
      row.className = 'project-library-item';
      const meta = document.createElement('div');
      meta.className = 'project-library-meta';
      const title = document.createElement('div');
      title.className = 'project-library-title';
      title.textContent = item.name || 'Project';
      const subtitle = document.createElement('div');
      subtitle.className = 'project-library-subtitle';
      subtitle.textContent = item.updated_at
        ? `Updated ${item.updated_at}`
        : item.id;
      meta.appendChild(title);
      meta.appendChild(subtitle);
      const actions = document.createElement('div');
      actions.className = 'project-library-actions';
      const openBtn = document.createElement('button');
      openBtn.type = 'button';
      openBtn.textContent = 'Open';
      openBtn.addEventListener('click', () => {
        openAccountProject(item.id);
      });
      actions.appendChild(openBtn);
      const shareBtn = document.createElement('button');
      shareBtn.type = 'button';
      shareBtn.className = 'secondary';
      shareBtn.textContent = 'Share';
      shareBtn.addEventListener('click', async () => {
        try {
          const data = await apiJson('/api/video-editor/projects/share', {
            method: 'POST',
            body: JSON.stringify({ id: item.id }),
          });
          const shareUrl = `${window.location.origin}${window.location.pathname}?share=${encodeURIComponent(data.share_token || '')}`;
          await copyTextValue(shareUrl);
          notify('Share link copied', 'success');
          await refreshAccountProjects();
        } catch (error) {
          if (handleSyncAuthError(error)) return;
          notify('Share failed', 'error');
        }
      });
      actions.appendChild(shareBtn);
      row.appendChild(meta);
      row.appendChild(actions);
      el.projectLibraryList.appendChild(row);
    });
  }

  function toggleProjectLibrary(open) {
    if (!el.projectLibraryModal) return;
    const shouldOpen =
      open === undefined
        ? !el.projectLibraryModal.classList.contains('open')
        : open;
    el.projectLibraryModal.classList.toggle('open', shouldOpen);
    el.projectLibraryModal.setAttribute(
      'aria-hidden',
      shouldOpen ? 'false' : 'true'
    );
    updateEditorModalOpenState();
  }

  async function refreshAccountProjects() {
    try {
      const data = await apiJson('/api/video-editor/projects');
      state.accountProjects = Array.isArray(data.projects) ? data.projects : [];
      renderProjectLibrary();
      return state.accountProjects;
    } catch (error) {
      state.accountProjects = [];
      renderProjectLibrary();
      throw error;
    }
  }

  async function openProjectLibrary() {
    toggleProjectLibrary(true);
    if (el.projectLibraryList) {
      el.projectLibraryList.innerHTML =
        '<div class="project-library-empty">Loading...</div>';
    }
    try {
      await refreshAccountProjects();
    } catch (error) {
      if (handleSyncAuthError(error)) return;
      if (el.projectLibraryList) {
        el.projectLibraryList.innerHTML =
          '<div class="project-library-empty">Failed to load projects.</div>';
      }
    }
  }

  async function openAccountProject(projectId) {
    try {
      const data = await apiJson(
        '/api/video-editor/projects/load?id=' + encodeURIComponent(projectId)
      );
      await applyProjectData(data.project || {}, {
        projectId: data.id || projectId,
        projectName: data.name || '',
        shareToken: data.share_token || '',
        parentProjectId: data.parent_project_id || '',
        readOnly: false,
        keepCurrentProjectPath: true,
      });
      markProjectFileSaved(data.project || {});
      setProjectLocation('project', data.id || projectId);
      toggleProjectLibrary(false);
    } catch (error) {
      if (handleSyncAuthError(error)) return;
      notify('Failed to open project', 'error');
    }
  }

  async function saveProjectToAccount(options) {
    const opts = options || {};
    const project = serializeProject();
    const projectName =
      opts.name ||
      state.currentProjectName ||
      promptProjectName(defaultAccountProjectName());
    if (!projectName) return null;
    const payload = {
      id: opts.forceCopy ? '' : opts.id || state.currentProjectId || '',
      name: projectName,
      parent_project_id:
        opts.parentProjectId || state.currentProjectParentId || '',
      project,
    };
    const data = await apiJson('/api/video-editor/projects/save', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    persistProject(false);
    applyProjectIdentity({
      projectId: data.id || '',
      projectName: data.name || projectName,
      shareToken: data.share_token || '',
      parentProjectId: data.parent_project_id || '',
      readOnly: false,
    });
    markProjectFileSaved(project);
    setProjectLocation('project', data.id || '');
    if (!opts.quiet) {
      notify(
        opts.forceCopy ? 'Project copy saved' : 'Project synced',
        'success'
      );
    }
    refreshAccountProjects().catch(function () {});
    return data;
  }

  async function saveProjectCopy() {
    try {
      const baseName = state.currentProjectName || 'Shared Project';
      const name = promptProjectName(`${baseName} Copy`);
      if (!name) return null;
      return await saveProjectToAccount({
        forceCopy: true,
        name,
        parentProjectId:
          state.currentProjectId || state.currentProjectParentId || '',
      });
    } catch (error) {
      if (handleSyncAuthError(error)) return null;
      notify('Save copy failed', 'error');
      return null;
    }
  }

  async function shareCurrentProject() {
    try {
      if (state.projectReadOnly && state.currentShareToken) {
        const shareUrl = `${window.location.origin}${window.location.pathname}?share=${encodeURIComponent(state.currentShareToken)}`;
        const copied = await copyTextValue(shareUrl);
        notify(copied ? 'Share link copied' : shareUrl, 'success');
        return;
      }
      let projectId = state.currentProjectId;
      if (!projectId || hasUnsavedFileChanges()) {
        const saved = await saveProjectToAccount({ quiet: true });
        projectId = saved && saved.id ? saved.id : state.currentProjectId;
      }
      if (!projectId) return;
      const data = await apiJson('/api/video-editor/projects/share', {
        method: 'POST',
        body: JSON.stringify({ id: projectId }),
      });
      applyProjectIdentity({ shareToken: data.share_token || '' });
      const shareUrl = `${window.location.origin}${window.location.pathname}?share=${encodeURIComponent(data.share_token || '')}`;
      const copied = await copyTextValue(shareUrl);
      notify(copied ? 'Share link copied' : shareUrl, 'success');
      refreshAccountProjects().catch(function () {});
    } catch (error) {
      if (handleSyncAuthError(error)) return;
      notify('Share failed', 'error');
    }
  }

  async function loadProjectFromLocation() {
    const params = new URLSearchParams(window.location.search || '');
    const shareToken = params.get('share');
    const projectId = params.get('project');
    if (shareToken) {
      const data = await apiJson(
        '/api/video-editor/projects/shared/' + encodeURIComponent(shareToken)
      );
      await applyProjectData(data.project || {}, {
        projectId: data.id || '',
        projectName: data.name || '',
        shareToken: data.share_token || shareToken,
        parentProjectId: data.parent_project_id || '',
        readOnly: true,
        keepCurrentProjectPath: true,
      });
      return true;
    }
    if (projectId) {
      try {
        const data = await apiJson(
          '/api/video-editor/projects/load?id=' + encodeURIComponent(projectId)
        );
        await applyProjectData(data.project || {}, {
          projectId: data.id || projectId,
          projectName: data.name || '',
          shareToken: data.share_token || '',
          parentProjectId: data.parent_project_id || '',
          readOnly: false,
          keepCurrentProjectPath: true,
        });
        markProjectFileSaved(data.project || {});
        return true;
      } catch (error) {
        if (!handleSyncAuthError(error)) {
          notify('Failed to open project', 'error');
        }
      }
    }
    return false;
  }

  function saveProject() {
    captureProjectHistory('save');
    persistProject(false);
    if (state.projectReadOnly) {
      saveProjectCopy();
      return;
    }
    saveProjectToAccount().catch((error) => {
      if (handleSyncAuthError(error)) {
        notify('Saved locally', 'info');
        return;
      }
      notify('Saved locally', 'info');
    });
  }

  function persistProject(showToast) {
    try {
      captureProjectHistory('autosave');
      const project = serializeProject();
      const fingerprint = projectFingerprint(project);
      if (fingerprint === state.lastSavedSnapshot) {
        updateProjectDirtyState();
        if (showToast) notify('Project already saved', 'info');
        return;
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(project));
      updateHistory(project, fingerprint);
      state.lastSavedSnapshot = fingerprint;
      renderHistory();
      updateProjectDirtyState();
      if (showToast) notify('Project saved', 'success');
    } catch (err) {
      updateProjectDirtyState();
      if (showToast) notify('Failed to save project', 'error');
    }
  }

  function autosaveNow() {
    persistProject(false);
  }

  function scheduleAutosave(reason) {
    captureProjectHistory(reason || 'edit');
    if (state.autosaveTimer) clearTimeout(state.autosaveTimer);
    updateProjectDirtyState();
    state.autosaveTimer = setTimeout(autosaveNow, 1500);
  }

  function exportProjectFile() {
    try {
      const project = serializeProject();
      const blob = new Blob([JSON.stringify(project, null, 2)], {
        type: 'application/json',
      });
      downloadBlob(blob, `netwrck-project-${Date.now()}.json`);
    } catch (err) {
      notify('Export failed', 'error');
    }
  }

  function handleImportFile(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const project = JSON.parse(reader.result || '{}');
        applyProjectData(project);
      } catch (err) {
        notify('Invalid project file', 'error');
      }
    };
    reader.readAsText(file);
    event.target.value = '';
  }

  async function fsListDir(path, filter) {
    const params = new URLSearchParams({
      path: path || '~',
      filter: filter || 'all',
    });
    const resp = await fetch('/api/video-editor/fs/list?' + params);
    if (!resp.ok) throw new Error('Failed to list directory');
    return resp.json();
  }

  async function fsSaveProjectToPath(path) {
    const project = serializeProject();
    const resp = await fetch('/api/video-editor/fs/save-project', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, project }),
    });
    if (!resp.ok) throw new Error('Save failed');
    return resp.json();
  }

  async function fsLoadProjectFromPath(path) {
    const resp = await fetch(
      '/api/video-editor/fs/load-project?path=' + encodeURIComponent(path)
    );
    if (!resp.ok) throw new Error('Load failed');
    return resp.json();
  }

  function fsMediaUrl(path) {
    return '/api/video-editor/fs/media?path=' + encodeURIComponent(path);
  }

  function inferFsEntryType(entry) {
    const rawType = String((entry && entry.type) || '').toLowerCase();
    if (rawType === 'image' || rawType === 'video' || rawType === 'audio')
      return rawType;
    const rawMime = String(
      (entry && entry.mimeType) || (entry && entry.contentType) || ''
    ).toLowerCase();
    if (rawMime.startsWith('image/')) return 'image';
    if (rawMime.startsWith('video/')) return 'video';
    if (rawMime.startsWith('audio/')) return 'audio';
    const source = String(
      (entry && (entry.name || entry.objectPath || entry.path || entry.url)) ||
        ''
    ).toLowerCase();
    const ext = extFromName(source).toLowerCase();
    if (
      ['.png', '.jpg', '.jpeg', '.webp', '.gif', '.bmp', '.svg'].includes(ext)
    )
      return 'image';
    if (['.mp4', '.webm', '.mov', '.m4v', '.avi', '.mkv'].includes(ext))
      return 'video';
    if (['.mp3', '.wav', '.ogg', '.aac', '.m4a', '.flac'].includes(ext))
      return 'audio';
    return 'file';
  }

  function normalizeFsSidebarEntry(entry) {
    if (!entry || entry.is_dir) return null;
    const normalized = {
      ...entry,
      name: entry.name || '',
      path: entry.path || '',
      url: entry.url || '',
      bucket: entry.bucket || '',
      objectPath: entry.objectPath || '',
      size: Number.isFinite(entry.size) ? entry.size : Number(entry.size) || 0,
      modTime: Number.isFinite(entry.modTime)
        ? entry.modTime
        : Number(entry.modTime) || Date.now(),
      storage: entry.storage || (entry.url ? 'cloud' : 'local'),
      is_dir: false,
    };
    normalized.type = inferFsEntryType(normalized);
    if (!normalized.name) {
      const source =
        normalized.objectPath || normalized.path || normalized.url || '';
      normalized.name = decodeURIComponent(
        source.split('/').filter(Boolean).pop() || 'file'
      );
    }
    return normalized;
  }

  function fsSidebarEntryKey(entry) {
    const normalized = normalizeFsSidebarEntry(entry);
    if (!normalized) return '';
    if (normalized.storage === 'cloud' || normalized.url) {
      return (
        'cloud:' + (normalized.objectPath || normalized.url || normalized.name)
      );
    }
    return 'local:' + (normalized.path || normalized.name);
  }

  function loadStoredFsSidebarEntries() {
    try {
      const raw = JSON.parse(
        localStorage.getItem(FS_MEDIA_LIBRARY_KEY) || '[]'
      );
      if (!Array.isArray(raw)) return [];
      return raw
        .map(function (entry) {
          return normalizeFsSidebarEntry({ ...entry, storage: 'cloud' });
        })
        .filter(Boolean);
    } catch (_) {
      return [];
    }
  }

  function saveStoredFsSidebarEntries(entries) {
    const serialized = (entries || [])
      .map(function (entry) {
        const normalized = normalizeFsSidebarEntry(entry);
        if (!normalized || normalized.storage !== 'cloud' || !normalized.url)
          return null;
        return {
          name: normalized.name,
          url: normalized.url,
          bucket: normalized.bucket,
          objectPath: normalized.objectPath,
          size: normalized.size,
          type: normalized.type,
          modTime: normalized.modTime,
        };
      })
      .filter(Boolean);
    localStorage.setItem(FS_MEDIA_LIBRARY_KEY, JSON.stringify(serialized));
  }

  function mergeFsSidebarEntries(primary, secondary) {
    const merged = [];
    const seen = new Set();
    [primary || [], secondary || []].forEach(function (entries) {
      entries.forEach(function (entry) {
        const normalized = normalizeFsSidebarEntry(entry);
        if (!normalized) return;
        const key = fsSidebarEntryKey(normalized);
        if (!key || seen.has(key)) return;
        seen.add(key);
        merged.push(normalized);
      });
    });
    return merged;
  }

  function upsertStoredFsSidebarEntry(entry) {
    const normalized = normalizeFsSidebarEntry({ ...entry, storage: 'cloud' });
    if (!normalized) return;
    const next = mergeFsSidebarEntries(
      [normalized],
      loadStoredFsSidebarEntries()
    );
    saveStoredFsSidebarEntries(next);
  }

  function removeStoredFsSidebarEntry(entry) {
    const targetKey = fsSidebarEntryKey(entry);
    const next = loadStoredFsSidebarEntries().filter(function (item) {
      return fsSidebarEntryKey(item) !== targetKey;
    });
    saveStoredFsSidebarEntries(next);
  }

  function resolveFsEntryUrl(entry) {
    if (!entry) return '';
    if (entry.url) return entry.url;
    if (entry.path) return fsMediaUrl(entry.path);
    return '';
  }

  function rememberFsDir(path, sidebar) {
    if (!path) return;
    state.fsLastDir = path;
    localStorage.setItem('netwrck_ve_fs_last_dir', path);
    if (sidebar !== false) {
      state.fsSidebarPath = path;
      localStorage.setItem('netwrck_ve_fs_sidebar_dir', path);
    }
  }

  async function fsUploadMediaFile(file, dir) {
    const formData = new FormData();
    formData.append('file', file, file && file.name ? file.name : 'upload.bin');
    formData.append(
      'dir',
      dir || state.fsSidebarPath || state.fsLastDir || '~'
    );
    const resp = await fetch('/api/video-editor/fs/upload', {
      method: 'POST',
      body: formData,
    });
    if (!resp.ok) throw new Error('upload failed');
    return resp.json();
  }

  async function fsDeleteEntry(path) {
    const resp = await fetch(
      '/api/video-editor/fs/delete?path=' + encodeURIComponent(path),
      {
        method: 'POST',
      }
    );
    if (!resp.ok) throw new Error('delete failed');
    return resp.json();
  }

  function fsFormatSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
    if (bytes < 1073741824) return (bytes / 1048576).toFixed(1) + ' MB';
    return (bytes / 1073741824).toFixed(1) + ' GB';
  }

  function fsEntryIcon(entry) {
    if (entry.is_dir)
      return '<svg viewBox="0 0 24 24" class="fs-entry-icon"><path d="M3 7V5a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    if (entry.type === 'image')
      return '<svg viewBox="0 0 24 24" class="fs-entry-icon"><rect x="3" y="3" width="18" height="18" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/><path d="m21 15-5-5L5 21" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    if (entry.type === 'video')
      return '<svg viewBox="0 0 24 24" class="fs-entry-icon"><rect x="2" y="4" width="20" height="16" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m10 9 5 3-5 3V9z" fill="currentColor"/></svg>';
    if (entry.type === 'audio')
      return '<svg viewBox="0 0 24 24" class="fs-entry-icon"><path d="M6 16v-4M10 19V5M14 16V8M18 14v-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
    return '<svg viewBox="0 0 24 24" class="fs-entry-icon"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M14 2v6h6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  }

  function renderFsBreadcrumbs(path) {
    const container = getEl('fs-breadcrumbs');
    if (!container) return;
    container.innerHTML = '';
    const parts = path.split('/').filter(Boolean);
    let built = '/';
    parts.forEach(function (part, i) {
      if (i > 0) {
        const sep = document.createElement('span');
        sep.className = 'fs-breadcrumb-sep';
        sep.textContent = '/';
        container.appendChild(sep);
      }
      built += (i > 0 ? '/' : '') + part;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fs-breadcrumb';
      btn.textContent = part;
      const target = built;
      btn.addEventListener('click', function () {
        navigateFsBrowser(target);
      });
      container.appendChild(btn);
    });
  }

  function renderFsEntries(entries) {
    const container = getEl('fs-entries');
    if (!container) return;
    if (!entries || entries.length === 0) {
      container.innerHTML = '<div class="fs-empty">Empty directory</div>';
      return;
    }
    container.innerHTML = '';
    entries.forEach(function (entry, idx) {
      const row = document.createElement('div');
      row.className = 'fs-entry';
      row.setAttribute('data-idx', idx);
      row.title = entry.name || '';
      row.innerHTML =
        fsEntryIcon(entry) +
        '<span class="fs-entry-name">' +
        (entry.name || '') +
        '</span>' +
        (entry.is_dir
          ? ''
          : '<span class="fs-entry-meta">' +
            fsFormatSize(entry.size) +
            '</span>');
      row.addEventListener('click', function () {
        state.fsSelectedEntry = entry;
        container.querySelectorAll('.fs-entry').forEach(function (r) {
          r.classList.remove('selected');
        });
        row.classList.add('selected');
        updateFsActionBar();
      });
      row.addEventListener('dblclick', function () {
        if (entry.is_dir) {
          navigateFsBrowser(entry.path);
        } else {
          executeFsAction(entry);
        }
      });
      container.appendChild(row);
    });
  }

  function renderFsSidebarEntries(entries) {
    const container = getEl('fs-sidebar-entries');
    if (!container) return;
    if (!entries || entries.length === 0) {
      container.innerHTML = '<div class="fs-empty">No media files yet</div>';
      return;
    }
    container.innerHTML = '';
    entries.forEach(function (entry) {
      if (!entry || entry.is_dir) return;
      const row = document.createElement('div');
      row.className = 'fs-entry';
      row.title = entry.name || '';
      row.innerHTML =
        fsEntryIcon(entry) +
        '<span class="fs-entry-name">' +
        (entry.name || '') +
        '</span>' +
        '<span class="fs-entry-meta">' +
        fsFormatSize(entry.size || 0) +
        '</span>';
      const addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'secondary';
      addBtn.innerHTML =
        '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
      addBtn.setAttribute('aria-label', 'Add');
      addBtn.title = 'Add';
      addBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        executeFsAction(entry);
      });
      const deleteBtn = document.createElement('button');
      deleteBtn.type = 'button';
      deleteBtn.className = 'secondary';
      deleteBtn.innerHTML =
        '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2m3 0-.7 13a2 2 0 0 1-2 1.9H9.7a2 2 0 0 1-2-1.9L7 6M10 11v6M14 11v6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      deleteBtn.setAttribute('aria-label', 'Delete');
      deleteBtn.title = 'Delete';
      deleteBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (entry.storage === 'cloud' || entry.url) {
          removeStoredFsSidebarEntry(entry);
          notify('Deleted: ' + entry.name, 'success');
          refreshFsSidebarEntries();
          return;
        }
        fsDeleteEntry(entry.path)
          .then(function () {
            notify('Deleted: ' + entry.name, 'success');
            refreshFsSidebarEntries();
            if (state.fsCurrentPath === state.fsSidebarPath) {
              navigateFsBrowser(
                state.fsCurrentPath || state.fsSidebarPath || '~'
              );
            }
          })
          .catch(function () {
            notify('Delete failed', 'error');
          });
      });
      row.appendChild(addBtn);
      row.appendChild(deleteBtn);
      container.appendChild(row);
    });
    if (!container.children.length) {
      container.innerHTML = '<div class="fs-empty">No media files yet</div>';
    }
  }

  function refreshFsSidebarEntries() {
    const storedEntries = loadStoredFsSidebarEntries();
    state.fsSidebarEntries = storedEntries;
    renderFsSidebarEntries(storedEntries);
    const target = state.fsSidebarPath || state.fsLastDir || '~';
    fsListDir(target, 'media')
      .then(function (data) {
        state.fsSidebarPath = data.path;
        state.fsSidebarEntries = mergeFsSidebarEntries(
          storedEntries,
          data.entries || []
        );
        rememberFsDir(data.path, true);
        renderFsSidebarEntries(state.fsSidebarEntries);
      })
      .catch(function () {
        state.fsSidebarEntries = storedEntries;
        renderFsSidebarEntries(storedEntries);
      });
  }

  function updateFsActionBar() {
    const bar = getEl('fs-action-bar');
    if (!bar) return;
    bar.innerHTML = '';
    var entry = state.fsSelectedEntry;
    if (state.fsBrowseMode === 'project-save') {
      var input = document.createElement('input');
      input.id = 'fs-save-filename';
      input.type = 'text';
      input.placeholder = 'project-name.json';
      input.value = state.currentProjectPath
        ? state.currentProjectPath.split('/').pop()
        : 'project.json';
      bar.appendChild(input);
      var saveBtn = document.createElement('button');
      saveBtn.type = 'button';
      saveBtn.className = 'primary';
      saveBtn.textContent = 'Save';
      saveBtn.addEventListener('click', function () {
        var filename = input.value.trim();
        if (!filename) return;
        var savePath = state.fsCurrentPath + '/' + filename;
        fsSaveProjectToPath(savePath)
          .then(function (res) {
            state.currentProjectPath = res.path || savePath;
            markProjectFileSaved();
            updateFsProjectLabel();
            notify('Saved: ' + state.currentProjectPath, 'success');
            toggleFsBrowser(false);
            persistProject(false);
          })
          .catch(function () {
            notify('Save failed', 'error');
          });
      });
      bar.appendChild(saveBtn);
      return;
    }
    if (state.fsBrowseMode === 'project-open' && entry && !entry.is_dir) {
      var openBtn = document.createElement('button');
      openBtn.type = 'button';
      openBtn.className = 'primary';
      openBtn.textContent = 'Open';
      openBtn.addEventListener('click', function () {
        executeFsAction(entry);
      });
      bar.appendChild(openBtn);
      return;
    }
    if (state.fsBrowseMode === 'media' && entry && !entry.is_dir) {
      var addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'primary';
      addBtn.textContent = 'Add to Assets';
      addBtn.addEventListener('click', function () {
        executeFsAction(entry);
      });
      bar.appendChild(addBtn);
    }
  }

  function executeFsAction(entry) {
    if (!entry || entry.is_dir) return;
    if (state.fsBrowseMode === 'project-open') {
      fsLoadProjectFromPath(entry.path)
        .then(function (project) {
          state.currentProjectPath = entry.path;
          convertFsMediaPaths(project);
          applyProjectData(project);
          markProjectFileSaved(project);
          updateFsProjectLabel();
          notify('Opened: ' + entry.name, 'success');
          toggleFsBrowser(false);
        })
        .catch(function () {
          notify('Failed to load project', 'error');
        });
      return;
    }
    if (state.fsBrowseMode === 'media') {
      var type =
        entry.type === 'image'
          ? 'image'
          : entry.type === 'video'
            ? 'video'
            : entry.type === 'audio'
              ? 'audio'
              : 'image';
      addExternalAsset(resolveFsEntryUrl(entry), type, entry.name, {
        fsPath: entry.path || entry.objectPath || entry.url || '',
        addToTimeline: true,
        timelineTime: Math.max(0, state.playhead || 0),
      });
      notify('Added: ' + entry.name, 'success');
      toggleFsBrowser(false);
    }
  }

  function convertFsMediaPaths(project) {
    if (Array.isArray(project.assets)) {
      project.assets.forEach(function (asset) {
        if (
          asset.src &&
          asset.src.startsWith('/') &&
          !asset.src.startsWith('/api/')
        ) {
          asset.src = fsMediaUrl(asset.src);
          asset.fsPath = asset.src;
        }
      });
    }
  }

  function navigateFsBrowser(path) {
    var filter =
      state.fsBrowseMode === 'project-open'
        ? 'project'
        : state.fsBrowseMode === 'media'
          ? 'media'
          : 'all';
    fsListDir(path, filter)
      .then(function (data) {
        state.fsCurrentPath = data.path;
        state.fsParentPath = data.parent;
        state.fsEntries = data.entries;
        state.fsSelectedEntry = null;
        rememberFsDir(data.path, filter === 'media');
        var pathInput = getEl('fs-path-input');
        if (pathInput) pathInput.value = data.path;
        renderFsBreadcrumbs(data.path);
        renderFsEntries(data.entries);
        updateFsActionBar();
      })
      .catch(function () {
        notify('Cannot access directory', 'error');
      });
  }

  function toggleFsBrowser(open) {
    var modal = getEl('fs-browser-modal');
    if (!modal) return;
    var shouldOpen =
      open === undefined ? !modal.classList.contains('open') : open;
    modal.classList.toggle('open', shouldOpen);
    modal.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    updateEditorModalOpenState();
    if (shouldOpen) {
      navigateFsBrowser(state.fsLastDir || '~');
    }
  }

  function openFsBrowser(mode) {
    state.fsBrowseMode = mode;
    state.fsSelectedEntry = null;
    toggleFsBrowser(true);
  }

  function updateFsProjectLabel() {
    var label = getEl('fs-current-project');
    if (!label) return;
    label.textContent = state.currentProjectPath || 'No project file';
    label.title = state.currentProjectPath || '';
  }

  async function openNativeFilePicker(mode) {
    if (mode === 'project-open') {
      if (window.showOpenFilePicker) {
        try {
          var handles = await window.showOpenFilePicker({
            types: [
              {
                description: 'Project files',
                accept: { 'application/json': ['.json'] },
              },
            ],
            multiple: false,
          });
          var file = await handles[0].getFile();
          var text = await file.text();
          var project = JSON.parse(text);
          await applyProjectData(project);
          state.currentProjectPath = file.name;
          markProjectFileSaved(project);
          updateFsProjectLabel();
          notify('Opened: ' + file.name, 'success');
          return;
        } catch (e) {
          if (e.name === 'AbortError') return;
        }
      }
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = '.json';
      input.addEventListener('change', async function () {
        var f = input.files && input.files[0];
        if (!f) return;
        try {
          var t = await f.text();
          var p = JSON.parse(t);
          await applyProjectData(p);
          state.currentProjectPath = f.name;
          markProjectFileSaved(p);
          updateFsProjectLabel();
          notify('Opened: ' + f.name, 'success');
        } catch (_) {
          notify('Failed to load project', 'error');
        }
      });
      input.click();
      return;
    }
    if (mode === 'media') {
      if (window.showOpenFilePicker) {
        try {
          var mediaHandles = await window.showOpenFilePicker({
            multiple: true,
          });
          for (var i = 0; i < mediaHandles.length; i++) {
            var mediaFile = await mediaHandles[i].getFile();
            await addAssetFromFile(mediaFile, {
              persistToMedia: true,
              addToTimeline: true,
              timelineTime: Math.max(0, (state.playhead || 0) + i * 0.1),
            });
          }
          return;
        } catch (e) {
          if (e.name === 'AbortError') return;
        }
      }
      var mediaInput = document.createElement('input');
      mediaInput.type = 'file';
      mediaInput.multiple = true;
      mediaInput.addEventListener('change', function () {
        Array.from(mediaInput.files || []).forEach(function (mf, mi) {
          addAssetFromFile(mf, {
            persistToMedia: true,
            addToTimeline: true,
            timelineTime: Math.max(0, (state.playhead || 0) + mi * 0.1),
          }).catch(function () {
            notify('Failed to add ' + (mf.name || 'file'), 'error');
          });
        });
      });
      mediaInput.click();
    }
  }

  function initFsBrowser() {
    var closeBtn = getEl('fs-browser-close');
    if (closeBtn)
      closeBtn.addEventListener('click', function () {
        toggleFsBrowser(false);
      });
    var modal = getEl('fs-browser-modal');
    if (modal)
      modal.addEventListener('click', function (e) {
        if (e.target === modal) toggleFsBrowser(false);
      });
    var goBtn = getEl('fs-path-go');
    if (goBtn)
      goBtn.addEventListener('click', function () {
        var input = getEl('fs-path-input');
        if (input && input.value.trim()) navigateFsBrowser(input.value.trim());
      });
    var upBtn = getEl('fs-path-up');
    if (upBtn)
      upBtn.addEventListener('click', function () {
        if (state.fsParentPath && state.fsParentPath !== state.fsCurrentPath)
          navigateFsBrowser(state.fsParentPath);
      });
    var pathInput = getEl('fs-path-input');
    if (pathInput)
      pathInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (pathInput.value.trim()) navigateFsBrowser(pathInput.value.trim());
        }
      });
    var openFs = getEl('project-open-fs');
    if (openFs)
      openFs.addEventListener('click', function () {
        openNativeFilePicker('project-open');
      });
    var saveFs = getEl('project-save-fs');
    if (saveFs)
      saveFs.addEventListener('click', function () {
        if (state.currentProjectPath) {
          fsSaveProjectToPath(state.currentProjectPath)
            .then(function () {
              notify('Saved: ' + state.currentProjectPath, 'success');
              markProjectFileSaved();
              persistProject(false);
            })
            .catch(function () {
              notify('Save failed', 'error');
            });
        } else {
          openFsBrowser('project-save');
        }
      });
    var browseMedia = getEl('fs-browse-media');
    if (browseMedia)
      browseMedia.addEventListener('click', function () {
        openNativeFilePicker('media');
      });
    var openProject = getEl('fs-open-project');
    if (openProject)
      openProject.addEventListener('click', function () {
        openNativeFilePicker('project-open');
      });
    var saveProject = getEl('fs-save-project');
    if (saveProject)
      saveProject.addEventListener('click', function () {
        if (state.currentProjectPath) {
          fsSaveProjectToPath(state.currentProjectPath)
            .then(function () {
              notify('Saved: ' + state.currentProjectPath, 'success');
              markProjectFileSaved();
              persistProject(false);
            })
            .catch(function () {
              notify('Save failed', 'error');
            });
        } else {
          openFsBrowser('project-save');
        }
      });
    var saveAsProject = getEl('fs-save-project-as');
    if (saveAsProject)
      saveAsProject.addEventListener('click', function () {
        openFsBrowser('project-save');
      });
    updateFsProjectLabel();
    refreshFsSidebarEntries();
    updateProjectDirtyState();
    var fsEntriesEl = getEl('fs-entries');
    if (fsEntriesEl) fsEntriesEl.setAttribute('tabindex', '0');
    document.addEventListener('keydown', function (e) {
      console.log('FSKEY', e.key, e.target && e.target.tagName);
      window.__FSKB__ = (window.__FSKB__ || 0) + 1;
      var modal = getEl('fs-browser-modal');
      if (!modal || !modal.classList.contains('open')) return;
      var t = e.target;
      if (
        t &&
        (t.tagName === 'INPUT' ||
          t.tagName === 'TEXTAREA' ||
          t.tagName === 'SELECT' ||
          t.isContentEditable)
      )
        return;
      if ((e.ctrlKey || e.metaKey) && e.key === 'ArrowUp') {
        e.preventDefault();
        if (state.fsParentPath && state.fsParentPath !== state.fsCurrentPath)
          navigateFsBrowser(state.fsParentPath);
        return;
      }
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      var container = getEl('fs-entries');
      if (!container) return;
      var rows = Array.from(container.querySelectorAll('.fs-entry'));
      if (!rows.length) return;
      var current = container.querySelector('.fs-entry.selected');
      var idx = current ? rows.indexOf(current) : -1;
      if (e.key === 'Enter') {
        if (state.fsSelectedEntry) {
          if (state.fsSelectedEntry.is_dir)
            navigateFsBrowser(state.fsSelectedEntry.path);
          else executeFsAction(state.fsSelectedEntry);
        }
        return;
      }
      if (e.key === 'ArrowDown') idx = Math.min(idx + 1, rows.length - 1);
      else if (e.key === 'ArrowUp') idx = Math.max(idx < 0 ? 0 : idx - 1, 0);
      else if (e.key === 'Home') idx = 0;
      else if (e.key === 'End') idx = rows.length - 1;
      else return;
      e.preventDefault();
      rows[idx].click();
      rows[idx].scrollIntoView({ block: 'nearest' });
    });
  }

  function handleAssetAction(event) {
    const target = event.target;
    if (!target) return;
    const assetId =
      target.getAttribute('data-asset-id') ||
      target.closest('.asset-item')?.getAttribute('data-asset-id');
    if (!assetId) return;
    const action = target.getAttribute('data-action');
    if (action === 'asset-menu') {
      const asset = state.assets.find((item) => item.id === assetId);
      if (!asset || asset.status === 'generating') return;
      const btn = target.closest('[data-action="asset-menu"]') || target;
      const rect = btn.getBoundingClientRect();
      showAssetContextMenu(rect.left, rect.bottom + 4, asset);
      return;
    }
    if (action === 'add-clip') {
      addClipFromAsset(assetId);
      return;
    }
    if (action === 'add-stage') {
      state.selectedAssetId = assetId;
      addStageElementFromAsset();
      return;
    }
    if (action === 'save-asset') {
      const asset = state.assets.find((item) => item.id === assetId);
      if (!asset || !canPersistAiAsset(asset)) return;
      toggleSavedAiAsset({
        src: asset.src,
        type: asset.type,
        name: asset.name,
      });
      return;
    }
    if (action === 'use-audio') {
      const asset = state.assets.find((item) => item.id === assetId);
      if (!asset) return;
      if (asset.file) {
        loadAudioFile(asset.file);
        return;
      }
      if (!asset.src) return;
      if (asset.src.startsWith('blob:')) {
        fetch(asset.src)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], asset.name || 'Audio', {
              type: blob.type || 'audio/mpeg',
            });
            loadAudioFile(file);
          })
          .catch(() => {});
        return;
      }
      loadAudioUrl(asset.src, asset.name);
      return;
    }
    state.selectedAssetId = assetId;
    renderAssetList();
    if (el.aiGenerateModal?.classList.contains('open')) {
      syncAiReferencePreviewFromSelectedOrInputs();
    }
  }

  function buildClipFromAsset(asset) {
    const clipId =
      'clip_' + Date.now() + '_' + Math.random().toString(16).slice(2);
    return {
      id: clipId,
      assetId: asset.id,
      type: asset.type,
      name: asset.name,
      src: asset.src,
      start: null,
      track: 0,
      duration:
        asset.type === 'video' || asset.type === 'audio'
          ? asset.duration || 4
          : 4,
      sourceDuration:
        asset.type === 'video' || asset.type === 'audio'
          ? asset.duration || 4
          : 4,
      audioPeaks: asset.audioPeaks || null,
      audioPeaksDuration: asset.audioPeaksDuration || null,
      trimStart: 0,
      trimEnd: 0,
      speed: 1,
      audioGain: 1,
      audioGainEnd: 1,
      audioPan: 0,
      audioPanEnd: 0,
      audioMute: false,
      audioSolo: false,
      audioFadeIn: 0,
      audioFadeOut: 0,
      audioGainKeyframes: [],
      audioPanKeyframes: [],
      speedKeyframes: [],
      transition: 'none',
      transitionIn: 'none',
      transitionOut: 'none',
      transitionDuration: 0.6,
      transitionEase: 'linear',
      focusX: 50,
      focusY: 50,
      resizeMode: '',
      element: asset.element,
    };
  }

  function buildCaptionClip(data) {
    const text = String(data?.text || '').trim();
    const clipId =
      'clip_' + Date.now() + '_' + Math.random().toString(16).slice(2);
    return {
      id: clipId,
      assetId: null,
      type: 'caption',
      name: text.length > 36 ? `${text.slice(0, 36)}…` : text || 'Caption',
      src: '',
      text,
      start: Number.isFinite(data?.start) ? Math.max(0, data.start) : 0,
      track: Number.isFinite(data?.track)
        ? Math.max(0, Math.floor(data.track))
        : getCaptionTrack(),
      duration: Number.isFinite(data?.duration)
        ? Math.max(0.1, data.duration)
        : 2,
      sourceDuration: Number.isFinite(data?.duration)
        ? Math.max(0.1, data.duration)
        : 2,
      trimStart: 0,
      trimEnd: 0,
      speed: 1,
      audioGain: 0,
      audioGainEnd: 0,
      audioPan: 0,
      audioPanEnd: 0,
      audioMute: true,
      audioSolo: false,
      audioFadeIn: 0,
      audioFadeOut: 0,
      audioGainKeyframes: [],
      audioPanKeyframes: [],
      speedKeyframes: [],
      transition: 'none',
      transitionIn: 'none',
      transitionOut: 'none',
      transitionDuration: 0,
      transitionEase: 'linear',
      element: null,
      captionFontSize: Number.isFinite(data?.captionFontSize)
        ? Math.max(12, data.captionFontSize)
        : DEFAULT_CAPTION_STYLE.fontSize,
      captionColor: data?.captionColor || DEFAULT_CAPTION_STYLE.color,
      captionAlign: data?.captionAlign || DEFAULT_CAPTION_STYLE.align,
      captionY: Number.isFinite(data?.captionY)
        ? Math.max(5, Math.min(95, data.captionY))
        : DEFAULT_CAPTION_STYLE.y,
    };
  }

  function isCaptionClip(clip) {
    return !!clip && clip.type === 'caption';
  }

  function getCaptionClips() {
    return state.clips.filter((clip) => isCaptionClip(clip));
  }

  function getCaptionTrack() {
    const captionTracks = getCaptionClips().map((clip) => getClipTrack(clip));
    if (captionTracks.length) return Math.min(...captionTracks);
    const visualTracks = state.clips
      .filter(
        (clip) => clip && clip.type !== 'audio' && clip.type !== 'caption'
      )
      .map((clip) => getClipTrack(clip));
    return visualTracks.length ? Math.max(...visualTracks) + 1 : 1;
  }

  function ensureCaptionTrackLabel(track) {
    const laneKey = `video-${Math.max(0, Math.floor(track || 0))}`;
    if (!state.trackHeaders[laneKey]) {
      state.trackHeaders[laneKey] = {
        name: 'Captions',
        muted: false,
        soloed: false,
        locked: false,
      };
      return;
    }
    const current = String(state.trackHeaders[laneKey].name || '').trim();
    if (!current || /^Video\b/.test(current)) {
      state.trackHeaders[laneKey].name = 'Captions';
    }
  }

  function clearCaptionClips(skipHistory) {
    const captionIds = new Set(getCaptionClips().map((clip) => clip.id));
    if (!captionIds.size) return false;
    if (!skipHistory) {
      pushTimelineHistory('caption-clear');
    }
    state.clips = state.clips.filter((clip) => !captionIds.has(clip.id));
    const nextSelection = state.selectedClipIds.filter(
      (id) => !captionIds.has(id)
    );
    setTimelineSelection(nextSelection, nextSelection[0] || null);
    recalcTimeline();
    renderTimeline();
    renderInspector();
    renderFrameAt(state.playhead);
    updateTimeLabel();
    renderCaptionPanel();
    scheduleAutosave();
    return true;
  }

  function getSelectedCaptionSource() {
    const selected = getSelectedClip();
    if (selected && (selected.type === 'video' || selected.type === 'audio')) {
      const asset = selected.assetId
        ? state.assets.find((item) => item.id === selected.assetId)
        : null;
      return {
        kind: 'clip',
        clip: selected,
        asset,
        name: selected.name || asset?.name || 'Selected clip',
        src: selected.src || asset?.src || '',
        file: asset?.file || null,
      };
    }
    if (state.audioElement && state.audioElement.src) {
      return {
        kind: 'project-audio',
        clip: null,
        asset: null,
        name: state.audioLabel || state.audioFile?.name || 'Project audio',
        src: state.audioElement.src,
        file: state.audioFile || null,
      };
    }
    const firstMediaClip = state.clips.find(
      (clip) => clip && (clip.type === 'video' || clip.type === 'audio')
    );
    if (firstMediaClip) {
      const asset = firstMediaClip.assetId
        ? state.assets.find((item) => item.id === firstMediaClip.assetId)
        : null;
      return {
        kind: 'clip',
        clip: firstMediaClip,
        asset,
        name: firstMediaClip.name || asset?.name || 'Timeline clip',
        src: firstMediaClip.src || asset?.src || '',
        file: asset?.file || null,
      };
    }
    return null;
  }

  function describeCaptionSource(source) {
    if (!source) {
      return 'Select a video or audio clip, or load project audio.';
    }
    const prefix =
      source.kind === 'project-audio' ? 'Project audio' : 'Selected clip';
    let suffix = '';
    if (source.asset && source.asset.type === 'video') {
      if (source.asset.captionAudioStatus === 'ready')
        suffix = ' · audio separated';
      else if (source.asset.captionAudioStatus === 'pending')
        suffix = ' · separating audio…';
    }
    return `${prefix}: ${source.name || 'Untitled'}${suffix}`;
  }

  function inferCaptionFileName(source, blob) {
    const current = source?.file?.name || source?.name || 'captions-source';
    const match = String(current).match(/\.([a-z0-9]+)$/i);
    if (match) return current;
    const type = String(blob?.type || '').toLowerCase();
    let ext = '.webm';
    if (type.includes('mp4')) ext = '.mp4';
    else if (type.includes('mpeg') || type.includes('mp3')) ext = '.mp3';
    else if (type.includes('wav')) ext = '.wav';
    else if (type.includes('ogg')) ext = '.ogg';
    return `${current}${ext}`;
  }

  async function resolveCaptionSourceFile(source) {
    if (!source) throw new Error('Select a source clip first');
    if (source.asset && source.asset.type === 'video') {
      if (source.asset.captionAudioFile instanceof File) {
        return source.asset.captionAudioFile;
      }
      if (source.asset.captionAudioPromise) {
        const extracted = await source.asset.captionAudioPromise;
        if (extracted instanceof File) return extracted;
      }
      if (source.asset.file instanceof File || source.asset.src) {
        queueVideoCaptionAudioExtraction(
          source.asset,
          source.asset.file || null
        );
        if (source.asset.captionAudioPromise) {
          const extracted = await source.asset.captionAudioPromise;
          if (extracted instanceof File) return extracted;
        }
      }
    }
    if (source.file instanceof File) return source.file;
    if (!source.src) throw new Error('Source media not available');
    const resp = await fetch(editorMediaSrc(source.src));
    if (!resp.ok) {
      throw new Error(`Failed to load media (${resp.status})`);
    }
    const blob = await resp.blob();
    const fileName = inferCaptionFileName(source, blob);
    return new File([blob], fileName, { type: blob.type || 'video/webm' });
  }

  function mapCaptionSegmentsToTimeline(segments, source) {
    const sourceClip = source?.kind === 'clip' ? source.clip : null;
    if (!sourceClip) {
      return segments
        .map((segment) =>
          buildCaptionClip({
            text: segment.text,
            start: segment.start,
            duration: segment.end - segment.start,
            track: getCaptionTrack(),
          })
        )
        .filter((clip) => clip.text);
    }
    if ((sourceClip.speed || 1) < 0) {
      throw new Error('Reverse clips are not supported for auto captions yet');
    }
    const usableStart = Math.max(
      0,
      Number.isFinite(sourceClip.trimStart) ? sourceClip.trimStart : 0
    );
    const usableEnd = Math.max(
      usableStart,
      (sourceClip.sourceDuration || sourceClip.duration || 0) -
        (sourceClip.trimEnd || 0)
    );
    const speed = Math.abs(sourceClip.speed || 1) || 1;
    const timelineStart = Number.isFinite(sourceClip.start)
      ? sourceClip.start
      : 0;
    return segments
      .map((segment) => {
        const start = Math.max(usableStart, segment.start);
        const end = Math.min(usableEnd, segment.end);
        if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start)
          return null;
        return buildCaptionClip({
          text: segment.text,
          start: timelineStart + (start - usableStart) / speed,
          duration: Math.max(0.1, (end - start) / speed),
          track: getCaptionTrack(),
        });
      })
      .filter(Boolean);
  }

  function estimateCaptionSourceDuration(source) {
    if (!source) return 0;
    if (source.clip) {
      const clip = source.clip;
      if (Number.isFinite(clip.sourceDuration) && clip.sourceDuration > 0) {
        const trimStart = Math.max(0, finiteNumber(clip.trimStart, 0));
        const trimEnd = Math.max(0, finiteNumber(clip.trimEnd, 0));
        return Math.max(0.1, clip.sourceDuration - trimStart - trimEnd);
      }
      if (Number.isFinite(clip.duration) && clip.duration > 0) {
        return Math.max(0.1, clip.duration * Math.abs(clip.speed || 1));
      }
    }
    if (
      state.audioElement &&
      Number.isFinite(state.audioElement.duration) &&
      state.audioElement.duration > 0
    ) {
      return state.audioElement.duration;
    }
    return Math.max(3, totalDuration() || 3);
  }

  function estimateCaptionSegmentsFromText(text, source) {
    const words = String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .filter(Boolean);
    if (!words.length) return [];
    const maxWords = 7;
    const chunks = [];
    for (let index = 0; index < words.length; index += maxWords) {
      chunks.push(words.slice(index, index + maxWords).join(' '));
    }
    const duration = Math.max(0.1, estimateCaptionSourceDuration(source));
    const chunkDuration = duration / chunks.length;
    return chunks.map((chunk, index) => ({
      start: Math.max(0, index * chunkDuration),
      end: Math.min(duration, (index + 1) * chunkDuration),
      text: chunk,
    }));
  }

  async function generateEstimatedCaptionSegments(file, source) {
    const formData = new FormData();
    formData.append('audio_file', file, file.name || 'caption-audio.webm');
    const response = await fetch('/api/transcribe', {
      method: 'POST',
      body: formData,
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(
        payload.error ||
          payload.message ||
          `Fallback transcription failed (${response.status})`
      );
    }
    const text =
      payload.text || payload.transcript || payload.transcription || '';
    const segments = estimateCaptionSegmentsFromText(text, source);
    if (!segments.length) {
      throw new Error('No transcript text returned for captions');
    }
    return { text, provider: 'transcribe-estimated', segments };
  }

  function setCaptionStatus(message, tone) {
    if (!el.captionsStatus) return;
    el.captionsStatus.textContent = message || '';
    el.captionsStatus.className = 'caption-status';
    if (tone) el.captionsStatus.classList.add(tone);
  }

  function renderCaptionPanel() {
    const source = getSelectedCaptionSource();
    if (el.captionsSource) {
      el.captionsSource.innerHTML = source
        ? `<strong>${describeCaptionSource(source)}</strong>`
        : 'Select a video or audio clip, or load project audio.';
    }
    if (!el.captionsList) return;
    const clips = getCaptionClips()
      .slice()
      .sort((a, b) => {
        const startDiff = (a.start || 0) - (b.start || 0);
        if (startDiff !== 0) return startDiff;
        return (a.id || '').localeCompare(b.id || '');
      });
    el.captionsList.innerHTML = '';
    if (!clips.length) {
      el.captionsList.innerHTML =
        '<div class="caption-list-empty">No caption clips yet.</div>';
      return;
    }
    clips.forEach((clip) => {
      const row = document.createElement('button');
      row.type = 'button';
      row.className = 'caption-list-item';
      if (clip.id === state.selectedClipId) {
        row.classList.add('active');
      }
      const time = document.createElement('div');
      time.className = 'caption-list-time';
      time.textContent = `${formatTimelineTimeValue(clip.start || 0, 1)}s - ${formatTimelineTimeValue((clip.start || 0) + (clip.duration || 0), 1)}s`;
      const text = document.createElement('div');
      text.className = 'caption-list-text';
      text.textContent = clip.text || clip.name || 'Caption';
      row.appendChild(time);
      row.appendChild(text);
      row.addEventListener('click', () => {
        state.playhead = Math.max(0, clip.start || 0);
        selectClip(clip.id);
        renderFrameAt(state.playhead);
        updateTimeLabel();
      });
      el.captionsList.appendChild(row);
    });
  }

  async function generateCaptionClips() {
    const source = getSelectedCaptionSource();
    if (!source) {
      setCaptionStatus('Select a video or audio clip first', 'error');
      return;
    }
    if (el.captionsGenerate) {
      el.captionsGenerate.disabled = true;
      el.captionsGenerate.textContent = 'Generating…';
    }
    setCaptionStatus(`Transcribing ${source.name || 'media'}…`, 'busy');
    try {
      const file = await resolveCaptionSourceFile(source);
      const formData = new FormData();
      formData.append('media_file', file, file.name);
      const response = await fetch('/api/video-editor/captions/generate', {
        method: 'POST',
        body: formData,
      });
      const payload = await response.json().catch(() => ({}));
      let captionPayload = payload;
      if (response.status === 401) {
        if (
          window.NetwrckTools &&
          typeof window.NetwrckTools.requireLogin === 'function'
        ) {
          window.NetwrckTools.requireLogin();
        } else {
          window.location.href = '/login';
        }
        throw new Error(payload.error || 'Authentication required');
      }
      if (response.status === 404) {
        setCaptionStatus(
          'Timed caption service unavailable. Estimating timings…',
          'busy'
        );
        captionPayload = await generateEstimatedCaptionSegments(file, source);
      } else if (!response.ok) {
        throw new Error(
          payload.error ||
            payload.message ||
            `Caption generation failed (${response.status})`
        );
      }
      const segments = Array.isArray(captionPayload.segments)
        ? captionPayload.segments
        : [];
      if (!segments.length) {
        throw new Error('No timed caption segments returned');
      }
      const clips = mapCaptionSegmentsToTimeline(segments, source);
      if (!clips.length) {
        throw new Error('No caption clips matched the selected source clip');
      }
      const captionTrack = getCaptionTrack();
      ensureCaptionTrackLabel(captionTrack);
      clips.forEach((clip) => {
        clip.track = captionTrack;
      });
      pushTimelineHistory('caption-generate');
      if (el.captionsClearExisting && el.captionsClearExisting.checked) {
        state.clips = state.clips.filter((clip) => clip.type !== 'caption');
      }
      state.clips.push(...clips);
      setTimelineSelection(
        clips.map((clip) => clip.id),
        clips[0]?.id || null
      );
      recalcTimeline();
      renderTimeline();
      renderInspector();
      renderFrameAt(state.playhead);
      updateTimeLabel();
      scheduleAutosave();
      setCaptionStatus(
        `Generated ${clips.length} caption clip${clips.length === 1 ? '' : 's'}${captionPayload.provider ? ` via ${captionPayload.provider}` : ''}`,
        'success'
      );
    } catch (error) {
      const message =
        error && error.message ? error.message : 'Caption generation failed';
      setCaptionStatus(message, 'error');
      notify(message, 'error');
    } finally {
      if (el.captionsGenerate) {
        el.captionsGenerate.disabled = false;
        el.captionsGenerate.textContent = 'Generate captions';
      }
      renderCaptionPanel();
    }
  }

  function addClipFromAsset(assetId) {
    const asset = state.assets.find((item) => item.id === assetId);
    if (!asset) return;
    pushTimelineHistory('add');
    const clip = buildClipFromAsset(asset);
    if (typeof clip.start !== 'number' || !Number.isFinite(clip.start)) {
      clip.start = Math.max(
        asset.type === 'audio'
          ? getAudioTrackEnd(getClipTrack(clip))
          : getTrackEnd(getClipTrack(clip)),
        getActivePageTimelineStart()
      );
    }
    state.clips.push(clip);
    recalcTimeline();
    renderTimeline();
    selectClip(clip.id);
    scheduleAutosave();
  }

  function addClipFromAssetAtIndex(assetId, index) {
    const asset = state.assets.find((item) => item.id === assetId);
    if (!asset) return;
    pushTimelineHistory('add');
    const clip = buildClipFromAsset(asset);
    const opts = index && typeof index === 'object' ? index : { index };
    const insertIndex = Math.max(
      0,
      Math.min(state.clips.length, opts.index ?? state.clips.length)
    );
    if (Number.isFinite(opts.track)) {
      clip.track = Math.max(0, Math.floor(opts.track));
    }
    if (Number.isFinite(opts.start)) {
      clip.start = snapTimelineTime(opts.start);
    }
    if (typeof clip.start !== 'number' || !Number.isFinite(clip.start)) {
      clip.start = Math.max(
        asset.type === 'audio'
          ? getAudioTrackEnd(getClipTrack(clip))
          : getTrackEnd(getClipTrack(clip)),
        getActivePageTimelineStart()
      );
    }
    state.clips.splice(insertIndex, 0, clip);
    recalcTimeline();
    renderTimeline();
    selectClip(clip.id);
    scheduleAutosave();
  }

  function getClipTrack(clip) {
    if (!clip) return 0;
    const value = Number.isFinite(clip.track) ? Math.floor(clip.track) : 0;
    return value < 0 ? 0 : value;
  }

  function getTrackEnd(track, excludeIds) {
    const exclude = new Set(excludeIds || []);
    let maxEnd = 0;
    state.clips.forEach((clip) => {
      if (!clip || clip.type === 'audio') return;
      if (exclude.has(clip.id)) return;
      if (getClipTrack(clip) !== track) return;
      const start = Number.isFinite(clip.start) ? clip.start : 0;
      const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
      const end = start + duration;
      if (end > maxEnd) maxEnd = end;
    });
    return maxEnd;
  }

  function getAudioTrackEnd(track, excludeIds) {
    const exclude = new Set(excludeIds || []);
    let maxEnd = 0;
    state.clips.forEach((clip) => {
      if (!clip || clip.type !== 'audio') return;
      if (exclude.has(clip.id)) return;
      if (getClipTrack(clip) !== track) return;
      const start = Number.isFinite(clip.start) ? clip.start : 0;
      const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
      const end = start + duration;
      if (end > maxEnd) maxEnd = end;
    });
    return maxEnd;
  }

  function clipsOverlap(startA, durationA, startB, durationB) {
    const aStart = Number.isFinite(startA) ? startA : 0;
    const bStart = Number.isFinite(startB) ? startB : 0;
    const aDur = Number.isFinite(durationA) ? durationA : 0;
    const bDur = Number.isFinite(durationB) ? durationB : 0;
    const aEnd = aStart + aDur;
    const bEnd = bStart + bDur;
    return aStart < bEnd - TIMELINE_GAP_EPS && bStart < aEnd - TIMELINE_GAP_EPS;
  }

  function hasOverlapInList(list, start, duration) {
    if (!Array.isArray(list) || !list.length) return false;
    return list.some((clip) =>
      clipsOverlap(start, duration, clip.start, clip.duration)
    );
  }

  function resolveTimelineOverlaps() {
    const clips = state.clips.filter((clip) => clip && clip.type !== 'audio');
    if (!clips.length) return;
    clips.forEach((clip) => {
      if (!Number.isFinite(clip.start)) {
        clip.start = getTrackEnd(getClipTrack(clip), [clip.id]);
      }
      if (!Number.isFinite(clip.duration)) {
        clip.duration = 0;
      }
    });
    const ordered = clips.slice().sort((a, b) => {
      const startA = Number.isFinite(a.start) ? a.start : 0;
      const startB = Number.isFinite(b.start) ? b.start : 0;
      if (startA !== startB) return startA - startB;
      return getClipTrack(a) - getClipTrack(b);
    });
    const placed = new Map();
    ordered.forEach((clip) => {
      const start = Number.isFinite(clip.start) ? clip.start : 0;
      const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
      let track = getClipTrack(clip);
      const maxTrack =
        Math.max(track, ...ordered.map((item) => getClipTrack(item))) +
        ordered.length +
        1;
      while (track <= maxTrack) {
        const list = placed.get(track) || [];
        if (!hasOverlapInList(list, start, duration)) {
          clip.track = track;
          list.push({ start, duration });
          placed.set(track, list);
          return;
        }
        track += 1;
      }
      clip.track = Math.max(0, track);
    });
  }

  function resolveAudioTimelineOverlaps() {
    const clips = state.clips.filter((clip) => clip && clip.type === 'audio');
    if (!clips.length) return;
    clips.forEach((clip) => {
      if (!Number.isFinite(clip.start)) {
        clip.start = getAudioTrackEnd(getClipTrack(clip), [clip.id]);
      }
      if (!Number.isFinite(clip.duration)) {
        clip.duration = 0;
      }
    });
    const ordered = clips.slice().sort((a, b) => {
      const startA = Number.isFinite(a.start) ? a.start : 0;
      const startB = Number.isFinite(b.start) ? b.start : 0;
      if (startA !== startB) return startA - startB;
      return getClipTrack(a) - getClipTrack(b);
    });
    const placed = new Map();
    ordered.forEach((clip) => {
      const start = Number.isFinite(clip.start) ? clip.start : 0;
      const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
      let track = getClipTrack(clip);
      const maxTrack =
        Math.max(track, ...ordered.map((item) => getClipTrack(item))) +
        ordered.length +
        1;
      while (track <= maxTrack) {
        const list = placed.get(track) || [];
        if (!hasOverlapInList(list, start, duration)) {
          clip.track = track;
          list.push({ start, duration });
          placed.set(track, list);
          return;
        }
        track += 1;
      }
      clip.track = Math.max(0, track);
    });
  }

  function placeTimelineClipsAtTime(ids, time, track) {
    if (!Array.isArray(ids) || !ids.length) return false;
    const moving = state.clips.filter((clip) => ids.includes(clip.id));
    if (!moving.length) return false;
    const placement = computeTimelineClipPlacement(ids, time, track);
    if (!placement.size) return false;
    moving.forEach((clip) => {
      const next = placement.get(clip.id);
      if (!next) return;
      clip.start = next.start;
      clip.track = next.track;
    });
    resolveTimelineOverlaps();
    return true;
  }

  function computeTimelineClipPlacement(ids, time, track) {
    const placement = new Map();
    if (!Array.isArray(ids) || !ids.length) return placement;
    const moving = state.clips.filter((clip) => ids.includes(clip.id));
    if (!moving.length) return placement;
    const baseTime = snapTimelineTime(time || 0);
    const movingIds = new Set(moving.map((clip) => clip.id));
    const movingAudio = moving.some((clip) => clip.type === 'audio');
    const minStart = Math.min(
      ...moving.map((clip) => (Number.isFinite(clip.start) ? clip.start : 0))
    );
    const minTrack = Math.min(...moving.map((clip) => getClipTrack(clip)));
    const baseTrack = Number.isFinite(track)
      ? Math.max(0, Math.floor(track))
      : minTrack;
    const existingByTrack = new Map();
    state.clips.forEach((clip) => {
      if (
        !clip ||
        (movingAudio ? clip.type !== 'audio' : clip.type === 'audio')
      )
        return;
      if (movingIds.has(clip.id)) return;
      const t = getClipTrack(clip);
      if (!existingByTrack.has(t)) existingByTrack.set(t, []);
      existingByTrack.get(t).push({
        start: Number.isFinite(clip.start) ? clip.start : 0,
        duration: Number.isFinite(clip.duration) ? clip.duration : 0,
      });
    });
    const assigned = new Map();
    moving
      .slice()
      .sort((a, b) => {
        const aStart = Number.isFinite(a.start) ? a.start : 0;
        const bStart = Number.isFinite(b.start) ? b.start : 0;
        if (aStart !== bStart) return aStart - bStart;
        return getClipTrack(a) - getClipTrack(b);
      })
      .forEach((clip) => {
        const desiredTrack = Math.max(
          0,
          baseTrack + (getClipTrack(clip) - minTrack)
        );
        const start = snapTimelineTime(
          (Number.isFinite(clip.start) ? clip.start : 0) - minStart + baseTime
        );
        const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
        let nextTrack = desiredTrack;
        const maxTrack =
          Math.max(
            desiredTrack,
            ...state.clips.map((item) => getClipTrack(item))
          ) +
          moving.length +
          1;
        while (nextTrack <= maxTrack) {
          const existing = existingByTrack.get(nextTrack) || [];
          const staged = assigned.get(nextTrack) || [];
          if (
            !hasOverlapInList(existing, start, duration) &&
            !hasOverlapInList(staged, start, duration)
          ) {
            placement.set(clip.id, { start, track: nextTrack });
            staged.push({ start, duration });
            assigned.set(nextTrack, staged);
            return;
          }
          nextTrack += 1;
        }
        placement.set(clip.id, { start, track: Math.max(0, nextTrack) });
      });
    return placement;
  }

  function recalcTimeline() {
    const audioClips = state.clips.filter(
      (clip) => clip && clip.type === 'audio'
    );
    audioClips.forEach((clip) => {
      if (!Number.isFinite(clip.start)) clip.start = 0;
    });
    resolveTimelineOverlaps();
    resolveAudioTimelineOverlaps();
    updatePreviewDuration();
    updateTimelineGapSummary();
  }

  function getTimelineGaps() {
    if (!state.clips.length) return [];
    const gaps = [];
    const tracks = new Map();
    state.clips.forEach((clip) => {
      if (!clip || clip.type === 'audio') return;
      const track = getClipTrack(clip);
      if (!tracks.has(track)) tracks.set(track, []);
      tracks.get(track).push(clip);
    });
    tracks.forEach((clips, track) => {
      const ordered = clips
        .slice()
        .sort((a, b) => (a.start || 0) - (b.start || 0));
      for (let i = 0; i < ordered.length - 1; i += 1) {
        const prev = ordered[i];
        const next = ordered[i + 1];
        const prevEnd = (prev.start || 0) + (prev.duration || 0);
        const gap = (next.start || 0) - prevEnd;
        if (gap > TIMELINE_GAP_EPS) {
          gaps.push({ track, start: prevEnd, duration: gap });
        }
      }
    });
    return gaps;
  }

  function updateTimelineGapSummary() {
    if (!el.timelineGapSummary || !el.timelineRemoveGaps) return;
    const gaps = getTimelineGaps();
    if (!gaps.length) {
      el.timelineGapSummary.textContent = '0';
      el.timelineGapSummary.style.display = 'none';
      el.timelineRemoveGaps.disabled = true;
      return;
    }
    const total = gaps.reduce((sum, gap) => sum + gap.duration, 0);
    el.timelineGapSummary.textContent = `${gaps.length}`;
    el.timelineGapSummary.style.display = '';
    el.timelineRemoveGaps.disabled = false;
  }

  function removeTimelineGaps() {
    const gaps = getTimelineGaps();
    if (!gaps.length) {
      updateTimelineGapSummary();
      return;
    }
    pushTimelineHistory('remove-gaps');
    const tracks = new Map();
    state.clips.forEach((clip) => {
      if (!clip || clip.type === 'audio') return;
      const track = getClipTrack(clip);
      if (!tracks.has(track)) tracks.set(track, []);
      tracks.get(track).push(clip);
    });
    tracks.forEach((clips) => {
      const ordered = clips
        .slice()
        .sort((a, b) => (a.start || 0) - (b.start || 0));
      let cursor = 0;
      ordered.forEach((clip) => {
        clip.start = cursor;
        cursor += clip.duration || 0;
      });
    });
    recalcTimeline();
    renderTimeline();
    scheduleAutosave();
    notify('Timeline gaps removed', 'success');
  }

  function insertTimelineGapAtTime(atTime, duration) {
    const gap = Number(duration);
    if (!Number.isFinite(gap) || gap <= 0) return;
    const time = Math.max(0, atTime || 0);
    pushTimelineHistory('insert-gap');
    const threshold = time - TIMELINE_GAP_EPS;
    state.clips.forEach((clip) => {
      if ((clip.start || 0) >= threshold) {
        clip.start = (clip.start || 0) + gap;
      }
    });
    updatePreviewDuration();
    updateTimelineGapSummary();
    renderTimeline();
    scheduleAutosave();
    notify(`Inserted ${gap.toFixed(2)}s gap`, 'success');
  }

  function totalDuration() {
    let maxEnd = clipsTimelineDuration();
    state.stageElements.forEach((element) => {
      if (!element || element.hidden) return;
      const timing = getStageElementTiming(element);
      if (timing.end > maxEnd) maxEnd = timing.end;
    });
    return maxEnd;
  }

  function updatePreviewDuration() {
    if (el.timelineDuration) {
      let durationText = totalDuration().toFixed(1);
      if (durationText.endsWith('.0')) durationText = durationText.slice(0, -2);
      if (durationText.startsWith('0.')) durationText = durationText.slice(1);
      el.timelineDuration.textContent = `${durationText}s`;
    }
  }

  function updateWaveformScale() {
    if (!el.timelineWaveform || !state.waveform || !state.waveform.peaks.length)
      return;
    drawWaveformPeaks(state.waveform.peaks, state.waveform.duration);
    updateWaveformPlayhead();
  }

  function updateWaveformPlayhead() {
    if (!el.timelinePlayhead || !el.timelineWaveform) return;
    const duration = totalDuration();
    if (duration <= 0) {
      el.timelinePlayhead.style.left = '0px';
      return;
    }
    const canvas = el.timelineWaveform.querySelector('canvas');
    if (!canvas) return;
    const width = canvas.width || 1;
    const x = Math.min(width, Math.max(0, (state.playhead / duration) * width));
    el.timelinePlayhead.style.left = `${x}px`;
  }

  function updateClipVisualizerPlayheads() {
    if (!el.timelineList) return;
    const playhead = state.playhead || 0;
    const clipNodes = el.timelineList.querySelectorAll(
      '.timeline-clip[data-clip-id]'
    );
    const clipNodeById = new Map();
    clipNodes.forEach((node) =>
      clipNodeById.set(node.getAttribute('data-clip-id'), node)
    );
    state.clips.forEach((clip) => {
      const clipEl = clipNodeById.get(clip.id);
      if (!clipEl) return;
      const visualizer = clipEl.querySelector('.clip-visualizer');
      const playheadEl = clipEl.querySelector('.clip-visualizer-playhead');
      if (!visualizer || !playheadEl) return;
      if (
        playhead < clip.start ||
        playhead > clip.start + clip.duration ||
        clip.duration <= 0
      ) {
        playheadEl.style.opacity = '0';
        return;
      }
      const ratio = Math.max(
        0,
        Math.min(1, (playhead - clip.start) / clip.duration)
      );
      playheadEl.style.opacity = '1';
      playheadEl.style.left = `${(ratio * 100).toFixed(2)}%`;
    });
  }

  function hashString(value) {
    if (!value) return 0;
    let hash = 0;
    for (let i = 0; i < value.length; i += 1) {
      hash = ((hash << 5) - hash + value.charCodeAt(i)) | 0;
    }
    return hash >>> 0;
  }

  function mulberry32(seed) {
    let t = seed >>> 0;
    return () => {
      t += 0x6d2b79f5;
      let r = Math.imul(t ^ (t >>> 15), t | 1);
      r ^= r + Math.imul(r ^ (r >>> 7), r | 61);
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }

  function buildClipVisualizer(clip) {
    if (clip && clip.type === 'caption') {
      return '';
    }
    const peaks = clip.audioPeaks;
    if (Array.isArray(peaks) && peaks.length) {
      return buildClipAudioSvg(peaks);
    }
    return buildClipRandomSvg(clip);
  }

  function buildClipAudioSvg(peaks) {
    const bars = 24;
    const height = 22;
    const gap = 3;
    const barWidth = 2;
    const width = bars * gap;
    const step = Math.max(1, Math.floor(peaks.length / bars));
    let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">`;
    for (let i = 0; i < bars; i += 1) {
      const sample = peaks[Math.min(peaks.length - 1, i * step)] || 0;
      const amp = Math.max(3, Math.round((0.2 + sample * 0.8) * height));
      const y = Math.round((height - amp) / 2);
      const x = i * gap;
      svg += `<rect x="${x}" y="${y}" width="${barWidth}" height="${amp}" rx="1" fill="rgba(34,211,238,0.75)"/>`;
    }
    svg += '</svg>';
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  }

  function buildClipRandomSvg(clip) {
    const seed = hashString(clip.id || clip.name || '');
    const rand = mulberry32(seed);
    const bars = 24;
    const height = 22;
    const gap = 3;
    const barWidth = 2;
    const width = bars * gap;
    let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">`;
    for (let i = 0; i < bars; i += 1) {
      const amp = Math.max(3, Math.round((0.25 + rand() * 0.75) * height));
      const y = Math.round((height - amp) / 2);
      const x = i * gap;
      svg += `<rect x="${x}" y="${y}" width="${barWidth}" height="${amp}" rx="1" fill="rgba(56,189,248,0.7)"/>`;
    }
    svg += '</svg>';
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  }

  function buildClipAudioGradient(clip) {
    const duration = clip.duration || 0;
    if (duration <= 0) return '';
    const fadeIn = Math.max(0, clip.audioFadeIn || 0);
    const fadeOut = Math.max(0, clip.audioFadeOut || 0);
    let start = Math.min(1, fadeIn / duration) * 100;
    let end = Math.max(0, 1 - Math.min(1, fadeOut / duration)) * 100;
    if (end < start) end = start;
    start = Math.round(start * 10) / 10;
    end = Math.round(end * 10) / 10;
    return `linear-gradient(90deg, rgba(56, 189, 248, 0.2) 0%, rgba(56, 189, 248, 0.75) ${start}%, rgba(56, 189, 248, 0.75) ${end}%, rgba(56, 189, 248, 0.2) 100%)`;
  }

  function drawClipAutomationPreview(clip) {
    if (!el.clipAutomationPreview) return;
    const canvas = el.clipAutomationPreview;
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const cssWidth = canvas.clientWidth || canvas.width;
    const cssHeight = canvas.clientHeight || canvas.height;
    const targetWidth = Math.max(1, Math.round(cssWidth * dpr));
    const targetHeight = Math.max(1, Math.round(cssHeight * dpr));
    if (canvas.width !== targetWidth || canvas.height !== targetHeight) {
      canvas.width = targetWidth;
      canvas.height = targetHeight;
    }
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpr, dpr);
    const width = canvas.width / dpr;
    const height = canvas.height / dpr;
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = '#0f172a';
    ctx.fillRect(0, 0, width, height);
    if (!clip) return;
    const pad = 6;
    const innerW = Math.max(1, width - pad * 2);
    const innerH = Math.max(1, height - pad * 2);
    ctx.strokeStyle = 'rgba(255,255,255,0.12)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(pad, pad + innerH / 2);
    ctx.lineTo(pad + innerW, pad + innerH / 2);
    ctx.stroke();
    if ((state.snapToBeat || state.showAutomationBeatGrid) && state.bpm) {
      const beat = 60 / state.bpm;
      if (isFinite(beat) && beat > 0) {
        const total = Math.max(0.01, clip.duration || 1);
        ctx.strokeStyle = 'rgba(148,163,184,0.18)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        for (let t = 0; t <= total; t += beat) {
          const x = pad + (t / total) * innerW;
          ctx.moveTo(x, pad);
          ctx.lineTo(x, pad + innerH);
        }
        ctx.stroke();
      }
    }
    const anchorAxis =
      state.selectedAutomation?.axis ||
      state.selectedAutomationMulti?.axis ||
      null;
    const anchor =
      anchorAxis && state.selectedAutomationAnchor
        ? state.selectedAutomationAnchor[anchorAxis]
        : null;
    if (anchor && typeof anchor.time === 'number' && isFinite(anchor.time)) {
      const anchorTime = Math.max(0, Math.min(clip.duration || 0, anchor.time));
      const x = pad + (anchorTime / (clip.duration || 1)) * innerW;
      ctx.save();
      ctx.strokeStyle = 'rgba(148, 163, 184, 0.6)';
      ctx.lineWidth = 1;
      ctx.setLineDash([4, 4]);
      ctx.beginPath();
      ctx.moveTo(x, pad);
      ctx.lineTo(x, pad + innerH);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.fillStyle = 'rgba(148, 163, 184, 0.8)';
      ctx.fillRect(x - 2, pad - 2, 4, 4);
      ctx.restore();
    }
    const gainStart = typeof clip.audioGain === 'number' ? clip.audioGain : 1;
    const gainEnd =
      typeof clip.audioGainEnd === 'number' ? clip.audioGainEnd : gainStart;
    const gainMin = 0;
    const gainMax = 3;
    const mapGain = (value) => {
      const clamped = Math.max(gainMin, Math.min(gainMax, value));
      const norm = (clamped - gainMin) / (gainMax - gainMin || 1);
      return pad + innerH - norm * innerH;
    };
    const panStart = typeof clip.audioPan === 'number' ? clip.audioPan : 0;
    const panEnd =
      typeof clip.audioPanEnd === 'number' ? clip.audioPanEnd : panStart;
    const mapPan = (value) => {
      const clamped = Math.max(-1, Math.min(1, value));
      const norm = (clamped + 1) / 2;
      return pad + innerH - norm * innerH;
    };
    if (
      automationDragging &&
      automationDragging.group &&
      automationDragging.group.length > 1 &&
      automationDragging.axis
    ) {
      const ghostKeyframes = automationDragging.group.map((item) => ({
        time: item.time,
        value: item.value,
        ease: item.ease || 'linear',
      }));
      const ghostAxis = automationDragging.axis;
      const ghostMap = ghostAxis === 'gain' ? mapGain : mapPan;
      const ghostColor =
        ghostAxis === 'gain'
          ? 'rgba(56,189,248,0.35)'
          : 'rgba(245,158,11,0.35)';
      ctx.save();
      ctx.strokeStyle = ghostColor;
      ctx.lineWidth = 1.5;
      drawAutomationLine(
        ctx,
        ghostKeyframes,
        0,
        0,
        ghostMap,
        pad,
        innerW,
        clip.duration
      );
      drawAutomationPoints(
        ctx,
        ghostKeyframes,
        ghostMap,
        pad,
        innerW,
        clip.duration,
        ghostColor,
        []
      );
      ctx.restore();
    }
    ctx.strokeStyle = '#38bdf8';
    ctx.lineWidth = 2;
    drawAutomationLine(
      ctx,
      clip.audioGainKeyframes,
      gainStart,
      gainEnd,
      mapGain,
      pad,
      innerW,
      clip.duration
    );
    ctx.strokeStyle = '#f59e0b';
    ctx.lineWidth = 2;
    drawAutomationLine(
      ctx,
      clip.audioPanKeyframes,
      panStart,
      panEnd,
      mapPan,
      pad,
      innerW,
      clip.duration
    );
    if (Array.isArray(clip.speedKeyframes) && clip.speedKeyframes.length) {
      ctx.strokeStyle = '#a78bfa';
      ctx.lineWidth = 2;
      var mapSpeed = function (v) {
        return pad + innerH - (Math.min(4, Math.max(0, v)) / 4) * innerH;
      };
      drawAutomationLine(
        ctx,
        clip.speedKeyframes,
        clip.speed || 1,
        clip.speed || 1,
        mapSpeed,
        pad,
        innerW,
        clip.duration
      );
    }
    ctx.fillStyle = 'rgba(255,255,255,0.6)';
    ctx.font = '10px system-ui, sans-serif';
    ctx.fillText('G', pad + 2, pad + 10);
    ctx.fillText('P', pad + 2, pad + 22);
    if (Array.isArray(clip.speedKeyframes) && clip.speedKeyframes.length) {
      ctx.fillText('S', pad + 2, pad + 34);
    }
    const selectedGain = resolveSelectedAutomationIndices(
      'gain',
      clip.audioGainKeyframes
    );
    const selectedPan = resolveSelectedAutomationIndices(
      'pan',
      clip.audioPanKeyframes
    );
    drawAutomationPoints(
      ctx,
      clip.audioGainKeyframes,
      mapGain,
      pad,
      innerW,
      clip.duration,
      '#38bdf8',
      selectedGain
    );
    drawAutomationPoints(
      ctx,
      clip.audioPanKeyframes,
      mapPan,
      pad,
      innerW,
      clip.duration,
      '#f59e0b',
      selectedPan
    );
    if (Array.isArray(clip.speedKeyframes) && clip.speedKeyframes.length) {
      var mapSpeedPt = function (v) {
        return pad + innerH - (Math.min(4, Math.max(0, v)) / 4) * innerH;
      };
      drawAutomationPoints(
        ctx,
        clip.speedKeyframes,
        mapSpeedPt,
        pad,
        innerW,
        clip.duration,
        '#a78bfa',
        []
      );
    }
    updateAutomationPlayhead();
  }

  function applyEase(value, ease) {
    const t = Math.max(0, Math.min(1, value));
    if (ease === 'ease-in') {
      return t * t;
    }
    if (ease === 'ease-out') {
      return 1 - Math.pow(1 - t, 2);
    }
    if (ease === 'ease-in-out') {
      return t < 0.5 ? 2 * t * t : 1 - 2 * Math.pow(1 - t, 2);
    }
    return t;
  }

  function sampleKeyframeValue(keyframes, time, fallback) {
    if (!Array.isArray(keyframes) || !keyframes.length) return fallback;
    const sorted = keyframes.slice().sort((a, b) => a.time - b.time);
    if (time <= sorted[0].time) return sorted[0].value;
    if (time >= sorted[sorted.length - 1].time)
      return sorted[sorted.length - 1].value;
    for (let i = 0; i < sorted.length - 1; i++) {
      const a = sorted[i];
      const b = sorted[i + 1];
      if (time >= a.time && time <= b.time) {
        const span = b.time - a.time;
        if (span < 0.001) return a.value;
        const t = (time - a.time) / span;
        const eased = applyEase(t, b.ease || 'linear');
        return a.value + (b.value - a.value) * eased;
      }
    }
    return fallback;
  }

  function getSpeedAtTime(clip, localTime) {
    const baseSpeed = normalizeClipSpeed(clip && clip.speed, 1);
    const keyframes = normalizeSpeedKeyframesForClip(clip);
    if (!keyframes.length) {
      return baseSpeed;
    }
    return normalizeSpeedRampValue(
      sampleKeyframeValue(keyframes, finiteNumber(localTime, 0), baseSpeed),
      baseSpeed
    );
  }

  function integrateSpeedRamp(clip, localTime) {
    const safeLocalTime = Math.max(0, finiteNumber(localTime, 0));
    const baseSpeed = normalizeClipSpeed(clip && clip.speed, 1);
    const keyframes = normalizeSpeedKeyframesForClip(clip);
    if (!keyframes.length) {
      return safeLocalTime * Math.abs(baseSpeed);
    }
    const steps = Math.max(8, Math.ceil(safeLocalTime * 30));
    const dt = safeLocalTime / steps;
    let sourceTime = 0;
    for (let i = 0; i < steps; i++) {
      const t = (i + 0.5) * dt;
      sourceTime += Math.abs(getSpeedAtTime(clip, t)) * dt;
    }
    return sourceTime;
  }

  function addSpeedKeyframe() {
    const clip = getSelectedClip();
    if (!clip || clip.type === 'caption') return;
    const currentTime = finiteNumber(state.currentTime, state.playhead || 0);
    const localTime = Math.max(0, currentTime - (clip.start || 0));
    if (localTime < 0 || localTime > clip.duration) return;
    const currentSpeed = normalizeSpeedRampValue(
      getSpeedAtTime(clip, localTime),
      clip.speed || 1
    );
    if (!Array.isArray(clip.speedKeyframes)) clip.speedKeyframes = [];
    const existing = clip.speedKeyframes.find(
      (kf) => Math.abs(kf.time - localTime) < 0.05
    );
    if (existing) {
      existing.value = currentSpeed;
    } else {
      clip.speedKeyframes.push({
        time: localTime,
        value: currentSpeed,
        ease: 'ease-in-out',
      });
    }
    normalizeSpeedKeyframesForClip(clip);
    pushTimelineHistory('speed-keyframe-add');
    renderSpeedRampList(clip);
    renderTimeline();
  }

  function clearSpeedKeyframes() {
    const clip = getSelectedClip();
    if (!clip) return;
    clip.speedKeyframes = [];
    pushTimelineHistory('speed-keyframe-clear');
    renderSpeedRampList(clip);
    renderTimeline();
  }

  var SPEED_RAMP_PRESETS = {
    'smooth-slow': function (d) {
      return [
        { time: 0, value: 1, ease: 'linear' },
        { time: d * 0.2, value: 1, ease: 'ease-in' },
        { time: d * 0.4, value: 0.3, ease: 'ease-out' },
        { time: d * 0.6, value: 0.3, ease: 'ease-in' },
        { time: d * 0.8, value: 1, ease: 'ease-out' },
        { time: d, value: 1, ease: 'linear' },
      ];
    },
    'smooth-fast': function (d) {
      return [
        { time: 0, value: 1, ease: 'linear' },
        { time: d * 0.2, value: 1, ease: 'ease-in' },
        { time: d * 0.4, value: 2.5, ease: 'ease-out' },
        { time: d * 0.6, value: 2.5, ease: 'ease-in' },
        { time: d * 0.8, value: 1, ease: 'ease-out' },
        { time: d, value: 1, ease: 'linear' },
      ];
    },
    punch: function (d) {
      return [
        { time: 0, value: 1, ease: 'linear' },
        { time: d * 0.3, value: 0.2, ease: 'ease-in' },
        { time: d * 0.35, value: 3, ease: 'ease-out' },
        { time: d * 0.7, value: 1, ease: 'ease-in-out' },
        { time: d, value: 1, ease: 'linear' },
      ];
    },
    dramatic: function (d) {
      return [
        { time: 0, value: 1, ease: 'linear' },
        { time: d * 0.25, value: 0.15, ease: 'ease-in' },
        { time: d * 0.75, value: 0.15, ease: 'ease-out' },
        { time: d, value: 1, ease: 'ease-out' },
      ];
    },
    'ramp-up': function (d) {
      return [
        { time: 0, value: 0.3, ease: 'linear' },
        { time: d, value: 3, ease: 'ease-in' },
      ];
    },
    'ramp-down': function (d) {
      return [
        { time: 0, value: 3, ease: 'linear' },
        { time: d, value: 0.3, ease: 'ease-out' },
      ];
    },
    pulse: function (d) {
      return [
        { time: 0, value: 1, ease: 'linear' },
        { time: d * 0.15, value: 2, ease: 'ease-in' },
        { time: d * 0.3, value: 0.4, ease: 'ease-out' },
        { time: d * 0.5, value: 2, ease: 'ease-in' },
        { time: d * 0.7, value: 0.4, ease: 'ease-out' },
        { time: d * 0.85, value: 2, ease: 'ease-in' },
        { time: d, value: 1, ease: 'ease-out' },
      ];
    },
  };

  function applySpeedRampPreset(presetName) {
    const clip = getSelectedClip();
    if (!clip || !presetName) return;
    const preset = SPEED_RAMP_PRESETS[presetName];
    if (!preset) return;
    clip.speedKeyframes = preset(Math.max(0.1, finiteNumber(clip.duration, 1)));
    normalizeSpeedKeyframesForClip(clip);
    pushTimelineHistory('speed-ramp-preset');
    renderSpeedRampList(clip);
    renderTimeline();
    if (el.clipSpeedRampPreset) el.clipSpeedRampPreset.value = '';
  }

  function renderSpeedRampList(clip) {
    if (!el.clipSpeedRampList) return;
    const keyframes = normalizeSpeedKeyframesForClip(clip);
    if (!clip || !keyframes.length) {
      el.clipSpeedRampList.innerHTML =
        '<span class="text-muted" style="font-size:11px">No speed keyframes</span>';
      return;
    }
    el.clipSpeedRampList.innerHTML = keyframes
      .map(function (kf, i) {
        return (
          '<div class="keyframe-item" style="display:flex;align-items:center;gap:4px;font-size:11px;padding:2px 0">' +
          '<span style="min-width:40px">' +
          kf.time.toFixed(2) +
          's</span>' +
          '<input type="number" value="' +
          kf.value.toFixed(2) +
          '" min="0.1" max="4" step="0.1" ' +
          'style="width:50px;font-size:11px" data-speed-kf-idx="' +
          i +
          '">' +
          '<select data-speed-kf-ease-idx="' +
          i +
          '" style="font-size:11px;width:70px">' +
          '<option value="linear"' +
          (kf.ease === 'linear' ? ' selected' : '') +
          '>Linear</option>' +
          '<option value="ease-in"' +
          (kf.ease === 'ease-in' ? ' selected' : '') +
          '>Ease In</option>' +
          '<option value="ease-out"' +
          (kf.ease === 'ease-out' ? ' selected' : '') +
          '>Ease Out</option>' +
          '<option value="ease-in-out"' +
          (kf.ease === 'ease-in-out' ? ' selected' : '') +
          '>Ease I/O</option>' +
          '</select>' +
          '<button class="secondary small" data-speed-kf-del="' +
          i +
          '" style="font-size:10px;padding:1px 4px">&times;</button>' +
          '</div>'
        );
      })
      .join('');
    el.clipSpeedRampList
      .querySelectorAll('[data-speed-kf-idx]')
      .forEach(function (input) {
        input.addEventListener('change', function () {
          var idx = parseInt(input.dataset.speedKfIdx);
          if (clip.speedKeyframes[idx]) {
            var val = normalizeSpeedRampValue(
              input.value,
              clip.speedKeyframes[idx].value || clip.speed || 1
            );
            clip.speedKeyframes[idx].value = val;
            input.value = val.toFixed(2);
            normalizeSpeedKeyframesForClip(clip);
            pushTimelineHistory('speed-keyframe-edit');
            renderSpeedRampList(clip);
            renderTimeline();
          }
        });
      });
    el.clipSpeedRampList
      .querySelectorAll('[data-speed-kf-ease-idx]')
      .forEach(function (sel) {
        sel.addEventListener('change', function () {
          var idx = parseInt(sel.dataset.speedKfEaseIdx);
          if (clip.speedKeyframes[idx]) {
            clip.speedKeyframes[idx].ease = sel.value;
            pushTimelineHistory('speed-keyframe-ease');
            renderTimeline();
          }
        });
      });
    el.clipSpeedRampList
      .querySelectorAll('[data-speed-kf-del]')
      .forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.dataset.speedKfDel);
          clip.speedKeyframes.splice(idx, 1);
          pushTimelineHistory('speed-keyframe-delete');
          renderSpeedRampList(clip);
          renderTimeline();
        });
      });
  }

  function drawAutomationLine(
    ctx,
    keyframes,
    startValue,
    endValue,
    mapFn,
    pad,
    width,
    duration
  ) {
    ctx.beginPath();
    const points =
      Array.isArray(keyframes) && keyframes.length
        ? keyframes.slice().sort((a, b) => a.time - b.time)
        : [];
    if (points.length === 0) {
      ctx.moveTo(pad, mapFn(startValue));
      ctx.lineTo(pad + width, mapFn(endValue));
      ctx.stroke();
      return;
    }
    const total = Math.max(0.01, duration || 1);
    const steps = 16;
    points.forEach((kf, index) => {
      const x = pad + (kf.time / total) * width;
      const y = mapFn(kf.value);
      if (index === 0) {
        ctx.moveTo(x, y);
      }
      const next = points[index + 1];
      if (!next) {
        return;
      }
      const ease = normalizeEase(kf.ease || 'linear');
      for (let step = 1; step <= steps; step += 1) {
        const progress = step / steps;
        const eased = applyEase(progress, ease);
        const value = kf.value + (next.value - kf.value) * eased;
        const time = kf.time + (next.time - kf.time) * progress;
        const px = pad + (time / total) * width;
        const py = mapFn(value);
        ctx.lineTo(px, py);
      }
    });
    ctx.stroke();
  }

  function drawAutomationPoints(
    ctx,
    keyframes,
    mapFn,
    pad,
    width,
    duration,
    color,
    selectedIndices
  ) {
    if (!Array.isArray(keyframes)) return;
    const total = Math.max(0.01, duration || 1);
    ctx.fillStyle = color;
    const indices = Array.isArray(selectedIndices)
      ? selectedIndices
      : typeof selectedIndices === 'number' && selectedIndices >= 0
        ? [selectedIndices]
        : [];
    const selectedSet = new Set(indices);
    const primary = indices.length ? indices[0] : -1;
    keyframes.forEach((kf, index) => {
      const x = pad + (kf.time / total) * width;
      const y = mapFn(kf.value);
      ctx.beginPath();
      ctx.arc(x, y, 3, 0, Math.PI * 2);
      ctx.fill();
      if (selectedSet.has(index)) {
        ctx.strokeStyle =
          index === primary ? '#f8fafc' : 'rgba(248,250,252,0.7)';
        ctx.lineWidth = index === primary ? 2 : 1.5;
        ctx.beginPath();
        ctx.arc(x, y, 5, 0, Math.PI * 2);
        ctx.stroke();
      }
    });
  }

  function getAutomationCanvasPosition(event) {
    if (!el.clipAutomationPreview) return null;
    const rect = el.clipAutomationPreview.getBoundingClientRect();
    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
      width: rect.width || 1,
      height: rect.height || 1,
    };
  }

  function hideAutomationTooltip() {
    return;
  }

  function updateAutomationPlayhead() {
    if (!el.clipAutomationPlayhead || !el.clipAutomationPreview) return;
    const clip = getSelectedClip();
    if (!clip) {
      el.clipAutomationPlayhead.style.opacity = '0';
      return;
    }
    const duration = Math.max(0.01, clip.duration || 1);
    let localTime = state.playhead - clip.start;
    const outOfRange = localTime < 0 || localTime > duration;
    if (outOfRange) {
      localTime = Math.max(0, Math.min(duration, localTime));
    }
    const rect = el.clipAutomationPreview.getBoundingClientRect();
    const width = rect.width || el.clipAutomationPreview.clientWidth || 1;
    const pad = 6;
    const innerW = Math.max(1, width - pad * 2);
    const x = pad + (localTime / duration) * innerW;
    el.clipAutomationPlayhead.style.left = `${x}px`;
    el.clipAutomationPlayhead.style.opacity = outOfRange ? '0.35' : '1';
  }

  function getAutomationPointAt(clip, axis, pos) {
    if (!clip || !pos) return null;
    const keyframes =
      axis === 'gain' ? clip.audioGainKeyframes : clip.audioPanKeyframes;
    if (!Array.isArray(keyframes) || !keyframes.length) return null;
    const duration = Math.max(0.01, clip.duration || 1);
    const pad = 6;
    const innerW = Math.max(1, pos.width - pad * 2);
    const mapGain = (value) => {
      const clamped = Math.max(0, Math.min(3, value));
      const norm = clamped / 3;
      return pad + (pos.height - pad * 2) * (1 - norm);
    };
    const mapPan = (value) => {
      const clamped = Math.max(-1, Math.min(1, value));
      const norm = (clamped + 1) / 2;
      return pad + (pos.height - pad * 2) * (1 - norm);
    };
    const mapY = axis === 'gain' ? mapGain : mapPan;
    let closest = null;
    keyframes.forEach((kf, index) => {
      const x = pad + (kf.time / duration) * innerW;
      const y = mapY(kf.value);
      const dx = pos.x - x;
      const dy = pos.y - y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist <= 8 && (!closest || dist < closest.dist)) {
        closest = { index, dist };
      }
    });
    if (!closest) return null;
    return { index: closest.index };
  }

  function setSelectedAutomation(axis, keyframe, index) {
    if (!keyframe) {
      state.selectedAutomation = null;
      state.selectedAutomationMulti = null;
      state.selectedAutomationAnchor[axis] = null;
      return;
    }
    state.selectedAutomation = {
      axis,
      index,
      time: keyframe.time,
      value: keyframe.value,
      ease: keyframe.ease || 'linear',
    };
    state.selectedAutomationMulti = null;
    state.selectedAutomationAnchor[axis] = {
      time: keyframe.time,
      value: keyframe.value,
    };
  }

  function clearSelectedAutomation() {
    state.selectedAutomation = null;
    state.selectedAutomationMulti = null;
    state.selectedAutomationAnchor.gain = null;
    state.selectedAutomationAnchor.pan = null;
  }

  function resolveSelectedAutomationIndex(axis, keyframes) {
    const indices = resolveSelectedAutomationIndices(axis, keyframes);
    return indices.length ? indices[0] : -1;
  }

  function automationSelectionMatch(a, b) {
    if (!a || !b) return false;
    return (
      Math.abs(a.time - b.time) < 0.001 && Math.abs(a.value - b.value) < 0.001
    );
  }

  function getAutomationAnchorIndex(axis, keyframes) {
    if (
      !state.selectedAutomationAnchor ||
      !state.selectedAutomationAnchor[axis]
    )
      return -1;
    const anchor = state.selectedAutomationAnchor[axis];
    return keyframes.findIndex((kf) => automationSelectionMatch(kf, anchor));
  }

  function getAutomationSelectionItems(axis) {
    const items = [];
    if (state.selectedAutomation && state.selectedAutomation.axis === axis) {
      items.push({
        time: state.selectedAutomation.time,
        value: state.selectedAutomation.value,
        ease: state.selectedAutomation.ease || 'linear',
      });
    }
    if (
      state.selectedAutomationMulti &&
      state.selectedAutomationMulti.axis === axis
    ) {
      const extra = Array.isArray(state.selectedAutomationMulti.items)
        ? state.selectedAutomationMulti.items
        : [];
      items.push(...extra);
    }
    const unique = [];
    items.forEach((item) => {
      if (
        !unique.some((existing) => automationSelectionMatch(existing, item))
      ) {
        unique.push(item);
      }
    });
    return unique;
  }

  function updateSelectionFromKeyframes(axis, keyframes, indices) {
    if (!Array.isArray(indices) || !indices.length) {
      clearSelectedAutomation();
      return;
    }
    const primary = keyframes[indices[0]];
    if (!primary) {
      clearSelectedAutomation();
      return;
    }
    state.selectedAutomation = {
      axis,
      index: indices[0],
      time: primary.time,
      value: primary.value,
      ease: primary.ease || 'linear',
    };
    state.selectedAutomationAnchor[axis] = {
      time: primary.time,
      value: primary.value,
    };
    const extras = indices
      .slice(1)
      .map((idx) => keyframes[idx])
      .filter(Boolean)
      .map((kf) => ({
        time: kf.time,
        value: kf.value,
        ease: kf.ease || 'linear',
      }));
    state.selectedAutomationMulti = extras.length
      ? { axis, items: extras }
      : null;
  }

  function resolveSelectedAutomationIndices(axis, keyframes) {
    if (!Array.isArray(keyframes) || !keyframes.length) {
      clearSelectedAutomation();
      return [];
    }
    const items = getAutomationSelectionItems(axis);
    if (!items.length) return [];
    const indices = items
      .map((item) =>
        keyframes.findIndex((kf) => automationSelectionMatch(kf, item))
      )
      .filter((idx) => idx >= 0);
    const unique = Array.from(new Set(indices)).sort((a, b) => a - b);
    if (!unique.length) {
      clearSelectedAutomation();
      return [];
    }
    const anchorIndex = getAutomationAnchorIndex(axis, keyframes);
    const ordered =
      anchorIndex >= 0 && unique.includes(anchorIndex)
        ? [anchorIndex, ...unique.filter((idx) => idx !== anchorIndex)]
        : unique;
    updateSelectionFromKeyframes(axis, keyframes, ordered);
    return ordered;
  }

  function updateAutomationSelectionAfterEdit(axis, previous, next) {
    if (
      state.selectedAutomation &&
      state.selectedAutomation.axis === axis &&
      automationSelectionMatch(state.selectedAutomation, previous)
    ) {
      state.selectedAutomation = {
        axis,
        index: state.selectedAutomation.index,
        time: next.time,
        value: next.value,
        ease: next.ease || 'linear',
      };
    }
    if (
      state.selectedAutomationAnchor &&
      state.selectedAutomationAnchor[axis] &&
      automationSelectionMatch(state.selectedAutomationAnchor[axis], previous)
    ) {
      state.selectedAutomationAnchor[axis] = {
        time: next.time,
        value: next.value,
      };
    }
    if (
      state.selectedAutomationMulti &&
      state.selectedAutomationMulti.axis === axis
    ) {
      state.selectedAutomationMulti.items = (
        state.selectedAutomationMulti.items || []
      ).map((item) => {
        if (automationSelectionMatch(item, previous)) {
          return {
            time: next.time,
            value: next.value,
            ease: next.ease || 'linear',
          };
        }
        return item;
      });
      if (!state.selectedAutomationMulti.items.length)
        state.selectedAutomationMulti = null;
    }
  }

  function refreshAutomationSelection(axis, keyframes) {
    if (!state.selectedAutomation && !state.selectedAutomationMulti) return;
    if (state.selectedAutomation && state.selectedAutomation.axis !== axis)
      return;
    if (
      state.selectedAutomationMulti &&
      state.selectedAutomationMulti.axis !== axis
    )
      return;
    resolveSelectedAutomationIndices(axis, keyframes);
  }

  function toggleAutomationSelection(axis, keyframe, index) {
    if (!keyframe) return;
    if (!state.selectedAutomation || state.selectedAutomation.axis !== axis) {
      setSelectedAutomation(axis, keyframe, index);
      return;
    }
    if (
      state.selectedAutomation &&
      state.selectedAutomation.axis === axis &&
      automationSelectionMatch(state.selectedAutomation, keyframe)
    ) {
      if (
        state.selectedAutomationMulti &&
        state.selectedAutomationMulti.items.length
      ) {
        const next = state.selectedAutomationMulti.items.shift();
        state.selectedAutomation = {
          axis,
          index: -1,
          time: next.time,
          value: next.value,
          ease: next.ease || 'linear',
        };
        state.selectedAutomationAnchor[axis] = {
          time: next.time,
          value: next.value,
        };
      } else {
        clearSelectedAutomation();
      }
      return;
    }
    if (
      state.selectedAutomationMulti &&
      state.selectedAutomationMulti.axis === axis
    ) {
      const remaining = state.selectedAutomationMulti.items.filter(
        (item) => !automationSelectionMatch(item, keyframe)
      );
      if (remaining.length !== state.selectedAutomationMulti.items.length) {
        state.selectedAutomationMulti.items = remaining;
        if (!remaining.length) state.selectedAutomationMulti = null;
        return;
      }
    }
    state.selectedAutomationMulti =
      state.selectedAutomationMulti &&
      state.selectedAutomationMulti.axis === axis
        ? state.selectedAutomationMulti
        : { axis, items: [] };
    state.selectedAutomationMulti.items.push({
      time: keyframe.time,
      value: keyframe.value,
      ease: keyframe.ease || 'linear',
    });
    if (!state.selectedAutomationAnchor[axis]) {
      state.selectedAutomationAnchor[axis] = {
        time: keyframe.time,
        value: keyframe.value,
      };
    }
  }

  function removeAutomationSelection(axis, keyframe) {
    if (!keyframe) return;
    if (
      state.selectedAutomation &&
      state.selectedAutomation.axis === axis &&
      automationSelectionMatch(state.selectedAutomation, keyframe)
    ) {
      if (
        state.selectedAutomationMulti &&
        state.selectedAutomationMulti.items.length
      ) {
        const next = state.selectedAutomationMulti.items.shift();
        state.selectedAutomation = {
          axis,
          index: -1,
          time: next.time,
          value: next.value,
          ease: next.ease || 'linear',
        };
        state.selectedAutomationAnchor[axis] = {
          time: next.time,
          value: next.value,
        };
      } else {
        clearSelectedAutomation();
      }
      return;
    }
    if (
      state.selectedAutomationMulti &&
      state.selectedAutomationMulti.axis === axis
    ) {
      state.selectedAutomationMulti.items =
        state.selectedAutomationMulti.items.filter(
          (item) => !automationSelectionMatch(item, keyframe)
        );
      if (!state.selectedAutomationMulti.items.length)
        state.selectedAutomationMulti = null;
    }
  }

  function selectAutomationRange(axis, keyframes, index) {
    if (!Array.isArray(keyframes) || index < 0 || index >= keyframes.length)
      return;
    let anchorIndex = getAutomationAnchorIndex(axis, keyframes);
    if (anchorIndex < 0) anchorIndex = index;
    const start = Math.min(anchorIndex, index);
    const end = Math.max(anchorIndex, index);
    const ordered = [anchorIndex];
    for (let i = start; i <= end; i += 1) {
      if (i !== anchorIndex) ordered.push(i);
    }
    updateSelectionFromKeyframes(axis, keyframes, ordered);
  }

  function isEditableTarget(target) {
    if (!target) return false;
    const tag = target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    return !!target.isContentEditable;
  }

  function isTextEntryTarget(target) {
    if (!target) return false;
    const tag = target.tagName;
    if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (target.isContentEditable) return true;
    if (tag !== 'INPUT') return false;
    const type = String(target.type || 'text').toLowerCase();
    return ![
      'button',
      'checkbox',
      'color',
      'file',
      'hidden',
      'image',
      'radio',
      'range',
      'reset',
      'submit',
    ].includes(type);
  }

  function isEditorModalOpen() {
    return !!document.querySelector(
      '.editor-modal.open, .font-picker-modal.open, dialog[open]'
    );
  }

  function shouldIgnoreEditorShortcut(event) {
    return (
      isEditorModalOpen() ||
      isEditableTarget(event && event.target) ||
      isEditableTarget(document.activeElement)
    );
  }
  function hasDomTextSelection() {
    const selection = window.getSelection();
    if (!selection || !selection.rangeCount) return false;
    return String(selection).length > 0;
  }

  function setAutomationClipboard(axis, keyframe) {
    if (!keyframe) return;
    state.automationClipboard = {
      axis,
      time: keyframe.time,
      value: keyframe.value,
      ease: normalizeEase(keyframe.ease || 'linear'),
    };
  }

  function pasteAutomationClipboard() {
    const clip = getSelectedClip();
    if (!clip || !state.automationClipboard) return;
    const axis = state.automationClipboard.axis;
    const keyframes =
      axis === 'gain' ? clip.audioGainKeyframes : clip.audioPanKeyframes;
    if (!Array.isArray(keyframes)) {
      if (axis === 'gain') {
        clip.audioGainKeyframes = [];
      } else {
        clip.audioPanKeyframes = [];
      }
    }
    const duration = Math.max(0, clip.duration || 0);
    let time = Math.max(0, Math.min(duration, state.playhead - clip.start));
    if (state.snapToBeat) {
      time = snapToBeat(time);
      time = Math.max(0, Math.min(duration, time));
    }
    let value = state.automationClipboard.value;
    if (axis === 'gain') {
      value = Math.max(0, Math.min(3, value));
      clip.audioGainKeyframes.push({
        time,
        value,
        ease: state.automationClipboard.ease,
      });
      clip.audioGainKeyframes.sort((a, b) => a.time - b.time);
      const index = clip.audioGainKeyframes.findIndex(
        (kf) =>
          Math.abs(kf.time - time) < 0.001 && Math.abs(kf.value - value) < 0.001
      );
      if (index >= 0)
        setSelectedAutomation('gain', clip.audioGainKeyframes[index], index);
      renderAudioGainKeyframes(clip);
    } else {
      value = Math.max(-1, Math.min(1, value));
      clip.audioPanKeyframes.push({
        time,
        value,
        ease: state.automationClipboard.ease,
      });
      clip.audioPanKeyframes.sort((a, b) => a.time - b.time);
      const index = clip.audioPanKeyframes.findIndex(
        (kf) =>
          Math.abs(kf.time - time) < 0.001 && Math.abs(kf.value - value) < 0.001
      );
      if (index >= 0)
        setSelectedAutomation('pan', clip.audioPanKeyframes[index], index);
      renderAudioPanKeyframes(clip);
    }
    drawClipAutomationPreview(clip);
    scheduleAutosave();
  }

  function duplicateSelectedAutomation() {
    const clip = getSelectedClip();
    if (!clip || !state.selectedAutomation) return;
    const axis = state.selectedAutomation.axis;
    const keyframes =
      axis === 'gain' ? clip.audioGainKeyframes : clip.audioPanKeyframes;
    const index = resolveSelectedAutomationIndex(axis, keyframes);
    if (index < 0) return;
    const source = keyframes[index];
    const duration = Math.max(0, clip.duration || 0);
    const beat = state.snapToBeat && state.bpm ? 60 / state.bpm : 0;
    let step = isFinite(beat) && beat > 0 ? beat : 0.1;
    let time = source.time + step;
    if (time > duration && duration > 0) {
      time = Math.max(0, source.time - step);
    }
    if (state.snapToBeat) {
      time = snapToBeat(time);
      time = Math.max(0, Math.min(duration, time));
    }
    if (Math.abs(time - source.time) < 0.001) {
      time = Math.max(0, Math.min(duration, source.time + step * 0.5));
    }
    const value = source.value;
    const ease = normalizeEase(source.ease || 'linear');
    if (axis === 'gain') {
      clip.audioGainKeyframes.push({ time, value, ease });
      clip.audioGainKeyframes.sort((a, b) => a.time - b.time);
      const nextIndex = clip.audioGainKeyframes.findIndex(
        (kf) =>
          Math.abs(kf.time - time) < 0.001 && Math.abs(kf.value - value) < 0.001
      );
      if (nextIndex >= 0)
        setSelectedAutomation(
          'gain',
          clip.audioGainKeyframes[nextIndex],
          nextIndex
        );
      renderAudioGainKeyframes(clip);
    } else {
      clip.audioPanKeyframes.push({ time, value, ease });
      clip.audioPanKeyframes.sort((a, b) => a.time - b.time);
      const nextIndex = clip.audioPanKeyframes.findIndex(
        (kf) =>
          Math.abs(kf.time - time) < 0.001 && Math.abs(kf.value - value) < 0.001
      );
      if (nextIndex >= 0)
        setSelectedAutomation(
          'pan',
          clip.audioPanKeyframes[nextIndex],
          nextIndex
        );
      renderAudioPanKeyframes(clip);
    }
    drawClipAutomationPreview(clip);
    scheduleAutosave();
  }

  function handleAutomationKeydown(event) {
    const { key, lower } = getEventKeyData(event);
    if (!key) return;
    if (shouldIgnoreEditorShortcut(event)) return;
    if (event.metaKey || event.ctrlKey) {
      if (event.altKey && lower === 'z') {
        if (event.shiftKey) {
          redoTimeline();
        } else {
          undoTimeline();
        }
        event.preventDefault();
        return;
      }
      if (lower === 'z') {
        if (event.shiftKey) {
          redoGlobal();
        } else {
          undoGlobal();
        }
        event.preventDefault();
        return;
      }
      if (lower === 'y') {
        redoGlobal();
        event.preventDefault();
        return;
      }
      if (lower === 'c') {
        if (state.selectedAutomation) {
          setAutomationClipboard(
            state.selectedAutomation.axis,
            state.selectedAutomation
          );
          event.preventDefault();
        }
        return;
      }
      if (lower === 'v') {
        pasteAutomationClipboard();
        event.preventDefault();
        return;
      }
      if (lower === 'd') {
        duplicateSelectedAutomation();
        event.preventDefault();
        return;
      }
    }
    if (
      ![
        'Backspace',
        'Delete',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
      ].includes(key)
    )
      return;
    const clip = getSelectedClip();
    if (!clip || !state.selectedAutomation) return;
    const axis = state.selectedAutomation.axis;
    const keyframes =
      axis === 'gain' ? clip.audioGainKeyframes : clip.audioPanKeyframes;
    const selectedIndices = resolveSelectedAutomationIndices(axis, keyframes);
    if (!selectedIndices.length) return;
    const before = keyframes.map((kf) => ({
      time: kf.time,
      value: kf.value,
      ease: kf.ease || 'linear',
    }));
    if (key === 'Backspace' || key === 'Delete') {
      const selectedSet = new Set(selectedIndices);
      const remaining = keyframes.filter((_, idx) => !selectedSet.has(idx));
      if (axis === 'gain') {
        clip.audioGainKeyframes = remaining;
      } else {
        clip.audioPanKeyframes = remaining;
      }
      clearSelectedAutomation();
    } else {
      const selectedKeyframes = selectedIndices
        .map((idx) => keyframes[idx])
        .filter(Boolean);
      if (key === 'ArrowLeft' || key === 'ArrowRight') {
        const beat = state.snapToBeat && state.bpm ? 60 / state.bpm : 0;
        let step = isFinite(beat) && beat > 0 ? beat : 0.1;
        if (event.shiftKey) step *= 0.25;
        const delta = key === 'ArrowLeft' ? -step : step;
        const duration = Math.max(0, clip.duration || 0);
        selectedKeyframes.forEach((kf) => {
          let next = Math.max(0, Math.min(duration, kf.time + delta));
          if (state.snapToBeat) {
            next = snapToBeat(next);
            next = Math.max(0, Math.min(duration, next));
          }
          kf.time = next;
        });
        keyframes.sort((a, b) => a.time - b.time);
      } else {
        let step = axis === 'gain' ? 0.05 : 0.05;
        if (event.shiftKey) step *= 0.25;
        const delta = key === 'ArrowUp' ? step : -step;
        selectedKeyframes.forEach((kf) => {
          if (axis === 'gain') {
            kf.value = Math.max(0, Math.min(3, kf.value + delta));
          } else {
            kf.value = Math.max(-1, Math.min(1, kf.value + delta));
          }
        });
      }
      const nextIndices = selectedKeyframes
        .map((kf) => keyframes.indexOf(kf))
        .filter((idx) => idx >= 0);
      updateSelectionFromKeyframes(axis, keyframes, nextIndices);
    }
    const after =
      (axis === 'gain' ? clip.audioGainKeyframes : clip.audioPanKeyframes) ||
      [];
    pushAutomationHistory(clip, axis, before, after, key);
    if (axis === 'gain') {
      renderAudioGainKeyframes(clip);
    } else {
      renderAudioPanKeyframes(clip);
    }
    drawClipAutomationPreview(clip);
    scheduleAutosave();
    event.preventDefault();
  }

  function handleTimelineKeydown(event) {
    if (shouldIgnoreEditorShortcut(event)) return;
    if (state.selectedAutomation) return;
    if (!state.selectedClipIds.length) return;
    const key = event.key;
    if (key === 'Delete' || key === 'Backspace') {
      event.preventDefault();
      removeTimelineSelection();
      return;
    }
    if (key === 'ArrowLeft') {
      event.preventDefault();
      moveTimelineSelection(-1, state.selectedClipId);
      return;
    }
    if (event.altKey && event.shiftKey && (key === 'o' || key === 'O')) {
      if (state.selectedClipIds.length < 2) return;
      event.preventDefault();
      reverseTimelineSelection();
      return;
    }
    if (event.altKey && (key === 'd' || key === 'D')) {
      event.preventDefault();
      duplicateTimelineSelection();
      return;
    }
    if (event.altKey && (key === 's' || key === 'S')) {
      if (!canSplitTimelineAtPlayhead(state.selectedClipIds)) return;
      event.preventDefault();
      splitTimelineSelectionAtPlayhead();
      return;
    }
    if (event.altKey && (event.key === 'p' || event.key === 'P')) {
      event.preventDefault();
      moveTimelineSelectionToPlayhead();
      return;
    }
    if (event.altKey && event.shiftKey && (key === 'Home' || key === 'End')) {
      if (state.selectedClipIds.length < 2) return;
      event.preventDefault();
      alignTimelineSelection(key === 'Home' ? 'start' : 'end');
      return;
    }
    if (event.altKey && (key === 'Home' || key === 'End')) {
      event.preventDefault();
      moveTimelineSelectionToEdge(key === 'Home' ? 'start' : 'end');
      return;
    }
    if (key === 'ArrowRight') {
      event.preventDefault();
      moveTimelineSelection(1, state.selectedClipId);
    }
  }

  function addAutomationKeyframeAt(clip, axis, pos) {
    if (!clip || !pos) return;
    const before =
      axis === 'gain'
        ? cloneKeyframes(clip.audioGainKeyframes)
        : cloneKeyframes(clip.audioPanKeyframes);
    const pad = 6;
    const innerW = Math.max(1, pos.width - pad * 2);
    const innerH = Math.max(1, pos.height - pad * 2);
    const duration = Math.max(0.01, clip.duration || 1);
    const clamp = (val, min, max) => Math.max(min, Math.min(max, val));
    let time = clamp((pos.x - pad) / innerW, 0, 1) * duration;
    if (state.snapToBeat) {
      time = snapToBeat(time);
      time = clamp(time, 0, duration);
    }
    if (axis === 'gain') {
      const value = clamp(1 - (pos.y - pad) / innerH, 0, 1) * 3;
      if (!Array.isArray(clip.audioGainKeyframes)) {
        clip.audioGainKeyframes = [];
      }
      clip.audioGainKeyframes.push({ time, value, ease: 'linear' });
      clip.audioGainKeyframes.sort((a, b) => a.time - b.time);
      const selectedIndex = resolveSelectedAutomationIndex(
        'gain',
        clip.audioGainKeyframes
      );
      if (selectedIndex >= 0) {
        setSelectedAutomation(
          'gain',
          clip.audioGainKeyframes[selectedIndex],
          selectedIndex
        );
      } else {
        const index = clip.audioGainKeyframes.findIndex(
          (kf) =>
            Math.abs(kf.time - time) < 0.001 &&
            Math.abs(kf.value - value) < 0.001
        );
        if (index >= 0)
          setSelectedAutomation('gain', clip.audioGainKeyframes[index], index);
      }
      renderAudioGainKeyframes(clip);
    } else {
      const value = clamp(1 - (pos.y - pad) / innerH, 0, 1) * 2 - 1;
      if (!Array.isArray(clip.audioPanKeyframes)) {
        clip.audioPanKeyframes = [];
      }
      clip.audioPanKeyframes.push({ time, value, ease: 'linear' });
      clip.audioPanKeyframes.sort((a, b) => a.time - b.time);
      const selectedIndex = resolveSelectedAutomationIndex(
        'pan',
        clip.audioPanKeyframes
      );
      if (selectedIndex >= 0) {
        setSelectedAutomation(
          'pan',
          clip.audioPanKeyframes[selectedIndex],
          selectedIndex
        );
      } else {
        const index = clip.audioPanKeyframes.findIndex(
          (kf) =>
            Math.abs(kf.time - time) < 0.001 &&
            Math.abs(kf.value - value) < 0.001
        );
        if (index >= 0)
          setSelectedAutomation('pan', clip.audioPanKeyframes[index], index);
      }
      renderAudioPanKeyframes(clip);
    }
    const after =
      axis === 'gain' ? clip.audioGainKeyframes : clip.audioPanKeyframes;
    pushAutomationHistory(clip, axis, before, after, 'add');
    drawClipAutomationPreview(clip);
    scheduleAutosave();
  }

  function startAutomationDrag(event) {
    const clip = getSelectedClip();
    if (!clip) return;
    const pos = getAutomationCanvasPosition(event);
    if (!pos) return;
    const gainHit = getAutomationPointAt(clip, 'gain', pos);
    const panHit = getAutomationPointAt(clip, 'pan', pos);
    if (!gainHit && !panHit) {
      if (event.shiftKey) {
        addAutomationKeyframeAt(clip, 'gain', pos);
      } else if (event.altKey) {
        addAutomationKeyframeAt(clip, 'pan', pos);
      }
      return;
    }
    const multiSelect = event.metaKey || event.ctrlKey;
    const rangeSelect = event.shiftKey && !multiSelect;
    if (gainHit) {
      const keyframes = clip.audioGainKeyframes || [];
      if (keyframes[gainHit.index]) {
        if (rangeSelect) {
          selectAutomationRange('gain', keyframes, gainHit.index);
        } else if (multiSelect) {
          toggleAutomationSelection(
            'gain',
            keyframes[gainHit.index],
            gainHit.index
          );
        } else {
          setSelectedAutomation(
            'gain',
            keyframes[gainHit.index],
            gainHit.index
          );
        }
        renderAudioGainKeyframes(clip);
        drawClipAutomationPreview(clip);
      }
    } else if (panHit) {
      const keyframes = clip.audioPanKeyframes || [];
      if (keyframes[panHit.index]) {
        if (rangeSelect) {
          selectAutomationRange('pan', keyframes, panHit.index);
        } else if (multiSelect) {
          toggleAutomationSelection(
            'pan',
            keyframes[panHit.index],
            panHit.index
          );
        } else {
          setSelectedAutomation('pan', keyframes[panHit.index], panHit.index);
        }
        renderAudioPanKeyframes(clip);
        drawClipAutomationPreview(clip);
      }
    }
    event.preventDefault();
    if (multiSelect || rangeSelect) {
      automationDragging = null;
      return;
    }
    const axis = gainHit ? 'gain' : 'pan';
    const keyframes =
      axis === 'gain'
        ? clip.audioGainKeyframes || []
        : clip.audioPanKeyframes || [];
    const hitIndex = gainHit ? gainHit.index : panHit.index;
    const active = keyframes[hitIndex];
    const selectedIndices = resolveSelectedAutomationIndices(axis, keyframes);
    const groupRefs =
      selectedIndices.length > 1 && active
        ? selectedIndices.map((idx) => keyframes[idx]).filter(Boolean)
        : null;
    const anchorTime = state.selectedAutomationAnchor[axis]
      ? state.selectedAutomationAnchor[axis].time
      : active
        ? active.time
        : 0;
    const scaleMode = event.altKey && groupRefs && groupRefs.length > 1;
    automationDragging = {
      axis,
      index: hitIndex,
      originTime: active ? active.time : 0,
      originValue: active ? active.value : 0,
      anchorTime,
      mode: scaleMode ? 'scale' : 'move',
      group: groupRefs
        ? groupRefs.map((kf) => ({
            ref: kf,
            time: kf.time,
            value: kf.value,
            ease: kf.ease || 'linear',
          }))
        : null,
    };
  }

  function moveAutomationDrag(event) {
    if (!automationDragging) return;
    const clip = getSelectedClip();
    if (!clip) return;
    if (!automationDragging.before) {
      const current =
        automationDragging.axis === 'gain'
          ? clip.audioGainKeyframes
          : clip.audioPanKeyframes;
      automationDragging.before = cloneKeyframes(current || []);
    }
    const pos = getAutomationCanvasPosition(event);
    if (!pos) return;
    const pad = 6;
    const innerW = Math.max(1, pos.width - pad * 2);
    const innerH = Math.max(1, pos.height - pad * 2);
    const duration = Math.max(0.01, clip.duration || 1);
    const clamp = (val, min, max) => Math.max(min, Math.min(max, val));
    let time = clamp((pos.x - pad) / innerW, 0, 1) * duration;
    if (state.snapToBeat) {
      time = snapToBeat(time);
      time = clamp(time, 0, duration);
    }
    if (automationDragging.axis === 'gain') {
      const value = clamp(1 - (pos.y - pad) / innerH, 0, 1) * 3;
      if (automationDragging.group && automationDragging.group.length > 1) {
        const deltaTime = time - automationDragging.originTime;
        const deltaValue = value - automationDragging.originValue;
        const refs = new Set();
        if (automationDragging.mode === 'scale') {
          const anchorTime =
            typeof automationDragging.anchorTime === 'number'
              ? automationDragging.anchorTime
              : automationDragging.originTime;
          const denom = automationDragging.originTime - anchorTime;
          let scale = denom !== 0 ? (time - anchorTime) / denom : 1;
          if (!isFinite(scale)) scale = 1;
          scale = Math.max(0.1, Math.min(10, scale));
          automationDragging.group.forEach((item) => {
            let nextTime = anchorTime + (item.time - anchorTime) * scale;
            nextTime = Math.max(0, Math.min(duration, nextTime));
            let nextValue = item.value + deltaValue;
            nextValue = Math.max(0, Math.min(3, nextValue));
            item.ref.time = nextTime;
            item.ref.value = nextValue;
            refs.add(item.ref);
          });
        } else {
          automationDragging.group.forEach((item) => {
            let nextTime = item.time + deltaTime;
            nextTime = Math.max(0, Math.min(duration, nextTime));
            let nextValue = item.value + deltaValue;
            nextValue = Math.max(0, Math.min(3, nextValue));
            item.ref.time = nextTime;
            item.ref.value = nextValue;
            refs.add(item.ref);
          });
        }
        clip.audioGainKeyframes.sort((a, b) => a.time - b.time);
        const selectedIndices = clip.audioGainKeyframes
          .map((kf, idx) => (refs.has(kf) ? idx : -1))
          .filter((idx) => idx >= 0);
        const anchorIndex = getAutomationAnchorIndex(
          'gain',
          clip.audioGainKeyframes
        );
        const ordered =
          anchorIndex >= 0 && selectedIndices.includes(anchorIndex)
            ? [
                anchorIndex,
                ...selectedIndices.filter((idx) => idx !== anchorIndex),
              ]
            : selectedIndices;
        updateSelectionFromKeyframes('gain', clip.audioGainKeyframes, ordered);
        renderAudioGainKeyframes(clip);
      } else {
        const existing = clip.audioGainKeyframes[automationDragging.index];
        if (!existing) return;
        const previous = {
          time: existing.time,
          value: existing.value,
          ease: existing.ease || 'linear',
        };
        existing.time = time;
        existing.value = value;
        existing.ease = existing.ease || 'linear';
        updateAutomationSelectionAfterEdit('gain', previous, existing);
        clip.audioGainKeyframes.sort((a, b) => a.time - b.time);
        const selectedIndex = resolveSelectedAutomationIndex(
          'gain',
          clip.audioGainKeyframes
        );
        if (selectedIndex >= 0) {
          setSelectedAutomation(
            'gain',
            clip.audioGainKeyframes[selectedIndex],
            selectedIndex
          );
        }
        renderAudioGainKeyframes(clip);
      }
    } else {
      const value = clamp(1 - (pos.y - pad) / innerH, 0, 1) * 2 - 1;
      if (automationDragging.group && automationDragging.group.length > 1) {
        const deltaTime = time - automationDragging.originTime;
        const deltaValue = value - automationDragging.originValue;
        const refs = new Set();
        if (automationDragging.mode === 'scale') {
          const anchorTime =
            typeof automationDragging.anchorTime === 'number'
              ? automationDragging.anchorTime
              : automationDragging.originTime;
          const denom = automationDragging.originTime - anchorTime;
          let scale = denom !== 0 ? (time - anchorTime) / denom : 1;
          if (!isFinite(scale)) scale = 1;
          scale = Math.max(0.1, Math.min(10, scale));
          automationDragging.group.forEach((item) => {
            let nextTime = anchorTime + (item.time - anchorTime) * scale;
            nextTime = Math.max(0, Math.min(duration, nextTime));
            let nextValue = item.value + deltaValue;
            nextValue = Math.max(-1, Math.min(1, nextValue));
            item.ref.time = nextTime;
            item.ref.value = nextValue;
            refs.add(item.ref);
          });
        } else {
          automationDragging.group.forEach((item) => {
            let nextTime = item.time + deltaTime;
            nextTime = Math.max(0, Math.min(duration, nextTime));
            let nextValue = item.value + deltaValue;
            nextValue = Math.max(-1, Math.min(1, nextValue));
            item.ref.time = nextTime;
            item.ref.value = nextValue;
            refs.add(item.ref);
          });
        }
        clip.audioPanKeyframes.sort((a, b) => a.time - b.time);
        const selectedIndices = clip.audioPanKeyframes
          .map((kf, idx) => (refs.has(kf) ? idx : -1))
          .filter((idx) => idx >= 0);
        const anchorIndex = getAutomationAnchorIndex(
          'pan',
          clip.audioPanKeyframes
        );
        const ordered =
          anchorIndex >= 0 && selectedIndices.includes(anchorIndex)
            ? [
                anchorIndex,
                ...selectedIndices.filter((idx) => idx !== anchorIndex),
              ]
            : selectedIndices;
        updateSelectionFromKeyframes('pan', clip.audioPanKeyframes, ordered);
        renderAudioPanKeyframes(clip);
      } else {
        const existing = clip.audioPanKeyframes[automationDragging.index];
        if (!existing) return;
        const previous = {
          time: existing.time,
          value: existing.value,
          ease: existing.ease || 'linear',
        };
        existing.time = time;
        existing.value = value;
        existing.ease = existing.ease || 'linear';
        updateAutomationSelectionAfterEdit('pan', previous, existing);
        clip.audioPanKeyframes.sort((a, b) => a.time - b.time);
        const selectedIndex = resolveSelectedAutomationIndex(
          'pan',
          clip.audioPanKeyframes
        );
        if (selectedIndex >= 0) {
          setSelectedAutomation(
            'pan',
            clip.audioPanKeyframes[selectedIndex],
            selectedIndex
          );
        }
        renderAudioPanKeyframes(clip);
      }
    }
    drawClipAutomationPreview(clip);
    scheduleAutosave();
  }

  function endAutomationDrag() {
    if (
      automationDragging &&
      automationDragging.before &&
      automationDragging.axis
    ) {
      const clip = getSelectedClip();
      if (clip) {
        const after =
          automationDragging.axis === 'gain'
            ? clip.audioGainKeyframes
            : clip.audioPanKeyframes;
        if (after) {
          pushAutomationHistory(
            clip,
            automationDragging.axis,
            automationDragging.before,
            after,
            'drag'
          );
        }
      }
    }
    automationDragging = null;
  }

  function addAudioGainKeyframe() {
    const clip = getSelectedClip();
    if (!clip) return;
    const before = cloneKeyframes(clip.audioGainKeyframes);
    if (!Array.isArray(clip.audioGainKeyframes)) {
      clip.audioGainKeyframes = [];
    }
    let time = Math.max(
      0,
      Math.min(clip.duration || 0, state.playhead - clip.start)
    );
    if (state.snapToBeat) {
      time = snapToBeat(time);
      time = Math.max(0, Math.min(clip.duration || 0, time));
    }
    const value = typeof clip.audioGain === 'number' ? clip.audioGain : 1;
    const existing = clip.audioGainKeyframes.find(
      (kf) => Math.abs(kf.time - time) < 0.05
    );
    if (existing) {
      existing.value = value;
    } else {
      clip.audioGainKeyframes.push({ time, value, ease: 'linear' });
    }
    clip.audioGainKeyframes.sort((a, b) => a.time - b.time);
    const index = clip.audioGainKeyframes.findIndex(
      (kf) =>
        Math.abs(kf.time - time) < 0.001 && Math.abs(kf.value - value) < 0.001
    );
    if (index >= 0) {
      setSelectedAutomation('gain', clip.audioGainKeyframes[index], index);
    }
    renderAudioGainKeyframes(clip);
    drawClipAutomationPreview(clip);
    scheduleAutosave();
    pushAutomationHistory(clip, 'gain', before, clip.audioGainKeyframes, 'add');
  }

  function applyAudioKeyframePreset(axis, ease) {
    const clip = getSelectedClip();
    if (!clip) return;
    const before =
      axis === 'gain'
        ? cloneKeyframes(clip.audioGainKeyframes)
        : cloneKeyframes(clip.audioPanKeyframes);
    const duration = Math.max(0.01, clip.duration || 0);
    if (axis === 'gain') {
      const start = typeof clip.audioGain === 'number' ? clip.audioGain : 1;
      const end =
        typeof clip.audioGainEnd === 'number' ? clip.audioGainEnd : start;
      clip.audioGainKeyframes = [
        { time: 0, value: start, ease: normalizeEase(ease) },
        { time: duration, value: end, ease: 'linear' },
      ];
      setSelectedAutomation('gain', clip.audioGainKeyframes[0], 0);
      renderAudioGainKeyframes(clip);
    } else {
      const start = typeof clip.audioPan === 'number' ? clip.audioPan : 0;
      const end =
        typeof clip.audioPanEnd === 'number' ? clip.audioPanEnd : start;
      clip.audioPanKeyframes = [
        { time: 0, value: start, ease: normalizeEase(ease) },
        { time: duration, value: end, ease: 'linear' },
      ];
      setSelectedAutomation('pan', clip.audioPanKeyframes[0], 0);
      renderAudioPanKeyframes(clip);
    }
    drawClipAutomationPreview(clip);
    scheduleAutosave();
    const after =
      axis === 'gain' ? clip.audioGainKeyframes : clip.audioPanKeyframes;
    pushAutomationHistory(clip, axis, before, after, 'preset');
  }

  function applyAudioGainPreset(mode) {
    const clip = getSelectedClip();
    if (!clip) return;
    const before = cloneKeyframes(clip.audioGainKeyframes);
    const duration = Math.max(0.01, clip.duration || 0);
    const startGain = typeof clip.audioGain === 'number' ? clip.audioGain : 1;
    const endGain =
      typeof clip.audioGainEnd === 'number' ? clip.audioGainEnd : startGain;
    if (mode === 'fade-in') {
      clip.audioGainKeyframes = [
        { time: 0, value: 0, ease: 'ease-in' },
        { time: duration, value: Math.max(0, endGain), ease: 'linear' },
      ];
    } else if (mode === 'fade-out') {
      clip.audioGainKeyframes = [
        { time: 0, value: Math.max(0, startGain), ease: 'linear' },
        { time: duration, value: 0, ease: 'ease-out' },
      ];
    } else if (mode === 'fade-in-out') {
      const mid = duration / 2;
      clip.audioGainKeyframes = [
        { time: 0, value: 0, ease: 'ease-in' },
        { time: mid, value: Math.max(0, endGain), ease: 'linear' },
        { time: duration, value: 0, ease: 'ease-out' },
      ];
    } else {
      return;
    }
    setSelectedAutomation('gain', clip.audioGainKeyframes[0], 0);
    renderAudioGainKeyframes(clip);
    drawClipAutomationPreview(clip);
    scheduleAutosave();
    pushAutomationHistory(
      clip,
      'gain',
      before,
      clip.audioGainKeyframes,
      'preset'
    );
  }

  function applyAudioPanPreset(mode) {
    const clip = getSelectedClip();
    if (!clip) return;
    const before = cloneKeyframes(clip.audioPanKeyframes);
    const duration = Math.max(0.01, clip.duration || 0);
    if (mode === 'left-right') {
      clip.audioPanKeyframes = [
        { time: 0, value: -1, ease: 'ease-in' },
        { time: duration, value: 1, ease: 'ease-out' },
      ];
    } else if (mode === 'right-left') {
      clip.audioPanKeyframes = [
        { time: 0, value: 1, ease: 'ease-in' },
        { time: duration, value: -1, ease: 'ease-out' },
      ];
    } else {
      return;
    }
    setSelectedAutomation('pan', clip.audioPanKeyframes[0], 0);
    renderAudioPanKeyframes(clip);
    drawClipAutomationPreview(clip);
    scheduleAutosave();
    pushAutomationHistory(
      clip,
      'pan',
      before,
      clip.audioPanKeyframes,
      'preset'
    );
  }

  function clearAudioKeyframes(axis) {
    const clip = getSelectedClip();
    if (!clip) return;
    const before =
      axis === 'gain'
        ? cloneKeyframes(clip.audioGainKeyframes)
        : cloneKeyframes(clip.audioPanKeyframes);
    if (axis === 'gain') {
      clip.audioGainKeyframes = [];
      renderAudioGainKeyframes(clip);
    } else {
      clip.audioPanKeyframes = [];
      renderAudioPanKeyframes(clip);
    }
    clearSelectedAutomation();
    drawClipAutomationPreview(clip);
    scheduleAutosave();
    const after =
      axis === 'gain' ? clip.audioGainKeyframes : clip.audioPanKeyframes;
    pushAutomationHistory(clip, axis, before, after, 'clear');
  }

  function renderAudioGainKeyframes(clip) {
    if (!el.clipAudioGainKeyframes) return;
    el.clipAudioGainKeyframes.innerHTML = '';
    if (
      !clip ||
      !Array.isArray(clip.audioGainKeyframes) ||
      !clip.audioGainKeyframes.length
    ) {
      return;
    }
    const selectedIndices = resolveSelectedAutomationIndices(
      'gain',
      clip.audioGainKeyframes
    );
    clip.audioGainKeyframes.forEach((kf, index) => {
      const row = document.createElement('div');
      row.className = 'action-row';
      if (selectedIndices.includes(index)) {
        row.style.background =
          index === selectedIndices[0]
            ? 'rgba(56, 189, 248, 0.16)'
            : 'rgba(56, 189, 248, 0.08)';
      }
      row.addEventListener('click', (event) => {
        if (isEditableTarget(event.target)) return;
        if (event.shiftKey && !(event.metaKey || event.ctrlKey)) {
          selectAutomationRange('gain', clip.audioGainKeyframes, index);
        } else if (event.metaKey || event.ctrlKey) {
          toggleAutomationSelection('gain', kf, index);
        } else {
          setSelectedAutomation('gain', kf, index);
        }
        renderAudioGainKeyframes(clip);
        drawClipAutomationPreview(clip);
      });
      const time = document.createElement('input');
      time.type = 'number';
      time.min = '0';
      time.step = '0.1';
      time.value = kf.time.toFixed(2);
      time.addEventListener('input', () => {
        const before = cloneKeyframes(clip.audioGainKeyframes);
        const previous = {
          time: kf.time,
          value: kf.value,
          ease: kf.ease || 'linear',
        };
        let next = Math.max(0, parseFloat(time.value) || 0);
        if (state.snapToBeat) {
          next = snapToBeat(next);
        }
        kf.time = Math.min(next, clip.duration || next);
        updateAutomationSelectionAfterEdit('gain', previous, kf);
        clip.audioGainKeyframes.sort((a, b) => a.time - b.time);
        refreshAutomationSelection('gain', clip.audioGainKeyframes);
        renderAudioGainKeyframes(clip);
        drawClipAutomationPreview(clip);
        scheduleAutosave();
        pushAutomationHistory(
          clip,
          'gain',
          before,
          clip.audioGainKeyframes,
          'edit'
        );
      });
      const value = document.createElement('input');
      value.type = 'number';
      value.min = '0';
      value.step = '0.1';
      value.value = kf.value.toFixed(2);
      value.addEventListener('input', () => {
        const before = cloneKeyframes(clip.audioGainKeyframes);
        const previous = {
          time: kf.time,
          value: kf.value,
          ease: kf.ease || 'linear',
        };
        kf.value = Math.max(0, parseFloat(value.value) || 0);
        updateAutomationSelectionAfterEdit('gain', previous, kf);
        drawClipAutomationPreview(clip);
        scheduleAutosave();
        pushAutomationHistory(
          clip,
          'gain',
          before,
          clip.audioGainKeyframes,
          'edit'
        );
      });
      const ease = document.createElement('select');
      ['linear', 'ease-in', 'ease-out', 'ease-in-out'].forEach((mode) => {
        const option = document.createElement('option');
        option.value = mode;
        option.textContent = mode;
        ease.appendChild(option);
      });
      kf.ease = normalizeEase(kf.ease || 'linear');
      ease.value = kf.ease;
      ease.addEventListener('change', () => {
        const before = cloneKeyframes(clip.audioGainKeyframes);
        const previous = {
          time: kf.time,
          value: kf.value,
          ease: kf.ease || 'linear',
        };
        kf.ease = normalizeEase(ease.value);
        updateAutomationSelectionAfterEdit('gain', previous, kf);
        drawClipAutomationPreview(clip);
        scheduleAutosave();
        pushAutomationHistory(
          clip,
          'gain',
          before,
          clip.audioGainKeyframes,
          'ease'
        );
      });
      const remove = document.createElement('button');
      remove.className = 'secondary';
      remove.textContent = 'Remove';
      remove.addEventListener('click', () => {
        const before = cloneKeyframes(clip.audioGainKeyframes);
        removeAutomationSelection('gain', kf);
        clip.audioGainKeyframes.splice(index, 1);
        refreshAutomationSelection('gain', clip.audioGainKeyframes);
        renderAudioGainKeyframes(clip);
        drawClipAutomationPreview(clip);
        scheduleAutosave();
        pushAutomationHistory(
          clip,
          'gain',
          before,
          clip.audioGainKeyframes,
          'remove'
        );
      });
      row.appendChild(time);
      row.appendChild(value);
      row.appendChild(ease);
      row.appendChild(remove);
      el.clipAudioGainKeyframes.appendChild(row);
    });
  }

  function addAudioPanKeyframe() {
    const clip = getSelectedClip();
    if (!clip) return;
    const before = cloneKeyframes(clip.audioPanKeyframes);
    if (!Array.isArray(clip.audioPanKeyframes)) {
      clip.audioPanKeyframes = [];
    }
    let time = Math.max(
      0,
      Math.min(clip.duration || 0, state.playhead - clip.start)
    );
    if (state.snapToBeat) {
      time = snapToBeat(time);
      time = Math.max(0, Math.min(clip.duration || 0, time));
    }
    const value = typeof clip.audioPan === 'number' ? clip.audioPan : 0;
    const existing = clip.audioPanKeyframes.find(
      (kf) => Math.abs(kf.time - time) < 0.05
    );
    if (existing) {
      existing.value = value;
    } else {
      clip.audioPanKeyframes.push({ time, value, ease: 'linear' });
    }
    clip.audioPanKeyframes.sort((a, b) => a.time - b.time);
    const index = clip.audioPanKeyframes.findIndex(
      (kf) =>
        Math.abs(kf.time - time) < 0.001 && Math.abs(kf.value - value) < 0.001
    );
    if (index >= 0) {
      setSelectedAutomation('pan', clip.audioPanKeyframes[index], index);
    }
    renderAudioPanKeyframes(clip);
    drawClipAutomationPreview(clip);
    scheduleAutosave();
    pushAutomationHistory(clip, 'pan', before, clip.audioPanKeyframes, 'add');
  }

  function renderAudioPanKeyframes(clip) {
    if (!el.clipAudioPanKeyframes) return;
    el.clipAudioPanKeyframes.innerHTML = '';
    if (
      !clip ||
      !Array.isArray(clip.audioPanKeyframes) ||
      !clip.audioPanKeyframes.length
    ) {
      return;
    }
    const selectedIndices = resolveSelectedAutomationIndices(
      'pan',
      clip.audioPanKeyframes
    );
    clip.audioPanKeyframes.forEach((kf, index) => {
      const row = document.createElement('div');
      row.className = 'action-row';
      if (selectedIndices.includes(index)) {
        row.style.background =
          index === selectedIndices[0]
            ? 'rgba(245, 158, 11, 0.18)'
            : 'rgba(245, 158, 11, 0.09)';
      }
      row.addEventListener('click', (event) => {
        if (isEditableTarget(event.target)) return;
        if (event.shiftKey && !(event.metaKey || event.ctrlKey)) {
          selectAutomationRange('pan', clip.audioPanKeyframes, index);
        } else if (event.metaKey || event.ctrlKey) {
          toggleAutomationSelection('pan', kf, index);
        } else {
          setSelectedAutomation('pan', kf, index);
        }
        renderAudioPanKeyframes(clip);
        drawClipAutomationPreview(clip);
      });
      const time = document.createElement('input');
      time.type = 'number';
      time.min = '0';
      time.step = '0.1';
      time.value = kf.time.toFixed(2);
      time.addEventListener('input', () => {
        const before = cloneKeyframes(clip.audioPanKeyframes);
        const previous = {
          time: kf.time,
          value: kf.value,
          ease: kf.ease || 'linear',
        };
        let next = Math.max(0, parseFloat(time.value) || 0);
        if (state.snapToBeat) {
          next = snapToBeat(next);
        }
        kf.time = Math.min(next, clip.duration || next);
        updateAutomationSelectionAfterEdit('pan', previous, kf);
        clip.audioPanKeyframes.sort((a, b) => a.time - b.time);
        refreshAutomationSelection('pan', clip.audioPanKeyframes);
        renderAudioPanKeyframes(clip);
        drawClipAutomationPreview(clip);
        scheduleAutosave();
        pushAutomationHistory(
          clip,
          'pan',
          before,
          clip.audioPanKeyframes,
          'edit'
        );
      });
      const value = document.createElement('input');
      value.type = 'number';
      value.min = '-1';
      value.max = '1';
      value.step = '0.1';
      value.value = kf.value.toFixed(2);
      value.addEventListener('input', () => {
        const before = cloneKeyframes(clip.audioPanKeyframes);
        const previous = {
          time: kf.time,
          value: kf.value,
          ease: kf.ease || 'linear',
        };
        let next = parseFloat(value.value);
        if (isNaN(next)) next = 0;
        kf.value = Math.max(-1, Math.min(1, next));
        updateAutomationSelectionAfterEdit('pan', previous, kf);
        drawClipAutomationPreview(clip);
        scheduleAutosave();
        pushAutomationHistory(
          clip,
          'pan',
          before,
          clip.audioPanKeyframes,
          'edit'
        );
      });
      const ease = document.createElement('select');
      ['linear', 'ease-in', 'ease-out', 'ease-in-out'].forEach((mode) => {
        const option = document.createElement('option');
        option.value = mode;
        option.textContent = mode;
        ease.appendChild(option);
      });
      kf.ease = normalizeEase(kf.ease || 'linear');
      ease.value = kf.ease;
      ease.addEventListener('change', () => {
        const before = cloneKeyframes(clip.audioPanKeyframes);
        const previous = {
          time: kf.time,
          value: kf.value,
          ease: kf.ease || 'linear',
        };
        kf.ease = normalizeEase(ease.value);
        updateAutomationSelectionAfterEdit('pan', previous, kf);
        drawClipAutomationPreview(clip);
        scheduleAutosave();
        pushAutomationHistory(
          clip,
          'pan',
          before,
          clip.audioPanKeyframes,
          'ease'
        );
      });
      const remove = document.createElement('button');
      remove.className = 'secondary';
      remove.textContent = 'Remove';
      remove.addEventListener('click', () => {
        const before = cloneKeyframes(clip.audioPanKeyframes);
        removeAutomationSelection('pan', kf);
        clip.audioPanKeyframes.splice(index, 1);
        refreshAutomationSelection('pan', clip.audioPanKeyframes);
        renderAudioPanKeyframes(clip);
        drawClipAutomationPreview(clip);
        scheduleAutosave();
        pushAutomationHistory(
          clip,
          'pan',
          before,
          clip.audioPanKeyframes,
          'remove'
        );
      });
      row.appendChild(time);
      row.appendChild(value);
      row.appendChild(ease);
      row.appendChild(remove);
      el.clipAudioPanKeyframes.appendChild(row);
    });
  }

  function updateBeatGrid() {
    if (!el.timelineList) return;
    const beat = state.bpm ? 60 / state.bpm : 0;
    if (!isFinite(beat) || beat <= 0) {
      el.timelineList.classList.remove('beat-grid');
      if (el.timelineWaveform)
        el.timelineWaveform.classList.remove('beat-grid');
      return;
    }
    const size = Math.max(20, beat * state.timelineScale);
    el.timelineList.style.setProperty('--beat-size', `${size}px`);
    el.timelineList.classList.add('beat-grid');
    if (el.timelineWaveform) {
      el.timelineWaveform.style.setProperty('--beat-size', `${size}px`);
      el.timelineWaveform.classList.add('beat-grid');
    }
  }

  function snapToBeat(value) {
    if (!state.snapToBeat || !state.bpm) return value;
    const beat = 60 / state.bpm;
    if (!isFinite(beat) || beat <= 0) return value;
    return Math.round(value / beat) * beat;
  }

  function snapTimelineMarkerTime(time) {
    let next = Math.max(0, time || 0);
    if (state.snapToBeat) {
      next = snapToBeat(next);
    }
    const fps = Math.max(1, state.fps || 30);
    const frame = 1 / fps;
    next = Math.max(0, Math.round(next / frame) * frame);
    return next <= TIMELINE_GAP_EPS ? 0 : next;
  }

  function snapTimelineTime(time) {
    let next = Math.max(0, time || 0);
    if (state.snapToBeat) {
      next = snapToBeat(next);
    }
    const fps = Math.max(1, state.fps || 30);
    const frame = 1 / fps;
    next = Math.max(0, Math.round(next / frame) * frame);
    return next <= TIMELINE_GAP_EPS ? 0 : next;
  }

  function getTimelineVideoTrackCount() {
    const tracks = state.clips
      .filter((clip) => clip && clip.type !== 'audio')
      .map((clip) => getClipTrack(clip));
    if (!tracks.length) return 1;
    return Math.max(...tracks) + 1;
  }

  function getVisibleTimelineStageElements() {
    const pageId = state.activePageId;
    return state.stageElements.filter(
      (element) => element && (!element.pageId || element.pageId === pageId)
    );
  }

  function getStageElementLaneKey(id) {
    return `stage-${id}`;
  }

  function getAudioClipLaneKey(track) {
    const index = Math.max(0, Math.floor(Number(track) || 0));
    return index === 0 ? 'audio' : `audio-${index}`;
  }

  function getTimelineAudioClipTrackCount() {
    const tracks = state.clips
      .filter((clip) => clip && clip.type === 'audio')
      .map((clip) => getClipTrack(clip));
    if (!tracks.length) return 1;
    return Math.max(...tracks) + 2;
  }

  function iconSvg(name) {
    const icons = {
      mute: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M11 5 6 9H3v6h3l5 4V5Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="m19 9-4 4m0-4 4 4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
      volume:
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M11 5 6 9H3v6h3l5 4V5Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M15 9.5a4 4 0 0 1 0 5M17.5 7a7 7 0 0 1 0 10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
      solo: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 13a8 8 0 0 1 16 0" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M4 13v3a3 3 0 0 0 3 3h1v-8H7a3 3 0 0 0-3 3Zm16 0v3a3 3 0 0 1-3 3h-1v-8h1a3 3 0 0 1 3 3Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
      lock: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="5" y="11" width="14" height="9" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
      unlock:
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="5" y="11" width="14" height="9" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><path d="M8 11V8a4 4 0 0 1 7.5-2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    };
    return icons[name] || '';
  }

  function clipHasAudio(clip) {
    if (!clip) return false;
    if (clip.type === 'audio') return true;
    if (clip.type !== 'video') return false;
    return Array.isArray(clip.audioPeaks) && clip.audioPeaks.length > 0;
  }

  function laneHasAudio(lane) {
    if (!lane) return false;
    if (lane.audioTrackId) {
      const track = state.audioTracks.find(
        (item) => item.id === lane.audioTrackId
      );
      return !!(track && (track.element || track.src));
    }
    if (lane.type === 'audio') {
      return (
        (lane.track === 0 && !!state.audioElement) ||
        state.clips.some(
          (clip) =>
            clip && clip.type === 'audio' && getClipTrack(clip) === lane.track
        )
      );
    }
    return state.clips.some(
      (clip) =>
        clip &&
        clip.type === 'video' &&
        getClipTrack(clip) === lane.track &&
        clipHasAudio(clip)
    );
  }

  function appendTimelineTrimGhost(track, clip, pxPerSec) {
    if (!track || !clip || !timelineHandleDrag) return;
    if (timelineHandleDrag.clipId !== clip.id) return;
    if (clip.type !== 'video') return;
    const sourceDuration = Math.max(
      0,
      finiteNumber(clip.sourceDuration, finiteNumber(clip.duration, 0))
    );
    const speed = Math.max(0.01, Math.abs(normalizeClipSpeed(clip.speed, 1)));
    const trimStart = Math.max(0, finiteNumber(clip.trimStart, 0));
    const trimEnd = Math.max(0, finiteNumber(clip.trimEnd, 0));
    const hiddenLeft = trimStart / speed;
    const hiddenRight = trimEnd / speed;
    if (hiddenLeft <= 0.001 && hiddenRight <= 0.001) return;
    const start = Number.isFinite(clip.start) ? clip.start : 0;
    const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
    const fullStart = Math.max(0, start - hiddenLeft);
    const fullDuration = Math.max(
      duration + hiddenLeft + hiddenRight,
      sourceDuration / speed,
      duration
    );
    const ghost = document.createElement('div');
    ghost.className = 'timeline-trim-ghost';
    ghost.style.left = `${fullStart * pxPerSec}px`;
    ghost.style.width = `${Math.max(48, fullDuration * pxPerSec)}px`;
    if (clip.src) {
      ghost.style.backgroundImage = `linear-gradient(90deg, rgba(15,23,42,0.22), rgba(15,23,42,0.08)), url("${clip.src}")`;
    }
    if (hiddenLeft > 0.001) {
      const left = document.createElement('span');
      left.className = 'timeline-trim-ghost-hidden timeline-trim-ghost-left';
      left.style.width = `${Math.min(100, (hiddenLeft / fullDuration) * 100)}%`;
      ghost.appendChild(left);
    }
    if (hiddenRight > 0.001) {
      const right = document.createElement('span');
      right.className = 'timeline-trim-ghost-hidden timeline-trim-ghost-right';
      right.style.width = `${Math.min(100, (hiddenRight / fullDuration) * 100)}%`;
      ghost.appendChild(right);
    }
    track.appendChild(ghost);
  }

  function renderTimeline() {
    if (!el.timelineList) return;
    closeTimelineContextMenu();
    closeTimelineMarkerMenu();
    closeTimelineTrackMenu();
    clipVisualizerHover = null;
    updateBeatGrid();
    el.timelineList.innerHTML = '';
    if (el.timelineTicks) {
      el.timelineList.appendChild(el.timelineTicks);
    }
    const pageRanges =
      state.pages && state.pages.length ? getPageTimelineRanges() : [];
    const duration = Math.max(
      totalDuration(),
      ...pageRanges.map((range) => range.end),
      1
    );
    const hasClips = state.clips.length > 0;
    const stageTimelineElements = getVisibleTimelineStageElements();
    syncWorkspaceHud();
    if (el.timelinePanel) {
      const empty =
        !hasClips && !state.audioElement && !stageTimelineElements.length;
      el.timelinePanel.classList.toggle('is-empty', empty);
    }
    const pxPerSec = getTimelinePixelsPerSecond();
    const trackWidth = Math.max(
      duration * pxPerSec,
      el.timelineList.clientWidth || 0
    );
    if (state.pages && state.pages.length) {
      const pagesTrack = document.createElement('div');
      pagesTrack.className = 'timeline-pages';
      pagesTrack.style.width = `${trackWidth}px`;
      pagesTrack.style.minWidth = `${trackWidth}px`;
      pageRanges.forEach((range) => {
        const page = range.page;
        const visible =
          page.id === state.activePageId || pageRangeHasContent(range);
        if (!visible) return;
        const left = Math.max(0, range.start * pxPerSec);
        const width = Math.max(
          2,
          Math.min(
            trackWidth - left,
            Math.max(0, range.end - range.start) * pxPerSec
          )
        );
        if (width <= 1) return;
        const pageBlock = document.createElement('div');
        pageBlock.className = 'timeline-page-block';
        if (page.id === state.activePageId) pageBlock.classList.add('active');
        if (!pageRangeHasContent(range)) pageBlock.classList.add('empty');
        pageBlock.style.left = `${left}px`;
        pageBlock.style.width = `${width}px`;
        const label = document.createElement('span');
        label.className = 'timeline-page-label';
        label.textContent = page.name || `Page ${range.index + 1}`;
        pageBlock.appendChild(label);
        pagesTrack.appendChild(pageBlock);
      });
      el.timelineList.appendChild(pagesTrack);
    }
    el.timelineList.classList.toggle('single-lane', false);
    const videoTrackCount = getTimelineVideoTrackCount();
    const audioTrackCount = getTimelineAudioClipTrackCount();
    const lanes = [];
    stageTimelineElements
      .slice()
      .reverse()
      .forEach((element, index) => {
        const layerIndex = Math.max(
          1,
          stageTimelineElements.indexOf(element) + 1
        );
        const labelText = element.name || element.type || `Layer ${layerIndex}`;
        lanes.push({
          key: getStageElementLaneKey(element.id),
          label: `L${layerIndex} ${labelText}`,
          type: 'stage',
          stageElementId: element.id,
          track: index,
          layerIndex,
        });
      });
    for (let i = 0; i < videoTrackCount; i += 1) {
      lanes.push({
        key: `video-${i}`,
        label: i === 0 ? 'Video' : `Video ${i + 1}`,
        type: 'video',
        track: i,
      });
    }
    for (let i = 0; i < audioTrackCount; i += 1) {
      lanes.push({
        key: getAudioClipLaneKey(i),
        label: i === 0 ? 'Audio' : `Audio ${i + 1}`,
        type: 'audio',
        track: i,
      });
    }
    state.audioTracks.forEach(function (at, i) {
      lanes.push({
        key: 'audio-' + at.id,
        label: at.label || 'Audio ' + (i + 2),
        type: 'audio',
        track: i + 1,
        audioTrackId: at.id,
      });
    });
    const laneTracks = {};
    lanes.forEach((lane) => {
      const row = document.createElement('div');
      row.className = 'timeline-lane';
      if (!state.trackHeaders[lane.key]) {
        state.trackHeaders[lane.key] = {
          name: lane.label,
          muted: false,
          soloed: false,
          locked: false,
        };
      }
      var th = state.trackHeaders[lane.key];
      if (lane.type === 'stage') th.name = lane.label;
      const label = document.createElement('div');
      label.className = 'timeline-lane-label';
      if (lane.type === 'stage') row.classList.add('stage-layer');
      if (lane.type === 'stage' && lane.layerIndex) {
        row.dataset.layerIndex = String(lane.layerIndex);
      }
      const audioControlsVisible = laneHasAudio(lane);
      if (th.muted && audioControlsVisible) row.classList.add('track-muted');
      if (th.locked) row.classList.add('track-locked');
      var nameSpan = document.createElement('span');
      nameSpan.className = 'lane-header-name';
      nameSpan.textContent =
        lane.type === 'stage' ? lane.label : th.name || lane.label;
      nameSpan.title =
        lane.type === 'stage' && lane.layerIndex
          ? `Layer ${lane.layerIndex}`
          : 'Double-click to rename';
      nameSpan.addEventListener('dblclick', function () {
        if (lane.type === 'stage') return;
        var v = prompt('Track name', th.name || lane.label);
        if (v !== null) {
          th.name = v;
          nameSpan.textContent = v;
          scheduleAutosave();
        }
      });
      var muteBtn = document.createElement('button');
      muteBtn.type = 'button';
      muteBtn.className = 'lane-header-btn' + (th.muted ? ' active' : '');
      muteBtn.innerHTML = iconSvg(th.muted ? 'mute' : 'volume');
      muteBtn.title = th.muted ? 'Unmute' : 'Mute';
      muteBtn.setAttribute('aria-label', muteBtn.title);
      muteBtn.setAttribute('aria-pressed', th.muted ? 'true' : 'false');
      muteBtn.addEventListener('click', function () {
        th.muted = !th.muted;
        muteBtn.classList.toggle('active', th.muted);
        muteBtn.innerHTML = iconSvg(th.muted ? 'mute' : 'volume');
        muteBtn.title = th.muted ? 'Unmute' : 'Mute';
        muteBtn.setAttribute('aria-label', muteBtn.title);
        muteBtn.setAttribute('aria-pressed', th.muted ? 'true' : 'false');
        row.classList.toggle('track-muted', th.muted);
        if (lane.audioTrackId) {
          var audioTrack = state.audioTracks.find(function (t) {
            return t.id === lane.audioTrackId;
          });
          if (audioTrack) audioTrack.muted = th.muted;
        } else if (lane.type === 'audio' && state.audioElement) {
          state.audioElement.muted = th.muted;
        }
        scheduleAutosave();
      });
      var soloBtn = document.createElement('button');
      soloBtn.type = 'button';
      soloBtn.className = 'lane-header-btn' + (th.soloed ? ' active' : '');
      soloBtn.innerHTML = iconSvg('solo');
      soloBtn.title = 'Solo';
      soloBtn.setAttribute('aria-label', 'Solo');
      soloBtn.setAttribute('aria-pressed', th.soloed ? 'true' : 'false');
      soloBtn.addEventListener('click', function () {
        th.soloed = !th.soloed;
        soloBtn.classList.toggle('active', th.soloed);
        soloBtn.setAttribute('aria-pressed', th.soloed ? 'true' : 'false');
        scheduleAutosave();
      });
      var lockBtn = document.createElement('button');
      lockBtn.type = 'button';
      lockBtn.className = 'lane-header-btn' + (th.locked ? ' active' : '');
      lockBtn.innerHTML = iconSvg(th.locked ? 'lock' : 'unlock');
      lockBtn.title = th.locked ? 'Unlock' : 'Lock';
      lockBtn.setAttribute('aria-label', lockBtn.title);
      lockBtn.setAttribute('aria-pressed', th.locked ? 'true' : 'false');
      lockBtn.addEventListener('click', function () {
        th.locked = !th.locked;
        lockBtn.classList.toggle('active', th.locked);
        lockBtn.innerHTML = iconSvg(th.locked ? 'lock' : 'unlock');
        lockBtn.title = th.locked ? 'Unlock' : 'Lock';
        lockBtn.setAttribute('aria-label', lockBtn.title);
        lockBtn.setAttribute('aria-pressed', th.locked ? 'true' : 'false');
        row.classList.toggle('track-locked', th.locked);
        scheduleAutosave();
      });
      label.appendChild(nameSpan);
      if (lane.type === 'stage') {
        label.title = 'Stage layer';
        label.addEventListener('click', function () {
          selectStageElement(lane.stageElementId);
        });
      } else if (audioControlsVisible) {
        label.appendChild(muteBtn);
        label.appendChild(soloBtn);
      }
      if (lane.type !== 'stage') label.appendChild(lockBtn);
      if (lane.audioTrackId) {
        var loadAudioBtn = document.createElement('button');
        loadAudioBtn.type = 'button';
        loadAudioBtn.className = 'lane-header-btn';
        loadAudioBtn.textContent = '+';
        loadAudioBtn.title = 'Load audio file';
        loadAudioBtn.addEventListener('click', function () {
          var input = document.createElement('input');
          input.type = 'file';
          input.accept = 'audio/*';
          input.addEventListener('change', function () {
            var f = input.files && input.files[0];
            if (!f) return;
            var at = state.audioTracks.find(function (t) {
              return t.id === lane.audioTrackId;
            });
            if (at) loadAudioTrackFile(at, f);
          });
          input.click();
        });
        label.appendChild(loadAudioBtn);
        var removeTrackBtn = document.createElement('button');
        removeTrackBtn.type = 'button';
        removeTrackBtn.className = 'lane-header-btn';
        removeTrackBtn.textContent = 'x';
        removeTrackBtn.title = 'Remove track';
        removeTrackBtn.addEventListener('click', function () {
          removeAudioTrack(lane.audioTrackId);
        });
        label.appendChild(removeTrackBtn);
      }
      const track = document.createElement('div');
      track.className = 'timeline-lane-track';
      track.dataset.lane = lane.key;
      if (lane.type === 'audio') {
        track.classList.add('audio', 'audio-track');
        track.dataset.track = String(lane.track);
      } else if (lane.type === 'stage') {
        track.classList.add('stage-track');
        track.dataset.stageId = lane.stageElementId;
        if (lane.layerIndex) track.dataset.layerIndex = String(lane.layerIndex);
      } else {
        track.classList.add('video-track');
        track.dataset.track = String(lane.track);
      }
      track.style.width = `${trackWidth}px`;
      track.style.minWidth = `${trackWidth}px`;
      row.appendChild(label);
      row.appendChild(track);
      el.timelineList.appendChild(row);
      laneTracks[lane.key] = track;
    });
    if (el.timelinePlayhead) {
      el.timelineList.appendChild(el.timelinePlayhead);
    }
    const selectedSet = new Set(state.selectedClipIds || []);
    const selectedStageSet = new Set(state.selectedStageElementIds || []);
    stageTimelineElements.forEach((element) => {
      const targetTrack = laneTracks[getStageElementLaneKey(element.id)];
      if (!targetTrack) return;
      const layerIndex = Math.max(
        1,
        stageTimelineElements.indexOf(element) + 1
      );
      ensureStageElementTiming(element);
      const stageTiming = getStageElementTiming(element);
      const stageLeft = Math.max(0, stageTiming.start * pxPerSec);
      const stageWidth = Math.max(48, stageTiming.duration * pxPerSec);
      const div = document.createElement('div');
      div.className = 'timeline-stage-clip';
      if (element.type) div.classList.add(element.type);
      if (element.hidden) div.classList.add('hidden');
      if (element.locked) div.classList.add('locked');
      if (selectedStageSet.has(element.id)) div.classList.add('selected');
      if (element.id === state.selectedStageElementId)
        div.classList.add('active');
      div.setAttribute('data-stage-id', element.id);
      div.setAttribute('data-layer-index', String(layerIndex));
      div.tabIndex = 0;
      div.style.left = `${stageLeft}px`;
      div.style.width = `${stageWidth}px`;
      const title = document.createElement('strong');
      title.className = 'clip-title';
      title.textContent = element.name || element.type || `Layer ${layerIndex}`;
      const meta = document.createElement('small');
      meta.className = 'clip-meta';
      meta.textContent =
        element.type === 'shape'
          ? `L${layerIndex} · ${element.shapeKind || 'shape'}`
          : `L${layerIndex} · ${element.type || 'stage'}`;
      div.title = `${title.textContent} · Layer ${layerIndex} · ${stageTiming.duration.toFixed(1)}s`;
      div.appendChild(title);
      div.appendChild(meta);
      const leftHandle = document.createElement('div');
      leftHandle.className = 'clip-handle clip-handle-left';
      leftHandle.setAttribute('data-stage-id', element.id);
      leftHandle.setAttribute('data-handle', 'left');
      leftHandle.setAttribute('draggable', 'false');
      const rightHandle = document.createElement('div');
      rightHandle.className = 'clip-handle clip-handle-right';
      rightHandle.setAttribute('data-stage-id', element.id);
      rightHandle.setAttribute('data-handle', 'right');
      rightHandle.setAttribute('draggable', 'false');
      div.appendChild(leftHandle);
      div.appendChild(rightHandle);
      div.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        selectStageElement(element.id, {
          toggle: event.shiftKey || event.metaKey || event.ctrlKey,
        });
        if (
          state.playhead < stageTiming.start - TIMELINE_GAP_EPS ||
          state.playhead > stageTiming.end + TIMELINE_GAP_EPS
        ) {
          seekTimelinePlayhead(stageTiming.start, { autoscroll: false });
        }
      });
      div.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        selectStageElement(element.id);
      });
      targetTrack.appendChild(div);
    });
    state.clips.forEach((clip, index) => {
      const div = document.createElement('div');
      div.className = 'timeline-clip';
      div.setAttribute('draggable', 'false');
      if (clip.type === 'video') {
        div.classList.add('video');
      } else if (clip.type === 'caption') {
        div.classList.add('caption');
      } else if (clip.type === 'audio') {
        div.classList.add('audio');
      }
      if (selectedSet.has(clip.id)) {
        div.classList.add('selected');
      }
      if (clip.id === state.selectedClipId) {
        div.classList.add('active');
      }
      const transitionIn = clip.transitionIn || clip.transition || 'none';
      const transitionOut = clip.transitionOut || clip.transition || 'none';
      if (transitionIn !== 'none' || transitionOut !== 'none') {
        div.classList.add('has-transition');
      }
      if ((clip.speed || 1) < 0) {
        div.classList.add('reversed');
      }
      const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
      const start = Number.isFinite(clip.start) ? clip.start : 0;
      div.style.left = `${Math.max(0, start * pxPerSec)}px`;
      div.style.width = `${Math.max(48, duration * pxPerSec)}px`;
      div.setAttribute('data-clip-id', clip.id);
      div.setAttribute('data-track', String(getClipTrack(clip)));
      const title = document.createElement('strong');
      title.className = 'clip-title';
      title.textContent =
        clip.type === 'caption' ? clip.text || clip.name : clip.name;
      const meta = document.createElement('small');
      meta.className = 'clip-meta';
      meta.textContent =
        clip.type === 'caption'
          ? `CC · ${clip.duration.toFixed(1)}s`
          : clip.duration.toFixed(1) + 's';
      div.title = `${clip.type === 'caption' ? clip.text || clip.name : clip.name} · ${clip.duration.toFixed(1)}s`;
      const thumb = document.createElement('div');
      thumb.className = 'clip-thumb';
      if (clip.type === 'caption') {
        thumb.textContent = 'CC';
      } else if (clip.src) {
        thumb.style.backgroundImage = `url("${clip.src}")`;
      }
      const visual = document.createElement('div');
      visual.className = 'clip-visualizer';
      const visualUrl = buildClipVisualizer(clip);
      if (visualUrl) {
        visual.style.backgroundImage = `url("${visualUrl}")`;
      }
      if (clip.audioMute) visual.classList.add('muted');
      if (clip.audioSolo) visual.classList.add('solo');
      const visualPlayhead = document.createElement('div');
      visualPlayhead.className = 'clip-visualizer-playhead';
      if (clip.duration > 0) {
        const local = state.playhead - clip.start;
        if (local >= 0 && local <= clip.duration) {
          const ratio = Math.max(0, Math.min(1, local / clip.duration));
          visualPlayhead.style.left = `${(ratio * 100).toFixed(2)}%`;
          visualPlayhead.style.opacity = '1';
        } else {
          visualPlayhead.style.opacity = '0';
        }
      } else {
        visualPlayhead.style.opacity = '0';
      }
      visual.appendChild(visualPlayhead);
      const visualTooltip = document.createElement('div');
      visualTooltip.className = 'clip-visualizer-tooltip';
      visual.appendChild(visualTooltip);
      const hasClipAudio = clipHasAudio(clip);
      const controls = document.createElement('div');
      controls.className = 'clip-controls';
      const left = document.createElement('button');
      left.type = 'button';
      left.title = 'Move left';
      left.setAttribute('aria-label', 'Move left');
      left.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M14 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      left.setAttribute('data-action', 'move-left');
      left.setAttribute('data-clip-id', clip.id);
      const right = document.createElement('button');
      right.type = 'button';
      right.title = 'Move right';
      right.setAttribute('aria-label', 'Move right');
      right.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M10 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      right.setAttribute('data-action', 'move-right');
      right.setAttribute('data-clip-id', clip.id);
      const mute = document.createElement('button');
      mute.type = 'button';
      mute.title = clip.audioMute ? 'Unmute' : 'Mute';
      mute.setAttribute('aria-label', mute.title);
      mute.setAttribute('aria-pressed', clip.audioMute ? 'true' : 'false');
      mute.innerHTML = iconSvg(clip.audioMute ? 'mute' : 'volume');
      mute.setAttribute('data-action', 'toggle-mute');
      mute.setAttribute('data-clip-id', clip.id);
      if (clip.audioMute) mute.classList.add('active');
      const solo = document.createElement('button');
      solo.type = 'button';
      solo.title = clip.audioSolo ? 'Unsolo' : 'Solo';
      solo.setAttribute('aria-label', solo.title);
      solo.setAttribute('aria-pressed', clip.audioSolo ? 'true' : 'false');
      solo.innerHTML = iconSvg('solo');
      solo.setAttribute('data-action', 'toggle-solo');
      solo.setAttribute('data-clip-id', clip.id);
      if (clip.audioSolo) solo.classList.add('active');
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.title = 'Remove';
      remove.setAttribute('aria-label', 'Remove');
      remove.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>`;
      remove.setAttribute('data-action', 'remove');
      remove.setAttribute('data-clip-id', clip.id);
      controls.appendChild(left);
      controls.appendChild(right);
      if (hasClipAudio) {
        controls.appendChild(mute);
        controls.appendChild(solo);
      }
      controls.appendChild(remove);
      div.appendChild(title);
      div.appendChild(meta);
      div.appendChild(thumb);
      if (hasClipAudio) {
        div.appendChild(visual);
      }
      if (transitionIn !== 'none' || transitionOut !== 'none') {
        const transitionBadge = document.createElement('div');
        transitionBadge.className = 'clip-transition-badge';
        const icon = document.createElement('span');
        icon.textContent = '↔';
        const durationLabel =
          typeof clip.transitionDuration === 'number'
            ? clip.transitionDuration.toFixed(1)
            : '0.6';
        const durationText = document.createElement('span');
        durationText.className = 'clip-transition-duration';
        const dirLabel =
          transitionIn !== 'none' && transitionOut !== 'none'
            ? 'In/Out'
            : transitionIn !== 'none'
              ? 'In'
              : 'Out';
        durationText.textContent = `${dirLabel} ${durationLabel}s`;
        transitionBadge.appendChild(icon);
        transitionBadge.appendChild(durationText);
        const easeLabel =
          clip.transitionEase && clip.transitionEase !== 'linear'
            ? clip.transitionEase.replace(/-/g, ' ')
            : '';
        if (easeLabel) {
          const easeText = document.createElement('span');
          easeText.className = 'clip-transition-ease';
          easeText.textContent =
            easeLabel === 'ease in'
              ? 'in'
              : easeLabel === 'ease out'
                ? 'out'
                : 'in‑out';
          const easeClass = clip.transitionEase
            ? clip.transitionEase.replace(/[^a-z]+/g, '-')
            : 'linear';
          easeText.classList.add(`clip-transition-ease-${easeClass}`);
          transitionBadge.appendChild(easeText);
        }
        transitionBadge.title = `${transitionIn !== 'none' ? transitionIn : 'none'} / ${transitionOut !== 'none' ? transitionOut : 'none'} · ${durationLabel}s${easeLabel ? ` · ${easeLabel}` : ''}`;
        div.appendChild(transitionBadge);
      } else {
        const noneBadge = document.createElement('div');
        noneBadge.className = 'clip-transition-badge clip-transition-none';
        noneBadge.textContent = '—';
        noneBadge.title = 'No transition';
        div.appendChild(noneBadge);
      }
      div.appendChild(controls);
      const audioBar = document.createElement('div');
      audioBar.className = 'clip-audio-bar';
      const gradient = buildClipAudioGradient(clip);
      if (gradient) {
        audioBar.style.backgroundImage = gradient;
      }
      if (clip.audioMute) audioBar.classList.add('muted');
      if (clip.audioSolo) audioBar.classList.add('solo');
      if (hasClipAudio) {
        div.appendChild(audioBar);
      }
      const leftHandle = document.createElement('div');
      leftHandle.className = 'clip-handle clip-handle-left';
      leftHandle.setAttribute('data-clip-id', clip.id);
      leftHandle.setAttribute('data-handle', 'left');
      leftHandle.setAttribute('draggable', 'false');
      const rightHandle = document.createElement('div');
      rightHandle.className = 'clip-handle clip-handle-right';
      rightHandle.setAttribute('data-clip-id', clip.id);
      rightHandle.setAttribute('data-handle', 'right');
      rightHandle.setAttribute('draggable', 'false');
      div.appendChild(leftHandle);
      div.appendChild(rightHandle);
      const laneKey =
        clip.type === 'audio'
          ? getAudioClipLaneKey(getClipTrack(clip))
          : `video-${getClipTrack(clip)}`;
      const targetTrack =
        laneTracks[laneKey] || laneTracks.video || el.timelineList;
      appendTimelineTrimGhost(targetTrack, clip, pxPerSec);
      targetTrack.appendChild(div);
    });
    if (laneTracks[getAudioClipLaneKey(0)] && state.audioElement) {
      const audioBar = document.createElement('div');
      audioBar.className = 'timeline-audio-clip';
      const label =
        state.audioLabel || state.audioFile?.name || 'Background Audio';
      audioBar.textContent = label;
      audioBar.title = label;
      laneTracks[getAudioClipLaneKey(0)].appendChild(audioBar);
    }
    updateTimelineSelectionBar();
    updateTimelinePlayhead();
    renderTimelineRuler();
    renderTimelineTicks();
    updateTimelineGapSummary();
    renderTimelineMarkerList();
    renderCaptionPanel();
  }

  function renderTimelineRuler() {
    if (!el.timelineRulerTrack || !el.timelineList) return;
    const duration = Math.max(totalDuration(), 60);
    const pxPerSec = getTimelinePixelsPerSecond();
    timelineRulerPxPerSec = pxPerSec;
    const trackOffset = getTimelineTrackOffset();
    if (el.timelineRuler) {
      el.timelineRuler.style.marginLeft = '';
      el.timelineRuler.style.width = '';
    }
    const trackWidth = Math.max(
      duration * pxPerSec,
      el.timelineList.clientWidth || 0
    );
    const tickScale = chooseTimelineTickScale(pxPerSec);
    const rulerKey = `${trackOffset.toFixed(1)}|${trackWidth.toFixed(1)}|${pxPerSec.toFixed(3)}|${tickScale.minorStep}|${duration.toFixed(2)}`;
    if (rulerKey === lastTimelineRulerKey) return;
    lastTimelineRulerKey = rulerKey;
    el.timelineRulerTrack.style.width = `${trackOffset + trackWidth}px`;
    el.timelineRulerTrack.innerHTML = '';
    timelineRulerStep = tickScale.minorStep;
    el.timelineList.style.setProperty(
      '--tl-grid-size',
      `${Math.max(8, tickScale.minorStep * pxPerSec)}px`
    );
    const listPadLeft =
      parseFloat(getComputedStyle(el.timelineList).paddingLeft) || 0;
    el.timelineList.style.setProperty(
      '--tl-grid-offset',
      `${trackOffset - listPadLeft}px`
    );
    const tickCount = Math.ceil(duration / tickScale.minorStep);
    for (let i = 0; i <= tickCount; i += 1) {
      const t = Number((i * tickScale.minorStep).toFixed(3));
      const tick = document.createElement('div');
      tick.className = 'timeline-ruler-tick';
      tick.dataset.time = timelineTickKey(t);
      tick.style.left = `${trackOffset + t * pxPerSec}px`;
      el.timelineRulerTrack.appendChild(tick);
      const labelRatio = t / tickScale.labelStep;
      if (Math.abs(labelRatio - Math.round(labelRatio)) < 0.001) {
        const label = document.createElement('span');
        label.className = 'timeline-ruler-label';
        label.dataset.time = timelineTickKey(t);
        label.textContent = formatTimelineRulerLabel(t);
        label.style.left = `${trackOffset + t * pxPerSec}px`;
        el.timelineRulerTrack.appendChild(label);
      }
    }
    if (!el.timelineRulerHover) {
      const hover = document.createElement('div');
      hover.id = 'timeline-ruler-hover';
      hover.className = 'timeline-ruler-hover';
      hover.style.display = 'none';
      const text = document.createElement('span');
      text.id = 'timeline-ruler-hover-text';
      text.className = 'timeline-ruler-hover-text';
      hover.appendChild(text);
      el.timelineRulerTrack.appendChild(hover);
      el.timelineRulerHover = hover;
      el.timelineRulerHoverText = text;
    } else {
      el.timelineRulerTrack.appendChild(el.timelineRulerHover);
    }
    if (!el.timelineRulerHoverLine) {
      const line = document.createElement('div');
      line.id = 'timeline-ruler-hover-line';
      line.className = 'timeline-ruler-hover-line';
      line.style.display = 'none';
      el.timelineRulerTrack.appendChild(line);
      el.timelineRulerHoverLine = line;
    } else {
      el.timelineRulerTrack.appendChild(el.timelineRulerHoverLine);
    }
  }

  function normalizeTimelineMarkers(list) {
    if (!Array.isArray(list)) return [];
    const markers = [];
    list.forEach((item) => {
      if (typeof item === 'number' && Number.isFinite(item)) {
        markers.push({ time: Math.max(0, item), label: '' });
        return;
      }
      if (!item || typeof item !== 'object') return;
      const time =
        typeof item.time === 'number' && Number.isFinite(item.time)
          ? item.time
          : null;
      if (time === null) return;
      const label = typeof item.label === 'string' ? item.label : '';
      markers.push({ time: Math.max(0, time), label });
    });
    markers.sort((a, b) => a.time - b.time);
    return markers;
  }

  function renderTimelineTicks() {
    if (!el.timelineTicks || !el.timelineList) return;
    const duration = Math.max(totalDuration(), 60);
    const pxPerSec = getTimelinePixelsPerSecond();
    const trackWidth = Math.max(
      duration * pxPerSec,
      el.timelineList.clientWidth || 0
    );
    const trackOffset = getTimelineTrackOffset();
    el.timelineTicks.style.width = `${trackOffset + trackWidth}px`;
    el.timelineTicks.innerHTML = '';
    const tickScale = chooseTimelineTickScale(pxPerSec);
    const tickCount = Math.ceil(duration / tickScale.minorStep);
    for (let i = 0; i <= tickCount; i += 1) {
      const t = Number((i * tickScale.minorStep).toFixed(3));
      const tick = document.createElement('div');
      tick.className = 'timeline-tick';
      tick.dataset.time = timelineTickKey(t);
      tick.style.left = `${trackOffset + t * pxPerSec}px`;
      el.timelineTicks.appendChild(tick);
      const labelRatio = t / tickScale.labelStep;
      if (Math.abs(labelRatio - Math.round(labelRatio)) < 0.001) {
        const label = document.createElement('span');
        label.className = 'timeline-tick-label';
        label.dataset.time = timelineTickKey(t);
        label.textContent = formatTimelineRulerLabel(t);
        label.style.left = `${trackOffset + t * pxPerSec}px`;
        el.timelineTicks.appendChild(label);
      }
    }
    if (Array.isArray(state.timelineMarkers) && state.timelineMarkers.length) {
      state.timelineMarkers = normalizeTimelineMarkers(state.timelineMarkers);
      state.timelineMarkers.forEach((markerInfo, index) => {
        const marker = document.createElement('div');
        marker.className = 'timeline-marker';
        marker.style.left = `${trackOffset + markerInfo.time * pxPerSec}px`;
        marker.dataset.markerIndex = String(index);
        marker.title = markerInfo.label
          ? `${markerInfo.label} • ${markerInfo.time.toFixed(2)}s`
          : `${markerInfo.time.toFixed(2)}s`;
        marker.addEventListener('contextmenu', (event) => {
          event.preventDefault();
          event.stopPropagation();
          openTimelineMarkerMenu(event.clientX, event.clientY, index);
        });
        let markerLongPressTimer = null;
        let markerLongPressStart = null;
        const clearMarkerLongPress = () => {
          if (markerLongPressTimer) {
            clearTimeout(markerLongPressTimer);
            markerLongPressTimer = null;
          }
          markerLongPressStart = null;
        };
        marker.addEventListener(
          'touchstart',
          (event) => {
            if (!event.touches || event.touches.length !== 1) return;
            event.stopPropagation();
            clearTimelineLongPress();
            const touch = event.touches[0];
            markerLongPressStart = { x: touch.clientX, y: touch.clientY };
            markerLongPressTimer = window.setTimeout(() => {
              markerLongPressTimer = null;
              if (!markerLongPressStart) return;
              fireHaptic();
              openTimelineMarkerMenu(
                markerLongPressStart.x,
                markerLongPressStart.y,
                index,
                true
              );
              markerLongPressStart = null;
            }, TIMELINE_LONG_PRESS_DELAY_MS);
          },
          { passive: true }
        );
        marker.addEventListener(
          'touchmove',
          (event) => {
            if (
              !markerLongPressStart ||
              !event.touches ||
              !event.touches.length
            )
              return;
            const touch = event.touches[0];
            if (
              Math.abs(touch.clientX - markerLongPressStart.x) >
                TIMELINE_LONG_PRESS_MOVE_THRESHOLD ||
              Math.abs(touch.clientY - markerLongPressStart.y) >
                TIMELINE_LONG_PRESS_MOVE_THRESHOLD
            ) {
              clearMarkerLongPress();
            }
          },
          { passive: true }
        );
        marker.addEventListener('touchend', clearMarkerLongPress);
        marker.addEventListener('touchcancel', clearMarkerLongPress);
        marker.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const markers = normalizeTimelineMarkers(state.timelineMarkers);
          const markerIndex = parseInt(marker.dataset.markerIndex, 10);
          const target = markers[markerIndex];
          if (!target) return;
          if (event.altKey || event.shiftKey) {
            markers.splice(markerIndex, 1);
            state.timelineMarkers = markers;
            renderTimeline();
            scheduleAutosave();
            return;
          }
          const nextLabel = window.prompt(
            'Marker label (leave blank to delete)',
            target.label || ''
          );
          if (nextLabel === null) return;
          const trimmed = nextLabel.trim();
          if (!trimmed) {
            markers.splice(markerIndex, 1);
          } else {
            target.label = trimmed;
          }
          state.timelineMarkers = markers;
          renderTimeline();
          scheduleAutosave();
        });
        el.timelineTicks.appendChild(marker);
      });
    }
  }

  function renderTimelineMarkerList() {
    if (!el.timelineMarkerList) return;
    const markers = normalizeTimelineMarkers(state.timelineMarkers);
    el.timelineMarkerList.innerHTML = '';
    if (timelineMarkerListFocusIndex != null) {
      if (timelineMarkerListFocusIndex >= markers.length) {
        timelineMarkerListFocusIndex = markers.length
          ? markers.length - 1
          : null;
      }
      if (timelineMarkerListFocusIndex < 0) {
        timelineMarkerListFocusIndex = null;
      }
    }
    if (!markers.length) {
      const empty = document.createElement('div');
      empty.className = 'timeline-marker-empty';
      empty.textContent = 'No markers yet.';
      el.timelineMarkerList.appendChild(empty);
      return;
    }
    markers.forEach((marker, index) => {
      const row = document.createElement('div');
      row.className = 'timeline-marker-row';
      row.dataset.markerIndex = String(index);
      if (timelineMarkerListFocusIndex === index) {
        row.classList.add('is-active');
      }
      row.addEventListener('contextmenu', (event) => {
        if (event.target.closest('input')) return;
        event.preventDefault();
        event.stopPropagation();
        openTimelineMarkerMenu(event.clientX, event.clientY, index);
      });
      let rowLongPressTimer = null;
      let rowLongPressStart = null;
      const clearRowLongPress = () => {
        if (rowLongPressTimer) {
          clearTimeout(rowLongPressTimer);
          rowLongPressTimer = null;
        }
        rowLongPressStart = null;
      };
      row.addEventListener(
        'touchstart',
        (event) => {
          if (
            event.target.closest('input') ||
            !event.touches ||
            event.touches.length !== 1
          )
            return;
          const touch = event.touches[0];
          rowLongPressStart = { x: touch.clientX, y: touch.clientY };
          rowLongPressTimer = window.setTimeout(() => {
            rowLongPressTimer = null;
            if (!rowLongPressStart) return;
            fireHaptic();
            openTimelineMarkerMenu(
              rowLongPressStart.x,
              rowLongPressStart.y,
              index,
              true
            );
            rowLongPressStart = null;
          }, TIMELINE_LONG_PRESS_DELAY_MS);
        },
        { passive: true }
      );
      row.addEventListener(
        'touchmove',
        (event) => {
          if (!rowLongPressStart || !event.touches || !event.touches.length)
            return;
          const touch = event.touches[0];
          if (
            Math.abs(touch.clientX - rowLongPressStart.x) >
              TIMELINE_LONG_PRESS_MOVE_THRESHOLD ||
            Math.abs(touch.clientY - rowLongPressStart.y) >
              TIMELINE_LONG_PRESS_MOVE_THRESHOLD
          ) {
            clearRowLongPress();
          }
        },
        { passive: true }
      );
      row.addEventListener('touchend', clearRowLongPress);
      row.addEventListener('touchcancel', clearRowLongPress);
      row.addEventListener('click', (event) => {
        if (event.target.closest('button, input')) return;
        timelineMarkerListFocusIndex = index;
        renderTimelineMarkerList();
      });
      const time = document.createElement('div');
      time.className = 'timeline-marker-time';
      time.textContent = `${marker.time.toFixed(2)}s`;
      const jump = document.createElement('button');
      jump.type = 'button';
      jump.className = 'timeline-marker-jump';
      jump.textContent = '→';
      jump.title = 'Jump to marker';
      jump.setAttribute('aria-label', 'Jump to marker');
      jump.addEventListener('click', () => {
        timelineMarkerListFocusIndex = index;
        state.playhead = Math.max(0, marker.time);
        renderFrameAt(state.playhead);
        updateTimeLabel();
        renderTimelineMarkerList();
      });
      const input = document.createElement('input');
      input.type = 'text';
      input.value = marker.label || '';
      input.placeholder = 'Label';
      input.addEventListener('focus', () => {
        timelineMarkerListFocusIndex = index;
        renderTimelineMarkerList();
      });
      input.addEventListener('change', () => {
        const nextMarkers = normalizeTimelineMarkers(state.timelineMarkers);
        const target = nextMarkers[index];
        if (!target) return;
        const trimmed = input.value.trim();
        if (!trimmed) {
          nextMarkers.splice(index, 1);
        } else {
          target.label = trimmed;
        }
        state.timelineMarkers = nextMarkers;
        renderTimeline();
        scheduleAutosave();
      });
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'timeline-marker-remove';
      remove.textContent = '×';
      remove.title = 'Delete marker';
      remove.setAttribute('aria-label', 'Delete marker');
      remove.addEventListener('click', () => {
        const nextMarkers = normalizeTimelineMarkers(state.timelineMarkers);
        nextMarkers.splice(index, 1);
        state.timelineMarkers = nextMarkers;
        renderTimeline();
        scheduleAutosave();
      });
      row.appendChild(time);
      row.appendChild(jump);
      row.appendChild(input);
      row.appendChild(remove);
      el.timelineMarkerList.appendChild(row);
    });
  }

  function getTimelinePixelsPerSecond() {
    return Math.max(TIMELINE_ZOOM_MIN, state.timelineScale || 80);
  }

  function clampTimelineZoom(value) {
    let next = Math.round(Number(value) || 80);
    next = Math.max(TIMELINE_ZOOM_MIN, Math.min(TIMELINE_ZOOM_MAX, next));
    const snapped = TIMELINE_ZOOM_SNAP_POINTS.find(
      (point) => Math.abs(point - next) <= TIMELINE_ZOOM_SNAP_THRESHOLD
    );
    return snapped != null ? snapped : next;
  }

  function setTimelineZoom(value, anchorClientX) {
    const previous = getTimelinePixelsPerSecond();
    const next = clampTimelineZoom(value);
    if (next === state.timelineScale) return;
    let anchorTime = null;
    let anchorOffset = 0;
    if (el.timelineList && Number.isFinite(anchorClientX)) {
      const rect = el.timelineList.getBoundingClientRect();
      anchorOffset = Math.max(0, anchorClientX - rect.left);
      anchorTime = (anchorOffset + el.timelineList.scrollLeft) / previous;
    }
    state.timelineScale = next;
    if (el.timelineZoom) {
      el.timelineZoom.value = String(next);
    }
    renderTimeline();
    updateWaveformScale();
    if (el.timelineList && anchorTime !== null) {
      el.timelineList.scrollLeft = Math.max(
        0,
        anchorTime * next - anchorOffset
      );
      if (el.timelineRuler)
        el.timelineRuler.scrollLeft = el.timelineList.scrollLeft;
    }
    scheduleAutosave();
  }

  function timelineTickKey(value) {
    return String(Number((Number(value) || 0).toFixed(3)));
  }

  function chooseTimelineTickScale(pxPerSec) {
    const minorIntervals = [
      0.1, 0.2, 0.5, 1, 2, 5, 10, 15, 30, 60, 120, 300, 600,
    ];
    const minorStep =
      minorIntervals.find((step) => step * pxPerSec >= 34) ||
      minorIntervals[minorIntervals.length - 1];
    const labelStep =
      minorIntervals.find(
        (step) => step >= minorStep && step * pxPerSec >= 82
      ) || minorStep;
    return { minorStep, labelStep };
  }

  function formatTimelineRulerLabel(time) {
    if (Math.abs(time) < 0.001) return '0s';
    if (time < 1) return `${time.toFixed(1)}s`;
    if (time < 60) return `${formatTimelineTimeValue(time, time % 1 ? 1 : 0)}s`;
    const minutes = Math.floor(time / 60);
    const seconds = Math.round(time % 60);
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }

  function clearWaveform() {
    if (!el.timelineWaveform) return;
    const ctx = el.timelineWaveform.getContext('2d');
    ctx.clearRect(0, 0, el.timelineWaveform.width, el.timelineWaveform.height);
    ctx.fillStyle = '#0f172a';
    ctx.fillRect(0, 0, el.timelineWaveform.width, el.timelineWaveform.height);
    state.waveform = { peaks: [], duration: 0 };
  }

  function drawWaveformPeaks(peaks, duration) {
    if (!el.timelineWaveform) return;
    const canvas = el.timelineWaveform;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = '#0f172a';
    ctx.fillRect(0, 0, width, height);
    if (!peaks || peaks.length === 0) return;
    const total = Math.min(duration || 0, totalDuration());
    const pixelsPerSec = total > 0 ? state.timelineScale : 1;
    const targetWidth = Math.max(width, Math.ceil(total * pixelsPerSec));
    if (targetWidth !== width) {
      canvas.width = targetWidth;
    }
    const drawWidth = canvas.width;
    const samples = Math.min(peaks.length, drawWidth);
    const step = Math.max(1, Math.floor(peaks.length / samples));
    const center = height / 2;
    const values = [];
    let maxPeak = 0;
    ctx.strokeStyle = '#38bdf8';
    ctx.lineWidth = 1;
    ctx.beginPath();
    for (let i = 0; i < samples; i += 1) {
      const peak = peaks[i * step] || 0;
      values.push(peak);
      if (peak > maxPeak) maxPeak = peak;
      const amp = peak * (height * 0.45);
      const x = i;
      ctx.moveTo(x, center - amp);
      ctx.lineTo(x, center + amp);
    }
    ctx.stroke();
    if (state.showBeatHighlights && maxPeak > 0) {
      const ratio = Math.max(
        0.4,
        Math.min(0.9, state.beatHighlightThreshold || 0.7)
      );
      const threshold = Math.max(0.25, maxPeak * ratio);
      const minGap = 6;
      let lastX = -minGap;
      let confidence = 0.6;
      if (
        typeof state.bpmConfidence === 'number' &&
        Number.isFinite(state.bpmConfidence)
      ) {
        confidence = Math.max(0, Math.min(1, state.bpmConfidence));
      }
      const alpha = 0.2 + confidence * 0.5;
      ctx.strokeStyle = `rgba(56,189,248,${alpha.toFixed(2)})`;
      ctx.lineWidth = 2;
      for (let i = 0; i < values.length; i += 1) {
        const peak = values[i];
        if (peak < threshold) continue;
        const x = i;
        if (x - lastX < minGap) continue;
        lastX = x;
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height);
        ctx.stroke();
      }
    }
    if (duration && duration > 0) {
      const beat = state.bpm ? 60 / state.bpm : 0;
      if (beat > 0) {
        const totalDur = Math.min(duration, totalDuration());
        const pixelsPerSec = drawWidth / Math.max(totalDur, 0.1);
        ctx.strokeStyle = 'rgba(255,255,255,0.15)';
        ctx.lineWidth = 1;
        for (let t = beat; t < totalDur; t += beat) {
          const x = t * pixelsPerSec;
          ctx.beginPath();
          ctx.moveTo(x, 0);
          ctx.lineTo(x, height);
          ctx.stroke();
        }
      }
    }
    updateWaveformPlayhead();
  }

  async function decodeAudioToPeaks(arrayBuffer) {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const audioBuffer = await ctx.decodeAudioData(arrayBuffer);
    const channelData = audioBuffer.getChannelData(0);
    const samples = 2048;
    const peaks = [];
    for (let i = 0; i < channelData.length; i += samples) {
      let max = 0;
      const end = Math.min(channelData.length, i + samples);
      for (let j = i; j < end; j += 1) {
        const val = Math.abs(channelData[j]);
        if (val > max) max = val;
      }
      peaks.push(max);
    }
    ctx.close();
    return { peaks, duration: audioBuffer.duration };
  }

  const AUDIO_PEAKS_MAX_BYTES = 128 * 1024 * 1024;

  function scheduleIdleWork(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
      window.setTimeout(fn, 400);
    }
  }

  function queueAssetAudioPeaks(asset, file) {
    if (!asset || asset.type !== 'video') return;
    if (asset.audioPeaksPending || asset.audioPeaks) return;
    if (file && file.size > AUDIO_PEAKS_MAX_BYTES) return;
    asset.audioPeaksPending = true;
    const apply = (peaks, duration) => {
      if (!Array.isArray(peaks) || !peaks.length) {
        asset.audioPeaksPending = false;
        return;
      }
      asset.audioPeaks = peaks;
      asset.audioPeaksDuration = duration;
      state.clips.forEach((clip) => {
        if (clip.assetId === asset.id || clip.src === asset.src) {
          clip.audioPeaks = peaks;
          clip.audioPeaksDuration = duration;
        }
      });
      asset.audioPeaksPending = false;
      renderTimeline();
    };
    const fail = () => {
      asset.audioPeaksPending = false;
    };
    const run = () => {
      if (file) {
        const reader = new FileReader();
        reader.onload = async () => {
          try {
            const { peaks, duration } = await decodeAudioToPeaks(reader.result);
            apply(peaks, duration);
          } catch {
            fail();
          }
        };
        reader.onerror = fail;
        reader.readAsArrayBuffer(file);
        return;
      }
      if (!asset.src) {
        fail();
        return;
      }
      fetch(editorMediaSrc(asset.src))
        .then((resp) => {
          if (!resp.ok) return null;
          const len = Number(resp.headers.get('content-length') || 0);
          if (len && len > AUDIO_PEAKS_MAX_BYTES) return null;
          return resp.arrayBuffer();
        })
        .then(async (buffer) => {
          if (!buffer) {
            fail();
            return;
          }
          try {
            const { peaks, duration } = await decodeAudioToPeaks(buffer);
            apply(peaks, duration);
          } catch {
            fail();
          }
        })
        .catch(fail);
    };
    scheduleIdleWork(run);
  }

  function drawWaveformFromAudioFile(file) {
    if (!file) {
      clearWaveform();
      return;
    }
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const { peaks, duration } = await decodeAudioToPeaks(reader.result);
        state.waveform = { peaks, duration };
        drawWaveformPeaks(peaks, duration);
      } catch (err) {
        clearWaveform();
      }
    };
    reader.readAsArrayBuffer(file);
  }

  async function drawWaveformFromUrl(url) {
    if (!url || url.startsWith('blob:')) {
      clearWaveform();
      return;
    }
    try {
      const resp = await fetch(editorMediaSrc(url));
      if (!resp.ok) {
        clearWaveform();
        return;
      }
      const buffer = await resp.arrayBuffer();
      const { peaks, duration } = await decodeAudioToPeaks(buffer);
      state.waveform = { peaks, duration };
      drawWaveformPeaks(peaks, duration);
    } catch (err) {
      clearWaveform();
    }
  }

  function scrubFromWaveformEvent(event) {
    if (!el.timelineWaveform) return;
    const duration = totalDuration();
    if (duration <= 0) return;
    const canvas = el.timelineWaveform.querySelector('canvas');
    if (!canvas) return;
    const rect = el.timelineWaveform.getBoundingClientRect();
    const x = event.clientX - rect.left + el.timelineWaveform.scrollLeft;
    const width = canvas.width || 1;
    const ratio = Math.min(1, Math.max(0, x / width));
    let time = ratio * duration;
    let snapped = false;
    let snapTime = 0;
    if (state.snapToBeat) {
      const snappedTime = Math.max(0, snapToBeat(time));
      snapped = Math.abs(snappedTime - time) > 0.001;
      time = snappedTime;
      snapTime = snappedTime;
    }
    state.playhead = time;
    if (state.audioElement) {
      state.audioElement.currentTime = time;
    }
    renderFrameAt(time);
    updateTimeLabel();
    if (el.timelineSnapline) {
      if (snapped) {
        const snapX = Math.min(
          width,
          Math.max(0, (snapTime / duration) * width)
        );
        el.timelineSnapline.style.left = `${snapX}px`;
        el.timelineSnapline.style.opacity = '1';
      } else {
        el.timelineSnapline.style.opacity = '0';
      }
    }
  }

  function startWaveformScrub(event) {
    waveformDragging = true;
    scrubFromWaveformEvent(event);
  }

  function moveWaveformScrub(event) {
    if (!waveformDragging) return;
    scrubFromWaveformEvent(event);
  }

  function endWaveformScrub() {
    waveformDragging = false;
    if (el.timelineSnapline) {
      el.timelineSnapline.style.opacity = '0';
    }
  }

  function clearTimelineDragStates() {
    if (!el.timelineList) return;
    el.timelineList.querySelectorAll('.timeline-clip').forEach((clipEl) => {
      clipEl.classList.remove('drag-over');
      clipEl.classList.remove('dragging');
      clipEl.style.transform = '';
    });
    el.timelineList
      .querySelectorAll('.timeline-lane-track')
      .forEach((trackEl) => {
        trackEl.classList.remove('drag-over');
      });
    if (el.timelineSnapline && !waveformDragging) {
      el.timelineSnapline.style.opacity = '0';
    }
  }

  function updateTimelineClipDragPreview(event, ids, point) {
    if (!el.timelineList || !timelineClipDrag || !Array.isArray(ids)) return;
    const placement = computeTimelineClipPlacement(
      ids,
      point.time,
      point.track
    );
    const pxPerSec = getTimelinePixelsPerSecond();
    ids.forEach((id) => {
      const clip = state.clips.find((item) => item.id === id);
      const clipEl = el.timelineList.querySelector(`[data-clip-id="${id}"]`);
      const next = placement.get(id);
      if (!clip || !clipEl || !next) return;
      const start = Number.isFinite(clip.start) ? clip.start : 0;
      const dx = (next.start - start) * pxPerSec;
      const fromTrackEl = clipEl.closest('.timeline-lane-track');
      const toTrackEl = el.timelineList.querySelector(
        `.timeline-lane-track.video-track[data-track="${next.track}"]`
      );
      let dy = 0;
      if (fromTrackEl && toTrackEl && fromTrackEl !== toTrackEl) {
        const fromRect = fromTrackEl.getBoundingClientRect();
        const toRect = toTrackEl.getBoundingClientRect();
        dy = toRect.top - fromRect.top;
      }
      clipEl.style.transform = `translate(${dx}px, ${dy}px)`;
    });
    if (el.timelineSnapline) {
      el.timelineSnapline.style.left = `${point.time * pxPerSec}px`;
      el.timelineSnapline.style.opacity = '1';
    }
  }

  function findTimelineClipElement(id) {
    if (!el.timelineList || !id) return null;
    const clips = el.timelineList.querySelectorAll('.timeline-clip');
    for (let i = 0; i < clips.length; i += 1) {
      if (clips[i].getAttribute('data-clip-id') === id) return clips[i];
    }
    return null;
  }

  function updateTimelineClipDragDom(ids) {
    if (!el.timelineList || !Array.isArray(ids)) return false;
    const pxPerSec = getTimelinePixelsPerSecond();
    let complete = true;
    ids.forEach((id) => {
      const clip = state.clips.find((item) => item && item.id === id);
      const clipEl = findTimelineClipElement(id);
      if (!clip || !clipEl) {
        complete = false;
        return;
      }
      const start = Number.isFinite(clip.start) ? clip.start : 0;
      const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
      clipEl.style.left = `${Math.max(0, start * pxPerSec)}px`;
      clipEl.style.width = `${Math.max(48, duration * pxPerSec)}px`;
      const track = getClipTrack(clip);
      clipEl.setAttribute('data-track', String(track));
      const laneSelector =
        clip.type === 'audio'
          ? `.timeline-lane-track.audio-track[data-track="${track}"]`
          : `.timeline-lane-track.video-track[data-track="${track}"]`;
      const lane = el.timelineList.querySelector(laneSelector);
      if (lane && clipEl.parentElement !== lane) {
        lane.appendChild(clipEl);
      } else if (!lane) {
        complete = false;
      }
    });
    updateTimelinePlayhead();
    return complete;
  }

  let timelineTrackOffsetCache = -1;
  let timelineTrackOffsetCacheAt = 0;

  function getTimelineTrackOffset() {
    if (!el.timelineList) return 0;
    const now = performance.now();
    if (
      state.playing &&
      timelineTrackOffsetCache >= 0 &&
      now - timelineTrackOffsetCacheAt < 250
    ) {
      return timelineTrackOffsetCache;
    }
    const track = el.timelineList.querySelector('.timeline-lane-track');
    if (!track) return 0;
    const listRect = el.timelineList.getBoundingClientRect();
    const trackRect = track.getBoundingClientRect();
    const offset = Math.max(
      0,
      trackRect.left - listRect.left + (el.timelineList.scrollLeft || 0)
    );
    timelineTrackOffsetCache = offset;
    timelineTrackOffsetCacheAt = now;
    return offset;
  }

  function ensureTimelineTimeGhost() {
    if (!el.timelineList) return null;
    if (
      el.timelineTimeGhost &&
      el.timelineTimeGhostLine &&
      el.timelineTimeGhost.isConnected &&
      el.timelineTimeGhostLine.isConnected
    ) {
      return {
        root: el.timelineTimeGhost,
        text: el.timelineTimeGhostText,
        line: el.timelineTimeGhostLine,
      };
    }
    const line = document.createElement('div');
    line.id = 'timeline-time-ghost-line';
    line.className = 'timeline-time-ghost-line';
    line.setAttribute('aria-hidden', 'true');
    const root = document.createElement('div');
    root.id = 'timeline-time-ghost';
    root.className = 'timeline-time-ghost';
    root.setAttribute('aria-hidden', 'true');
    const text = document.createElement('span');
    text.id = 'timeline-time-ghost-text';
    text.className = 'timeline-time-ghost-text';
    root.appendChild(text);
    el.timelineList.appendChild(line);
    el.timelineList.appendChild(root);
    el.timelineTimeGhost = root;
    el.timelineTimeGhostText = text;
    el.timelineTimeGhostLine = line;
    return { root, text, line };
  }

  function hideTimelineTimeGhost() {
    if (el.timelineTimeGhost) el.timelineTimeGhost.style.display = 'none';
    if (el.timelineTimeGhostLine)
      el.timelineTimeGhostLine.style.display = 'none';
  }

  function handleTimelineTimeHover(event) {
    if (!el.timelineList) return;
    if (
      timelineClipPointerDrag ||
      timelineHandleDrag ||
      timelineStageHandleDrag ||
      timelineMarquee ||
      clipVisualizerScrub
    ) {
      hideTimelineTimeGhost();
      return;
    }
    const ghost = ensureTimelineTimeGhost();
    if (!ghost) return;
    const rect = el.timelineList.getBoundingClientRect();
    const offset = getTimelineTrackOffset();
    const pxPerSec = getTimelinePixelsPerSecond();
    const localX = event.clientX - rect.left + el.timelineList.scrollLeft;
    const time = Math.max(0, (localX - offset) / pxPerSec);
    const x = offset + time * pxPerSec;
    const label = `${formatTimelineTimeValue(time, 2)}s`;
    ghost.root.style.left = `${x}px`;
    ghost.line.style.left = `${x}px`;
    ghost.text.textContent = label;
    ghost.root.style.display = 'block';
    ghost.line.style.display = 'block';
  }

  function cancelTimelineClipDragFrame() {
    if (!timelineClipDragRaf) return;
    cancelAnimationFrame(timelineClipDragRaf);
    timelineClipDragRaf = 0;
  }

  function applyTimelineClipPointerDragFrame() {
    timelineClipDragRaf = 0;
    const drag = timelineClipPointerDrag;
    if (!drag || !drag.pending) return;
    const clientX = drag.pending.clientX;
    const clientY = drag.pending.clientY;
    const dx = clientX - drag.startX;
    const dy = clientY - drag.startY;
    if (
      !drag.moved &&
      Math.hypot(dx, dy) < TIMELINE_LONG_PRESS_MOVE_THRESHOLD
    ) {
      return;
    }
    if (!drag.historyPushed) {
      pushTimelineHistory('move');
      drag.historyPushed = true;
    }
    drag.moved = true;
    const point = getTimelinePointFromClient(clientX, clientY);
    const nextTrack = Math.max(0, point.track + drag.trackOffset);
    const nextTime = Math.max(0, point.time - drag.offset);
    placeTimelineClipsAtTime(drag.ids, nextTime, nextTrack);
    setTimelineSelection(drag.ids, drag.clipId);
    if (!updateTimelineClipDragDom(drag.ids)) {
      renderTimeline();
    }
  }

  function flushTimelineClipDragFrame() {
    if (!timelineClipDragRaf) return;
    cancelTimelineClipDragFrame();
    applyTimelineClipPointerDragFrame();
  }

  function ensureTimelineMarquee() {
    if (!el.timelineList) return null;
    if (!el.timelineMarquee) {
      const div = document.createElement('div');
      div.className = 'timeline-marquee';
      div.style.display = 'none';
      el.timelineList.appendChild(div);
      el.timelineMarquee = div;
    }
    return el.timelineMarquee;
  }

  function applyTimelineSelectionToDom(selectedSet, primaryId) {
    if (!el.timelineList) return;
    el.timelineList.querySelectorAll('.timeline-clip').forEach((clipEl) => {
      const id = clipEl.getAttribute('data-clip-id');
      clipEl.classList.toggle('selected', selectedSet.has(id));
      clipEl.classList.toggle('active', id === primaryId);
    });
    updateTimelineSelectionBar();
  }

  function updateTimelineStageSelectionDom() {
    if (!el.timelineList) return;
    const selectedSet = new Set(state.selectedStageElementIds || []);
    el.timelineList
      .querySelectorAll('.timeline-stage-clip')
      .forEach((stageEl) => {
        const id = stageEl.getAttribute('data-stage-id');
        stageEl.classList.toggle('selected', selectedSet.has(id));
        stageEl.classList.toggle('active', id === state.selectedStageElementId);
      });
  }

  function handleTimelineMarqueeStart(event) {
    if (!el.timelineList) return;
    if (timelineHandleDrag || timelineStageHandleDrag || timelineClipPointerDrag) return;
    if (event.button !== 0) return;
    if (event.pointerType === 'touch') return;
    if (event.target.closest('.timeline-clip')) return;
    event.preventDefault();
    const listRect = el.timelineList.getBoundingClientRect();
    const startX = event.clientX - listRect.left + el.timelineList.scrollLeft;
    const startY = event.clientY - listRect.top + el.timelineList.scrollTop;
    const marqueeEl = ensureTimelineMarquee();
    if (!marqueeEl) return;
    timelineMarquee = {
      startX,
      startY,
      additive: event.metaKey || event.ctrlKey || event.shiftKey,
      baseSelection: new Set(state.selectedClipIds),
      basePrimaryId: state.selectedClipId,
      moved: false,
    };
    marqueeEl.style.display = 'none';
    marqueeEl.style.left = `${startX}px`;
    marqueeEl.style.top = `${startY}px`;
    marqueeEl.style.width = '0px';
    marqueeEl.style.height = '0px';
    window.addEventListener('pointermove', handleTimelineMarqueeMove);
    window.addEventListener('pointerup', handleTimelineMarqueeEnd);
    window.addEventListener('pointercancel', handleTimelineMarqueeEnd);
    window.addEventListener('keydown', handleTimelineMarqueeKeyDown);
  }

  function handleTimelineMarqueeKeyDown(event) {
    if (event.key !== 'Escape' || !timelineMarquee) return;
    const base = [...timelineMarquee.baseSelection];
    const primaryId = timelineMarquee.basePrimaryId;
    finishTimelineMarquee();
    setTimelineSelection(base, primaryId);
    applyTimelineSelectionToDom(new Set(base), state.selectedClipId);
    renderInspector();
    renderAutomationHistoryPanel();
  }

  function finishTimelineMarquee() {
    timelineMarquee = null;
    if (el.timelineMarquee) {
      el.timelineMarquee.style.display = 'none';
    }
    window.removeEventListener('pointermove', handleTimelineMarqueeMove);
    window.removeEventListener('pointerup', handleTimelineMarqueeEnd);
    window.removeEventListener('pointercancel', handleTimelineMarqueeEnd);
    window.removeEventListener('keydown', handleTimelineMarqueeKeyDown);
  }

  function handleTimelineMarqueeMove(event) {
    if (!timelineMarquee || !el.timelineList) return;
    const listRect = el.timelineList.getBoundingClientRect();
    const currentX = event.clientX - listRect.left + el.timelineList.scrollLeft;
    const currentY = event.clientY - listRect.top + el.timelineList.scrollTop;
    const dx = Math.abs(currentX - timelineMarquee.startX);
    const dy = Math.abs(currentY - timelineMarquee.startY);
    if (!timelineMarquee.moved && dx < 3 && dy < 3) return;
    timelineMarquee.moved = true;
    const edge = 40;
    const localX = event.clientX - listRect.left;
    if (localX < edge) {
      const delta = Math.ceil((edge - localX) / 6);
      el.timelineList.scrollLeft = Math.max(
        0,
        el.timelineList.scrollLeft - delta
      );
    } else if (localX > listRect.width - edge) {
      const delta = Math.ceil((localX - (listRect.width - edge)) / 6);
      el.timelineList.scrollLeft = Math.min(
        el.timelineList.scrollWidth - el.timelineList.clientWidth,
        el.timelineList.scrollLeft + delta
      );
    }
    const x1 = Math.min(timelineMarquee.startX, currentX);
    const x2 = Math.max(timelineMarquee.startX, currentX);
    const y1 = Math.min(timelineMarquee.startY, currentY);
    const y2 = Math.max(timelineMarquee.startY, currentY);
    if (el.timelineMarquee) {
      el.timelineMarquee.style.display = 'block';
      el.timelineMarquee.style.left = `${x1}px`;
      el.timelineMarquee.style.top = `${y1}px`;
      el.timelineMarquee.style.width = `${x2 - x1}px`;
      el.timelineMarquee.style.height = `${y2 - y1}px`;
    }
    const selected = timelineMarquee.additive
      ? new Set(timelineMarquee.baseSelection)
      : new Set();
    let lastHit = null;
    el.timelineList.querySelectorAll('.timeline-clip').forEach((clipEl) => {
      const id = clipEl.getAttribute('data-clip-id');
      const rect = clipEl.getBoundingClientRect();
      const left = rect.left - listRect.left + el.timelineList.scrollLeft;
      const right = left + rect.width;
      const top = rect.top - listRect.top + el.timelineList.scrollTop;
      const bottom = top + rect.height;
      const intersects = right >= x1 && left <= x2 && bottom >= y1 && top <= y2;
      if (intersects) {
        selected.add(id);
        lastHit = id;
      }
    });
    const order = state.clips.map((clip) => clip.id);
    const ordered = order.filter((id) => selected.has(id));
    const primary =
      lastHit && selected.has(lastHit)
        ? lastHit
        : ordered.includes(state.selectedClipId)
          ? state.selectedClipId
          : ordered[0];
    setTimelineSelection(ordered, primary || null);
    applyTimelineSelectionToDom(new Set(ordered), state.selectedClipId);
  }

  function handleTimelineMarqueeEnd() {
    if (!timelineMarquee) return;
    const moved = timelineMarquee.moved;
    const additive = timelineMarquee.additive;
    finishTimelineMarquee();
    if (!moved && !additive && state.selectedClipIds.length) {
      clearSelectedAutomation();
      setTimelineSelection([], null);
      applyTimelineSelectionToDom(new Set(), null);
    }
    renderInspector();
    renderAutomationHistoryPanel();
  }

  function getPointerX(event) {
    if (event.touches && event.touches.length) {
      return event.touches[0].clientX;
    }
    return event.clientX;
  }

  function getPointerY(event) {
    if (event.touches && event.touches.length) {
      return event.touches[0].clientY;
    }
    return event.clientY;
  }

  function getTouchDistance(touches) {
    if (!touches || touches.length < 2) return 0;
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.hypot(dx, dy);
  }

  function startTimelinePinch(event) {
    if (!el.timelineList) return;
    if (!event.touches || event.touches.length < 2) return;
    timelinePinchActive = true;
    timelinePinchStartDistance = getTouchDistance(event.touches);
    timelinePinchStartScale = state.timelineScale || 80;
    clearTimelineLongPress();
    if (event.cancelable) event.preventDefault();
  }

  function moveTimelinePinch(event) {
    if (!timelinePinchActive || !event.touches || event.touches.length < 2)
      return;
    const distance = getTouchDistance(event.touches);
    if (!timelinePinchStartDistance) return;
    const ratio = distance / timelinePinchStartDistance;
    const next = timelinePinchStartScale * ratio;
    const anchorX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
    setTimelineZoom(next, anchorX);
    if (event.cancelable) event.preventDefault();
  }

  function endTimelinePinch(event) {
    if (!timelinePinchActive) return;
    if (!event.touches || event.touches.length < 2) {
      timelinePinchActive = false;
      timelinePinchStartDistance = 0;
    }
  }

  function handleTimelineHandleDown(event) {
    if (timelineHandleDrag || timelineStageHandleDrag) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const handle = event.target.closest('.clip-handle');
    if (!handle) return;
    if (event.type === 'mousedown' && event.button !== 0) return;
    if (event.type === 'pointerdown' && event.button !== 0) return;
    if (event.touches && event.touches.length > 1) return;
    const clipId = handle.getAttribute('data-clip-id');
    const stageId = handle.getAttribute('data-stage-id');
    const side = handle.getAttribute('data-handle');
    if (!side) return;
    if (stageId) {
      const element = state.stageElements.find((item) => item.id === stageId);
      if (!element || element.locked) return;
      event.preventDefault();
      event.stopPropagation();
      ensureStageElementTiming(element);
      const timing = getStageElementTiming(element);
      selectStageElement(stageId);
      dragClipId = null;
      dragClipIds = null;
      pushTimelineHistory('stage-timing');
      timelineStageHandleDrag = {
        stageId,
        side,
        startX: getPointerX(event),
        start: timing.start,
        duration: timing.duration,
        startFingerprint: currentProjectFingerprint(),
      };
      window.addEventListener('mousemove', handleTimelineHandleMove);
      window.addEventListener('mouseup', handleTimelineHandleUp);
      window.addEventListener('pointermove', handleTimelineHandleMove);
      window.addEventListener('pointerup', handleTimelineHandleUp);
      window.addEventListener('pointercancel', handleTimelineHandleUp);
      window.addEventListener('touchmove', handleTimelineHandleMove, {
        passive: false,
      });
      window.addEventListener('touchend', handleTimelineHandleUp);
      return;
    }
    if (!clipId) return;
    const clip = state.clips.find((item) => item.id === clipId);
    if (!clip) return;
    event.preventDefault();
    event.stopPropagation();
    if (!state.selectedClipIds.includes(clipId)) {
      setTimelineSelection([clipId], clipId);
      state.timelineSelectionAnchorId = clipId;
      renderTimeline();
      renderInspector();
      renderAutomationHistoryPanel();
    }
    dragClipId = null;
    dragClipIds = null;
    pushTimelineHistory(side === 'left' ? 'trim-start' : 'trim-end');
    timelineHandleDrag = {
      clipId,
      side,
      startX: getPointerX(event),
      trimStart: clip.trimStart || 0,
      trimEnd: clip.trimEnd || 0,
      duration: clip.duration || 0,
      start: Number.isFinite(clip.start) ? clip.start : 0,
      speed: clip.speed || 1,
      sourceDuration: clip.sourceDuration || clip.duration || 0,
      type: clip.type,
    };
    window.addEventListener('mousemove', handleTimelineHandleMove);
    window.addEventListener('mouseup', handleTimelineHandleUp);
    window.addEventListener('pointermove', handleTimelineHandleMove);
    window.addEventListener('pointerup', handleTimelineHandleUp);
    window.addEventListener('pointercancel', handleTimelineHandleUp);
    window.addEventListener('touchmove', handleTimelineHandleMove, {
      passive: false,
    });
    window.addEventListener('touchend', handleTimelineHandleUp);
  }

  function handleTimelineHandleMove(event) {
    if (timelineStageHandleDrag) {
      if (event.cancelable) event.preventDefault();
      const element = state.stageElements.find(
        (item) => item.id === timelineStageHandleDrag.stageId
      );
      if (!element) return;
      const dx = getPointerX(event) - timelineStageHandleDrag.startX;
      const delta = dx / Math.max(1, state.timelineScale);
      if (timelineStageHandleDrag.side === 'left') {
        const fixedEnd =
          timelineStageHandleDrag.start + timelineStageHandleDrag.duration;
        let nextDuration = Math.max(
          0.1,
          timelineStageHandleDrag.duration - delta
        );
        let nextStart = fixedEnd - nextDuration;
        if (nextStart < 0) {
          nextStart = 0;
          nextDuration = fixedEnd;
        }
        element.timelineStart = snapTimelineTime(nextStart);
        element.timelineDuration = Math.max(
          0.1,
          fixedEnd - element.timelineStart
        );
      } else {
        element.timelineDuration = Math.max(
          0.1,
          snapTimelineTime(timelineStageHandleDrag.duration + delta)
        );
      }
      updatePreviewDuration();
      renderTimeline();
      renderStageElements();
      renderFrameAt(state.playhead);
      return;
    }
    if (!timelineHandleDrag) return;
    if (event.cancelable) event.preventDefault();
    const clip = state.clips.find(
      (item) => item.id === timelineHandleDrag.clipId
    );
    if (!clip) return;
    const dx = getPointerX(event) - timelineHandleDrag.startX;
    const deltaOut = dx / Math.max(1, state.timelineScale);
    const absSpeed = Math.abs(clip.speed || 1);
    const deltaSource = deltaOut * absSpeed;
    const sourceDur = timelineHandleDrag.sourceDuration;
    if (timelineHandleDrag.side === 'left') {
      const fixedEnd =
        timelineHandleDrag.start + Math.max(0, timelineHandleDrag.duration);
      if (clip.type === 'video') {
        const maxTrimStart = Math.max(
          0,
          sourceDur - (timelineHandleDrag.trimEnd || 0) - 0.1
        );
        let nextTrim = Math.max(
          0,
          Math.min(maxTrimStart, timelineHandleDrag.trimStart + deltaSource)
        );
        let usable = Math.max(
          0.1,
          sourceDur - nextTrim - (timelineHandleDrag.trimEnd || 0)
        );
        let nextDuration = usable / absSpeed;
        let nextStart = fixedEnd - nextDuration;
        if (nextStart < 0) {
          nextStart = 0;
          nextDuration = fixedEnd;
          usable = nextDuration * absSpeed;
          nextTrim = Math.max(
            0,
            Math.min(
              maxTrimStart,
              sourceDur - (timelineHandleDrag.trimEnd || 0) - usable
            )
          );
        }
        clip.trimStart = nextTrim;
        clip.trimEnd = timelineHandleDrag.trimEnd || 0;
        clip.duration = Math.max(0.1, nextDuration);
        clip.start = Math.max(0, nextStart);
        recalcTimeline();
        renderTimeline();
        renderInspector();
        renderFrameAt(state.playhead);
      } else {
        let nextDuration = Math.max(
          0.1,
          timelineHandleDrag.duration - deltaOut
        );
        let nextStart = fixedEnd - nextDuration;
        if (nextStart < 0) {
          nextStart = 0;
          nextDuration = fixedEnd;
        }
        clip.start = Math.max(0, nextStart);
        clip.duration = Math.max(0.1, nextDuration);
        recalcTimeline();
        renderTimeline();
        renderInspector();
        renderFrameAt(state.playhead);
      }
    } else {
      if (clip.type === 'video') {
        const nextTrim = timelineHandleDrag.trimEnd - deltaSource;
        if (nextTrim > sourceDur - (clip.trimStart || 0)) {
          clip.speed = -absSpeed;
          clip.trimEnd = Math.max(0, sourceDur - (clip.trimStart || 0) - 0.1);
          const usable = Math.max(
            0.1,
            sourceDur - clip.trimStart - clip.trimEnd
          );
          clip.duration = usable / absSpeed;
          renderTimeline();
          renderInspector();
        } else {
          updateClipField('trimEnd', nextTrim, {
            skipHistory: true,
            skipAutosave: true,
          });
        }
      } else {
        const nextDuration = timelineHandleDrag.duration + deltaOut;
        updateClipField('duration', nextDuration, {
          skipHistory: true,
          skipAutosave: true,
        });
      }
    }
  }

  function handleTimelineHandleUp(event) {
    if (!timelineHandleDrag && !timelineStageHandleDrag) return;
    if (event && event.preventDefault) event.preventDefault();
    if (event && event.stopPropagation) event.stopPropagation();
    const stageChanged =
      timelineStageHandleDrag &&
      timelineStageHandleDrag.startFingerprint !== currentProjectFingerprint();
    timelineHandleDrag = null;
    timelineStageHandleDrag = null;
    window.removeEventListener('mousemove', handleTimelineHandleMove);
    window.removeEventListener('mouseup', handleTimelineHandleUp);
    window.removeEventListener('pointermove', handleTimelineHandleMove);
    window.removeEventListener('pointerup', handleTimelineHandleUp);
    window.removeEventListener('pointercancel', handleTimelineHandleUp);
    window.removeEventListener('touchmove', handleTimelineHandleMove);
    window.removeEventListener('touchend', handleTimelineHandleUp);
    timelineSuppressClickUntil = Date.now() + 300;
    renderTimeline();
    if (stageChanged) renderStageElements();
    scheduleAutosave(stageChanged ? 'stage-timing' : undefined);
  }

  function getTimelinePointFromClient(clientX, clientY, clipType) {
    if (!el.timelineList) return { time: 0, track: 0 };
    const listRect = el.timelineList.getBoundingClientRect();
    const pxPerSec = getTimelinePixelsPerSecond();
    const localX = clientX - listRect.left + el.timelineList.scrollLeft;
    const time = snapTimelineTime(Math.max(0, localX / pxPerSec));
    let trackEl = null;
    const trackSelector =
      clipType === 'audio'
        ? '.timeline-lane-track.audio-track'
        : '.timeline-lane-track.video-track';
    const tracks = Array.from(el.timelineList.querySelectorAll(trackSelector));
    trackEl =
      tracks.find((row) => {
        const rect = row.getBoundingClientRect();
        return clientY >= rect.top && clientY <= rect.bottom;
      }) || null;
    if (!trackEl) {
      trackEl = el.timelineList.querySelector(trackSelector);
    }
    const trackAttr = trackEl && trackEl.dataset ? trackEl.dataset.track : null;
    const track =
      trackAttr !== null && trackAttr !== undefined && trackAttr !== ''
        ? Math.max(0, parseInt(trackAttr, 10) || 0)
        : 0;
    return { time, track };
  }

  function handleTimelineClipPointerDown(event) {
    if (
      timelineHandleDrag ||
      timelineStageHandleDrag ||
      timelineClipPointerDrag
    )
      return;
    if (event.button !== 0) return;
    const target = event.target;
    if (!target || target.closest('.clip-handle')) return;
    if (target.closest('.clip-controls')) return;
    if (target.closest('.clip-visualizer')) return;
    const clipEl = target.closest('.timeline-clip');
    if (!clipEl || !el.timelineList || !el.timelineList.contains(clipEl))
      return;
    const clipId = clipEl.getAttribute('data-clip-id');
    const clip = state.clips.find((item) => item.id === clipId);
    if (!clip) return;
    const point = getTimelinePointFromClient(
      event.clientX,
      event.clientY,
      clip.type
    );
    const clipStart = Number.isFinite(clip.start) ? clip.start : 0;
    if (!state.selectedClipIds.includes(clipId)) {
      setTimelineSelection([clipId], clipId);
      state.timelineSelectionAnchorId = clipId;
      clearSelectedAutomation();
      applyTimelineSelectionToDom(new Set([clipId]), clipId);
      renderInspector();
      renderAutomationHistoryPanel();
    }
    const selected = state.selectedClipIds.includes(clipId)
      ? state.selectedClipIds.slice()
      : [clipId];
    const moving = state.clips
      .filter((item) => selected.includes(item.id))
      .map((item) => ({
        id: item.id,
        start: Number.isFinite(item.start) ? item.start : 0,
        track: getClipTrack(item),
      }));
    if (!moving.length) return;
    event.preventDefault();
    event.stopPropagation();
    hideTimelineVideoHover();
    dragClipId = clipId;
    dragClipIds = moving.map((item) => item.id);
    timelineClipPointerDrag = {
      pointerId: event.pointerId,
      clipId,
      ids: dragClipIds.slice(),
      startX: event.clientX,
      startY: event.clientY,
      offset: Math.max(0, point.time - clipStart),
      trackOffset: getClipTrack(clip) - point.track,
      moved: false,
      historyPushed: false,
      pending: null,
    };
    dragClipIds.forEach((id) => {
      const elClip = findTimelineClipElement(id);
      if (elClip) elClip.classList.add('dragging');
    });
    if (typeof clipEl.setPointerCapture === 'function') {
      try {
        clipEl.setPointerCapture(event.pointerId);
      } catch (_) {}
    }
    window.addEventListener('pointermove', handleTimelineClipPointerMove);
    window.addEventListener('pointerup', handleTimelineClipPointerUp);
    window.addEventListener('pointercancel', handleTimelineClipPointerUp);
  }

  function handleTimelineClipPointerMove(event) {
    if (!timelineClipPointerDrag) return;
    event.preventDefault();
    timelineClipPointerDrag.pending = {
      clientX: event.clientX,
      clientY: event.clientY,
    };
    if (!timelineClipDragRaf) {
      timelineClipDragRaf = requestAnimationFrame(
        applyTimelineClipPointerDragFrame
      );
    }
  }

  function handleTimelineClipPointerUp(event) {
    if (!timelineClipPointerDrag) return;
    if (event && event.preventDefault) event.preventDefault();
    flushTimelineClipDragFrame();
    const moved = timelineClipPointerDrag.moved;
    timelineClipPointerDrag = null;
    cancelTimelineClipDragFrame();
    window.removeEventListener('pointermove', handleTimelineClipPointerMove);
    window.removeEventListener('pointerup', handleTimelineClipPointerUp);
    window.removeEventListener('pointercancel', handleTimelineClipPointerUp);
    clearTimelineDragStates();
    dragClipId = null;
    dragClipIds = null;
    if (moved) {
      timelineSuppressClickUntil = Date.now() + 250;
      renderTimeline();
      renderInspector();
      renderAutomationHistoryPanel();
      renderFrameAt(state.playhead);
      scheduleAutosave();
    }
  }

  function handleTimelineDragStart(event) {
    if (event.target.closest('.clip-handle')) {
      event.preventDefault();
      if (event.dataTransfer) event.dataTransfer.clearData();
      return;
    }
    if (timelineHandleDrag || timelineStageHandleDrag) {
      event.preventDefault();
      if (event.dataTransfer) event.dataTransfer.clearData();
      return;
    }
    if (clipVisualizerScrub) {
      if (event.dataTransfer) event.dataTransfer.clearData();
      event.preventDefault();
      return;
    }
    closeTimelineContextMenu();
    closeTimelineTrackMenu();
    closeTimelineMarkerMenu();
    const target = event.target.closest('.timeline-clip');
    if (!target) return;
    dragClipId = target.getAttribute('data-clip-id');
    if (!dragClipId) return;
    if (!state.selectedClipIds.includes(dragClipId)) {
      setTimelineSelection([dragClipId], dragClipId);
      state.timelineSelectionAnchorId = dragClipId;
      if (el.timelineList) {
        el.timelineList.querySelectorAll('.timeline-clip').forEach((clipEl) => {
          clipEl.classList.toggle(
            'selected',
            clipEl.getAttribute('data-clip-id') === dragClipId
          );
          clipEl.classList.toggle(
            'active',
            clipEl.getAttribute('data-clip-id') === dragClipId
          );
        });
      }
      renderInspector();
      renderAutomationHistoryPanel();
    }
    const selection = new Set(state.selectedClipIds);
    dragClipIds = state.clips
      .filter((clip) => selection.has(clip.id))
      .map((clip) => clip.id);
    const moving = state.clips.filter((clip) => dragClipIds.includes(clip.id));
    const anchorClip = state.clips.find((clip) => clip.id === dragClipId);
    const minStart = moving.length
      ? Math.min(
          ...moving.map((clip) =>
            Number.isFinite(clip.start) ? clip.start : 0
          )
        )
      : 0;
    const pointerTime = getTimelinePointerTime(event);
    const anchorStart =
      anchorClip && Number.isFinite(anchorClip.start) ? anchorClip.start : 0;
    const anchorDuration =
      anchorClip && Number.isFinite(anchorClip.duration)
        ? anchorClip.duration
        : 0;
    timelineClipDrag = {
      minStart,
      anchorStart,
      grabOffset: Math.max(
        0,
        Math.min(anchorDuration, pointerTime - anchorStart)
      ),
    };
    dragClipIds.forEach((id) => {
      const elClip = el.timelineList?.querySelector(`[data-clip-id="${id}"]`);
      if (elClip) elClip.classList.add('dragging');
    });
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', dragClipId);
      const canvas = document.createElement('canvas');
      canvas.width = 1;
      canvas.height = 1;
      event.dataTransfer.setDragImage(canvas, 0, 0);
    }
  }

  function handleTimelineDragOver(event) {
    closeTimelineContextMenu();
    closeTimelineTrackMenu();
    closeTimelineMarkerMenu();
    const target = event.target.closest('.timeline-clip');
    const trackEl =
      event.target.closest('.timeline-lane-track') ||
      el.timelineList?.querySelector('.timeline-lane-track');
    const dragIds =
      dragClipIds && dragClipIds.length
        ? dragClipIds
        : dragClipId
          ? [dragClipId]
          : [];
    if (!trackEl || !dragIds.length) return;
    event.preventDefault();
    clearTimelineDragStates();
    trackEl.classList.add('drag-over');
    if (target) target.classList.add('drag-over');
    const point = getTimelineAdjustedDropPoint(event, dragIds);
    updateTimelineClipDragPreview(event, dragIds, point);
  }

  function handleTimelineDragLeave(event) {
    const target = event.target.closest('.timeline-clip');
    if (target) target.classList.remove('drag-over');
    const trackEl = event.target.closest('.timeline-lane-track');
    if (trackEl) trackEl.classList.remove('drag-over');
  }

  function handleTimelineDrop(event) {
    event.preventDefault();
    const dragIds =
      dragClipIds && dragClipIds.length
        ? dragClipIds
        : dragClipId
          ? [dragClipId]
          : [];
    if (!dragIds.length) {
      clearTimelineDragStates();
      dragClipId = null;
      dragClipIds = null;
      timelineClipDrag = null;
      return;
    }
    const point = getTimelineAdjustedDropPoint(event, dragIds);
    pushTimelineHistory('move');
    placeTimelineClipsAtTime(dragIds, point.time, point.track);
    setTimelineSelection(dragIds, dragIds[0] || null);
    renderTimeline();
    renderInspector();
    renderAutomationHistoryPanel();
    renderFrameAt(state.playhead);
    scheduleAutosave();
    clearTimelineDragStates();
    dragClipId = null;
    dragClipIds = null;
    timelineClipDrag = null;
  }

  function handleTimelineDragEnd() {
    clearTimelineDragStates();
    dragClipId = null;
    dragClipIds = null;
    timelineClipDrag = null;
  }

  function updateClipScrubFromEvent(event) {
    if (!clipVisualizerScrub) return;
    const clip = state.clips.find(
      (item) => item.id === clipVisualizerScrub.clipId
    );
    if (!clip || clip.duration <= 0) return;
    const rect = clipVisualizerScrub.visualizer.getBoundingClientRect();
    const ratio =
      rect.width > 0
        ? Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width))
        : 0;
    clipVisualizerScrub.ratio = ratio;
    state.playhead = clip.start + ratio * clip.duration;
    renderFrameAt(state.playhead);
    updateTimeLabel();
  }

  function handleClipVisualizerScrubMove(event) {
    if (!clipVisualizerScrub) return;
    event.preventDefault();
    updateClipScrubFromEvent(event);
  }

  function handleClipVisualizerScrubEnd(event) {
    if (!clipVisualizerScrub) return;
    event.preventDefault();
    clipVisualizerScrub = null;
    window.removeEventListener('mousemove', handleClipVisualizerScrubMove);
    window.removeEventListener('mouseup', handleClipVisualizerScrubEnd);
  }

  function handleClipVisualizerScrubStart(event) {
    if (event.button !== 0) return;
    const visualizer = event.target.closest('.clip-visualizer');
    if (!visualizer) return;
    const clipId = visualizer
      .closest('.timeline-clip')
      ?.getAttribute('data-clip-id');
    if (!clipId) return;
    event.preventDefault();
    event.stopPropagation();
    clipVisualizerScrub = { clipId, visualizer };
    if (!state.selectedClipIds.includes(clipId)) {
      setTimelineSelection([clipId], clipId);
      state.timelineSelectionAnchorId = clipId;
      clearSelectedAutomation();
      renderTimeline();
      renderInspector();
      renderAutomationHistoryPanel();
    }
    updateClipScrubFromEvent(event);
    window.addEventListener('mousemove', handleClipVisualizerScrubMove);
    window.addEventListener('mouseup', handleClipVisualizerScrubEnd);
  }

  function getTimelineSeekTimeFromEvent(event, source) {
    const pxPerSec = getTimelinePixelsPerSecond();
    if (!pxPerSec) return state.playhead || 0;
    let x = 0;
    if (source === 'ruler' && el.timelineRuler) {
      const rect = el.timelineRuler.getBoundingClientRect();
      x =
        event.clientX -
        rect.left +
        (el.timelineRuler.scrollLeft || 0) -
        getTimelineTrackOffset();
    } else if (el.timelineList) {
      const rect = el.timelineList.getBoundingClientRect();
      const offset = getTimelineTrackOffset();
      x =
        event.clientX - rect.left + (el.timelineList.scrollLeft || 0) - offset;
    }
    const maxTime = Math.max(totalDuration(), 0);
    return Math.max(0, Math.min(maxTime, x / pxPerSec));
  }

  function seekTimelinePlayhead(time, options) {
    const opts = options || {};
    const maxTime = Math.max(totalDuration(), 0);
    let next = Math.max(0, Math.min(maxTime, Number(time) || 0));
    if (opts.snap) next = snapTimelineTime(next);
    next = Math.max(0, Math.min(maxTime, next));
    state.playhead = next;
    if (state.playing) {
      state.playStartTime = performance.now() - next * 1000;
    }
    if (state.audioElement) {
      try {
        state.audioElement.currentTime = next;
      } catch (_) {}
    }
    state.audioTracks.forEach((track) => {
      if (!track || !track.element) return;
      try {
        track.element.currentTime = Math.max(0, next);
      } catch (_) {}
    });
    renderFrameAt(next);
    updateTimeLabel();
    if (opts.autoscroll) scrollTimelinePlayheadIntoView();
  }

  function scrollTimelinePlayheadIntoView() {
    if (!el.timelineList) return;
    const pxPerSec = getTimelinePixelsPerSecond();
    const offset = getTimelineTrackOffset();
    const x = offset + (state.playhead || 0) * pxPerSec;
    const left = el.timelineList.scrollLeft || 0;
    const right = left + el.timelineList.clientWidth;
    if (x < left + 32) {
      el.timelineList.scrollLeft = Math.max(0, x - 32);
    } else if (x > right - 32) {
      el.timelineList.scrollLeft = Math.max(
        0,
        x - el.timelineList.clientWidth + 32
      );
    }
    if (el.timelineRuler)
      el.timelineRuler.scrollLeft = el.timelineList.scrollLeft;
  }

  function scrubTimelinePlayheadFromEvent(event, source) {
    seekTimelinePlayhead(getTimelineSeekTimeFromEvent(event, source), {
      snap: !!state.snapToBeat,
    });
  }

  function startTimelinePlayheadDrag(event, source) {
    if (!el.timelineList) return;
    event.preventDefault();
    event.stopPropagation();
    timelinePlayheadDrag = {
      source: source || 'timeline',
      pointerId: event.pointerId,
    };
    if (el.timelinePlayhead) {
      el.timelinePlayhead.classList.add('dragging');
      if (typeof el.timelinePlayhead.setPointerCapture === 'function') {
        try {
          el.timelinePlayhead.setPointerCapture(event.pointerId);
        } catch (_) {}
      }
    }
    scrubTimelinePlayheadFromEvent(event, timelinePlayheadDrag.source);
  }

  function handleTimelinePlayheadDragMove(event) {
    if (!timelinePlayheadDrag) return;
    event.preventDefault();
    scrubTimelinePlayheadFromEvent(event, timelinePlayheadDrag.source);
  }

  function endTimelinePlayheadDrag(event) {
    if (!timelinePlayheadDrag) return;
    event.preventDefault();
    if (el.timelinePlayhead) {
      el.timelinePlayhead.classList.remove('dragging');
      if (typeof el.timelinePlayhead.releasePointerCapture === 'function') {
        try {
          el.timelinePlayhead.releasePointerCapture(
            timelinePlayheadDrag.pointerId
          );
        } catch (_) {}
      }
    }
    timelinePlayheadDrag = null;
  }

  function startRulerPointerSession(event) {
    if (!el.timelineList) return;
    event.preventDefault();
    event.stopPropagation();
    const snap = !!state.snapToBeat;
    let startTime = getTimelineSeekTimeFromEvent(event, 'ruler');
    if (snap) startTime = snapTimelineTime(startTime);
    rulerPointerSession = {
      pointerId: event.pointerId,
      startClientX: event.clientX,
      startClientY: event.clientY,
      startTime,
      additive: event.metaKey || event.ctrlKey || event.shiftKey,
      moved: false,
      snap,
    };
    window.addEventListener('pointermove', handleRulerPointerMove);
    window.addEventListener('pointerup', handleRulerPointerUp);
    window.addEventListener('pointercancel', handleRulerPointerCancel);
  }

  function handleRulerPointerMove(event) {
    if (!rulerPointerSession || rulerPointerSession.pointerId !== event.pointerId)
      return;
    event.preventDefault();
    if (!rulerPointerSession.moved) {
      const dx = Math.abs(event.clientX - rulerPointerSession.startClientX);
      const dy = Math.abs(event.clientY - rulerPointerSession.startClientY);
      if (dx < 4 && dy < 4) return;
      rulerPointerSession.moved = true;
      beginRulerTimeSelection();
    }
    updateRulerTimeSelection(event);
  }

  function handleRulerPointerCancel(event) {
    if (!rulerPointerSession || rulerPointerSession.pointerId !== event.pointerId)
      return;
    finishRulerPointerSession();
  }

  function handleRulerPointerUp(event) {
    if (!rulerPointerSession || rulerPointerSession.pointerId !== event.pointerId)
      return;
    const wasDrag = rulerPointerSession.moved;
    if (!wasDrag) {
      const snapped = rulerPointerSession.snap
        ? snapTimelineTime(getTimelineSeekTimeFromEvent(event, 'ruler'))
        : getTimelineSeekTimeFromEvent(event, 'ruler');
      seekTimelinePlayhead(snapped, {
        snap: rulerPointerSession.snap,
        autoscroll: true,
      });
      finishRulerPointerSession();
      return;
    }
    finishRulerPointerSession();
    renderInspector();
    renderAutomationHistoryPanel();
  }

  function finishRulerPointerSession() {
    if (el.timelineMarquee) el.timelineMarquee.style.display = 'none';
    rulerSelectionDrag = null;
    rulerPointerSession = null;
    window.removeEventListener('pointermove', handleRulerPointerMove);
    window.removeEventListener('pointerup', handleRulerPointerUp);
    window.removeEventListener('pointercancel', handleRulerPointerCancel);
  }

  function beginRulerTimeSelection() {
    if (!el.timelineList) return;
    const marqueeEl = ensureTimelineMarquee();
    if (!marqueeEl) return;
    const listRect = el.timelineList.getBoundingClientRect();
    const offset = getTimelineTrackOffset();
    const startX =
      rulerPointerSession.startClientX -
      listRect.left +
      el.timelineList.scrollLeft;
    const baseSelection = new Set(state.selectedClipIds);
    rulerSelectionDrag = {
      startTime: rulerPointerSession.startTime,
      startX: Math.max(0, startX - offset),
      additive: rulerPointerSession.additive,
      baseSelection,
      basePrimaryId: state.selectedClipId,
      primaryId: null,
    };
    marqueeEl.style.display = 'none';
    marqueeEl.style.top = `${el.timelineList.scrollTop}px`;
    marqueeEl.style.height = `${el.timelineList.clientHeight}px`;
  }

  function updateRulerTimeSelection(event) {
    if (!rulerSelectionDrag || !el.timelineList) return;
    const listRect = el.timelineList.getBoundingClientRect();
    const offset = getTimelineTrackOffset();
    const currentX =
      event.clientX - listRect.left + el.timelineList.scrollLeft - offset;
    const pxPerSec = getTimelinePixelsPerSecond();
    let currentTime = pxPerSec ? currentX / pxPerSec : 0;
    const maxTime = Math.max(totalDuration(), 0);
    currentTime = Math.max(0, Math.min(maxTime, currentTime));
    const snap = rulerPointerSession.snap;
    if (snap) currentTime = snapTimelineTime(currentTime);
    const x1 = Math.min(rulerSelectionDrag.startX, currentX);
    const x2 = Math.max(rulerSelectionDrag.startX, currentX);
    if (el.timelineMarquee && x2 - x1 >= 1) {
      el.timelineMarquee.style.display = 'block';
      el.timelineMarquee.style.left = `${x1 + offset}px`;
      el.timelineMarquee.style.width = `${x2 - x1}px`;
      el.timelineMarquee.style.top = `${el.timelineList.scrollTop}px`;
      el.timelineMarquee.style.height = `${el.timelineList.clientHeight}px`;
    }
    const s = Math.min(rulerSelectionDrag.startTime, currentTime);
    const e = Math.max(rulerSelectionDrag.startTime, currentTime);
    const selected = rulerSelectionDrag.additive
      ? new Set(rulerSelectionDrag.baseSelection)
      : new Set();
    let lastHit = null;
    state.clips.forEach((clip) => {
      const clipStart = Number.isFinite(clip.start) ? clip.start : 0;
      const clipEnd = clipStart + (Number.isFinite(clip.duration) ? clip.duration : 0);
      if (clipEnd >= s && clipStart <= e) {
        selected.add(clip.id);
        lastHit = clip.id;
      }
    });
    const order = state.clips.map((clip) => clip.id);
    const ordered = order.filter((id) => selected.has(id));
    const primary =
      lastHit && selected.has(lastHit)
        ? lastHit
        : ordered.includes(state.selectedClipId)
          ? state.selectedClipId
          : ordered[0];
    rulerSelectionDrag.primaryId = primary || null;
    setTimelineSelection(ordered, primary || null);
    applyTimelineSelectionToDom(new Set(ordered), state.selectedClipId);
  }

  function updateClipVisualizerTooltipTitle(clip, tooltip, altActive) {
    if (!tooltip) return;
    if (!clip || !altActive) {
      tooltip.title = '';
      return;
    }
    const gain = typeof clip.audioGain === 'number' ? clip.audioGain : 1;
    const gainEnd =
      typeof clip.audioGainEnd === 'number' ? clip.audioGainEnd : gain;
    const gainLabel =
      gainEnd !== gain
        ? `${gain.toFixed(2)}-${gainEnd.toFixed(2)}`
        : gain.toFixed(2);
    tooltip.title = `G=${gainLabel}`;
  }

  function handleClipVisualizerHover(event) {
    if (
      timelineClipPointerDrag ||
      timelineHandleDrag ||
      timelineStageHandleDrag
    )
      return;
    const visualizer = event.target.closest('.clip-visualizer');
    if (!visualizer) return;
    const tooltip = visualizer.querySelector('.clip-visualizer-tooltip');
    if (!tooltip) return;
    const clipId = visualizer
      .closest('.timeline-clip')
      ?.getAttribute('data-clip-id');
    if (!clipId) return;
    const clip = state.clips.find((item) => item.id === clipId);
    if (!clip) return;
    const rect = visualizer.getBoundingClientRect();
    const ratio =
      rect.width > 0
        ? Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width))
        : 0;
    const time = clip.start + ratio * clip.duration;
    tooltip.textContent = `${formatTimelineTimeValue(time, 2)}s`;
    clipVisualizerHover = { clipId, tooltip };
    updateClipVisualizerTooltipTitle(
      clip,
      tooltip,
      event.altKey || clipVisualizerAltDown
    );
  }

  function handleClipVisualizerHoverLeave() {
    if (clipVisualizerHover && clipVisualizerHover.tooltip) {
      clipVisualizerHover.tooltip.title = '';
    }
    clipVisualizerHover = null;
  }

  function getClipSourceTimeAtRatio(clip, ratio) {
    if (!clip) return 0;
    const duration = Math.max(0.01, finiteNumber(clip.duration, 0.01));
    const localTime = Math.max(0, Math.min(duration, ratio * duration));
    const sourceOffset = integrateSpeedRamp(clip, localTime);
    const speed = normalizeClipSpeed(clip.speed, 1);
    const trimStart = Math.max(0, finiteNumber(clip.trimStart, 0));
    const trimEnd = Math.max(0, finiteNumber(clip.trimEnd, 0));
    const sourceDuration = Math.max(
      0,
      finiteNumber(clip.sourceDuration, finiteNumber(clip.duration, duration))
    );
    const targetTime =
      speed >= 0
        ? trimStart + sourceOffset
        : sourceDuration - trimEnd - sourceOffset;
    return Math.max(
      0,
      Math.min(Math.max(0, sourceDuration - 0.05), targetTime)
    );
  }

  function ensureTimelineVideoHover() {
    if (
      timelineVideoHover &&
      timelineVideoHover.root &&
      timelineVideoHover.root.isConnected
    )
      return timelineVideoHover;
    if (!el.timelineList) return null;
    const root = document.createElement('div');
    root.className = 'timeline-video-hover';
    root.setAttribute('aria-hidden', 'true');
    const video = document.createElement('video');
    video.muted = true;
    video.playsInline = true;
    video.preload = 'metadata';
    root.appendChild(video);
    const time = document.createElement('span');
    time.className = 'timeline-video-hover-time';
    root.appendChild(time);
    document.body.appendChild(root);
    timelineVideoHover = { root, video, time, clipId: '', src: '', seek: -1 };
    return timelineVideoHover;
  }

  function hideTimelineVideoHover() {
    if (!timelineVideoHover || !timelineVideoHover.root) return;
    timelineVideoHover.root.classList.remove('visible');
    timelineVideoHover.clipId = '';
    timelineVideoHover.seek = -1;
  }

  function handleTimelineVideoHover(event) {
    if (!el.timelineList) return;
    if (
      timelineClipPointerDrag ||
      timelineHandleDrag ||
      timelineStageHandleDrag
    ) {
      hideTimelineVideoHover();
      return;
    }
    const clipEl = event.target.closest('.timeline-clip.video');
    if (!clipEl || event.target.closest('.clip-controls')) {
      hideTimelineVideoHover();
      return;
    }
    const clipId = clipEl.getAttribute('data-clip-id');
    const clip = state.clips.find((item) => item && item.id === clipId);
    if (!clip || !clip.src) {
      hideTimelineVideoHover();
      return;
    }
    const rect = clipEl.getBoundingClientRect();
    const ratio =
      rect.width > 0
        ? Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width))
        : 0;
    const hover = ensureTimelineVideoHover();
    if (!hover) return;
    if (hover.src !== clip.src) {
      hover.video.src = clip.src;
      hover.src = clip.src;
      hover.seek = -1;
    }
    const sourceTime = getClipSourceTimeAtRatio(clip, ratio);
    if (Math.abs(hover.seek - sourceTime) > 0.08) {
      hover.seek = sourceTime;
      try {
        hover.video.pause();
        hover.video.currentTime = sourceTime;
      } catch (_) {}
    }
    const panelRect = (
      el.timelinePanel || el.timelineList
    ).getBoundingClientRect();
    const hoverWidth = 128;
    const hoverHeight = 72;
    const margin = 8;
    const minX = hoverWidth / 2 + margin;
    const maxX = window.innerWidth - hoverWidth / 2 - margin;
    const x = Math.max(minX, Math.min(maxX, event.clientX));
    const y = Math.max(margin, panelRect.top - hoverHeight - margin);
    hover.root.style.left = `${x}px`;
    hover.root.style.top = `${y}px`;
    hover.time.textContent = `${formatTimelineTimeValue(
      (clip.start || 0) + ratio * (clip.duration || 0),
      2
    )}s`;
    hover.root.classList.add('visible');
    hover.clipId = clipId;
  }

  function closeTimelineContextMenu() {
    if (!el.timelineContextMenu) return;
    el.timelineContextMenu.classList.remove('open');
    el.timelineContextMenu.classList.remove('is-sheet');
    el.timelineContextMenu.style.transform = '';
    el.timelineContextMenu.setAttribute('aria-hidden', 'true');
    el.timelineContextMenu.querySelectorAll('details').forEach((detail) => {
      detail.open = false;
    });
    updateTimelineContextOverlay();
    timelineContextTargetId = null;
  }

  function closeTimelineTrackMenu() {
    if (!el.timelineTrackMenu) return;
    el.timelineTrackMenu.classList.remove('open');
    el.timelineTrackMenu.classList.remove('is-sheet');
    el.timelineTrackMenu.style.transform = '';
    el.timelineTrackMenu.setAttribute('aria-hidden', 'true');
    el.timelineTrackMenu.querySelectorAll('details').forEach((detail) => {
      detail.open = false;
    });
    updateTimelineContextOverlay();
    timelineTrackContextTime = null;
  }

  function closeTimelineMarkerMenu() {
    if (!el.timelineMarkerMenu) return;
    el.timelineMarkerMenu.classList.remove('open');
    el.timelineMarkerMenu.classList.remove('is-sheet');
    el.timelineMarkerMenu.style.transform = '';
    el.timelineMarkerMenu.setAttribute('aria-hidden', 'true');
    updateTimelineContextOverlay();
    timelineMarkerContextIndex = null;
  }

  function updateTimelineContextOverlay() {
    if (!el.timelineContextOverlay) return;
    const sheetMenus = [
      el.timelineContextMenu,
      el.timelineTrackMenu,
      el.timelineMarkerMenu,
      el.stageContextMenu,
      el.stageBackgroundMenu,
      el.assetContextMenu,
    ];
    const active = sheetMenus.some(
      (menu) =>
        menu &&
        menu.classList.contains('open') &&
        menu.classList.contains('is-sheet')
    );
    el.timelineContextOverlay.classList.toggle('active', active);
    el.timelineContextOverlay.setAttribute(
      'aria-hidden',
      active ? 'false' : 'true'
    );
    document.body.classList.toggle('timeline-sheet-open', active);
  }

  function reorderSheetActions(menu, lastAction) {
    if (!menu || !lastAction || !timelineRememberQuickActions) return;
    const actions = menu.querySelector('.timeline-context-sheet-actions');
    if (!actions) return;
    const target = actions.querySelector(`[data-quick="${lastAction}"]`);
    if (target && actions.firstElementChild !== target) {
      actions.prepend(target);
    }
  }

  function expandTimelineContextSubmenus(menu) {
    if (!menu) return;
    menu.querySelectorAll('.timeline-context-submenu').forEach((detail) => {
      detail.open = true;
    });
  }

  function positionTimelineMenu(menu, x, y, useSheet) {
    if (!menu) return;
    if (useSheet) {
      menu.classList.add('is-sheet');
      menu.style.left = '';
      menu.style.right = '';
      menu.style.bottom = '';
      menu.style.top = '';
      updateTimelineContextOverlay();
      return;
    }
    menu.classList.remove('is-sheet');
    updateTimelineContextOverlay();
    const padding = 8;
    menu.style.maxHeight = `${Math.max(120, window.innerHeight - padding * 2)}px`;
    const menuRect = menu.getBoundingClientRect();
    const maxLeft = Math.max(
      padding,
      window.innerWidth - menuRect.width - padding
    );
    const maxTop = Math.max(
      padding,
      window.innerHeight - menuRect.height - padding
    );
    const left = Math.min(Math.max(padding, x), maxLeft);
    const top = Math.min(Math.max(padding, y), maxTop);
    menu.style.left = `${left}px`;
    menu.style.top = `${top}px`;
  }

  function openTimelineContextMenu(x, y, useSheet = false) {
    if (!el.timelineContextMenu) return;
    lastContextMenuOpenedAt = Date.now();
    el.timelineContextMenu.classList.add('open');
    el.timelineContextMenu.setAttribute('aria-hidden', 'false');
    positionTimelineMenu(el.timelineContextMenu, x, y, useSheet);
    if (useSheet) {
      reorderSheetActions(el.timelineContextMenu, lastTimelineClipQuickAction);
    }
    const count =
      state.selectedClipIds && state.selectedClipIds.length
        ? state.selectedClipIds.length
        : timelineContextTargetId
          ? 1
          : 0;
    if (el.timelineContextTitle) {
      el.timelineContextTitle.textContent =
        count > 1 ? `Clip Actions (${count})` : 'Clip Actions';
    }
    const copyButton = el.timelineContextMenu.querySelector(
      '[data-context-action="copy"]'
    );
    if (copyButton) {
      copyButton.textContent = count > 1 ? `Copy (${count})` : 'Copy';
    }
    const splitButton = el.timelineContextMenu.querySelector(
      '[data-context-action="split"]'
    );
    if (splitButton) {
      const selection =
        state.selectedClipIds && state.selectedClipIds.length
          ? state.selectedClipIds.slice()
          : timelineContextTargetId
            ? [timelineContextTargetId]
            : [];
      splitButton.disabled =
        !selection.length || !canSplitSelectionAtPlayhead(selection);
    }
    const clipboardCount = timelineClipboard?.length || 0;
    const pasteTitle = el.timelineContextMenu.querySelector(
      '#timeline-context-paste-title'
    );
    if (pasteTitle) {
      pasteTitle.textContent =
        clipboardCount > 1 ? `Paste (${clipboardCount})` : '';
      pasteTitle.style.display = clipboardCount > 1 ? 'block' : 'none';
    }
    const pasteSummary = el.timelineContextMenu.querySelector(
      '#timeline-context-paste summary'
    );
    if (pasteSummary) {
      pasteSummary.textContent =
        clipboardCount > 1 ? `Paste (${clipboardCount})` : 'Paste';
    }
    const pasteMenu = el.timelineContextMenu.querySelector(
      '#timeline-context-paste'
    );
    if (pasteMenu) {
      if (timelineRememberSubmenu && lastTimelineClipMenuSection === 'paste') {
        pasteMenu.open = true;
      } else {
        pasteMenu.open = clipboardCount > 0;
      }
    }
    el.timelineContextMenu
      .querySelectorAll('[data-context-paste-gap]')
      .forEach((button) => {
        const gap = parseFloat(button.dataset.contextPasteGap || '0');
        let label = gap > 0 ? `Paste +${gap}s gaps` : 'Paste';
        if (clipboardCount > 1) label += ` (${clipboardCount})`;
        button.textContent = label;
        button.disabled = clipboardCount === 0;
      });
    positionTimelineMenu(el.timelineContextMenu, x, y, useSheet);
  }

  function openTimelineTrackMenu(x, y, useSheet = false) {
    if (!el.timelineTrackMenu) return;
    lastContextMenuOpenedAt = Date.now();
    el.timelineTrackMenu.classList.add('open');
    el.timelineTrackMenu.setAttribute('aria-hidden', 'false');
    positionTimelineMenu(el.timelineTrackMenu, x, y, useSheet);
    if (useSheet) {
      reorderSheetActions(el.timelineTrackMenu, lastTimelineTrackQuickAction);
    }
    const count = timelineClipboard?.length || 0;
    el.timelineTrackMenu.querySelectorAll('details').forEach((detail) => {
      detail.open = false;
    });
    const pasteSummary = el.timelineTrackMenu.querySelector(
      '#timeline-track-paste summary'
    );
    if (pasteSummary) {
      pasteSummary.textContent = count > 1 ? `Paste (${count})` : 'Paste';
    }
    const pasteMenu = el.timelineTrackMenu.querySelector(
      '#timeline-track-paste'
    );
    const markersMenu = el.timelineTrackMenu.querySelector(
      '#timeline-track-markers'
    );
    const gapsMenu = el.timelineTrackMenu.querySelector('#timeline-track-gaps');
    const sectionMap = {
      paste: pasteMenu,
      markers: markersMenu,
      gaps: gapsMenu,
    };
    if (
      timelineRememberSubmenu &&
      lastTimelineTrackMenuSection &&
      sectionMap[lastTimelineTrackMenuSection]
    ) {
      sectionMap[lastTimelineTrackMenuSection].open = true;
    } else if (pasteMenu && count > 0) {
      pasteMenu.open = true;
    }
    const pasteButton = el.timelineTrackMenu.querySelector(
      '[data-track-action="paste"]'
    );
    if (pasteButton) {
      pasteButton.disabled = count === 0;
      pasteButton.textContent = count > 1 ? `Paste (${count})` : 'Paste';
    }
    const pastePlayhead = el.timelineTrackMenu.querySelector(
      '[data-track-action="paste-playhead"]'
    );
    if (pastePlayhead) {
      pastePlayhead.disabled = count === 0;
      pastePlayhead.textContent =
        count > 1 ? `Paste at playhead (${count})` : 'Paste at playhead';
    }
    el.timelineTrackMenu
      .querySelectorAll('[data-track-action="paste-spaced"]')
      .forEach((button) => {
        button.disabled = count === 0;
        if (count > 1) {
          button.textContent =
            button.textContent.replace(/\s*\(\d+\)$/, '') + ` (${count})`;
        } else {
          button.textContent = button.textContent.replace(/\s*\(\d+\)$/, '');
        }
      });
    el.timelineTrackMenu
      .querySelectorAll('[data-track-action="paste-spaced-playhead"]')
      .forEach((button) => {
        button.disabled = count === 0;
        if (count > 1) {
          button.textContent =
            button.textContent.replace(/\s*\(\d+\)$/, '') + ` (${count})`;
        } else {
          button.textContent = button.textContent.replace(/\s*\(\d+\)$/, '');
        }
      });
    expandTimelineContextSubmenus(el.timelineTrackMenu);
    positionTimelineMenu(el.timelineTrackMenu, x, y, useSheet);
  }

  function openTimelineMarkerMenu(x, y, index, useSheet = false) {
    if (!el.timelineMarkerMenu) return;
    lastContextMenuOpenedAt = Date.now();
    el.timelineMarkerMenu.classList.add('open');
    el.timelineMarkerMenu.setAttribute('aria-hidden', 'false');
    positionTimelineMenu(el.timelineMarkerMenu, x, y, useSheet);
    if (useSheet) {
      reorderSheetActions(el.timelineMarkerMenu, lastTimelineMarkerQuickAction);
    }
    timelineMarkerContextIndex = index;
  }

  function getTransitionSelection() {
    return state.selectedClipIds && state.selectedClipIds.length
      ? state.selectedClipIds.slice()
      : timelineContextTargetId
        ? [timelineContextTargetId]
        : state.selectedClipId
          ? [state.selectedClipId]
          : [];
  }

  function getPrimaryTransitionClip() {
    const selection = getTransitionSelection();
    const id = selection[0];
    return state.clips.find((clip) => clip.id === id) || null;
  }

  function applyTransitionToSelection(transition, options = {}) {
    const selection = getTransitionSelection();
    if (!selection.length) return;
    pushTimelineHistory('transition');
    const transitionValue = transition || 'none';
    const direction = options.direction || 'both';
    const nextDuration = transitionValue === 'none' ? 0 : 0.6;
    state.clips.forEach((clip) => {
      if (!selection.includes(clip.id)) return;
      clip.transition = transitionValue;
      if (direction === 'in' || direction === 'both') {
        clip.transitionIn = transitionValue;
      }
      if (direction === 'out' || direction === 'both') {
        clip.transitionOut = transitionValue;
      }
      if (transitionValue === 'none') {
        if (direction === 'both') clip.transitionDuration = 0;
        clip.transitionEase = 'linear';
      } else if (!clip.transitionDuration || clip.transitionDuration <= 0.05) {
        clip.transitionDuration = nextDuration;
      }
      if (!clip.transitionEase) {
        clip.transitionEase = 'linear';
      }
    });
    renderTimeline();
    renderInspector();
    syncTransitionPanel();
    scheduleAutosave();
  }

  function applyTransitionDurationToSelection(duration) {
    const selection = getTransitionSelection();
    if (!selection.length) return;
    const next = Math.max(0, parseFloat(duration) || 0);
    pushTimelineHistory('transition-duration');
    state.clips.forEach((clip) => {
      if (!selection.includes(clip.id)) return;
      clip.transitionDuration = next;
      if (!clip.transition || clip.transition === 'none') {
        clip.transition = 'crossfade';
      }
      if (!clip.transitionIn || clip.transitionIn === 'none') {
        clip.transitionIn = clip.transition;
      }
      if (!clip.transitionOut || clip.transitionOut === 'none') {
        clip.transitionOut = clip.transition;
      }
      if (!clip.transitionEase) {
        clip.transitionEase = 'linear';
      }
    });
    renderTimeline();
    renderInspector();
    syncTransitionPanel();
    scheduleAutosave();
  }

  function applyTransitionEaseToSelection(ease) {
    const selection = getTransitionSelection();
    if (!selection.length) return;
    const nextEase = normalizeEase(ease || 'linear');
    pushTimelineHistory('transition-ease');
    state.clips.forEach((clip) => {
      if (!selection.includes(clip.id)) return;
      clip.transitionEase = nextEase;
      if (!clip.transition || clip.transition === 'none') {
        clip.transition = 'crossfade';
      }
      if (!clip.transitionIn || clip.transitionIn === 'none') {
        clip.transitionIn = clip.transition;
      }
      if (!clip.transitionOut || clip.transitionOut === 'none') {
        clip.transitionOut = clip.transition;
      }
    });
    renderTimeline();
    renderInspector();
    syncTransitionPanel();
    scheduleAutosave();
  }

  function applyTransitionComboToSelection(duration, ease) {
    const selection = getTransitionSelection();
    if (!selection.length) return;
    const nextDuration = Math.max(0, parseFloat(duration) || 0);
    const nextEase = normalizeEase(ease || 'linear');
    pushTimelineHistory('transition-combo');
    state.clips.forEach((clip) => {
      if (!selection.includes(clip.id)) return;
      clip.transition = 'crossfade';
      clip.transitionIn = 'crossfade';
      clip.transitionOut = 'crossfade';
      clip.transitionDuration = nextDuration;
      clip.transitionEase = nextEase;
    });
    renderTimeline();
    renderInspector();
    syncTransitionPanel();
    scheduleAutosave();
  }

  function applyTransitionResetToSelection(ease) {
    const selection = getTransitionSelection();
    if (!selection.length) return;
    const nextEase = normalizeEase(ease || 'linear');
    pushTimelineHistory('transition-reset');
    state.clips.forEach((clip) => {
      if (!selection.includes(clip.id)) return;
      clip.transition = 'none';
      clip.transitionIn = 'none';
      clip.transitionOut = 'none';
      clip.transitionDuration = 0;
      clip.transitionEase = nextEase;
    });
    renderTimeline();
    renderInspector();
    syncTransitionPanel();
    scheduleAutosave();
  }

  function selectedTransitionValue(clip) {
    if (!clip) return 'none';
    if (transitionPanelDirection === 'in') {
      return clip.transitionIn || clip.transition || 'none';
    }
    if (transitionPanelDirection === 'out') {
      return clip.transitionOut || clip.transition || 'none';
    }
    const transitionIn = clip.transitionIn || clip.transition || 'none';
    const transitionOut = clip.transitionOut || clip.transition || 'none';
    return transitionIn === transitionOut ? transitionIn : 'mixed';
  }

  function syncTransitionPanel() {
    const clip = getPrimaryTransitionClip();
    const selection = getTransitionSelection();
    const disabled = !clip || clip.type === 'audio' || clip.type === 'caption';
    if (el.transitionsTarget) {
      if (!clip) {
        el.transitionsTarget.textContent = 'No clip';
      } else if (selection.length > 1) {
        el.transitionsTarget.textContent = `${selection.length} clips`;
      } else {
        el.transitionsTarget.textContent = clip.name || 'Clip';
      }
    }
    if (el.transitionDirectionButtons) {
      el.transitionDirectionButtons.forEach((button) => {
        const active =
          button.dataset.transitionDirection === transitionPanelDirection;
        button.classList.toggle('active', active);
        button.disabled = !clip;
      });
    }
    const activeTransition = selectedTransitionValue(clip);
    if (el.transitionGrid) {
      el.transitionGrid
        .querySelectorAll('[data-transition-choice]')
        .forEach((button) => {
          const value = button.dataset.transitionChoice || 'none';
          button.classList.toggle(
            'active',
            !disabled && value === activeTransition
          );
          button.disabled = disabled;
        });
    }
    const duration =
      clip && typeof clip.transitionDuration === 'number'
        ? Math.max(0, Math.min(2, clip.transitionDuration))
        : 0.6;
    if (el.transitionPanelDuration) {
      el.transitionPanelDuration.disabled = disabled;
      el.transitionPanelDuration.value = duration.toFixed(2);
    }
    if (el.transitionPanelDurationValue) {
      el.transitionPanelDurationValue.disabled = disabled;
      el.transitionPanelDurationValue.value = duration.toFixed(2);
    }
    const ease = normalizeEase(clip?.transitionEase || 'linear');
    if (el.transitionEaseButtons) {
      el.transitionEaseButtons.forEach((button) => {
        const active = button.dataset.transitionPanelEase === ease;
        button.classList.toggle('active', active);
        button.disabled = disabled;
      });
    }
    if (el.transitionPanelReset) el.transitionPanelReset.disabled = disabled;
  }

  function setTransitionPanelDirection(direction) {
    transitionPanelDirection =
      direction === 'in' || direction === 'out' ? direction : 'both';
    syncTransitionPanel();
  }

  function openTransitionsPanelForSelection() {
    closeTimelineContextMenu();
    activateSidebarTab('transitions');
    syncTransitionPanel();
  }

  function handleTransitionPanelDuration(value) {
    const next = Math.max(0, Math.min(2, parseFloat(value) || 0));
    if (el.transitionPanelDuration) {
      el.transitionPanelDuration.value = next.toFixed(2);
    }
    if (el.transitionPanelDurationValue) {
      el.transitionPanelDurationValue.value = next.toFixed(2);
    }
    applyTransitionDurationToSelection(next);
    renderFrameAt(state.playhead);
  }

  function addTimelineMarkerAtTime(time) {
    const next = Math.max(0, time || 0);
    const markers = normalizeTimelineMarkers(state.timelineMarkers);
    const existing = markers.find(
      (marker) => Math.abs(marker.time - next) < 0.01
    );
    if (existing) return;
    markers.push({ time: next, label: '' });
    markers.sort((a, b) => a.time - b.time);
    state.timelineMarkers = markers;
    scheduleAutosave();
    renderTimeline();
  }

  function clearTimelineLongPress() {
    if (timelineLongPressTimer) {
      clearTimeout(timelineLongPressTimer);
      timelineLongPressTimer = null;
    }
    timelineLongPressStart = null;
  }

  function fireHaptic(duration = 15) {
    try {
      if (
        typeof navigator !== 'undefined' &&
        typeof navigator.vibrate === 'function'
      ) {
        navigator.vibrate(duration);
      }
    } catch {}
  }

  function markLongPressMenu() {
    lastLongPressMenuAt = Date.now();
  }

  function suppressLongPressContextMenu() {
    return Date.now() - lastLongPressMenuAt < 700;
  }

  function bindLongPressMenu(target, onFire, shouldArm) {
    let pressStart = null;
    let pressTimer = null;
    const clearPress = () => {
      pressStart = null;
      if (pressTimer) {
        window.clearTimeout(pressTimer);
        pressTimer = null;
      }
    };
    target.addEventListener(
      'touchstart',
      (event) => {
        if (!event.touches || event.touches.length !== 1) return;
        const touchTarget = event.target;
        if (shouldArm && !shouldArm(touchTarget)) return;
        clearPress();
        const touch = event.touches[0];
        pressStart = { x: touch.clientX, y: touch.clientY };
        pressTimer = window.setTimeout(() => {
          pressTimer = null;
          if (!pressStart) return;
          const pos = pressStart;
          clearPress();
          markLongPressMenu();
          fireHaptic();
          onFire(pos);
        }, TIMELINE_LONG_PRESS_DELAY_MS);
      },
      { passive: true }
    );
    target.addEventListener(
      'touchmove',
      (event) => {
        if (!pressStart || !event.touches || !event.touches.length) return;
        const touch = event.touches[0];
        if (
          Math.abs(touch.clientX - pressStart.x) >
            TIMELINE_LONG_PRESS_MOVE_THRESHOLD ||
          Math.abs(touch.clientY - pressStart.y) >
            TIMELINE_LONG_PRESS_MOVE_THRESHOLD
        ) {
          clearPress();
        }
      },
      { passive: true }
    );
    target.addEventListener('touchend', clearPress);
    target.addEventListener('touchcancel', clearPress);
  }

  function handleTimelineLongPressStart(event) {
    if (!el.timelineList) return;
    if (!event.touches || event.touches.length !== 1) return;
    const target = event.target;
    if (!el.timelineList.contains(target)) return;
    if (target.closest('.clip-handle')) return;
    const touch = event.touches[0];
    clearTimelineLongPress();
    timelineLongPressStart = {
      x: touch.clientX,
      y: touch.clientY,
      target,
    };
    timelineLongPressTimer = window.setTimeout(() => {
      timelineLongPressTimer = null;
      const start = timelineLongPressStart;
      timelineLongPressStart = null;
      if (!start) return;
      fireHaptic();
      const clipEl = start.target.closest('.timeline-clip');
      if (clipEl) {
        const clipId = clipEl.getAttribute('data-clip-id');
        if (!clipId) return;
        timelineContextTargetId = clipId;
        if (!state.selectedClipIds.includes(clipId)) {
          setTimelineSelection([clipId], clipId);
          state.timelineSelectionAnchorId = clipId;
          clearSelectedAutomation();
          renderTimeline();
          renderInspector();
          renderAutomationHistoryPanel();
        }
        openTimelineContextMenu(start.x, start.y, true);
        return;
      }
      if (!el.timelineList || !el.timelineList.contains(start.target)) return;
      const rect = el.timelineList.getBoundingClientRect();
      const localX = start.x - rect.left + el.timelineList.scrollLeft;
      const pxPerSec = getTimelinePixelsPerSecond();
      timelineTrackContextTime = Math.max(0, localX / pxPerSec);
      openTimelineTrackMenu(start.x, start.y, true);
    }, TIMELINE_LONG_PRESS_DELAY_MS);
  }

  function handleTimelineLongPressMove(event) {
    if (!timelineLongPressStart || !event.touches || !event.touches.length)
      return;
    const touch = event.touches[0];
    if (
      Math.abs(touch.clientX - timelineLongPressStart.x) >
        TIMELINE_LONG_PRESS_MOVE_THRESHOLD ||
      Math.abs(touch.clientY - timelineLongPressStart.y) >
        TIMELINE_LONG_PRESS_MOVE_THRESHOLD
    ) {
      clearTimelineLongPress();
    }
  }

  function handleTimelineLongPressEnd() {
    clearTimelineLongPress();
  }

  function handleTimelineSheetDragStart(event) {
    if (!event.touches || event.touches.length !== 1) return;
    const target = event.target;
    if (!target.closest('.context-menu.is-sheet')) return;
    const menu = target.closest('.context-menu.is-sheet');
    if (!menu) return;
    const touch = event.touches[0];
    timelineSheetDragMenu = menu;
    timelineSheetDragStart = { y: touch.clientY };
  }

  function handleTimelineSheetDragMove(event) {
    if (
      !timelineSheetDragStart ||
      !timelineSheetDragMenu ||
      !event.touches ||
      !event.touches.length
    )
      return;
    const touch = event.touches[0];
    const deltaY = touch.clientY - timelineSheetDragStart.y;
    if (deltaY > 0) {
      timelineSheetDragMenu.style.transform = `translateY(${Math.min(deltaY, 140)}px)`;
    }
  }

  function handleTimelineSheetDragEnd() {
    if (!timelineSheetDragMenu || !timelineSheetDragStart) {
      timelineSheetDragMenu = null;
      timelineSheetDragStart = null;
      return;
    }
    const menu = timelineSheetDragMenu;
    const deltaY = menu.style.transform
      ? parseFloat(menu.style.transform.replace(/[^\d.-]/g, '')) || 0
      : 0;
    menu.style.transform = '';
    if (deltaY >= TIMELINE_SHEET_DRAG_THRESHOLD) {
      closeTimelineContextMenu();
      closeTimelineTrackMenu();
      closeTimelineMarkerMenu();
      hideStageContextMenu();
      hideStageBackgroundMenu();
      hideAssetContextMenu();
    }
    if (deltaY > 8 && deltaY < TIMELINE_SHEET_DRAG_THRESHOLD) {
      menu.classList.add('timeline-sheet-snap');
      if (timelineSheetSnapTimer) {
        clearTimeout(timelineSheetSnapTimer);
      }
      timelineSheetSnapTimer = window.setTimeout(() => {
        menu.classList.remove('timeline-sheet-snap');
        timelineSheetSnapTimer = null;
      }, 220);
    }
    timelineSheetDragMenu = null;
    timelineSheetDragStart = null;
  }

  function handleTimelineContextMenu(event) {
    const clipEl = event.target.closest('.timeline-clip');
    if (!clipEl) {
      if (!el.timelineList || !el.timelineList.contains(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      const rect = el.timelineList.getBoundingClientRect();
      const x = event.clientX - rect.left + el.timelineList.scrollLeft;
      const pxPerSec = getTimelinePixelsPerSecond();
      timelineTrackContextTime = Math.max(0, x / pxPerSec);
      openTimelineTrackMenu(event.clientX, event.clientY);
      return;
    }
    event.preventDefault();
    const clipId = clipEl.getAttribute('data-clip-id');
    if (!clipId) return;
    timelineContextTargetId = clipId;
    if (!state.selectedClipIds.includes(clipId)) {
      setTimelineSelection([clipId], clipId);
      state.timelineSelectionAnchorId = clipId;
      clearSelectedAutomation();
      renderTimeline();
      renderInspector();
      renderAutomationHistoryPanel();
    }
    openTimelineContextMenu(event.clientX, event.clientY);
  }

  function handleTimelineAction(event) {
    if (Date.now() < timelineSuppressClickUntil) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const target = event.target;
    if (!target) return;
    if (target.closest('.clip-handle')) return;
    const visualizer = target.closest('.clip-visualizer');
    const action = target.getAttribute('data-action');
    const clipId =
      target.getAttribute('data-clip-id') ||
      target.closest('.timeline-clip')?.getAttribute('data-clip-id');
    if (!clipId) return;
    const contextChanged = inspectorContext !== 'clip';
    inspectorContext = 'clip';
    scheduleStageInlineToolbarSync();
    if (visualizer) {
      const clip = state.clips.find((item) => item.id === clipId);
      if (clip && clip.duration > 0) {
        const rect = visualizer.getBoundingClientRect();
        const ratio =
          rect.width > 0
            ? Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width))
            : 0;
        if (!state.selectedClipIds.includes(clipId)) {
          setTimelineSelection([clipId], clipId);
          state.timelineSelectionAnchorId = clipId;
          clearSelectedAutomation();
          renderTimeline();
          renderInspector();
          renderAutomationHistoryPanel();
        } else if (contextChanged) {
          renderInspector();
        }
        state.playhead = clip.start + ratio * clip.duration;
        renderFrameAt(state.playhead);
        updateTimeLabel();
      }
      return;
    }
    if (!action) {
      const isToggle = event.metaKey || event.ctrlKey;
      const isRange = event.shiftKey;
      const order = state.clips.map((clip) => clip.id);
      const anchorId =
        state.timelineSelectionAnchorId || state.selectedClipId || clipId;
      if (isRange && order.length) {
        const start = order.indexOf(anchorId);
        const end = order.indexOf(clipId);
        if (start !== -1 && end !== -1) {
          const rangeIds = order.slice(
            Math.min(start, end),
            Math.max(start, end) + 1
          );
          if (isToggle) {
            const merged = new Set(state.selectedClipIds);
            rangeIds.forEach((id) => merged.add(id));
            setTimelineSelection(
              order.filter((id) => merged.has(id)),
              clipId
            );
          } else {
            setTimelineSelection(rangeIds, clipId);
          }
          state.timelineSelectionAnchorId = anchorId;
        } else {
          setTimelineSelection([clipId], clipId);
          state.timelineSelectionAnchorId = clipId;
        }
      } else if (isToggle) {
        const next = state.selectedClipIds.slice();
        const idx = next.indexOf(clipId);
        if (idx >= 0) {
          next.splice(idx, 1);
        } else {
          next.push(clipId);
        }
        setTimelineSelection(
          next,
          next.includes(clipId) ? clipId : state.selectedClipId
        );
        state.timelineSelectionAnchorId = clipId;
      } else {
        setTimelineSelection([clipId], clipId);
        state.timelineSelectionAnchorId = clipId;
      }
      clearSelectedAutomation();
      renderTimeline();
      renderInspector();
      renderAutomationHistoryPanel();
      renderFrameAt(state.playhead);
      updateTimeLabel();
      return;
    }
    if (action === 'remove') {
      removeTimelineSelection(
        state.selectedClipIds.includes(clipId) ? null : [clipId]
      );
      return;
    }
    if (action === 'move-left' || action === 'move-right') {
      if (contextChanged) {
        renderInspector();
      }
      moveTimelineSelection(action === 'move-left' ? -1 : 1, clipId);
      return;
    }
    if (action === 'toggle-mute' || action === 'toggle-solo') {
      const clip = state.clips.find((item) => item.id === clipId);
      if (!clip || !clipHasAudio(clip)) return;
      pushTimelineHistory('update');
      if (action === 'toggle-mute') {
        clip.audioMute = !clip.audioMute;
      } else {
        clip.audioSolo = !clip.audioSolo;
      }
      setTimelineSelection([clipId], clipId);
      renderTimeline();
      renderInspector();
      renderAutomationHistoryPanel();
      scheduleAutosave();
      return;
    }
  }

  function removeTimelineSelection(overrideIds) {
    const selection =
      Array.isArray(overrideIds) && overrideIds.length
        ? overrideIds
        : state.selectedClipIds.slice();
    if (!selection.length) return;
    const indices = selection
      .map((id) => state.clips.findIndex((clip) => clip.id === id))
      .filter((idx) => idx >= 0);
    if (!indices.length) return;
    const removeSet = new Set(selection);
    const removedClips = state.clips.filter((clip) => removeSet.has(clip.id));
    const removedStart = removedClips.length
      ? Math.min(...removedClips.map((clip) => clip.start))
      : state.playhead;
    pushTimelineHistory('remove');
    state.clips = state.clips.filter((clip) => !removeSet.has(clip.id));
    recalcTimeline();
    let nextSelected = null;
    if (state.clips.length) {
      const minIndex = Math.min(...indices);
      const nextIndex = Math.min(minIndex, state.clips.length - 1);
      nextSelected = state.clips[nextIndex].id;
    }
    setTimelineSelection(nextSelected ? [nextSelected] : [], nextSelected);
    if (removedClips.length) {
      state.playhead = Math.min(removedStart, totalDuration());
    }
    renderTimeline();
    renderInspector();
    renderFrameAt(state.playhead);
    updateTimeLabel();
    scheduleAutosave();
  }

  function moveTimelineSelection(direction, fallbackClipId) {
    const selection = state.selectedClipIds.includes(fallbackClipId)
      ? state.selectedClipIds.slice()
      : [fallbackClipId];
    if (!selection.length) return;
    const clips = state.clips.filter((clip) => selection.includes(clip.id));
    if (!clips.length) return;
    const minStart = Math.min(
      ...clips.map((clip) => (Number.isFinite(clip.start) ? clip.start : 0))
    );
    const minTrack = Math.min(...clips.map((clip) => getClipTrack(clip)));
    const step = 1 / Math.max(1, state.fps || 30);
    const nextTime = Math.max(0, minStart + (direction < 0 ? -step : step));
    if (Math.abs(nextTime - minStart) < TIMELINE_GAP_EPS) return;
    pushTimelineHistory('move');
    placeTimelineClipsAtTime(selection, nextTime, minTrack);
    renderTimeline();
    scheduleAutosave();
  }

  function moveTimelineSelectionToEdge(edge) {
    if (!state.selectedClipIds.length) return;
    const selection = new Set(state.selectedClipIds);
    const selectedClips = state.clips.filter((clip) => selection.has(clip.id));
    if (!selectedClips.length) return;
    const baseTrack = Math.min(
      ...selectedClips.map((clip) => getClipTrack(clip))
    );
    const remaining = state.clips.filter(
      (clip) => !selection.has(clip.id) && clip.type !== 'audio'
    );
    const remainingEnd = remaining.length
      ? Math.max(
          ...remaining.map(
            (clip) =>
              (Number.isFinite(clip.start) ? clip.start : 0) +
              (clip.duration || 0)
          )
        )
      : 0;
    const targetTime = edge === 'start' ? 0 : remainingEnd;
    pushTimelineHistory('move');
    placeTimelineClipsAtTime(Array.from(selection), targetTime, baseTrack);
    renderTimeline();
    scheduleAutosave();
  }

  function moveTimelineSelectionToPlayhead() {
    if (!state.selectedClipIds.length) return;
    const selection = new Set(state.selectedClipIds);
    const selectedClips = state.clips.filter((clip) => selection.has(clip.id));
    if (!selectedClips.length) return;
    const baseTrack = Math.min(
      ...selectedClips.map((clip) => getClipTrack(clip))
    );
    pushTimelineHistory('move');
    placeTimelineClipsAtTime(
      Array.from(selection),
      state.playhead || 0,
      baseTrack
    );
    renderTimeline();
    scheduleAutosave();
  }

  function alignTimelineSelection(edge) {
    if (!state.selectedClipIds.length) return;
    const selection = new Set(state.selectedClipIds);
    const indices = [];
    state.clips.forEach((clip, idx) => {
      if (selection.has(clip.id)) indices.push(idx);
    });
    if (indices.length < 2) return;
    const minIndex = Math.min(...indices);
    const maxIndex = Math.max(...indices);
    const segment = state.clips.slice(minIndex, maxIndex + 1);
    const selected = segment.filter((clip) => selection.has(clip.id));
    const unselected = segment.filter((clip) => !selection.has(clip.id));
    const packed =
      edge === 'end'
        ? [...unselected, ...selected]
        : [...selected, ...unselected];
    const isUnchanged = segment.every((clip, idx) => clip === packed[idx]);
    if (isUnchanged) return;
    pushTimelineHistory('reorder');
    state.clips = [
      ...state.clips.slice(0, minIndex),
      ...packed,
      ...state.clips.slice(maxIndex + 1),
    ];
    reorderTimelineSelection();
    recalcTimeline();
    renderTimeline();
    scheduleAutosave();
  }

  function reverseTimelineSelection() {
    if (!state.selectedClipIds.length) return;
    const selection = new Set(state.selectedClipIds);
    const indices = [];
    state.clips.forEach((clip, idx) => {
      if (selection.has(clip.id)) indices.push(idx);
    });
    if (indices.length < 2) return;
    const selectedClips = indices.map((idx) => state.clips[idx]).reverse();
    pushTimelineHistory('reorder');
    indices.forEach((idx, i) => {
      state.clips[idx] = selectedClips[i];
    });
    reorderTimelineSelection();
    recalcTimeline();
    renderTimeline();
    scheduleAutosave();
  }

  function cloneTimelineClip(clip, nameSuffix) {
    return {
      id: `clip_${Date.now()}_${Math.random().toString(16).slice(2)}`,
      assetId: clip.assetId,
      type: clip.type,
      name: nameSuffix ? `${clip.name} ${nameSuffix}` : clip.name,
      src: clip.src,
      text: clip.text,
      start: clip.start,
      track: clip.track,
      duration: clip.duration,
      sourceDuration: clip.sourceDuration,
      audioPeaks: clip.audioPeaks || null,
      audioPeaksDuration: clip.audioPeaksDuration || null,
      trimStart: clip.trimStart,
      trimEnd: clip.trimEnd,
      speed: clip.speed,
      audioGain: clip.audioGain,
      audioGainEnd: clip.audioGainEnd,
      audioPan: clip.audioPan,
      audioPanEnd: clip.audioPanEnd,
      audioMute: clip.audioMute,
      audioSolo: clip.audioSolo,
      audioFadeIn: clip.audioFadeIn,
      audioFadeOut: clip.audioFadeOut,
      audioGainKeyframes: cloneKeyframes(clip.audioGainKeyframes),
      audioPanKeyframes: cloneKeyframes(clip.audioPanKeyframes),
      speedKeyframes: cloneKeyframes(clip.speedKeyframes),
      transition: clip.transition,
      transitionIn: clip.transitionIn,
      transitionOut: clip.transitionOut,
      transitionDuration: clip.transitionDuration,
      transitionEase: clip.transitionEase,
      element: clip.element,
      captionFontSize: clip.captionFontSize,
      captionColor: clip.captionColor,
      captionAlign: clip.captionAlign,
      captionY: clip.captionY,
      focusX: clip.focusX,
      focusY: clip.focusY,
      resizeMode: clip.resizeMode,
    };
  }

  function hasTimelineClipboard() {
    return Array.isArray(timelineClipboard) && timelineClipboard.length > 0;
  }

  function copyTimelineSelectionToClipboard() {
    const selection =
      state.selectedClipIds && state.selectedClipIds.length
        ? state.selectedClipIds.slice()
        : [];
    if (!selection.length) return;
    timelineClipboard = selection.slice();
    notify(
      `Copied ${selection.length} clip${selection.length > 1 ? 's' : ''}`,
      'success'
    );
  }

  function getTimelineInsertIndexForTime(time) {
    const target = Math.max(0, time || 0);
    const index = state.clips.findIndex(
      (clip) => clip.start + clip.duration > target
    );
    return index === -1 ? state.clips.length : index;
  }

  function pasteTimelineClipboard(atTime) {
    if (!hasTimelineClipboard()) return;
    const sourceClips = timelineClipboard
      .map((id) => state.clips.find((clip) => clip.id === id))
      .filter(Boolean);
    if (!sourceClips.length) return;
    const clones = sourceClips.map((clip) => {
      const next = cloneTimelineClip(clip, 'copy');
      next.start = Number.isFinite(clip.start) ? clip.start : 0;
      next.track = getClipTrack(clip);
      return next;
    });
    pushTimelineHistory('add');
    state.clips = [...state.clips, ...clones];
    const baseTrack = Math.min(...clones.map((clip) => getClipTrack(clip)));
    placeTimelineClipsAtTime(
      clones.map((clip) => clip.id),
      atTime,
      baseTrack
    );
    const newIds = clones.map((clip) => clip.id);
    setTimelineSelection(newIds, newIds[0] || null);
    renderTimeline();
    renderInspector();
    renderAutomationHistoryPanel();
    scheduleAutosave();
    notify(
      `Pasted ${clones.length} clip${clones.length > 1 ? 's' : ''}`,
      'success'
    );
  }

  function pasteTimelineClipboardSpaced(atTime, gapSeconds) {
    if (!hasTimelineClipboard()) return;
    const sourceClips = timelineClipboard
      .map((id) => state.clips.find((clip) => clip.id === id))
      .filter(Boolean);
    if (!sourceClips.length) return;
    const gap = Math.max(0, Number(gapSeconds) || 0);
    const clones = sourceClips.map((clip) => {
      const next = cloneTimelineClip(clip, 'copy');
      next.start = Number.isFinite(clip.start) ? clip.start : 0;
      next.track = getClipTrack(clip);
      return next;
    });
    pushTimelineHistory('add');
    state.clips = [...state.clips, ...clones];
    const baseTrack = Math.min(...clones.map((clip) => getClipTrack(clip)));
    placeTimelineClipsAtTime(
      clones.map((clip) => clip.id),
      (atTime || 0) + gap,
      baseTrack
    );
    const newIds = clones.map((clip) => clip.id);
    setTimelineSelection(newIds, newIds[0] || null);
    renderTimeline();
    renderInspector();
    renderAutomationHistoryPanel();
    scheduleAutosave();
    notify(
      `Pasted ${clones.length} clip${clones.length > 1 ? 's' : ''}`,
      'success'
    );
  }

  function splitKeyframesAtTime(list, splitTime) {
    const sorted = cloneKeyframes(list);
    if (!sorted.length) return [[], []];
    const left = [];
    const right = [];
    sorted.forEach((kf) => {
      if (kf.time <= splitTime) {
        left.push({ ...kf });
      } else {
        right.push({ ...kf, time: Math.max(0, kf.time - splitTime) });
      }
    });
    return [left, right];
  }

  function duplicateTimelineSelection() {
    if (!state.selectedClipIds.length) return;
    const selection = new Set(state.selectedClipIds);
    const selectedClips = state.clips.filter((clip) => selection.has(clip.id));
    if (!selectedClips.length) return;
    const maxEnd = Math.max(
      ...selectedClips.map(
        (clip) =>
          (Number.isFinite(clip.start) ? clip.start : 0) + (clip.duration || 0)
      )
    );
    const duplicates = selectedClips.map((clip) => {
      const next = cloneTimelineClip(clip, 'copy');
      next.start = Number.isFinite(clip.start) ? clip.start : 0;
      next.track = getClipTrack(clip);
      return next;
    });
    pushTimelineHistory('add');
    state.clips = [...state.clips, ...duplicates];
    const baseTrack = Math.min(...duplicates.map((clip) => getClipTrack(clip)));
    placeTimelineClipsAtTime(
      duplicates.map((clip) => clip.id),
      maxEnd,
      baseTrack
    );
    const newIds = duplicates.map((clip) => clip.id);
    setTimelineSelection(newIds, newIds[0] || null);
    renderTimeline();
    renderInspector();
    renderAutomationHistoryPanel();
    scheduleAutosave();
  }

  function splitTimelineSelectionAtPlayhead() {
    const targetIds = getSplitTargetIdsAtPlayhead(state.selectedClipIds);
    if (!targetIds.length || !canSplitSelectionAtPlayhead(targetIds)) return;
    const targetSet = new Set(targetIds);
    const splitAt = state.playhead;
    pushTimelineHistory('update-split');
    const nextClips = [];
    const newSelection = [];
    state.clips.forEach((clip) => {
      if (!targetSet.has(clip.id)) {
        nextClips.push(clip);
        return;
      }
      const localTime = splitAt - clip.start;
      if (localTime <= 0.05 || localTime >= clip.duration - 0.05) {
        nextClips.push(clip);
        return;
      }
      const originalTrack = getClipTrack(clip);
      const originalTrimEnd = Number.isFinite(clip.trimEnd) ? clip.trimEnd : 0;
      const first = clip;
      const second = cloneTimelineClip(clip, 'part 2');
      second.start = splitAt;
      second.track = originalTrack;
      if (clip.type === 'video') {
        const sourceDuration = clip.sourceDuration || clip.duration || 0;
        const speed = clip.speed || 1;
        const absSpeed = Math.abs(speed);
        const splitPoint = Math.max(
          0,
          Math.min(sourceDuration, clip.trimStart + localTime * absSpeed)
        );
        first.trimEnd = Math.max(0, sourceDuration - splitPoint);
        first.duration = Math.max(
          0.1,
          (sourceDuration - first.trimStart - first.trimEnd) / absSpeed
        );
        second.trimStart = splitPoint;
        second.trimEnd = originalTrimEnd;
        second.duration = Math.max(
          0.1,
          (sourceDuration - second.trimStart - second.trimEnd) / absSpeed
        );
      } else {
        first.duration = Math.max(0.1, localTime);
        second.duration = Math.max(0.1, clip.duration - localTime);
      }
      const [gainLeft, gainRight] = splitKeyframesAtTime(
        clip.audioGainKeyframes,
        localTime
      );
      const [panLeft, panRight] = splitKeyframesAtTime(
        clip.audioPanKeyframes,
        localTime
      );
      const [speedLeft, speedRight] = splitKeyframesAtTime(
        clip.speedKeyframes,
        localTime
      );
      first.audioGainKeyframes = gainLeft;
      second.audioGainKeyframes = gainRight;
      first.audioPanKeyframes = panLeft;
      second.audioPanKeyframes = panRight;
      first.speedKeyframes = speedLeft;
      second.speedKeyframes = speedRight;
      second.transition = 'none';
      nextClips.push(first, second);
      newSelection.push(first.id, second.id);
    });
    state.clips = nextClips;
    recalcTimeline();
    setTimelineSelection(newSelection, newSelection[0] || null);
    renderTimeline();
    renderInspector();
    renderAutomationHistoryPanel();
    scheduleAutosave();
  }

  function canSplitSelectionAtPlayhead(targetIds) {
    const targetSet = new Set(targetIds);
    const splitAt = state.playhead;
    return state.clips.some((clip) => {
      if (!targetSet.has(clip.id)) return false;
      const localTime = splitAt - clip.start;
      return localTime > 0.05 && localTime < clip.duration - 0.05;
    });
  }

  function getSplitTargetIdsAtPlayhead(targetIds) {
    const ids = Array.isArray(targetIds) ? targetIds.filter(Boolean) : [];
    if (ids.length) return ids;
    const splitAt = state.playhead;
    const clipAtPlayhead = state.clips.find((clip) => {
      if (!clip) return false;
      const start = Number.isFinite(clip.start) ? clip.start : 0;
      const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
      return splitAt > start + 0.05 && splitAt < start + duration - 0.05;
    });
    return clipAtPlayhead ? [clipAtPlayhead.id] : [];
  }

  function canSplitTimelineAtPlayhead(targetIds) {
    const ids = getSplitTargetIdsAtPlayhead(targetIds);
    return ids.length > 0 && canSplitSelectionAtPlayhead(ids);
  }

  function updateTimelineSelectionBar() {
    if (!el.timelineSelectionBar) return;
    const ids =
      state.selectedClipIds && state.selectedClipIds.length
        ? state.selectedClipIds.slice()
        : state.selectedClipId
          ? [state.selectedClipId]
          : [];
    const selection = new Set(ids);
    const selectedClips = state.clips.filter((clip) => selection.has(clip.id));
    const count = selectedClips.length;
    const hasSelection = count > 0;
    el.timelineSelectionBar.setAttribute(
      'aria-hidden',
      hasSelection ? 'false' : 'true'
    );
    if (hasSelection) {
      el.timelineSelectionBar.removeAttribute('inert');
      el.timelineSelectionBar.dataset.hidden = '0';
    } else {
      el.timelineSelectionBar.setAttribute('inert', '');
      el.timelineSelectionBar.dataset.hidden = '1';
    }
    const dupBtn = getEl('timeline-selection-duplicate');
    const splitBtn = getEl('timeline-selection-split');
    const deleteBtn = getEl('timeline-selection-delete');
    if (dupBtn && !dupBtn.textContent) dupBtn.textContent = 'Dup';
    if (splitBtn && !splitBtn.textContent) splitBtn.textContent = 'Split';
    if (deleteBtn && !deleteBtn.textContent) deleteBtn.textContent = 'Del';
    if (dupBtn) {
      const enabled = hasSelection;
      dupBtn.disabled = !enabled;
      dupBtn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }
    if (deleteBtn) {
      const enabled = hasSelection;
      deleteBtn.disabled = !enabled;
      deleteBtn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }
    if (splitBtn) {
      const enabled = hasSelection && canSplitTimelineAtPlayhead(ids);
      splitBtn.disabled = !enabled;
      splitBtn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }
  }

  function getClipStart(clipId) {
    const clip = state.clips.find((item) => item.id === clipId);
    return clip ? clip.start : 0;
  }

  function normalizeClipIds(ids) {
    const valid = new Set(state.clips.map((clip) => clip.id));
    const seen = new Set();
    const next = [];
    if (Array.isArray(ids)) {
      ids.forEach((id) => {
        if (!id || seen.has(id) || !valid.has(id)) return;
        seen.add(id);
        next.push(id);
      });
    }
    return next;
  }

  function setTimelineSelection(ids, primaryId) {
    const next = normalizeClipIds(ids);
    state.selectedClipIds = next;
    if (primaryId && next.includes(primaryId)) {
      state.selectedClipId = primaryId;
    } else {
      state.selectedClipId = next[0] || null;
    }
    if (!state.selectedClipId) {
      state.timelineSelectionAnchorId = null;
    }
  }

  function reorderTimelineSelection() {
    if (!state.selectedClipIds.length) return;
    const selection = new Set(state.selectedClipIds);
    state.selectedClipIds = state.clips
      .filter((clip) => selection.has(clip.id))
      .map((clip) => clip.id);
    if (state.selectedClipId && !selection.has(state.selectedClipId)) {
      state.selectedClipId = state.selectedClipIds[0] || null;
    }
  }

  function selectClip(clipId) {
    inspectorContext = 'clip';
    setTimelineSelection(clipId ? [clipId] : [], clipId);
    state.timelineSelectionAnchorId = clipId || null;
    clearSelectedAutomation();
    renderTimeline();
    syncStageSelectionForClip(getSelectedClip());
    renderInspector();
    renderAutomationHistoryPanel();
  }

  function selectAllTimelineClips() {
    const ids = state.clips.map((clip) => clip.id);
    if (!ids.length) return;
    setTimelineSelection(ids, ids[0]);
    state.timelineSelectionAnchorId = ids[0];
    renderTimeline();
    renderInspector();
    renderAutomationHistoryPanel();
  }

  function syncStageSelectionForClip(clip) {
    if (
      !clip ||
      !Array.isArray(state.stageElements) ||
      !state.stageElements.length
    )
      return;
    const match = state.stageElements.find((element) => {
      if (element.hidden) return false;
      if (!clipMatchesStageElement(clip, element)) return false;
      return true;
    });
    if (match) {
      selectStageElement(match.id, { source: 'clip' });
    }
  }

  function getSelectedClip() {
    return state.clips.find((clip) => clip.id === state.selectedClipId) || null;
  }

  function renderInspector() {
    const stageSelected =
      Array.isArray(state.selectedStageElementIds) &&
      state.selectedStageElementIds.length > 0;
    const clip = getSelectedClip();
    const stageMode = inspectorContext === 'stage';
    const isCaption = !!clip && clip.type === 'caption';
    if (el.inspectorPanel)
      el.inspectorPanel.classList.toggle('stage-mode', stageMode);
    if (el.inspectorPanel)
      el.inspectorPanel.classList.toggle(
        'caption-clip',
        !stageMode && isCaption
      );
    if (el.inspectorContextClip) {
      el.inspectorContextClip.classList.toggle('active', !stageMode);
      el.inspectorContextClip.setAttribute(
        'aria-pressed',
        stageMode ? 'false' : 'true'
      );
    }
    if (el.inspectorContextStage) {
      el.inspectorContextStage.classList.toggle('active', stageMode);
      el.inspectorContextStage.setAttribute(
        'aria-pressed',
        stageMode ? 'true' : 'false'
      );
    }
    if (stageMode) {
      if (el.inspectorPanel) el.inspectorPanel.classList.remove('is-empty');
      if (el.inspectorPanel) el.inspectorPanel.classList.remove('caption-clip');
      if (el.videoEditorBody)
        el.videoEditorBody.classList.remove('inspector-empty');
      if (el.inspectorEmpty) el.inspectorEmpty.style.display = 'none';
      if (el.inspectorFields) el.inspectorFields.style.display = 'none';
      if (el.inspectorPins) el.inspectorPins.style.display = 'none';
      if (el.inspectorTitle) {
        if (stageSelected) {
          el.inspectorTitle.setAttribute(
            'data-clip-count',
            String(state.selectedStageElementIds.length)
          );
        } else {
          el.inspectorTitle.removeAttribute('data-clip-count');
        }
      }
      drawClipAutomationPreview(null);
      clearSelectedAutomation();
      hideAutomationTooltip();
      if (el.clipAutomationPlayhead)
        el.clipAutomationPlayhead.style.opacity = '0';
      syncTransitionPanel();
      return;
    }
    if (!clip) {
      if (el.inspectorPanel) el.inspectorPanel.classList.add('is-empty');
      if (el.inspectorPanel) el.inspectorPanel.classList.remove('caption-clip');
      if (el.videoEditorBody)
        el.videoEditorBody.classList.add('inspector-empty');
      if (el.inspectorTitle)
        el.inspectorTitle.removeAttribute('data-clip-count');
      if (el.inspectorEmpty) el.inspectorEmpty.style.display = 'block';
      if (el.inspectorFields) el.inspectorFields.style.display = 'none';
      if (el.inspectorPins) el.inspectorPins.style.display = 'none';
      drawClipAutomationPreview(null);
      clearSelectedAutomation();
      hideAutomationTooltip();
      if (el.clipAutomationPlayhead)
        el.clipAutomationPlayhead.style.opacity = '0';
      syncTransitionPanel();
      return;
    }
    if (el.inspectorPanel) el.inspectorPanel.classList.remove('is-empty');
    if (el.videoEditorBody)
      el.videoEditorBody.classList.remove('inspector-empty');
    if (el.inspectorEmpty) el.inspectorEmpty.style.display = 'none';
    if (el.inspectorTitle) {
      const count =
        state.selectedClipIds && state.selectedClipIds.length
          ? state.selectedClipIds.length
          : 1;
      el.inspectorTitle.setAttribute('data-clip-count', String(count));
    }
    if (el.inspectorFields) el.inspectorFields.style.display = 'block';
    el.clipName.value = clip.name;
    el.clipDuration.value = clip.duration.toFixed(2);
    if (el.clipCaptionText) el.clipCaptionText.value = clip.text || '';
    if (el.clipCaptionFontSize)
      el.clipCaptionFontSize.value = String(
        Math.round(clip.captionFontSize || DEFAULT_CAPTION_STYLE.fontSize)
      );
    updateCaptionColorControls(
      clip.captionColor || DEFAULT_CAPTION_STYLE.color
    );
    if (el.clipCaptionAlign)
      el.clipCaptionAlign.value =
        clip.captionAlign || DEFAULT_CAPTION_STYLE.align;
    if (el.clipCaptionY)
      el.clipCaptionY.value = String(
        Math.round(clip.captionY || DEFAULT_CAPTION_STYLE.y)
      );
    el.clipTrimStart.value = clip.trimStart.toFixed(2);
    el.clipTrimEnd.value = clip.trimEnd.toFixed(2);
    const sourceDuration = clip.sourceDuration || clip.duration || 0;
    const maxStart = Math.max(0, sourceDuration - clip.trimEnd - 0.1);
    const maxEnd = Math.max(0, sourceDuration - clip.trimStart - 0.1);
    if (el.clipTrimStartRange) {
      el.clipTrimStartRange.min = '0';
      el.clipTrimStartRange.max = maxStart.toFixed(2);
      el.clipTrimStartRange.step = '0.1';
      el.clipTrimStartRange.value = clip.trimStart.toFixed(2);
    }
    if (el.clipTrimEndRange) {
      el.clipTrimEndRange.min = '0';
      el.clipTrimEndRange.max = maxEnd.toFixed(2);
      el.clipTrimEndRange.step = '0.1';
      el.clipTrimEndRange.value = clip.trimEnd.toFixed(2);
    }
    clip.speed = normalizeClipSpeed(clip.speed, 1);
    el.clipSpeed.value = clip.speed.toFixed(2);
    if (el.clipSpeedRange) {
      el.clipSpeedRange.value = clip.speed.toFixed(2);
    }
    renderSpeedRampList(clip);
    if (el.clipAudioGain)
      el.clipAudioGain.value = (clip.audioGain ?? 1).toFixed(2);
    if (el.clipAudioGainEnd)
      el.clipAudioGainEnd.value = (
        clip.audioGainEnd ??
        clip.audioGain ??
        1
      ).toFixed(2);
    if (el.clipAudioPan)
      el.clipAudioPan.value = (clip.audioPan ?? 0).toFixed(2);
    if (el.clipAudioPanEnd)
      el.clipAudioPanEnd.value = (
        clip.audioPanEnd ??
        clip.audioPan ??
        0
      ).toFixed(2);
    if (el.clipAudioMute) el.clipAudioMute.checked = !!clip.audioMute;
    if (el.clipAudioSolo) el.clipAudioSolo.checked = !!clip.audioSolo;
    if (el.clipAudioFadeIn)
      el.clipAudioFadeIn.value = (clip.audioFadeIn ?? 0).toFixed(2);
    if (el.clipAudioFadeOut)
      el.clipAudioFadeOut.value = (clip.audioFadeOut ?? 0).toFixed(2);
    if (el.clipAutomationGridToggle)
      el.clipAutomationGridToggle.checked = !!state.showAutomationBeatGrid;
    if (el.clipTransitionIn) {
      el.clipTransitionIn.value =
        clip.transitionIn || clip.transition || 'none';
    }
    if (el.clipTransitionOut) {
      el.clipTransitionOut.value =
        clip.transitionOut || clip.transition || 'none';
    }
    const durationValue =
      typeof clip.transitionDuration === 'number'
        ? clip.transitionDuration
        : 0.6;
    el.clipTransitionDuration.value = durationValue.toFixed(2);
    drawClipAutomationPreview(clip);
    renderAudioGainKeyframes(clip);
    renderAudioPanKeyframes(clip);
    renderInspectorPins(clip);
    syncTransitionPanel();
  }

  function updateClipField(field, value, options) {
    const clip = getSelectedClip();
    if (!clip) return;
    const opts = options || {};
    if (!opts.skipHistory) {
      pushTimelineHistory(`update-${field}`);
    }
    if (field === 'name') {
      clip.name = value || clip.name;
    } else if (field === 'text') {
      clip.text = String(value || '').trim();
      if (clip.type === 'caption') {
        clip.name =
          clip.text.length > 36
            ? `${clip.text.slice(0, 36)}…`
            : clip.text || 'Caption';
      }
    } else if (field === 'captionFontSize') {
      const next = Math.max(
        12,
        parseFloat(value) || DEFAULT_CAPTION_STYLE.fontSize
      );
      clip.captionFontSize = next;
    } else if (field === 'captionColor') {
      clip.captionColor = normalizeHexColor(value, DEFAULT_CAPTION_STYLE.color);
      updateCaptionColorControls(clip.captionColor);
    } else if (field === 'captionAlign') {
      clip.captionAlign = value || DEFAULT_CAPTION_STYLE.align;
    } else if (field === 'captionY') {
      const next = Math.max(
        5,
        Math.min(95, parseFloat(value) || DEFAULT_CAPTION_STYLE.y)
      );
      clip.captionY = next;
    } else if (field === 'duration') {
      let next = parseFloat(value);
      if (!isNaN(next) && next > 0) {
        next = Math.max(0.1, snapToBeat(next));
        clip.duration = next;
      }
    } else if (field === 'trimStart') {
      const next = Math.max(0, snapToBeat(parseFloat(value) || 0));
      const maxStart = Math.max(
        0,
        (clip.sourceDuration || clip.duration || 0) - clip.trimEnd - 0.1
      );
      clip.trimStart = Math.min(next, maxStart);
      if (clip.type === 'video') {
        const usable = Math.max(
          0.1,
          clip.sourceDuration - clip.trimStart - clip.trimEnd
        );
        clip.duration = usable / Math.abs(clip.speed || 1);
      }
    } else if (field === 'trimEnd') {
      const next = Math.max(0, snapToBeat(parseFloat(value) || 0));
      const maxEnd = Math.max(
        0,
        (clip.sourceDuration || clip.duration || 0) - clip.trimStart - 0.1
      );
      clip.trimEnd = Math.min(next, maxEnd);
      if (clip.type === 'video') {
        const usable = Math.max(
          0.1,
          clip.sourceDuration - clip.trimStart - clip.trimEnd
        );
        clip.duration = usable / Math.abs(clip.speed || 1);
      }
    } else if (field === 'speed') {
      let next = normalizeClipSpeed(value, clip.speed || 1);
      clip.speed = next;
      if (clip.type === 'video') {
        const sourceDuration = finiteNumber(
          clip.sourceDuration,
          finiteNumber(clip.duration, 0)
        );
        const trimStart = Math.max(0, finiteNumber(clip.trimStart, 0));
        const trimEnd = Math.max(0, finiteNumber(clip.trimEnd, 0));
        const usable = Math.max(0.1, sourceDuration - trimStart - trimEnd);
        clip.duration = usable / Math.abs(clip.speed);
      }
    } else if (field === 'audioGain') {
      const next = Math.max(0, parseFloat(value) || 0);
      const prev = typeof clip.audioGain === 'number' ? clip.audioGain : 1;
      const prevEnd =
        typeof clip.audioGainEnd === 'number' ? clip.audioGainEnd : prev;
      clip.audioGain = next;
      if (Math.abs(prevEnd - prev) < 0.001) {
        clip.audioGainEnd = next;
      }
    } else if (field === 'audioGainEnd') {
      const next = Math.max(0, parseFloat(value) || 0);
      clip.audioGainEnd = next;
    } else if (field === 'audioPan') {
      let next = parseFloat(value);
      if (isNaN(next)) next = 0;
      const prev = typeof clip.audioPan === 'number' ? clip.audioPan : 0;
      const prevEnd =
        typeof clip.audioPanEnd === 'number' ? clip.audioPanEnd : prev;
      clip.audioPan = Math.max(-1, Math.min(1, next));
      if (Math.abs(prevEnd - prev) < 0.001) {
        clip.audioPanEnd = clip.audioPan;
      }
    } else if (field === 'audioPanEnd') {
      let next = parseFloat(value);
      if (isNaN(next)) next = 0;
      clip.audioPanEnd = Math.max(-1, Math.min(1, next));
    } else if (field === 'audioMute') {
      clip.audioMute = !!value;
    } else if (field === 'audioSolo') {
      clip.audioSolo = !!value;
    } else if (field === 'audioFadeIn') {
      const next = Math.max(0, parseFloat(value) || 0);
      clip.audioFadeIn = next;
    } else if (field === 'audioFadeOut') {
      const next = Math.max(0, parseFloat(value) || 0);
      clip.audioFadeOut = next;
    } else if (field === 'transition') {
      clip.transition = value || 'none';
      clip.transitionIn = clip.transition;
      clip.transitionOut = clip.transition;
    } else if (field === 'transitionDuration') {
      const next = Math.max(0, parseFloat(value) || 0);
      clip.transitionDuration = next;
      if (
        (clip.transitionIn && clip.transitionIn !== 'none') ||
        (clip.transitionOut && clip.transitionOut !== 'none')
      ) {
        if (!clip.transition || clip.transition === 'none') {
          clip.transition = 'crossfade';
        }
      }
    } else if (field === 'transitionIn') {
      clip.transitionIn = value || 'none';
      if (
        clip.transitionIn !== 'none' &&
        (!clip.transition || clip.transition === 'none')
      ) {
        clip.transition = 'crossfade';
      }
      if (
        clip.transitionIn !== 'none' &&
        (!clip.transitionDuration || clip.transitionDuration <= 0.05)
      ) {
        clip.transitionDuration = 0.6;
      }
    } else if (field === 'transitionOut') {
      clip.transitionOut = value || 'none';
      if (
        clip.transitionOut !== 'none' &&
        (!clip.transition || clip.transition === 'none')
      ) {
        clip.transition = 'crossfade';
      }
      if (
        clip.transitionOut !== 'none' &&
        (!clip.transitionDuration || clip.transitionDuration <= 0.05)
      ) {
        clip.transitionDuration = 0.6;
      }
    }
    recalcTimeline();
    renderTimeline();
    renderInspector();
    renderFrameAt(state.playhead);
    if (!opts.skipAutosave) {
      scheduleAutosave();
    }
  }

  function findClipAt(timeSec) {
    const candidates = state.clips.filter((clip) => {
      if (!clip || clip.type === 'audio' || clip.type === 'caption')
        return false;
      const start = Number.isFinite(clip.start) ? clip.start : 0;
      const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
      return timeSec >= start - TIMELINE_GAP_EPS && timeSec < start + duration;
    });
    if (!candidates.length) return null;
    candidates.sort((a, b) => {
      const trackDiff = getClipTrack(a) - getClipTrack(b);
      if (trackDiff !== 0) return trackDiff;
      const startDiff = (a.start || 0) - (b.start || 0);
      if (startDiff !== 0) return startDiff;
      return (a.id || '').localeCompare(b.id || '');
    });
    return candidates[candidates.length - 1] || null;
  }

  function findCaptionClipsAt(timeSec) {
    return state.clips
      .filter((clip) => {
        if (!isCaptionClip(clip)) return false;
        const start = Number.isFinite(clip.start) ? clip.start : 0;
        const duration = Number.isFinite(clip.duration) ? clip.duration : 0;
        return (
          timeSec >= start - TIMELINE_GAP_EPS && timeSec < start + duration
        );
      })
      .sort((a, b) => {
        const trackDiff = getClipTrack(a) - getClipTrack(b);
        if (trackDiff !== 0) return trackDiff;
        return (a.start || 0) - (b.start || 0);
      });
  }

  function getVideoClipSourceTime(clip, localTime) {
    if (!clip || clip.type !== 'video') return null;
    const sourceOffset = integrateSpeedRamp(clip, localTime);
    const speed = normalizeClipSpeed(clip.speed, 1);
    const trimStart = Math.max(0, finiteNumber(clip.trimStart, 0));
    const trimEnd = Math.max(0, finiteNumber(clip.trimEnd, 0));
    const sourceDuration = Math.max(
      0,
      finiteNumber(clip.sourceDuration, finiteNumber(clip.duration, 0))
    );
    const targetTime =
      speed >= 0
        ? trimStart + sourceOffset
        : sourceDuration - trimEnd - sourceOffset;
    return finiteNumber(targetTime, 0);
  }

  function getRenderVideoSeekTargets(timeSec) {
    const clip = findClipAt(timeSec);
    if (!clip) return [];
    const localTime = timeSec - clip.start;
    const clips = [clip];
    const transitionIn = clip.transitionIn || clip.transition || 'none';
    const transitionOut = clip.transitionOut || clip.transition || 'none';
    const transitionDuration =
      transitionIn !== 'none' || transitionOut !== 'none'
        ? Math.min(clip.transitionDuration || 0, clip.duration)
        : 0;
    if (transitionDuration > 0) {
      const trackClips = state.clips
        .filter(
          (item) =>
            item &&
            item.type !== 'audio' &&
            getClipTrack(item) === getClipTrack(clip)
        )
        .sort((a, b) => (a.start || 0) - (b.start || 0));
      const clipIndex = trackClips.findIndex((item) => item.id === clip.id);
      if (
        transitionIn !== 'none' &&
        localTime <= transitionDuration &&
        clipIndex > 0
      ) {
        clips.push(trackClips[clipIndex - 1]);
      }
      if (
        transitionOut !== 'none' &&
        localTime >= clip.duration - transitionDuration &&
        clipIndex >= 0 &&
        clipIndex < trackClips.length - 1
      ) {
        clips.push(trackClips[clipIndex + 1]);
      }
    }
    return clips
      .filter((item) => item && item.type === 'video' && item.element)
      .map((item) => {
        const local = Math.max(0, timeSec - (item.start || 0));
        const target = getVideoClipSourceTime(item, local);
        if (target === null) return null;
        const maxTime = Math.max(
          0,
          finiteNumber(item.element.duration, target) - 0.05
        );
        return {
          video: item.element,
          time: Math.min(Math.max(target, 0), maxTime),
        };
      })
      .filter(Boolean);
  }

  function waitForExportVideoSeek(video, targetTime) {
    if (!video) return Promise.resolve();
    const target = Math.max(0, finiteNumber(targetTime, 0));
    const frameTolerance = 1 / Math.max(12, (state.fps || 30) * 1.5);
    if (
      video.readyState >= 2 &&
      Math.abs((video.currentTime || 0) - target) <= frameTolerance
    ) {
      return Promise.resolve();
    }
    return new Promise((resolve) => {
      let done = false;
      let frameHandle = null;
      const cleanup = () => {
        video.removeEventListener('seeked', complete);
        video.removeEventListener('loadeddata', complete);
        video.removeEventListener('error', complete);
        if (
          frameHandle !== null &&
          typeof video.cancelVideoFrameCallback === 'function'
        ) {
          try {
            video.cancelVideoFrameCallback(frameHandle);
          } catch (_) {}
        }
      };
      const finish = () => {
        if (done) return;
        done = true;
        cleanup();
        resolve();
      };
      const complete = () => {
        if (
          typeof video.requestVideoFrameCallback === 'function' &&
          video.readyState >= 2
        ) {
          frameHandle = video.requestVideoFrameCallback(() => finish());
          return;
        }
        finish();
      };
      video.addEventListener('seeked', complete, { once: true });
      video.addEventListener('loadeddata', complete, { once: true });
      video.addEventListener('error', complete, { once: true });
      try {
        video.pause();
        video.currentTime = target;
      } catch (_) {
        finish();
        return;
      }
      setTimeout(finish, 650);
    });
  }

  async function renderFrameForExport(timeSec) {
    const targets = getRenderVideoSeekTargets(timeSec);
    if (targets.length) {
      await Promise.all(
        targets.map((target) =>
          waitForExportVideoSeek(target.video, target.time)
        )
      );
    }
    renderFrameAt(timeSec);
  }

  function renderFrameAt(timeSec) {
    const ctx = el.previewCanvas.getContext('2d');
    ctx.clearRect(0, 0, state.resolution.width, state.resolution.height);
    if (!state.clips.length) {
      previewFrameCacheKey = '';
      ctx.fillStyle = '#111827';
      ctx.fillRect(0, 0, state.resolution.width, state.resolution.height);
      if (!state.exportInProgress) renderStageElements();
      drawCaptionOverlays(ctx, timeSec);
      if (!state.exportInProgress) updateShaderStageSource();
      return;
    }
    const clip = findClipAt(timeSec);
    if (!clip) {
      if (!state.exportInProgress) renderStageElements();
      drawCaptionOverlays(ctx, timeSec);
      if (!state.exportInProgress) updateShaderStageSource();
      return;
    }
    const localTime = Math.max(0, timeSec - clip.start);
    const transitionIn = clip.transitionIn || clip.transition || 'none';
    const transitionOut = clip.transitionOut || clip.transition || 'none';
    const transitionDuration =
      transitionIn !== 'none' || transitionOut !== 'none'
        ? Math.min(clip.transitionDuration || 0, clip.duration)
        : 0;
    const trackClips = state.clips
      .filter(
        (item) =>
          item &&
          item.type !== 'audio' &&
          getClipTrack(item) === getClipTrack(clip)
      )
      .sort((a, b) => (a.start || 0) - (b.start || 0));
    const clipIndex = trackClips.findIndex((item) => item.id === clip.id);
    const prevClip = clipIndex > 0 ? trackClips[clipIndex - 1] : null;
    const nextClip =
      clipIndex >= 0 && clipIndex < trackClips.length - 1
        ? trackClips[clipIndex + 1]
        : null;
    if (
      transitionDuration > 0 &&
      transitionIn !== 'none' &&
      localTime <= transitionDuration
    ) {
      const progress = applyEase(
        Math.min(1, localTime / transitionDuration),
        clip.transitionEase || 'linear'
      );
      applyTransitionEffect(
        ctx,
        transitionIn,
        progress,
        clip,
        prevClip,
        localTime,
        true
      );
      if (!state.exportInProgress) renderStageElements();
      drawCaptionOverlays(ctx, timeSec);
      if (!state.exportInProgress) updateShaderStageSource();
      return;
    }
    if (
      transitionDuration > 0 &&
      transitionOut !== 'none' &&
      localTime >= clip.duration - transitionDuration
    ) {
      const progress = applyEase(
        Math.min(
          1,
          (localTime - (clip.duration - transitionDuration)) /
            transitionDuration
        ),
        clip.transitionEase || 'linear'
      );
      applyTransitionEffect(
        ctx,
        transitionOut,
        progress,
        clip,
        nextClip,
        localTime,
        false
      );
      if (!state.exportInProgress) renderStageElements();
      drawCaptionOverlays(ctx, timeSec);
      if (!state.exportInProgress) updateShaderStageSource();
      return;
    }
    drawClip(ctx, clip, localTime, 1);
    if (!state.exportInProgress) renderStageElements();
    drawCaptionOverlays(ctx, timeSec);
    if (!state.exportInProgress) updateShaderStageSource();
  }

  function cachePreviewMediaFrame(ctx, cacheKey) {
    if (state.exportInProgress || !ctx || !ctx.canvas) return;
    if (!previewFrameCacheCanvas) {
      previewFrameCacheCanvas = document.createElement('canvas');
    }
    if (
      previewFrameCacheCanvas.width !== state.resolution.width ||
      previewFrameCacheCanvas.height !== state.resolution.height
    ) {
      previewFrameCacheCanvas.width = state.resolution.width;
      previewFrameCacheCanvas.height = state.resolution.height;
    }
    const cacheCtx = previewFrameCacheCanvas.getContext('2d');
    if (!cacheCtx) return;
    cacheCtx.clearRect(
      0,
      0,
      previewFrameCacheCanvas.width,
      previewFrameCacheCanvas.height
    );
    try {
      cacheCtx.drawImage(ctx.canvas, 0, 0);
      previewFrameCacheKey = cacheKey || '';
    } catch (_) {
      previewFrameCacheKey = '';
    }
  }

  function restorePreviewMediaFrame(ctx, cacheKey) {
    if (
      !previewFrameCacheCanvas ||
      previewFrameCacheKey !== (cacheKey || '') ||
      previewFrameCacheCanvas.width !== state.resolution.width ||
      previewFrameCacheCanvas.height !== state.resolution.height
    ) {
      return false;
    }
    ctx.drawImage(previewFrameCacheCanvas, 0, 0);
    return true;
  }

  function restoreAnyPreviewMediaFrame(ctx) {
    if (
      state.exportInProgress ||
      !previewFrameCacheCanvas ||
      previewFrameCacheCanvas.width !== state.resolution.width ||
      previewFrameCacheCanvas.height !== state.resolution.height
    ) {
      return false;
    }
    try {
      ctx.drawImage(previewFrameCacheCanvas, 0, 0);
      return true;
    } catch (_) {
      return false;
    }
  }

  function drawClip(ctx, clip, localTime, alpha) {
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    if (clip.type === 'image') {
      if (clip.element && clip.element.complete) {
        drawMediaCover(ctx, clip.element, clip);
        cachePreviewMediaFrame(ctx, clip.id);
      } else if (!restorePreviewMediaFrame(ctx, clip.id)) {
        restoreAnyPreviewMediaFrame(ctx);
      }
    } else if (clip.type === 'video') {
      const video = clip.element;
      if (video && video.readyState >= 2) {
        const safeTargetTime = getVideoClipSourceTime(clip, localTime) || 0;
        if (
          !state.playing ||
          video.paused ||
          Math.abs(video.currentTime - safeTargetTime) > 0.5
        ) {
          const maxTime = Math.max(
            0,
            finiteNumber(video.duration, safeTargetTime) - 0.05
          );
          video.currentTime = Math.min(Math.max(safeTargetTime, 0), maxTime);
        }
        try {
          drawMediaCover(ctx, video, clip);
          cachePreviewMediaFrame(ctx, clip.id);
        } catch (_) {
          if (
            !restorePreviewMediaFrame(ctx, clip.id) &&
            !restoreAnyPreviewMediaFrame(ctx)
          ) {
            ctx.fillStyle = '#111827';
            ctx.fillRect(0, 0, state.resolution.width, state.resolution.height);
          }
        }
      } else if (
        !restorePreviewMediaFrame(ctx, clip.id) &&
        !restoreAnyPreviewMediaFrame(ctx)
      ) {
        ctx.fillStyle = '#111827';
        ctx.fillRect(0, 0, state.resolution.width, state.resolution.height);
      }
    }
    ctx.restore();
  }

  function drawMediaCover(ctx, media, framing) {
    const sourceWidth =
      media.videoWidth ||
      media.naturalWidth ||
      media.width ||
      state.resolution.width;
    const sourceHeight =
      media.videoHeight ||
      media.naturalHeight ||
      media.height ||
      state.resolution.height;
    const targetWidth = state.resolution.width;
    const targetHeight = state.resolution.height;
    if (!(sourceWidth > 0) || !(sourceHeight > 0)) {
      ctx.drawImage(media, 0, 0, targetWidth, targetHeight);
      return;
    }
    const sourceAspect = sourceWidth / sourceHeight;
    const targetAspect = targetWidth / targetHeight;
    let sx = 0;
    let sy = 0;
    let sw = sourceWidth;
    let sh = sourceHeight;
    const focusX = Math.max(
      0,
      Math.min(1, Number(framing?.focusX ?? 50) / 100)
    );
    const focusY = Math.max(
      0,
      Math.min(1, Number(framing?.focusY ?? 50) / 100)
    );
    if (sourceAspect > targetAspect) {
      sw = sourceHeight * targetAspect;
      sx = Math.max(
        0,
        Math.min(sourceWidth - sw, sourceWidth * focusX - sw / 2)
      );
    } else if (sourceAspect < targetAspect) {
      sh = sourceWidth / targetAspect;
      sy = Math.max(
        0,
        Math.min(sourceHeight - sh, sourceHeight * focusY - sh / 2)
      );
    }
    ctx.drawImage(media, sx, sy, sw, sh, 0, 0, targetWidth, targetHeight);
  }

  function wrapCaptionLines(ctx, text, maxWidth) {
    const words = String(text || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!words.length) return [];
    const lines = [];
    let current = '';
    words.forEach((word) => {
      const next = current ? `${current} ${word}` : word;
      if (current && ctx.measureText(next).width > maxWidth) {
        lines.push(current);
        current = word;
      } else {
        current = next;
      }
    });
    if (current) lines.push(current);
    return lines;
  }

  function drawRoundRect(ctx, x, y, width, height, radius) {
    const r = Math.min(radius, width / 2, height / 2);
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + width, y, x + width, y + height, r);
    ctx.arcTo(x + width, y + height, x, y + height, r);
    ctx.arcTo(x, y + height, x, y, r);
    ctx.arcTo(x, y, x + width, y, r);
    ctx.closePath();
  }

  function drawCaptionOverlays(ctx, timeSec) {
    const captions = findCaptionClipsAt(timeSec);
    if (!captions.length) return;
    captions.forEach((clip, index) => {
      const fontSize = Math.max(
        12,
        clip.captionFontSize || DEFAULT_CAPTION_STYLE.fontSize
      );
      const lineHeight = fontSize * 1.22;
      const maxWidth = state.resolution.width * 0.82;
      ctx.save();
      ctx.font = `700 ${fontSize}px Montserrat, Manrope, sans-serif`;
      ctx.textBaseline = 'middle';
      ctx.textAlign = clip.captionAlign || DEFAULT_CAPTION_STYLE.align;
      const lines = wrapCaptionLines(
        ctx,
        clip.text || clip.name || '',
        maxWidth
      );
      if (!lines.length) {
        ctx.restore();
        return;
      }
      const widest = lines.reduce(
        (max, line) => Math.max(max, ctx.measureText(line).width),
        0
      );
      const blockHeight = lines.length * lineHeight;
      const yPercent = Math.max(
        5,
        Math.min(95, clip.captionY || DEFAULT_CAPTION_STYLE.y)
      );
      const yCenter =
        (state.resolution.height * yPercent) / 100 -
        (captions.length - index - 1) * (blockHeight + 24);
      const boxPaddingX = 18;
      const boxPaddingY = 10;
      const boxWidth = Math.min(
        state.resolution.width * 0.9,
        widest + boxPaddingX * 2
      );
      const boxHeight = blockHeight + boxPaddingY * 2;
      let anchorX = state.resolution.width / 2;
      if ((clip.captionAlign || DEFAULT_CAPTION_STYLE.align) === 'left') {
        anchorX = state.resolution.width * 0.1;
      } else if (
        (clip.captionAlign || DEFAULT_CAPTION_STYLE.align) === 'right'
      ) {
        anchorX = state.resolution.width * 0.9;
      }
      const boxX =
        (clip.captionAlign || DEFAULT_CAPTION_STYLE.align) === 'left'
          ? anchorX - boxPaddingX
          : (clip.captionAlign || DEFAULT_CAPTION_STYLE.align) === 'right'
            ? anchorX - boxWidth + boxPaddingX
            : anchorX - boxWidth / 2;
      const boxY = yCenter - boxHeight / 2;
      ctx.fillStyle = 'rgba(15, 23, 42, 0.74)';
      drawRoundRect(ctx, boxX, boxY, boxWidth, boxHeight, 18);
      ctx.fill();
      ctx.fillStyle = clip.captionColor || DEFAULT_CAPTION_STYLE.color;
      ctx.shadowColor = 'rgba(15, 23, 42, 0.65)';
      ctx.shadowBlur = 12;
      lines.forEach((line, lineIndex) => {
        ctx.fillText(
          line,
          anchorX,
          yCenter - blockHeight / 2 + (lineIndex + 0.5) * lineHeight
        );
      });
      ctx.restore();
    });
  }

  let rulerHoverThumbKey = '';
  let rulerHoverSeekEl = null;

  function getRulerHoverThumbNode() {
    if (!el.timelineRulerHover) return null;
    let node = el.timelineRulerHover.querySelector(
      '.timeline-ruler-hover-thumb'
    );
    if (!node) {
      node = document.createElement('div');
      node.className = 'timeline-ruler-hover-thumb';
      el.timelineRulerHover.insertBefore(
        node,
        el.timelineRulerHover.firstChild
      );
    }
    return node;
  }

  function updateRulerHoverThumb(timeSec) {
    const node = getRulerHoverThumbNode();
    if (!node) return;
    const clip = findClipAt(timeSec);
    if (!clip) {
      node.classList.remove('is-visible');
      rulerHoverThumbKey = '';
      return;
    }
    node.classList.add('is-visible');
    node.title = clip.name || '';
    if (clip.type === 'image' && clip.src) {
      node.textContent = '';
      node.style.backgroundImage = `url("${clip.src}")`;
      rulerHoverThumbKey = '';
      return;
    }
    if (
      clip.type === 'video' &&
      clip.element &&
      clip.element.readyState >= 2 &&
      !state.playing
    ) {
      const localTime =
        Math.max(0, timeSec - (clip.start || 0)) + (clip.trimStart || 0);
      const key = `${clip.id}:${localTime.toFixed(1)}`;
      if (key === rulerHoverThumbKey) return;
      rulerHoverThumbKey = key;
      node.textContent = '';
      const drawFrame = () => {
        try {
          const cv = document.createElement('canvas');
          cv.width = 96;
          cv.height = 54;
          cv.getContext('2d').drawImage(clip.element, 0, 0, 96, 54);
          node.style.backgroundImage = `url("${cv.toDataURL('image/jpeg', 0.6)}")`;
        } catch (e) {}
      };
      if (Math.abs(clip.element.currentTime - localTime) > 0.2) {
        if (rulerHoverSeekEl && rulerHoverSeekEl !== clip.element) {
          rulerHoverSeekEl.onseeked = null;
        }
        rulerHoverSeekEl = clip.element;
        clip.element.onseeked = () => {
          drawFrame();
          clip.element.onseeked = null;
        };
        try {
          clip.element.currentTime = localTime;
        } catch (e) {}
      } else {
        drawFrame();
      }
      return;
    }
    node.style.backgroundImage = 'none';
    node.textContent = (clip.name || '').slice(0, 22);
    rulerHoverThumbKey = '';
  }

  function updateTimeLabel() {
    if (el.timelineTime) {
      el.timelineTime.textContent =
        formatTimelineTimeValue(state.playhead || 0, 1) + 's';
    }
    updateTimelinePlayhead();
    updateTimelineSelectionBar();
    updateWaveformPlayhead();
    updateClipVisualizerPlayheads();
    updateAutomationPlayhead();
  }

  function formatTimelineTimeValue(value, precision = 2) {
    let label = Number.isFinite(value) ? value.toFixed(precision) : '0';
    label = label.replace(/\.0+$/, '').replace(/^0\./, '.');
    if (label === '' || label === '.') label = '0';
    return label;
  }

  function updateTimelinePlayhead() {
    if (!el.timelinePlayhead || !el.timelineList) return;
    const duration = totalDuration();
    const pxPerSec = getTimelinePixelsPerSecond();
    const offset = getTimelineTrackOffset();
    const x = Math.max(0, offset + (state.playhead || 0) * pxPerSec);
    el.timelinePlayhead.style.left = `${x}px`;
    el.timelinePlayhead.classList.toggle(
      'at-zero',
      !state.playing && (state.playhead || 0) < 0.02
    );
    el.timelinePlayhead.dataset.time = formatTimelineTimeValue(
      state.playhead || 0,
      2
    );
  }

  function playPreview() {
    if (state.playing) return;
    const total = totalDuration();
    if (total <= 0) return;
    const frame = 1 / Math.max(1, state.fps || 30);
    const startTime =
      state.playhead >= Math.max(0, total - frame)
        ? 0
        : Math.max(0, state.playhead || 0);
    state.playhead = startTime;
    state.playing = true;
    state.playStartTime = performance.now() - startTime * 1000;
    playbackLastRenderNow = performance.now();
    renderFrameAt(startTime);
    updateTimeLabel();
    if (state.audioElement) {
      const doPlay = () => {
        state.audioElement.currentTime = startTime;
        state.audioElement.play().catch(() => {});
      };
      if (state.audioContext && state.audioContext.state === 'suspended') {
        state.audioContext
          .resume()
          .catch(() => {})
          .then(doPlay);
      } else {
        doPlay();
      }
    }
    state.clips.forEach((clip) => {
      if (clip.type === 'video' && clip.element && clip.element.paused) {
        const targetTime = Math.max(
          0,
          startTime - (clip.start || 0) + (clip.trimStart || 0)
        );
        clip.element.currentTime = Math.min(
          Math.max(targetTime, 0),
          (clip.element.duration || targetTime) - 0.01
        );
        clip.element.play().catch(() => {});
      }
    });
    playAllAudioTracks();
    if (el.timelineWaveform && state.autoScrollWaveform) {
      if (total > 0) {
        const canvas = el.timelineWaveform.querySelector('canvas');
        const width = canvas ? canvas.width : el.timelineWaveform.scrollWidth;
        const target = Math.min(
          Math.max(
            0,
            (startTime / total) * width - el.timelineWaveform.clientWidth / 2
          ),
          Math.max(0, width - el.timelineWaveform.clientWidth)
        );
        el.timelineWaveform.scrollLeft = target;
      }
    }
    syncPlayToggle();
    requestAnimationFrame(tick);
  }

  function pausePreview() {
    if (!state.playing) return;
    state.playing = false;
    playbackLastRenderNow = 0;
    if (state.audioElement) {
      state.audioElement.pause();
    }
    state.clips.forEach((clip) => {
      if (clip.type === 'video' && clip.element && !clip.element.paused) {
        clip.element.pause();
      }
    });
    pauseAllAudioTracks();
    syncPlayToggle();
  }

  function togglePreviewPlayback() {
    if (state.playing) {
      pausePreview();
    } else {
      playPreview();
    }
  }

  function syncPlayToggle() {
    if (!el.timelinePlayToggle) return;
    const isPlaying = !!state.playing;
    el.timelinePlayToggle.setAttribute(
      'aria-pressed',
      isPlaying ? 'true' : 'false'
    );
    el.timelinePlayToggle.setAttribute(
      'aria-label',
      isPlaying ? 'Pause' : 'Play'
    );
    el.timelinePlayToggle.setAttribute('title', isPlaying ? 'Pause' : 'Play');
    el.timelinePlayToggle.innerHTML = isPlaying
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><rect x="5" y="4" width="4" height="16" rx="1"/><rect x="15" y="4" width="4" height="16" rx="1"/></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>';
  }

  function handleGlobalPlaybackKeydown(event) {
    const { key, lower } = getEventKeyData(event);
    if (!key) return;
    if (
      event.repeat &&
      key !== 'ArrowLeft' &&
      key !== 'ArrowRight' &&
      key !== ',' &&
      key !== '.' &&
      event.code !== 'Comma' &&
      event.code !== 'Period'
    )
      return;
    const modKey = event.ctrlKey || event.metaKey;
    if (isEditorModalOpen()) return;
    if (modKey && event.shiftKey && !event.altKey && lower === 's') {
      event.preventDefault();
      openFsBrowser('project-save');
      return;
    }
    if (modKey && !event.altKey && !event.shiftKey && lower === 's') {
      event.preventDefault();
      saveProject();
      return;
    }
    if (modKey && !event.altKey && !event.shiftKey && lower === 'a') {
      if (isEditableTarget(document.activeElement)) return;
      event.preventDefault();
      if (state.selectedClipIds.length && !state.selectedStageElementId) {
        selectAllTimelineClips();
      } else {
        selectAllStageElements();
      }
      return;
    }
    if (
      modKey &&
      !event.altKey &&
      !event.shiftKey &&
      (key === '/' || key === '?')
    ) {
      event.preventDefault();
      toggleSidebarDrawer();
      return;
    }
    if (modKey && !event.altKey && !event.shiftKey && lower === 'e') {
      event.preventDefault();
      setStageFiltersPopoverOpen(true, { focus: true });
      return;
    }
    if (modKey && !event.altKey && !event.shiftKey && key === 'Enter') {
      event.preventDefault();
      addPage();
      return;
    }
    if (
      modKey &&
      !event.altKey &&
      !event.shiftKey &&
      (key === 'Backspace' || key === 'Delete')
    ) {
      event.preventDefault();
      removeActivePageIfEmpty();
      return;
    }
    if (
      modKey &&
      !event.altKey &&
      !event.shiftKey &&
      (key === 'F1' || event.code === 'F1')
    ) {
      event.preventDefault();
      focusToolbar();
      return;
    }
    if (
      modKey &&
      !event.altKey &&
      !event.shiftKey &&
      (key === 'F2' || event.code === 'F2')
    ) {
      event.preventDefault();
      focusStageCanvas();
      return;
    }
    if (
      modKey &&
      !event.altKey &&
      !event.shiftKey &&
      (key === '+' || key === '=')
    ) {
      event.preventDefault();
      adjustPreviewScale(0.1);
      return;
    }
    if (
      modKey &&
      !event.altKey &&
      !event.shiftKey &&
      (key === '-' || key === '_')
    ) {
      event.preventDefault();
      adjustPreviewScale(-0.1);
      return;
    }
    if (modKey && event.altKey && !event.shiftKey && key === '0') {
      event.preventDefault();
      fitPreviewScale();
      return;
    }
    if (modKey && event.shiftKey && !event.altKey && key === '0') {
      event.preventDefault();
      fillPreviewScale();
      return;
    }
    if (modKey && !event.altKey && !event.shiftKey && key === '0') {
      event.preventDefault();
      applyPreviewScale(1);
      return;
    }
    if (
      event.code === 'Space' &&
      !modKey &&
      !event.altKey &&
      !event.shiftKey &&
      !isTextEntryTarget(event.target) &&
      !isTextEntryTarget(document.activeElement)
    ) {
      event.preventDefault();
      togglePreviewPlayback();
      return;
    }
    if (shouldIgnoreEditorShortcut(event)) return;
    if (modKey && event.altKey && !event.shiftKey && lower === 'l') {
      event.preventDefault();
      state.loopPlayback = !state.loopPlayback;
      return;
    }
    if (!modKey && !event.altKey && !event.shiftKey && lower === 'm') {
      event.preventDefault();
      toggleAudioMute();
      return;
    }
    if (!modKey && !event.altKey && !event.shiftKey && lower === 's') {
      if (!canSplitTimelineAtPlayhead(state.selectedClipIds)) return;
      event.preventDefault();
      splitTimelineSelectionAtPlayhead();
      return;
    }
    if (!modKey && !event.altKey && key === '?') {
      event.preventDefault();
      toggleKeyboardShortcuts();
      return;
    }
    if (
      !event.altKey &&
      !event.ctrlKey &&
      !event.metaKey &&
      !state.selectedStageElementId &&
      (key === ',' ||
        key === '.' ||
        event.code === 'Comma' ||
        event.code === 'Period')
    ) {
      event.preventDefault();
      const frameStep = 1 / Math.max(1, state.fps || 30);
      const step = event.shiftKey ? 1 : frameStep;
      const backwards = key === ',' || event.code === 'Comma';
      seekTimelinePlayhead((state.playhead || 0) + (backwards ? -step : step), {
        snap: false,
        autoscroll: true,
      });
      return;
    }
    if (
      !event.altKey &&
      !event.ctrlKey &&
      !event.metaKey &&
      !state.selectedStageElementId &&
      !state.selectedClipIds.length &&
      (key === 'ArrowLeft' || key === 'ArrowRight')
    ) {
      event.preventDefault();
      const frameStep = 1 / Math.max(1, state.fps || 30);
      const step = event.shiftKey ? 1 : frameStep;
      const delta = key === 'ArrowLeft' ? -step : step;
      seekTimelinePlayhead((state.playhead || 0) + delta, {
        snap: false,
        autoscroll: true,
      });
      return;
    }
    if (
      !event.altKey &&
      !event.ctrlKey &&
      !event.metaKey &&
      !event.shiftKey &&
      !state.selectedStageElementId &&
      !state.selectedClipIds.length &&
      (key === 'Home' || key === 'End')
    ) {
      event.preventDefault();
      seekTimelinePlayhead(key === 'Home' ? 0 : totalDuration(), {
        snap: false,
        autoscroll: true,
      });
      return;
    }
    if (!event.altKey && !event.ctrlKey && !event.metaKey && lower === 'k') {
      event.preventDefault();
      togglePreviewPlayback();
      return;
    }
    if (key === 'Enter' && state.selectedStageElementId && el.stageElements) {
      const target = state.stageElements.find(
        (item) => item.id === state.selectedStageElementId
      );
      if (target && target.type === 'text') {
        event.preventDefault();
        const node = el.stageElements.querySelector(
          `[data-stage-id="${target.id}"]`
        );
        if (node) beginStageTextEdit(node, target);
        return;
      }
    }
    if (!event.altKey && !event.ctrlKey && !event.metaKey && lower === 't') {
      event.preventDefault();
      const point = getStagePointer();
      addStageTextAndEdit(point || undefined);
      return;
    }
    if (!event.altKey && !event.ctrlKey && !event.metaKey && lower === 'r') {
      event.preventDefault();
      const point = getStagePointer();
      addStageShapeAt(point || undefined, 'rect');
      return;
    }
    if (!event.altKey && !event.ctrlKey && !event.metaKey && lower === 'c') {
      event.preventDefault();
      const point = getStagePointer();
      addStageShapeAt(point || undefined, 'circle');
      return;
    }
    if (!event.altKey && !event.ctrlKey && !event.metaKey && lower === 'l') {
      event.preventDefault();
      const point = getStagePointer();
      addStageShapeAt(point || undefined, 'line');
      return;
    }
    if (
      event.altKey &&
      event.shiftKey &&
      (key === '0' || key === '1' || key === '2' || key === '3')
    ) {
      if (!hasTimelineClipboard()) return;
      event.preventDefault();
      const gap = key === '0' ? 0 : key === '1' ? 0.5 : key === '2' ? 1 : 2;
      pasteTimelineClipboardSpaced(state.playhead || 0, gap);
      return;
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      !event.altKey &&
      !event.shiftKey &&
      hasDomTextSelection() &&
      (lower === 'c' || lower === 'x')
    ) {
      return;
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      !event.altKey &&
      !event.shiftKey &&
      lower === 'c'
    ) {
      if (state.selectedStageElementId) return;
      if (!state.selectedClipIds.length) return;
      event.preventDefault();
      copyTimelineSelectionToClipboard();
      return;
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      !event.altKey &&
      !event.shiftKey &&
      lower === 'x'
    ) {
      if (state.selectedStageElementId) return;
      if (!state.selectedClipIds.length) return;
      event.preventDefault();
      copyTimelineSelectionToClipboard();
      removeTimelineSelection();
      return;
    }
    if (
      (event.ctrlKey || event.metaKey) &&
      !event.altKey &&
      !event.shiftKey &&
      lower === 'v'
    ) {
      if (state.selectedStageElementId) return;
      if (!hasTimelineClipboard()) return;
      event.preventDefault();
      pasteTimelineClipboard(state.playhead || 0);
      return;
    }
    if (
      event.code === 'KeyG' &&
      !event.altKey &&
      !event.ctrlKey &&
      !event.metaKey
    ) {
      event.preventDefault();
      toggleAiGenerate(true);
    }
  }

  function tick(now) {
    if (!state.playing) return;
    const total = totalDuration();
    const elapsed = (now - state.playStartTime) / 1000;
    if (elapsed >= total) {
      if (state.loopPlayback && total > 0) {
        state.playStartTime = now;
        state.playhead = 0;
        renderFrameAt(0);
        updateTimeLabel();
        if (state.audioElement) {
          state.audioElement.currentTime = 0;
          state.audioElement.play();
        }
        requestAnimationFrame(tick);
        return;
      }
      state.playing = false;
      state.playhead = total;
      renderFrameAt(total);
      updateTimeLabel();
      if (state.audioElement) {
        state.audioElement.pause();
      }
      syncPlayToggle();
      return;
    }
    const targetFps = Math.max(1, Math.min(60, state.fps || 30));
    const frameMs = 1000 / targetFps;
    if (playbackLastRenderNow && now - playbackLastRenderNow < frameMs - 1) {
      requestAnimationFrame(tick);
      return;
    }
    playbackLastRenderNow = now;
    state.playhead = elapsed;
    renderFrameAt(state.playhead);
    updateTimeLabel();
    if (el.timelineWaveform && state.autoScrollWaveform) {
      const duration = totalDuration();
      if (duration > 0) {
        const canvas = el.timelineWaveform.querySelector('canvas');
        const width = canvas ? canvas.width : el.timelineWaveform.scrollWidth;
        const target = Math.min(
          Math.max(
            0,
            (state.playhead / duration) * width -
              el.timelineWaveform.clientWidth / 2
          ),
          Math.max(0, width - el.timelineWaveform.clientWidth)
        );
        el.timelineWaveform.scrollLeft = target;
      }
    }
    requestAnimationFrame(tick);
  }

  function pickMediaRecorderMimeType(format) {
    const candidates =
      format === 'mp4'
        ? [
            'video/mp4;codecs=avc1.42E01E,mp4a.40.2',
            'video/mp4;codecs=h264,aac',
            'video/mp4',
          ]
        : [
            'video/webm;codecs=vp9,opus',
            'video/webm;codecs=vp8,opus',
            'video/webm',
          ];
    if (!window.MediaRecorder || !MediaRecorder.isTypeSupported) {
      return candidates[candidates.length - 1];
    }
    return (
      candidates.find((candidate) =>
        MediaRecorder.isTypeSupported(candidate)
      ) || ''
    );
  }

  function recordTimeline(options = {}) {
    return new Promise((resolve, reject) => {
      if (state.exportInProgress)
        return reject(new Error('export in progress'));
      setExportInProgress(true);
      const mediaState = suspendProjectMediaForExport();
      let settled = false;
      const finish = (callback) => {
        if (settled) return;
        settled = true;
        restoreProjectMediaAfterExport(mediaState);
        setExportInProgress(false);
        callback();
      };
      const total = totalDuration();
      if (total <= 0) {
        return finish(() => reject(new Error('no clips')));
      }
      const canvasStream = el.previewCanvas.captureStream(state.fps);
      let stream = canvasStream;
      if (state.audioElement) {
        prepareAudioGraph({ monitor: false });
        if (state.audioDestination) {
          const tracks = [
            ...canvasStream.getVideoTracks(),
            ...state.audioDestination.stream.getAudioTracks(),
          ];
          stream = new MediaStream(tracks);
        }
      }
      let recorder;
      const requestedFormat = options.format || 'webm';
      const mimeType =
        options.mimeType || pickMediaRecorderMimeType(requestedFormat);
      if (!mimeType && requestedFormat === 'mp4') {
        return finish(() => reject(new Error('MP4 recording not supported')));
      }
      try {
        recorder = mimeType
          ? new MediaRecorder(stream, { mimeType })
          : new MediaRecorder(stream);
      } catch (err) {
        if (requestedFormat === 'mp4') {
          return finish(() => reject(err));
        }
        try {
          recorder = new MediaRecorder(stream);
        } catch (fallbackErr) {
          return finish(() => reject(fallbackErr));
        }
      }
      const chunks = [];
      recorder.ondataavailable = (event) => {
        if (event.data && event.data.size) chunks.push(event.data);
      };
      recorder.onerror = () => {
        finish(() => reject(new Error('recorder error')));
      };
      recorder.onstop = () => {
        const blob = new Blob(chunks, {
          type: recorder.mimeType || 'video/webm',
        });
        finish(() => resolve(blob));
      };
      recorder.start(200);
      if (state.audioElement) {
        state.audioElement.currentTime = 0;
        state.audioElement.muted = true;
        try {
          const playResult = state.audioElement.play();
          if (playResult && typeof playResult.catch === 'function') {
            playResult.catch(() => {});
          }
        } catch (_) {}
      }
      const start = performance.now();
      let rendering = false;
      const renderLoop = async (now) => {
        if (rendering) {
          requestAnimationFrame(renderLoop);
          return;
        }
        rendering = true;
        const elapsed = (now - start) / 1000;
        if (elapsed >= total) {
          await renderFrameForExport(total);
          recorder.stop();
          if (state.audioElement) {
            state.audioElement.pause();
          }
          rendering = false;
          return;
        }
        await renderFrameForExport(elapsed);
        rendering = false;
        requestAnimationFrame(renderLoop);
      };
      requestAnimationFrame(renderLoop);
    });
  }

  function suspendProjectMediaForExport() {
    const snapshot = {
      playing: !!state.playing,
      playhead: state.playhead || 0,
      audio: null,
      videos: [],
    };
    state.playing = false;
    if (state.audioElement) {
      snapshot.audio = {
        currentTime: state.audioElement.currentTime || 0,
        muted: !!state.audioElement.muted,
        paused: state.audioElement.paused,
      };
      try {
        state.audioElement.pause();
      } catch (_) {}
    }
    state.clips.forEach((clip) => {
      if (clip.type !== 'video' || !clip.element) return;
      snapshot.videos.push({
        element: clip.element,
        currentTime: clip.element.currentTime || 0,
        paused: clip.element.paused,
        muted: !!clip.element.muted,
      });
      try {
        clip.element.pause();
      } catch (_) {}
      clip.element.muted = true;
    });
    pauseAllAudioTracks();
    syncPlayToggle();
    return snapshot;
  }

  function restoreProjectMediaAfterExport(snapshot) {
    if (!snapshot) return;
    state.playing = false;
    state.playhead = snapshot.playhead || state.playhead || 0;
    if (state.audioElement && snapshot.audio) {
      try {
        state.audioElement.pause();
        state.audioElement.currentTime = snapshot.audio.currentTime || 0;
      } catch (_) {}
      state.audioElement.muted = !!snapshot.audio.muted;
      try {
        prepareAudioGraph({ monitor: true });
      } catch (_) {}
    }
    (snapshot.videos || []).forEach((entry) => {
      if (!entry.element) return;
      try {
        entry.element.pause();
        entry.element.currentTime = entry.currentTime || 0;
      } catch (_) {}
      entry.element.muted = !!entry.muted;
    });
    renderFrameAt(state.playhead || 0);
    updateTimeLabel();
    syncPlayToggle();
  }

  async function exportWithWebCodecs() {
    if (!window.VideoEncoder || !window.VideoFrame) {
      throw new Error('WebCodecs not supported');
    }
    const total = totalDuration();
    if (total <= 0) {
      throw new Error('no clips');
    }
    const bitrate =
      state.exportSettings.bitrate ||
      Math.max(2_000_000, state.resolution.width * state.resolution.height * 2);
    const encoderConfig = {
      codec: 'avc1.42E01E',
      width: state.resolution.width,
      height: state.resolution.height,
      framerate: state.fps,
      bitrate: bitrate,
    };
    if (typeof VideoEncoder.isConfigSupported === 'function') {
      const support = await VideoEncoder.isConfigSupported(encoderConfig);
      if (!support || !support.supported) {
        throw new Error('MP4 WebCodecs encoder not supported');
      }
    }
    const { ArrayBufferTarget, Muxer } = await import(
      'https://cdn.jsdelivr.net/npm/mp4-muxer@5/dist/mp4-muxer.mjs'
    );
    const target = new ArrayBufferTarget();
    const muxer = new Muxer({
      target,
      video: {
        codec: encoderConfig.codec,
        width: state.resolution.width,
        height: state.resolution.height,
        frameRate: state.fps,
      },
    });
    const encoder = new VideoEncoder({
      output: (chunk, meta) => muxer.addVideoChunk(chunk, meta),
      error: () => {},
    });
    encoder.configure(encoderConfig);
    const totalFrames = Math.ceil(total * state.fps);
    const keyFrameInterval = Math.max(1, Math.round(state.fps || 30));
    for (let i = 0; i < totalFrames; i += 1) {
      const t = i / state.fps;
      await renderFrameForExport(t);
      const frame = new VideoFrame(el.previewCanvas, {
        timestamp: Math.round(t * 1_000_000),
      });
      encoder.encode(frame, { keyFrame: i % keyFrameInterval === 0 });
      frame.close();
      if (i % 10 === 0) {
        const pct = Math.round((i / totalFrames) * 100);
        if (el.exportProgressBar) el.exportProgressBar.style.width = pct + '%';
        await new Promise((r) => setTimeout(r, 0));
      }
    }
    if (el.exportProgressBar) el.exportProgressBar.style.width = '100%';
    await encoder.flush();
    muxer.finalize();
    const buffer = target.buffer;
    return new Blob([buffer], { type: 'video/mp4' });
  }

  function getExportResolution() {
    return (
      parseResolutionValue(state.exportSettings.resolution) || {
        width: state.resolution.width,
        height: state.resolution.height,
      }
    );
  }

  async function withExportCanvasResolution(task) {
    if (!el.previewCanvas) return task();
    const nextResolution = getExportResolution();
    const prevResolution = {
      width: state.resolution.width,
      height: state.resolution.height,
    };
    const prevCanvas = el.previewCanvas;
    const prevCanvasSize = {
      width: prevCanvas.width,
      height: prevCanvas.height,
    };
    const exportCanvas = document.createElement('canvas');
    exportCanvas.width = nextResolution.width;
    exportCanvas.height = nextResolution.height;
    state.resolution.width = nextResolution.width;
    state.resolution.height = nextResolution.height;
    el.previewCanvas = exportCanvas;
    try {
      return await task();
    } finally {
      el.previewCanvas = prevCanvas;
      applyCanvasResolution(prevResolution.width, prevResolution.height);
      if (
        prevCanvas.width !== prevCanvasSize.width ||
        prevCanvas.height !== prevCanvasSize.height
      ) {
        prevCanvas.width = prevCanvasSize.width;
        prevCanvas.height = prevCanvasSize.height;
        applyPreviewAspect();
      }
      renderFrameAt(state.playhead || 0);
    }
  }

  async function exportMp4Locally() {
    let webCodecsError = null;
    if (!state.audioElement && window.VideoEncoder && window.VideoFrame) {
      setExportInProgress(true);
      const mediaState = suspendProjectMediaForExport();
      try {
        return await exportWithWebCodecs();
      } catch (err) {
        webCodecsError = err;
      } finally {
        restoreProjectMediaAfterExport(mediaState);
        setExportInProgress(false);
      }
    }
    try {
      return await recordTimeline({ format: 'mp4' });
    } catch (err) {
      if (webCodecsError) {
        throw new Error(
          `MP4 export unavailable: ${webCodecsError.message || 'WebCodecs failed'}; ${err.message || 'MediaRecorder failed'}`
        );
      }
      throw new Error(
        `MP4 export unavailable: ${err.message || 'MediaRecorder failed'}`
      );
    }
  }

  function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  async function exportProject(format, publish) {
    if (state.exportInProgress) return;
    let managedExport = false;
    try {
      notify('xs', 'info');
      const { blob, exportFormat } = await withExportCanvasResolution(
        async () => {
          let nextBlob;
          let nextFormat = format;
          if (format === 'webm') {
            nextBlob = await recordTimeline({ format: 'webm' });
          } else {
            nextBlob = await exportMp4Locally();
            nextFormat = 'mp4';
          }
          return { blob: nextBlob, exportFormat: nextFormat };
        }
      );
      if (!blob) {
        notify('xf', 'error');
        return;
      }
      if (publish) {
        const published = await publishExport(blob, exportFormat);
        if (!published) return;
      } else {
        downloadBlob(blob, `netwrck-edit-${Date.now()}.${exportFormat}`);
      }
      notify('xd', 'success');
    } catch (err) {
      console.error('Export failed', err);
      const detail = err && err.message ? `: ${err.message}` : '';
      notify(`xf${detail}`, 'error');
    } finally {
      if (managedExport) {
        setExportInProgress(false);
      }
      resetExportProgress();
    }
  }

  async function queueServerRender(publish) {
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      notify('li', 'error');
      return;
    }
    if (state.exportInProgress) return;
    setExportInProgress(true);
    let managedExport = true;
    if (!state.clips.length) {
      setExportInProgress(false);
      managedExport = false;
      notify('nc', 'error');
      return;
    }
    if (window.NetwrckTools && !window.NetwrckTools.requireLogin()) {
      if (window.showSubscribeDialog) window.showSubscribeDialog();
      setExportInProgress(false);
      managedExport = false;
      return;
    }
    const duration = totalDuration();
    const cost = duration * 0.01;
    const credits = Math.max(1, Math.ceil(cost * 100));
    if (
      window.NetwrckTools &&
      !window.NetwrckTools.checkCredits(credits, cost.toFixed(2))
    ) {
      setExportInProgress(false);
      managedExport = false;
      return;
    }
    const localAssetCount = state.assets.reduce((count, asset) => {
      if (
        typeof asset.src === 'string' &&
        asset.src.startsWith('blob:') &&
        asset.file
      )
        return count + 1;
      return count;
    }, 0);
    const localAudioCount =
      state.audioElement &&
      typeof state.audioElement.src === 'string' &&
      state.audioElement.src.startsWith('blob:') &&
      state.audioFile
        ? 1
        : 0;
    const uploadCount = localAssetCount + localAudioCount;
    const uploadKind =
      localAssetCount > 0 && localAudioCount > 0
        ? 'mixed'
        : localAssetCount > 0 && localAudioCount === 0
          ? 'assets'
          : localAssetCount === 0 && localAudioCount > 0
            ? 'audio'
            : '';
    const hasLocalAssets = uploadCount > 0;
    let uploadJob = null;
    if (hasLocalAssets) {
      uploadJob = {
        id: `uploading-${Date.now()}`,
        label: publish ? 'P' : 'R',
        status: 'uploading',
        kind: 'render',
        temporary: true,
        uploadCount,
        uploadKind,
      };
      state.queue.unshift(uploadJob);
      renderQueue();
    }
    const hostedOk = await ensureServerAssetsHosted();
    if (uploadJob) {
      state.queue = state.queue.filter((job) => job !== uploadJob);
      renderQueue();
    }
    if (!hostedOk) {
      setExportInProgress(false);
      managedExport = false;
      return;
    }
    const project = serializeProject();
    const captionCount = Array.isArray(project.clips)
      ? project.clips.filter((clip) => clip && clip.type === 'caption').length
      : 0;
    const serverProject = {
      ...project,
      clips: Array.isArray(project.clips)
        ? project.clips.filter((clip) => clip && clip.type !== 'caption')
        : [],
    };
    if (!serverProject.clips || serverProject.clips.length === 0) {
      setExportInProgress(false);
      managedExport = false;
      notify('nc', 'error');
      return;
    }
    const hasLocal = serverProject.clips.some(
      (clip) => typeof clip.src === 'string' && clip.src.startsWith('blob:')
    );
    if (hasLocal) {
      setExportInProgress(false);
      managedExport = false;
      notify('ha', 'error');
      return;
    }
    let resp;
    try {
      resp = await fetch('/api/video-editor/render', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: `Bearer ${secret}`,
        },
        body: JSON.stringify({
          project: serverProject,
          format: 'mp4',
          publish: !!publish,
        }),
      });
    } catch (err) {
      console.error('Server render failed', err);
      const detail = err && err.message ? `: ${err.message}` : '';
      notify(`rf${detail}`, 'error');
      if (managedExport) setExportInProgress(false);
      return;
    }
    if (!resp.ok) {
      const text = await resp.text().catch(() => '');
      let detail = '';
      if (text) {
        try {
          const data = JSON.parse(text);
          detail = data.error || data.message || data.detail || '';
        } catch (err) {
          detail = text;
        }
        detail = detail.replace(/\s+/g, ' ').trim();
        if (detail.length > 140) detail = detail.slice(0, 140) + '…';
        if (detail) detail = ` — ${detail}`;
      }
      console.error('Server render failed', resp.status, text);
      notify(`rf${detail}`, 'error');
      if (managedExport) setExportInProgress(false);
      return;
    }
    let data;
    try {
      data = await resp.json();
    } catch (err) {
      const text = await resp.text().catch(() => '');
      let detail = text.replace(/\s+/g, ' ').trim();
      if (detail.length > 140) detail = detail.slice(0, 140) + '…';
      if (detail) detail = ` — ${detail}`;
      console.error('Server render failed', err, text);
      const fallback = err && err.message ? `: ${err.message}` : '';
      notify(`rf${detail || fallback}`, 'error');
      if (managedExport) setExportInProgress(false);
      return;
    }
    if (resp.status === 202 && data.job_id) {
      if (captionCount > 0) {
        notify('Server render skips caption overlays for now', 'info');
      }
      const jobCredits =
        typeof data.credits_charged === 'number'
          ? data.credits_charged
          : credits;
      const jobCost = typeof data.cost_usd === 'number' ? data.cost_usd : cost;
      enqueueJob(
        {
          id: data.job_id,
          label: publish ? 'P' : 'R',
          status: 'in_progress',
          kind: 'render',
          publish: !!publish,
          credits: jobCredits,
          cost: jobCost,
          statusEndpoint: `/api/video-editor/render/status/${data.job_id}?api_key=${encodeURIComponent(secret)}`,
        },
        secret
      );
      const metaParts = [];
      if (typeof jobCredits === 'number' && jobCredits > 0)
        metaParts.push(`${jobCredits} credits`);
      if (typeof jobCost === 'number' && jobCost > 0)
        metaParts.push(`$${jobCost.toFixed(2)}`);
      const meta = metaParts.length ? ` (${metaParts.join(' · ')})` : '';
      notify(`rq${meta}`, 'info');
      if (managedExport) setExportInProgress(false);
      return;
    }
    const url = data.video_url || data.result?.video_url;
    if (url) {
      addExternalAsset(url, 'video', 'R');
      if (publish) window.location.href = '/gallery';
      if (managedExport) setExportInProgress(false);
      return;
    }
    const detail = data.error || data.message || data.detail || '';
    notify(detail ? `rf ${detail}` : 'rf', 'error');
    if (managedExport) setExportInProgress(false);
  }

  async function getSignedUploadUrl(contentType, fileName) {
    const url =
      '/file-upload-get-signed-url-cloudflare?' +
      new URLSearchParams({ file_type: contentType, file_name: fileName });
    const headers = { 'Content-Type': 'application/json' };
    const secret = getAuthSecret();
    if (secret) {
      headers['X-API-Key'] = secret;
      headers.Authorization = `Bearer ${secret}`;
    }
    const response = await fetch(url, { method: 'GET', headers });
    if (!response.ok) {
      const text = await response.text().catch(() => '');
      let detail = '';
      if (text) {
        try {
          const data = JSON.parse(text);
          detail = data.error || data.message || data.detail || '';
        } catch (err) {
          detail = text;
        }
        detail = detail.replace(/\s+/g, ' ').trim();
        if (detail.length > 140) detail = detail.slice(0, 140) + '…';
        if (detail) detail = ` — ${detail}`;
      }
      throw new Error(`signed url error (${response.status})${detail}`);
    }
    return response.json();
  }

  async function uploadAssetToBucket(blob, contentType, fileName) {
    const signedUrl = await getSignedUploadUrl(contentType, fileName);
    const uploadResp = await fetch(signedUrl.url, {
      method: 'PUT',
      headers: { 'Content-Type': contentType },
      body: blob,
    });
    if (!uploadResp.ok) {
      const text = await uploadResp.text().catch(() => '');
      let detail = '';
      if (text) {
        detail = text.replace(/\s+/g, ' ').trim();
        if (detail.length > 140) detail = detail.slice(0, 140) + '…';
        if (detail) detail = ` — ${detail}`;
      }
      throw new Error(`upload failed (${uploadResp.status})${detail}`);
    }
    const bucket = signedUrl.bucket_name || 'netwrckstatic.netwrck.com';
    return {
      url: `https://${bucket}/${signedUrl.object_path}`,
      bucket,
      objectPath: signedUrl.object_path || '',
      contentType,
      name: fileName,
    };
  }

  async function uploadToR2(blob, contentType, fileName) {
    const uploaded = await uploadAssetToBucket(blob, contentType, fileName);
    return uploaded.url;
  }

  function extFromName(name) {
    if (!name) return '';
    const idx = name.lastIndexOf('.');
    if (idx === -1) return '';
    return name.slice(idx);
  }

  function extFromType(type, fallback) {
    if (!type) return fallback || '';
    if (type.includes('png')) return '.png';
    if (type.includes('webp')) return '.webp';
    if (type.includes('jpeg') || type.includes('jpg')) return '.jpg';
    if (type.includes('mp4')) return '.mp4';
    if (type.includes('webm')) return '.webm';
    if (type.includes('mpeg') || type.includes('mp3')) return '.mp3';
    if (type.includes('wav')) return '.wav';
    if (type.includes('ogg')) return '.ogg';
    if (type.includes('aac')) return '.aac';
    if (type.includes('m4a') || type.includes('mp4a')) return '.m4a';
    return fallback || '';
  }

  function buildVariantAssetName(name, suffix) {
    const raw = String(name || '').trim() || 'asset';
    const ext = extFromName(raw);
    const stem = ext ? raw.slice(0, -ext.length) : raw;
    const cleanStem = String(stem || 'asset')
      .trim()
      .replace(/\s+/g, '-');
    return `${cleanStem}-${suffix}${ext}`;
  }

  function persistDerivedAssetLineage(sourceAsset, nextAsset, variantKind) {
    if (sourceAsset && canPersistAiAsset(sourceAsset)) {
      ensureSavedAiAssetLocal({
        src: sourceAsset.src,
        type: sourceAsset.type,
        name: sourceAsset.name,
      });
      saveAiAssetToAccount({
        src: sourceAsset.src,
        type: sourceAsset.type,
        name: sourceAsset.name,
      }).catch(function () {});
    }
    if (nextAsset && canPersistAiAsset(nextAsset)) {
      ensureSavedAiAssetLocal({
        src: nextAsset.src,
        type: nextAsset.type,
        name: nextAsset.name,
      });
      saveAiAssetToAccount({
        src: nextAsset.src,
        type: nextAsset.type,
        name: nextAsset.name,
        parentSrc: sourceAsset && sourceAsset.src ? sourceAsset.src : '',
        variantKind: variantKind || '',
      }).catch(function () {});
    }
    renderSavedAiPanels();
    renderAssetList();
  }

  async function uploadMediaToBucket(file) {
    const contentType = String((file && file.type) || '').toLowerCase();
    const inferredType = inferFsEntryType({
      mimeType: contentType,
      name: file && file.name ? file.name : '',
    });
    if (
      inferredType !== 'image' &&
      inferredType !== 'video' &&
      inferredType !== 'audio'
    ) {
      return null;
    }
    const fallbackExt =
      inferredType === 'image'
        ? '.png'
        : inferredType === 'video'
          ? '.mp4'
          : '.mp3';
    const ext =
      extFromName(file && file.name ? file.name : '') ||
      extFromType(contentType, fallbackExt) ||
      fallbackExt;
    const fileName = `video-editor-media-${Date.now()}-${Math.random().toString(36).slice(2, 8)}${ext}`;
    const uploaded = await uploadAssetToBucket(
      file,
      contentType || 'application/octet-stream',
      fileName
    );
    return normalizeFsSidebarEntry({
      name: file && file.name ? file.name : fileName,
      url: uploaded.url,
      bucket: uploaded.bucket,
      objectPath: uploaded.objectPath,
      size: file && Number.isFinite(file.size) ? file.size : 0,
      type: inferredType,
      storage: 'cloud',
      modTime: Date.now(),
    });
  }

  async function ensureServerAssetsHosted() {
    if (state.uploadingAssets) return false;
    state.uploadingAssets = true;
    renderQueue();
    let hadFailure = false;
    for (const asset of state.assets) {
      if (
        typeof asset.src === 'string' &&
        asset.src.startsWith('blob:') &&
        asset.file
      ) {
        const contentType =
          asset.file.type ||
          (asset.type === 'image'
            ? 'image/jpeg'
            : asset.type === 'audio'
              ? 'audio/mpeg'
              : 'video/mp4');
        const fallbackExt =
          asset.type === 'image'
            ? '.jpg'
            : asset.type === 'audio'
              ? '.mp3'
              : '.mp4';
        const ext =
          extFromName(asset.file.name) || extFromType(contentType, fallbackExt);
        const fileName = `video-editor-${Date.now()}-${asset.id}${ext}`;
        try {
          const url = await uploadToR2(asset.file, contentType, fileName);
          asset.src = url;
          if (asset.element) {
            asset.element.src = url;
          }
          asset.file = null;
          state.clips.forEach((clip) => {
            if (clip.assetId === asset.id) {
              clip.src = url;
            }
          });
        } catch (err) {
          const detail = err && err.message ? `: ${err.message}` : '';
          notify(`au${detail}`, 'error');
          hadFailure = true;
        }
      }
    }
    if (
      state.audioElement &&
      typeof state.audioElement.src === 'string' &&
      state.audioElement.src.startsWith('blob:') &&
      state.audioFile
    ) {
      const contentType = state.audioFile.type || 'audio/mpeg';
      const ext =
        extFromName(state.audioFile.name) || extFromType(contentType, '.mp3');
      const fileName = `video-editor-audio-${Date.now()}${ext}`;
      try {
        const url = await uploadToR2(state.audioFile, contentType, fileName);
        state.audioElement.src = url;
        state.audioFile = null;
      } catch (err) {
        const detail = err && err.message ? `: ${err.message}` : '';
        notify(`au${detail}`, 'error');
        hadFailure = true;
      }
    }
    renderAssetList();
    renderTimeline();
    state.uploadingAssets = false;
    renderQueue();
    return !hadFailure;
  }

  async function publishExport(blob, format) {
    try {
      const secret = getAuthSecret();
      if (!secret) {
        if (window.NetwrckTools) window.NetwrckTools.requireLogin();
        notify('li', 'error');
        return false;
      }
      const fileName = `video-editor-${Date.now()}.${format}`;
      const publishJob = {
        id: `publish-${Date.now()}`,
        label: 'P',
        kind: 'render',
        status: 'uploading',
        uploadKind: 'video',
      };
      const removePublishJob = () => {
        state.queue = state.queue.filter((job) => job !== publishJob);
        renderQueue();
      };
      state.queue.unshift(publishJob);
      renderQueue();
      let videoUrl;
      try {
        videoUrl = await uploadToR2(
          blob,
          format === 'mp4' ? 'video/mp4' : 'video/webm',
          fileName
        );
      } catch (err) {
        removePublishJob();
        throw err;
      }
      if (!videoUrl) {
        removePublishJob();
        notify('pf', 'error');
        return false;
      }
      const thumbBlob = await new Promise((resolve) =>
        el.previewCanvas.toBlob(resolve, 'image/webp', 0.85)
      );
      let thumbUrl = null;
      if (thumbBlob) {
        publishJob.uploadKind = 'thumb';
        renderQueue();
        try {
          thumbUrl = await uploadToR2(
            thumbBlob,
            'image/webp',
            `video-editor-thumb-${Date.now()}.webp`
          );
        } catch (err) {
          const detail = err && err.message ? `: ${err.message}` : '';
          notify(`tf${detail}`, 'error');
        }
      }
      removePublishJob();
      const payload = {
        generator: 'video-editor',
        args: {
          clips: state.clips.map((clip) => ({
            name: clip.name,
            type: clip.type,
            src: clip.src,
            duration: clip.duration,
            trim_start: clip.trimStart,
            trim_end: clip.trimEnd,
            speed: clip.speed,
            transition: clip.transition,
            transition_duration: clip.transitionDuration,
          })),
          fps: state.fps,
          resolution: `${state.resolution.width}x${state.resolution.height}`,
        },
        video_url: videoUrl,
        thumbnail_url: thumbUrl,
        duration_seconds: totalDuration(),
        width: state.resolution.width,
        height: state.resolution.height,
        format: format,
      };
      const resp = await fetch('/api/store-video-generation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: `Bearer ${secret}`,
        },
        body: JSON.stringify(payload),
      });
      if (!resp.ok) {
        const text = await resp.text().catch(() => '');
        let detail = '';
        if (text) {
          try {
            const data = JSON.parse(text);
            detail = data.error || data.message || data.detail || '';
          } catch (err) {
            detail = text;
          }
          detail = detail.replace(/\s+/g, ' ').trim();
          if (detail.length > 140) detail = detail.slice(0, 140) + '…';
          if (detail) detail = ` — ${detail}`;
        }
        console.error('Publish failed', resp.status, text);
        notify(`pf${detail}`, 'error');
        return false;
      }
      const post = await createGalleryVideoPost({
        videoUrl,
        thumbUrl,
        format,
        secret,
      });
      if (!post) return false;
      const postId = post && (post.id || post.ID);
      window.location.href = postId ? `/p/${postId}` : '/gallery';
      return true;
    } catch (err) {
      console.error('Publish failed', err);
      const detail = err && err.message ? `: ${err.message}` : '';
      notify(`pf${detail}`, 'error');
      return false;
    }
  }

  async function createGalleryVideoPost(options) {
    const videoUrl = options && options.videoUrl ? options.videoUrl : '';
    if (!videoUrl) return null;
    const secret = options && options.secret ? options.secret : getAuthSecret();
    const formData = new FormData();
    const duration = totalDuration();
    const resolution = `${state.resolution.width}x${state.resolution.height}`;
    const caption =
      el.shareCaption && el.shareCaption.value
        ? el.shareCaption.value.trim()
        : '';
    formData.append(
      'text',
      caption ||
        `Video Editor export ${resolution} ${Math.max(0, duration).toFixed(1)}s`
    );
    formData.append('media_url', videoUrl);
    formData.append('media_type', 'video');
    const headers = {};
    if (secret) {
      headers['X-API-Key'] = secret;
      headers.Authorization = `Bearer ${secret}`;
    }
    const resp = await fetch('/api/create-post', {
      method: 'POST',
      headers,
      body: formData,
    });
    if (!resp.ok) {
      const text = await resp.text().catch(() => '');
      let detail = '';
      if (text) {
        try {
          const data = JSON.parse(text);
          detail = data.error || data.message || data.detail || '';
        } catch (err) {
          detail = text;
        }
        detail = detail.replace(/\s+/g, ' ').trim();
        if (detail.length > 140) detail = detail.slice(0, 140) + '…';
        if (detail) detail = ` — ${detail}`;
      }
      console.error('Create gallery post failed', resp.status, text);
      notify(`pf${detail}`, 'error');
      return null;
    }
    try {
      return await resp.json();
    } catch (err) {
      return {};
    }
  }

  function getAuthSecret() {
    const creds =
      typeof window.getAuthCredentials === 'function'
        ? window.getAuthCredentials()
        : null;
    if (creds && creds.secret) return creds.secret;
    if (window.userData && window.userData.secret)
      return window.userData.secret;
    return '';
  }

  function hasAccountUser() {
    const user = window.userData || null;
    return !!(
      user &&
      (user.id || user.email || user.username) &&
      getAuthSecret()
    );
  }

  function getSelectedImageAsset() {
    return state.assets.find(
      (item) => item.id === state.selectedAssetId && item.type === 'image'
    );
  }

  function getAiReferenceInputs() {
    return [el.aiLtx3Image, el.aiH3Image].filter(Boolean);
  }

  function formatImageDimensions(width, height) {
    const w = Number(width) || 0;
    const h = Number(height) || 0;
    return w > 0 && h > 0 ? `${Math.round(w)} x ${Math.round(h)}` : '';
  }

  function setAiReferencePreview(options) {
    if (!el.aiReferencePanel) return;
    const src = options && options.src ? String(options.src).trim() : '';
    aiReferencePreviewToken += 1;
    const token = aiReferencePreviewToken;
    if (!src) {
      el.aiReferencePanel.classList.add('empty');
      if (el.aiReferencePreview) {
        el.aiReferencePreview.removeAttribute('src');
        el.aiReferencePreview.alt = '';
      }
      if (el.aiReferenceName)
        el.aiReferenceName.textContent = 'No reference image';
      if (el.aiReferenceSize)
        el.aiReferenceSize.textContent = 'No image selected';
      if (el.aiReferenceUrl) el.aiReferenceUrl.textContent = '';
      return;
    }
    const name = options.name || 'Image reference';
    const dimensions = formatImageDimensions(options.width, options.height);
    el.aiReferencePanel.classList.remove('empty');
    if (el.aiReferencePreview) {
      el.aiReferencePreview.src = src;
      el.aiReferencePreview.alt = name;
    }
    if (el.aiReferenceName) el.aiReferenceName.textContent = name;
    if (el.aiReferenceSize)
      el.aiReferenceSize.textContent = dimensions || 'Loading size';
    if (el.aiReferenceUrl) {
      el.aiReferenceUrl.textContent = src;
      el.aiReferenceUrl.title = src;
    }
    if (!dimensions) {
      const image = new Image();
      image.onload = () => {
        if (token !== aiReferencePreviewToken) return;
        const loaded = formatImageDimensions(
          image.naturalWidth,
          image.naturalHeight
        );
        if (loaded && el.aiReferenceSize)
          el.aiReferenceSize.textContent = loaded;
      };
      image.onerror = () => {
        if (token !== aiReferencePreviewToken) return;
        if (el.aiReferenceSize)
          el.aiReferenceSize.textContent = 'Size unavailable';
      };
      image.src = src;
    }
  }

  function setAiReferenceFromAsset(asset) {
    if (!asset || !asset.src) {
      setAiReferencePreview(null);
      return;
    }
    setAiReferencePreview({
      src: asset.src,
      name: asset.name || 'Selected image',
      width: asset.width,
      height: asset.height,
    });
  }

  function getAiReferenceDragAsset(dataTransfer) {
    if (!dataTransfer) return null;
    const assetId =
      dataTransfer.getData(AI_REFERENCE_ASSET_MIME) ||
      dataTransfer.getData('text/plain');
    if (!assetId) return null;
    return state.assets.find(
      (item) => item.id === assetId && item.type === 'image' && item.src
    );
  }

  function getAiReferenceDropImageFile(dataTransfer) {
    if (!dataTransfer || !dataTransfer.files) return null;
    return Array.from(dataTransfer.files).find((file) => {
      const type = (file.type || '').toLowerCase();
      const name = (file.name || '').toLowerCase();
      return (
        type.startsWith('image/') ||
        ['.png', '.jpg', '.jpeg', '.webp', '.gif', '.bmp', '.svg'].some((ext) =>
          name.endsWith(ext)
        )
      );
    });
  }

  function hasAiReferenceDropPayload(dataTransfer) {
    return !!(
      getAiReferenceDragAsset(dataTransfer) ||
      getAiReferenceDropImageFile(dataTransfer)
    );
  }

  function applyImageAssetToAiReference(asset) {
    if (!asset || asset.type !== 'image' || !asset.src) {
      notify('sa', 'error');
      return null;
    }
    state.selectedAssetId = asset.id;
    if (el.aiLtx3Image) {
      el.aiLtx3Image.value = asset.src;
      el.aiLtx3Image.style.display = 'block';
    }
    if (el.aiLtx3Mode) el.aiLtx3Mode.value = 'image-to-video';
    if (el.aiH3Image) {
      el.aiH3Image.value = asset.src;
      el.aiH3Image.style.display = 'block';
    }
    if (el.aiH3EndImage) el.aiH3EndImage.style.display = 'block';
    if (el.aiH3Mode) el.aiH3Mode.value = 'image-to-video';
    setAiReferenceFromAsset(asset);
    renderAssetList();
    return asset;
  }

  async function applyDroppedImageToAiReference(dataTransfer) {
    const dragAsset = getAiReferenceDragAsset(dataTransfer);
    if (dragAsset) return applyImageAssetToAiReference(dragAsset);
    const file = getAiReferenceDropImageFile(dataTransfer);
    if (!file) {
      notify('sa', 'error');
      return null;
    }
    const asset = await addAssetFromFile(file, { persistToMedia: true });
    return applyImageAssetToAiReference(asset);
  }

  function syncAiReferencePreviewFromInput(input) {
    if (!input) return;
    const src = input.value.trim();
    if (!src) {
      syncAiReferencePreviewFromSelectedOrInputs();
      return;
    }
    const asset = state.assets.find(
      (item) => item.type === 'image' && item.src === src
    );
    if (asset) {
      setAiReferenceFromAsset(asset);
      return;
    }
    setAiReferencePreview({ src, name: 'URL reference' });
  }

  function syncAiReferencePreviewFromSelectedOrInputs() {
    const selected = getSelectedImageAsset();
    if (selected) {
      setAiReferenceFromAsset(selected);
      return;
    }
    const input = getAiReferenceInputs().find((node) => node.value.trim());
    if (input) {
      syncAiReferencePreviewFromInput(input);
      return;
    }
    setAiReferencePreview(null);
  }

  function applySelectedImageToInput(input) {
    const asset = getSelectedImageAsset();
    if (!asset) {
      notify('sa', 'error');
      return null;
    }
    if (input) input.value = asset.src;
    setAiReferenceFromAsset(asset);
    return asset;
  }

  function clearAiReferenceImage() {
    getAiReferenceInputs().forEach((input) => {
      input.value = '';
    });
    if (el.aiH3EndImage) el.aiH3EndImage.value = '';
    if (el.aiLtx3Mode) el.aiLtx3Mode.value = 'text-to-video';
    if (el.aiH3Mode) el.aiH3Mode.value = 'text-to-video';
    if (el.aiLtx3Image) el.aiLtx3Image.style.display = 'none';
    if (el.aiH3Image) el.aiH3Image.style.display = 'none';
    if (el.aiH3EndImage) el.aiH3EndImage.style.display = 'none';
    setAiReferencePreview(null);
  }

  function bindAiImageInputDrop(input) {
    ['dragenter', 'dragover'].forEach((type) => {
      input.addEventListener(type, (event) => {
        if (!hasAiReferenceDropPayload(event.dataTransfer)) return;
        event.preventDefault();
        event.stopPropagation();
        event.dataTransfer.dropEffect = 'copy';
      });
    });
    input.addEventListener('drop', (event) => {
      if (!hasAiReferenceDropPayload(event.dataTransfer)) return;
      event.preventDefault();
      event.stopPropagation();
      const dragAsset = getAiReferenceDragAsset(event.dataTransfer);
      const file = dragAsset
        ? null
        : getAiReferenceDropImageFile(event.dataTransfer);
      if (!dragAsset && !file) {
        notify('Failed to use reference image', 'error');
        return;
      }
      if (dragAsset && /^https?:\/\//i.test(dragAsset.src || '')) {
        input.value = dragAsset.src;
        input.style.display = 'block';
        if (el.aiH3Mode) el.aiH3Mode.value = 'image-to-video';
        if (input === el.aiH3Image) setAiReferenceFromAsset(dragAsset);
        notify('hu', 'success');
        return;
      }
      const blob =
        file || (dragAsset && dragAsset.file instanceof Blob
          ? dragAsset.file
          : null);
      if (!blob) {
        notify('Failed to use reference image', 'error');
        return;
      }
      const name =
        (file && file.name) || (dragAsset && dragAsset.name) || 'Dropped image';
      uploadImageBlobForAiInput(blob, name)
        .then((url) => {
          input.value = url;
          input.style.display = 'block';
          if (el.aiH3Mode) el.aiH3Mode.value = 'image-to-video';
          if (input === el.aiH3Image) {
            setAiReferencePreview({ src: url, name });
          }
          notify('hu', 'success');
        })
        .catch(() => {
          notify('Failed to use reference image', 'error');
        });
    });
  }
  async function uploadReferenceImageToR2(file) {
    const contentType = file.type || 'image/png';
    const ext =
      extFromName(file.name) || extFromType(contentType, '.png') || '.png';
    const fileName = `video-editor-reference-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 8)}${ext}`;
    const url = await uploadToR2(file, contentType, fileName);
    getAiReferenceInputs().forEach((input) => {
      input.value = url;
    });
    if (el.aiLtx3Image) el.aiLtx3Image.style.display = 'block';
    if (el.aiH3Image) el.aiH3Image.style.display = 'block';
    if (el.aiH3EndImage) el.aiH3EndImage.style.display = 'block';
    if (el.aiLtx3Mode) el.aiLtx3Mode.value = 'image-to-video';
    if (el.aiH3Mode) el.aiH3Mode.value = 'image-to-video';
    setAiReferencePreview({ src: url, name: file.name || 'Uploaded image' });
    notify('hu', 'success');
    return url;
  }

  async function uploadImageBlobForAiInput(blob, name) {
    const contentType = blob.type || 'image/png';
    const ext =
      extFromName(name) || extFromType(contentType, '.png') || '.png';
    const fileName = `video-editor-h3-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 8)}${ext}`;
    return uploadToR2(blob, contentType, fileName);
  }

  function applySelectedImageToLtx3() {
    applyImageAssetToAiReference(getSelectedImageAsset());
  }

  async function generateLtx3Asset() {
    const prompt = el.aiLtx3Prompt ? el.aiLtx3Prompt.value.trim() : '';
    if (!prompt) {
      notify('np', 'error');
      return;
    }
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      return;
    }
    const duration =
      parseFloat(el.aiLtx3Duration ? el.aiLtx3Duration.value : '6') || 6;
    const resolution = el.aiLtx3Resolution
      ? el.aiLtx3Resolution.value
      : '1080p';
    const cost =
      resolution === '1440p' ? 0.12 * duration * 1.2 : 0.06 * duration * 1.2;
    const credits = Math.ceil(cost * 100);
    if (
      window.NetwrckTools &&
      !window.NetwrckTools.checkCredits(credits, cost.toFixed(2))
    )
      return;
    const mode = el.aiLtx3Mode ? el.aiLtx3Mode.value : 'text-to-video';
    const imageUrl = el.aiLtx3Image ? el.aiLtx3Image.value.trim() : '';
    if (mode === 'image-to-video' && !imageUrl) {
      notify('nu', 'error');
      return;
    }
    const placeholder = createGeneratingAsset({
      name: 'LTX Video',
      type: 'video',
    });
    const endpoint =
      mode === 'image-to-video'
        ? '/api/ltx-2.3-image-to-video'
        : '/api/ltx-text-to-video';
    const payload = {
      api_key: secret,
      prompt,
      duration,
      resolution,
      aspect_ratio: '16:9',
      fps: 25,
      generate_audio: true,
      response_mode: 'polling',
    };
    if (imageUrl) payload.image_url = imageUrl;
    try {
      const resp = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: `Bearer ${secret}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await resp.json();
      if (resp.status === 202 && data.job_id) {
        enqueueJob(
          {
            id: data.job_id,
            label: 'L3',
            status: 'in_progress',
            credits,
            cost,
            assetId: placeholder.id,
            assetName: 'LTX Video',
            statusEndpoint: data.status_url || '',
          },
          secret
        );
        return;
      }
      if (!resp.ok) {
        removeAssetById(placeholder.id);
        notify('lf', 'error');
        return;
      }
      const url = data.result?.video?.url || data.video?.url || data.video_url;
      if (url) {
        removeAssetById(placeholder.id);
        const asset = await addExternalAsset(url, 'video', 'LTX Video', {
          select: true,
          addToTimeline: true,
          addToStage: true,
        });
        if (asset) {
          rememberAiAsset(url, 'video', 'LTX Video');
          notify('ld', 'success');
          return;
        }
      }
      removeAssetById(placeholder.id);
      notify('lf', 'error');
    } catch (_) {
      removeAssetById(placeholder.id);
      notify('lf', 'error');
    }
  }

  async function generateH3Asset() {
    const prompt = el.aiH3Prompt ? el.aiH3Prompt.value.trim() : '';
    if (!prompt) {
      notify('np', 'error');
      return;
    }
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      return;
    }
    const mode = el.aiH3Mode ? el.aiH3Mode.value : 'text-to-video';
    const imageUrl = el.aiH3Image ? el.aiH3Image.value.trim() : '';
    const endImageUrl = el.aiH3EndImage ? el.aiH3EndImage.value.trim() : '';
    if (mode === 'image-to-video' && !imageUrl) {
      notify('nu', 'error');
      return;
    }
    const placeholder = createGeneratingAsset({
      name: 'H3 Video',
      type: 'video',
    });
    const payload = {
      api_key: secret,
      prompt,
      aspect_ratio: el.aiH3Aspect ? el.aiH3Aspect.value : '16:9',
      size: el.aiH3Size ? el.aiH3Size.value : 'balanced',
      duration:
        parseInt(el.aiH3Duration ? el.aiH3Duration.value : '5', 10) || 5,
      include_audio: el.aiH3Audio ? !!el.aiH3Audio.checked : true,
    };
    if (mode === 'image-to-video') {
      if (imageUrl) payload.first_frame = imageUrl;
      if (endImageUrl) payload.last_frame = endImageUrl;
    }
    try {
      const resp = await fetch('/api/minimax-h3-video', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: `Bearer ${secret}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await resp.json().catch(() => ({}));
      if (resp.status === 202 && data.job_id) {
        const credits =
          data.pricing && typeof data.pricing.reserved_credits === 'number'
            ? data.pricing.reserved_credits
            : 0;
        enqueueJob(
          {
            id: data.job_id,
            label: 'H3',
            status: 'in_progress',
            credits,
            cost: credits / 100,
            assetId: placeholder.id,
            assetName: 'H3 Video',
            statusEndpoint: data.status_url || '',
          },
          secret
        );
        notify('rq', 'info');
        return;
      }
      removeAssetById(placeholder.id);
      const detail = data.error || data.message || data.detail || '';
      notify(detail ? `h3f ${detail}` : 'h3f', 'error');
    } catch (_) {
      removeAssetById(placeholder.id);
      notify('h3f', 'error');
    }
  }

  const CUTOUT_POLL_INTERVAL_MS = 700;
  const CUTOUT_POLL_ATTEMPTS = 120;

  async function ensureCutoutSourceURL(asset) {
    const src = asset.src || '';
    if (/^https?:\/\//i.test(src)) return src;
    let blob = null;
    if (asset.file instanceof Blob) {
      blob = asset.file;
    } else if (src.startsWith('blob:') || src.startsWith('data:')) {
      blob = await (await fetch(src)).blob();
    }
    if (!blob) return '';
    try {
      const uploaded = await uploadToR2(
        blob,
        blob.type || 'image/png',
        `video-editor-cutout-src-${Date.now()}.png`
      );
      if (uploaded) return uploaded;
    } catch (_) {}
    if (src.startsWith('data:image/')) return src;
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => reject(new Error('read failed'));
      reader.readAsDataURL(blob);
    });
  }

  function cutoutResultURL(payload) {
    if (!payload) return '';
    return (
      payload.url ||
      payload.data_url ||
      payload.image_url ||
      (payload.image && payload.image.url) ||
      (payload.result && payload.result.image && payload.result.image.url) ||
      ''
    );
  }

  async function runNativeCutout(imageURL) {
    const secret = getAuthSecret();
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${secret}`,
    };
    const resp = await fetch('/api/cutout', {
      method: 'POST',
      headers,
      body: JSON.stringify({ image_url: imageURL, cache: true }),
    });
    const data = await resp.json().catch(() => null);
    if (!resp.ok) {
      throw new Error((data && data.error) || `cutout returned ${resp.status}`);
    }
    if (data && !data.error && data.status === 'done')
      return cutoutResultURL(data);
    if (data && data.job_id) {
      for (let attempt = 1; attempt <= CUTOUT_POLL_ATTEMPTS; attempt++) {
        await new Promise((resolve) =>
          setTimeout(resolve, CUTOUT_POLL_INTERVAL_MS)
        );
        const pollResp = await fetch(
          '/api/cutout/status?job=' + encodeURIComponent(data.job_id),
          { headers }
        );
        const job = await pollResp.json().catch(() => null);
        if (!job) continue;
        if (job.status === 'done') return cutoutResultURL(job);
        if (job.status === 'error')
          throw new Error(job.error || 'Cutout failed');
      }
      throw new Error('Timed out waiting for the cutout');
    }
    const url = cutoutResultURL(data);
    if (!url)
      throw new Error((data && data.error) || 'Cutout produced no image');
    return url;
  }

  function removeBackgroundCreditsForAsset(asset) {
    return asset && asset.type === 'video'
      ? REMOVE_BACKGROUND_VIDEO_CREDITS
      : REMOVE_BACKGROUND_IMAGE_CREDITS;
  }

  function creditsToUSD(credits) {
    return (Math.max(0, Number(credits) || 0) / 100).toFixed(2);
  }

  async function showPaidAPIPromptForResponse(resp, fallbackCredits) {
    if (!resp || resp.status !== 402 || !window.NetwrckTools) return false;
    let requiredCredits = fallbackCredits;
    try {
      const text = await resp.clone().text();
      try {
        const data = JSON.parse(text);
        if (Number.isFinite(Number(data.required))) {
          requiredCredits = Number(data.required);
        } else if (typeof data.error === 'string') {
          const match = data.error.match(/Required:\s*(\d+)/i);
          if (match) requiredCredits = Number(match[1]);
        }
      } catch (_) {
        const match = text.match(/Required:\s*(\d+)/i);
        if (match) requiredCredits = Number(match[1]);
      }
    } catch (_) {}
    if (typeof window.NetwrckTools.showCreditsToast === 'function') {
      window.NetwrckTools.showCreditsToast(
        requiredCredits,
        creditsToUSD(requiredCredits)
      );
    } else if (typeof window.NetwrckTools.checkCredits === 'function') {
      window.NetwrckTools.checkCredits(
        requiredCredits,
        creditsToUSD(requiredCredits)
      );
    }
    return true;
  }

  async function ensureVideoSourceURL(asset) {
    const src = asset.src || '';
    if (/^https?:\/\//i.test(src)) return src;
    let blob = null;
    if (asset.file instanceof Blob) {
      blob = asset.file;
    } else if (src.startsWith('blob:') || src.startsWith('data:')) {
      blob = await (await fetch(src)).blob();
    }
    if (!blob) return '';
    const ext = extFromType(blob.type, '.mp4') || '.mp4';
    return uploadToR2(
      blob,
      blob.type || 'video/mp4',
      `video-editor-bg-src-${Date.now()}${ext}`
    ).catch(() => '');
  }

  function videoBackgroundResultURL(payload) {
    if (!payload) return '';
    return (
      payload.result?.video?.url ||
      payload.result?.result?.video?.url ||
      payload.result?.video_url ||
      payload.result?.output ||
      payload.video?.url ||
      payload.video_url ||
      payload.output ||
      payload.url ||
      ''
    );
  }

  async function requestVideoBackgroundRemoval(asset, secret) {
    const videoURL = await ensureVideoSourceURL(asset);
    if (!videoURL) {
      throw new Error('Upload or save this video before removing its background');
    }
    const duration = Math.min(
      30,
      Math.max(1, Math.round(Number(asset.duration) || 5))
    );
    const headers = {
      'Content-Type': 'application/json',
      'X-API-Key': secret,
      Authorization: `Bearer ${secret}`,
    };
    const resp = await fetch('/api/remove-background-video', {
      method: 'POST',
      headers,
      body: JSON.stringify({ video_url: videoURL, duration }),
    });
    if (!resp.ok) {
      if (await showPaidAPIPromptForResponse(resp, REMOVE_BACKGROUND_VIDEO_CREDITS)) {
        throw new Error('PAYMENT_PROMPTED');
      }
      const text = await resp.text().catch(() => '');
      throw new Error(text.slice(0, 200) || `Request failed (${resp.status})`);
    }
    const data = await resp.json().catch(() => ({}));
    const immediate = videoBackgroundResultURL(data);
    if (immediate) return immediate;
    const jobId =
      data.result?.job_id || data.job_id || data.result?.jobId || '';
    if (!jobId) throw new Error('Background service returned no job');
    notify('Removing background — polling for the result', 'info');
    for (let attempt = 0; attempt < 1080; attempt += 1) {
      await new Promise((resolve) => window.setTimeout(resolve, 2500));
      const poll = await fetch(
        `/api/fal/status/${encodeURIComponent(jobId)}`,
        { headers }
      );
      if (!poll.ok) {
        if ([401, 403, 404].includes(poll.status)) {
          throw new Error(`Background job unavailable (${poll.status})`);
        }
        continue;
      }
      const status = await poll.json().catch(() => ({}));
      const state = String(status.status || status.state || '').toLowerCase();
      const url = videoBackgroundResultURL(status);
      if (url || state === 'completed') {
        if (!url) throw new Error('Background service returned no video');
        return url;
      }
      if (['failed', 'cancelled', 'canceled', 'payment_required'].includes(state)) {
        throw new Error(status.error || `Background removal ${state}`);
      }
    }
    throw new Error('Background removal is still running — check the job later');
  }

  async function removeBackgroundFromAsset(asset) {
    if (!asset || !asset.src) {
      notify('sa', 'error');
      return;
    }
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      return;
    }
    notify('rb', 'info');
    const credits = removeBackgroundCreditsForAsset(asset);
    if (
      window.NetwrckTools &&
      !window.NetwrckTools.checkCredits(credits, creditsToUSD(credits))
    )
      return;
    try {
      let url = '';
      if (asset.type === 'video') {
        url = await requestVideoBackgroundRemoval(asset, secret);
      } else {
        const imageURL = await ensureCutoutSourceURL(asset);
        if (!imageURL) {
          notify('rbf', 'error');
          return;
        }
        url = await runNativeCutout(imageURL);
      }
      if (!url) {
        notify('rbf', 'error');
        return;
      }
      const variantName = buildVariantAssetName(
        asset.name || 'asset',
        'background-removed'
      );
      const nextAsset = await addExternalAsset(url, asset.type, variantName, {
        select: true,
        addToTimeline: false,
        addToStage: false,
      });
      if (nextAsset) nextAsset.originalSrc = asset.src;
      persistDerivedAssetLineage(asset, nextAsset, 'background-removed');
      scheduleAutosave('background-removed');
      notify('rbd', 'success');
    } catch (err) {
      if (err && err.message === 'PAYMENT_PROMPTED') return;
      notify(err && err.message ? `rbf: ${err.message}` : 'rbf', 'error');
    }
  }

  async function removeBackgroundFromStageElement(element) {
    if (!element) return;
    const asset = state.assets.find((a) => a.id === element.assetId);
    if (!asset || !asset.src) {
      notify('sa', 'error');
      return;
    }
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      return;
    }
    notify('rb', 'info');
    const credits = removeBackgroundCreditsForAsset(asset);
    if (
      window.NetwrckTools &&
      !window.NetwrckTools.checkCredits(credits, creditsToUSD(credits))
    )
      return;
    try {
      let url = '';
      if (asset.type === 'video') {
        url = await requestVideoBackgroundRemoval(asset, secret);
      } else {
        const imageURL = await ensureCutoutSourceURL(asset);
        if (!imageURL) {
          notify('rbf', 'error');
          return;
        }
        url = await runNativeCutout(imageURL);
      }
      if (!url) {
        notify('rbf', 'error');
        return;
      }
      const variantName = buildVariantAssetName(
        asset.name || 'asset',
        'background-removed'
      );
      const newAsset = await addExternalAsset(url, asset.type, variantName, {
        select: false,
        addToTimeline: false,
        addToStage: false,
      });
      if (newAsset) {
        newAsset.originalSrc = asset.src;
        element.assetId = newAsset.id;
        const stageNode = el.stageElements
          ? el.stageElements.querySelector(`[data-stage-id="${element.id}"]`)
          : null;
        if (stageNode) {
          const img = stageNode.querySelector('img, video');
          if (img) img.src = url;
        }
        persistDerivedAssetLineage(asset, newAsset, 'background-removed');
        captureProjectHistory('background-removed-stage');
        saveProject();
        notify('rbd', 'success');
      }
    } catch (err) {
      if (err && err.message === 'PAYMENT_PROMPTED') return;
      notify(err && err.message ? `rbf: ${err.message}` : 'rbf', 'error');
    }
  }

  function assetOriginalForRefine(asset) {
    return (asset && (asset.originalSrc || asset.src)) || '';
  }

  function refineCutoutForAsset(asset) {
    if (!asset || asset.type !== 'image' || !asset.src) {
      notify('sa', 'error');
      return;
    }
    if (!window.MaskBrushEditor) {
      notify('cf', 'error');
      return;
    }
    window.MaskBrushEditor.open({
      imageUrl: asset.src,
      originalUrl: assetOriginalForRefine(asset),
      title: 'Refine Cutout',
      applyLabel: 'Apply Cutout',
      onApply: (blob) => applyRefinedCutout(asset, null, blob),
      onError: () => notify('cf', 'error'),
    });
  }

  function refineCutoutForStageElement(element) {
    if (!element) return;
    const asset = state.assets.find((a) => a.id === element.assetId);
    if (!asset || asset.type !== 'image' || !asset.src) {
      notify('sa', 'error');
      return;
    }
    if (!window.MaskBrushEditor) {
      notify('cf', 'error');
      return;
    }
    window.MaskBrushEditor.open({
      imageUrl: asset.src,
      originalUrl: assetOriginalForRefine(asset),
      title: 'Refine Cutout',
      applyLabel: 'Apply Cutout',
      onApply: (blob) => applyRefinedCutout(asset, element, blob),
      onError: () => notify('cf', 'error'),
    });
  }

  async function applyRefinedCutout(asset, element, blob) {
    if (!blob) {
      notify('cf', 'error');
      return;
    }
    const variantName = buildVariantAssetName(asset.name || 'asset', 'refined');
    const fileName = /\.png$/i.test(variantName)
      ? variantName
      : variantName + '.png';
    const file = new File([blob], fileName, { type: 'image/png' });
    let hostedUrl = '';
    try {
      hostedUrl = await uploadToR2(
        blob,
        'image/png',
        `video-editor-refined-${Date.now()}.png`
      );
    } catch (_) {}
    const src = hostedUrl || URL.createObjectURL(blob);
    const newAsset = await addExternalAsset(src, 'image', variantName, {
      select: !element,
      addToTimeline: false,
      addToStage: false,
    });
    if (!newAsset) {
      notify('cf', 'error');
      return;
    }
    if (!hostedUrl) newAsset.file = file;
    newAsset.originalSrc = assetOriginalForRefine(asset);
    persistDerivedAssetLineage(asset, newAsset, 'refined');
    if (element) {
      element.assetId = newAsset.id;
      const stageNode = el.stageElements
        ? el.stageElements.querySelector(`[data-stage-id="${element.id}"]`)
        : null;
      if (stageNode) {
        const img = stageNode.querySelector('img, video');
        if (img) img.src = src;
      }
      captureProjectHistory('refine-cutout-stage');
      saveProject();
    } else {
      scheduleAutosave('refine-cutout');
    }
    notify('cr', 'success');
  }

  async function convertStageElementToVideo(element) {
    if (!element || element.type !== 'image') return;
    const asset = state.assets.find(
      (a) => a.id === element.assetId && a.type === 'image'
    );
    if (!asset) {
      notify('sa', 'error');
      return;
    }
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      return;
    }
    const cost = 0.06 * 6 * 1.2;
    const credits = Math.ceil(cost * 100);
    if (
      window.NetwrckTools &&
      !window.NetwrckTools.checkCredits(credits, cost.toFixed(2))
    )
      return;
    let imageUrl = asset.src;
    if (imageUrl && imageUrl.startsWith('blob:') && asset.file) {
      try {
        const contentType = asset.file.type || 'image/jpeg';
        const ext =
          extFromName(asset.file.name) || extFromType(contentType, '.jpg');
        imageUrl = await uploadToR2(
          asset.file,
          contentType,
          `stage-i2v-${Date.now()}${ext}`
        );
        asset.src = imageUrl;
        asset.file = null;
      } catch (_) {
        notify('wf', 'error');
        return;
      }
    }
    const placeholder = createGeneratingAsset({
      name: 'Stage → Video',
      type: 'video',
    });
    const payload = {
      api_key: secret,
      prompt:
        asset.name || 'The scene comes to life with smooth cinematic motion',
      image_url: imageUrl,
      duration: 6,
      resolution: '1080p',
      aspect_ratio: '16:9',
      fps: 25,
      generate_audio: true,
      response_mode: 'polling',
    };
    try {
      const resp = await fetch('/api/ltx-2.3-image-to-video', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: `Bearer ${secret}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await resp.json();
      if (resp.status === 202 && data.job_id) {
        enqueueJob(
          {
            id: data.job_id,
            label: 'S',
            status: 'in_progress',
            credits,
            cost,
            assetId: placeholder.id,
            assetName: 'Stage → Video',
            statusEndpoint: data.status_url || '',
          },
          secret
        );
        return;
      }
      if (!resp.ok) {
        removeAssetById(placeholder.id);
        notify('lf', 'error');
        return;
      }
      const url = data.result?.video?.url || data.video?.url || data.video_url;
      if (url) {
        removeAssetById(placeholder.id);
        const videoAsset = await addExternalAsset(
          url,
          'video',
          'Stage → Video',
          { select: true, addToTimeline: true, addToStage: false }
        );
        if (videoAsset) {
          rememberAiAsset(url, 'video', 'Stage → Video');
          notify('ld', 'success');
          return;
        }
      }
      removeAssetById(placeholder.id);
      notify('lf', 'error');
    } catch (_) {
      removeAssetById(placeholder.id);
      notify('lf', 'error');
    }
  }

  function readAiAssetCache() {
    try {
      const raw = localStorage.getItem(AI_ASSET_CACHE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function writeAiAssetCache(list) {
    try {
      localStorage.setItem(
        AI_ASSET_CACHE_KEY,
        JSON.stringify(list.slice(0, 12))
      );
    } catch (_) {}
  }

  function rememberAiAsset(src, type, name) {
    if (!src) return;
    const list = readAiAssetCache().filter((item) => item && item.src !== src);
    list.unshift({ src, type: type || 'image', name: name || 'AI Art' });
    writeAiAssetCache(list);
  }

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function aiImageUrlFromResponse(data) {
    return (
      data?.image_url ||
      data?.url ||
      data?.path ||
      data?.result?.image_url ||
      data?.result?.url ||
      data?.result?.path ||
      data?.result?.image?.url ||
      data?.result?.output?.image_url ||
      data?.result?.output?.images?.[0]?.url ||
      data?.result?.output?.images?.[0] ||
      data?.images?.[0]?.url ||
      data?.images?.[0] ||
      data?.result?.images?.[0]?.url ||
      data?.result?.images?.[0] ||
      null
    );
  }

  function canLoadImageUrl(src) {
    return new Promise((resolve) => {
      if (!src) {
        resolve(false);
        return;
      }
      if (String(src).startsWith('data:') || String(src).startsWith('blob:')) {
        resolve(true);
        return;
      }
      let done = false;
      const finish = (value) => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(value);
      };
      const image = new Image();
      const retry = () => {
        const fallback = new Image();
        fallback.onload = () => finish(true);
        fallback.onerror = () => finish(false);
        fallback.src = src;
      };
      const timer = setTimeout(() => finish(false), 10000);
      image.crossOrigin = 'anonymous';
      image.onload = () => finish(true);
      image.onerror = retry;
      image.src = src;
    });
  }

  function sizeToDimensions(size) {
    const parts = String(size || '1024x1024')
      .split('x')
      .map(Number);
    return {
      width: parts[0] || 1024,
      height: parts[1] || 1024,
    };
  }

  async function fetchAiImageCandidate(source, prompt, size, secret) {
    if (source === 'images') {
      const dims = sizeToDimensions(size);
      const params = new URLSearchParams({
        prompt,
        width: String(dims.width),
        height: String(dims.height),
        model: 'zimage-turbo',
        auto_lora: 'true',
        teleport: 'true',
        perf: 'false',
      });
      return apiJson(`/api/create-and-upload-image?${params.toString()}`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'include',
      });
    }
    const payload = {
      prompt,
      size,
      resolution: size,
      api_key: secret,
      secret,
    };
    return apiJson(source, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': secret,
        Authorization: `Bearer ${secret}`,
      },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
  }

  async function generateImageWithFallbacks(prompt, size, secret) {
    const sources = ['/api/ra1'];
    if (
      window.location.hostname === 'netwrck.com' ||
      window.location.hostname === 'www.netwrck.com'
    ) {
      sources.push('https://beta.netwrck.com/api/ra1');
    }
    sources.push('images');
    let lastError = null;
    for (const source of sources) {
      for (let attempt = 0; attempt < 2; attempt++) {
        try {
          const data = await fetchAiImageCandidate(
            source,
            prompt,
            size,
            secret
          );
          const url = aiImageUrlFromResponse(data);
          if (!url) throw new Error('missing image url');
          if (await canLoadImageUrl(url)) {
            return { url, source };
          }
          throw new Error('image failed to load');
        } catch (error) {
          lastError = error;
          if (error && (error.status === 401 || error.status === 402)) {
            throw error;
          }
          if (attempt === 0) await wait(800);
        }
      }
    }
    throw lastError || new Error('image generation failed');
  }

  function normalizeSavedAiAsset(item) {
    if (!item || typeof item !== 'object') return null;
    const src = typeof item.src === 'string' ? item.src.trim() : '';
    const type =
      item.type === 'video'
        ? 'video'
        : item.type === 'audio'
          ? 'audio'
          : 'image';
    if (!src || src.startsWith('blob:')) return null;
    return {
      src,
      type,
      name:
        (typeof item.name === 'string' && item.name.trim()) ||
        (type === 'video'
          ? 'Saved Video'
          : type === 'audio'
            ? 'Saved Audio'
            : 'Saved Art'),
      savedAt: Number.isFinite(item.savedAt) ? item.savedAt : Date.now(),
    };
  }

  function readLocalSavedAiAssets() {
    try {
      const raw = localStorage.getItem(AI_SAVED_ASSET_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];
      const seen = new Set();
      const list = [];
      parsed.forEach((item) => {
        const normalized = normalizeSavedAiAsset(item);
        if (!normalized || seen.has(normalized.src)) return;
        seen.add(normalized.src);
        list.push(normalized);
      });
      return list;
    } catch (_) {
      return [];
    }
  }

  function writeLocalSavedAiAssets(list) {
    try {
      localStorage.setItem(
        AI_SAVED_ASSET_KEY,
        JSON.stringify(list.slice(0, 48))
      );
      return true;
    } catch (_) {
      return false;
    }
  }

  function mergeSavedAiAssetLists() {
    const seen = new Set();
    const merged = [];
    [state.syncedSavedAiAssets || [], readLocalSavedAiAssets()].forEach(
      (list) => {
        list.forEach((item) => {
          const normalized = normalizeSavedAiAsset(item);
          if (!normalized || seen.has(normalized.src)) return;
          seen.add(normalized.src);
          merged.push(normalized);
        });
      }
    );
    return merged;
  }

  function readSavedAiAssets() {
    return mergeSavedAiAssetLists();
  }

  function ensureSavedAiAssetLocal(item) {
    const normalized = normalizeSavedAiAsset(item);
    if (!normalized) return false;
    const list = readLocalSavedAiAssets();
    if (list.some((entry) => entry.src === normalized.src)) return true;
    list.unshift({ ...normalized, savedAt: Date.now() });
    return writeLocalSavedAiAssets(list);
  }

  function removeSavedAiAssetLocal(src) {
    const list = readLocalSavedAiAssets().filter((item) => item.src !== src);
    return writeLocalSavedAiAssets(list);
  }

  async function refreshSyncedSavedAiAssets() {
    if (!hasAccountUser()) {
      state.syncedSavedAiAssets = [];
      renderSavedAiPanels();
      return state.syncedSavedAiAssets;
    }
    try {
      const data = await apiJson('/api/video-editor/assets');
      state.syncedSavedAiAssets = Array.isArray(data.assets)
        ? data.assets.map(normalizeSavedAiAsset).filter(Boolean)
        : [];
      renderSavedAiPanels();
      return state.syncedSavedAiAssets;
    } catch (error) {
      state.syncedSavedAiAssets = [];
      renderSavedAiPanels();
      throw error;
    }
  }

  async function saveAiAssetToAccount(item) {
    const normalized = normalizeSavedAiAsset(item);
    if (!normalized) return null;
    return apiJson('/api/video-editor/assets/save', {
      method: 'POST',
      body: JSON.stringify({
        src: normalized.src,
        type: normalized.type,
        name: normalized.name,
        parent_src: item && item.parentSrc ? item.parentSrc : '',
        variant_kind: item && item.variantKind ? item.variantKind : '',
      }),
    });
  }

  async function deleteAiAssetFromAccount(src) {
    if (!src) return null;
    return apiJson('/api/video-editor/assets/delete', {
      method: 'POST',
      body: JSON.stringify({ src }),
    });
  }

  function canPersistAiAsset(item) {
    if (!item || typeof item !== 'object') return false;
    const src = typeof item.src === 'string' ? item.src.trim() : '';
    return (
      !!src &&
      !src.startsWith('blob:') &&
      (item.type === 'image' || item.type === 'video' || item.type === 'audio')
    );
  }

  function isAiAssetSaved(src) {
    if (!src) return false;
    return readSavedAiAssets().some((item) => item.src === src);
  }

  function setAiSaveButtonState(button, saved) {
    if (!button) return;
    button.classList.toggle('saved', !!saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.textContent = saved ? 'Saved' : 'Save';
  }

  function refreshAiSaveButtons() {
    document.querySelectorAll('[data-ai-save-src]').forEach((button) => {
      const src = button.getAttribute('data-ai-save-src') || '';
      setAiSaveButtonState(button, isAiAssetSaved(src));
    });
  }

  function createAiSaveButton(item) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'save-toggle-btn';
    button.setAttribute('data-ai-save-src', item.src || '');
    setAiSaveButtonState(button, isAiAssetSaved(item.src));
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleSavedAiAsset(item);
    });
    return button;
  }

  async function loadSavedAiAsset(item) {
    const normalized = normalizeSavedAiAsset(item);
    if (!normalized) return;
    let asset = state.assets.find(
      (entry) => entry.src === normalized.src && entry.type === normalized.type
    );
    if (!asset) {
      asset = await addExternalAsset(
        normalized.src,
        normalized.type,
        normalized.name,
        { select: true }
      );
    } else {
      state.selectedAssetId = asset.id;
      renderAssetList();
      scheduleAutosave();
    }
    if (asset) {
      rememberAiAsset(asset.src, asset.type, asset.name);
      if (normalized.type === 'audio') {
        loadAudioUrl(normalized.src, normalized.name);
      }
    }
  }

  function renderEmptyAiResults(container, text, className) {
    if (!container) return;
    container.innerHTML = '';
    const empty = document.createElement('div');
    empty.className = className || 'search-result-empty';
    empty.textContent = text;
    container.appendChild(empty);
  }

  function renderSavedAiAssetGrid(container, items) {
    if (!container) return;
    container.innerHTML = '';
    if (!items.length) return;
    items.forEach((item) => {
      const card = document.createElement('div');
      card.className = 'saved-generation-card';
      let media = null;
      if (item.type === 'audio') {
        media = document.createElement('div');
        media.className = 'search-result audio';
        media.innerHTML =
          '<div class="audio-icon"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 18V6l12-2v12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7" cy="18" r="3" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="19" cy="16" r="3" fill="none" stroke="currentColor" stroke-width="2"/></svg></div>';
      } else {
        media = document.createElement(item.type === 'video' ? 'video' : 'img');
        media.src = item.src;
      }
      if (item.type === 'video') {
        media.muted = true;
        media.playsInline = true;
        media.preload = 'metadata';
      }
      if (media.addEventListener) {
        media.addEventListener('error', () => {
          card.remove();
        });
      }
      const meta = document.createElement('div');
      meta.className = 'saved-generation-meta';
      const title = document.createElement('div');
      title.className = 'saved-generation-title';
      title.textContent = item.name;
      meta.appendChild(title);
      meta.appendChild(createAiSaveButton(item));
      card.appendChild(media);
      card.appendChild(meta);
      card.addEventListener('click', () => {
        loadSavedAiAsset(item);
      });
      container.appendChild(card);
    });
  }

  async function persistGeneratedAiAsset(item) {
    const normalized = normalizeSavedAiAsset(item);
    if (!normalized) return false;
    ensureSavedAiAssetLocal(normalized);
    renderSavedAiPanels();
    if (!hasAccountUser()) return true;
    try {
      await saveAiAssetToAccount(normalized);
      await refreshSyncedSavedAiAssets();
      return true;
    } catch (_) {
      return false;
    }
  }

  function renderSavedAiPanels() {
    const items = readSavedAiAssets();
    renderSavedAiAssetGrid(el.searchSavedResults, items);
    renderSavedAiAssetGrid(el.aiSavedResults, items);
    refreshAiSaveButtons();
  }

  function toggleSavedAiAsset(item) {
    const normalized = normalizeSavedAiAsset(item);
    if (!normalized) return false;
    const list = readLocalSavedAiAssets();
    const existingIndex = list.findIndex(
      (entry) => entry.src === normalized.src
    );
    let saved = false;
    if (existingIndex !== -1) {
      list.splice(existingIndex, 1);
      removeSavedAiAssetLocal(normalized.src);
      if (hasAccountUser()) {
        deleteAiAssetFromAccount(normalized.src)
          .then(() => {
            refreshSyncedSavedAiAssets().catch(function () {});
          })
          .catch(function () {});
      }
    } else {
      list.unshift({ ...normalized, savedAt: Date.now() });
      rememberAiAsset(normalized.src, normalized.type, normalized.name);
      saved = true;
      writeLocalSavedAiAssets(list);
      if (hasAccountUser()) {
        saveAiAssetToAccount(item)
          .then(() => {
            refreshSyncedSavedAiAssets().catch(function () {});
          })
          .catch(function () {});
      }
    }
    if (existingIndex !== -1) {
      writeLocalSavedAiAssets(list);
    }
    renderSavedAiPanels();
    renderAssetList();
    return saved;
  }

  function syncArtSearchInputs(query, source) {
    const value = String(query || '').trim();
    if (!value) return;
    if (source !== 'sidebar' && el.searchQuery) {
      el.searchQuery.value = value;
    }
    if (source !== 'modal' && el.aiRa1Prompt) {
      el.aiRa1Prompt.value = value;
    }
  }

  function getArtItemName(item) {
    if (!item || typeof item !== 'object') return 'AI Art';
    return item.name || item.Name || item.title || item.Title || 'AI Art';
  }

  function applyAiDefaults() {
    if (window.__TEST_MODE__) return;
    if (el.aiRa1Prompt) {
      const storedPrompt = localStorage.getItem(AI_LAST_PROMPT_KEY);
      el.aiRa1Prompt.value =
        storedPrompt ||
        el.aiRa1Prompt.value ||
        'Cinematic landscape with soft morning light';
    }
    if (el.aiRa1Size) {
      const storedSize = localStorage.getItem(AI_LAST_SIZE_KEY);
      if (
        storedSize &&
        Array.from(el.aiRa1Size.options).some((opt) => opt.value === storedSize)
      ) {
        el.aiRa1Size.value = storedSize;
      }
    }
    if (el.searchQuery) {
      const storedSearch = localStorage.getItem(AI_SEARCH_QUERY_KEY);
      state.searchKind = 'images';
      el.searchQuery.value =
        storedSearch || el.searchQuery.value || 'landscape';
      if (el.aiRa1Prompt && !el.aiRa1Prompt.value) {
        el.aiRa1Prompt.value = el.searchQuery.value;
      }
      if (el.searchResults && !el.searchResults.children.length) {
        searchAssets();
      }
    }
    if (state.assets.length) return;
    const cached = readAiAssetCache();
    const defaults = cached.length ? cached : DEFAULT_AI_ASSETS;
    defaults.forEach((item) => {
      if (!item || !item.src) return;
      addExternalAsset(item.src, item.type || 'image', item.name || 'AI Art');
    });
  }

  async function generateRa1Asset() {
    const prompt = el.aiRa1Prompt.value.trim();
    if (!prompt) {
      notify('np', 'error');
      return;
    }
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      if (window.showSubscribeDialog) window.showSubscribeDialog();
      return;
    }
    if (window.NetwrckTools && !window.NetwrckTools.checkCredits(4, '0.04'))
      return;
    if (
      window.NetwrckTools &&
      typeof window.NetwrckTools.checkSubscription === 'function'
    ) {
      if (!window.NetwrckTools.checkSubscription()) return;
    }
    const placeholder = createGeneratingAsset({
      name: 'RA1 Image',
      type: 'image',
    });
    try {
      localStorage.setItem(AI_LAST_PROMPT_KEY, prompt);
      if (el.aiRa1Size) {
        localStorage.setItem(AI_LAST_SIZE_KEY, el.aiRa1Size.value);
      }
    } catch (_) {}
    const originalText = el.aiRa1Generate ? el.aiRa1Generate.textContent : '';
    if (el.aiRa1Generate) {
      el.aiRa1Generate.disabled = true;
      el.aiRa1Generate.setAttribute('aria-busy', 'true');
      el.aiRa1Generate.textContent = 'Generating...';
    }
    try {
      const result = await generateImageWithFallbacks(
        prompt,
        el.aiRa1Size ? el.aiRa1Size.value : '1024x1024',
        secret
      );
      if (result && result.url) {
        removeAssetById(placeholder.id);
        const asset = await addExternalAsset(result.url, 'image', 'RA1 Image', {
          select: true,
          addToTimeline: true,
          addToStage: true,
        });
        if (asset) {
          rememberAiAsset(result.url, 'image', 'RA1 Image');
          notify('r1d', 'success');
          return;
        }
      }
      removeAssetById(placeholder.id);
      notify('r1f', 'error');
    } catch (error) {
      removeAssetById(placeholder.id);
      if (
        error &&
        error.status === 402 &&
        typeof window.showSubscribeDialog === 'function'
      ) {
        window.showSubscribeDialog();
      }
      notify('r1f', 'error');
    } finally {
      if (el.aiRa1Generate) {
        el.aiRa1Generate.disabled = false;
        el.aiRa1Generate.removeAttribute('aria-busy');
        el.aiRa1Generate.textContent = originalText || 'Generate';
      }
    }
  }

  async function generateComfyAsset() {
    const prompt = el.aiRa1Prompt ? el.aiRa1Prompt.value.trim() : '';
    if (!prompt) {
      notify('np', 'error');
      return;
    }
    if (el.aiComfyGenerate && el.aiComfyGenerate.disabled) return;
    const sizeVal = el.aiRa1Size ? el.aiRa1Size.value : '1024x1024';
    const [w, h] = sizeVal.split('x').map(Number);
    const placeholder = createGeneratingAsset({
      name: 'Alt Image',
      type: 'image',
    });
    const originalText = el.aiComfyGenerate
      ? el.aiComfyGenerate.textContent
      : '';
    if (el.aiComfyGenerate) {
      el.aiComfyGenerate.disabled = true;
      el.aiComfyGenerate.setAttribute('aria-busy', 'true');
      el.aiComfyGenerate.textContent = 'Generating...';
    }
    try {
      const resp = await fetch('/fal', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          model_name: 'comfy/leepenkman-6to13z8kkwo6/imgen',
          emptylatentimage_width: w || 1024,
          emptylatentimage_height: h || 1024,
          cliptextencode_text: prompt,
        }),
      });
      if (!resp.ok) {
        removeAssetById(placeholder.id);
        if (resp.status === 402) {
          if (typeof window.showSubscribeDialog === 'function') {
            window.showSubscribeDialog();
          }
          notify('Credits needed to generate', 'error');
        } else {
          notify('Alt image generation failed', 'error');
        }
        return;
      }
      const data = await resp.json();
      const url =
        data?.result?.images?.[0]?.url ||
        data?.result?.output?.images?.[0]?.url ||
        data?.result?.output?.images?.[0] ||
        data?.images?.[0]?.url ||
        null;
      if (url) {
        removeAssetById(placeholder.id);
        const asset = await addExternalAsset(url, 'image', 'Alt Image', {
          select: true,
          addToTimeline: true,
          addToStage: true,
        });
        if (asset) {
          rememberAiAsset(url, 'image', 'Alt Image');
          notify('Generated', 'success');
          return;
        }
      }
      removeAssetById(placeholder.id);
      notify('Alt image generation failed', 'error');
    } catch (_) {
      removeAssetById(placeholder.id);
      notify('Alt image generation failed', 'error');
    } finally {
      if (el.aiComfyGenerate) {
        el.aiComfyGenerate.disabled = false;
        el.aiComfyGenerate.removeAttribute('aria-busy');
        el.aiComfyGenerate.textContent = originalText || 'Generate Alt';
      }
    }
  }

  function enqueueJob(job, secret) {
    state.queue.unshift(job);
    renderQueue();
    pollJob(job, secret);
  }

  function renderQueue() {
    if (!el.queueList) return;
    el.queueList.innerHTML = '';
    state.queue.forEach((job) => {
      const canCancel = job.kind === 'render' && job.status === 'in_progress';
      if (!canCancel) return;
      const row = document.createElement('div');
      const cancelBtn = document.createElement('button');
      cancelBtn.removeAttribute('title');
      cancelBtn.disabled = !!job.canceling;
      cancelBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        cancelRenderJob(job);
      });
      row.appendChild(cancelBtn);
      el.queueList.appendChild(row);
    });
  }

  function showAssetContextMenu(x, y, asset, useSheet = false) {
    if (!el.assetContextMenu || !asset) return;
    hideStageContextMenu();
    hideStageBackgroundMenu();
    state.assetContextMenuId = asset.id;
    const capabilities = getAssetCapabilities(asset);
    const hasSrc = !!asset.src && asset.status !== 'generating';
    const visibility = {
      'add-clip': capabilities.addClip,
      'add-stage': capabilities.addStage,
      'use-audio': capabilities.useAudio,
      'image-to-video': capabilities.imageToVideo,
      'remove-bg': capabilities.removeBg,
      'refine-bg': asset.type === 'image',
      relight: capabilities.relight,
      'style-transfer': capabilities.styleTransfer,
      'extract-frame': capabilities.extractFrame,
      'convert-gif': capabilities.convertGif,
      'cut-asset': hasSrc,
      'copy-asset': hasSrc,
      'duplicate-asset': hasSrc,
      'rename-asset': true,
      'save-asset': capabilities.saveAsset,
      'download-asset': hasSrc,
      'copy-address': hasSrc && !asset.src.startsWith('blob:'),
      'delete-asset': true,
    };
    el.assetContextMenu
      .querySelectorAll('[data-asset-action]')
      .forEach((btn) => {
        const action = btn.getAttribute('data-asset-action');
        btn.hidden = !visibility[action];
        if (action === 'save-asset' && visibility[action]) {
          const saved = readSavedAiAssets().some(
            (entry) => entry.src === asset.src
          );
          btn.textContent = saved ? 'Remove from Saved' : 'Save to Library';
        }
      });
    lastContextMenuOpenedAt = Date.now();
    el.assetContextMenu.classList.add('open');
    el.assetContextMenu.setAttribute('aria-hidden', 'false');
    if (useSheet) {
      positionTimelineMenu(el.assetContextMenu, x, y, true);
      return;
    }
    const rect = el.assetContextMenu.getBoundingClientRect();
    const left = Math.max(8, Math.min(x, window.innerWidth - rect.width - 8));
    const top = Math.max(8, Math.min(y, window.innerHeight - rect.height - 8));
    el.assetContextMenu.style.left = `${left}px`;
    el.assetContextMenu.style.top = `${top}px`;
  }

  function hideAssetContextMenu() {
    if (!el.assetContextMenu) return;
    el.assetContextMenu.classList.remove('open');
    el.assetContextMenu.classList.remove('is-sheet');
    el.assetContextMenu.style.transform = '';
    el.assetContextMenu.setAttribute('aria-hidden', 'true');
    state.assetContextMenuId = null;
    updateTimelineContextOverlay();
  }

  async function generateVideoFromImageAsset(asset) {
    if (!asset || asset.type !== 'image') return;
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      if (window.showSubscribeDialog) window.showSubscribeDialog();
      return;
    }
    if (window.NetwrckTools && !window.NetwrckTools.checkCredits(30, '0.30'))
      return;
    const placeholder = createGeneratingAsset({
      name: 'Image → Video',
      type: 'video',
    });
    let imageUrl = asset.src;
    if (
      typeof imageUrl === 'string' &&
      imageUrl.startsWith('blob:') &&
      asset.file
    ) {
      try {
        const contentType = asset.file.type || 'image/jpeg';
        const ext =
          extFromName(asset.file.name) || extFromType(contentType, '.jpg');
        const fileName = `video-editor-i2v-${Date.now()}-${asset.id}${ext}`;
        imageUrl = await uploadToR2(asset.file, contentType, fileName);
        asset.src = imageUrl;
        asset.file = null;
        if (asset.element) {
          asset.element.src = imageUrl;
        }
      } catch (err) {
        removeAssetById(placeholder.id);
        notify('wf', 'error');
        return;
      }
    }
    const payload = {
      model_name: 'fal-ai/wan/v2.2-a14b/image-to-video',
      image_url: imageUrl,
      prompt:
        asset.name || 'The scene comes to life with smooth, cinematic motion',
      num_frames: 81,
      frames_per_second: 16,
      resolution: '720p',
      aspect_ratio: 'auto',
      num_inference_steps: 27,
      guidance_scale: 3.5,
      response_mode: 'polling',
    };
    try {
      const resp = await fetch('/fal', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: `Bearer ${secret}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await resp.json();
      if (resp.status === 202 && data.job_id) {
        enqueueJob(
          {
            id: data.job_id,
            label: 'I',
            status: 'in_progress',
            assetId: placeholder.id,
            assetName: 'Image → Video',
            statusEndpoint: data.status_url || '',
          },
          secret
        );
        return;
      }
      if (!resp.ok) {
        removeAssetById(placeholder.id);
        notify('wf', 'error');
        return;
      }
      const url = data.video?.url || data.result?.video?.url || data.video_url;
      if (url) {
        removeAssetById(placeholder.id);
        const out = await addExternalAsset(url, 'video', 'Image → Video', {
          select: true,
          addToTimeline: true,
          addToStage: true,
        });
        if (out) {
          rememberAiAsset(url, 'video', 'Image → Video');
          notify('wd', 'success');
          return;
        }
      }
      removeAssetById(placeholder.id);
      notify('wf', 'error');
    } catch (_) {
      removeAssetById(placeholder.id);
      notify('wf', 'error');
    }
  }

  async function extractFrameFromVideoAsset(asset) {
    if (!asset || asset.type !== 'video' || !asset.src) return;
    const video = document.createElement('video');
    video.muted = true;
    video.playsInline = true;
    video.preload = 'metadata';
    setEditorMediaSource(video, asset.src);

    const ensureReady = () =>
      new Promise((resolve) => {
        if (video.readyState >= 2 && video.videoWidth) {
          resolve();
          return;
        }
        const onLoaded = () => {
          cleanup();
          resolve();
        };
        const onError = () => {
          cleanup();
          resolve();
        };
        const cleanup = () => {
          video.removeEventListener('loadedmetadata', onLoaded);
          video.removeEventListener('error', onError);
        };
        video.addEventListener('loadedmetadata', onLoaded);
        video.addEventListener('error', onError);
      });

    const seekToStart = () =>
      new Promise((resolve) => {
        const onSeeked = () => {
          video.removeEventListener('seeked', onSeeked);
          resolve();
        };
        video.addEventListener('seeked', onSeeked);
        try {
          video.currentTime = 0;
        } catch (_) {
          video.removeEventListener('seeked', onSeeked);
          resolve();
        }
      });

    await ensureReady();
    await seekToStart();

    const width = video.videoWidth || asset.width || 640;
    const height = video.videoHeight || asset.height || 360;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(video, 0, 0, width, height);
    const dataUrl = canvas.toDataURL('image/png');

    await addExternalAsset(dataUrl, 'image', `${asset.name || 'Video'} Frame`, {
      select: true,
      addToTimeline: true,
      addToStage: true,
    });
  }

  let ffmpegModuleRef = null;
  let ffmpegInstanceRef = null;

  async function getFfmpegInstance() {
    if (ffmpegInstanceRef && ffmpegModuleRef)
      return { ffmpeg: ffmpegInstanceRef, module: ffmpegModuleRef };
    throw new Error('Client FFmpeg is not bundled locally');
  }

  async function fetchAssetBlob(asset) {
    if (asset?.file instanceof Blob) return asset.file;
    if (asset?.src) {
      const resp = await fetch(editorMediaSrc(asset.src));
      if (!resp.ok) throw new Error('fetch failed');
      return await resp.blob();
    }
    throw new Error('missing src');
  }

  async function convertVideoToGifAsset(asset) {
    if (!asset || asset.type !== 'video') return;
    const placeholder = createGeneratingAsset({
      name: `${asset.name || 'Video'} GIF`,
      type: 'image',
    });
    try {
      const blob = await fetchAssetBlob(asset);
      const { ffmpeg, module } = await getFfmpegInstance();
      const inputName = `input_${Date.now()}.mp4`;
      const outputName = `output_${Date.now()}.gif`;
      const data = await module.fetchFile(blob);
      ffmpeg.FS('writeFile', inputName, data);
      await ffmpeg.run(
        '-i',
        inputName,
        '-vf',
        'fps=12,scale=480:-1:flags=lanczos',
        '-loop',
        '0',
        outputName
      );
      const output = ffmpeg.FS('readFile', outputName);
      ffmpeg.FS('unlink', inputName);
      ffmpeg.FS('unlink', outputName);
      const gifBlob = new Blob([output.buffer], { type: 'image/gif' });
      const fileName = `${asset.name || 'video'}-clip.gif`;
      const file = new File([gifBlob], fileName, { type: 'image/gif' });
      removeAssetById(placeholder.id);
      await addImageAsset(file, {
        select: true,
        addToTimeline: true,
        addToStage: true,
      });
    } catch (_) {
      removeAssetById(placeholder.id);
      notify('gf', 'error');
    }
  }

  async function cancelRenderJob(job) {
    const secret = getAuthSecret();
    if (!secret) {
      if (window.NetwrckTools) window.NetwrckTools.requireLogin();
      return;
    }
    if (!job || !job.id) return;
    if (job.canceling) return;
    job.canceling = true;
    renderQueue();
    try {
      const resp = await fetch(`/api/video-editor/render/cancel/${job.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: `Bearer ${secret}`,
        },
      });
      let data = null;
      try {
        data = await resp.json();
      } catch (_e) {
        data = null;
      }
      if (resp.ok) {
        job.status = data?.status || 'cancelled';
        if (
          typeof data?.credits_refunded === 'number' &&
          data.credits_refunded > 0
        ) {
          notify(`rc${data.credits_refunded}`, 'info');
        } else {
          notify('rc', 'info');
        }
      } else {
        const detail = data?.error || data?.message || data?.detail || '';
        notify(detail ? `cf ${detail}` : 'cf', 'error');
      }
    } catch (err) {
      const detail = err && err.message ? ` — ${err.message}` : '';
      notify(`cf${detail}`, 'error');
    } finally {
      job.canceling = false;
      renderQueue();
    }
  }

  function pollJob(job, secret) {
    if (!job || !secret) return;
    let statusUrl =
      job.statusEndpoint ||
      `/api/fal/status/${job.id}?api_key=${encodeURIComponent(secret)}`;
    if (statusUrl && !/[?&]api_key=/.test(statusUrl)) {
      statusUrl +=
        (statusUrl.indexOf('?') === -1 ? '?' : '&') +
        `api_key=${encodeURIComponent(secret)}`;
    }
    fetch(statusUrl)
      .then((resp) => resp.json())
      .then((data) => {
        if (data.status) {
          job.status = data.status;
          renderQueue();
        }
        if (typeof data.progress === 'number') {
          job.progress = data.progress;
          updateGeneratingAssetProgress(job, data.progress);
          renderQueue();
        }
        if (data.status === 'completed') {
          if (job.kind === 'render') {
            const url = data.result?.video_url;
            if (url) {
              addExternalAsset(url, 'video', job.label || 'Server Render');
              if (job.publish) {
                window.location.href = '/gallery';
              }
              notify('rd', 'success');
            } else {
              notify('rd', 'success');
            }
          } else {
            const url =
              data.result?.video?.url ||
              data.result?.result?.video?.url ||
              data.result?.video_url;
            if (url) {
              if (job.assetId) {
                removeAssetById(job.assetId);
              }
              const label = job.assetName || job.label || 'Video';
              addExternalAsset(url, 'video', label, {
                select: true,
                addToTimeline: true,
                addToStage: true,
              });
              notify(`${job.label || 'v'}d`, 'success');
            }
          }
          return;
        }
        if (data.status === 'failed') {
          const label = job.label || 'Job';
          const detail = data.error || data.message || data.detail || '';
          if (job.assetId) removeAssetById(job.assetId);
          notify(detail ? `${label}f ${detail}` : `${label}f`, 'error');
          return;
        }
        if (data.status === 'cancelled') {
          const label = job.label || 'Job';
          if (job.assetId) removeAssetById(job.assetId);
          notify(`${label}c`, 'info');
          return;
        }
        setTimeout(() => pollJob(job, secret), 4000);
      })
      .catch(() => {
        setTimeout(() => pollJob(job, secret), 6000);
      });
  }

  function normalizeSearchKind(kind) {
    const next = kind === 'audio' ? 'audio' : 'images';
    if (next === 'audio' && state.audioSearchUnavailable) return 'images';
    return next;
  }

  function setAudioSearchUnavailable(unavailable) {
    state.audioSearchUnavailable = !!unavailable;
    if (el.searchKindButtons && el.searchKindButtons.length) {
      el.searchKindButtons.forEach((btn) => {
        const kind = btn.dataset.searchKind || '';
        if (kind !== 'audio') return;
        btn.disabled = state.audioSearchUnavailable;
        btn.setAttribute(
          'aria-disabled',
          state.audioSearchUnavailable ? 'true' : 'false'
        );
        btn.title = state.audioSearchUnavailable
          ? 'Audio search unavailable on this server'
          : 'Audio';
      });
    }
  }

  function setSearchKind(kind, options = {}) {
    const prev = state.searchKind;
    const next = normalizeSearchKind(kind);
    state.searchKind = next;
    if (el.searchKindButtons && el.searchKindButtons.length) {
      el.searchKindButtons.forEach((btn) => {
        const buttonKind = btn.dataset.searchKind || '';
        const disabled = buttonKind === 'audio' && state.audioSearchUnavailable;
        btn.disabled = disabled;
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        const active = buttonKind === next;
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    if (el.searchResults) {
      if (prev !== next) {
        el.searchResults.innerHTML = '';
      }
      el.searchResults.classList.toggle('audio', next === 'audio');
    }
    if (el.searchQuery) {
      el.searchQuery.placeholder =
        next === 'audio' ? 'Search audio' : 'Search art';
    }
    if (options.persist !== false) {
      try {
        localStorage.setItem(AI_SEARCH_KIND_KEY, next);
      } catch (_) {}
    }
  }

  async function searchAssets() {
    return searchArt({ source: 'sidebar', target: el.searchResults });
  }

  async function searchAudio() {
    const query = el.searchQuery.value.trim();
    if (!query) return;
    try {
      localStorage.setItem(AI_SEARCH_QUERY_KEY, query);
    } catch (_) {}
    el.searchResults.innerHTML = '';
    let response = null;
    try {
      response = await fetch(
        `/api/search-audio?query=${encodeURIComponent(query)}&limit=24`
      );
    } catch (_) {
      notify('Search failed', 'error');
      return;
    }
    if (!response.ok) {
      if (response.status === 404) {
        setAudioSearchUnavailable(true);
        setSearchKind('images');
        notify('Audio search unavailable (restart server)', 'info');
        return;
      }
      notify('Search failed', 'error');
      return;
    }
    let results = [];
    try {
      results = await response.json();
    } catch (_) {
      results = [];
    }
    if (!Array.isArray(results)) return;
    results.forEach((item) => {
      const url = item.url || item.audio_url || item.src || '';
      if (!url) return;
      const title = item.title || item.name || 'Audio';
      const card = document.createElement('div');
      card.className = 'search-result audio';
      const icon = document.createElement('div');
      icon.className = 'audio-icon';
      icon.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 18V6l12-2v12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7" cy="18" r="3" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="19" cy="16" r="3" fill="none" stroke="currentColor" stroke-width="2"/></svg>`;
      const meta = document.createElement('div');
      meta.className = 'audio-meta';
      const titleEl = document.createElement('div');
      titleEl.className = 'audio-title';
      titleEl.textContent = title;
      const tagsEl = document.createElement('div');
      tagsEl.className = 'audio-tags';
      const tags = [];
      if (item.provider) tags.push(item.provider);
      if (item.license) tags.push(item.license);
      if (item.attribution) tags.push(`by ${item.attribution}`);
      if (
        typeof item.duration === 'number' &&
        Number.isFinite(item.duration) &&
        item.duration > 0
      ) {
        tags.push(`${item.duration.toFixed(1)}s`);
      }
      if (Array.isArray(item.tags) && item.tags.length) {
        tags.push(item.tags.slice(0, 5).join(', '));
      }
      tagsEl.textContent = tags.join(' · ');
      meta.appendChild(titleEl);
      meta.appendChild(tagsEl);
      card.appendChild(icon);
      card.appendChild(meta);
      card.addEventListener('click', () => {
        addExternalAsset(url, 'audio', title, { select: true });
        loadAudioUrl(url, title);
      });
      el.searchResults.appendChild(card);
    });
  }

  function getSearchAiImageUrl(item) {
    if (!item || typeof item !== 'object') return '';
    const directUrl =
      item.image_url || item.imageUrl || item.url || item.src || '';
    if (directUrl) return directUrl;
    const fileName =
      item.avatar_file_name || item.avatarFileName || item.AvatarFileName || '';
    if (!fileName) return '';
    if (/^(https?:|data:)/i.test(fileName)) return fileName;
    if (fileName.startsWith('gs://')) {
      const parts = fileName.split('/');
      const uploadedName = parts[parts.length - 1] || '';
      return uploadedName
        ? `https://netwrckstatic.netwrck.com/static/uploads/${uploadedName}`
        : '';
    }
    return `https://netwrckstatic.netwrck.com/static/uploads/${String(fileName).replace(/^\/?static\/?uploads\/?/, '')}`;
  }

  function appendAllowNSFWSearchParam(params) {
    if (!(params instanceof URLSearchParams)) return params;
    if (window.addAllowNSFWParam) {
      return window.addAllowNSFWParam(params);
    }
    try {
      if (
        window.userData &&
        (window.userData.allow_nsfw || window.userData.AllowNSFW)
      ) {
        params.set('allow_nsfw', 'true');
      }
    } catch (_) {}
    return params;
  }

  async function fetchArtSearchResults(query) {
    let response = null;
    try {
      const params = new URLSearchParams({ query, limit: '24' });
      appendAllowNSFWSearchParam(params);
      response = await fetch(`/api/search-aiimages?${params.toString()}`, {
        credentials: 'include',
      });
    } catch (_) {
      return null;
    }
    if (!response.ok) {
      return null;
    }
    let results = [];
    try {
      const data = await response.json();
      if (Array.isArray(data)) {
        results = data;
      } else if (data && Array.isArray(data.results)) {
        results = data.results;
      } else if (data && Array.isArray(data.data)) {
        results = data.data;
      }
    } catch (_) {
      results = [];
    }
    return Array.isArray(results) ? results : [];
  }

  async function addArtResultToEditor(url, name) {
    const asset = await addExternalAsset(url, 'image', name, {
      select: true,
      addToTimeline: true,
      addToStage: true,
    });
    if (!asset) return null;
    rememberAiAsset(url, 'image', name);
    return asset;
  }

  function buildArtResultCard(item) {
    const url = getSearchAiImageUrl(item);
    if (!url) return null;
    const name = getArtItemName(item);
    const card = document.createElement('div');
    card.className = 'search-result';
    const img = document.createElement('img');
    img.src = url;
    img.addEventListener('error', () => {
      card.remove();
    });
    const meta = document.createElement('div');
    meta.className = 'search-result-meta';
    const title = document.createElement('div');
    title.className = 'search-result-title';
    title.textContent = name;
    meta.appendChild(title);
    meta.appendChild(createAiSaveButton({ src: url, type: 'image', name }));
    card.appendChild(img);
    card.appendChild(meta);
    card.addEventListener('click', () => {
      addArtResultToEditor(url, name).then((asset) => {
        if (!asset) {
          card.remove();
        }
      });
    });
    return card;
  }

  async function searchArt(options = {}) {
    const source = options.source === 'modal' ? 'modal' : 'sidebar';
    const target =
      options.target ||
      (source === 'modal' ? el.aiSearchResults : el.searchResults);
    if (!target) return;
    const query = String(
      options.query !== undefined
        ? options.query
        : source === 'modal'
          ? el.aiRa1Prompt
            ? el.aiRa1Prompt.value
            : ''
          : el.searchQuery
            ? el.searchQuery.value
            : ''
    ).trim();
    if (!query) return;
    syncArtSearchInputs(query, source);
    try {
      localStorage.setItem(AI_SEARCH_QUERY_KEY, query);
    } catch (_) {}
    target.innerHTML = '';
    const results = await fetchArtSearchResults(query);
    if (results === null) {
      notify('Search failed', 'error');
      renderEmptyAiResults(target, 'Search failed.');
      return;
    }
    if (!results.length) {
      renderEmptyAiResults(target, 'No art found.');
      return;
    }
    results.forEach((item) => {
      const card = buildArtResultCard(item);
      if (!card) return;
      target.appendChild(card);
    });
    if (!target.children.length) {
      renderEmptyAiResults(target, 'No art found.');
    }
  }

  async function searchAiModalArt() {
    return searchArt({ source: 'modal', target: el.aiSearchResults });
  }

  async function searchAudioTab() {
    const query =
      (el.audioSearchQuery ? el.audioSearchQuery.value.trim() : '') ||
      state.audioTabQuery;
    if (!query) return;
    state.audioTabQuery = query;
    if (!el.audioSearchResults) return;
    el.audioSearchResults.innerHTML = '';
    let response;
    try {
      response = await fetch(
        `/api/search-audio?query=${encodeURIComponent(query)}&limit=24`
      );
    } catch (_) {
      return;
    }
    if (!response.ok) return;
    let results = [];
    try {
      results = await response.json();
    } catch (_) {}
    if (!Array.isArray(results)) return;
    results.forEach((item) => {
      const url = item.url || '';
      if (!url) return;
      const title = item.title || 'Audio';
      const card = document.createElement('div');
      card.className = 'audio-result-card';
      card.setAttribute('tabindex', '0');
      const previewBtn = document.createElement('button');
      previewBtn.type = 'button';
      previewBtn.className = 'audio-preview-btn';
      previewBtn.setAttribute('aria-label', 'Preview ' + title);
      previewBtn.innerHTML =
        '<svg viewBox="0 0 24 24"><polygon points="8,5 19,12 8,19" fill="currentColor"/></svg>';
      previewBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleAudioPreview(url, previewBtn);
      });
      const meta = document.createElement('div');
      meta.className = 'audio-meta';
      const titleEl = document.createElement('div');
      titleEl.className = 'audio-title';
      titleEl.textContent = title;
      const tagsEl = document.createElement('div');
      tagsEl.className = 'audio-tags';
      const tags = [];
      if (item.provider) tags.push(item.provider);
      if (item.license) tags.push(item.license);
      if (item.attribution) tags.push(`by ${item.attribution}`);
      if (typeof item.duration === 'number' && item.duration > 0)
        tags.push(formatAudioDuration(item.duration));
      if (Array.isArray(item.tags) && item.tags.length)
        tags.push(item.tags.slice(0, 5).join(', '));
      tagsEl.textContent = tags.join(' \u00b7 ');
      meta.appendChild(titleEl);
      meta.appendChild(tagsEl);
      card.appendChild(previewBtn);
      card.appendChild(meta);
      card.addEventListener('click', () => {
        stopAudioPreview();
        addExternalAsset(url, 'audio', title, { select: true });
        loadAudioUrl(url, title);
      });
      el.audioSearchResults.appendChild(card);
    });
  }

  function setGeneratedMusicStatus(message, tone) {
    if (!el.audioGenerateStatus) return;
    el.audioGenerateStatus.textContent = message || '';
    el.audioGenerateStatus.className = 'music-generate-status';
    if (tone) el.audioGenerateStatus.classList.add(tone);
  }

  function setGeneratedMusicBusy(busy) {
    if (!el.audioGenerateSubmit) return;
    el.audioGenerateSubmit.disabled = !!busy;
    el.audioGenerateSubmit.textContent = busy
      ? 'Generating…'
      : 'Generate ($0.50)';
  }

  function renderGeneratedMusicResult(result) {
    state.musicGenerateResult = result || null;
    if (el.audioGenerateOpenEditor) {
      el.audioGenerateOpenEditor.textContent = 'Tool';
    }
    if (!el.audioGeneratedResult) return;
    el.audioGeneratedResult.innerHTML = '';
    if (!result || !result.audio_url) return;
    const card = document.createElement('div');
    card.className = 'audio-result-card generated';
    const meta = document.createElement('div');
    meta.className = 'audio-meta';
    const title = document.createElement('div');
    title.className = 'audio-title';
    title.textContent = result.title || result.name || 'Generated Music';
    const tags = document.createElement('div');
    tags.className = 'audio-tags';
    const tagList = [];
    if (result.format) tagList.push(String(result.format).toUpperCase());
    if (result.content_type) tagList.push(result.content_type);
    tags.textContent = tagList.join(' · ');
    meta.appendChild(title);
    meta.appendChild(tags);
    const audio = document.createElement('audio');
    audio.className = 'generated-audio-preview';
    audio.controls = true;
    audio.preload = 'metadata';
    audio.src = result.audio_url;
    const actions = document.createElement('div');
    actions.className = 'action-row';
    const addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.textContent = 'Use';
    addBtn.addEventListener('click', () => {
      if (result.asset) {
        state.selectedAssetId = result.asset.id;
        renderAssetList();
      }
      loadAudioUrl(result.audio_url, result.title || 'Generated Music');
    });
    const saveBtn = document.createElement('button');
    saveBtn.type = 'button';
    saveBtn.className = 'secondary';
    saveBtn.textContent = 'Save';
    saveBtn.addEventListener('click', async () => {
      const ok = await persistGeneratedAiAsset({
        src: result.audio_url,
        type: 'audio',
        name: result.title || 'Generated Music',
      });
      setGeneratedMusicStatus(
        ok ? 'Saved to synced audio library.' : 'Could not save track.',
        ok ? 'success' : 'error'
      );
    });
    actions.appendChild(addBtn);
    actions.appendChild(saveBtn);
    card.appendChild(meta);
    card.appendChild(audio);
    card.appendChild(actions);
    el.audioGeneratedResult.appendChild(card);
  }

  async function finalizeGeneratedMusicJob(result) {
    if (!result || !result.audio_url) return;
    const placeholder = state.assets.find(
      (entry) =>
        entry.status === 'generating' &&
        entry.jobId === state.musicGenerateJobId
    );
    if (placeholder) {
      removeAssetById(placeholder.id);
    }
    let asset = state.assets.find(
      (entry) => entry.src === result.audio_url && entry.type === 'audio'
    );
    if (!asset) {
      asset = await addExternalAsset(
        result.audio_url,
        'audio',
        result.title || 'Generated Music',
        { select: true }
      );
    }
    if (asset) {
      result.asset = asset;
      rememberAiAsset(
        result.audio_url,
        'audio',
        result.title || asset.name || 'Generated Music'
      );
      loadAudioUrl(
        result.audio_url,
        result.title || asset.name || 'Generated Music'
      );
      if (result.bucket || result.object_path) {
        upsertStoredFsSidebarEntry({
          name: result.title || asset.name || 'Generated Music',
          url: result.audio_url,
          bucket: result.bucket || '',
          objectPath: result.object_path || '',
          type: 'audio',
          modTime: Date.now(),
        });
        refreshFsSidebarEntries();
      }
      await persistGeneratedAiAsset({
        src: result.audio_url,
        type: 'audio',
        name: result.title || asset.name || 'Generated Music',
      });
    }
    renderGeneratedMusicResult(result);
  }

  async function pollGeneratedMusicJob(jobId) {
    if (!jobId) return;
    try {
      const headers = { 'Content-Type': 'application/json' };
      const secret = getAuthSecret();
      if (secret) {
        headers.Authorization = `Bearer ${secret}`;
        headers['X-API-Key'] = secret;
      }
      const response = await fetch(
        `/api/music-generator/status/${encodeURIComponent(jobId)}`,
        {
          credentials: 'include',
          headers,
        }
      );
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const placeholder = state.assets.find(
          (entry) => entry.status === 'generating' && entry.jobId === jobId
        );
        if (placeholder) removeAssetById(placeholder.id);
        setGeneratedMusicBusy(false);
        setGeneratedMusicStatus(
          data.error || 'Music generation failed.',
          'error'
        );
        return;
      }
      if (data.status === 'completed') {
        setGeneratedMusicBusy(false);
        await finalizeGeneratedMusicJob(data.result || {});
        setGeneratedMusicStatus('Generated and loaded into audio.', 'success');
        return;
      }
      if (data.status === 'failed') {
        const placeholder = state.assets.find(
          (entry) => entry.status === 'generating' && entry.jobId === jobId
        );
        if (placeholder) removeAssetById(placeholder.id);
        setGeneratedMusicBusy(false);
        setGeneratedMusicStatus(
          data.error || 'Music generation failed.',
          'error'
        );
        return;
      }
      const progress =
        typeof data.progress === 'number'
          ? ` ${Math.max(0, Math.min(100, data.progress))}%`
          : '';
      setGeneratedMusicStatus(`Generating music…${progress}`, '');
      setTimeout(() => pollGeneratedMusicJob(jobId), 3000);
    } catch (_) {
      const placeholder = state.assets.find(
        (entry) => entry.status === 'generating' && entry.jobId === jobId
      );
      if (placeholder) removeAssetById(placeholder.id);
      setGeneratedMusicBusy(false);
      setGeneratedMusicStatus('Music generation failed.', 'error');
    }
  }

  async function submitGeneratedMusicJob() {
    const prompt = (
      el.audioGeneratePrompt && el.audioGeneratePrompt.value
        ? el.audioGeneratePrompt.value
        : ''
    ).trim();
    if (!prompt) {
      setGeneratedMusicStatus('Prompt required.', 'error');
      return;
    }
    const secret = getAuthSecret();
    const payload = {
      prompt,
      duration:
        parseInt(
          el.audioGenerateDuration ? el.audioGenerateDuration.value : '12',
          10
        ) || 12,
      format: el.audioGenerateFormat ? el.audioGenerateFormat.value : 'wav',
      title: prompt.slice(0, 64),
    };
    const seedRaw = (
      el.audioGenerateSeed && el.audioGenerateSeed.value
        ? el.audioGenerateSeed.value
        : ''
    ).trim();
    if (seedRaw) {
      payload.seed = parseInt(seedRaw, 10) || 0;
    }
    setGeneratedMusicBusy(true);
    setGeneratedMusicStatus('Submitting music job…', '');
    renderGeneratedMusicResult(null);
    const placeholder = createGeneratingAsset({
      name: 'Generated Music',
      type: 'audio',
    });
    try {
      const headers = { 'Content-Type': 'application/json' };
      if (secret) {
        headers.Authorization = `Bearer ${secret}`;
        headers['X-API-Key'] = secret;
      }
      const response = await fetch('/api/music-generator', {
        method: 'POST',
        credentials: 'include',
        headers,
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        removeAssetById(placeholder.id);
        setGeneratedMusicBusy(false);
        if (
          response.status === 401 &&
          window.NetwrckTools &&
          typeof window.NetwrckTools.requireLogin === 'function'
        ) {
          window.NetwrckTools.requireLogin();
        }
        setGeneratedMusicStatus(
          data.error || 'Music generation failed.',
          'error'
        );
        return;
      }
      state.musicGenerateJobId = data.job_id || '';
      placeholder.jobId = state.musicGenerateJobId;
      if (!state.musicGenerateJobId) {
        removeAssetById(placeholder.id);
        setGeneratedMusicBusy(false);
        setGeneratedMusicStatus('Music job missing id.', 'error');
        return;
      }
      pollGeneratedMusicJob(state.musicGenerateJobId);
      if (el.audioGenerateOpenEditor) {
        el.audioGenerateOpenEditor.textContent = 'Tool';
      }
    } catch (_) {
      removeAssetById(placeholder.id);
      setGeneratedMusicBusy(false);
      setGeneratedMusicStatus('Music generation failed.', 'error');
    }
  }

  function formatAudioDuration(secs) {
    if (secs < 60) return secs.toFixed(1) + 's';
    const m = Math.floor(secs / 60);
    const s = Math.floor(secs % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function toggleAudioPreview(url, btn) {
    if (
      state.audioPreviewUrl === url &&
      state.audioPreviewEl &&
      !state.audioPreviewEl.paused
    ) {
      stopAudioPreview();
      return;
    }
    stopAudioPreview();
    const audio = new Audio();
    setEditorMediaSource(audio, url);
    audio.volume = 0.5;
    state.audioPreviewEl = audio;
    state.audioPreviewUrl = url;
    const card = btn && btn.closest('.audio-result-card');
    let progressEl = null;
    if (card) {
      progressEl = document.createElement('div');
      progressEl.className = 'audio-card-progress';
      card.appendChild(progressEl);
    }
    if (btn) {
      btn.classList.add('playing');
      btn.innerHTML =
        '<span class="audio-waveform-icon"><i></i><i></i><i></i><i></i></span>';
    }
    audio.addEventListener('timeupdate', () => {
      if (progressEl && audio.duration > 0) {
        progressEl.style.width =
          (audio.currentTime / audio.duration) * 100 + '%';
      }
    });
    audio.addEventListener('ended', () => stopAudioPreview());
    audio.play().catch(() => {
      state.audioPreviewEl = null;
      state.audioPreviewUrl = '';
      if (progressEl) progressEl.remove();
      if (btn) {
        btn.classList.remove('playing');
        btn.classList.add('error');
        btn.innerHTML =
          '<svg viewBox="0 0 24 24"><line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/><line x1="20" y1="4" x2="4" y2="20" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>';
      }
    });
  }

  function stopAudioPreview() {
    if (state.audioPreviewEl) {
      state.audioPreviewEl.pause();
      state.audioPreviewEl = null;
    }
    state.audioPreviewUrl = '';
    document
      .querySelectorAll('.audio-card-progress')
      .forEach((p) => p.remove());
    document.querySelectorAll('.audio-preview-btn.playing').forEach((b) => {
      b.classList.remove('playing');
      b.innerHTML =
        '<svg viewBox="0 0 24 24"><polygon points="8,5 19,12 8,19" fill="currentColor"/></svg>';
    });
  }

  var SHORTCUTS_MAP = [
    { keys: 'Space', label: 'Play / Pause', cat: 'Playback' },
    { keys: 'K', label: 'Play / Pause', cat: 'Playback' },
    { keys: ', / .', label: 'Step playhead one frame', cat: 'Playback' },
    { keys: 'Shift+, / .', label: 'Seek playhead one second', cat: 'Playback' },
    { keys: 'Left / Right', label: 'Step playhead one frame', cat: 'Playback' },
    {
      keys: 'Shift+Left / Right',
      label: 'Seek playhead one second',
      cat: 'Playback',
    },
    { keys: 'Home / End', label: 'Playhead to start / end', cat: 'Playback' },
    { keys: 'M', label: 'Mute audio', cat: 'Playback' },
    { keys: 'T', label: 'Add text', cat: 'Create' },
    { keys: 'R', label: 'Add rectangle', cat: 'Create' },
    { keys: 'C', label: 'Add circle', cat: 'Create' },
    { keys: 'L', label: 'Add line', cat: 'Create' },
    { keys: 'G', label: 'AI Generator', cat: 'Create' },
    { keys: 'Del / Backspace', label: 'Delete selection', cat: 'Edit' },
    { keys: 'Ctrl+Z', label: 'Undo', cat: 'Edit' },
    { keys: 'Ctrl+Shift+Z', label: 'Redo', cat: 'Edit' },
    { keys: 'Ctrl+Y', label: 'Redo (alt)', cat: 'Edit' },
    { keys: 'Ctrl+C', label: 'Copy element', cat: 'Clipboard' },
    { keys: 'Ctrl+V', label: 'Paste element', cat: 'Clipboard' },
    { keys: 'Ctrl+D', label: 'Duplicate element', cat: 'Clipboard' },
    { keys: 'Ctrl+A', label: 'Select all', cat: 'Selection' },
    { keys: 'Tab', label: 'Next element', cat: 'Selection' },
    { keys: 'Shift+Tab', label: 'Previous element', cat: 'Selection' },
    { keys: 'H', label: 'Toggle visibility', cat: 'Layers' },
    { keys: 'Alt+Shift+L', label: 'Toggle lock', cat: 'Layers' },
    { keys: 'Ctrl+]', label: 'Bring forward', cat: 'Layers' },
    { keys: 'Ctrl+[', label: 'Send backward', cat: 'Layers' },
    { keys: 'Ctrl+Alt+]', label: 'Bring to front', cat: 'Layers' },
    { keys: 'Ctrl+Alt+[', label: 'Send to back', cat: 'Layers' },
    { keys: 'F', label: 'Toggle filter panel', cat: 'Layers' },
    { keys: 'Shift+F', label: 'Clear filters', cat: 'Layers' },
    { keys: 'Ctrl+B', label: 'Bold', cat: 'Text' },
    { keys: 'Ctrl+I', label: 'Italic', cat: 'Text' },
    { keys: 'Ctrl+U', label: 'Underline', cat: 'Text' },
    { keys: 'Ctrl+Shift+F', label: 'Focus font search', cat: 'Text' },
    { keys: 'Ctrl+Shift+K', label: 'Uppercase', cat: 'Text' },
    { keys: 'Ctrl+Shift+L', label: 'Align left', cat: 'Text' },
    { keys: 'Ctrl+Shift+E', label: 'Align center', cat: 'Text' },
    { keys: 'Ctrl+Shift+R', label: 'Align right', cat: 'Text' },
    { keys: 'S', label: 'Split at playhead', cat: 'Timeline' },
    { keys: 'Alt+D', label: 'Duplicate clips', cat: 'Timeline' },
    { keys: 'Alt+P', label: 'Move to playhead', cat: 'Timeline' },
    { keys: 'Alt+Shift+O', label: 'Reverse clip order', cat: 'Timeline' },
    { keys: 'Alt+Home', label: 'Move to start', cat: 'Timeline' },
    { keys: 'Alt+End', label: 'Move to end', cat: 'Timeline' },
    {
      keys: 'Arrow keys',
      label: 'Move automation keyframes',
      cat: 'Automation',
    },
    { keys: 'Ctrl+S', label: 'Save project', cat: 'Project' },
    { keys: 'Ctrl+/', label: 'Toggle sidebar', cat: 'Project' },
    { keys: 'Ctrl+E', label: 'Filters', cat: 'Project' },
    { keys: 'Ctrl+Enter', label: 'New page', cat: 'Project' },
    { keys: 'Ctrl++/-', label: 'Zoom in/out', cat: 'View' },
    { keys: 'Ctrl+0', label: 'Zoom 100%', cat: 'View' },
    { keys: 'Ctrl+F1', label: 'Focus toolbar', cat: 'View' },
    { keys: 'Ctrl+F2', label: 'Focus canvas', cat: 'View' },
    { keys: '?', label: 'Keyboard shortcuts', cat: 'View' },
  ];

  function renderShortcutsList(filter) {
    var container = getEl('shortcuts-list');
    if (!container) return;
    container.innerHTML = '';
    var q = (filter || '').toLowerCase().trim();
    var groups = [];
    var lookup = {};
    SHORTCUTS_MAP.forEach(function (s) {
      if (
        q &&
        s.keys.toLowerCase().indexOf(q) === -1 &&
        s.label.toLowerCase().indexOf(q) === -1 &&
        s.cat.toLowerCase().indexOf(q) === -1
      )
        return;
      if (!lookup[s.cat]) {
        lookup[s.cat] = [];
        groups.push({ cat: s.cat, items: lookup[s.cat] });
      }
      lookup[s.cat].push(s);
    });
    groups.forEach(function (group) {
      var section = document.createElement('div');
      section.className = 'shortcut-category-group';
      var heading = document.createElement('div');
      heading.className = 'shortcut-category';
      heading.textContent = group.cat;
      section.appendChild(heading);
      group.items.forEach(function (s) {
        var row = document.createElement('div');
        row.className = 'shortcut-row';
        row.innerHTML = '<kbd>' + s.keys + '</kbd><span>' + s.label + '</span>';
        section.appendChild(row);
      });
      container.appendChild(section);
    });
    if (!container.children.length) {
      container.innerHTML =
        '<div class="shortcuts-empty">No shortcuts match</div>';
    }
  }

  function toggleKeyboardShortcuts(open) {
    if (!el.keyboardShortcutsModal) return;
    const shouldOpen =
      open === undefined
        ? !el.keyboardShortcutsModal.classList.contains('open')
        : open;
    if (shortcutsFocusRaf) {
      cancelAnimationFrame(shortcutsFocusRaf);
      shortcutsFocusRaf = null;
    }
    if (
      !shouldOpen &&
      el.keyboardShortcutsModal.contains(document.activeElement)
    ) {
      if (el.toolbarShortcutsHelp) el.toolbarShortcutsHelp.focus();
      else if (document.activeElement.blur) document.activeElement.blur();
    }
    el.keyboardShortcutsModal.classList.toggle('open', shouldOpen);
    el.keyboardShortcutsModal.inert = !shouldOpen;
    el.keyboardShortcutsModal.setAttribute(
      'aria-hidden',
      shouldOpen ? 'false' : 'true'
    );
    updateEditorModalOpenState();
    if (shouldOpen) {
      renderShortcutsList('');
      announceLive('Keyboard shortcuts');
      var searchInput = getEl('shortcuts-search');
      shortcutsFocusRaf = requestAnimationFrame(() => {
        shortcutsFocusRaf = null;
        if (searchInput) {
          searchInput.value = '';
          searchInput.focus();
        } else if (el.keyboardShortcutsClose) el.keyboardShortcutsClose.focus();
      });
    }
  }

  function handleAudioResultsKeydown(e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')
      return;
    const cards = el.audioSearchResults.querySelectorAll('.audio-result-card');
    if (!cards.length) return;
    const idx = Array.prototype.indexOf.call(cards, document.activeElement);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      cards[idx < cards.length - 1 ? idx + 1 : 0].focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      cards[idx > 0 ? idx - 1 : cards.length - 1].focus();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      document.activeElement.click();
    }
  }

  function getPanelFocusableControls(panel) {
    if (!panel) return [];
    return Array.from(
      panel.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((node) => {
      if (!node || node.getAttribute('aria-hidden') === 'true') return false;
      const rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
  }

  function trapPanelFocus(event, panel) {
    if (event.key !== 'Tab' || !panel || !isCompactEditorViewport()) return;
    const focusable = getPanelFocusableControls(panel);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!panel.contains(document.activeElement)) {
      event.preventDefault();
      focusWithoutScroll(event.shiftKey ? last : first);
      return;
    }
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      focusWithoutScroll(last);
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      focusWithoutScroll(first);
    }
  }

  function focusMobileDrawerFirstControl(panel) {
    if (!panel || !isCompactEditorViewport()) return;
    const startedAt = performance.now();
    const attempt = () => {
      if (!panel.classList.contains('open')) return;
      if (!panel.contains(document.activeElement)) {
        const focusable = getPanelFocusableControls(panel);
        if (focusable.length) {
          focusWithoutScroll(focusable[0]);
        }
      }
      if (performance.now() - startedAt < 500) {
        window.setTimeout(attempt, 50);
      } else if (!panel.contains(document.activeElement)) {
        const focusable = getPanelFocusableControls(panel);
        if (!focusable.length) return;
        focusWithoutScroll(focusable[0]);
      }
    };
    window.requestAnimationFrame(attempt);
  }

  function trapSidebarFocus(e) {
    trapPanelFocus(e, el.sidebarDrawer);
  }

  function trapInspectorFocus(e) {
    trapPanelFocus(e, el.inspectorPanel);
  }

  const TEMPLATES = [
    {
      id: 'tiktok-reels',
      name: 'TikTok / Reels',
      category: 'social',
      resolution: { width: 1080, height: 1920 },
      stageElements: [
        {
          type: 'text',
          name: 'Title',
          text: 'YOUR TITLE HERE',
          x: 10,
          y: 34,
          w: 80,
          h: 10,
          fontSize: 72,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'center',
        },
        {
          type: 'text',
          name: 'Subtitle',
          text: 'Subtitle text goes here',
          x: 12,
          y: 45,
          w: 76,
          h: 6,
          fontSize: 32,
          color: '#cccccc',
          textAlign: 'center',
        },
      ],
      preview:
        '<svg viewBox="0 0 108 192"><rect width="108" height="192" fill="#111827"/><rect x="14" y="65" width="80" height="8" rx="2" fill="#fff"/><rect x="24" y="78" width="60" height="4" rx="1" fill="#999"/></svg>',
    },
    {
      id: 'youtube-thumb',
      name: 'YouTube Thumbnail',
      category: 'social',
      resolution: { width: 1920, height: 1080 },
      stageElements: [
        {
          type: 'shape',
          name: 'Accent',
          shapeKind: 'rect',
          x: 5,
          y: 10,
          w: 18,
          h: 80,
          color: '#ef4444',
          opacity: 80,
        },
        {
          type: 'text',
          name: 'Headline',
          text: 'BIG TITLE',
          x: 28,
          y: 36,
          w: 64,
          h: 18,
          fontSize: 96,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'center',
        },
        {
          type: 'text',
          name: 'Caption',
          text: 'Click to watch',
          x: 30,
          y: 57,
          w: 60,
          h: 8,
          fontSize: 36,
          color: '#f59e0b',
          textAlign: 'center',
        },
      ],
      preview:
        '<svg viewBox="0 0 192 108"><rect width="192" height="108" fill="#111827"/><rect x="5" y="5" width="40" height="98" rx="2" fill="#ef4444" opacity=".8"/><rect x="60" y="44" width="90" height="10" rx="2" fill="#fff"/><rect x="70" y="60" width="70" height="5" rx="1" fill="#f59e0b"/></svg>',
    },
    {
      id: 'insta-story',
      name: 'Instagram Story',
      category: 'social',
      resolution: { width: 1080, height: 1920 },
      stageElements: [
        {
          type: 'shape',
          name: 'Overlay',
          shapeKind: 'rect',
          x: 13,
          y: 39,
          w: 74,
          h: 22,
          color: '#000000',
          opacity: 50,
        },
        {
          type: 'text',
          name: 'Headline',
          text: 'Your Story Title',
          x: 14,
          y: 43,
          w: 72,
          h: 10,
          fontSize: 56,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'center',
        },
        {
          type: 'text',
          name: 'CTA',
          text: 'Swipe up for more',
          x: 18,
          y: 52,
          w: 64,
          h: 6,
          fontSize: 28,
          color: '#e2e8f0',
          textAlign: 'center',
        },
      ],
      preview:
        '<svg viewBox="0 0 108 192"><rect width="108" height="192" fill="#111827"/><rect x="14" y="76" width="80" height="40" rx="4" fill="#000" opacity=".5"/><rect x="22" y="88" width="64" height="6" rx="1" fill="#fff"/><rect x="30" y="100" width="48" height="3" rx="1" fill="#999"/></svg>',
    },
    {
      id: 'presentation',
      name: 'Presentation',
      category: 'intros',
      resolution: { width: 1920, height: 1080 },
      stageElements: [
        {
          type: 'text',
          name: 'Title',
          text: 'Presentation Title',
          x: 10,
          y: 26,
          w: 55,
          h: 12,
          fontSize: 64,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'left',
        },
        {
          type: 'shape',
          name: 'Divider',
          shapeKind: 'rect',
          x: 10,
          y: 40,
          w: 18,
          h: 1,
          color: '#14b8a6',
          opacity: 100,
        },
        {
          type: 'text',
          name: 'Subtitle',
          text: 'Your name or subtitle here',
          x: 10,
          y: 44,
          w: 45,
          h: 6,
          fontSize: 28,
          color: '#94a3b8',
          textAlign: 'left',
        },
      ],
      preview:
        '<svg viewBox="0 0 192 108"><rect width="192" height="108" fill="#111827"/><rect x="15" y="38" width="120" height="8" rx="2" fill="#fff"/><rect x="15" y="50" width="40" height="2" fill="#14b8a6"/><rect x="15" y="56" width="80" height="4" rx="1" fill="#94a3b8"/></svg>',
    },
    {
      id: 'lower-third',
      name: 'Lower Third',
      category: 'intros',
      resolution: { width: 1920, height: 1080 },
      stageElements: [
        {
          type: 'shape',
          name: 'Bar',
          shapeKind: 'rect',
          x: 4,
          y: 76,
          w: 32,
          h: 10,
          color: '#14b8a6',
          opacity: 95,
        },
        {
          type: 'text',
          name: 'Speaker',
          text: 'Speaker Name',
          x: 6,
          y: 78,
          w: 28,
          h: 5,
          fontSize: 32,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'left',
        },
        {
          type: 'text',
          name: 'Role',
          text: 'Title / Role',
          x: 6,
          y: 84,
          w: 24,
          h: 4,
          fontSize: 22,
          color: '#e0f2f1',
          textAlign: 'left',
        },
      ],
      preview:
        '<svg viewBox="0 0 192 108"><rect width="192" height="108" fill="#111827"/><rect x="4" y="82" width="80" height="14" rx="2" fill="#14b8a6" opacity=".95"/><rect x="8" y="85" width="50" height="4" rx="1" fill="#fff"/><rect x="8" y="91" width="35" height="3" rx="1" fill="#e0f2f1"/></svg>',
    },
    {
      id: 'countdown',
      name: 'Countdown',
      category: 'text',
      resolution: { width: 1080, height: 1080 },
      stageElements: [
        {
          type: 'shape',
          name: 'Circle',
          shapeKind: 'circle',
          x: 31,
          y: 31,
          w: 38,
          h: 38,
          color: '#2563eb',
          opacity: 20,
        },
        {
          type: 'text',
          name: 'Number',
          text: '3',
          x: 30,
          y: 24,
          w: 40,
          h: 52,
          fontSize: 120,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'center',
        },
      ],
      preview:
        '<svg viewBox="0 0 108 108"><rect width="108" height="108" fill="#111827"/><circle cx="54" cy="54" r="30" fill="#2563eb" opacity=".2"/><text x="54" y="62" text-anchor="middle" fill="#fff" font-size="32" font-weight="bold">3</text></svg>',
    },
    {
      id: 'title-card',
      name: 'Title Card',
      category: 'text',
      resolution: { width: 1920, height: 1080 },
      stageElements: [
        {
          type: 'text',
          name: 'Title',
          text: 'TITLE CARD',
          x: 18,
          y: 38,
          w: 64,
          h: 18,
          fontSize: 120,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'center',
        },
      ],
      preview:
        '<svg viewBox="0 0 192 108"><rect width="192" height="108" fill="#111827"/><rect x="36" y="48" width="120" height="12" rx="3" fill="#fff"/></svg>',
    },
    {
      id: 'social-post',
      name: 'Social Post',
      category: 'minimal',
      resolution: { width: 1080, height: 1080 },
      stageElements: [
        {
          type: 'shape',
          name: 'Panel',
          shapeKind: 'rect',
          x: 8,
          y: 32,
          w: 84,
          h: 36,
          color: '#1e293b',
          opacity: 70,
        },
        {
          type: 'text',
          name: 'Message',
          text: 'Your message here',
          x: 14,
          y: 42,
          w: 72,
          h: 10,
          fontSize: 48,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'center',
        },
        {
          type: 'text',
          name: 'Handle',
          text: '@handle',
          x: 30,
          y: 55,
          w: 40,
          h: 4,
          fontSize: 24,
          color: '#94a3b8',
          textAlign: 'center',
        },
      ],
      preview:
        '<svg viewBox="0 0 108 108"><rect width="108" height="108" fill="#111827"/><rect x="9" y="34" width="90" height="40" rx="4" fill="#1e293b" opacity=".7"/><rect x="22" y="48" width="64" height="6" rx="1" fill="#fff"/><rect x="34" y="58" width="40" height="3" rx="1" fill="#94a3b8"/></svg>',
    },
    {
      id: 'cinematic-opener',
      name: 'Cinematic Opener',
      category: 'intros',
      resolution: { width: 1920, height: 1080 },
      stageElements: [
        {
          type: 'shape',
          name: 'Accent',
          shapeKind: 'rect',
          x: 8,
          y: 18,
          w: 1.2,
          h: 64,
          color: '#f97316',
          opacity: 100,
        },
        {
          type: 'text',
          name: 'Kicker',
          text: 'A NETWRCK ORIGINAL',
          x: 13,
          y: 23,
          w: 52,
          h: 5,
          fontSize: 22,
          fontWeight: 'bold',
          color: '#fb923c',
          textAlign: 'left',
        },
        {
          type: 'text',
          name: 'Title',
          text: 'THE NEXT FRAME',
          x: 13,
          y: 32,
          w: 74,
          h: 18,
          fontSize: 88,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'left',
        },
        {
          type: 'text',
          name: 'Subtitle',
          text: 'A short film about impossible ideas',
          x: 13,
          y: 55,
          w: 58,
          h: 7,
          fontSize: 30,
          color: '#cbd5e1',
          textAlign: 'left',
        },
      ],
      preview:
        '<svg viewBox="0 0 192 108"><rect width="192" height="108" fill="#070b16"/><rect x="16" y="20" width="2" height="68" fill="#f97316"/><rect x="26" y="31" width="48" height="3" rx="1" fill="#fb923c"/><rect x="26" y="42" width="126" height="12" rx="2" fill="#fff"/><rect x="26" y="63" width="84" height="5" rx="1" fill="#94a3b8"/></svg>',
    },
    {
      id: 'product-drop',
      name: 'Product Drop',
      category: 'social',
      resolution: { width: 1080, height: 1080 },
      stageElements: [
        {
          type: 'shape',
          name: 'Card',
          shapeKind: 'rect',
          x: 5,
          y: 5,
          w: 90,
          h: 90,
          color: '#111827',
          opacity: 96,
        },
        {
          type: 'shape',
          name: 'Badge',
          shapeKind: 'rect',
          x: 9,
          y: 11,
          w: 25,
          h: 7,
          color: '#f97316',
          opacity: 100,
        },
        {
          type: 'text',
          name: 'Badge Text',
          text: 'NEW DROP',
          x: 10,
          y: 11.8,
          w: 23,
          h: 4,
          fontSize: 20,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'center',
        },
        {
          type: 'text',
          name: 'Headline',
          text: 'BUILT TO MOVE',
          x: 9,
          y: 27,
          w: 62,
          h: 18,
          fontSize: 68,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'left',
        },
        {
          type: 'text',
          name: 'Price',
          text: 'FROM $49',
          x: 9,
          y: 54,
          w: 38,
          h: 7,
          fontSize: 32,
          fontWeight: 'bold',
          color: '#fdba74',
          textAlign: 'left',
        },
        {
          type: 'shape',
          name: 'CTA',
          shapeKind: 'rect',
          x: 9,
          y: 70,
          w: 35,
          h: 10,
          color: '#ec4899',
          opacity: 100,
        },
        {
          type: 'text',
          name: 'CTA Text',
          text: 'SHOP NOW',
          x: 11,
          y: 72,
          w: 31,
          h: 5,
          fontSize: 24,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'center',
        },
      ],
      preview:
        '<svg viewBox="0 0 108 108"><rect width="108" height="108" fill="#f3f4f6"/><rect x="6" y="6" width="96" height="96" rx="4" fill="#111827"/><rect x="11" y="13" width="29" height="8" rx="2" fill="#f97316"/><rect x="11" y="32" width="68" height="8" rx="1" fill="#fff"/><rect x="11" y="45" width="54" height="8" rx="1" fill="#fff"/><rect x="11" y="60" width="35" height="5" fill="#fdba74"/><rect x="11" y="76" width="39" height="12" rx="2" fill="#ec4899"/></svg>',
    },
    {
      id: 'podcast-quote',
      name: 'Podcast Quote',
      category: 'text',
      resolution: { width: 1920, height: 1080 },
      stageElements: [
        {
          type: 'shape',
          name: 'Quote Panel',
          shapeKind: 'rect',
          x: 8,
          y: 12,
          w: 84,
          h: 76,
          color: '#172554',
          opacity: 92,
        },
        {
          type: 'text',
          name: 'Quote Mark',
          text: '“',
          x: 12,
          y: 14,
          w: 12,
          h: 18,
          fontSize: 112,
          fontWeight: 'bold',
          color: '#60a5fa',
          textAlign: 'left',
        },
        {
          type: 'text',
          name: 'Quote',
          text: 'The best ideas feel obvious only after someone builds them.',
          x: 20,
          y: 29,
          w: 66,
          h: 25,
          fontSize: 52,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'left',
        },
        {
          type: 'text',
          name: 'Speaker',
          text: 'ALEX MORGAN · EPISODE 24',
          x: 20,
          y: 66,
          w: 52,
          h: 5,
          fontSize: 22,
          fontWeight: 'bold',
          color: '#93c5fd',
          textAlign: 'left',
        },
        {
          type: 'shape',
          name: 'Wave 1',
          shapeKind: 'rect',
          x: 20,
          y: 77,
          w: 10,
          h: 1,
          color: '#60a5fa',
          opacity: 100,
        },
        {
          type: 'shape',
          name: 'Wave 2',
          shapeKind: 'rect',
          x: 32,
          y: 77,
          w: 18,
          h: 1,
          color: '#ec4899',
          opacity: 100,
        },
        {
          type: 'shape',
          name: 'Wave 3',
          shapeKind: 'rect',
          x: 52,
          y: 77,
          w: 8,
          h: 1,
          color: '#60a5fa',
          opacity: 100,
        },
      ],
      preview:
        '<svg viewBox="0 0 192 108"><rect width="192" height="108" fill="#080f2c"/><rect x="14" y="13" width="164" height="82" rx="5" fill="#172554"/><text x="24" y="48" fill="#60a5fa" font-size="42" font-family="serif">“</text><rect x="49" y="34" width="106" height="8" rx="2" fill="#fff"/><rect x="49" y="48" width="92" height="8" rx="2" fill="#fff"/><rect x="49" y="68" width="72" height="4" rx="1" fill="#93c5fd"/><path d="M49 82h18m5 0h30m5 0h14" stroke="#ec4899" stroke-width="2"/></svg>',
    },
    {
      id: 'creator-end-screen',
      name: 'Creator End Screen',
      category: 'minimal',
      resolution: { width: 1920, height: 1080 },
      stageElements: [
        {
          type: 'text',
          name: 'Title',
          text: 'KEEP WATCHING',
          x: 24,
          y: 16,
          w: 52,
          h: 10,
          fontSize: 56,
          fontWeight: 'bold',
          color: '#ffffff',
          textAlign: 'center',
        },
        {
          type: 'shape',
          name: 'Video One',
          shapeKind: 'rect',
          x: 8,
          y: 34,
          w: 39,
          h: 36,
          color: '#1e293b',
          opacity: 100,
        },
        {
          type: 'shape',
          name: 'Video Two',
          shapeKind: 'rect',
          x: 53,
          y: 34,
          w: 39,
          h: 36,
          color: '#1e293b',
          opacity: 100,
        },
        {
          type: 'text',
          name: 'Handle',
          text: '@YOURCHANNEL',
          x: 33,
          y: 79,
          w: 34,
          h: 5,
          fontSize: 24,
          fontWeight: 'bold',
          color: '#fb7185',
          textAlign: 'center',
        },
      ],
      preview:
        '<svg viewBox="0 0 192 108"><rect width="192" height="108" fill="#0f172a"/><rect x="55" y="17" width="82" height="7" rx="2" fill="#fff"/><rect x="15" y="36" width="72" height="40" rx="3" fill="#334155"/><rect x="105" y="36" width="72" height="40" rx="3" fill="#334155"/><rect x="70" y="87" width="52" height="4" rx="1" fill="#fb7185"/></svg>',
    },
  ];

  function renderTemplates(filter) {
    if (!el.templatesGrid) return;
    el.templatesGrid.innerHTML = '';
    const cat = filter || 'all';
    if (el.templatesCategoryBar) {
      el.templatesCategoryBar
        .querySelectorAll('.templates-chip')
        .forEach((c) => {
          c.classList.toggle('active', c.dataset.tplCategory === cat);
        });
    }
    TEMPLATES.forEach((tpl) => {
      if (cat !== 'all' && tpl.category !== cat) return;
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'template-card';
      card.title = `Add ${tpl.name} layers`;
      card.setAttribute('aria-label', `Add ${tpl.name} template layers`);
      card.innerHTML =
        '<div class="template-card-preview">' +
        tpl.preview +
        '</div><div class="template-card-meta"><div class="template-card-label">' +
        tpl.name +
        '</div><span class="template-card-action">Add</span></div>';
      card.addEventListener('click', () => loadTemplate(tpl));
      el.templatesGrid.appendChild(card);
    });
  }

  function loadTemplate(tpl) {
    if (!tpl || !Array.isArray(tpl.stageElements)) return;
    ensurePages();
    const hadContent = state.clips.length > 0 || state.stageElements.length > 0;
    if (!hadContent && tpl.resolution) {
      const value = formatResolutionValue(
        tpl.resolution.width,
        tpl.resolution.height
      );
      ensureProjectResolutionOption(value);
      if (el.projectResolution) el.projectResolution.value = value;
      updateProjectSettings();
    }
    const created = tpl.stageElements
      .map((element, index) =>
        normalizeStageElement({
          ...element,
          id: `tpl_${tpl.id}_${Date.now()}_${index}`,
          pageId: state.activePageId,
        })
      )
      .filter(Boolean);
    created.forEach((element) =>
      ensureStageElementTiming(element, { forNew: true })
    );
    state.stageElements.push(...created);
    setStageSelection(
      created.map((element) => element.id),
      created[0]?.id || null
    );
    renderStageElementsList();
    renderTimeline();
    scheduleAutosave('template-add');
    closeSidebarDrawer();
    notify(`${tpl.name} layers added`, 'success');
  }

  function toggleExportSettings(open) {
    if (!el.exportSettingsModal) return;
    const shouldOpen =
      open === undefined
        ? !el.exportSettingsModal.classList.contains('open')
        : open;
    el.exportSettingsModal.classList.toggle('open', shouldOpen);
    el.exportSettingsModal.setAttribute(
      'aria-hidden',
      shouldOpen ? 'false' : 'true'
    );
    updateEditorModalOpenState();
    if (shouldOpen) {
      syncExportSettingsUI();
      requestAnimationFrame(() => {
        if (el.exportSettingsClose) el.exportSettingsClose.focus();
      });
    } else if (el.exportOpen) {
      resetExportProgress();
      restoreModalTriggerFocus(el.exportOpen);
    }
  }

  let shareGalleryUrl = '';
  let shareVideoBlob = null;

  function toggleShareModal(open) {
    if (!el.shareModal) return;
    const shouldOpen =
      open === undefined ? !el.shareModal.classList.contains('open') : open;
    el.shareModal.classList.toggle('open', shouldOpen);
    el.shareModal.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
    updateEditorModalOpenState();
    if (shouldOpen) {
      shareGalleryUrl = '';
      shareVideoBlob = null;
      if (el.shareStepPublish) el.shareStepPublish.style.display = '';
      if (el.shareStepLinks) el.shareStepLinks.style.display = 'none';
      if (el.shareStepYoutube) el.shareStepYoutube.style.display = 'none';
      if (el.sharePublishProgress)
        el.sharePublishProgress.style.display = 'none';
      if (navigator.share && el.shareNativeBtn)
        el.shareNativeBtn.style.display = '';
      requestAnimationFrame(() => {
        if (el.shareModalClose) el.shareModalClose.focus();
      });
    } else if (el.shareOpen) {
      restoreModalTriggerFocus(el.shareOpen);
    }
  }

  async function sharePublishToGallery() {
    if (state.exportInProgress) return;
    if (el.sharePublishProgress) el.sharePublishProgress.style.display = '';
    try {
      const { blob, exportFormat } = await withExportCanvasResolution(
        async () => {
          let nextBlob;
          nextBlob = await exportMp4Locally();
          return { blob: nextBlob, exportFormat: 'mp4' };
        }
      );
      if (!blob) {
        notify('xf', 'error');
        return;
      }
      shareVideoBlob = blob;
      const secret = getAuthSecret();
      if (!secret) {
        if (window.NetwrckTools) window.NetwrckTools.requireLogin();
        notify('li', 'error');
        return;
      }
      const fileName = `video-editor-${Date.now()}.${exportFormat}`;
      const videoUrl = await uploadToR2(
        blob,
        exportFormat === 'webm' ? 'video/webm' : 'video/mp4',
        fileName
      );
      if (!videoUrl) {
        notify('pf', 'error');
        return;
      }
      const thumbBlob = await new Promise((resolve) =>
        el.previewCanvas.toBlob(resolve, 'image/webp', 0.85)
      );
      let thumbUrl = null;
      if (thumbBlob) {
        try {
          thumbUrl = await uploadToR2(
            thumbBlob,
            'image/webp',
            `video-editor-thumb-${Date.now()}.webp`
          );
        } catch (e) {}
      }
      const payload = {
        generator: 'video-editor',
        args: {
          clips: state.clips.map((c) => ({
            name: c.name,
            type: c.type,
            src: c.src,
          })),
          fps: state.fps,
          resolution: `${state.resolution.width}x${state.resolution.height}`,
        },
        video_url: videoUrl,
        thumbnail_url: thumbUrl,
        duration_seconds: totalDuration(),
        width: state.resolution.width,
        height: state.resolution.height,
        format: exportFormat,
      };
      const resp = await fetch('/api/store-video-generation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': secret,
          Authorization: `Bearer ${secret}`,
        },
        body: JSON.stringify(payload),
      });
      if (!resp.ok) {
        const text = await resp.text().catch(() => '');
        let detail = '';
        if (text) {
          try {
            const data = JSON.parse(text);
            detail = data.error || data.message || data.detail || '';
          } catch (err) {
            detail = text;
          }
          detail = detail.replace(/\s+/g, ' ').trim();
          if (detail.length > 140) detail = detail.slice(0, 140) + '…';
          if (detail) detail = ` — ${detail}`;
        }
        console.error('Publish failed', resp.status, text);
        notify(`pf${detail}`, 'error');
        return;
      }
      const postData = await createGalleryVideoPost({
        videoUrl,
        thumbUrl,
        format: exportFormat,
        secret,
      });
      if (!postData) return;
      const postId =
        postData && (postData.post_id || postData.id || postData.ID);
      const galleryPath = postId ? `/p/${postId}` : '/gallery';
      shareGalleryUrl = `${window.location.origin}${galleryPath}`;
      if (el.shareUrl) el.shareUrl.value = shareGalleryUrl;
      if (el.shareViewPost) el.shareViewPost.href = shareGalleryUrl;
      if (el.shareStepPublish) el.shareStepPublish.style.display = 'none';
      if (el.shareStepLinks) el.shareStepLinks.style.display = '';
      notify('Posted to feed', 'success');
    } catch (err) {
      notify('pf', 'error');
    } finally {
      setExportInProgress(false);
      if (el.sharePublishProgress)
        el.sharePublishProgress.style.display = 'none';
    }
  }

  function openShareLink(platform) {
    if (!shareGalleryUrl) return;
    const text = encodeURIComponent('Check out my video');
    const url = encodeURIComponent(shareGalleryUrl);
    const urls = {
      twitter: `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      reddit: `https://www.reddit.com/submit?url=${url}&title=${text}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    };
    if (platform === 'native' && navigator.share) {
      navigator
        .share({ title: 'My Video', url: shareGalleryUrl })
        .catch(() => {});
      return;
    }
    if (platform === 'youtube') {
      showYouTubeStep();
      return;
    }
    if (urls[platform])
      window.open(urls[platform], '_blank', 'width=600,height=400');
  }

  function showYouTubeStep() {
    if (el.shareStepLinks) el.shareStepLinks.style.display = 'none';
    if (el.shareStepYoutube) el.shareStepYoutube.style.display = '';
    checkYouTubeConnection();
  }

  async function checkYouTubeConnection() {
    try {
      const secret = getAuthSecret();
      const resp = await fetch('/api/youtube/status', {
        headers: { 'X-API-Key': secret, Authorization: `Bearer ${secret}` },
      });
      if (resp.ok) {
        const data = await resp.json();
        if (data.connected) {
          if (el.youtubeNotConnected)
            el.youtubeNotConnected.style.display = 'none';
          if (el.youtubeUploadForm) el.youtubeUploadForm.style.display = '';
          return;
        }
      }
    } catch (e) {}
    if (el.youtubeNotConnected) el.youtubeNotConnected.style.display = '';
    if (el.youtubeUploadForm) el.youtubeUploadForm.style.display = 'none';
  }

  async function uploadToYouTube() {
    const secret = getAuthSecret();
    if (!secret) {
      notify('li', 'error');
      return;
    }
    if (!shareGalleryUrl) {
      notify('Publish first', 'error');
      return;
    }
    const title = el.youtubeTitle ? el.youtubeTitle.value.trim() : '';
    const description = el.youtubeDescription
      ? el.youtubeDescription.value.trim()
      : '';
    const privacy = el.youtubePrivacy ? el.youtubePrivacy.value : 'unlisted';
    if (!title) {
      notify('Title required', 'error');
      return;
    }
    if (el.youtubeUploadBtn) {
      el.youtubeUploadBtn.disabled = true;
      el.youtubeUploadBtn.textContent = 'Uploading...';
    }
    try {
      const fd = new FormData();
      if (shareVideoBlob)
        fd.append('video', shareVideoBlob, `video-${Date.now()}.mp4`);
      fd.append('title', title);
      fd.append('description', description);
      fd.append('privacy', privacy);
      fd.append('gallery_url', shareGalleryUrl);
      const resp = await fetch('/api/youtube/upload', {
        method: 'POST',
        headers: { 'X-API-Key': secret, Authorization: `Bearer ${secret}` },
        body: fd,
      });
      if (!resp.ok) {
        const t = await resp.text().catch(() => '');
        notify(`YouTube upload failed: ${t}`, 'error');
        return;
      }
      const data = await resp.json();
      if (data.video_id) {
        notify('Uploaded to YouTube', 'success');
        window.open(
          `https://www.youtube.com/watch?v=${data.video_id}`,
          '_blank'
        );
      }
    } catch (err) {
      notify('YouTube upload failed', 'error');
    } finally {
      if (el.youtubeUploadBtn) {
        el.youtubeUploadBtn.disabled = false;
        el.youtubeUploadBtn.textContent = 'Upload to YouTube';
      }
    }
  }

  function resetExportProgress() {
    if (el.exportProgressBar) el.exportProgressBar.style.width = '0%';
    if (el.exportProgress) el.exportProgress.style.display = 'none';
  }

  function updateExportEstimate() {
    if (!el.exportEstimate) return;
    const dur = totalDuration();
    const bitrate = state.exportSettings.bitrate || 4000000;
    const resolution = getExportResolution();
    const bytes = (bitrate / 8) * Math.max(dur, 0.1);
    const mb = (bytes / (1024 * 1024)).toFixed(1);
    const frames = Math.ceil(dur * state.fps);
    el.exportEstimate.textContent =
      'Estimated: ~' +
      mb +
      ' MB, ' +
      frames +
      ' frames, ' +
      dur.toFixed(1) +
      's, ' +
      resolution.width +
      'x' +
      resolution.height;
  }

  function getTransitionOtherLocalTime(clip, otherClip, localTime, isIn) {
    if (!otherClip) return 0;
    const duration = Math.min(
      clip.transitionDuration || 0,
      clip.duration || 0,
      typeof otherClip.duration === 'number' && otherClip.duration > 0
        ? otherClip.duration
        : clip.transitionDuration || 0
    );
    if (isIn) {
      return Math.max(0, (otherClip.duration || 0) - duration + localTime);
    }
    return 0;
  }

  function applyTransitionEffect(
    ctx,
    type,
    progress,
    clip,
    otherClip,
    localTime,
    isIn
  ) {
    const w = state.resolution.width;
    const h = state.resolution.height;
    const p = Math.max(0, Math.min(1, progress));
    const otherLocal = getTransitionOtherLocalTime(
      clip,
      otherClip,
      localTime,
      isIn
    );
    switch (type) {
      case 'crossfade':
      case 'dissolve':
        if (otherClip) {
          drawClip(ctx, otherClip, otherLocal, isIn ? 1 - p : p);
          drawClip(ctx, clip, localTime, isIn ? p : 1 - p);
        } else {
          drawClip(ctx, clip, localTime, isIn ? p : 1 - p);
        }
        break;
      case 'fade':
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, w, h);
        drawClip(ctx, clip, localTime, isIn ? p : 1 - p);
        break;
      case 'wipe-left':
        if (isIn) {
          if (otherClip) drawClip(ctx, otherClip, otherLocal, 1);
          ctx.save();
          ctx.beginPath();
          ctx.rect(w * (1 - p), 0, w * p, h);
          ctx.clip();
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
        } else {
          drawClip(ctx, clip, localTime, 1);
          if (!otherClip) break;
          ctx.save();
          ctx.beginPath();
          ctx.rect(w * (1 - p), 0, w * p, h);
          ctx.clip();
          drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
        }
        break;
      case 'wipe-right':
        if (isIn) {
          if (otherClip) drawClip(ctx, otherClip, otherLocal, 1);
          ctx.save();
          ctx.beginPath();
          ctx.rect(0, 0, w * p, h);
          ctx.clip();
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
        } else {
          drawClip(ctx, clip, localTime, 1);
          if (!otherClip) break;
          ctx.save();
          ctx.beginPath();
          ctx.rect(0, 0, w * p, h);
          ctx.clip();
          drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
        }
        break;
      case 'wipe-up':
        if (isIn) {
          if (otherClip) drawClip(ctx, otherClip, otherLocal, 1);
          ctx.save();
          ctx.beginPath();
          ctx.rect(0, h * (1 - p), w, h * p);
          ctx.clip();
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
        } else {
          drawClip(ctx, clip, localTime, 1);
          if (!otherClip) break;
          ctx.save();
          ctx.beginPath();
          ctx.rect(0, h * (1 - p), w, h * p);
          ctx.clip();
          drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
        }
        break;
      case 'wipe-down':
        if (isIn) {
          if (otherClip) drawClip(ctx, otherClip, otherLocal, 1);
          ctx.save();
          ctx.beginPath();
          ctx.rect(0, 0, w, h * p);
          ctx.clip();
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
        } else {
          drawClip(ctx, clip, localTime, 1);
          if (!otherClip) break;
          ctx.save();
          ctx.beginPath();
          ctx.rect(0, 0, w, h * p);
          ctx.clip();
          drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
        }
        break;
      case 'slide-left':
        if (otherClip) {
          ctx.save();
          ctx.translate(isIn ? w * p : w * (1 - p), 0);
          drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
        }
        ctx.save();
        ctx.translate(isIn ? -w * (1 - p) : -w * p, 0);
        drawClip(ctx, clip, localTime, 1);
        ctx.restore();
        break;
      case 'slide-right':
        if (otherClip) {
          ctx.save();
          ctx.translate(isIn ? -w * p : -w * (1 - p), 0);
          drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
        }
        ctx.save();
        ctx.translate(isIn ? w * (1 - p) : w * p, 0);
        drawClip(ctx, clip, localTime, 1);
        ctx.restore();
        break;
      case 'zoom-in': {
        if (otherClip) {
          drawClip(ctx, otherClip, otherLocal, 1);
        }
        const scale = isIn ? 1.2 - 0.2 * p : 1.0 + 0.2 * p;
        ctx.save();
        ctx.globalAlpha = isIn ? p : 1 - p;
        ctx.translate(w / 2, h / 2);
        ctx.scale(scale, scale);
        ctx.translate(-w / 2, -h / 2);
        drawClip(ctx, clip, localTime, 1);
        ctx.restore();
        break;
      }
      case 'zoom-out': {
        if (otherClip) {
          drawClip(ctx, otherClip, otherLocal, 1);
        }
        const scale = isIn ? 0.8 + 0.2 * p : 1.0 - 0.2 * p;
        ctx.save();
        ctx.globalAlpha = isIn ? p : 1 - p;
        ctx.translate(w / 2, h / 2);
        ctx.scale(Math.max(0.01, scale), Math.max(0.01, scale));
        ctx.translate(-w / 2, -h / 2);
        drawClip(ctx, clip, localTime, 1);
        ctx.restore();
        break;
      }
      case 'push-left':
        if (isIn) {
          ctx.save();
          ctx.translate(w * p, 0);
          if (otherClip) drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
          ctx.save();
          ctx.translate(-w * (1 - p), 0);
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
        } else {
          ctx.save();
          ctx.translate(-w * p, 0);
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
          if (otherClip) {
            ctx.save();
            ctx.translate(w * (1 - p), 0);
            drawClip(ctx, otherClip, otherLocal, 1);
            ctx.restore();
          }
        }
        break;
      case 'push-right':
        if (isIn) {
          ctx.save();
          ctx.translate(-w * p, 0);
          if (otherClip) drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
          ctx.save();
          ctx.translate(w * (1 - p), 0);
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
        } else {
          ctx.save();
          ctx.translate(w * p, 0);
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
          if (otherClip) {
            ctx.save();
            ctx.translate(-w * (1 - p), 0);
            drawClip(ctx, otherClip, otherLocal, 1);
            ctx.restore();
          }
        }
        break;
      case 'push-up':
        if (isIn) {
          ctx.save();
          ctx.translate(0, h * p);
          if (otherClip) drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
          ctx.save();
          ctx.translate(0, -h * (1 - p));
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
        } else {
          ctx.save();
          ctx.translate(0, -h * p);
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
          if (otherClip) {
            ctx.save();
            ctx.translate(0, h * (1 - p));
            drawClip(ctx, otherClip, otherLocal, 1);
            ctx.restore();
          }
        }
        break;
      case 'push-down':
        if (isIn) {
          ctx.save();
          ctx.translate(0, -h * p);
          if (otherClip) drawClip(ctx, otherClip, otherLocal, 1);
          ctx.restore();
          ctx.save();
          ctx.translate(0, h * (1 - p));
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
        } else {
          ctx.save();
          ctx.translate(0, h * p);
          drawClip(ctx, clip, localTime, 1);
          ctx.restore();
          if (otherClip) {
            ctx.save();
            ctx.translate(0, -h * (1 - p));
            drawClip(ctx, otherClip, otherLocal, 1);
            ctx.restore();
          }
        }
        break;
      default:
        drawClip(ctx, clip, localTime, isIn ? p : 1 - p);
    }
  }

  function resetEditorStateForTests() {
    suppressDefaultAssetForTests = true;
    closeSidebarDrawer();
    closeInspectorPanel();
    if (state.autosaveTimer) clearTimeout(state.autosaveTimer);
    state.assets = [];
    state.clips = [];
    state.selectedClipId = null;
    state.selectedClipIds = [];
    state.timelineSelectionAnchorId = null;
    transitionPanelDirection = 'both';
    state.selectedAssetId = null;
    state.assetContextMenuId = null;
    state.pages = [{ id: 'test_page_1', name: 'Page 1', timelineStart: 0 }];
    state.activePageId = 'test_page_1';
    state.stageElements = [];
    state.selectedStageElementId = null;
    state.selectedStageElementIds = [];
    state.userInteracted = false;
    state.stageElementsFilter = '';
    state.stageElementsFilterType = 'all';
    state.stageElementsFilterStatus = 'all';
    state.stageElementsFilterSelectedOnly = false;
    state.stageKeyframeMuted = {};
    state.stageKeyframeSoloId = null;
    state.audioSearchUnavailable = false;
    state.audioElement = null;
    state.audioFile = null;
    state.audioLabel = '';
    state.audioSource = null;
    state.audioSourceElement = null;
    state.audioDestination = null;
    state.audioGainNode = null;
    state.audioSettings = { gain: 1, fadeIn: 0, fadeOut: 0 };
    state.audioTracks = [];
    state.waveform = { peaks: [], duration: 0 };
    state.playing = false;
    state.playStartTime = 0;
    state.playhead = 0;
    state.queue = [];
    state.exportInProgress = false;
    state.exportSettings = {
      resolution:
        (el.projectResolution && el.projectResolution.value) ||
        `${state.resolution.width}x${state.resolution.height}`,
      bitrate: 4000000,
      format: 'mp4',
    };
    state.autosaveTimer = null;
    state.lastSavedSnapshot = '';
    state.lastFileSavedSnapshot = '';
    state.selectedAutomation = null;
    state.selectedAutomationMulti = null;
    state.selectedAutomationAnchor = { gain: null, pan: null };
    state.automationClipboard = null;
    importedSharedArtSrcs.clear();
    clipVisualizerScrub = null;
    clipVisualizerHover = null;
    clipVisualizerAltDown = false;
    timelineHandleDrag = null;
    timelineStageHandleDrag = null;
    timelineMarquee = null;
    dragClipId = null;
    dragClipIds = null;
    timelineClipDrag = null;
    timelineHistory.length = 0;
    timelineFuture.length = 0;
    automationHistory.length = 0;
    automationFuture.length = 0;
    globalRedoStack.length = 0;
    setAudioSearchUnavailable(false);
    setSearchKind('images', { persist: false });
    resetExportProgress();
    if (el.stageElements) {
      el.stageElements
        .querySelectorAll('.stage-element.editing[contenteditable="true"]')
        .forEach((node) => {
          node.classList.remove('editing');
          node.removeAttribute('contenteditable');
        });
    }
    if (el.createPicResults) {
      el.createPicResults.innerHTML = '';
    }
    if (el.createPicResultsInline) {
      el.createPicResultsInline.innerHTML = '';
    }
    renderPages();
    renderStageElements();
    updateStageElementControls();
    renderAssetList();
    renderTimeline();
    renderInspector();
    renderAutomationHistoryPanel();
    syncExportSettingsUI();
    updateTimeLabel();
    resetProjectHistory(serializeProject());
    updateProjectDirtyState();
  }

  function updateBalanceFromUser() {
    if (
      window.userData &&
      typeof window.userData.free_credits !== 'undefined'
    ) {
      const total =
        parseFloat(window.userData.free_credits || 0) +
        parseFloat(window.userData.paid_credits || 0);
      const usd = total.toFixed(2);
      document.querySelectorAll('.api-credits-balance-usd').forEach((node) => {
        node.textContent = usd;
      });
      document.querySelectorAll('.api-credits-balance').forEach((node) => {
        node.textContent = total;
      });
    }
  }

  function exposeTestApi() {
    if (!window.__TEST_MODE__) return;
    window.videoEditorTestApi = {
      ready: false,
      state,
      addExternalAsset,
      addMockAsset,
      addClipFromAsset,
      addPage,
      selectPage,
      addStageText,
      addStageTextAndEdit,
      addStageShape,
      addStageShapeAt,
      addStageElementFromAsset,
      addStageElementFromAssetAt,
      activateEyedropper,
      hasExternalFilePayload,
      collectDroppedFiles,
      resolveExternalFileDropZone,
      buildExternalFileDropOptions,
      handleDroppedFiles,
      handleExternalFileDrop,
      renderPages,
      renderStageElements,
      renderStageElementsList,
      renderShortcutsList,
      selectStageElement,
      setStageSelection,
      toggleKeyboardShortcuts,
      selectClip,
      renderFrameAt,
      renderTimeline,
      renderInspector,
      saveProject,
      loadProject,
      exportProjectFile,
      updateClipField,
      recalcTimeline,
      getTimelineGaps,
      resolveTimelineOverlaps,
      getTimelineVideoTrackCount,
      getTimelineDropPoint,
      placeTimelineClipsAtTime,
      splitTimelineSelectionAtPlayhead,
      playPreview,
      pausePreview,
      togglePreviewPlayback,
      tick,
      readSavedAiAssets,
      renderSavedAiPanels,
      resetTestState: resetEditorStateForTests,
      getTimelineHistoryLength: () => timelineHistory.length,
      copyTimelineSelectionToClipboard,
      pasteTimelineClipboard,
      hasTimelineClipboard,
      setTimelineSelection,
      selectAllTimelineClips,
      resolveAspectLockedResizeBounds,
      serializeProject,
      applyProjectData,
      loadTemplate,
      templates: TEMPLATES,
      applyMagicResizeResolution,
      applyMagicResizeFocus,
      detectMagicResizeFocus,
      drawMediaCover,
    };
  }

  function markTestApiReady() {
    if (window.videoEditorTestApi) {
      window.videoEditorTestApi.ready = true;
    }
  }

  function initShaderStage() {
    bindShaderControls();
  }

  function hasEnabledShaderEffects() {
    return Object.values(state.shaderEffects || {}).some(
      (effect) => effect && effect.enabled
    );
  }

  function ensureShaderStage() {
    if (state.shaderStage) return state.shaderStage;
    if (
      shaderStageUnavailable ||
      TEST_MODE ||
      !window.ShaderStage ||
      !window.THREE
    )
      return null;
    const container = el.previewCanvasShell;
    if (!container) return null;
    try {
      const probe = document.createElement('canvas');
      if (!probe.getContext('webgl') && !probe.getContext('experimental-webgl'))
        return null;
      state.shaderStage = new ShaderStage(container, {
        width: state.resolution.width,
        height: state.resolution.height,
        maxFps: state.fps || 30,
      });
      return state.shaderStage;
    } catch (e) {
      shaderStageUnavailable = true;
      return null;
    }
  }

  function bindShaderControls() {
    if (shaderControlsBound) return;
    shaderControlsBound = true;

    function syncShaderUI() {
      if (el.shaderFxBlur)
        el.shaderFxBlur.checked = state.shaderEffects.blur.enabled;
      if (el.shaderFxBlurRadius)
        el.shaderFxBlurRadius.value = state.shaderEffects.blur.radius;
      if (el.shaderFxRecolor)
        el.shaderFxRecolor.checked = state.shaderEffects.recolor.enabled;
      if (el.shaderFxHue)
        el.shaderFxHue.value = state.shaderEffects.recolor.hueShift;
      if (el.shaderFxSat)
        el.shaderFxSat.value = state.shaderEffects.recolor.saturation;
      if (el.shaderFxBright)
        el.shaderFxBright.value = state.shaderEffects.recolor.brightness;
      if (el.shaderFxGlitch)
        el.shaderFxGlitch.checked = state.shaderEffects.glitch.enabled;
      if (el.shaderFxGlitchIntensity)
        el.shaderFxGlitchIntensity.value = state.shaderEffects.glitch.intensity;
      if (el.shaderFxVhs)
        el.shaderFxVhs.checked = state.shaderEffects.vhs.enabled;
      if (el.shaderFxVhsIntensity)
        el.shaderFxVhsIntensity.value = state.shaderEffects.vhs.intensity;
      if (el.shaderFxCorrupt)
        el.shaderFxCorrupt.checked = state.shaderEffects.corrupt.enabled;
      if (el.shaderFxCorruptIntensity)
        el.shaderFxCorruptIntensity.value =
          state.shaderEffects.corrupt.intensity;
      if (el.shaderFxBloom)
        el.shaderFxBloom.checked = state.shaderEffects.bloom.enabled;
      if (el.shaderFxBloomIntensity)
        el.shaderFxBloomIntensity.value = state.shaderEffects.bloom.intensity;
      if (el.shaderFxSharpen)
        el.shaderFxSharpen.checked = state.shaderEffects.sharpen.enabled;
      if (el.shaderFxSharpenIntensity)
        el.shaderFxSharpenIntensity.value =
          state.shaderEffects.sharpen.intensity;
      if (el.shaderFxVignette)
        el.shaderFxVignette.checked = state.shaderEffects.vignette.enabled;
      if (el.shaderFxVignetteIntensity)
        el.shaderFxVignetteIntensity.value =
          state.shaderEffects.vignette.intensity;
      if (el.shaderFxChromatic)
        el.shaderFxChromatic.checked = state.shaderEffects.chromatic.enabled;
      if (el.shaderFxChromaticIntensity)
        el.shaderFxChromaticIntensity.value =
          state.shaderEffects.chromatic.intensity;
      if (el.shaderFxFilmgrain)
        el.shaderFxFilmgrain.checked = state.shaderEffects.filmgrain.enabled;
      if (el.shaderFxFilmgrainIntensity)
        el.shaderFxFilmgrainIntensity.value =
          state.shaderEffects.filmgrain.intensity;
      if (el.shaderFxCrt)
        el.shaderFxCrt.checked = state.shaderEffects.crt.enabled;
      if (el.shaderFxCrtIntensity)
        el.shaderFxCrtIntensity.value = state.shaderEffects.crt.intensity;
      if (el.shaderFxPixelate)
        el.shaderFxPixelate.checked = state.shaderEffects.pixelate.enabled;
      if (el.shaderFxPixelateSize)
        el.shaderFxPixelateSize.value = state.shaderEffects.pixelate.pixelSize;
      if (el.shaderFxDream)
        el.shaderFxDream.checked = state.shaderEffects.dream.enabled;
      if (el.shaderFxDreamIntensity)
        el.shaderFxDreamIntensity.value = state.shaderEffects.dream.intensity;
      if (el.shaderFxEdgeglow)
        el.shaderFxEdgeglow.checked = state.shaderEffects.edgeglow.enabled;
      if (el.shaderFxEdgeglowIntensity)
        el.shaderFxEdgeglowIntensity.value =
          state.shaderEffects.edgeglow.intensity;
      if (el.shaderFxDuotone)
        el.shaderFxDuotone.checked = state.shaderEffects.duotone.enabled;
      if (el.shaderFxDuotoneIntensity)
        el.shaderFxDuotoneIntensity.value =
          state.shaderEffects.duotone.intensity;
      document.querySelectorAll('.shader-preset-btn').forEach((btn) => {
        btn.classList.toggle(
          'active',
          btn.dataset.preset === state.shaderPreset
        );
      });
    }

    function applyShaderState() {
      if (!hasEnabledShaderEffects()) {
        if (state.shaderStage) {
          state.shaderStage.stopLoop();
          state.shaderStage.getCanvas().style.display = 'none';
        }
        return;
      }
      const stage = ensureShaderStage();
      if (!stage) return;
      stage.maxFps = Math.max(1, Math.min(60, state.fps || 30));
      stage.getCanvas().style.display = '';
      stage.enableEffect('blur', state.shaderEffects.blur.enabled);
      stage.setEffect('blur', { radius: state.shaderEffects.blur.radius });
      stage.enableEffect('recolor', state.shaderEffects.recolor.enabled);
      stage.setEffect('recolor', {
        hueShift: state.shaderEffects.recolor.hueShift,
        saturation: state.shaderEffects.recolor.saturation,
        brightness: state.shaderEffects.recolor.brightness,
      });
      stage.enableEffect('glitch', state.shaderEffects.glitch.enabled);
      stage.setEffect('glitch', {
        intensity: state.shaderEffects.glitch.intensity,
      });
      stage.enableEffect('vhs', state.shaderEffects.vhs.enabled);
      stage.setEffect('vhs', { intensity: state.shaderEffects.vhs.intensity });
      stage.enableEffect('corrupt', state.shaderEffects.corrupt.enabled);
      stage.setEffect('corrupt', {
        intensity: state.shaderEffects.corrupt.intensity,
      });
      stage.enableEffect('sharpen', state.shaderEffects.sharpen.enabled);
      stage.setEffect('sharpen', {
        intensity: state.shaderEffects.sharpen.intensity,
      });
      stage.enableEffect('vignette', state.shaderEffects.vignette.enabled);
      stage.setEffect('vignette', {
        intensity: state.shaderEffects.vignette.intensity,
        softness: state.shaderEffects.vignette.softness,
      });
      stage.enableEffect('chromatic', state.shaderEffects.chromatic.enabled);
      stage.setEffect('chromatic', {
        intensity: state.shaderEffects.chromatic.intensity,
      });
      stage.enableEffect('filmgrain', state.shaderEffects.filmgrain.enabled);
      stage.setEffect('filmgrain', {
        intensity: state.shaderEffects.filmgrain.intensity,
      });
      stage.enableEffect('crt', state.shaderEffects.crt.enabled);
      stage.setEffect('crt', { intensity: state.shaderEffects.crt.intensity });
      stage.enableEffect('pixelate', state.shaderEffects.pixelate.enabled);
      stage.setEffect('pixelate', {
        pixelSize: state.shaderEffects.pixelate.pixelSize,
      });
      stage.enableEffect('dream', state.shaderEffects.dream.enabled);
      stage.setEffect('dream', {
        intensity: state.shaderEffects.dream.intensity,
      });
      stage.enableEffect('edgeglow', state.shaderEffects.edgeglow.enabled);
      stage.setEffect('edgeglow', {
        intensity: state.shaderEffects.edgeglow.intensity,
        glowColor: state.shaderEffects.edgeglow.glowColor,
      });
      stage.enableEffect('duotone', state.shaderEffects.duotone.enabled);
      stage.setEffect('duotone', {
        intensity: state.shaderEffects.duotone.intensity,
        colorA: state.shaderEffects.duotone.colorA,
        colorB: state.shaderEffects.duotone.colorB,
      });
      stage.enableEffect('bloom', state.shaderEffects.bloom.enabled);
      stage.setEffect('bloom', {
        intensity: state.shaderEffects.bloom.intensity,
      });
      updateShaderStageSource();
    }

    if (el.shaderFxBlur) {
      el.shaderFxBlur.addEventListener('change', () => {
        state.shaderEffects.blur.enabled = el.shaderFxBlur.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxBlurRadius) {
      el.shaderFxBlurRadius.addEventListener('input', () => {
        state.shaderEffects.blur.radius = parseFloat(
          el.shaderFxBlurRadius.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxRecolor) {
      el.shaderFxRecolor.addEventListener('change', () => {
        state.shaderEffects.recolor.enabled = el.shaderFxRecolor.checked;
        if (el.shaderRecolorControls)
          el.shaderRecolorControls.style.display = state.shaderEffects.recolor
            .enabled
            ? ''
            : 'none';
        applyShaderState();
      });
    }
    if (el.shaderFxHue) {
      el.shaderFxHue.addEventListener('input', () => {
        state.shaderEffects.recolor.hueShift = parseFloat(el.shaderFxHue.value);
        applyShaderState();
      });
    }
    if (el.shaderFxSat) {
      el.shaderFxSat.addEventListener('input', () => {
        state.shaderEffects.recolor.saturation = parseFloat(
          el.shaderFxSat.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxBright) {
      el.shaderFxBright.addEventListener('input', () => {
        state.shaderEffects.recolor.brightness = parseFloat(
          el.shaderFxBright.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxGlitch) {
      el.shaderFxGlitch.addEventListener('change', () => {
        state.shaderEffects.glitch.enabled = el.shaderFxGlitch.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxGlitchIntensity) {
      el.shaderFxGlitchIntensity.addEventListener('input', () => {
        state.shaderEffects.glitch.intensity = parseFloat(
          el.shaderFxGlitchIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxVhs) {
      el.shaderFxVhs.addEventListener('change', () => {
        state.shaderEffects.vhs.enabled = el.shaderFxVhs.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxVhsIntensity) {
      el.shaderFxVhsIntensity.addEventListener('input', () => {
        state.shaderEffects.vhs.intensity = parseFloat(
          el.shaderFxVhsIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxCorrupt) {
      el.shaderFxCorrupt.addEventListener('change', () => {
        state.shaderEffects.corrupt.enabled = el.shaderFxCorrupt.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxCorruptIntensity) {
      el.shaderFxCorruptIntensity.addEventListener('input', () => {
        state.shaderEffects.corrupt.intensity = parseFloat(
          el.shaderFxCorruptIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxBloom) {
      el.shaderFxBloom.addEventListener('change', () => {
        state.shaderEffects.bloom.enabled = el.shaderFxBloom.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxBloomIntensity) {
      el.shaderFxBloomIntensity.addEventListener('input', () => {
        state.shaderEffects.bloom.intensity = parseFloat(
          el.shaderFxBloomIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxSharpen) {
      el.shaderFxSharpen.addEventListener('change', () => {
        state.shaderEffects.sharpen.enabled = el.shaderFxSharpen.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxSharpenIntensity) {
      el.shaderFxSharpenIntensity.addEventListener('input', () => {
        state.shaderEffects.sharpen.intensity = parseFloat(
          el.shaderFxSharpenIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxVignette) {
      el.shaderFxVignette.addEventListener('change', () => {
        state.shaderEffects.vignette.enabled = el.shaderFxVignette.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxVignetteIntensity) {
      el.shaderFxVignetteIntensity.addEventListener('input', () => {
        state.shaderEffects.vignette.intensity = parseFloat(
          el.shaderFxVignetteIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxChromatic) {
      el.shaderFxChromatic.addEventListener('change', () => {
        state.shaderEffects.chromatic.enabled = el.shaderFxChromatic.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxChromaticIntensity) {
      el.shaderFxChromaticIntensity.addEventListener('input', () => {
        state.shaderEffects.chromatic.intensity = parseFloat(
          el.shaderFxChromaticIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxFilmgrain) {
      el.shaderFxFilmgrain.addEventListener('change', () => {
        state.shaderEffects.filmgrain.enabled = el.shaderFxFilmgrain.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxFilmgrainIntensity) {
      el.shaderFxFilmgrainIntensity.addEventListener('input', () => {
        state.shaderEffects.filmgrain.intensity = parseFloat(
          el.shaderFxFilmgrainIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxCrt) {
      el.shaderFxCrt.addEventListener('change', () => {
        state.shaderEffects.crt.enabled = el.shaderFxCrt.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxCrtIntensity) {
      el.shaderFxCrtIntensity.addEventListener('input', () => {
        state.shaderEffects.crt.intensity = parseFloat(
          el.shaderFxCrtIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxPixelate) {
      el.shaderFxPixelate.addEventListener('change', () => {
        state.shaderEffects.pixelate.enabled = el.shaderFxPixelate.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxPixelateSize) {
      el.shaderFxPixelateSize.addEventListener('input', () => {
        state.shaderEffects.pixelate.pixelSize = parseFloat(
          el.shaderFxPixelateSize.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxDream) {
      el.shaderFxDream.addEventListener('change', () => {
        state.shaderEffects.dream.enabled = el.shaderFxDream.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxDreamIntensity) {
      el.shaderFxDreamIntensity.addEventListener('input', () => {
        state.shaderEffects.dream.intensity = parseFloat(
          el.shaderFxDreamIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxEdgeglow) {
      el.shaderFxEdgeglow.addEventListener('change', () => {
        state.shaderEffects.edgeglow.enabled = el.shaderFxEdgeglow.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxEdgeglowIntensity) {
      el.shaderFxEdgeglowIntensity.addEventListener('input', () => {
        state.shaderEffects.edgeglow.intensity = parseFloat(
          el.shaderFxEdgeglowIntensity.value
        );
        applyShaderState();
      });
    }
    if (el.shaderFxDuotone) {
      el.shaderFxDuotone.addEventListener('change', () => {
        state.shaderEffects.duotone.enabled = el.shaderFxDuotone.checked;
        applyShaderState();
      });
    }
    if (el.shaderFxDuotoneIntensity) {
      el.shaderFxDuotoneIntensity.addEventListener('input', () => {
        state.shaderEffects.duotone.intensity = parseFloat(
          el.shaderFxDuotoneIntensity.value
        );
        applyShaderState();
      });
    }

    function resetAllEffects() {
      Object.keys(state.shaderEffects).forEach((k) => {
        state.shaderEffects[k].enabled = false;
      });
    }

    function applyPreset(preset) {
      resetAllEffects();
      state.shaderPreset = preset;
      const presets = {
        none: {},
        vintage: {
          vhs: { enabled: true, intensity: 0.3 },
          filmgrain: { enabled: true, intensity: 0.08 },
          vignette: { enabled: true, intensity: 0.4 },
        },
        cinematic: {
          bloom: { enabled: true, intensity: 0.6 },
          vignette: { enabled: true, intensity: 0.3 },
          recolor: { enabled: true, saturation: 0.9, brightness: 1.05 },
        },
        dreamy: {
          dream: { enabled: true, intensity: 0.6 },
          bloom: { enabled: true, intensity: 0.4 },
          recolor: { enabled: true, saturation: 1.1, brightness: 1.1 },
        },
        retro: {
          crt: { enabled: true, intensity: 0.4 },
          chromatic: { enabled: true, intensity: 0.5 },
          vignette: { enabled: true, intensity: 0.5 },
        },
        glitchy: {
          glitch: { enabled: true, intensity: 0.6 },
          chromatic: { enabled: true, intensity: 0.8 },
          corrupt: { enabled: true, intensity: 0.2 },
        },
        noir: {
          duotone: { enabled: true, intensity: 0.9 },
          vignette: { enabled: true, intensity: 0.6 },
          filmgrain: { enabled: true, intensity: 0.1 },
        },
        neon: {
          bloom: { enabled: true, intensity: 1.2 },
          edgeglow: { enabled: true, intensity: 2.0 },
          recolor: { enabled: true, saturation: 1.4, brightness: 1.0 },
        },
        lofi: {
          pixelate: { enabled: true, pixelSize: 4 },
          recolor: { enabled: true, saturation: 0.8, brightness: 0.95 },
          vignette: { enabled: true, intensity: 0.3 },
        },
        cyberpunk: {
          glitch: { enabled: true, intensity: 0.4 },
          chromatic: { enabled: true, intensity: 1.2 },
          edgeglow: { enabled: true, intensity: 1.5 },
        },
        film: {
          filmgrain: { enabled: true, intensity: 0.12 },
          vignette: { enabled: true, intensity: 0.4 },
          recolor: { enabled: true, saturation: 0.85 },
        },
      };
      const p = presets[preset];
      if (p)
        Object.keys(p).forEach((k) =>
          Object.assign(state.shaderEffects[k], p[k])
        );
      syncShaderUI();
      applyShaderState();
    }

    document.querySelectorAll('.shader-preset-btn').forEach((btn) => {
      btn.addEventListener('click', () => applyPreset(btn.dataset.preset));
    });

    syncShaderUI();
  }

  function updateShaderStageSource() {
    if (!hasEnabledShaderEffects()) {
      if (state.shaderStage) {
        state.shaderStage.stopLoop();
        state.shaderStage.getCanvas().style.display = 'none';
      }
      return;
    }
    const stage = ensureShaderStage();
    if (!stage) return;
    const canvas = el.previewCanvas;
    if (canvas) {
      stage.maxFps = Math.max(1, Math.min(60, state.fps || 30));
      stage.getCanvas().style.display = '';
      if (stage.sourceTexture && stage.sourceTexture.image === canvas) {
        stage.sourceTexture.needsUpdate = true;
      } else {
        stage.setSource(canvas);
      }
      if (!stage.animationId) stage.startLoop();
    }
  }

  async function boot() {
    bindElements();
    initToolbarFonts();
    syncProjectChrome();
    updateHeaderOffset();
    requestAnimationFrame(updateHeaderOffset);
    setTimeout(updateHeaderOffset, 200);
    window.addEventListener('resize', updateHeaderOffset);
    window.addEventListener('resize', ensureTimelineVisible);
    window.addEventListener('resize', handleTimelineViewportResize);
    window.addEventListener('resize', scheduleStageInlineToolbarSync);
    window.addEventListener('resize', syncMobileDrawerInteractivity);
    if (el.sidebarDrawer && el.sidebarDrawer.classList.contains('open')) {
      sidebarOpen = true;
      const activeTab = document.querySelector('.asset-tab.active');
      if (activeTab) {
        sidebarActiveTab =
          activeTab.getAttribute('data-tab') || sidebarActiveTab;
        if (el.sidebarDrawerTitle) {
          el.sidebarDrawerTitle.textContent = sidebarLabelForTab(activeTab);
        }
      }
    }
    if (sidebarOpen && isCompactEditorViewport()) {
      closeSidebarDrawer();
    }
    if (el.videoEditorBody) {
      el.videoEditorBody.classList.toggle('sidebar-collapsed', !sidebarOpen);
      el.videoEditorBody.classList.toggle(
        'filesystem-active',
        sidebarOpen && sidebarActiveTab === 'filesystem'
      );
    }
    syncSidebarToggleState();
    ensurePages();
    renderPages();
    if (el.featureFlagContainer) {
      el.featureFlagContainer.addEventListener('submit', (event) => {
        event.preventDefault();
      });
      el.featureFlagContainer
        .querySelectorAll('button:not([type])')
        .forEach((button) => {
          button.type = 'button';
        });
    }
    setupTabs();
    renderTemplates();
    if (el.templatesCategoryBar) {
      el.templatesCategoryBar
        .querySelectorAll('.templates-chip')
        .forEach((chip) => {
          chip.addEventListener('click', () =>
            renderTemplates(chip.dataset.tplCategory)
          );
        });
    }
    bindSidebar();
    bindEvents();
    bindDropTargets();
    loadDetailsState();
    bindDetailsPersistence();
    bindMenuExclusivity();
    bindTimelineContextSubmenus();
    bindStageSelectionBox();
    applyFeatureFlags();
    initSettingsDisclosures();
    loadStageElementsFilterType();
    loadStageElementsFilterStatus();
    loadStageElementsSelectedOnly();
    loadStageElementsTypeBadges();
    loadStageElementsCompact();
    loadTimelineWaveformSetting();
    loadTimelineHeightSetting();
    loadTimelineRememberSubmenuSetting();
    loadTimelineRememberQuickSetting();
    if (el.stageSnapToggle) {
      el.stageSnapToggle.checked = state.stageSnapEnabled;
    }
    if (el.stageRotationSnapToggle) {
      el.stageRotationSnapToggle.checked = state.stageRotationSnapEnabled;
    }
    if (el.stageAspectLockToggle) {
      el.stageAspectLockToggle.checked = state.stageAspectLocked;
    }
    if (el.stageGridToggle) {
      el.stageGridToggle.checked = state.stageGridEnabled;
      if (el.previewCanvasShell) {
        el.previewCanvasShell.classList.toggle(
          'show-grid',
          state.stageGridEnabled
        );
      }
    }
    applyPreviewScale(state.previewScale || 1);
    syncStageToolbar();
    if (el.stageSnapGridToggle) {
      el.stageSnapGridToggle.checked =
        state.stageGridEnabled && state.stageSnapEnabled;
    }
    if (el.stageSnapStrength) {
      el.stageSnapStrength.value = state.stageSnapStrength;
    }
    if (el.stageSnapStrengthInput) {
      el.stageSnapStrengthInput.value = state.stageSnapStrength;
    }
    renderStageElements();
    initShaderStage();
    exposeTestApi();
    const startupParams = new URLSearchParams(window.location.search);
    const hasUrlStartupMedia =
      startupParams.get('videoUrl') ||
      startupParams.get('videourl') ||
      startupParams.get('imageUrl') ||
      startupParams.get('imageurl') ||
      startupParams.get('audioUrl') ||
      startupParams.get('audiourl') ||
      startupParams.get('src');
    if (hasUrlStartupMedia) {
      await maybeLoadUrlAsset();
    }
    state.inspectorPins = loadInspectorPins();
    renderInspectorPinMenu();
    loadAutomationHistoryFilter();
    state.automationHistoryBadgesCollapsed =
      loadAutomationHistoryBadgesCollapsed();
    loadAutomationPresets();
    maybeImportPresetsFromHash();
    updateGlobalUndoIndicators();
    updateProjectSettings();
    renderTimeline();
    try {
      await refreshSyncedSavedAiAssets();
    } catch (_) {}
    let loadedFromLocation = false;
    try {
      loadedFromLocation = await loadProjectFromLocation();
    } catch (_) {}
    if (!loadedFromLocation) {
      applyAiDefaults();
    }
    const hasStartupMedia =
      startupParams.has('sample') ||
      startupParams.get('import') === 'feed-upload' ||
      startupParams.get('videoUrl') ||
      startupParams.get('videourl') ||
      startupParams.get('imageUrl') ||
      startupParams.get('imageurl') ||
      startupParams.get('audioUrl') ||
      startupParams.get('audiourl') ||
      startupParams.get('src');
    if (hasStartupMedia || !loadedFromLocation || !state.assets.length) {
      if (!hasUrlStartupMedia) await maybeLoadUrlAsset();
      await maybeLoadSampleAsset();
      await maybeLoadDefaultAsset();
    }
    await importScreenRecording();
    await importFeedUpload();
    renderAssetList();
    renderSavedAiPanels();
    resetProjectHistory(serializeProject());
    updateBalanceFromUser();
    updateCreditsWidgets();
    setupSharedArtDialogBridge();
    renderHistory();
    updateProjectDirtyState();
    requestAnimationFrame(ensureTimelineVisible);
    setTimeout(ensureTimelineVisible, 250);
    window.addEventListener('beforeunload', handleEditorBeforeUnload);
    document.addEventListener('keydown', handleReadOnlyKeydown, true);
    window.addEventListener('netwrck:credits-updated', () => {
      updateBalanceFromUser();
      updateCreditsWidgets();
    });
    if (window.jQuery) {
      window.jQuery(document).on('user-ready', function (_evt, user) {
        if (user) window.userData = user;
        updateBalanceFromUser();
        updateCreditsWidgets();
        refreshSyncedSavedAiAssets().catch(function () {});
        refreshAccountProjects().catch(function () {});
      });
    }
    markTestApiReady();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
